/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/webpack/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 360);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.1
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-02-22T19:11Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE11 only
	// In IE 11 fullscreen elements inside of an iframe have
	// 100x too small dimensions (gh-1764).
	if ( document.msFullscreenElement && window.top !== window ) {

		// Support: IE11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
		}
	}

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				// Support: IE<11
				// option.value not trimmed (#14858)
				return jQuery.trim( elem.value );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// But now, this "simulate" function is used only for events
				// for which stopPropagation() is noop, so there is no need for that anymore.
				//
				// For the 1.x branch though, guard for "click" and "submit"
				// events is still used, but was moved to jQuery.event.stopPropagation function
				// because `originalEvent` should point to the original event for the constancy
				// with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8+
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	// Stop scripts or inline event handlers from being executed immediately
	// by using document.implementation
	context = context || ( support.createHTMLDocument ?
		document.implementation.createHTMLDocument( "" ) :
		document );

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( self, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-unused-expressions, no-param-reassign, no-else-return, quotes, object-shorthand, comma-dangle, camelcase, one-var, vars-on-top, one-var-declaration-per-line, no-return-assign, consistent-return, max-len, prefer-template */
  (function () {
    (function (w) {
      var base;
      w.gl || (w.gl = {});
      (base = w.gl).utils || (base.utils = {});
      w.gl.utils.isInGroupsPage = function () {
        return gl.utils.getPagePath() === 'groups';
      };
      w.gl.utils.isInProjectPage = function () {
        return gl.utils.getPagePath() === 'projects';
      };
      w.gl.utils.getProjectSlug = function () {
        if (this.isInProjectPage()) {
          return $('body').data('project');
        } else {
          return null;
        }
      };
      w.gl.utils.getGroupSlug = function () {
        if (this.isInGroupsPage()) {
          return $('body').data('group');
        } else {
          return null;
        }
      };

      w.gl.utils.ajaxGet = function (url) {
        return $.ajax({
          type: "GET",
          url: url,
          dataType: "script"
        });
      };

      w.gl.utils.extractLast = function (term) {
        return this.split(term).pop();
      };

      w.gl.utils.rstrip = function rstrip(val) {
        if (val) {
          return val.replace(/\s+$/, '');
        } else {
          return val;
        }
      };

      w.gl.utils.disableButtonIfEmptyField = function (field_selector, button_selector, event_name) {
        event_name = event_name || 'input';
        var closest_submit, field, that;
        that = this;
        field = $(field_selector);
        closest_submit = field.closest('form').find(button_selector);
        if (this.rstrip(field.val()) === "") {
          closest_submit.disable();
        }
        return field.on(event_name, function () {
          if (that.rstrip($(this).val()) === "") {
            return closest_submit.disable();
          } else {
            return closest_submit.enable();
          }
        });
      };

      // automatically adjust scroll position for hash urls taking the height of the navbar into account
      // https://github.com/twitter/bootstrap/issues/1768
      w.gl.utils.handleLocationHash = function () {
        var hash = w.gl.utils.getLocationHash();
        if (!hash) return;

        // This is required to handle non-unicode characters in hash
        hash = decodeURIComponent(hash);

        var navbar = document.querySelector('.navbar-gitlab');
        var subnav = document.querySelector('.layout-nav');
        var fixedTabs = document.querySelector('.js-tabs-affix');

        var adjustment = 0;
        if (navbar) adjustment -= navbar.offsetHeight;
        if (subnav) adjustment -= subnav.offsetHeight;

        // scroll to user-generated markdown anchor if we cannot find a match
        if (document.getElementById(hash) === null) {
          var target = document.getElementById('user-content-' + hash);
          if (target && target.scrollIntoView) {
            target.scrollIntoView(true);
            window.scrollBy(0, adjustment);
          }
        } else {
          // only adjust for fixedTabs when not targeting user-generated content
          if (fixedTabs) {
            adjustment -= fixedTabs.offsetHeight;
          }
          window.scrollBy(0, adjustment);
        }
      };

      // Check if element scrolled into viewport from above or below
      // Courtesy http://stackoverflow.com/a/7557433/414749
      w.gl.utils.isInViewport = function (el) {
        var rect = el.getBoundingClientRect();

        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
      };

      gl.utils.getPagePath = function (index) {
        index = index || 0;
        return $('body').data('page').split(':')[index];
      };

      gl.utils.parseUrl = function (url) {
        var parser = document.createElement('a');
        parser.href = url;
        return parser;
      };

      gl.utils.parseUrlPathname = function (url) {
        var parsedUrl = gl.utils.parseUrl(url);
        // parsedUrl.pathname will return an absolute path for Firefox and a relative path for IE11
        // We have to make sure we always have an absolute path.
        return parsedUrl.pathname.charAt(0) === '/' ? parsedUrl.pathname : '/' + parsedUrl.pathname;
      };

      gl.utils.getUrlParamsArray = function () {
        // We can trust that each param has one & since values containing & will be encoded
        // Remove the first character of search as it is always ?
        return window.location.search.slice(1).split('&');
      };

      gl.utils.isMetaKey = function (e) {
        return e.metaKey || e.ctrlKey || e.altKey || e.shiftKey;
      };

      gl.utils.isMetaClick = function (e) {
        // Identify following special clicks
        // 1) Cmd + Click on Mac (e.metaKey)
        // 2) Ctrl + Click on PC (e.ctrlKey)
        // 3) Middle-click or Mouse Wheel Click (e.which is 2)
        return e.metaKey || e.ctrlKey || e.which === 2;
      };

      gl.utils.scrollToElement = function ($el) {
        var top = $el.offset().top;
        gl.navBarHeight = gl.navBarHeight || $('.navbar-gitlab').height();
        gl.navLinksHeight = gl.navLinksHeight || $('.nav-links').height();
        gl.mrTabsHeight = gl.mrTabsHeight || $('.merge-request-tabs').height();

        return $('body, html').animate({
          scrollTop: top - (gl.navBarHeight + gl.navLinksHeight + gl.mrTabsHeight)
        }, 200);
      };

      /**
        this will take in the `name` of the param you want to parse in the url
        if the name does not exist this function will return `null`
        otherwise it will return the value of the param key provided
      */
      w.gl.utils.getParameterByName = function (name) {
        var url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      };

      w.gl.utils.getSelectedFragment = function () {
        var selection = window.getSelection();
        if (selection.rangeCount === 0) return null;
        var documentFragment = selection.getRangeAt(0).cloneContents();
        if (documentFragment.textContent.length === 0) return null;

        return documentFragment;
      };

      w.gl.utils.insertText = function (target, text) {
        // Firefox doesn't support `document.execCommand('insertText', false, text)` on textareas

        var selectionStart = target.selectionStart;
        var selectionEnd = target.selectionEnd;
        var value = target.value;

        var textBefore = value.substring(0, selectionStart);
        var textAfter = value.substring(selectionEnd, value.length);
        var newText = textBefore + text + textAfter;

        target.value = newText;
        target.selectionStart = target.selectionEnd = selectionStart + text.length;

        // Trigger autosave
        $(target).trigger('input');

        // Trigger autosize
        var event = document.createEvent('Event');
        event.initEvent('autosize:update', true, false);
        target.dispatchEvent(event);
      };

      w.gl.utils.nodeMatchesSelector = function (node, selector) {
        var matches = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

        if (matches) {
          return matches.call(node, selector);
        }

        // IE11 doesn't support `node.matches(selector)`

        var parentNode = node.parentNode;
        if (!parentNode) {
          parentNode = document.createElement('div');
          node = node.cloneNode(true);
          parentNode.appendChild(node);
        }

        var matchingNodes = parentNode.querySelectorAll(selector);
        return Array.prototype.indexOf.call(matchingNodes, node) !== -1;
      };

      /**
        this will take in the headers from an API response and normalize them
        this way we don't run into production issues when nginx gives us lowercased header keys
      */
      w.gl.utils.normalizeHeaders = function (headers) {
        var upperCaseHeaders = {};

        Object.keys(headers).forEach(function (e) {
          upperCaseHeaders[e.toUpperCase()] = headers[e];
        });

        return upperCaseHeaders;
      };

      /**
       * Transforms a DOMStringMap into a plain object.
       *
       * @param {DOMStringMap} DOMStringMapObject
       * @returns {Object}
       */
      w.gl.utils.DOMStringMapToObject = function (DOMStringMapObject) {
        return Object.keys(DOMStringMapObject).reduce(function (acc, element) {
          acc[element] = DOMStringMapObject[element];
          return acc;
        }, {});
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, object-shorthand, func-names, space-before-function-paren, arrow-parens, no-unused-vars, class-methods-use-this, no-var, consistent-return, no-param-reassign, max-len */

  (function (global) {
    var TemplateSelector = function () {
      function TemplateSelector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            dropdown = _ref.dropdown,
            data = _ref.data,
            pattern = _ref.pattern,
            wrapper = _ref.wrapper,
            editor = _ref.editor,
            fileEndpoint = _ref.fileEndpoint,
            $input = _ref.$input;

        _classCallCheck(this, TemplateSelector);

        this.onClick = this.onClick.bind(this);
        this.dropdown = dropdown;
        this.data = data;
        this.pattern = pattern;
        this.wrapper = wrapper;
        this.editor = editor;
        this.fileEndpoint = fileEndpoint;
        this.$input = $input || $('#file_name');
        this.dropdownIcon = $('.fa-chevron-down', this.dropdown);
        this.buildDropdown();
        this.bindEvents();
        this.onFilenameUpdate();

        this.autosizeUpdateEvent = document.createEvent('Event');
        this.autosizeUpdateEvent.initEvent('autosize:update', true, false);
      }

      _createClass(TemplateSelector, [{
        key: 'buildDropdown',
        value: function buildDropdown() {
          return this.dropdown.glDropdown({
            data: this.data,
            filterable: true,
            selectable: true,
            toggleLabel: this.toggleLabel,
            search: {
              fields: ['name']
            },
            clicked: this.onClick,
            text: function text(item) {
              return item.name;
            }
          });
        }
      }, {
        key: 'bindEvents',
        value: function bindEvents() {
          var _this = this;

          return this.$input.on('keyup blur', function (e) {
            return _this.onFilenameUpdate();
          });
        }
      }, {
        key: 'toggleLabel',
        value: function toggleLabel(item) {
          return item.name;
        }
      }, {
        key: 'onFilenameUpdate',
        value: function onFilenameUpdate() {
          var filenameMatches;
          if (!this.$input.length) {
            return;
          }
          filenameMatches = this.pattern.test(this.$input.val().trim());
          if (!filenameMatches) {
            this.wrapper.addClass('hidden');
            return;
          }
          return this.wrapper.removeClass('hidden');
        }
      }, {
        key: 'onClick',
        value: function onClick(item, el, e) {
          e.preventDefault();
          return this.requestFile(item);
        }
      }, {
        key: 'requestFile',
        value: function requestFile(item) {}
        // This `requestFile` method is an abstract method that should
        // be added by all subclasses.


        // To be implemented on the extending class
        // e.g.
        // Api.gitignoreText item.name, @requestFileSuccess.bind(@)

      }, {
        key: 'requestFileSuccess',
        value: function requestFileSuccess(file) {
          var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              skipFocus = _ref2.skipFocus;

          if (!file) return;

          var oldValue = this.editor.getValue();
          var newValue = file.content;

          this.editor.setValue(newValue, 1);
          if (!skipFocus) this.editor.focus();

          if (this.editor instanceof jQuery) {
            this.editor.get(0).dispatchEvent(this.autosizeUpdateEvent);
          }
        }
      }, {
        key: 'startLoadingSpinner',
        value: function startLoadingSpinner() {
          this.dropdownIcon.addClass('fa-spinner fa-spin').removeClass('fa-chevron-down');
        }
      }, {
        key: 'stopLoadingSpinner',
        value: function stopLoadingSpinner() {
          this.dropdownIcon.addClass('fa-chevron-down').removeClass('fa-spinner fa-spin');
        }
      }]);

      return TemplateSelector;
    }();

    global.TemplateSelector = TemplateSelector;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/**
 * Copyright (c) 2016 hustcc
 * License: MIT
 * Version: v2.0.2
 * https://github.com/hustcc/timeago.js
 * This is a forked from (https://gitlab.com/ClemMakesApps/timeago.js)
**/
/* eslint-disable */
/* jshint expr: true */
!function (root, factory) {
  if (typeof module === 'object' && module.exports)
    module.exports = factory(root);
  else
    root.timeago = factory(root);
}(typeof window !== 'undefined' ? window : this,
function () {
  var cnt = 0, // the timer counter, for timer key
    indexMapEn = 'second_minute_hour_day_week_month_year'.split('_'),

    // build-in locales: en & zh_CN
    locales = {
      'en': function(number, index) {
        if (index === 0) return ['just now', 'right now'];
        var unit = indexMapEn[parseInt(index / 2)];
        if (number > 1) unit += 's';
        return [number + ' ' + unit + ' ago', 'in ' + number + ' ' + unit];
      },
    },
    // second, minute, hour, day, week, month, year(365 days)
    SEC_ARRAY = [60, 60, 24, 7, 365/7/12, 12],
    SEC_ARRAY_LEN = 6,
    ATTR_DATETIME = 'datetime';

  // format Date / string / timestamp to Date instance.
  function toDate(input) {
    if (input instanceof Date) return input;
    if (!isNaN(input)) return new Date(toInt(input));
    if (/^\d+$/.test(input)) return new Date(toInt(input, 10));
    input = (input || '').trim().replace(/\.\d+/, '') // remove milliseconds
      .replace(/-/, '/').replace(/-/, '/')
      .replace(/T/, ' ').replace(/Z/, ' UTC')
      .replace(/([\+\-]\d\d)\:?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
  }
  // change f into int, remove Decimal. just for code compression
  function toInt(f) {
    return parseInt(f);
  }
  // format the diff second to *** time ago, with setting locale
  function formatDiff(diff, locale, defaultLocale) {
    // if locale is not exist, use defaultLocale.
    // if defaultLocale is not exist, use build-in `en`.
    // be sure of no error when locale is not exist.
    locale = locales[locale] ? locale : (locales[defaultLocale] ? defaultLocale : 'en');
    // if (! locales[locale]) locale = defaultLocale;
    var i = 0;
      agoin = diff < 0 ? 1 : 0; // timein or timeago
    diff = Math.abs(diff);

    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY_LEN; i++) {
      diff /= SEC_ARRAY[i];
    }
    diff = toInt(diff);
    i *= 2;

    if (diff > (i === 0 ? 9 : 1)) i += 1;
    return locales[locale](diff, i)[agoin].replace('%s', diff);
  }
  // calculate the diff second between date to be formated an now date.
  function diffSec(date, nowDate) {
    nowDate = nowDate ? toDate(nowDate) : new Date();
    return (nowDate - toDate(date)) / 1000;
  }
  /**
   * nextInterval: calculate the next interval time.
   * - diff: the diff sec between now and date to be formated.
   *
   * What's the meaning?
   * diff = 61 then return 59
   * diff = 3601 (an hour + 1 second), then return 3599
   * make the interval with high performace.
  **/
  function nextInterval(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY_LEN; i++) {
      diff /= SEC_ARRAY[i];
      rst *= SEC_ARRAY[i];
    }
    // return leftSec(d, rst);
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
  }
  // get the datetime attribute, jQuery and DOM
  function getDateAttr(node) {
    if (node.getAttribute) return node.getAttribute(ATTR_DATETIME);
    if(node.attr) return node.attr(ATTR_DATETIME);
  }
  /**
   * timeago: the function to get `timeago` instance.
   * - nowDate: the relative date, default is new Date().
   * - defaultLocale: the default locale, default is en. if your set it, then the `locale` parameter of format is not needed of you.
   *
   * How to use it?
   * var timeagoLib = require('timeago.js');
   * var timeago = timeagoLib(); // all use default.
   * var timeago = timeagoLib('2016-09-10'); // the relative date is 2016-09-10, so the 2016-09-11 will be 1 day ago.
   * var timeago = timeagoLib(null, 'zh_CN'); // set default locale is `zh_CN`.
   * var timeago = timeagoLib('2016-09-10', 'zh_CN'); // the relative date is 2016-09-10, and locale is zh_CN, so the 2016-09-11 will be 1天前.
  **/
  function Timeago(nowDate, defaultLocale) {
    var timers = {}; // real-time render timers
    // if do not set the defaultLocale, set it with `en`
    if (! defaultLocale) defaultLocale = 'en'; // use default build-in locale
    // what the timer will do
    function doRender(node, date, locale, cnt) {
      var diff = diffSec(date, nowDate);
      node.innerHTML = formatDiff(diff, locale, defaultLocale);
      // waiting %s seconds, do the next render
      timers['k' + cnt] = setTimeout(function() {
        doRender(node, date, locale, cnt);
      }, nextInterval(diff) * 1000);
    }
    /**
     * nextInterval: calculate the next interval time.
     * - diff: the diff sec between now and date to be formated.
     *
     * What's the meaning?
     * diff = 61 then return 59
     * diff = 3601 (an hour + 1 second), then return 3599
     * make the interval with high performace.
    **/
    // this.nextInterval = function(diff) { // for dev test
    //   var rst = 1, i = 0, d = Math.abs(diff);
    //   for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY_LEN; i++) {
    //     diff /= SEC_ARRAY[i];
    //     rst *= SEC_ARRAY[i];
    //   }
    //   // return leftSec(d, rst);
    //   d = d % rst;
    //   d = d ? rst - d : rst;
    //   return Math.ceil(d);
    // }; // for dev test
    /**
     * format: format the date to *** time ago, with setting or default locale
     * - date: the date / string / timestamp to be formated
     * - locale: the formated string's locale name, e.g. en / zh_CN
     *
     * How to use it?
     * var timeago = require('timeago.js')();
     * timeago.format(new Date(), 'pl'); // Date instance
     * timeago.format('2016-09-10', 'fr'); // formated date string
     * timeago.format(1473473400269); // timestamp with ms
    **/
    this.format = function(date, locale) {
      return formatDiff(diffSec(date, nowDate), locale, defaultLocale);
    };
    /**
     * render: render the DOM real-time.
     * - nodes: which nodes will be rendered.
     * - locale: the locale name used to format date.
     *
     * How to use it?
     * var timeago = new require('timeago.js')();
     * // 1. javascript selector
     * timeago.render(document.querySelectorAll('.need_to_be_rendered'));
     * // 2. use jQuery selector
     * timeago.render($('.need_to_be_rendered'), 'pl');
     *
     * Notice: please be sure the dom has attribute `datetime`.
    **/
    this.render = function(nodes, locale) {
      if (nodes.length === undefined) nodes = [nodes];
      for (var i = 0; i < nodes.length; i++) {
        doRender(nodes[i], getDateAttr(nodes[i]), locale, ++ cnt); // render item
      }
    };
    /**
     * cancel: cancel all the timers which are doing real-time render.
     *
     * How to use it?
     * var timeago = new require('timeago.js')();
     * timeago.render(document.querySelectorAll('.need_to_be_rendered'));
     * timeago.cancel(); // will stop all the timer, stop render in real time.
    **/
    this.cancel = function() {
      for (var key in timers) {
        clearTimeout(timers[key]);
      }
      timers = {};
    };
    /**
     * setLocale: set the default locale name.
     *
     * How to use it?
     * var timeago = require('timeago.js');
     * timeago = new timeago();
     * timeago.setLocale('fr');
    **/
    this.setLocale = function(locale) {
      defaultLocale = locale;
    };
    return this;
  }
  /**
   * timeago: the function to get `timeago` instance.
   * - nowDate: the relative date, default is new Date().
   * - defaultLocale: the default locale, default is en. if your set it, then the `locale` parameter of format is not needed of you.
   *
   * How to use it?
   * var timeagoLib = require('timeago.js');
   * var timeago = timeagoLib(); // all use default.
   * var timeago = timeagoLib('2016-09-10'); // the relative date is 2016-09-10, so the 2016-09-11 will be 1 day ago.
   * var timeago = timeagoLib(null, 'zh_CN'); // set default locale is `zh_CN`.
   * var timeago = timeagoLib('2016-09-10', 'zh_CN'); // the relative date is 2016-09-10, and locale is zh_CN, so the 2016-09-11 will be 1天前.
   **/
  function timeagoFactory(nowDate, defaultLocale) {
    return new Timeago(nowDate, defaultLocale);
  }
  /**
   * register: register a new language locale
   * - locale: locale name, e.g. en / zh_CN, notice the standard.
   * - localeFunc: the locale process function
   *
   * How to use it?
   * var timeagoLib = require('timeago.js');
   *
   * timeagoLib.register('the locale name', the_locale_func);
   * // or
   * timeagoLib.register('pl', require('timeago.js/locales/pl'));
   **/
  timeagoFactory.register = function(locale, localeFunc) {
    locales[locale] = localeFunc;
  };

  return timeagoFactory;
});

}.call(window));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, comma-dangle, no-unused-expressions, prefer-template, max-len */
  /* global timeago */
  /* global dateFormat */

  window.timeago = __webpack_require__(6);
  window.dateFormat = __webpack_require__(16);

  (function () {
    (function (w) {
      var base;
      var timeagoInstance;

      if (w.gl == null) {
        w.gl = {};
      }
      if ((base = w.gl).utils == null) {
        base.utils = {};
      }
      w.gl.utils.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      w.gl.utils.formatDate = function (datetime) {
        return dateFormat(datetime, 'mmm d, yyyy h:MMtt Z');
      };

      w.gl.utils.getDayName = function (date) {
        return this.days[date.getDay()];
      };

      w.gl.utils.localTimeAgo = function ($timeagoEls) {
        var setTimeago = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        $timeagoEls.each(function (i, el) {
          el.setAttribute('title', gl.utils.formatDate(el.getAttribute('datetime')));

          if (setTimeago) {
            // Recreate with custom template
            $(el).tooltip({
              template: '<div class="tooltip local-timeago" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            });
          }

          el.classList.add('js-timeago-render');
        });

        gl.utils.renderTimeago($timeagoEls);
      };

      w.gl.utils.getTimeago = function () {
        var locale;

        if (!timeagoInstance) {
          locale = function locale(number, index) {
            return [['less than a minute ago', 'a while'], ['less than a minute ago', 'in %s seconds'], ['about a minute ago', 'in 1 minute'], ['%s minutes ago', 'in %s minutes'], ['about an hour ago', 'in 1 hour'], ['about %s hours ago', 'in %s hours'], ['a day ago', 'in 1 day'], ['%s days ago', 'in %s days'], ['a week ago', 'in 1 week'], ['%s weeks ago', 'in %s weeks'], ['a month ago', 'in 1 month'], ['%s months ago', 'in %s months'], ['a year ago', 'in 1 year'], ['%s years ago', 'in %s years']][index];
          };

          timeago.register('gl_en', locale);
          timeagoInstance = timeago();
        }

        return timeagoInstance;
      };

      w.gl.utils.timeFor = function (time, suffix, expiredLabel) {
        var timefor;
        if (!time) {
          return '';
        }
        suffix || (suffix = 'remaining');
        expiredLabel || (expiredLabel = 'Past due');
        timefor = gl.utils.getTimeago().format(time).replace('in', '');
        if (timefor.indexOf('ago') > -1) {
          timefor = expiredLabel;
        } else {
          timefor = timefor.trim() + ' ' + suffix;
        }
        return timefor;
      };

      w.gl.utils.cachedTimeagoElements = [];
      w.gl.utils.renderTimeago = function ($els) {
        if (!$els && !w.gl.utils.cachedTimeagoElements.length) {
          w.gl.utils.cachedTimeagoElements = [].slice.call(document.querySelectorAll('.js-timeago-render'));
        } else if ($els) {
          w.gl.utils.cachedTimeagoElements = w.gl.utils.cachedTimeagoElements.concat($els.toArray());
        }

        w.gl.utils.cachedTimeagoElements.forEach(gl.utils.updateTimeagoText);
      };

      w.gl.utils.updateTimeagoText = function (el) {
        var timeago = gl.utils.getTimeago();
        var formattedDate = timeago.format(el.getAttribute('datetime'), 'gl_en');

        if (el.textContent !== formattedDate) {
          el.textContent = formattedDate;
        }
      };

      w.gl.utils.initTimeagoTimeout = function () {
        gl.utils.renderTimeago();

        gl.utils.timeagoTimeout = setTimeout(gl.utils.initTimeagoTimeout, 1000);
      };

      w.gl.utils.getDayDifference = function (a, b) {
        var millisecondsPerDay = 1000 * 60 * 60 * 24;
        var date1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        var date2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((date2 - date1) / millisecondsPerDay);
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, prefer-arrow-callback, consistent-return, object-shorthand, no-unused-vars, one-var, one-var-declaration-per-line, no-else-return, comma-dangle, max-len */
  /* global Mousetrap */
  /* global findFileURL */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.Shortcuts = function () {
      function Shortcuts(skipResetBindings) {
        this.onToggleHelp = bind(this.onToggleHelp, this);
        this.enabledHelp = [];
        if (!skipResetBindings) {
          Mousetrap.reset();
        }
        Mousetrap.bind('?', this.onToggleHelp);
        Mousetrap.bind('s', Shortcuts.focusSearch);
        Mousetrap.bind('f', function (_this) {
          return function (e) {
            return _this.focusFilter(e);
          };
        }(this));
        Mousetrap.bind(['ctrl+shift+p', 'command+shift+p'], this.toggleMarkdownPreview);
        if (typeof findFileURL !== "undefined" && findFileURL !== null) {
          Mousetrap.bind('t', function () {
            return gl.utils.visitUrl(findFileURL);
          });
        }
      }

      Shortcuts.prototype.onToggleHelp = function (e) {
        e.preventDefault();
        return Shortcuts.toggleHelp(this.enabledHelp);
      };

      Shortcuts.prototype.toggleMarkdownPreview = function (e) {
        return $(document).triggerHandler('markdown-preview:toggle', [e]);
      };

      Shortcuts.toggleHelp = function (location) {
        var $modal;
        $modal = $('#modal-shortcuts');
        if ($modal.length) {
          $modal.modal('toggle');
          return;
        }
        return $.ajax({
          url: gon.shortcuts_path,
          dataType: 'script',
          success: function success(e) {
            var i, l, len, results;
            if (location && location.length > 0) {
              results = [];
              for (i = 0, len = location.length; i < len; i += 1) {
                l = location[i];
                results.push($(l).show());
              }
              return results;
            } else {
              $('.hidden-shortcut').show();
              return $('.js-more-help-button').remove();
            }
          }
        });
      };

      Shortcuts.prototype.focusFilter = function (e) {
        if (this.filterInput == null) {
          this.filterInput = $('input[type=search]', '.nav-controls');
        }
        this.filterInput.focus();
        return e.preventDefault();
      };

      Shortcuts.focusSearch = function (e) {
        $('#search').focus();
        return e.preventDefault();
      };

      return Shortcuts;
    }();

    $(document).on('click.more_help', '.js-more-help-button', function (e) {
      $(this).remove();
      $('.hidden-shortcut').show();
      return e.preventDefault();
    });

    Mousetrap.stopCallback = function () {
      var defaultStopCallback;
      defaultStopCallback = Mousetrap.stopCallback;
      return function (e, element, combo) {
        // allowed shortcuts if textarea, input, contenteditable are focused
        if (['ctrl+shift+p', 'command+shift+p'].indexOf(combo) !== -1) {
          return false;
        } else {
          return defaultStopCallback.apply(this, arguments);
        }
      };
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-arrow-callback, consistent-return, no-return-assign */
  /* global Mousetrap */
  /* global Shortcuts */

  __webpack_require__(8);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.ShortcutsNavigation = function (superClass) {
      extend(ShortcutsNavigation, superClass);

      function ShortcutsNavigation() {
        ShortcutsNavigation.__super__.constructor.call(this);
        Mousetrap.bind('g p', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-project');
        });
        Mousetrap.bind('g e', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-project-activity');
        });
        Mousetrap.bind('g f', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-tree');
        });
        Mousetrap.bind('g c', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-commits');
        });
        Mousetrap.bind('g b', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-builds');
        });
        Mousetrap.bind('g n', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-network');
        });
        Mousetrap.bind('g g', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-graphs');
        });
        Mousetrap.bind('g i', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-issues');
        });
        Mousetrap.bind('g l', function () {
          ShortcutsNavigation.findAndFollowLink('.shortcuts-issue-boards');
        });
        Mousetrap.bind('g m', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-merge_requests');
        });
        Mousetrap.bind('g w', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-wiki');
        });
        Mousetrap.bind('g s', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-snippets');
        });
        Mousetrap.bind('i', function () {
          return ShortcutsNavigation.findAndFollowLink('.shortcuts-new-issue');
        });
        this.enabledHelp.push('.hidden-shortcut.project');
      }

      ShortcutsNavigation.findAndFollowLink = function (selector) {
        var link;
        link = $(selector).attr('href');
        if (link) {
          return window.location = link;
        }
      };

      return ShortcutsNavigation;
    }(Shortcuts);
  }).call(this);
}).call(window);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
}.call(window));

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    /*
     * TODO: Make these methods more configurable (e.g. parseSeconds timePeriodContstraints,
     * stringifyTime condensed or non-condensed, abbreviateTimelengths)
     * */

    var utils = window.gl.utils = gl.utils || {};
    var prettyTime = utils.prettyTime = {
      /*
       * Accepts seconds and returns a timeObject { weeks: #, days: #, hours: #, minutes: # }
       * Seconds can be negative or positive, zero or non-zero.
      */
      parseSeconds: function parseSeconds(seconds) {
        var DAYS_PER_WEEK = 5;
        var HOURS_PER_DAY = 8;
        var MINUTES_PER_HOUR = 60;
        var MINUTES_PER_WEEK = DAYS_PER_WEEK * HOURS_PER_DAY * MINUTES_PER_HOUR;
        var MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

        var timePeriodConstraints = {
          weeks: MINUTES_PER_WEEK,
          days: MINUTES_PER_DAY,
          hours: MINUTES_PER_HOUR,
          minutes: 1
        };

        var unorderedMinutes = prettyTime.secondsToMinutes(seconds);

        return _.mapObject(timePeriodConstraints, function (minutesPerPeriod) {
          var periodCount = Math.floor(unorderedMinutes / minutesPerPeriod);

          unorderedMinutes -= periodCount * minutesPerPeriod;

          return periodCount;
        });
      },


      /*
      * Accepts a timeObject and returns a condensed string representation of it
      * (e.g. '1w 2d 3h 1m' or '1h 30m'). Zero value units are not included.
      */

      stringifyTime: function stringifyTime(timeObject) {
        var reducedTime = _.reduce(timeObject, function (memo, unitValue, unitName) {
          var isNonZero = !!unitValue;
          return isNonZero ? memo + ' ' + unitValue + unitName.charAt(0) : memo;
        }, '').trim();
        return reducedTime.length ? reducedTime : '0m';
      },


      /*
      * Accepts a time string of any size (e.g. '1w 2d 3h 5m' or '1w 2d') and returns
      *  the first non-zero unit/value pair.
      */

      abbreviateTime: function abbreviateTime(timeStr) {
        return timeStr.split(' ').filter(function (unitStr) {
          return unitStr.charAt(0) !== '0';
        })[0];
      },
      secondsToMinutes: function secondsToMinutes(seconds) {
        return Math.abs(seconds / 60);
      }
    };
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len */

  __webpack_require__(17);

  (function () {
    (function (w) {
      var base;
      if (w.gl == null) {
        w.gl = {};
      }
      if ((base = w.gl).text == null) {
        base.text = {};
      }
      gl.text.addDelimiter = function (text) {
        return text ? text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : text;
      };
      gl.text.randomString = function () {
        return Math.random().toString(36).substring(7);
      };
      gl.text.replaceRange = function (s, start, end, substitute) {
        return s.substring(0, start) + substitute + s.substring(end);
      };
      gl.text.getTextWidth = function (text, font) {
        /**
        * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
        *
        * @param {String} text The text to be rendered.
        * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
        *
        * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
        */
        // re-use canvas object for better performance
        var canvas = gl.text.getTextWidth.canvas || (gl.text.getTextWidth.canvas = document.createElement('canvas'));
        var context = canvas.getContext('2d');
        context.font = font;
        return context.measureText(text).width;
      };
      gl.text.selectedText = function (text, textarea) {
        return text.substring(textarea.selectionStart, textarea.selectionEnd);
      };
      gl.text.lineBefore = function (text, textarea) {
        var split;
        split = text.substring(0, textarea.selectionStart).trim().split('\n');
        return split[split.length - 1];
      };
      gl.text.lineAfter = function (text, textarea) {
        return text.substring(textarea.selectionEnd).trim().split('\n')[0];
      };
      gl.text.blockTagText = function (text, textArea, blockTag, selected) {
        var lineAfter, lineBefore;
        lineBefore = this.lineBefore(text, textArea);
        lineAfter = this.lineAfter(text, textArea);
        if (lineBefore === blockTag && lineAfter === blockTag) {
          // To remove the block tag we have to select the line before & after
          if (blockTag != null) {
            textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
            textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
          }
          return selected;
        } else {
          return blockTag + "\n" + selected + "\n" + blockTag;
        }
      };
      gl.text.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
        var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine;
        removedLastNewLine = false;
        removedFirstNewLine = false;

        // Remove the first newline
        if (selected.indexOf('\n') === 0) {
          removedFirstNewLine = true;
          selected = selected.replace(/\n+/, '');
        }

        // Remove the last newline
        if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
          removedLastNewLine = true;
          selected = selected.replace(/\n$/, '');
        }

        selectedSplit = selected.split('\n');
        startChar = !wrap && textArea.selectionStart > 0 ? '\n' : '';

        if (selectedSplit.length > 1 && (!wrap || blockTag != null)) {
          if (blockTag != null) {
            insertText = this.blockTagText(text, textArea, blockTag, selected);
          } else {
            insertText = selectedSplit.map(function (val) {
              if (val.indexOf(tag) === 0) {
                return "" + val.replace(tag, '');
              } else {
                return "" + tag + val;
              }
            }).join('\n');
          }
        } else {
          insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
        }

        if (removedFirstNewLine) {
          insertText = '\n' + insertText;
        }

        if (removedLastNewLine) {
          insertText += '\n';
        }

        if (document.queryCommandSupported('insertText')) {
          inserted = document.execCommand('insertText', false, insertText);
        }
        if (!inserted) {
          try {
            document.execCommand("ms-beginUndoUnit");
          } catch (error) {}
          textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
          try {
            document.execCommand("ms-endUndoUnit");
          } catch (error) {}
        }
        return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
      };
      gl.text.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
        var pos;
        if (!textArea.setSelectionRange) {
          return;
        }
        if (textArea.selectionStart === textArea.selectionEnd) {
          if (wrapped) {
            pos = textArea.selectionStart - tag.length;
          } else {
            pos = textArea.selectionStart;
          }

          if (removedLastNewLine) {
            pos -= 1;
          }

          return textArea.setSelectionRange(pos, pos);
        }
      };
      gl.text.updateText = function (textArea, tag, blockTag, wrap) {
        var $textArea, oldVal, selected, text;
        $textArea = $(textArea);
        oldVal = $textArea.val();
        textArea = $textArea.get(0);
        text = $textArea.val();
        selected = this.selectedText(text, textArea);
        $textArea.focus();
        return this.insertText(textArea, text, tag, blockTag, selected, wrap);
      };
      gl.text.init = function (form) {
        var self;
        self = this;
        return $('.js-md', form).off('click').on('click', function () {
          var $this;
          $this = $(this);
          return self.updateText($this.closest('.md-area').find('textarea'), $this.data('md-tag'), $this.data('md-block'), !$this.data('md-prepend'));
        });
      };
      gl.text.removeListeners = function (form) {
        return $('.js-md', form).off();
      };
      gl.text.humanize = function (string) {
        return string.charAt(0).toUpperCase() + string.replace(/_/g, ' ').slice(1);
      };
      gl.text.pluralize = function (str, count) {
        return str + (count > 1 || count === 0 ? 's' : '');
      };
      gl.text.truncate = function (string, maxLength) {
        return string.substr(0, maxLength - 3) + '...';
      };
      gl.text.dasherize = function (str) {
        return str.replace(/[_\s]+/g, '-');
      };
      gl.text.slugify = function (str) {
        return str.trim().toLowerCase().latinise();
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /*
  * Instances of SmartInterval extend the functionality of `setInterval`, make it configurable
  * and controllable by a public API.
  *
  * */

  (function () {
    var SmartInterval = function () {
      /**
        * @param { function } opts.callback Function to be called on each iteration (required)
        * @param { milliseconds } opts.startingInterval `currentInterval` is set to this initially
        * @param { milliseconds } opts.maxInterval `currentInterval` will be incremented to this
        * @param { milliseconds } opts.hiddenInterval `currentInterval` is set to this
        *                         when the page is hidden
        * @param { integer } opts.incrementByFactorOf `currentInterval` is incremented by this factor
        * @param { boolean } opts.lazyStart Configure if timer is initialized on
        *                    instantiation or lazily
        * @param { boolean } opts.immediateExecution Configure if callback should
        *                    be executed before the first interval.
        */
      function SmartInterval() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, SmartInterval);

        this.cfg = {
          callback: opts.callback,
          startingInterval: opts.startingInterval,
          maxInterval: opts.maxInterval,
          hiddenInterval: opts.hiddenInterval,
          incrementByFactorOf: opts.incrementByFactorOf,
          lazyStart: opts.lazyStart,
          immediateExecution: opts.immediateExecution
        };

        this.state = {
          intervalId: null,
          currentInterval: this.cfg.startingInterval,
          pageVisibility: 'visible'
        };

        this.initInterval();
      }
      /* public */

      _createClass(SmartInterval, [{
        key: 'start',
        value: function start() {
          var _this = this;

          var cfg = this.cfg;
          var state = this.state;

          if (cfg.immediateExecution) {
            cfg.immediateExecution = false;
            cfg.callback();
          }

          state.intervalId = window.setInterval(function () {
            cfg.callback();

            if (_this.getCurrentInterval() === cfg.maxInterval) {
              return;
            }

            _this.incrementInterval();
            _this.resume();
          }, this.getCurrentInterval());
        }

        // cancel the existing timer, setting the currentInterval back to startingInterval

      }, {
        key: 'cancel',
        value: function cancel() {
          this.setCurrentInterval(this.cfg.startingInterval);
          this.stopTimer();
        }
      }, {
        key: 'onVisibilityHidden',
        value: function onVisibilityHidden() {
          if (this.cfg.hiddenInterval) {
            this.setCurrentInterval(this.cfg.hiddenInterval);
            this.resume();
          } else {
            this.cancel();
          }
        }

        // start a timer, using the existing interval

      }, {
        key: 'resume',
        value: function resume() {
          this.stopTimer(); // stop exsiting timer, in case timer was not previously stopped
          this.start();
        }
      }, {
        key: 'onVisibilityVisible',
        value: function onVisibilityVisible() {
          this.cancel();
          this.start();
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.cancel();
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          $(document).off('visibilitychange').off('beforeunload');
        }

        /* private */

      }, {
        key: 'initInterval',
        value: function initInterval() {
          var cfg = this.cfg;

          if (!cfg.lazyStart) {
            this.start();
          }

          this.initVisibilityChangeHandling();
          this.initPageUnloadHandling();
        }
      }, {
        key: 'initVisibilityChangeHandling',
        value: function initVisibilityChangeHandling() {
          // cancel interval when tab no longer shown (prevents cached pages from polling)
          document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
        }
      }, {
        key: 'initPageUnloadHandling',
        value: function initPageUnloadHandling() {
          var _this2 = this;

          // TODO: Consider refactoring in light of turbolinks removal.
          // prevent interval continuing after page change, when kept in cache by Turbolinks
          $(document).on('beforeunload', function () {
            return _this2.cancel();
          });
        }
      }, {
        key: 'handleVisibilityChange',
        value: function handleVisibilityChange(e) {
          this.state.pageVisibility = e.target.visibilityState;
          var intervalAction = this.isPageVisible() ? this.onVisibilityVisible : this.onVisibilityHidden;

          intervalAction.apply(this);
        }
      }, {
        key: 'getCurrentInterval',
        value: function getCurrentInterval() {
          return this.state.currentInterval;
        }
      }, {
        key: 'setCurrentInterval',
        value: function setCurrentInterval(newInterval) {
          this.state.currentInterval = newInterval;
        }
      }, {
        key: 'incrementInterval',
        value: function incrementInterval() {
          var cfg = this.cfg;
          var currentInterval = this.getCurrentInterval();
          if (cfg.hiddenInterval && !this.isPageVisible()) return;
          var nextInterval = currentInterval * cfg.incrementByFactorOf;

          if (nextInterval > cfg.maxInterval) {
            nextInterval = cfg.maxInterval;
          }

          this.setCurrentInterval(nextInterval);
        }
      }, {
        key: 'isPageVisible',
        value: function isPageVisible() {
          return this.state.pageVisibility === 'visible';
        }
      }, {
        key: 'stopTimer',
        value: function stopTimer() {
          var state = this.state;

          state.intervalId = window.clearInterval(state.intervalId);
        }
      }]);

      return SmartInterval;
    }();

    gl.SmartInterval = SmartInterval;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */
 (function (global, factory) {
      true ? module.exports = factory() :
     typeof define === 'function' && define.amd ? define(factory) :
     (global.dateFormat = factory());
 }(this, (function () { 'use strict';
  var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(L > 99 ? Math.round(L / 10) : L),
          t:    H < 12 ? "a"  : "p",
          tt:   H < 12 ? "am" : "pm",
          T:    H < 12 ? "A"  : "P",
          TT:   H < 12 ? "AM" : "PM",
          Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
  };

  return dateFormat;
})));

}.call(window));

/***/ }),
/* 17 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

// Converting text to basic latin (aka removing accents)
//
// Based on: http://semplicewebsites.com/removing-accents-javascript
//
var Latinise = {
  map: {"Á":"A","Ă":"A","Ắ":"A","Ặ":"A","Ằ":"A","Ẳ":"A","Ẵ":"A","Ǎ":"A","Â":"A","Ấ":"A","Ậ":"A","Ầ":"A","Ẩ":"A","Ẫ":"A","Ä":"A","Ǟ":"A","Ȧ":"A","Ǡ":"A","Ạ":"A","Ȁ":"A","À":"A","Ả":"A","Ȃ":"A","Ā":"A","Ą":"A","Å":"A","Ǻ":"A","Ḁ":"A","Ⱥ":"A","Ã":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ḃ":"B","Ḅ":"B","Ɓ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ć":"C","Č":"C","Ç":"C","Ḉ":"C","Ĉ":"C","Ċ":"C","Ƈ":"C","Ȼ":"C","Ď":"D","Ḑ":"D","Ḓ":"D","Ḋ":"D","Ḍ":"D","Ɗ":"D","Ḏ":"D","ǲ":"D","ǅ":"D","Đ":"D","Ƌ":"D","Ǳ":"DZ","Ǆ":"DZ","É":"E","Ĕ":"E","Ě":"E","Ȩ":"E","Ḝ":"E","Ê":"E","Ế":"E","Ệ":"E","Ề":"E","Ể":"E","Ễ":"E","Ḙ":"E","Ë":"E","Ė":"E","Ẹ":"E","Ȅ":"E","È":"E","Ẻ":"E","Ȇ":"E","Ē":"E","Ḗ":"E","Ḕ":"E","Ę":"E","Ɇ":"E","Ẽ":"E","Ḛ":"E","Ꝫ":"ET","Ḟ":"F","Ƒ":"F","Ǵ":"G","Ğ":"G","Ǧ":"G","Ģ":"G","Ĝ":"G","Ġ":"G","Ɠ":"G","Ḡ":"G","Ǥ":"G","Ḫ":"H","Ȟ":"H","Ḩ":"H","Ĥ":"H","Ⱨ":"H","Ḧ":"H","Ḣ":"H","Ḥ":"H","Ħ":"H","Í":"I","Ĭ":"I","Ǐ":"I","Î":"I","Ï":"I","Ḯ":"I","İ":"I","Ị":"I","Ȉ":"I","Ì":"I","Ỉ":"I","Ȋ":"I","Ī":"I","Į":"I","Ɨ":"I","Ĩ":"I","Ḭ":"I","Ꝺ":"D","Ꝼ":"F","Ᵹ":"G","Ꞃ":"R","Ꞅ":"S","Ꞇ":"T","Ꝭ":"IS","Ĵ":"J","Ɉ":"J","Ḱ":"K","Ǩ":"K","Ķ":"K","Ⱪ":"K","Ꝃ":"K","Ḳ":"K","Ƙ":"K","Ḵ":"K","Ꝁ":"K","Ꝅ":"K","Ĺ":"L","Ƚ":"L","Ľ":"L","Ļ":"L","Ḽ":"L","Ḷ":"L","Ḹ":"L","Ⱡ":"L","Ꝉ":"L","Ḻ":"L","Ŀ":"L","Ɫ":"L","ǈ":"L","Ł":"L","Ǉ":"LJ","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ń":"N","Ň":"N","Ņ":"N","Ṋ":"N","Ṅ":"N","Ṇ":"N","Ǹ":"N","Ɲ":"N","Ṉ":"N","Ƞ":"N","ǋ":"N","Ñ":"N","Ǌ":"NJ","Ó":"O","Ŏ":"O","Ǒ":"O","Ô":"O","Ố":"O","Ộ":"O","Ồ":"O","Ổ":"O","Ỗ":"O","Ö":"O","Ȫ":"O","Ȯ":"O","Ȱ":"O","Ọ":"O","Ő":"O","Ȍ":"O","Ò":"O","Ỏ":"O","Ơ":"O","Ớ":"O","Ợ":"O","Ờ":"O","Ở":"O","Ỡ":"O","Ȏ":"O","Ꝋ":"O","Ꝍ":"O","Ō":"O","Ṓ":"O","Ṑ":"O","Ɵ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Õ":"O","Ṍ":"O","Ṏ":"O","Ȭ":"O","Ƣ":"OI","Ꝏ":"OO","Ɛ":"E","Ɔ":"O","Ȣ":"OU","Ṕ":"P","Ṗ":"P","Ꝓ":"P","Ƥ":"P","Ꝕ":"P","Ᵽ":"P","Ꝑ":"P","Ꝙ":"Q","Ꝗ":"Q","Ŕ":"R","Ř":"R","Ŗ":"R","Ṙ":"R","Ṛ":"R","Ṝ":"R","Ȑ":"R","Ȓ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꜿ":"C","Ǝ":"E","Ś":"S","Ṥ":"S","Š":"S","Ṧ":"S","Ş":"S","Ŝ":"S","Ș":"S","Ṡ":"S","Ṣ":"S","Ṩ":"S","ẞ":"SS","Ť":"T","Ţ":"T","Ṱ":"T","Ț":"T","Ⱦ":"T","Ṫ":"T","Ṭ":"T","Ƭ":"T","Ṯ":"T","Ʈ":"T","Ŧ":"T","Ɐ":"A","Ꞁ":"L","Ɯ":"M","Ʌ":"V","Ꜩ":"TZ","Ú":"U","Ŭ":"U","Ǔ":"U","Û":"U","Ṷ":"U","Ü":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ǖ":"U","Ṳ":"U","Ụ":"U","Ű":"U","Ȕ":"U","Ù":"U","Ủ":"U","Ư":"U","Ứ":"U","Ự":"U","Ừ":"U","Ử":"U","Ữ":"U","Ȗ":"U","Ū":"U","Ṻ":"U","Ų":"U","Ů":"U","Ũ":"U","Ṹ":"U","Ṵ":"U","Ꝟ":"V","Ṿ":"V","Ʋ":"V","Ṽ":"V","Ꝡ":"VY","Ẃ":"W","Ŵ":"W","Ẅ":"W","Ẇ":"W","Ẉ":"W","Ẁ":"W","Ⱳ":"W","Ẍ":"X","Ẋ":"X","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ẏ":"Y","Ỵ":"Y","Ỳ":"Y","Ƴ":"Y","Ỷ":"Y","Ỿ":"Y","Ȳ":"Y","Ɏ":"Y","Ỹ":"Y","Ź":"Z","Ž":"Z","Ẑ":"Z","Ⱬ":"Z","Ż":"Z","Ẓ":"Z","Ȥ":"Z","Ẕ":"Z","Ƶ":"Z","Ĳ":"IJ","Œ":"OE","ᴀ":"A","ᴁ":"AE","ʙ":"B","ᴃ":"B","ᴄ":"C","ᴅ":"D","ᴇ":"E","ꜰ":"F","ɢ":"G","ʛ":"G","ʜ":"H","ɪ":"I","ʁ":"R","ᴊ":"J","ᴋ":"K","ʟ":"L","ᴌ":"L","ᴍ":"M","ɴ":"N","ᴏ":"O","ɶ":"OE","ᴐ":"O","ᴕ":"OU","ᴘ":"P","ʀ":"R","ᴎ":"N","ᴙ":"R","ꜱ":"S","ᴛ":"T","ⱻ":"E","ᴚ":"R","ᴜ":"U","ᴠ":"V","ᴡ":"W","ʏ":"Y","ᴢ":"Z","á":"a","ă":"a","ắ":"a","ặ":"a","ằ":"a","ẳ":"a","ẵ":"a","ǎ":"a","â":"a","ấ":"a","ậ":"a","ầ":"a","ẩ":"a","ẫ":"a","ä":"a","ǟ":"a","ȧ":"a","ǡ":"a","ạ":"a","ȁ":"a","à":"a","ả":"a","ȃ":"a","ā":"a","ą":"a","ᶏ":"a","ẚ":"a","å":"a","ǻ":"a","ḁ":"a","ⱥ":"a","ã":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ḃ":"b","ḅ":"b","ɓ":"b","ḇ":"b","ᵬ":"b","ᶀ":"b","ƀ":"b","ƃ":"b","ɵ":"o","ć":"c","č":"c","ç":"c","ḉ":"c","ĉ":"c","ɕ":"c","ċ":"c","ƈ":"c","ȼ":"c","ď":"d","ḑ":"d","ḓ":"d","ȡ":"d","ḋ":"d","ḍ":"d","ɗ":"d","ᶑ":"d","ḏ":"d","ᵭ":"d","ᶁ":"d","đ":"d","ɖ":"d","ƌ":"d","ı":"i","ȷ":"j","ɟ":"j","ʄ":"j","ǳ":"dz","ǆ":"dz","é":"e","ĕ":"e","ě":"e","ȩ":"e","ḝ":"e","ê":"e","ế":"e","ệ":"e","ề":"e","ể":"e","ễ":"e","ḙ":"e","ë":"e","ė":"e","ẹ":"e","ȅ":"e","è":"e","ẻ":"e","ȇ":"e","ē":"e","ḗ":"e","ḕ":"e","ⱸ":"e","ę":"e","ᶒ":"e","ɇ":"e","ẽ":"e","ḛ":"e","ꝫ":"et","ḟ":"f","ƒ":"f","ᵮ":"f","ᶂ":"f","ǵ":"g","ğ":"g","ǧ":"g","ģ":"g","ĝ":"g","ġ":"g","ɠ":"g","ḡ":"g","ᶃ":"g","ǥ":"g","ḫ":"h","ȟ":"h","ḩ":"h","ĥ":"h","ⱨ":"h","ḧ":"h","ḣ":"h","ḥ":"h","ɦ":"h","ẖ":"h","ħ":"h","ƕ":"hv","í":"i","ĭ":"i","ǐ":"i","î":"i","ï":"i","ḯ":"i","ị":"i","ȉ":"i","ì":"i","ỉ":"i","ȋ":"i","ī":"i","į":"i","ᶖ":"i","ɨ":"i","ĩ":"i","ḭ":"i","ꝺ":"d","ꝼ":"f","ᵹ":"g","ꞃ":"r","ꞅ":"s","ꞇ":"t","ꝭ":"is","ǰ":"j","ĵ":"j","ʝ":"j","ɉ":"j","ḱ":"k","ǩ":"k","ķ":"k","ⱪ":"k","ꝃ":"k","ḳ":"k","ƙ":"k","ḵ":"k","ᶄ":"k","ꝁ":"k","ꝅ":"k","ĺ":"l","ƚ":"l","ɬ":"l","ľ":"l","ļ":"l","ḽ":"l","ȴ":"l","ḷ":"l","ḹ":"l","ⱡ":"l","ꝉ":"l","ḻ":"l","ŀ":"l","ɫ":"l","ᶅ":"l","ɭ":"l","ł":"l","ǉ":"lj","ſ":"s","ẜ":"s","ẛ":"s","ẝ":"s","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ᵯ":"m","ᶆ":"m","ń":"n","ň":"n","ņ":"n","ṋ":"n","ȵ":"n","ṅ":"n","ṇ":"n","ǹ":"n","ɲ":"n","ṉ":"n","ƞ":"n","ᵰ":"n","ᶇ":"n","ɳ":"n","ñ":"n","ǌ":"nj","ó":"o","ŏ":"o","ǒ":"o","ô":"o","ố":"o","ộ":"o","ồ":"o","ổ":"o","ỗ":"o","ö":"o","ȫ":"o","ȯ":"o","ȱ":"o","ọ":"o","ő":"o","ȍ":"o","ò":"o","ỏ":"o","ơ":"o","ớ":"o","ợ":"o","ờ":"o","ở":"o","ỡ":"o","ȏ":"o","ꝋ":"o","ꝍ":"o","ⱺ":"o","ō":"o","ṓ":"o","ṑ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","õ":"o","ṍ":"o","ṏ":"o","ȭ":"o","ƣ":"oi","ꝏ":"oo","ɛ":"e","ᶓ":"e","ɔ":"o","ᶗ":"o","ȣ":"ou","ṕ":"p","ṗ":"p","ꝓ":"p","ƥ":"p","ᵱ":"p","ᶈ":"p","ꝕ":"p","ᵽ":"p","ꝑ":"p","ꝙ":"q","ʠ":"q","ɋ":"q","ꝗ":"q","ŕ":"r","ř":"r","ŗ":"r","ṙ":"r","ṛ":"r","ṝ":"r","ȑ":"r","ɾ":"r","ᵳ":"r","ȓ":"r","ṟ":"r","ɼ":"r","ᵲ":"r","ᶉ":"r","ɍ":"r","ɽ":"r","ↄ":"c","ꜿ":"c","ɘ":"e","ɿ":"r","ś":"s","ṥ":"s","š":"s","ṧ":"s","ş":"s","ŝ":"s","ș":"s","ṡ":"s","ṣ":"s","ṩ":"s","ʂ":"s","ᵴ":"s","ᶊ":"s","ȿ":"s","ɡ":"g","ß":"ss","ᴑ":"o","ᴓ":"o","ᴝ":"u","ť":"t","ţ":"t","ṱ":"t","ț":"t","ȶ":"t","ẗ":"t","ⱦ":"t","ṫ":"t","ṭ":"t","ƭ":"t","ṯ":"t","ᵵ":"t","ƫ":"t","ʈ":"t","ŧ":"t","ᵺ":"th","ɐ":"a","ᴂ":"ae","ǝ":"e","ᵷ":"g","ɥ":"h","ʮ":"h","ʯ":"h","ᴉ":"i","ʞ":"k","ꞁ":"l","ɯ":"m","ɰ":"m","ᴔ":"oe","ɹ":"r","ɻ":"r","ɺ":"r","ⱹ":"r","ʇ":"t","ʌ":"v","ʍ":"w","ʎ":"y","ꜩ":"tz","ú":"u","ŭ":"u","ǔ":"u","û":"u","ṷ":"u","ü":"u","ǘ":"u","ǚ":"u","ǜ":"u","ǖ":"u","ṳ":"u","ụ":"u","ű":"u","ȕ":"u","ù":"u","ủ":"u","ư":"u","ứ":"u","ự":"u","ừ":"u","ử":"u","ữ":"u","ȗ":"u","ū":"u","ṻ":"u","ų":"u","ᶙ":"u","ů":"u","ũ":"u","ṹ":"u","ṵ":"u","ᵫ":"ue","ꝸ":"um","ⱴ":"v","ꝟ":"v","ṿ":"v","ʋ":"v","ᶌ":"v","ⱱ":"v","ṽ":"v","ꝡ":"vy","ẃ":"w","ŵ":"w","ẅ":"w","ẇ":"w","ẉ":"w","ẁ":"w","ⱳ":"w","ẘ":"w","ẍ":"x","ẋ":"x","ᶍ":"x","ý":"y","ŷ":"y","ÿ":"y","ẏ":"y","ỵ":"y","ỳ":"y","ƴ":"y","ỷ":"y","ỿ":"y","ȳ":"y","ẙ":"y","ɏ":"y","ỹ":"y","ź":"z","ž":"z","ẑ":"z","ʑ":"z","ⱬ":"z","ż":"z","ẓ":"z","ȥ":"z","ẕ":"z","ᵶ":"z","ᶎ":"z","ʐ":"z","ƶ":"z","ɀ":"z","ﬀ":"ff","ﬃ":"ffi","ﬄ":"ffl","ﬁ":"fi","ﬂ":"fl","ĳ":"ij","œ":"oe","ﬆ":"st","ₐ":"a","ₑ":"e","ᵢ":"i","ⱼ":"j","ₒ":"o","ᵣ":"r","ᵤ":"u","ᵥ":"v","ₓ":"x"}
};

String.prototype.latinise = function() {
  return this.replace(/[^A-Za-z0-9]/g, function(x) { return Latinise.map[x] || x; });
};

}.call(window));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.4",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};

}));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var widget_uuid = 0,
	widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; (elem = elems[i]) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
})( $.cleanData );

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widget_slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = widget_slice.call( arguments, 1 ),
			returnValue = this;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( options === "instance" ) {
					returnValue = instance;
					return false;
				}
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat(args) );
			}

			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widget_uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled", !!value );

			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
		}

		return this;
	},

	enable: function() {
		return this._setOptions({ disabled: false });
	},
	disable: function() {
		return this._setOptions({ disabled: true });
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

return $.widget;

}));


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    /*
    *   SubbableResource can be extended to provide a pubsub-style service for one-off REST
    *   calls. Subscribe by passing a callback or render method you will use to handle responses.
     *
    * */

    var SubbableResource = function () {
      function SubbableResource(resourcePath) {
        _classCallCheck(this, SubbableResource);

        this.endpoint = resourcePath;

        // TODO: Switch to axios.create
        this.resource = $.ajax;
        this.subscribers = [];
      }

      _createClass(SubbableResource, [{
        key: "subscribe",
        value: function subscribe(callback) {
          this.subscribers.push(callback);
        }
      }, {
        key: "publish",
        value: function publish(newResponse) {
          var responseCopy = _.extend({}, newResponse);
          this.subscribers.forEach(function (fn) {
            fn(responseCopy);
          });
          return newResponse;
        }
      }, {
        key: "get",
        value: function get(payload) {
          var _this = this;

          return this.resource(payload).then(function (data) {
            return _this.publish(data);
          });
        }
      }, {
        key: "post",
        value: function post(payload) {
          var _this2 = this;

          return this.resource(payload).then(function (data) {
            return _this2.publish(data);
          });
        }
      }, {
        key: "put",
        value: function put(payload) {
          var _this3 = this;

          return this.resource(payload).then(function (data) {
            return _this3.publish(data);
          });
        }
      }, {
        key: "delete",
        value: function _delete(payload) {
          var _this4 = this;

          return this.resource(payload).then(function (data) {
            return _this4.publish(data);
          });
        }
      }]);

      return SubbableResource;
    }();

    gl.SubbableResource = SubbableResource;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-param-reassign, quotes, prefer-template, no-var, one-var, no-unused-vars, one-var-declaration-per-line, no-void, consistent-return, no-empty, max-len */
  (function () {
    this.Autosave = function () {
      function Autosave(field, key) {
        this.field = field;
        if (key.join != null) {
          key = key.join("/");
        }
        this.key = "autosave/" + key;
        this.field.data("autosave", this);
        this.restore();
        this.field.on("input", function (_this) {
          return function () {
            return _this.save();
          };
        }(this));
      }

      Autosave.prototype.restore = function () {
        var e, text;
        if (window.localStorage == null) {
          return;
        }
        try {
          text = window.localStorage.getItem(this.key);
        } catch (error) {
          e = error;
          return;
        }
        if ((text != null ? text.length : void 0) > 0) {
          this.field.val(text);
        }
        return this.field.trigger("input");
      };

      Autosave.prototype.save = function () {
        var text;
        if (window.localStorage == null) {
          return;
        }
        text = this.field.val();
        if ((text != null ? text.length : void 0) > 0) {
          try {
            return window.localStorage.setItem(this.key, text);
          } catch (error) {}
        } else {
          return this.reset();
        }
      };

      Autosave.prototype.reset = function () {
        if (window.localStorage == null) {
          return;
        }
        try {
          return window.localStorage.removeItem(this.key);
        } catch (error) {}
      };

      return Autosave;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(359)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * jQuery.scrollTo
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * @projectDescription Lightweight, cross-browser and highly customizable animated scrolling with jQuery
 * @author Ariel Flesler
 * @version 2.1.2
 */
;(function(factory) {
	'use strict';
	if (true) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		// CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Global
		factory(jQuery);
	}
})(function($) {
	'use strict';

	var $scrollTo = $.scrollTo = function(target, duration, settings) {
		return $(window).scrollTo(target, duration, settings);
	};

	$scrollTo.defaults = {
		axis:'xy',
		duration: 0,
		limit:true
	};

	function isWin(elem) {
		return !elem.nodeName ||
			$.inArray(elem.nodeName.toLowerCase(), ['iframe','#document','html','body']) !== -1;
	}		

	$.fn.scrollTo = function(target, duration, settings) {
		if (typeof duration === 'object') {
			settings = duration;
			duration = 0;
		}
		if (typeof settings === 'function') {
			settings = { onAfter:settings };
		}
		if (target === 'max') {
			target = 9e9;
		}

		settings = $.extend({}, $scrollTo.defaults, settings);
		// Speed is still recognized for backwards compatibility
		duration = duration || settings.duration;
		// Make sure the settings are given right
		var queue = settings.queue && settings.axis.length > 1;
		if (queue) {
			// Let's keep the overall duration
			duration /= 2;
		}
		settings.offset = both(settings.offset);
		settings.over = both(settings.over);

		return this.each(function() {
			// Null target yields nothing, just like jQuery does
			if (target === null) return;

			var win = isWin(this),
				elem = win ? this.contentWindow || window : this,
				$elem = $(elem),
				targ = target, 
				attr = {},
				toff;

			switch (typeof targ) {
				// A number will pass the regex
				case 'number':
				case 'string':
					if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
						targ = both(targ);
						// We are done
						break;
					}
					// Relative/Absolute selector
					targ = win ? $(targ) : $(targ, elem);
					/* falls through */
				case 'object':
					if (targ.length === 0) return;
					// DOMElement / jQuery
					if (targ.is || targ.style) {
						// Get the real position of the target
						toff = (targ = $(targ)).offset();
					}
			}

			var offset = $.isFunction(settings.offset) && settings.offset(elem, targ) || settings.offset;

			$.each(settings.axis.split(''), function(i, axis) {
				var Pos	= axis === 'x' ? 'Left' : 'Top',
					pos = Pos.toLowerCase(),
					key = 'scroll' + Pos,
					prev = $elem[key](),
					max = $scrollTo.max(elem, axis);

				if (toff) {// jQuery / DOMElement
					attr[key] = toff[pos] + (win ? 0 : prev - $elem.offset()[pos]);

					// If it's a dom element, reduce the margin
					if (settings.margin) {
						attr[key] -= parseInt(targ.css('margin'+Pos), 10) || 0;
						attr[key] -= parseInt(targ.css('border'+Pos+'Width'), 10) || 0;
					}

					attr[key] += offset[pos] || 0;

					if (settings.over[pos]) {
						// Scroll to a fraction of its width/height
						attr[key] += targ[axis === 'x'?'width':'height']() * settings.over[pos];
					}
				} else {
					var val = targ[pos];
					// Handle percentage values
					attr[key] = val.slice && val.slice(-1) === '%' ?
						parseFloat(val) / 100 * max
						: val;
				}

				// Number or 'number'
				if (settings.limit && /^\d+$/.test(attr[key])) {
					// Check the limits
					attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
				}

				// Don't waste time animating, if there's no need.
				if (!i && settings.axis.length > 1) {
					if (prev === attr[key]) {
						// No animation needed
						attr = {};
					} else if (queue) {
						// Intermediate animation
						animate(settings.onAfterFirst);
						// Don't animate this axis again in the next iteration.
						attr = {};
					}
				}
			});

			animate(settings.onAfter);

			function animate(callback) {
				var opts = $.extend({}, settings, {
					// The queue setting conflicts with animate()
					// Force it to always be true
					queue: true,
					duration: duration,
					complete: callback && function() {
						callback.call(elem, targ, settings);
					}
				});
				$elem.animate(attr, opts);
			}
		});
	};

	// Max scrolling position, works on quirks mode
	// It only fails (not too badly) on IE, quirks mode.
	$scrollTo.max = function(elem, axis) {
		var Dim = axis === 'x' ? 'Width' : 'Height',
			scroll = 'scroll'+Dim;

		if (!isWin(elem))
			return elem[scroll] - $(elem)[Dim.toLowerCase()]();

		var size = 'client' + Dim,
			doc = elem.ownerDocument || elem.document,
			html = doc.documentElement,
			body = doc.body;

		return Math.max(html[scroll], body[scroll]) - Math.min(html[size], body[size]);
	};

	function both(val) {
		return $.isFunction(val) || $.isPlainObject(val) ? val : { top:val, left:val };
	}

	// Add special hooks so that window scroll properties can be animated
	$.Tween.propHooks.scrollLeft = 
	$.Tween.propHooks.scrollTop = {
		get: function(t) {
			return $(t.elem)[t.prop]();
		},
		set: function(t) {
			var curr = this.get(t);
			// If interrupt is true and user scrolled, stop animating
			if (t.options.interrupt && t._last && t._last !== curr) {
				return $(t.elem).stop();
			}
			var next = Math.round(t.now);
			// Don't waste CPU
			// Browsers don't render floating point scroll
			if (curr !== next) {
				$(t.elem)[t.prop](next);
				t._last = this.get(t);
			}
		}
	};

	// AMD requirement
	return $scrollTo;
});

}.call(window));

/***/ }),
/* 28 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/*
 * waitForImages 1.4
 * -----------------
 * Provides a callback when all images have loaded in your given selector.
 * http://www.alexanderdickson.com/
 *
 *
 * Copyright (c) 2011 Alex Dickson
 * Licensed under the MIT licenses.
 * See website for more info.
 *
 */

;(function($) {
    // Namespace all events.
    var eventNamespace = 'waitForImages';

    // CSS properties which contain references to images. 
    $.waitForImages = {
        hasImageProperties: [
        'backgroundImage',
        'listStyleImage',
        'borderImage',
        'borderCornerImage'
        ]
    };
    
    // Custom selector to find `img` elements that have a valid `src` attribute and have not already loaded.
    $.expr[':'].uncached = function(obj) {
        // Ensure we are dealing with an `img` element with a valid `src` attribute.
        if ( ! $(obj).is('img[src!=""]')) {
            return false;
        }

        // Firefox's `complete` property will always be`true` even if the image has not been downloaded.
        // Doing it this way works in Firefox.
        var img = document.createElement('img');
        img.src = obj.src;
        return ! img.complete;
    };

    $.fn.waitForImages = function(finishedCallback, eachCallback, waitForAll) {

        // Handle options object.
        if ($.isPlainObject(arguments[0])) {
            eachCallback = finishedCallback.each;
            waitForAll = finishedCallback.waitForAll;
            finishedCallback = finishedCallback.finished;
        }

        // Handle missing callbacks.
        finishedCallback = finishedCallback || $.noop;
        eachCallback = eachCallback || $.noop;

        // Convert waitForAll to Boolean
        waitForAll = !! waitForAll;

        // Ensure callbacks are functions.
        if (!$.isFunction(finishedCallback) || !$.isFunction(eachCallback)) {
            throw new TypeError('An invalid callback was supplied.');
        };

        return this.each(function() {
            // Build a list of all imgs, dependent on what images will be considered.
            var obj = $(this),
                allImgs = [];

            if (waitForAll) {
                // CSS properties which may contain an image.
                var hasImgProperties = $.waitForImages.hasImageProperties || [],
                    matchUrl = /url\((['"]?)(.*?)\1\)/g;
                
                // Get all elements, as any one of them could have a background image.
                obj.find('*').each(function() {
                    var element = $(this);

                    // If an `img` element, add it. But keep iterating in case it has a background image too.
                    if (element.is('img:uncached')) {
                        allImgs.push({
                            src: element.attr('src'),
                            element: element[0]
                        });
                    }

                    $.each(hasImgProperties, function(i, property) {
                        var propertyValue = element.css(property);
                        // If it doesn't contain this property, skip.
                        if ( ! propertyValue) {
                            return true;
                        }

                        // Get all url() of this element.
                        var match;
                        while (match = matchUrl.exec(propertyValue)) {
                            allImgs.push({
                                src: match[2],
                                element: element[0]
                            });
                        };
                    });
                });
            } else {
                // For images only, the task is simpler.
                obj
                 .find('img:uncached')
                 .each(function() {
                    allImgs.push({
                        src: this.src,
                        element: this
                    });
                });
            };

            var allImgsLength = allImgs.length,
                allImgsLoaded = 0;

            // If no images found, don't bother.
            if (allImgsLength == 0) {
                finishedCallback.call(obj[0]);
            };

            $.each(allImgs, function(i, img) {
                
                var image = new Image;
                
                // Handle the image loading and error with the same callback.
                $(image).bind('load.' + eventNamespace + ' error.' + eventNamespace, function(event) {
                    allImgsLoaded++;
                    
                    // If an error occurred with loading the image, set the third argument accordingly.
                    eachCallback.call(img.element, allImgsLoaded, allImgsLength, event.type == 'load');
                    
                    if (allImgsLoaded == allImgsLength) {
                        finishedCallback.call(obj[0]);
                        return false;
                    };
                    
                });

                image.src = img.src;
            });
        });
    };
})(jQuery);

}.call(window));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2013 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.4.6
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
            8: 'backspace',
            9: 'tab',
            13: 'enter',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'ins',
            46: 'del',
            91: 'meta',
            93: 'meta',
            224: 'meta'
        },

        /**
         * mapping for special characters so they can support
         *
         * this dictionary is only used incase you want to bind a
         * keyup or keydown event to one of these keys
         *
         * @type {Object}
         */
        _KEYCODE_MAP = {
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111 : '/',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: '\''
        },

        /**
         * this is a mapping of keys that require shift on a US keypad
         * back to the non shift equivelents
         *
         * this is so you can use keyup events with these keys
         *
         * note that this will only work reliably on US keyboards
         *
         * @type {Object}
         */
        _SHIFT_MAP = {
            '~': '`',
            '!': '1',
            '@': '2',
            '#': '3',
            '$': '4',
            '%': '5',
            '^': '6',
            '&': '7',
            '*': '8',
            '(': '9',
            ')': '0',
            '_': '-',
            '+': '=',
            ':': ';',
            '\"': '\'',
            '<': ',',
            '>': '.',
            '?': '/',
            '|': '\\'
        },

        /**
         * this is a list of special strings you can use to map
         * to modifier keys when you specify your keyboard shortcuts
         *
         * @type {Object}
         */
        _SPECIAL_ALIASES = {
            'option': 'alt',
            'command': 'meta',
            'return': 'enter',
            'escape': 'esc',
            'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
        },

        /**
         * variable to store the flipped version of _MAP from above
         * needed to check if we should use keypress or not when no action
         * is specified
         *
         * @type {Object|undefined}
         */
        _REVERSE_MAP,

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        _callbacks = {},

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        _directMap = {},

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        _sequenceLevels = {},

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        _resetTimer,

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        _ignoreNextKeyup = false,

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        _ignoreNextKeypress = false,

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        _nextExpectedAction = false;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {
        _MAP[i + 96] = i;
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */
    function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};

        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
            if (doNotReset[key]) {
                activeSequences = true;
                continue;
            }
            _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
            _nextExpectedAction = false;
        }
    }

    /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */
    function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i,
            callback,
            matches = [],
            action = e.type;

        // if there are no events related to this keycode
        if (!_callbacks[character]) {
            return [];
        }

        // if a modifier key is coming up on its own we should allow it
        if (action == 'keyup' && _isModifier(character)) {
            modifiers = [character];
        }

        // loop through all callbacks for the key that was pressed
        // and see if any of them match
        for (i = 0; i < _callbacks[character].length; ++i) {
            callback = _callbacks[character][i];

            // if a sequence name is not specified, but this is a sequence at
            // the wrong level then move onto the next match
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                continue;
            }

            // if the action we are looking for doesn't match the action we got
            // then we should keep going
            if (action != callback.action) {
                continue;
            }

            // if this is a keypress event and the meta key and control key
            // are not pressed that means that we need to only look at the
            // character, otherwise check the modifiers as well
            //
            // chrome will not fire a keypress if meta or control is down
            // safari will fire a keypress if meta or meta+shift is down
            // firefox will fire a keypress if meta or control is down
            if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                // when you bind a combination or sequence a second time it
                // should overwrite the first one.  if a sequenceName or
                // combination is specified in this call it does just that
                //
                // @todo make deleting its own method?
                var deleteCombo = !sequenceName && callback.combo == combination;
                var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                if (deleteCombo || deleteSequence) {
                    _callbacks[character].splice(i, 1);
                }

                matches.push(callback);
            }
        }

        return matches;
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */
    function _fireCallback(callback, e, combo, sequence) {

        // if this event should not happen stop here
        if (Mousetrap.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
        }

        if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
        }
    }

    /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */
    function _handleKey(character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e),
            i,
            doNotReset = {},
            maxLevel = 0,
            processedSequenceCallback = false;

        // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
        for (i = 0; i < callbacks.length; ++i) {
            if (callbacks[i].seq) {
                maxLevel = Math.max(maxLevel, callbacks[i].level);
            }
        }

        // loop through matching callbacks for this key event
        for (i = 0; i < callbacks.length; ++i) {

            // fire for all sequence callbacks
            // this is because if for example you have multiple sequences
            // bound such as "g i" and "g t" they both need to fire the
            // callback for matching g cause otherwise you can only ever
            // match the first one
            if (callbacks[i].seq) {

                // only fire callbacks for the maxLevel to prevent
                // subsequences from also firing
                //
                // for example 'a option b' should not cause 'option b' to fire
                // even though 'option b' is part of the other sequence
                //
                // any sequences that do not match here will be discarded
                // below by the _resetSequences call
                if (callbacks[i].level != maxLevel) {
                    continue;
                }

                processedSequenceCallback = true;

                // keep a list of which sequences were matches for later
                doNotReset[callbacks[i].seq] = 1;
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                continue;
            }

            // if there were no sequence matches but we are still here
            // that means this is a regular match so we should fire that
            if (!processedSequenceCallback) {
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
        }

        // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character
        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
    }

    /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */
    function _handleKeyEvent(e) {

        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
            e.which = e.keyCode;
        }

        var character = _characterFromEvent(e);

        // no character found then stop
        if (!character) {
            return;
        }

        // need to use === for the character check because the character can be 0
        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
        }

        Mousetrap.handleKey(character, _eventModifiers(e), e);
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */
    function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */
    function _bindSequence(combo, keys, callback, action) {

        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;

        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */
        function _increaseSequence(nextAction) {
            return function() {
                _nextExpectedAction = nextAction;
                ++_sequenceLevels[combo];
                _resetSequenceTimer();
            };
        }

        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */
        function _callbackAndReset(e) {
            _fireCallback(callback, e, combo);

            // we should ignore the next key up if the action is key down
            // or keypress.  this is so if you finish a sequence and
            // release the key the final key will not trigger a keyup
            if (action !== 'keyup') {
                _ignoreNextKeyup = _characterFromEvent(e);
            }

            // weird race condition if a sequence ends with the key
            // another sequence begins with
            setTimeout(_resetSequences, 10);
        }

        // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided
        for (var i = 0; i < keys.length; ++i) {
            var isFinal = i + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
            _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys,
            key,
            i,
            modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */
    function _bindSingle(combination, callback, action, sequenceName, level) {

        // store a direct mapped reference for use with Mousetrap.trigger
        _directMap[combination + ':' + action] = callback;

        // make sure multiple spaces in a row become a single space
        combination = combination.replace(/\s+/g, ' ');

        var sequence = combination.split(' '),
            info;

        // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time
        if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
        }

        info = _getKeyInfo(combination, action);

        // make sure to initialize array if this is the first time
        // a callback is added for this key
        _callbacks[info.key] = _callbacks[info.key] || [];

        // remove an existing match if there is one
        _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

        // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first
        _callbacks[info.key][sequenceName ? 'unshift' : 'push']({
            callback: callback,
            modifiers: info.modifiers,
            action: info.action,
            seq: sequenceName,
            level: level,
            combo: combination
        });
    }

    /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */
    function _bindMultiple(combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
            _bindSingle(combinations[i], callback, action);
        }
    }

    // start!
    _addEvent(document, 'keypress', _handleKeyEvent);
    _addEvent(document, 'keydown', _handleKeyEvent);
    _addEvent(document, 'keyup', _handleKeyEvent);

    var Mousetrap = {

        /**
         * binds an event to mousetrap
         *
         * can be a single key, a combination of keys separated with +,
         * an array of keys, or a sequence of keys separated by spaces
         *
         * be sure to list the modifier keys first to make sure that the
         * correct key ends up getting bound (the last key in the pattern)
         *
         * @param {string|Array} keys
         * @param {Function} callback
         * @param {string=} action - 'keypress', 'keydown', or 'keyup'
         * @returns void
         */
        bind: function(keys, callback, action) {
            keys = keys instanceof Array ? keys : [keys];
            _bindMultiple(keys, callback, action);
            return this;
        },

        /**
         * unbinds an event to mousetrap
         *
         * the unbinding sets the callback function of the specified key combo
         * to an empty function and deletes the corresponding key in the
         * _directMap dict.
         *
         * TODO: actually remove this from the _callbacks dictionary instead
         * of binding an empty function
         *
         * the keycombo+action has to be exactly the same as
         * it was defined in the bind method
         *
         * @param {string|Array} keys
         * @param {string} action
         * @returns void
         */
        unbind: function(keys, action) {
            return Mousetrap.bind(keys, function() {}, action);
        },

        /**
         * triggers an event that has already been bound
         *
         * @param {string} keys
         * @param {string=} action
         * @returns void
         */
        trigger: function(keys, action) {
            if (_directMap[keys + ':' + action]) {
                _directMap[keys + ':' + action]({}, keys);
            }
            return this;
        },

        /**
         * resets the library back to its initial state.  this is useful
         * if you want to clear out the current keyboard shortcuts and bind
         * new ones - for example if you switch to another page
         *
         * @returns void
         */
        reset: function() {
            _callbacks = {};
            _directMap = {};
            return this;
        },

       /**
        * should we stop this event before firing off callbacks
        *
        * @param {Event} e
        * @param {Element} element
        * @return {boolean}
        */
        stopCallback: function(e, element) {

            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }

            // stop for input, select, and textarea
            return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
        },

        /**
         * exposes _handleKey publicly so it can be overwritten by extensions
         */
        handleKey: _handleKey
    };

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Mousetrap),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (window, document);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, quotes, no-shadow, prefer-arrow-callback, prefer-template, consistent-return, no-return-assign, new-parens, no-param-reassign, max-len */

  (function () {
    var Breakpoints = function () {
      var BreakpointInstance, instance;

      function Breakpoints() {}

      instance = null;

      BreakpointInstance = function () {
        var BREAKPOINTS;

        BREAKPOINTS = ["xs", "sm", "md", "lg"];

        function BreakpointInstance() {
          this.setup();
        }

        BreakpointInstance.prototype.setup = function () {
          var allDeviceSelector, els;
          allDeviceSelector = BREAKPOINTS.map(function (breakpoint) {
            return ".device-" + breakpoint;
          });
          if ($(allDeviceSelector.join(",")).length) {
            return;
          }
          // Create all the elements
          els = $.map(BREAKPOINTS, function (breakpoint) {
            return "<div class='device-" + breakpoint + " visible-" + breakpoint + "'></div>";
          });
          return $("body").append(els.join(''));
        };

        BreakpointInstance.prototype.visibleDevice = function () {
          var allDeviceSelector;
          allDeviceSelector = BREAKPOINTS.map(function (breakpoint) {
            return ".device-" + breakpoint;
          });
          return $(allDeviceSelector.join(",")).filter(":visible");
        };

        BreakpointInstance.prototype.getBreakpointSize = function () {
          var $visibleDevice;
          $visibleDevice = this.visibleDevice;
          // TODO: Consider refactoring in light of turbolinks removal.
          // the page refreshed via turbolinks
          if (!$visibleDevice().length) {
            this.setup();
          }
          $visibleDevice = this.visibleDevice();
          return $visibleDevice.attr("class").split("visible-")[1];
        };

        return BreakpointInstance;
      }();

      Breakpoints.get = function () {
        return instance != null ? instance : instance = new BreakpointInstance();
      };

      return Breakpoints;
    }();

    $(function (_this) {
      return function () {
        return _this.bp = Breakpoints.get();
      };
    }(this));

    window.Breakpoints = Breakpoints;
  }).call(this);
}).call(window);

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, object-shorthand, comma-dangle, max-len */
  // Disable an element and add the 'disabled' Bootstrap class
  (function () {
    $.fn.extend({
      disable: function disable() {
        return $(this).attr('disabled', 'disabled').addClass('disabled');
      }
    });

    // Enable an element and remove the 'disabled' Bootstrap class
    $.fn.extend({
      enable: function enable() {
        return $(this).removeAttr('disabled').removeClass('disabled');
      }
    });
  }).call(this);
}).call(window);

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-param-reassign, quotes, quote-props, prefer-template, comma-dangle, max-len */
  (function () {
    this.Flash = function () {
      var hideFlash;

      hideFlash = function hideFlash() {
        return $(this).fadeOut();
      };

      function Flash(message, type, parent) {
        var flash, textDiv;
        if (type == null) {
          type = 'alert';
        }
        if (parent == null) {
          parent = null;
        }
        if (parent) {
          this.flashContainer = parent.find('.flash-container');
        } else {
          this.flashContainer = $('.flash-container-page');
        }
        this.flashContainer.html('');
        flash = $('<div/>', {
          "class": "flash-" + type
        });
        flash.on('click', hideFlash);
        textDiv = $('<div/>', {
          "class": 'flash-text',
          text: message
        });
        textDiv.appendTo(flash);
        if (this.flashContainer.parent().hasClass('content-wrapper')) {
          textDiv.addClass('container-fluid container-limited');
        }
        flash.appendTo(this.flashContainer);
        this.flashContainer.show();
      }

      return Flash;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 35 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-template-curly-in-string, comma-dangle, object-shorthand, quotes, dot-notation, no-else-return, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-param-reassign, no-useless-escape, prefer-template, consistent-return, wrap-iife, prefer-arrow-callback, camelcase, no-unused-vars, no-useless-return, vars-on-top, max-len */

  // Creates the variables for setting up GFM auto-completion
  (function () {
    if (window.gl == null) {
      window.gl = {};
    }

    function sanitize(str) {
      return str.replace(/<(?:.|\n)*?>/gm, '');
    }

    window.gl.GfmAutoComplete = {
      dataSources: {},
      defaultLoadingData: ['loading'],
      cachedData: {},
      isLoadingData: {},
      atTypeMap: {
        ':': 'emojis',
        '@': 'members',
        '#': 'issues',
        '!': 'mergeRequests',
        '~': 'labels',
        '%': 'milestones',
        '/': 'commands'
      },
      // Emoji
      Emoji: {
        template: '<li>${name} <img alt="${name}" height="20" src="${path}" width="20" /></li>'
      },
      // Team Members
      Members: {
        template: '<li>${avatarTag} ${username} <small>${title}</small></li>'
      },
      Labels: {
        template: '<li><span class="dropdown-label-box" style="background: ${color}"></span> ${title}</li>'
      },
      // Issues and MergeRequests
      Issues: {
        template: '<li><small>${id}</small> ${title}</li>'
      },
      // Milestones
      Milestones: {
        template: '<li>${title}</li>'
      },
      Loading: {
        template: '<li style="pointer-events: none;"><i class="fa fa-refresh fa-spin"></i> Loading...</li>'
      },
      DefaultOptions: {
        sorter: function sorter(query, items, searchKey) {
          this.setting.highlightFirst = this.setting.alwaysHighlightFirst || query.length > 0;
          if (gl.GfmAutoComplete.isLoading(items)) {
            this.setting.highlightFirst = false;
            return items;
          }
          return $.fn.atwho["default"].callbacks.sorter(query, items, searchKey);
        },
        filter: function filter(query, data, searchKey) {
          if (gl.GfmAutoComplete.isLoading(data)) {
            gl.GfmAutoComplete.fetchData(this.$inputor, this.at);
            return data;
          } else {
            return $.fn.atwho["default"].callbacks.filter(query, data, searchKey);
          }
        },
        beforeInsert: function beforeInsert(value) {
          if (value && !this.setting.skipSpecialCharacterTest) {
            var withoutAt = value.substring(1);
            if (withoutAt && /[^\w\d]/.test(withoutAt)) value = value.charAt() + '"' + withoutAt + '"';
          }
          return value;
        },
        matcher: function matcher(flag, subtext) {
          // The below is taken from At.js source
          // Tweaked to commands to start without a space only if char before is a non-word character
          // https://github.com/ichord/At.js
          var _a, _y, regexp, match, atSymbolsWithBar, atSymbolsWithoutBar;
          atSymbolsWithBar = Object.keys(this.app.controllers).join('|');
          atSymbolsWithoutBar = Object.keys(this.app.controllers).join('');
          subtext = subtext.split(/\s+/g).pop();
          flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

          _a = decodeURI("%C3%80");
          _y = decodeURI("%C3%BF");

          regexp = new RegExp("^(?:\\B|[^a-zA-Z0-9_" + atSymbolsWithoutBar + "]|\\s)" + flag + "(?![" + atSymbolsWithBar + "])(([A-Za-z" + _a + "-" + _y + "0-9_\'\.\+\-]|[^\\x00-\\x7a])*)$", 'gi');

          match = regexp.exec(subtext);

          if (match) {
            return match[1] || match[1] === "" ? match[1] : match[2];
          } else {
            return null;
          }
        }
      },
      setup: function setup(input) {
        // Add GFM auto-completion to all input fields, that accept GFM input.
        this.input = input || $('.js-gfm-input');
        this.setupLifecycle();
      },
      setupLifecycle: function setupLifecycle() {
        var _this = this;

        this.input.each(function (i, input) {
          var $input = $(input);
          $input.off('focus.setupAtWho').on('focus.setupAtWho', _this.setupAtWho.bind(_this, $input));
          // This triggers at.js again
          // Needed for slash commands with suffixes (ex: /label ~)
          $input.on('inserted-commands.atwho', $input.trigger.bind($input, 'keyup'));
        });
      },

      setupAtWho: function setupAtWho($input) {
        // Emoji
        $input.atwho({
          at: ':',
          displayTpl: function (value) {
            return value.path != null ? this.Emoji.template : this.Loading.template;
          }.bind(this),
          insertTpl: ':${name}:',
          skipSpecialCharacterTest: true,
          data: this.defaultLoadingData,
          callbacks: {
            sorter: this.DefaultOptions.sorter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            filter: this.DefaultOptions.filter
          }
        });
        // Team Members
        $input.atwho({
          at: '@',
          displayTpl: function (value) {
            return value.username != null ? this.Members.template : this.Loading.template;
          }.bind(this),
          insertTpl: '${atwho-at}${username}',
          searchKey: 'search',
          alwaysHighlightFirst: true,
          skipSpecialCharacterTest: true,
          data: this.defaultLoadingData,
          callbacks: {
            sorter: this.DefaultOptions.sorter,
            filter: this.DefaultOptions.filter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            matcher: this.DefaultOptions.matcher,
            beforeSave: function beforeSave(members) {
              return $.map(members, function (m) {
                var title = '';
                if (m.username == null) {
                  return m;
                }
                title = m.name;
                if (m.count) {
                  title += " (" + m.count + ")";
                }

                var autoCompleteAvatar = m.avatar_url || m.username.charAt(0).toUpperCase();
                var imgAvatar = '<img src="' + m.avatar_url + '" alt="' + m.username + '" class="avatar avatar-inline center s26"/>';
                var txtAvatar = '<div class="avatar center avatar-inline s26">' + autoCompleteAvatar + '</div>';

                return {
                  username: m.username,
                  avatarTag: autoCompleteAvatar.length === 1 ? txtAvatar : imgAvatar,
                  title: sanitize(title),
                  search: sanitize(m.username + " " + m.name)
                };
              });
            }
          }
        });
        $input.atwho({
          at: '#',
          alias: 'issues',
          searchKey: 'search',
          displayTpl: function (value) {
            return value.title != null ? this.Issues.template : this.Loading.template;
          }.bind(this),
          data: this.defaultLoadingData,
          insertTpl: '${atwho-at}${id}',
          callbacks: {
            sorter: this.DefaultOptions.sorter,
            filter: this.DefaultOptions.filter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            matcher: this.DefaultOptions.matcher,
            beforeSave: function beforeSave(issues) {
              return $.map(issues, function (i) {
                if (i.title == null) {
                  return i;
                }
                return {
                  id: i.iid,
                  title: sanitize(i.title),
                  search: i.iid + " " + i.title
                };
              });
            }
          }
        });
        $input.atwho({
          at: '%',
          alias: 'milestones',
          searchKey: 'search',
          insertTpl: '${atwho-at}${title}',
          displayTpl: function (value) {
            return value.title != null ? this.Milestones.template : this.Loading.template;
          }.bind(this),
          data: this.defaultLoadingData,
          callbacks: {
            matcher: this.DefaultOptions.matcher,
            sorter: this.DefaultOptions.sorter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            filter: this.DefaultOptions.filter,
            beforeSave: function beforeSave(milestones) {
              return $.map(milestones, function (m) {
                if (m.title == null) {
                  return m;
                }
                return {
                  id: m.iid,
                  title: sanitize(m.title),
                  search: "" + m.title
                };
              });
            }
          }
        });
        $input.atwho({
          at: '!',
          alias: 'mergerequests',
          searchKey: 'search',
          displayTpl: function (value) {
            return value.title != null ? this.Issues.template : this.Loading.template;
          }.bind(this),
          data: this.defaultLoadingData,
          insertTpl: '${atwho-at}${id}',
          callbacks: {
            sorter: this.DefaultOptions.sorter,
            filter: this.DefaultOptions.filter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            matcher: this.DefaultOptions.matcher,
            beforeSave: function beforeSave(merges) {
              return $.map(merges, function (m) {
                if (m.title == null) {
                  return m;
                }
                return {
                  id: m.iid,
                  title: sanitize(m.title),
                  search: m.iid + " " + m.title
                };
              });
            }
          }
        });
        $input.atwho({
          at: '~',
          alias: 'labels',
          searchKey: 'search',
          data: this.defaultLoadingData,
          displayTpl: function (value) {
            return this.isLoading(value) ? this.Loading.template : this.Labels.template;
          }.bind(this),
          insertTpl: '${atwho-at}${title}',
          callbacks: {
            matcher: this.DefaultOptions.matcher,
            beforeInsert: this.DefaultOptions.beforeInsert,
            filter: this.DefaultOptions.filter,
            sorter: this.DefaultOptions.sorter,
            beforeSave: function beforeSave(merges) {
              if (gl.GfmAutoComplete.isLoading(merges)) return merges;
              var sanitizeLabelTitle;
              sanitizeLabelTitle = function sanitizeLabelTitle(title) {
                if (/[\w\?&]+\s+[\w\?&]+/g.test(title)) {
                  return "\"" + sanitize(title) + "\"";
                } else {
                  return sanitize(title);
                }
              };
              return $.map(merges, function (m) {
                return {
                  title: sanitize(m.title),
                  color: m.color,
                  search: "" + m.title
                };
              });
            }
          }
        });
        // We don't instantiate the slash commands autocomplete for note and issue/MR edit forms
        $input.filter('[data-supports-slash-commands="true"]').atwho({
          at: '/',
          alias: 'commands',
          searchKey: 'search',
          skipSpecialCharacterTest: true,
          data: this.defaultLoadingData,
          displayTpl: function (value) {
            if (this.isLoading(value)) return this.Loading.template;
            var tpl = '<li>/${name}';
            if (value.aliases.length > 0) {
              tpl += ' <small>(or /<%- aliases.join(", /") %>)</small>';
            }
            if (value.params.length > 0) {
              tpl += ' <small><%- params.join(" ") %></small>';
            }
            if (value.description !== '') {
              tpl += '<small class="description"><i><%- description %></i></small>';
            }
            tpl += '</li>';
            return _.template(tpl)(value);
          }.bind(this),
          insertTpl: function insertTpl(value) {
            var tpl = "/${name} ";
            var reference_prefix = null;
            if (value.params.length > 0) {
              reference_prefix = value.params[0][0];
              if (/^[@%~]/.test(reference_prefix)) {
                tpl += '<%- reference_prefix %>';
              }
            }
            return _.template(tpl)({ reference_prefix: reference_prefix });
          },
          suffix: '',
          callbacks: {
            sorter: this.DefaultOptions.sorter,
            filter: this.DefaultOptions.filter,
            beforeInsert: this.DefaultOptions.beforeInsert,
            beforeSave: function beforeSave(commands) {
              if (gl.GfmAutoComplete.isLoading(commands)) return commands;
              return $.map(commands, function (c) {
                var search = c.name;
                if (c.aliases.length > 0) {
                  search = search + " " + c.aliases.join(" ");
                }
                return {
                  name: c.name,
                  aliases: c.aliases,
                  params: c.params,
                  description: c.description,
                  search: search
                };
              });
            },
            matcher: function matcher(flag, subtext, should_startWithSpace, acceptSpaceBar) {
              var regexp = /(?:^|\n)\/([A-Za-z_]*)$/gi;
              var match = regexp.exec(subtext);
              if (match) {
                return match[1];
              } else {
                return null;
              }
            }
          }
        });
        return;
      },
      fetchData: function fetchData($input, at) {
        var _this2 = this;

        if (this.isLoadingData[at]) return;
        this.isLoadingData[at] = true;
        if (this.cachedData[at]) {
          this.loadData($input, at, this.cachedData[at]);
        } else {
          $.getJSON(this.dataSources[this.atTypeMap[at]], function (data) {
            _this2.loadData($input, at, data);
          }).fail(function () {
            _this2.isLoadingData[at] = false;
          });
        }
      },
      loadData: function loadData($input, at, data) {
        this.isLoadingData[at] = false;
        this.cachedData[at] = data;
        $input.atwho('load', at, data);
        // This trigger at.js again
        // otherwise we would be stuck with loading until the user types
        return $input.trigger('keyup');
      },
      isLoading: function isLoading(data) {
        var dataToInspect = data;
        if (data && data.length > 0) {
          dataToInspect = data[0];
        }

        var loadingState = this.defaultLoadingData[0];
        return dataToInspect && (dataToInspect === loadingState || dataToInspect.name === loadingState);
      }
    };
  }).call(this);
}).call(window);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-param-reassign */
  (function (global) {
    /*
     * This class overrides the browser's validation error bubbles, displaying custom
     * error messages for invalid fields instead. To begin validating any form, add the
     * class `gl-show-field-errors` to the form element, and ensure error messages are
     * declared in each inputs' `title` attribute. If no title is declared for an invalid
     * field the user attempts to submit, "This field is required." will be shown by default.
     *
     * Opt not to validate certain fields by adding the class `gl-field-error-ignore` to the input.
     *
     * Set a custom error anchor for error message to be injected after with the
     * class `gl-field-error-anchor`
     *
     * Examples:
     *
     * Basic:
     *
     * <form class='gl-show-field-errors'>
     *  <input type='text' name='username' title='Username is required.'/>
     * </form>
     *
     * Ignore specific inputs (e.g. UsernameValidator):
     *
     * <form class='gl-show-field-errors'>
     *   <div class="form-group>
     *     <input type='text' class='gl-field-errors-ignore' pattern='[a-zA-Z0-9-_]+'/>
     *   </div>
     *   <div class="form-group">
     *      <input type='text' name='username' title='Username is required.'/>
     *    </div>
     * </form>
     *
     * Custom Error Anchor (allows error message to be injected after specified element):
     *
     * <form class='gl-show-field-errors'>
     *  <div class="form-group gl-field-error-anchor">
     *    <input type='text' name='username' title='Username is required.'/>
     *    // Error message typically injected here
     *  </div>
     *  // Error message now injected here
     * </form>
     *
      * */

    /*
      * Regex Patterns in use:
      *
      * Only alphanumeric: : "[a-zA-Z0-9]+"
      * No special characters : "[a-zA-Z0-9-_]+",
      *
      * */

    var errorMessageClass = 'gl-field-error';
    var inputErrorClass = 'gl-field-error-outline';
    var errorAnchorSelector = '.gl-field-error-anchor';
    var ignoreInputSelector = '.gl-field-error-ignore';

    var GlFieldError = function () {
      function GlFieldError(_ref) {
        var input = _ref.input,
            formErrors = _ref.formErrors;

        _classCallCheck(this, GlFieldError);

        this.inputElement = $(input);
        this.inputDomElement = this.inputElement.get(0);
        this.form = formErrors;
        this.errorMessage = this.inputElement.attr('title') || 'This field is required.';
        this.fieldErrorElement = $('<p class=\'' + errorMessageClass + ' hide\'>' + this.errorMessage + '</p>');

        this.state = {
          valid: false,
          empty: true
        };

        this.initFieldValidation();
      }

      _createClass(GlFieldError, [{
        key: 'initFieldValidation',
        value: function initFieldValidation() {
          var customErrorAnchor = this.inputElement.parents(errorAnchorSelector);
          var errorAnchor = customErrorAnchor.length ? customErrorAnchor : this.inputElement;

          // hidden when injected into DOM
          errorAnchor.after(this.fieldErrorElement);
          this.inputElement.off('invalid').on('invalid', this.handleInvalidSubmit.bind(this));
          this.scopedSiblings = this.safelySelectSiblings();
        }
      }, {
        key: 'safelySelectSiblings',
        value: function safelySelectSiblings() {
          // Apply `ignoreSelector` in markup to siblings whose visibility should not be toggled
          var unignoredSiblings = this.inputElement.siblings('p:not(' + ignoreInputSelector + ')');
          var parentContainer = this.inputElement.parent('.form-group');

          // Only select siblings when they're scoped within a form-group with one input
          var safelyScoped = parentContainer.length && parentContainer.find('input').length === 1;

          return safelyScoped ? unignoredSiblings : this.fieldErrorElement;
        }
      }, {
        key: 'renderValidity',
        value: function renderValidity() {
          this.renderClear();

          if (this.state.valid) {
            this.renderValid();
          } else if (this.state.empty) {
            this.renderEmpty();
          } else if (!this.state.valid) {
            this.renderInvalid();
          }
        }
      }, {
        key: 'handleInvalidSubmit',
        value: function handleInvalidSubmit(event) {
          event.preventDefault();
          var currentValue = this.accessCurrentValue();
          this.state.valid = false;
          this.state.empty = currentValue === '';

          this.renderValidity();
          this.form.focusOnFirstInvalid.apply(this.form);
          // For UX, wait til after first invalid submission to check each keyup
          this.inputElement.off('keyup.fieldValidator').on('keyup.fieldValidator', this.updateValidity.bind(this));
        }

        /* Get or set current input value */

      }, {
        key: 'accessCurrentValue',
        value: function accessCurrentValue(newVal) {
          return newVal ? this.inputElement.val(newVal) : this.inputElement.val();
        }
      }, {
        key: 'getInputValidity',
        value: function getInputValidity() {
          return this.inputDomElement.validity.valid;
        }
      }, {
        key: 'updateValidity',
        value: function updateValidity() {
          var inputVal = this.accessCurrentValue();
          this.state.empty = !inputVal.length;
          this.state.valid = this.getInputValidity();
          this.renderValidity();
        }
      }, {
        key: 'renderValid',
        value: function renderValid() {
          return this.renderClear();
        }
      }, {
        key: 'renderEmpty',
        value: function renderEmpty() {
          return this.renderInvalid();
        }
      }, {
        key: 'renderInvalid',
        value: function renderInvalid() {
          this.inputElement.addClass(inputErrorClass);
          this.scopedSiblings.hide();
          return this.fieldErrorElement.show();
        }
      }, {
        key: 'renderClear',
        value: function renderClear() {
          var inputVal = this.accessCurrentValue();
          if (!inputVal.split(' ').length) {
            var trimmedInput = inputVal.trim();
            this.accessCurrentValue(trimmedInput);
          }
          this.inputElement.removeClass(inputErrorClass);
          this.scopedSiblings.hide();
          this.fieldErrorElement.hide();
        }
      }]);

      return GlFieldError;
    }();

    global.GlFieldError = GlFieldError;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /**
   * Linked Tabs
   *
   * Handles persisting and restores the current tab selection and content.
   * Reusable component for static content.
   *
   * ### Example Markup
   *
   *  <ul class="nav-links tab-links">
   *    <li class="active">
   *      <a data-action="tab1" data-target="#tab1" data-toggle="tab" href="/path/tab1">
   *        Tab 1
   *      </a>
   *    </li>
   *    <li class="groups-tab">
   *      <a data-action="tab2" data-target="#tab2" data-toggle="tab" href="/path/tab2">
   *        Tab 2
   *      </a>
   *    </li>
   *
   *
   *  <div class="tab-content">
   *    <div class="tab-pane" id="tab1">
   *      Tab 1 Content
   *    </div>
   *    <div class="tab-pane" id="tab2">
   *      Tab 2 Content
   *    </div>
   * </div>
   *
   *
   * ### How to use
   *
   *  new window.gl.LinkedTabs({
   *    action: "#{controller.action_name}",
   *    defaultAction: 'tab1',
   *    parentEl: '.tab-links'
   *  });
   */

  (function () {
    window.gl = window.gl || {};

    window.gl.LinkedTabs = function () {
      /**
       * Binds the events and activates de default tab.
       *
       * @param  {Object} options
       */
      function LinkedTabs(options) {
        var _this = this;

        _classCallCheck(this, LinkedTabs);

        this.options = options || {};

        this.defaultAction = this.options.defaultAction;
        this.action = this.options.action || this.defaultAction;

        if (this.action === 'show') {
          this.action = this.defaultAction;
        }

        this.currentLocation = window.location;

        var tabSelector = this.options.parentEl + ' a[data-toggle="tab"]';

        // since this is a custom event we need jQuery :(
        $(document).off('shown.bs.tab', tabSelector).on('shown.bs.tab', tabSelector, function (e) {
          return _this.tabShown(e);
        });

        this.activateTab(this.action);
      }

      /**
       * Handles the `shown.bs.tab` event to set the currect url action.
       *
       * @param  {type} evt
       * @return {Function}
       */


      _createClass(LinkedTabs, [{
        key: 'tabShown',
        value: function tabShown(evt) {
          var source = evt.target.getAttribute('href');

          return this.setCurrentAction(source);
        }

        /**
         * Updates the URL with the path that matched the given action.
         *
         * @param  {String} source
         * @return {String}
         */

      }, {
        key: 'setCurrentAction',
        value: function setCurrentAction(source) {
          var copySource = source;

          copySource.replace(/\/+$/, '');

          var newState = '' + copySource + this.currentLocation.search + this.currentLocation.hash;

          history.replaceState({
            url: newState
          }, document.title, newState);
          return newState;
        }

        /**
         * Given the current action activates the correct tab.
         * http://getbootstrap.com/javascript/#tab-show
         * Note: Will trigger `shown.bs.tab`
         */

      }, {
        key: 'activateTab',
        value: function activateTab() {
          return $(this.options.parentEl + ' a[data-action=\'' + this.action + '\']').tab('show');
        }
      }]);

      return LinkedTabs;
    }();
  })();
}).call(window);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, one-var, one-var-declaration-per-line, no-void, guard-for-in, no-restricted-syntax, prefer-template, quotes, max-len */
  (function () {
    (function (w) {
      var base;
      if (w.gl == null) {
        w.gl = {};
      }
      if ((base = w.gl).utils == null) {
        base.utils = {};
      }
      // Returns an array containing the value(s) of the
      // of the key passed as an argument
      w.gl.utils.getParameterValues = function (sParam) {
        var i, sPageURL, sParameterName, sURLVariables, values;
        sPageURL = decodeURIComponent(window.location.search.substring(1));
        sURLVariables = sPageURL.split('&');
        sParameterName = void 0;
        values = [];
        i = 0;
        while (i < sURLVariables.length) {
          sParameterName = sURLVariables[i].split('=');
          if (sParameterName[0] === sParam) {
            values.push(sParameterName[1].replace(/\+/g, ' '));
          }
          i += 1;
        }
        return values;
      };
      // @param {Object} params - url keys and value to merge
      // @param {String} url
      w.gl.utils.mergeUrlParams = function (params, url) {
        var lastChar, newUrl, paramName, paramValue, pattern;
        newUrl = decodeURIComponent(url);
        for (paramName in params) {
          paramValue = params[paramName];
          pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
          if (paramValue == null) {
            newUrl = newUrl.replace(pattern, '');
          } else if (url.search(pattern) !== -1) {
            newUrl = newUrl.replace(pattern, "$1" + paramValue + "$2");
          } else {
            newUrl = "" + newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + "=" + paramValue;
          }
        }
        // Remove a trailing ampersand
        lastChar = newUrl[newUrl.length - 1];
        if (lastChar === '&') {
          newUrl = newUrl.slice(0, -1);
        }
        return newUrl;
      };
      // removes parameter query string from url. returns the modified url
      w.gl.utils.removeParamQueryString = function (url, param) {
        var urlVariables, variables;
        url = decodeURIComponent(url);
        urlVariables = url.split('&');
        return function () {
          var j, len, results;
          results = [];
          for (j = 0, len = urlVariables.length; j < len; j += 1) {
            variables = urlVariables[j];
            if (variables.indexOf(param) === -1) {
              results.push(variables);
            }
          }
          return results;
        }().join('&');
      };
      w.gl.utils.getLocationHash = function (url) {
        var hashIndex;
        if (typeof url === 'undefined') {
          // Note: We can't use window.location.hash here because it's
          // not consistent across browsers - Firefox will pre-decode it
          url = window.location.href;
        }
        hashIndex = url.indexOf('#');
        return hashIndex === -1 ? null : url.substring(hashIndex + 1);
      };

      w.gl.utils.refreshCurrentPage = function () {
        return gl.utils.visitUrl(document.location.href);
      };

      w.gl.utils.visitUrl = function (url) {
        document.location.href = url;
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new, class-methods-use-this */
  /* global Breakpoints */
  /* global Cookies */
  /* global Flash */

  __webpack_require__(30);
  window.Cookies = __webpack_require__(10);
  __webpack_require__(34);

  /* eslint-disable max-len */
  // MergeRequestTabs
  //
  // Handles persisting and restoring the current tab selection and lazily-loading
  // content on the MergeRequests#show page.
  //
  // ### Example Markup
  //
  //   <ul class="nav-links merge-request-tabs">
  //     <li class="notes-tab active">
  //       <a data-action="notes" data-target="#notes" data-toggle="tab" href="/foo/bar/merge_requests/1">
  //         Discussion
  //       </a>
  //     </li>
  //     <li class="commits-tab">
  //       <a data-action="commits" data-target="#commits" data-toggle="tab" href="/foo/bar/merge_requests/1/commits">
  //         Commits
  //       </a>
  //     </li>
  //     <li class="diffs-tab">
  //       <a data-action="diffs" data-target="#diffs" data-toggle="tab" href="/foo/bar/merge_requests/1/diffs">
  //         Diffs
  //       </a>
  //     </li>
  //   </ul>
  //
  //   <div class="tab-content">
  //     <div class="notes tab-pane active" id="notes">
  //       Notes Content
  //     </div>
  //     <div class="commits tab-pane" id="commits">
  //       Commits Content
  //     </div>
  //     <div class="diffs tab-pane" id="diffs">
  //       Diffs Content
  //     </div>
  //   </div>
  //
  //   <div class="mr-loading-status">
  //     <div class="loading">
  //       Loading Animation
  //     </div>
  //   </div>
  //
  /* eslint-enable max-len */

  (function () {
    // Store the `location` object, allowing for easier stubbing in tests
    var location = window.location;

    var MergeRequestTabs = function () {
      function MergeRequestTabs() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            action = _ref.action,
            setUrl = _ref.setUrl,
            stubLocation = _ref.stubLocation;

        _classCallCheck(this, MergeRequestTabs);

        this.diffsLoaded = false;
        this.pipelinesLoaded = false;
        this.commitsLoaded = false;
        this.fixedLayoutPref = null;

        this.setUrl = setUrl !== undefined ? setUrl : true;
        this.setCurrentAction = this.setCurrentAction.bind(this);
        this.tabShown = this.tabShown.bind(this);
        this.showTab = this.showTab.bind(this);

        if (stubLocation) {
          location = stubLocation;
        }

        this.bindEvents();
        this.activateTab(action);
        this.initAffix();
      }

      _createClass(MergeRequestTabs, [{
        key: 'bindEvents',
        value: function bindEvents() {
          $(document).on('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).on('click', '.js-show-tab', this.showTab);

          $('.merge-request-tabs a[data-toggle="tab"]').on('click', this.clickTab);
        }
      }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
          $(document).off('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).off('click', '.js-show-tab', this.showTab);

          $('.merge-request-tabs a[data-toggle="tab"]').off('click', this.clickTab);
        }
      }, {
        key: 'showTab',
        value: function showTab(e) {
          e.preventDefault();
          this.activateTab($(e.target).data('action'));
        }
      }, {
        key: 'clickTab',
        value: function clickTab(e) {
          if (e.currentTarget && gl.utils.isMetaClick(e)) {
            var targetLink = e.currentTarget.getAttribute('href');
            e.stopImmediatePropagation();
            e.preventDefault();
            window.open(targetLink, '_blank');
          }
        }
      }, {
        key: 'tabShown',
        value: function tabShown(e) {
          var $target = $(e.target);
          var action = $target.data('action');

          if (action === 'commits') {
            this.loadCommits($target.attr('href'));
            this.expandView();
            this.resetViewContainer();
          } else if (this.isDiffAction(action)) {
            this.loadDiff($target.attr('href'));
            if (Breakpoints.get().getBreakpointSize() !== 'lg') {
              this.shrinkView();
            }
            if (this.diffViewType() === 'parallel') {
              this.expandViewContainer();
            }
            var navBarHeight = $('.navbar-gitlab').outerHeight();
            $.scrollTo('.merge-request-details .merge-request-tabs', {
              offset: -navBarHeight
            });
          } else if (action === 'pipelines') {
            if (this.pipelinesLoaded) {
              return;
            }
            var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');
            gl.commits.pipelines.PipelinesTableBundle.$mount(pipelineTableViewEl);
            this.pipelinesLoaded = true;
          } else {
            this.expandView();
            this.resetViewContainer();
          }
          if (this.setUrl) {
            this.setCurrentAction(action);
          }
        }
      }, {
        key: 'scrollToElement',
        value: function scrollToElement(container) {
          if (location.hash) {
            var offset = 0 - ($('.navbar-gitlab').outerHeight() + $('.layout-nav').outerHeight() + $('.js-tabs-affix').outerHeight());
            var $el = $(container + ' ' + location.hash + ':not(.match)');
            if ($el.length) {
              $.scrollTo($el[0], { offset: offset });
            }
          }
        }

        // Activate a tab based on the current action

      }, {
        key: 'activateTab',
        value: function activateTab(action) {
          var activate = action === 'show' ? 'notes' : action;
          // important note: the .tab('show') method triggers 'shown.bs.tab' event itself
          $('.merge-request-tabs a[data-action=\'' + activate + '\']').tab('show');
        }

        // Replaces the current Merge Request-specific action in the URL with a new one
        //
        // If the action is "notes", the URL is reset to the standard
        // `MergeRequests#show` route.
        //
        // Examples:
        //
        //   location.pathname # => "/namespace/project/merge_requests/1"
        //   setCurrentAction('diffs')
        //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
        //
        //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
        //   setCurrentAction('notes')
        //   location.pathname # => "/namespace/project/merge_requests/1"
        //
        //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
        //   setCurrentAction('commits')
        //   location.pathname # => "/namespace/project/merge_requests/1/commits"
        //
        // Returns the new URL String

      }, {
        key: 'setCurrentAction',
        value: function setCurrentAction(action) {
          this.currentAction = action === 'show' ? 'notes' : action;

          // Remove a trailing '/commits' '/diffs' '/pipelines' '/new' '/new/diffs'
          var newState = location.pathname.replace(/\/(commits|diffs|pipelines|new|new\/diffs)(\.html)?\/?$/, '');

          // Append the new action if we're on a tab other than 'notes'
          if (this.currentAction !== 'notes') {
            newState += '/' + this.currentAction;
          }

          // Ensure parameters and hash come along for the ride
          newState += location.search + location.hash;

          // TODO: Consider refactoring in light of turbolinks removal.

          // Replace the current history state with the new one without breaking
          // Turbolinks' history.
          //
          // See https://github.com/rails/turbolinks/issues/363
          window.history.replaceState({
            url: newState
          }, document.title, newState);

          return newState;
        }
      }, {
        key: 'loadCommits',
        value: function loadCommits(source) {
          var _this = this;

          if (this.commitsLoaded) {
            return;
          }
          this.ajaxGet({
            url: source + '.json',
            success: function success(data) {
              document.querySelector('div#commits').innerHTML = data.html;
              gl.utils.localTimeAgo($('.js-timeago', 'div#commits'));
              _this.commitsLoaded = true;
              _this.scrollToElement('#commits');
            }
          });
        }
      }, {
        key: 'loadDiff',
        value: function loadDiff(source) {
          var _this2 = this;

          if (this.diffsLoaded) {
            return;
          }

          // We extract pathname for the current Changes tab anchor href
          // some pages like MergeRequestsController#new has query parameters on that anchor
          var urlPathname = gl.utils.parseUrlPathname(source);

          this.ajaxGet({
            url: urlPathname + '.json' + location.search,
            success: function success(data) {
              $('#diffs').html(data.html);

              if (typeof gl.diffNotesCompileComponents !== 'undefined') {
                gl.diffNotesCompileComponents();
              }

              gl.utils.localTimeAgo($('.js-timeago', 'div#diffs'));
              $('#diffs .js-syntax-highlight').syntaxHighlight();

              if (_this2.diffViewType() === 'parallel' && _this2.isDiffAction(_this2.currentAction)) {
                _this2.expandViewContainer();
              }
              _this2.diffsLoaded = true;

              new gl.Diff();
              _this2.scrollToElement('#diffs');
            }
          });
        }

        // Show or hide the loading spinner
        //
        // status - Boolean, true to show, false to hide

      }, {
        key: 'toggleLoading',
        value: function toggleLoading(status) {
          $('.mr-loading-status .loading').toggle(status);
        }
      }, {
        key: 'ajaxGet',
        value: function ajaxGet(options) {
          var _this3 = this;

          var defaults = {
            beforeSend: function beforeSend() {
              return _this3.toggleLoading(true);
            },
            error: function error() {
              return new Flash('An error occurred while fetching this tab.', 'alert');
            },
            complete: function complete() {
              return _this3.toggleLoading(false);
            },
            dataType: 'json',
            type: 'GET'
          };
          $.ajax($.extend({}, defaults, options));
        }
      }, {
        key: 'diffViewType',
        value: function diffViewType() {
          return $('.inline-parallel-buttons a.active').data('view-type');
        }
      }, {
        key: 'isDiffAction',
        value: function isDiffAction(action) {
          return action === 'diffs' || action === 'new/diffs';
        }
      }, {
        key: 'expandViewContainer',
        value: function expandViewContainer() {
          var $wrapper = $('.content-wrapper .container-fluid');
          if (this.fixedLayoutPref === null) {
            this.fixedLayoutPref = $wrapper.hasClass('container-limited');
          }
          $wrapper.removeClass('container-limited');
        }
      }, {
        key: 'resetViewContainer',
        value: function resetViewContainer() {
          if (this.fixedLayoutPref !== null) {
            $('.content-wrapper .container-fluid').toggleClass('container-limited', this.fixedLayoutPref);
          }
        }
      }, {
        key: 'shrinkView',
        value: function shrinkView() {
          var $gutterIcon = $('.js-sidebar-toggle i:visible');

          // Wait until listeners are set
          setTimeout(function () {
            // Only when sidebar is expanded
            if ($gutterIcon.is('.fa-angle-double-right')) {
              $gutterIcon.closest('a').trigger('click', [true]);
            }
          }, 0);
        }

        // Expand the issuable sidebar unless the user explicitly collapsed it

      }, {
        key: 'expandView',
        value: function expandView() {
          if (Cookies.get('collapsed_gutter') === 'true') {
            return;
          }
          var $gutterIcon = $('.js-sidebar-toggle i:visible');

          // Wait until listeners are set
          setTimeout(function () {
            // Only when sidebar is collapsed
            if ($gutterIcon.is('.fa-angle-double-left')) {
              $gutterIcon.closest('a').trigger('click', [true]);
            }
          }, 0);
        }
      }, {
        key: 'initAffix',
        value: function initAffix() {
          var $tabs = $('.js-tabs-affix');

          // Screen space on small screens is usually very sparse
          // So we dont affix the tabs on these
          if (Breakpoints.get().getBreakpointSize() === 'xs' || !$tabs.length) return;

          var $diffTabs = $('#diff-notes-app');
          var $fixedNav = $('.navbar-fixed-top');
          var $layoutNav = $('.layout-nav');

          $tabs.off('affix.bs.affix affix-top.bs.affix').affix({
            offset: {
              top: function top() {
                return $diffTabs.offset().top - $tabs.height() - $fixedNav.height() - $layoutNav.height();
              }
            }
          }).on('affix.bs.affix', function () {
            return $diffTabs.css({ marginTop: $tabs.height() });
          }).on('affix-top.bs.affix', function () {
            return $diffTabs.css({ marginTop: '' });
          });

          // Fix bug when reloading the page already scrolling
          if ($tabs.hasClass('affix')) {
            $tabs.trigger('affix.bs.affix');
          }
        }
      }]);

      return MergeRequestTabs;
    }();

    window.gl = window.gl || {};
    window.gl.MergeRequestTabs = MergeRequestTabs;
  })();
}).call(window);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Mousetrap */
  /* global Shortcuts */

  __webpack_require__(8);

  var defaults = {
    skipResetBindings: false,
    fileBlobPermalinkUrl: null
  };

  var ShortcutsBlob = function (_Shortcuts) {
    _inherits(ShortcutsBlob, _Shortcuts);

    function ShortcutsBlob(opts) {
      _classCallCheck(this, ShortcutsBlob);

      var options = Object.assign({}, defaults, opts);

      var _this = _possibleConstructorReturn(this, (ShortcutsBlob.__proto__ || Object.getPrototypeOf(ShortcutsBlob)).call(this, options.skipResetBindings));

      _this.options = options;

      Mousetrap.bind('y', _this.moveToFilePermalink.bind(_this));
      return _this;
    }

    _createClass(ShortcutsBlob, [{
      key: 'moveToFilePermalink',
      value: function moveToFilePermalink() {
        if (this.options.fileBlobPermalinkUrl) {
          var hash = gl.utils.getLocationHash();
          var hashUrlString = hash ? '#' + hash : '';
          gl.utils.visitUrl('' + this.options.fileBlobPermalinkUrl + hashUrlString);
        }
      }
    }]);

    return ShortcutsBlob;
  }(Shortcuts);

  module.exports = ShortcutsBlob;
}).call(window);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

// The MIT License (MIT)
//
// Copyright (c) 2014 GitHub, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// TaskList Behavior
//
/*= provides tasklist:enabled */
/*= provides tasklist:disabled */
/*= provides tasklist:change */
/*= provides tasklist:changed */
//
//
// Enables Task List update behavior.
//
// ### Example Markup
//
//   <div class="js-task-list-container">
//     <ul class="task-list">
//       <li class="task-list-item">
//         <input type="checkbox" class="js-task-list-item-checkbox" disabled />
//         text
//       </li>
//     </ul>
//     <form>
//       <textarea class="js-task-list-field">- [ ] text</textarea>
//     </form>
//   </div>
//
// ### Specification
//
// TaskLists MUST be contained in a `(div).js-task-list-container`.
//
// TaskList Items SHOULD be an a list (`UL`/`OL`) element.
//
// Task list items MUST match `(input).task-list-item-checkbox` and MUST be
// `disabled` by default.
//
// TaskLists MUST have a `(textarea).js-task-list-field` form element whose
// `value` attribute is the source (Markdown) to be udpated. The source MUST
// follow the syntax guidelines.
//
// TaskList updates trigger `tasklist:change` events. If the change is
// successful, `tasklist:changed` is fired. The change can be canceled.
//
// jQuery is required.
//
// ### Methods
//
// `.taskList('enable')` or `.taskList()`
//
// Enables TaskList updates for the container.
//
// `.taskList('disable')`
//
// Disables TaskList updates for the container.
//
//# ### Events
//
// `tasklist:enabled`
//
// Fired when the TaskList is enabled.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-container`
//
// `tasklist:disabled`
//
// Fired when the TaskList is disabled.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-container`
//
// `tasklist:change`
//
// Fired before the TaskList item change takes affect.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** Yes
// * **Target** `.js-task-list-field`
//
// `tasklist:changed`
//
// Fired once the TaskList item change has taken affect.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-field`
//
// ### NOTE
//
// Task list checkboxes are rendered as disabled by default because rendered
// user content is cached without regard for the viewer.
(function() {
  var codeFencesPattern, complete, completePattern, disableTaskList, disableTaskLists, enableTaskList, enableTaskLists, escapePattern, incomplete, incompletePattern, itemPattern, itemsInParasPattern, updateTaskList, updateTaskListItem,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  incomplete = "[ ]";

  complete = "[x]";

  // Escapes the String for regular expression matching.
  escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  incompletePattern = RegExp("" + (escapePattern(incomplete))); // escape square brackets
 // match all white space
  completePattern = RegExp("" + (escapePattern(complete))); // match all cases

  // Pattern used to identify all task list items.
  // Useful when you need iterate over all items.
  itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (escapePattern(complete)) + "|" + (escapePattern(incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  // prefix, consisting of
  // optional leading whitespace
  // zero or more blockquotes
  // list item indicator
  // optional whitespace prefix
  // checkbox
  // is followed by whitespace
  // is not part of a [foo](url) link
  // and is followed by zero or more links
  // and either a non-link or the end of the string
  // Used to filter out code fences from the source for comparison only.
  // http://rubular.com/r/x5EwZVrloI
  // Modified slightly due to issues with JS
  codeFencesPattern = /^`{3}(?:\s*\w+)?[\S\s].*[\S\s]^`{3}$/mg;

  // ```
  // followed by optional language
  // whitespace
  // code
  // whitespace
  // ```
  // Used to filter out potential mismatches (items not in lists).
  // http://rubular.com/r/OInl6CiePy
  itemsInParasPattern = RegExp("^(" + (escapePattern(complete)) + "|" + (escapePattern(incomplete)) + ").+$", "g");

  // Given the source text, updates the appropriate task list item to match the
  // given checked value.
  //
  // Returns the updated String text.
  updateTaskListItem = function(source, itemIndex, checked) {
    var clean, index, line, result;
    clean = source.replace(/\r/g, '').replace(codeFencesPattern, '').replace(itemsInParasPattern, '').split("\n");
    index = 0;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (indexOf.call(clean, line) >= 0 && line.match(itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(incompletePattern, complete) : line.replace(completePattern, incomplete);
          }
        }
        results.push(line);
      }
      return results;
    })();
    return result.join("\n");
  };

  // Updates the $field value to reflect the state of $item.
  // Triggers the `tasklist:change` event before the value has changed, and fires
  // a `tasklist:changed` event once the value has changed.
  updateTaskList = function($item) {
    var $container, $field, checked, event, index;
    $container = $item.closest('.js-task-list-container');
    $field = $container.find('.js-task-list-field');
    index = 1 + $container.find('.task-list-item-checkbox').index($item);
    checked = $item.prop('checked');
    event = $.Event('tasklist:change');
    $field.trigger(event, [index, checked]);
    if (!event.isDefaultPrevented()) {
      $field.val(updateTaskListItem($field.val(), index, checked));
      $field.trigger('change');
      return $field.trigger('tasklist:changed', [index, checked]);
    }
  };

  // When the task list item checkbox is updated, submit the change
  $(document).on('change', '.task-list-item-checkbox', function() {
    return updateTaskList($(this));
  });

  // Enables TaskList item changes.
  enableTaskList = function($container) {
    if ($container.find('.js-task-list-field').length > 0) {
      $container.find('.task-list-item').addClass('enabled').find('.task-list-item-checkbox').attr('disabled', null);
      return $container.addClass('is-task-list-enabled').trigger('tasklist:enabled');
    }
  };

  // Enables a collection of TaskList containers.
  enableTaskLists = function($containers) {
    var container, i, len, results;
    results = [];
    for (i = 0, len = $containers.length; i < len; i++) {
      container = $containers[i];
      results.push(enableTaskList($(container)));
    }
    return results;
  };

  // Disable TaskList item changes.
  disableTaskList = function($container) {
    $container.find('.task-list-item').removeClass('enabled').find('.task-list-item-checkbox').attr('disabled', 'disabled');
    return $container.removeClass('is-task-list-enabled').trigger('tasklist:disabled');
  };

  // Disables a collection of TaskList containers.
  disableTaskLists = function($containers) {
    var container, i, len, results;
    results = [];
    for (i = 0, len = $containers.length; i < len; i++) {
      container = $containers[i];
      results.push(disableTaskList($(container)));
    }
    return results;
  };

  $.fn.taskList = function(method) {
    var $container, methods;
    $container = $(this).closest('.js-task-list-container');
    methods = {
      enable: enableTaskLists,
      disable: disableTaskLists
    };
    return methods[method || 'enable']($container);
  };

}).call(this);

}.call(window));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-arrow-callback, consistent-return, no-return-assign */
  /* global Mousetrap */
  /* global Shortcuts */

  __webpack_require__(8);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.ShortcutsDashboardNavigation = function (superClass) {
      extend(ShortcutsDashboardNavigation, superClass);

      function ShortcutsDashboardNavigation() {
        ShortcutsDashboardNavigation.__super__.constructor.call(this);
        Mousetrap.bind('g a', function () {
          return ShortcutsDashboardNavigation.findAndFollowLink('.dashboard-shortcuts-activity');
        });
        Mousetrap.bind('g i', function () {
          return ShortcutsDashboardNavigation.findAndFollowLink('.dashboard-shortcuts-issues');
        });
        Mousetrap.bind('g m', function () {
          return ShortcutsDashboardNavigation.findAndFollowLink('.dashboard-shortcuts-merge_requests');
        });
        Mousetrap.bind('g p', function () {
          return ShortcutsDashboardNavigation.findAndFollowLink('.dashboard-shortcuts-projects');
        });
      }

      ShortcutsDashboardNavigation.findAndFollowLink = function (selector) {
        var link;
        link = $(selector).attr('href');
        if (link) {
          return window.location = link;
        }
      };

      return ShortcutsDashboardNavigation;
    }(Shortcuts);
  }).call(this);
}).call(window);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, one-var-declaration-per-line, quotes, prefer-arrow-callback, consistent-return, prefer-template, no-mixed-operators */
  /* global Mousetrap */
  /* global ShortcutsNavigation */
  /* global sidebar */

  __webpack_require__(29);
  __webpack_require__(9);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.ShortcutsIssuable = function (superClass) {
      extend(ShortcutsIssuable, superClass);

      function ShortcutsIssuable(isMergeRequest) {
        ShortcutsIssuable.__super__.constructor.call(this);
        Mousetrap.bind('a', this.openSidebarDropdown.bind(this, 'assignee'));
        Mousetrap.bind('m', this.openSidebarDropdown.bind(this, 'milestone'));
        Mousetrap.bind('r', function (_this) {
          return function () {
            _this.replyWithSelectedText();
            return false;
          };
        }(this));
        Mousetrap.bind('e', function (_this) {
          return function () {
            _this.editIssue();
            return false;
          };
        }(this));
        Mousetrap.bind('l', this.openSidebarDropdown.bind(this, 'labels'));
        if (isMergeRequest) {
          this.enabledHelp.push('.hidden-shortcut.merge_requests');
        } else {
          this.enabledHelp.push('.hidden-shortcut.issues');
        }
      }

      ShortcutsIssuable.prototype.replyWithSelectedText = function () {
        var quote, documentFragment, selected, separator;
        var replyField = $('.js-main-target-form #note_note');

        documentFragment = window.gl.utils.getSelectedFragment();
        if (!documentFragment) {
          replyField.focus();
          return;
        }

        // If the documentFragment contains more than just Markdown, don't copy as GFM.
        if (documentFragment.querySelector('.md, .wiki')) return;

        selected = window.gl.CopyAsGFM.nodeToGFM(documentFragment);

        if (selected.trim() === "") {
          return;
        }
        quote = _.map(selected.split("\n"), function (val) {
          return ("> " + val).trim() + "\n";
        });
        // If replyField already has some content, add a newline before our quote
        separator = replyField.val().trim() !== "" && "\n\n" || '';
        replyField.val(function (_, current) {
          return current + separator + quote.join('') + "\n";
        });

        // Trigger autosave
        replyField.trigger('input');

        // Trigger autosize
        var event = document.createEvent('Event');
        event.initEvent('autosize:update', true, false);
        replyField.get(0).dispatchEvent(event);

        // Focus the input field
        return replyField.focus();
      };

      ShortcutsIssuable.prototype.editIssue = function () {
        var $editBtn;
        $editBtn = $('.issuable-edit');
        return gl.utils.visitUrl($editBtn.attr('href'));
      };

      ShortcutsIssuable.prototype.openSidebarDropdown = function (name) {
        sidebar.openDropdown(name);
        return false;
      };

      return ShortcutsIssuable;
    }(ShortcutsNavigation);
  }).call(this);
}).call(window);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, max-len */
  /* global Mousetrap */
  /* global ShortcutsNavigation */

  __webpack_require__(9);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.ShortcutsNetwork = function (superClass) {
      extend(ShortcutsNetwork, superClass);

      function ShortcutsNetwork(graph) {
        this.graph = graph;
        ShortcutsNetwork.__super__.constructor.call(this);
        Mousetrap.bind(['left', 'h'], this.graph.scrollLeft);
        Mousetrap.bind(['right', 'l'], this.graph.scrollRight);
        Mousetrap.bind(['up', 'k'], this.graph.scrollUp);
        Mousetrap.bind(['down', 'j'], this.graph.scrollDown);
        Mousetrap.bind(['shift+up', 'shift+k'], this.graph.scrollTop);
        Mousetrap.bind(['shift+down', 'shift+j'], this.graph.scrollBottom);
        this.enabledHelp.push('.hidden-shortcut.network');
      }

      return ShortcutsNetwork;
    }(ShortcutsNavigation);
  }).call(this);
}).call(window);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/**
 * at.js - 1.5.1
 * Copyright (c) 2016 chord.luo <chord.luo@gmail.com>;
 * Homepage: http://ichord.github.com/At.js
 * License: MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return (factory(a0));
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function ($) {
var DEFAULT_CALLBACKS, KEY_CODE;

KEY_CODE = {
  DOWN: 40,
  UP: 38,
  ESC: 27,
  TAB: 9,
  ENTER: 13,
  CTRL: 17,
  A: 65,
  P: 80,
  N: 78,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  BACKSPACE: 8,
  SPACE: 32
};

DEFAULT_CALLBACKS = {
  beforeSave: function(data) {
    return Controller.arrayToDefaultHash(data);
  },
  matcher: function(flag, subtext, should_startWithSpace, acceptSpaceBar) {
    var _a, _y, match, regexp, space;
    flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    if (should_startWithSpace) {
      flag = '(?:^|\\s)' + flag;
    }
    _a = decodeURI("%C3%80");
    _y = decodeURI("%C3%BF");
    space = acceptSpaceBar ? "\ " : "";
    regexp = new RegExp(flag + "([A-Za-z" + _a + "-" + _y + "0-9_" + space + "\'\.\+\-]*)$|" + flag + "([^\\x00-\\xff]*)$", 'gi');
    match = regexp.exec(subtext);
    if (match) {
      return match[2] || match[1];
    } else {
      return null;
    }
  },
  filter: function(query, data, searchKey) {
    var _results, i, item, len;
    _results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if (~new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase())) {
        _results.push(item);
      }
    }
    return _results;
  },
  remoteFilter: null,
  sorter: function(query, items, searchKey) {
    var _results, i, item, len;
    if (!query) {
      return items;
    }
    _results = [];
    for (i = 0, len = items.length; i < len; i++) {
      item = items[i];
      item.atwho_order = new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase());
      if (item.atwho_order > -1) {
        _results.push(item);
      }
    }
    return _results.sort(function(a, b) {
      return a.atwho_order - b.atwho_order;
    });
  },
  tplEval: function(tpl, map) {
    var error, error1, template;
    template = tpl;
    try {
      if (typeof tpl !== 'string') {
        template = tpl(map);
      }
      return template.replace(/\$\{([^\}]*)\}/g, function(tag, key, pos) {
        return map[key];
      });
    } catch (error1) {
      error = error1;
      return "";
    }
  },
  highlighter: function(li, query) {
    var regexp;
    if (!query) {
      return li;
    }
    regexp = new RegExp(">\\s*(\\w*?)(" + query.replace("+", "\\+") + ")(\\w*)\\s*<", 'ig');
    return li.replace(regexp, function(str, $1, $2, $3) {
      return '> ' + $1 + '<strong>' + $2 + '</strong>' + $3 + ' <';
    });
  },
  beforeInsert: function(value, $li, e) {
    return value;
  },
  beforeReposition: function(offset) {
    return offset;
  },
  afterMatchFailed: function(at, el) {}
};

var App;

App = (function() {
  function App(inputor) {
    this.currentFlag = null;
    this.controllers = {};
    this.aliasMaps = {};
    this.$inputor = $(inputor);
    this.setupRootElement();
    this.listen();
  }

  App.prototype.createContainer = function(doc) {
    var ref;
    if ((ref = this.$el) != null) {
      ref.remove();
    }
    return $(doc.body).append(this.$el = $("<div class='atwho-container'></div>"));
  };

  App.prototype.setupRootElement = function(iframe, asRoot) {
    var error, error1;
    if (asRoot == null) {
      asRoot = false;
    }
    if (iframe) {
      this.window = iframe.contentWindow;
      this.document = iframe.contentDocument || this.window.document;
      this.iframe = iframe;
    } else {
      this.document = this.$inputor[0].ownerDocument;
      this.window = this.document.defaultView || this.document.parentWindow;
      try {
        this.iframe = this.window.frameElement;
      } catch (error1) {
        error = error1;
        this.iframe = null;
        if ($.fn.atwho.debug) {
          throw new Error("iframe auto-discovery is failed.\nPlease use `setIframe` to set the target iframe manually.\n" + error);
        }
      }
    }
    return this.createContainer((this.iframeAsRoot = asRoot) ? this.document : document);
  };

  App.prototype.controller = function(at) {
    var c, current, currentFlag, ref;
    if (this.aliasMaps[at]) {
      current = this.controllers[this.aliasMaps[at]];
    } else {
      ref = this.controllers;
      for (currentFlag in ref) {
        c = ref[currentFlag];
        if (currentFlag === at) {
          current = c;
          break;
        }
      }
    }
    if (current) {
      return current;
    } else {
      return this.controllers[this.currentFlag];
    }
  };

  App.prototype.setContextFor = function(at) {
    this.currentFlag = at;
    return this;
  };

  App.prototype.reg = function(flag, setting) {
    var base, controller;
    controller = (base = this.controllers)[flag] || (base[flag] = this.$inputor.is('[contentEditable]') ? new EditableController(this, flag) : new TextareaController(this, flag));
    if (setting.alias) {
      this.aliasMaps[setting.alias] = flag;
    }
    controller.init(setting);
    return this;
  };

  App.prototype.listen = function() {
    return this.$inputor.on('compositionstart', (function(_this) {
      return function(e) {
        var ref;
        if ((ref = _this.controller()) != null) {
          ref.view.hide();
        }
        _this.isComposing = true;
        return null;
      };
    })(this)).on('compositionend', (function(_this) {
      return function(e) {
        _this.isComposing = false;
        setTimeout(function(e) {
          return _this.dispatch(e);
        });
        return null;
      };
    })(this)).on('keyup.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeyup(e);
      };
    })(this)).on('keydown.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeydown(e);
      };
    })(this)).on('blur.atwhoInner', (function(_this) {
      return function(e) {
        var c;
        if (c = _this.controller()) {
          c.expectedQueryCBId = null;
          return c.view.hide(e, c.getOpt("displayTimeout"));
        }
      };
    })(this)).on('click.atwhoInner', (function(_this) {
      return function(e) {
        return _this.dispatch(e);
      };
    })(this)).on('scroll.atwhoInner', (function(_this) {
      return function() {
        var lastScrollTop;
        lastScrollTop = _this.$inputor.scrollTop();
        return function(e) {
          var currentScrollTop, ref;
          currentScrollTop = e.target.scrollTop;
          if (lastScrollTop !== currentScrollTop) {
            if ((ref = _this.controller()) != null) {
              ref.view.hide(e);
            }
          }
          lastScrollTop = currentScrollTop;
          return true;
        };
      };
    })(this)());
  };

  App.prototype.shutdown = function() {
    var _, c, ref;
    ref = this.controllers;
    for (_ in ref) {
      c = ref[_];
      c.destroy();
      delete this.controllers[_];
    }
    this.$inputor.off('.atwhoInner');
    return this.$el.remove();
  };

  App.prototype.dispatch = function(e) {
    var _, c, ref, results;
    ref = this.controllers;
    results = [];
    for (_ in ref) {
      c = ref[_];
      results.push(c.lookUp(e));
    }
    return results;
  };

  App.prototype.onKeyup = function(e) {
    var ref;
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        if ((ref = this.controller()) != null) {
          ref.view.hide();
        }
        break;
      case KEY_CODE.DOWN:
      case KEY_CODE.UP:
      case KEY_CODE.CTRL:
      case KEY_CODE.ENTER:
        $.noop();
        break;
      case KEY_CODE.P:
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          this.dispatch(e);
        }
        break;
      default:
        this.dispatch(e);
    }
  };

  App.prototype.onKeydown = function(e) {
    var ref, view;
    view = (ref = this.controller()) != null ? ref.view : void 0;
    if (!(view && view.visible())) {
      return;
    }
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        view.hide(e);
        break;
      case KEY_CODE.UP:
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.DOWN:
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.P:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.TAB:
      case KEY_CODE.ENTER:
      case KEY_CODE.SPACE:
        if (!view.visible()) {
          return;
        }
        if (!this.controller().getOpt('spaceSelectsMatch') && e.keyCode === KEY_CODE.SPACE) {
          return;
        }
        if (!this.controller().getOpt('tabSelectsMatch') && e.keyCode === KEY_CODE.TAB) {
          return;
        }
        if (view.highlighted()) {
          e.preventDefault();
          view.choose(e);
        } else {
          view.hide(e);
        }
        break;
      default:
        $.noop();
    }
  };

  return App;

})();

var Controller,
  slice = [].slice;

Controller = (function() {
  Controller.prototype.uid = function() {
    return (Math.random().toString(16) + "000000000").substr(2, 8) + (new Date().getTime());
  };

  function Controller(app, at1) {
    this.app = app;
    this.at = at1;
    this.$inputor = this.app.$inputor;
    this.id = this.$inputor[0].id || this.uid();
    this.expectedQueryCBId = null;
    this.setting = null;
    this.query = null;
    this.pos = 0;
    this.range = null;
    if ((this.$el = $("#atwho-ground-" + this.id, this.app.$el)).length === 0) {
      this.app.$el.append(this.$el = $("<div id='atwho-ground-" + this.id + "'></div>"));
    }
    this.model = new Model(this);
    this.view = new View(this);
  }

  Controller.prototype.init = function(setting) {
    this.setting = $.extend({}, this.setting || $.fn.atwho["default"], setting);
    this.view.init();
    return this.model.reload(this.setting.data);
  };

  Controller.prototype.destroy = function() {
    this.trigger('beforeDestroy');
    this.model.destroy();
    this.view.destroy();
    return this.$el.remove();
  };

  Controller.prototype.callDefault = function() {
    var args, error, error1, funcName;
    funcName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    try {
      return DEFAULT_CALLBACKS[funcName].apply(this, args);
    } catch (error1) {
      error = error1;
      return $.error(error + " Or maybe At.js doesn't have function " + funcName);
    }
  };

  Controller.prototype.trigger = function(name, data) {
    var alias, eventName;
    if (data == null) {
      data = [];
    }
    data.push(this);
    alias = this.getOpt('alias');
    eventName = alias ? name + "-" + alias + ".atwho" : name + ".atwho";
    return this.$inputor.trigger(eventName, data);
  };

  Controller.prototype.callbacks = function(funcName) {
    return this.getOpt("callbacks")[funcName] || DEFAULT_CALLBACKS[funcName];
  };

  Controller.prototype.getOpt = function(at, default_value) {
    var e, error1;
    try {
      return this.setting[at];
    } catch (error1) {
      e = error1;
      return null;
    }
  };

  Controller.prototype.insertContentFor = function($li) {
    var data, tpl;
    tpl = this.getOpt('insertTpl');
    data = $.extend({}, $li.data('item-data'), {
      'atwho-at': this.at
    });
    return this.callbacks("tplEval").call(this, tpl, data, "onInsert");
  };

  Controller.prototype.renderView = function(data) {
    var searchKey;
    searchKey = this.getOpt("searchKey");
    data = this.callbacks("sorter").call(this, this.query.text, data.slice(0, 1001), searchKey);
    return this.view.render(data.slice(0, this.getOpt('limit')));
  };

  Controller.arrayToDefaultHash = function(data) {
    var i, item, len, results;
    if (!$.isArray(data)) {
      return data;
    }
    results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if ($.isPlainObject(item)) {
        results.push(item);
      } else {
        results.push({
          name: item
        });
      }
    }
    return results;
  };

  Controller.prototype.lookUp = function(e) {
    var query, wait;
    if (e && e.type === 'click' && !this.getOpt('lookUpOnClick')) {
      return;
    }
    if (this.getOpt('suspendOnComposing') && this.app.isComposing) {
      return;
    }
    query = this.catchQuery(e);
    if (!query) {
      this.expectedQueryCBId = null;
      return query;
    }
    this.app.setContextFor(this.at);
    if (wait = this.getOpt('delay')) {
      this._delayLookUp(query, wait);
    } else {
      this._lookUp(query);
    }
    return query;
  };

  Controller.prototype._delayLookUp = function(query, wait) {
    var now, remaining;
    now = Date.now ? Date.now() : new Date().getTime();
    this.previousCallTime || (this.previousCallTime = now);
    remaining = wait - (now - this.previousCallTime);
    if ((0 < remaining && remaining < wait)) {
      this.previousCallTime = now;
      this._stopDelayedCall();
      return this.delayedCallTimeout = setTimeout((function(_this) {
        return function() {
          _this.previousCallTime = 0;
          _this.delayedCallTimeout = null;
          return _this._lookUp(query);
        };
      })(this), wait);
    } else {
      this._stopDelayedCall();
      if (this.previousCallTime !== now) {
        this.previousCallTime = 0;
      }
      return this._lookUp(query);
    }
  };

  Controller.prototype._stopDelayedCall = function() {
    if (this.delayedCallTimeout) {
      clearTimeout(this.delayedCallTimeout);
      return this.delayedCallTimeout = null;
    }
  };

  Controller.prototype._generateQueryCBId = function() {
    return {};
  };

  Controller.prototype._lookUp = function(query) {
    var _callback;
    _callback = function(queryCBId, data) {
      if (queryCBId !== this.expectedQueryCBId) {
        return;
      }
      if (data && data.length > 0) {
        return this.renderView(this.constructor.arrayToDefaultHash(data));
      } else {
        return this.view.hide();
      }
    };
    this.expectedQueryCBId = this._generateQueryCBId();
    return this.model.query(query.text, $.proxy(_callback, this, this.expectedQueryCBId));
  };

  return Controller;

})();

var TextareaController,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

TextareaController = (function(superClass) {
  extend(TextareaController, superClass);

  function TextareaController() {
    return TextareaController.__super__.constructor.apply(this, arguments);
  }

  TextareaController.prototype.catchQuery = function() {
    var caretPos, content, end, isString, query, start, subtext;
    content = this.$inputor.val();
    caretPos = this.$inputor.caret('pos', {
      iframe: this.app.iframe
    });
    subtext = content.slice(0, caretPos);
    query = this.callbacks("matcher").call(this, this.at, subtext, this.getOpt('startWithSpace'), this.getOpt("acceptSpaceBar"));
    isString = typeof query === 'string';
    if (isString && query.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString && query.length <= this.getOpt('maxLen', 20)) {
      start = caretPos - query.length;
      end = start + query.length;
      this.pos = start;
      query = {
        'text': query,
        'headPos': start,
        'endPos': end
      };
      this.trigger("matched", [this.at, query.text]);
    } else {
      query = null;
      this.view.hide();
    }
    return this.query = query;
  };

  TextareaController.prototype.rect = function() {
    var c, iframeOffset, scaleBottom;
    if (!(c = this.$inputor.caret('offset', this.pos - 1, {
      iframe: this.app.iframe
    }))) {
      return;
    }
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = $(this.app.iframe).offset();
      c.left += iframeOffset.left;
      c.top += iframeOffset.top;
    }
    scaleBottom = this.app.document.selection ? 0 : 2;
    return {
      left: c.left,
      top: c.top,
      bottom: c.top + c.height + scaleBottom
    };
  };

  TextareaController.prototype.insert = function(content, $li) {
    var $inputor, source, startStr, suffix, text;
    $inputor = this.$inputor;
    source = $inputor.val();
    startStr = source.slice(0, Math.max(this.query.headPos - this.at.length, 0));
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || " ";
    content += suffix;
    text = "" + startStr + content + (source.slice(this.query['endPos'] || 0));
    $inputor.val(text);
    $inputor.caret('pos', startStr.length + content.length, {
      iframe: this.app.iframe
    });
    if (!$inputor.is(':focus')) {
      $inputor.focus();
    }
    return $inputor.change();
  };

  return TextareaController;

})(Controller);

var EditableController,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EditableController = (function(superClass) {
  extend(EditableController, superClass);

  function EditableController() {
    return EditableController.__super__.constructor.apply(this, arguments);
  }

  EditableController.prototype._getRange = function() {
    var sel;
    sel = this.app.window.getSelection();
    if (sel.rangeCount > 0) {
      return sel.getRangeAt(0);
    }
  };

  EditableController.prototype._setRange = function(position, node, range) {
    if (range == null) {
      range = this._getRange();
    }
    if (!range) {
      return;
    }
    node = $(node)[0];
    if (position === 'after') {
      range.setEndAfter(node);
      range.setStartAfter(node);
    } else {
      range.setEndBefore(node);
      range.setStartBefore(node);
    }
    range.collapse(false);
    return this._clearRange(range);
  };

  EditableController.prototype._clearRange = function(range) {
    var sel;
    if (range == null) {
      range = this._getRange();
    }
    sel = this.app.window.getSelection();
    if (this.ctrl_a_pressed == null) {
      sel.removeAllRanges();
      return sel.addRange(range);
    }
  };

  EditableController.prototype._movingEvent = function(e) {
    var ref;
    return e.type === 'click' || ((ref = e.which) === KEY_CODE.RIGHT || ref === KEY_CODE.LEFT || ref === KEY_CODE.UP || ref === KEY_CODE.DOWN);
  };

  EditableController.prototype._unwrap = function(node) {
    var next;
    node = $(node).unwrap().get(0);
    if ((next = node.nextSibling) && next.nodeValue) {
      node.nodeValue += next.nodeValue;
      $(next).remove();
    }
    return node;
  };

  EditableController.prototype.catchQuery = function(e) {
    var $inserted, $query, _range, index, inserted, isString, lastNode, matched, offset, query, query_content, range;
    if (!(range = this._getRange())) {
      return;
    }
    if (!range.collapsed) {
      return;
    }
    if (e.which === KEY_CODE.ENTER) {
      ($query = $(range.startContainer).closest('.atwho-query')).contents().unwrap();
      if ($query.is(':empty')) {
        $query.remove();
      }
      ($query = $(".atwho-query", this.app.document)).text($query.text()).contents().last().unwrap();
      this._clearRange();
      return;
    }
    if (/firefox/i.test(navigator.userAgent)) {
      if ($(range.startContainer).is(this.$inputor)) {
        this._clearRange();
        return;
      }
      if (e.which === KEY_CODE.BACKSPACE && range.startContainer.nodeType === document.ELEMENT_NODE && (offset = range.startOffset - 1) >= 0) {
        _range = range.cloneRange();
        _range.setStart(range.startContainer, offset);
        if ($(_range.cloneContents()).contents().last().is('.atwho-inserted')) {
          inserted = $(range.startContainer).contents().get(offset);
          this._setRange('after', $(inserted).contents().last());
        }
      } else if (e.which === KEY_CODE.LEFT && range.startContainer.nodeType === document.TEXT_NODE) {
        $inserted = $(range.startContainer.previousSibling);
        if ($inserted.is('.atwho-inserted') && range.startOffset === 0) {
          this._setRange('after', $inserted.contents().last());
        }
      }
    }
    $(range.startContainer).closest('.atwho-inserted').addClass('atwho-query').siblings().removeClass('atwho-query');
    if (($query = $(".atwho-query", this.app.document)).length > 0 && $query.is(':empty') && $query.text().length === 0) {
      $query.remove();
    }
    if (!this._movingEvent(e)) {
      $query.removeClass('atwho-inserted');
    }
    if ($query.length > 0) {
      switch (e.which) {
        case KEY_CODE.LEFT:
          this._setRange('before', $query.get(0), range);
          $query.removeClass('atwho-query');
          return;
        case KEY_CODE.RIGHT:
          this._setRange('after', $query.get(0).nextSibling, range);
          $query.removeClass('atwho-query');
          return;
      }
    }
    if ($query.length > 0 && (query_content = $query.attr('data-atwho-at-query'))) {
      $query.empty().html(query_content).attr('data-atwho-at-query', null);
      this._setRange('after', $query.get(0), range);
    }
    _range = range.cloneRange();
    _range.setStart(range.startContainer, 0);
    matched = this.callbacks("matcher").call(this, this.at, _range.toString(), this.getOpt('startWithSpace'), this.getOpt("acceptSpaceBar"));
    isString = typeof matched === 'string';
    if ($query.length === 0 && isString && (index = range.startOffset - this.at.length - matched.length) >= 0) {
      range.setStart(range.startContainer, index);
      $query = $('<span/>', this.app.document).attr(this.getOpt("editableAtwhoQueryAttrs")).addClass('atwho-query');
      range.surroundContents($query.get(0));
      lastNode = $query.contents().last().get(0);
      if (/firefox/i.test(navigator.userAgent)) {
        range.setStart(lastNode, lastNode.length);
        range.setEnd(lastNode, lastNode.length);
        this._clearRange(range);
      } else {
        this._setRange('after', lastNode, range);
      }
    }
    if (isString && matched.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString && matched.length <= this.getOpt('maxLen', 20)) {
      query = {
        text: matched,
        el: $query
      };
      this.trigger("matched", [this.at, query.text]);
      return this.query = query;
    } else {
      this.view.hide();
      this.query = {
        el: $query
      };
      if ($query.text().indexOf(this.at) >= 0) {
        if (this._movingEvent(e) && $query.hasClass('atwho-inserted')) {
          $query.removeClass('atwho-query');
        } else if (false !== this.callbacks('afterMatchFailed').call(this, this.at, $query)) {
          this._setRange("after", this._unwrap($query.text($query.text()).contents().first()));
        }
      }
      return null;
    }
  };

  EditableController.prototype.rect = function() {
    var $iframe, iframeOffset, rect;
    rect = this.query.el.offset();
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = ($iframe = $(this.app.iframe)).offset();
      rect.left += iframeOffset.left - this.$inputor.scrollLeft();
      rect.top += iframeOffset.top - this.$inputor.scrollTop();
    }
    rect.bottom = rect.top + this.query.el.height();
    return rect;
  };

  EditableController.prototype.insert = function(content, $li) {
    var data, range, suffix, suffixNode;
    if (!this.$inputor.is(':focus')) {
      this.$inputor.focus();
    }
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || "\u00A0";
    data = $li.data('item-data');
    this.query.el.removeClass('atwho-query').addClass('atwho-inserted').html(content).attr('data-atwho-at-query', "" + data['atwho-at'] + this.query.text);
    if (range = this._getRange()) {
      range.setEndAfter(this.query.el[0]);
      range.collapse(false);
      range.insertNode(suffixNode = this.app.document.createTextNode("\u200D" + suffix));
      this._setRange('after', suffixNode, range);
    }
    if (!this.$inputor.is(':focus')) {
      this.$inputor.focus();
    }
    return this.$inputor.change();
  };

  return EditableController;

})(Controller);

var Model;

Model = (function() {
  function Model(context) {
    this.context = context;
    this.at = this.context.at;
    this.storage = this.context.$inputor;
  }

  Model.prototype.destroy = function() {
    return this.storage.data(this.at, null);
  };

  Model.prototype.saved = function() {
    return this.fetch() > 0;
  };

  Model.prototype.query = function(query, callback) {
    var _remoteFilter, data, searchKey;
    data = this.fetch();
    searchKey = this.context.getOpt("searchKey");
    data = this.context.callbacks('filter').call(this.context, query, data, searchKey) || [];
    _remoteFilter = this.context.callbacks('remoteFilter');
    if (data.length > 0 || (!_remoteFilter && data.length === 0)) {
      return callback(data);
    } else {
      return _remoteFilter.call(this.context, query, callback);
    }
  };

  Model.prototype.fetch = function() {
    return this.storage.data(this.at) || [];
  };

  Model.prototype.save = function(data) {
    return this.storage.data(this.at, this.context.callbacks("beforeSave").call(this.context, data || []));
  };

  Model.prototype.load = function(data) {
    if (!(this.saved() || !data)) {
      return this._load(data);
    }
  };

  Model.prototype.reload = function(data) {
    return this._load(data);
  };

  Model.prototype._load = function(data) {
    if (typeof data === "string") {
      return $.ajax(data, {
        dataType: "json"
      }).done((function(_this) {
        return function(data) {
          return _this.save(data);
        };
      })(this));
    } else {
      return this.save(data);
    }
  };

  return Model;

})();

var View;

View = (function() {
  function View(context) {
    this.context = context;
    this.$el = $("<div class='atwho-view'><ul class='atwho-view-ul'></ul></div>");
    this.$elUl = this.$el.children();
    this.timeoutID = null;
    this.context.$el.append(this.$el);
    this.bindEvent();
  }

  View.prototype.init = function() {
    var header_tpl, id;
    id = this.context.getOpt("alias") || this.context.at.charCodeAt(0);
    header_tpl = this.context.getOpt("headerTpl");
    if (header_tpl && this.$el.children().length === 1) {
      this.$el.prepend(header_tpl);
    }
    return this.$el.attr({
      'id': "at-view-" + id
    });
  };

  View.prototype.destroy = function() {
    return this.$el.remove();
  };

  View.prototype.bindEvent = function() {
    var $menu, lastCoordX, lastCoordY;
    $menu = this.$el.find('ul');
    lastCoordX = 0;
    lastCoordY = 0;
    return $menu.on('mousemove.atwho-view', 'li', (function(_this) {
      return function(e) {
        var $cur;
        if (lastCoordX === e.clientX && lastCoordY === e.clientY) {
          return;
        }
        lastCoordX = e.clientX;
        lastCoordY = e.clientY;
        $cur = $(e.currentTarget);
        if ($cur.hasClass('cur')) {
          return;
        }
        $menu.find('.cur').removeClass('cur');
        return $cur.addClass('cur');
      };
    })(this)).on('click.atwho-view', 'li', (function(_this) {
      return function(e) {
        $menu.find('.cur').removeClass('cur');
        $(e.currentTarget).addClass('cur');
        _this.choose(e);
        return e.preventDefault();
      };
    })(this));
  };

  View.prototype.visible = function() {
    return this.$el.is(":visible");
  };

  View.prototype.highlighted = function() {
    return this.$el.find(".cur").length > 0;
  };

  View.prototype.choose = function(e) {
    var $li, content;
    if (($li = this.$el.find(".cur")).length) {
      content = this.context.insertContentFor($li);
      this.context._stopDelayedCall();
      this.context.insert(this.context.callbacks("beforeInsert").call(this.context, content, $li, e), $li);
      this.context.trigger("inserted", [$li, e]);
      this.hide(e);
    }
    if (this.context.getOpt("hideWithoutSuffix")) {
      return this.stopShowing = true;
    }
  };

  View.prototype.reposition = function(rect) {
    var _window, offset, overflowOffset, ref;
    _window = this.context.app.iframeAsRoot ? this.context.app.window : window;
    if (rect.bottom + this.$el.height() - $(_window).scrollTop() > $(_window).height()) {
      rect.bottom = rect.top - this.$el.height();
    }
    if (rect.left > (overflowOffset = $(_window).width() - this.$el.width() - 5)) {
      rect.left = overflowOffset;
    }
    offset = {
      left: rect.left,
      top: rect.bottom
    };
    if ((ref = this.context.callbacks("beforeReposition")) != null) {
      ref.call(this.context, offset);
    }
    this.$el.offset(offset);
    return this.context.trigger("reposition", [offset]);
  };

  View.prototype.next = function() {
    var cur, next, nextEl, offset;
    cur = this.$el.find('.cur').removeClass('cur');
    next = cur.next();
    if (!next.length) {
      next = this.$el.find('li:first');
    }
    next.addClass('cur');
    nextEl = next[0];
    offset = nextEl.offsetTop + nextEl.offsetHeight + (nextEl.nextSibling ? nextEl.nextSibling.offsetHeight : 0);
    return this.scrollTop(Math.max(0, offset - this.$el.height()));
  };

  View.prototype.prev = function() {
    var cur, offset, prev, prevEl;
    cur = this.$el.find('.cur').removeClass('cur');
    prev = cur.prev();
    if (!prev.length) {
      prev = this.$el.find('li:last');
    }
    prev.addClass('cur');
    prevEl = prev[0];
    offset = prevEl.offsetTop + prevEl.offsetHeight + (prevEl.nextSibling ? prevEl.nextSibling.offsetHeight : 0);
    return this.scrollTop(Math.max(0, offset - this.$el.height()));
  };

  View.prototype.scrollTop = function(scrollTop) {
    var scrollDuration;
    scrollDuration = this.context.getOpt('scrollDuration');
    if (scrollDuration) {
      return this.$elUl.animate({
        scrollTop: scrollTop
      }, scrollDuration);
    } else {
      return this.$elUl.scrollTop(scrollTop);
    }
  };

  View.prototype.show = function() {
    var rect;
    if (this.stopShowing) {
      this.stopShowing = false;
      return;
    }
    if (!this.visible()) {
      this.$el.show();
      this.$el.scrollTop(0);
      this.context.trigger('shown');
    }
    if (rect = this.context.rect()) {
      return this.reposition(rect);
    }
  };

  View.prototype.hide = function(e, time) {
    var callback;
    if (!this.visible()) {
      return;
    }
    if (isNaN(time)) {
      this.$el.hide();
      return this.context.trigger('hidden', [e]);
    } else {
      callback = (function(_this) {
        return function() {
          return _this.hide();
        };
      })(this);
      clearTimeout(this.timeoutID);
      return this.timeoutID = setTimeout(callback, time);
    }
  };

  View.prototype.render = function(list) {
    var $li, $ul, i, item, len, li, tpl;
    if (!($.isArray(list) && list.length > 0)) {
      this.hide();
      return;
    }
    this.$el.find('ul').empty();
    $ul = this.$el.find('ul');
    tpl = this.context.getOpt('displayTpl');
    for (i = 0, len = list.length; i < len; i++) {
      item = list[i];
      item = $.extend({}, item, {
        'atwho-at': this.context.at
      });
      li = this.context.callbacks("tplEval").call(this.context, tpl, item, "onDisplay");
      $li = $(this.context.callbacks("highlighter").call(this.context, li, this.context.query.text));
      $li.data("item-data", item);
      $ul.append($li);
    }
    this.show();
    if (this.context.getOpt('highlightFirst')) {
      return $ul.find("li:first").addClass("cur");
    }
  };

  return View;

})();

var Api;

Api = {
  load: function(at, data) {
    var c;
    if (c = this.controller(at)) {
      return c.model.load(data);
    }
  },
  isSelecting: function() {
    var ref;
    return !!((ref = this.controller()) != null ? ref.view.visible() : void 0);
  },
  hide: function() {
    var ref;
    return (ref = this.controller()) != null ? ref.view.hide() : void 0;
  },
  reposition: function() {
    var c;
    if (c = this.controller()) {
      return c.view.reposition(c.rect());
    }
  },
  setIframe: function(iframe, asRoot) {
    this.setupRootElement(iframe, asRoot);
    return null;
  },
  run: function() {
    return this.dispatch();
  },
  destroy: function() {
    this.shutdown();
    return this.$inputor.data('atwho', null);
  }
};

$.fn.atwho = function(method) {
  var _args, result;
  _args = arguments;
  result = null;
  this.filter('textarea, input, [contenteditable=""], [contenteditable=true]').each(function() {
    var $this, app;
    if (!(app = ($this = $(this)).data("atwho"))) {
      $this.data('atwho', (app = new App(this)));
    }
    if (typeof method === 'object' || !method) {
      return app.reg(method.at, method);
    } else if (Api[method] && app) {
      return result = Api[method].apply(app, Array.prototype.slice.call(_args, 1));
    } else {
      return $.error("Method " + method + " does not exist on jQuery.atwho");
    }
  });
  if (result != null) {
    return result;
  } else {
    return this;
  }
};

$.fn.atwho["default"] = {
  at: void 0,
  alias: void 0,
  data: null,
  displayTpl: "<li>${name}</li>",
  insertTpl: "${atwho-at}${name}",
  headerTpl: null,
  callbacks: DEFAULT_CALLBACKS,
  searchKey: "name",
  suffix: void 0,
  hideWithoutSuffix: false,
  startWithSpace: true,
  acceptSpaceBar: false,
  highlightFirst: true,
  limit: 5,
  maxLen: 20,
  minLen: 0,
  displayTimeout: 300,
  delay: null,
  spaceSelectsMatch: false,
  tabSelectsMatch: true,
  editableAtwhoQueryAttrs: {},
  scrollDuration: 150,
  suspendOnComposing: true,
  lookUpOnClick: true
};

$.fn.atwho.debug = false;

}));

}.call(window));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
      return (root.returnExportsGlobal = factory($));
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function ($) {

/*
  Implement Github like autocomplete mentions
  http://ichord.github.com/At.js

  Copyright (c) 2013 chord.luo@gmail.com
  Licensed under the MIT license.
*/

/*
本插件操作 textarea 或者 input 内的插入符
只实现了获得插入符在文本框中的位置，我设置
插入符的位置.
*/

"use strict";
var EditableCaret, InputCaret, Mirror, Utils, discoveryIframeOf, methods, oDocument, oFrame, oWindow, pluginName, setContextBy;

pluginName = 'caret';

EditableCaret = (function() {
  function EditableCaret($inputor) {
    this.$inputor = $inputor;
    this.domInputor = this.$inputor[0];
  }

  EditableCaret.prototype.setPos = function(pos) {
    var fn, found, offset, sel;
    if (sel = oWindow.getSelection()) {
      offset = 0;
      found = false;
      (fn = function(pos, parent) {
        var node, range, _i, _len, _ref, _results;
        _ref = parent.childNodes;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          node = _ref[_i];
          if (found) {
            break;
          }
          if (node.nodeType === 3) {
            if (offset + node.length >= pos) {
              found = true;
              range = oDocument.createRange();
              range.setStart(node, pos - offset);
              sel.removeAllRanges();
              sel.addRange(range);
              break;
            } else {
              _results.push(offset += node.length);
            }
          } else {
            _results.push(fn(pos, node));
          }
        }
        return _results;
      })(pos, this.domInputor);
    }
    return this.domInputor;
  };

  EditableCaret.prototype.getIEPosition = function() {
    return this.getPosition();
  };

  EditableCaret.prototype.getPosition = function() {
    var inputor_offset, offset;
    offset = this.getOffset();
    inputor_offset = this.$inputor.offset();
    offset.left -= inputor_offset.left;
    offset.top -= inputor_offset.top;
    return offset;
  };

  EditableCaret.prototype.getOldIEPos = function() {
    var preCaretTextRange, textRange;
    textRange = oDocument.selection.createRange();
    preCaretTextRange = oDocument.body.createTextRange();
    preCaretTextRange.moveToElementText(this.domInputor);
    preCaretTextRange.setEndPoint("EndToEnd", textRange);
    return preCaretTextRange.text.length;
  };

  EditableCaret.prototype.getPos = function() {
    var clonedRange, pos, range;
    if (range = this.range()) {
      clonedRange = range.cloneRange();
      clonedRange.selectNodeContents(this.domInputor);
      clonedRange.setEnd(range.endContainer, range.endOffset);
      pos = clonedRange.toString().length;
      clonedRange.detach();
      return pos;
    } else if (oDocument.selection) {
      return this.getOldIEPos();
    }
  };

  EditableCaret.prototype.getOldIEOffset = function() {
    var range, rect;
    range = oDocument.selection.createRange().duplicate();
    range.moveStart("character", -1);
    rect = range.getBoundingClientRect();
    return {
      height: rect.bottom - rect.top,
      left: rect.left,
      top: rect.top
    };
  };

  EditableCaret.prototype.getOffset = function(pos) {
    var clonedRange, offset, range, rect, shadowCaret;
    if (oWindow.getSelection && (range = this.range())) {
      if (range.endOffset - 1 > 0 && range.endContainer !== this.domInputor) {
        clonedRange = range.cloneRange();
        clonedRange.setStart(range.endContainer, range.endOffset - 1);
        clonedRange.setEnd(range.endContainer, range.endOffset);
        rect = clonedRange.getBoundingClientRect();
        offset = {
          height: rect.height,
          left: rect.left + rect.width,
          top: rect.top
        };
        clonedRange.detach();
      }
      if (!offset || (offset != null ? offset.height : void 0) === 0) {
        clonedRange = range.cloneRange();
        shadowCaret = $(oDocument.createTextNode("|"));
        clonedRange.insertNode(shadowCaret[0]);
        clonedRange.selectNode(shadowCaret[0]);
        rect = clonedRange.getBoundingClientRect();
        offset = {
          height: rect.height,
          left: rect.left,
          top: rect.top
        };
        shadowCaret.remove();
        clonedRange.detach();
      }
    } else if (oDocument.selection) {
      offset = this.getOldIEOffset();
    }
    if (offset) {
      offset.top += $(oWindow).scrollTop();
      offset.left += $(oWindow).scrollLeft();
    }
    return offset;
  };

  EditableCaret.prototype.range = function() {
    var sel;
    if (!oWindow.getSelection) {
      return;
    }
    sel = oWindow.getSelection();
    if (sel.rangeCount > 0) {
      return sel.getRangeAt(0);
    } else {
      return null;
    }
  };

  return EditableCaret;

})();

InputCaret = (function() {
  function InputCaret($inputor) {
    this.$inputor = $inputor;
    this.domInputor = this.$inputor[0];
  }

  InputCaret.prototype.getIEPos = function() {
    var endRange, inputor, len, normalizedValue, pos, range, textInputRange;
    inputor = this.domInputor;
    range = oDocument.selection.createRange();
    pos = 0;
    if (range && range.parentElement() === inputor) {
      normalizedValue = inputor.value.replace(/\r\n/g, "\n");
      len = normalizedValue.length;
      textInputRange = inputor.createTextRange();
      textInputRange.moveToBookmark(range.getBookmark());
      endRange = inputor.createTextRange();
      endRange.collapse(false);
      if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
        pos = len;
      } else {
        pos = -textInputRange.moveStart("character", -len);
      }
    }
    return pos;
  };

  InputCaret.prototype.getPos = function() {
    if (oDocument.selection) {
      return this.getIEPos();
    } else {
      return this.domInputor.selectionStart;
    }
  };

  InputCaret.prototype.setPos = function(pos) {
    var inputor, range;
    inputor = this.domInputor;
    if (oDocument.selection) {
      range = inputor.createTextRange();
      range.move("character", pos);
      range.select();
    } else if (inputor.setSelectionRange) {
      inputor.setSelectionRange(pos, pos);
    }
    return inputor;
  };

  InputCaret.prototype.getIEOffset = function(pos) {
    var h, textRange, x, y;
    textRange = this.domInputor.createTextRange();
    pos || (pos = this.getPos());
    textRange.move('character', pos);
    x = textRange.boundingLeft;
    y = textRange.boundingTop;
    h = textRange.boundingHeight;
    return {
      left: x,
      top: y,
      height: h
    };
  };

  InputCaret.prototype.getOffset = function(pos) {
    var $inputor, offset, position;
    $inputor = this.$inputor;
    if (oDocument.selection) {
      offset = this.getIEOffset(pos);
      offset.top += $(oWindow).scrollTop() + $inputor.scrollTop();
      offset.left += $(oWindow).scrollLeft() + $inputor.scrollLeft();
      return offset;
    } else {
      offset = $inputor.offset();
      position = this.getPosition(pos);
      return offset = {
        left: offset.left + position.left - $inputor.scrollLeft(),
        top: offset.top + position.top - $inputor.scrollTop(),
        height: position.height
      };
    }
  };

  InputCaret.prototype.getPosition = function(pos) {
    var $inputor, at_rect, end_range, format, html, mirror, start_range;
    $inputor = this.$inputor;
    format = function(value) {
      value = value.replace(/<|>|`|"|&/g, '?').replace(/\r\n|\r|\n/g, "<br/>");
      if (/firefox/i.test(navigator.userAgent)) {
        value = value.replace(/\s/g, '&nbsp;');
      }
      return value;
    };
    if (pos === void 0) {
      pos = this.getPos();
    }
    start_range = $inputor.val().slice(0, pos);
    end_range = $inputor.val().slice(pos);
    html = "<span style='position: relative; display: inline;'>" + format(start_range) + "</span>";
    html += "<span id='caret' style='position: relative; display: inline;'>|</span>";
    html += "<span style='position: relative; display: inline;'>" + format(end_range) + "</span>";
    mirror = new Mirror($inputor);
    return at_rect = mirror.create(html).rect();
  };

  InputCaret.prototype.getIEPosition = function(pos) {
    var h, inputorOffset, offset, x, y;
    offset = this.getIEOffset(pos);
    inputorOffset = this.$inputor.offset();
    x = offset.left - inputorOffset.left;
    y = offset.top - inputorOffset.top;
    h = offset.height;
    return {
      left: x,
      top: y,
      height: h
    };
  };

  return InputCaret;

})();

Mirror = (function() {
  Mirror.prototype.css_attr = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontWeight", "height", "letterSpacing", "lineHeight", "marginBottom", "marginLeft", "marginRight", "marginTop", "outlineWidth", "overflow", "overflowX", "overflowY", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "textAlign", "textOverflow", "textTransform", "whiteSpace", "wordBreak", "wordWrap"];

  function Mirror($inputor) {
    this.$inputor = $inputor;
  }

  Mirror.prototype.mirrorCss = function() {
    var css,
      _this = this;
    css = {
      position: 'absolute',
      left: -9999,
      top: 0,
      zIndex: -20000
    };
    if (this.$inputor.prop('tagName') === 'TEXTAREA') {
      this.css_attr.push('width');
    }
    $.each(this.css_attr, function(i, p) {
      return css[p] = _this.$inputor.css(p);
    });
    return css;
  };

  Mirror.prototype.create = function(html) {
    this.$mirror = $('<div></div>');
    this.$mirror.css(this.mirrorCss());
    this.$mirror.html(html);
    this.$inputor.after(this.$mirror);
    return this;
  };

  Mirror.prototype.rect = function() {
    var $flag, pos, rect;
    $flag = this.$mirror.find("#caret");
    pos = $flag.position();
    rect = {
      left: pos.left,
      top: pos.top,
      height: $flag.height()
    };
    this.$mirror.remove();
    return rect;
  };

  return Mirror;

})();

Utils = {
  contentEditable: function($inputor) {
    return !!($inputor[0].contentEditable && $inputor[0].contentEditable === 'true');
  }
};

methods = {
  pos: function(pos) {
    if (pos || pos === 0) {
      return this.setPos(pos);
    } else {
      return this.getPos();
    }
  },
  position: function(pos) {
    if (oDocument.selection) {
      return this.getIEPosition(pos);
    } else {
      return this.getPosition(pos);
    }
  },
  offset: function(pos) {
    var offset;
    offset = this.getOffset(pos);
    return offset;
  }
};

oDocument = null;

oWindow = null;

oFrame = null;

setContextBy = function(settings) {
  var iframe;
  if (iframe = settings != null ? settings.iframe : void 0) {
    oFrame = iframe;
    oWindow = iframe.contentWindow;
    return oDocument = iframe.contentDocument || oWindow.document;
  } else {
    oFrame = void 0;
    oWindow = window;
    return oDocument = document;
  }
};

discoveryIframeOf = function($dom) {
  var error;
  oDocument = $dom[0].ownerDocument;
  oWindow = oDocument.defaultView || oDocument.parentWindow;
  try {
    return oFrame = oWindow.frameElement;
  } catch (_error) {
    error = _error;
  }
};

$.fn.caret = function(method, value, settings) {
  var caret;
  if (methods[method]) {
    if ($.isPlainObject(value)) {
      setContextBy(value);
      value = void 0;
    } else {
      setContextBy(settings);
    }
    caret = Utils.contentEditable(this) ? new EditableCaret(this) : new InputCaret(this);
    return methods[method].apply(caret, [value]);
  } else {
    return $.error("Method " + method + " does not exist on jQuery.caret");
  }
};

$.fn.caret.EditableCaret = EditableCaret;

$.fn.caret.InputCaret = InputCaret;

$.fn.caret.Utils = Utils;

$.fn.caret.apis = methods;


}));

}.call(window));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/* jquery.nicescroll
-- version 3.6.0
-- copyright 2014-11-21 InuYaksa*2014
-- licensed under the MIT
--
-- http://nicescroll.areaaperta.com/
-- https://github.com/inuyaksa/jquery.nicescroll
--
*/

(function(factory) {
  if (true) {
    // AMD. Register as anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals.
    factory(jQuery);
  }
}(function(jQuery) {
  "use strict";

  // globals
  var domfocus = false;
  var mousefocus = false;
  var tabindexcounter = 0;
  var ascrailcounter = 2000;
  var globalmaxzindex = 0;

  var $ = jQuery; // sandbox

  // http://stackoverflow.com/questions/2161159/get-script-path
  function getScriptPath() {
    var scripts = document.getElementsByTagName('script');
    var path = scripts[scripts.length - 1].src.split('?')[0];
    return (path.split('/').length > 0) ? path.split('/').slice(0, -1).join('/') + '/' : '';
  }

  var vendors = ['webkit','ms','moz','o'];

  var setAnimationFrame = window.requestAnimationFrame || false;
  var clearAnimationFrame = window.cancelAnimationFrame || false;

  if (!setAnimationFrame) {  // legacy detection
    for (var vx in vendors) {
      var v = vendors[vx];
      if (!setAnimationFrame) setAnimationFrame = window[v + 'RequestAnimationFrame'];
      if (!clearAnimationFrame) clearAnimationFrame = window[v + 'CancelAnimationFrame'] || window[v + 'CancelRequestAnimationFrame'];
    }
  }

  var ClsMutationObserver = window.MutationObserver || window.WebKitMutationObserver || false;

  var _globaloptions = {
    zindex: "auto",
    cursoropacitymin: 0,
    cursoropacitymax: 1,
    cursorcolor: "#424242",
    cursorwidth: "5px",
    cursorborder: "1px solid #fff",
    cursorborderradius: "5px",
    scrollspeed: 60,
    mousescrollstep: 8 * 3,
    touchbehavior: false,
    hwacceleration: true,
    usetransition: true,
    boxzoom: false,
    dblclickzoom: true,
    gesturezoom: true,
    grabcursorenabled: true,
    autohidemode: true,
    background: "",
    iframeautoresize: true,
    cursorminheight: 32,
    preservenativescrolling: true,
    railoffset: false,
    railhoffset: false,
    bouncescroll: true,
    spacebarenabled: true,
    railpadding: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    },
    disableoutline: true,
    horizrailenabled: true,
    railalign: "right",
    railvalign: "bottom",
    enabletranslate3d: true,
    enablemousewheel: true,
    enablekeyboard: true,
    smoothscroll: true,
    sensitiverail: true,
    enablemouselockapi: true,
    //      cursormaxheight:false,
    cursorfixedheight: false,
    directionlockdeadzone: 6,
    hidecursordelay: 400,
    nativeparentscrolling: true,
    enablescrollonselection: true,
    overflowx: true,
    overflowy: true,
    cursordragspeed: 0.3,
    rtlmode: "auto",
    cursordragontouch: false,
    oneaxismousemode: "auto",
    scriptpath: getScriptPath(),
    preventmultitouchscrolling: true
  };

  var browserdetected = false;

  var getBrowserDetection = function() {

    if (browserdetected) return browserdetected;

    var _el = document.createElement('DIV'),
        _style = _el.style,
        _agent = navigator.userAgent,
        _platform = navigator.platform,
        d = {};

    d.haspointerlock = "pointerLockElement" in document || "webkitPointerLockElement" in document || "mozPointerLockElement" in document;

    d.isopera = ("opera" in window); // 12-
    d.isopera12 = (d.isopera && ("getUserMedia" in navigator));
    d.isoperamini = (Object.prototype.toString.call(window.operamini) === "[object OperaMini]");

    d.isie = (("all" in document) && ("attachEvent" in _el) && !d.isopera); //IE10-
    d.isieold = (d.isie && !("msInterpolationMode" in _style)); // IE6 and older
    d.isie7 = d.isie && !d.isieold && (!("documentMode" in document) || (document.documentMode == 7));
    d.isie8 = d.isie && ("documentMode" in document) && (document.documentMode == 8);
    d.isie9 = d.isie && ("performance" in window) && (document.documentMode >= 9);
    d.isie10 = d.isie && ("performance" in window) && (document.documentMode == 10);
    d.isie11 = ("msRequestFullscreen" in _el) && (document.documentMode >= 11); // IE11+

    d.isie9mobile = /iemobile.9/i.test(_agent); //wp 7.1 mango
    if (d.isie9mobile) d.isie9 = false;
    d.isie7mobile = (!d.isie9mobile && d.isie7) && /iemobile/i.test(_agent); //wp 7.0

    d.ismozilla = ("MozAppearance" in _style);

    d.iswebkit = ("WebkitAppearance" in _style);

    d.ischrome = ("chrome" in window);
    d.ischrome22 = (d.ischrome && d.haspointerlock);
    d.ischrome26 = (d.ischrome && ("transition" in _style)); // issue with transform detection (maintain prefix)

    d.cantouch = ("ontouchstart" in document.documentElement) || ("ontouchstart" in window); // detection for Chrome Touch Emulation
    d.hasmstouch = (window.MSPointerEvent || false); // IE10 pointer events
    d.hasw3ctouch = (window.PointerEvent || false); //IE11 pointer events, following W3C Pointer Events spec

    d.ismac = /^mac$/i.test(_platform);

    d.isios = (d.cantouch && /iphone|ipad|ipod/i.test(_platform));
    d.isios4 = ((d.isios) && !("seal" in Object));
    d.isios7 = ((d.isios)&&("webkitHidden" in document));  //iOS 7+

    d.isandroid = (/android/i.test(_agent));

    d.haseventlistener = ("addEventListener" in _el);
    
    d.trstyle = false;
    d.hastransform = false;
    d.hastranslate3d = false;
    d.transitionstyle = false;
    d.hastransition = false;
    d.transitionend = false;

    var a;
    var check = ['transform', 'msTransform', 'webkitTransform', 'MozTransform', 'OTransform'];    
    for (a = 0; a < check.length; a++) {
      if (typeof _style[check[a]] != "undefined") {
        d.trstyle = check[a];
        break;
      }
    }
    d.hastransform = (!!d.trstyle);
    if (d.hastransform) {
      _style[d.trstyle] = "translate3d(1px,2px,3px)";
      d.hastranslate3d = /translate3d/.test(_style[d.trstyle]);
    }

    d.transitionstyle = false;
    d.prefixstyle = '';
    d.transitionend = false;
    check = ['transition', 'webkitTransition', 'msTransition', 'MozTransition', 'OTransition', 'OTransition', 'KhtmlTransition'];
    var prefix = ['', '-webkit-', '-ms-', '-moz-', '-o-', '-o', '-khtml-'];
    var evs = ['transitionend', 'webkitTransitionEnd', 'msTransitionEnd',  'transitionend', 'otransitionend', 'oTransitionEnd', 'KhtmlTransitionEnd'];
    for (a = 0; a < check.length; a++) {
      if (check[a] in _style) {
        d.transitionstyle = check[a];
        d.prefixstyle = prefix[a];
        d.transitionend = evs[a];
        break;
      }
    }
    if (d.ischrome26) {  // always use prefix
      d.prefixstyle = prefix[1];
    }

    d.hastransition = (d.transitionstyle);

    function detectCursorGrab() {
      var lst = ['-webkit-grab', '-moz-grab', 'grab'];
      if ((d.ischrome && !d.ischrome22) || d.isie) lst = []; // force setting for IE returns false positive and chrome cursor bug
      for (var a = 0; a < lst.length; a++) {
        var p = lst[a];
        _style.cursor = p;
        if (_style.cursor == p) return p;
      }
      return 'url(//mail.google.com/mail/images/2/openhand.cur),n-resize'; // thank you google for custom cursor!
    }
    d.cursorgrabvalue = detectCursorGrab();

    d.hasmousecapture = ("setCapture" in _el);

    d.hasMutationObserver = (ClsMutationObserver !== false);

    _el = null; //memory released

    browserdetected = d;

    return d;
  };

  var NiceScrollClass = function(myopt, me) {

    var self = this;

    this.version = '3.6.0';
    this.name = 'nicescroll';

    this.me = me;

    this.opt = {
      doc: $("body"),
      win: false
    };

    $.extend(this.opt, _globaloptions);  // clone opts

    // Options for internal use
    this.opt.snapbackspeed = 80;

    if (myopt || false) {
      for (var a in self.opt) {
        if (typeof myopt[a] != "undefined") self.opt[a] = myopt[a];
      }
    }

    this.doc = self.opt.doc;
    this.iddoc = (this.doc && this.doc[0]) ? this.doc[0].id || '' : '';
    this.ispage = /^BODY|HTML/.test((self.opt.win) ? self.opt.win[0].nodeName : this.doc[0].nodeName);
    this.haswrapper = (self.opt.win !== false);
    this.win = self.opt.win || (this.ispage ? $(window) : this.doc);
    this.docscroll = (this.ispage && !this.haswrapper) ? $(window) : this.win;
    this.body = $("body");
    this.viewport = false;

    this.isfixed = false;

    this.iframe = false;
    this.isiframe = ((this.doc[0].nodeName == 'IFRAME') && (this.win[0].nodeName == 'IFRAME'));

    this.istextarea = (this.win[0].nodeName == 'TEXTAREA');

    this.forcescreen = false; //force to use screen position on events

    this.canshowonmouseevent = (self.opt.autohidemode != "scroll");

    // Events jump table    
    this.onmousedown = false;
    this.onmouseup = false;
    this.onmousemove = false;
    this.onmousewheel = false;
    this.onkeypress = false;
    this.ongesturezoom = false;
    this.onclick = false;

    // Nicescroll custom events
    this.onscrollstart = false;
    this.onscrollend = false;
    this.onscrollcancel = false;

    this.onzoomin = false;
    this.onzoomout = false;

    // Let's start!  
    this.view = false;
    this.page = false;

    this.scroll = {
      x: 0,
      y: 0
    };
    this.scrollratio = {
      x: 0,
      y: 0
    };
    this.cursorheight = 20;
    this.scrollvaluemax = 0;

    this.isrtlmode = (this.opt.rtlmode == "auto") ? ((this.win[0] == window ? this.body : this.win).css("direction") == "rtl") : (this.opt.rtlmode === true);
    //    this.checkrtlmode = false;
    
    this.scrollrunning = false;

    this.scrollmom = false;

    this.observer        = false;  // observer div changes
    this.observerremover = false;  // observer on parent for remove detection
    this.observerbody    = false;  // observer on body for position change

    do {
      this.id = "ascrail" + (ascrailcounter++);
    } while (document.getElementById(this.id));

    this.rail = false;
    this.cursor = false;
    this.cursorfreezed = false;
    this.selectiondrag = false;

    this.zoom = false;
    this.zoomactive = false;

    this.hasfocus = false;
    this.hasmousefocus = false;

    this.visibility = true;
    this.railslocked = false;  // locked by resize
    this.locked = false;  // prevent lost of locked status sets by user
    this.hidden = false; // rails always hidden
    this.cursoractive = true; // user can interact with cursors

    this.wheelprevented = false; //prevent mousewheel event

    this.overflowx = self.opt.overflowx;
    this.overflowy = self.opt.overflowy;

    this.nativescrollingarea = false;
    this.checkarea = 0;

    this.events = []; // event list for unbind

    this.saved = {};  // style saved

    this.delaylist = {};
    this.synclist = {};

    this.lastdeltax = 0;
    this.lastdeltay = 0;

    this.detected = getBrowserDetection();

    var cap = $.extend({}, this.detected);

    this.canhwscroll = (cap.hastransform && self.opt.hwacceleration);
    this.ishwscroll = (this.canhwscroll && self.haswrapper);

    this.hasreversehr = (this.isrtlmode&&!cap.iswebkit);  //RTL mode with reverse horizontal axis
    
    this.istouchcapable = false; // desktop devices with touch screen support

    //## Check WebKit-based desktop with touch support
    //## + Firefox 18 nightly build (desktop) false positive (or desktop with touch support)
    if (cap.cantouch && !cap.isios && !cap.isandroid && (cap.iswebkit || cap.ismozilla)) {
      this.istouchcapable = true;
      cap.cantouch = false; // parse normal desktop events
    }

    //## disable MouseLock API on user request
    if (!self.opt.enablemouselockapi) {
      cap.hasmousecapture = false;
      cap.haspointerlock = false;
    }

/* deprecated
    this.delayed = function(name, fn, tm, lazy) {
    };
*/    

    this.debounced = function(name, fn, tm) {
      var dd = self.delaylist[name];
      self.delaylist[name] = fn;
      if (!dd) {
        setTimeout(function() {
          var fn = self.delaylist[name];
          self.delaylist[name] = false;
          fn.call(self);
        }, tm);
      }
    };

    var _onsync = false;

    this.synched = function(name, fn) {

      function requestSync() {
        if (_onsync) return;
        setAnimationFrame(function() {
          _onsync = false;
          for (var nn in self.synclist) {
            var fn = self.synclist[nn];
            if (fn) fn.call(self);
            self.synclist[nn] = false;
          }
        });
        _onsync = true;
      }

      self.synclist[name] = fn;
      requestSync();
      return name;
    };

    this.unsynched = function(name) {
      if (self.synclist[name]) self.synclist[name] = false;
    };

    this.css = function(el, pars) { // save & set
      for (var n in pars) {
        self.saved.css.push([el, n, el.css(n)]);
        el.css(n, pars[n]);
      }
    };

    this.scrollTop = function(val) {
      return (typeof val == "undefined") ? self.getScrollTop() : self.setScrollTop(val);
    };

    this.scrollLeft = function(val) {
      return (typeof val == "undefined") ? self.getScrollLeft() : self.setScrollLeft(val);
    };

    // derived by by Dan Pupius www.pupius.net
    var BezierClass = function(st, ed, spd, p1, p2, p3, p4) {
    
      this.st = st;
      this.ed = ed;
      this.spd = spd;

      this.p1 = p1 || 0;
      this.p2 = p2 || 1;
      this.p3 = p3 || 0;
      this.p4 = p4 || 1;

      this.ts = (new Date()).getTime();
      this.df = this.ed - this.st;
    };
    BezierClass.prototype = {
      B2: function(t) {
        return 3 * t * t * (1 - t);
      },
      B3: function(t) {
        return 3 * t * (1 - t) * (1 - t);
      },
      B4: function(t) {
        return (1 - t) * (1 - t) * (1 - t);
      },
      getNow: function() {
        var nw = (new Date()).getTime();
        var pc = 1 - ((nw - this.ts) / this.spd);
        var bz = this.B2(pc) + this.B3(pc) + this.B4(pc);
        return (pc < 0) ? this.ed : this.st + Math.round(this.df * bz);
      },
      update: function(ed, spd) {
        this.st = this.getNow();
        this.ed = ed;
        this.spd = spd;
        this.ts = (new Date()).getTime();
        this.df = this.ed - this.st;
        return this;
      }
    };

    //derived from http://stackoverflow.com/questions/11236090/
    function getMatrixValues() {
      var tr = self.doc.css(cap.trstyle);
      if (tr && (tr.substr(0, 6) == "matrix")) {
        return tr.replace(/^.*\((.*)\)$/g, "$1").replace(/px/g, '').split(/, +/);
      }
      return false;
    }

    if (this.ishwscroll) {
      // hw accelerated scroll
      this.doc.translate = {
        x: 0,
        y: 0,
        tx: "0px",
        ty: "0px"
      };

      //this one can help to enable hw accel on ios6 http://indiegamr.com/ios6-html-hardware-acceleration-changes-and-how-to-fix-them/
      if (cap.hastranslate3d && cap.isios) this.doc.css("-webkit-backface-visibility", "hidden"); // prevent flickering http://stackoverflow.com/questions/3461441/      

      this.getScrollTop = function(last) {
        if (!last) {
          var mtx = getMatrixValues();
          if (mtx) return (mtx.length == 16) ? -mtx[13] : -mtx[5]; //matrix3d 16 on IE10
          if (self.timerscroll && self.timerscroll.bz) return self.timerscroll.bz.getNow();
        }
        return self.doc.translate.y;
      };

      this.getScrollLeft = function(last) {
        if (!last) {
          var mtx = getMatrixValues();
          if (mtx) return (mtx.length == 16) ? -mtx[12] : -mtx[4]; //matrix3d 16 on IE10
          if (self.timerscroll && self.timerscroll.bh) return self.timerscroll.bh.getNow();
        }
        return self.doc.translate.x;
      };

      this.notifyScrollEvent = function(el) {
        var e = document.createEvent("UIEvents");
        e.initUIEvent("scroll", false, true, window, 1);
        e.niceevent = true;
        el.dispatchEvent(e);
      };

      var cxscrollleft = (this.isrtlmode) ? 1 : -1;

      if (cap.hastranslate3d && self.opt.enabletranslate3d) {
        this.setScrollTop = function(val, silent) {
          self.doc.translate.y = val;
          self.doc.translate.ty = (val * -1) + "px";
          self.doc.css(cap.trstyle, "translate3d(" + self.doc.translate.tx + "," + self.doc.translate.ty + ",0px)");
          if (!silent) self.notifyScrollEvent(self.win[0]);
        };
        this.setScrollLeft = function(val, silent) {
          self.doc.translate.x = val;
          self.doc.translate.tx = (val * cxscrollleft) + "px";
          self.doc.css(cap.trstyle, "translate3d(" + self.doc.translate.tx + "," + self.doc.translate.ty + ",0px)");
          if (!silent) self.notifyScrollEvent(self.win[0]);
        };
      } else {
        this.setScrollTop = function(val, silent) {
          self.doc.translate.y = val;
          self.doc.translate.ty = (val * -1) + "px";
          self.doc.css(cap.trstyle, "translate(" + self.doc.translate.tx + "," + self.doc.translate.ty + ")");
          if (!silent) self.notifyScrollEvent(self.win[0]);
        };
        this.setScrollLeft = function(val, silent) {
          self.doc.translate.x = val;
          self.doc.translate.tx = (val * cxscrollleft) + "px";
          self.doc.css(cap.trstyle, "translate(" + self.doc.translate.tx + "," + self.doc.translate.ty + ")");
          if (!silent) self.notifyScrollEvent(self.win[0]);
        };
      }
    } else {
      // native scroll
      this.getScrollTop = function() {
        return self.docscroll.scrollTop();
      };
      this.setScrollTop = function(val) {
        return self.docscroll.scrollTop(val);
      };
      this.getScrollLeft = function() {
        if (self.detected.ismozilla && self.isrtlmode)
          return Math.abs(self.docscroll.scrollLeft());
        return self.docscroll.scrollLeft();
      };
      this.setScrollLeft = function(val) {
        return self.docscroll.scrollLeft((self.detected.ismozilla && self.isrtlmode) ? -val : val);
      };
    }

    this.getTarget = function(e) {
      if (!e) return false;
      if (e.target) return e.target;
      if (e.srcElement) return e.srcElement;
      return false;
    };

    this.hasParent = function(e, id) {
      if (!e) return false;
      var el = e.target || e.srcElement || e || false;
      while (el && el.id != id) {
        el = el.parentNode || false;
      }
      return (el !== false);
    };

    function getZIndex() {
      var dom = self.win;
      if ("zIndex" in dom) return dom.zIndex(); // use jQuery UI method when available
      while (dom.length > 0) {
        if (dom[0].nodeType == 9) return false;
        var zi = dom.css('zIndex');
        if (!isNaN(zi) && zi != 0) return parseInt(zi);
        dom = dom.parent();
      }
      return false;
    }

    //inspired by http://forum.jquery.com/topic/width-includes-border-width-when-set-to-thin-medium-thick-in-ie
    var _convertBorderWidth = {
      "thin": 1,
      "medium": 3,
      "thick": 5
    };

    function getWidthToPixel(dom, prop, chkheight) {
      var wd = dom.css(prop);
      var px = parseFloat(wd);
      if (isNaN(px)) {
        px = _convertBorderWidth[wd] || 0;
        var brd = (px == 3) ? ((chkheight) ? (self.win.outerHeight() - self.win.innerHeight()) : (self.win.outerWidth() - self.win.innerWidth())) : 1; //DON'T TRUST CSS
        if (self.isie8 && px) px += 1;
        return (brd) ? px : 0;
      }
      return px;
    }

    this.getDocumentScrollOffset = function() {
      return {top:window.pageYOffset||document.documentElement.scrollTop,
              left:window.pageXOffset||document.documentElement.scrollLeft};
    }
    
    this.getOffset = function() {
      if (self.isfixed) {
        var ofs = self.win.offset();  // fix Chrome auto issue (when right/bottom props only)
        var scrl = self.getDocumentScrollOffset();
        ofs.top-=scrl.top;
        ofs.left-=scrl.left;
        return ofs;  
      }
      var ww = self.win.offset();
      if (!self.viewport) return ww;      
      var vp = self.viewport.offset();
      return {
        top: ww.top - vp.top,// + self.viewport.scrollTop(),
        left: ww.left - vp.left // + self.viewport.scrollLeft()
      };
    };

    this.updateScrollBar = function(len) {
      if (self.ishwscroll) {
        self.rail.css({  //**
          height: self.win.innerHeight() - (self.opt.railpadding.top + self.opt.railpadding.bottom)
        });
        if (self.railh) self.railh.css({  //**
          width: self.win.innerWidth() - (self.opt.railpadding.left + self.opt.railpadding.right)
        });
        
      } else {
        var wpos = self.getOffset();
        var pos = {
          top: wpos.top,
          left: wpos.left  - (self.opt.railpadding.left + self.opt.railpadding.right)
        };
        pos.top += getWidthToPixel(self.win, 'border-top-width', true);
        pos.left += (self.rail.align) ? self.win.outerWidth() - getWidthToPixel(self.win, 'border-right-width') - self.rail.width : getWidthToPixel(self.win, 'border-left-width');

        var off = self.opt.railoffset;
        if (off) {
          if (off.top) pos.top += off.top;
          if (self.rail.align && off.left) pos.left += off.left;
        }
        
        if (!self.railslocked) self.rail.css({
          top: pos.top,
          left: pos.left,
          height: ((len) ? len.h : self.win.innerHeight()) - (self.opt.railpadding.top + self.opt.railpadding.bottom)
        });

        if (self.zoom) {
          self.zoom.css({
            top: pos.top + 1,
            left: (self.rail.align == 1) ? pos.left - 20 : pos.left + self.rail.width + 4
          });
        }

        if (self.railh && !self.railslocked) {
          var pos = {
            top: wpos.top,
            left: wpos.left
          };
          var off = self.opt.railhoffset;
          if (!!off) {
            if (!!off.top) pos.top += off.top;
            if (!!off.left) pos.left += off.left;
          }
          var y = (self.railh.align) ? pos.top + getWidthToPixel(self.win, 'border-top-width', true) + self.win.innerHeight() - self.railh.height : pos.top + getWidthToPixel(self.win, 'border-top-width', true);
          var x = pos.left + getWidthToPixel(self.win, 'border-left-width');
          self.railh.css({
            top: y  - (self.opt.railpadding.top + self.opt.railpadding.bottom),
            left: x,
            width: self.railh.width
          });
        }


      }
    };

    this.doRailClick = function(e, dbl, hr) {
      var fn, pg, cur, pos;

      if (self.railslocked) return;
      self.cancelEvent(e);

      if (dbl) {
        fn = (hr) ? self.doScrollLeft : self.doScrollTop;
        cur = (hr) ? ((e.pageX - self.railh.offset().left - (self.cursorwidth / 2)) * self.scrollratio.x) : ((e.pageY - self.rail.offset().top - (self.cursorheight / 2)) * self.scrollratio.y);
        fn(cur);
      } else {
        fn = (hr) ? self.doScrollLeftBy : self.doScrollBy;
        cur = (hr) ? self.scroll.x : self.scroll.y;
        pos = (hr) ? e.pageX - self.railh.offset().left : e.pageY - self.rail.offset().top;
        pg = (hr) ? self.view.w : self.view.h;
        fn((cur >= pos) ? pg: -pg);//   (cur >= pos) ? fn(pg): fn(-pg);
      }

    };

    self.hasanimationframe = (setAnimationFrame);
    self.hascancelanimationframe = (clearAnimationFrame);

    if (!self.hasanimationframe) {
      setAnimationFrame = function(fn) {
        return setTimeout(fn, 15 - Math.floor((+new Date()) / 1000) % 16);
      }; // 1000/60)};
      clearAnimationFrame = clearInterval;
    } else if (!self.hascancelanimationframe) clearAnimationFrame = function() {
      self.cancelAnimationFrame = true;
    };

    this.init = function() {

      self.saved.css = [];

      if (cap.isie7mobile) return true; // SORRY, DO NOT WORK!
      if (cap.isoperamini) return true; // SORRY, DO NOT WORK!

      if (cap.hasmstouch) self.css((self.ispage) ? $("html") : self.win, {
        '-ms-touch-action': 'none'
      });

      self.zindex = "auto";
      if (!self.ispage && self.opt.zindex == "auto") {
        self.zindex = getZIndex() || "auto";
      } else {
        self.zindex = self.opt.zindex;
      }

      if (!self.ispage && self.zindex != "auto") {
        if (self.zindex > globalmaxzindex) globalmaxzindex = self.zindex;
      }

      if (self.isie && self.zindex == 0 && self.opt.zindex == "auto") { // fix IE auto == 0
        self.zindex = "auto";
      }

      if (!self.ispage || (!cap.cantouch && !cap.isieold && !cap.isie9mobile)) {

        var cont = self.docscroll;
        if (self.ispage) cont = (self.haswrapper) ? self.win : self.doc;

        if (!cap.isie9mobile) self.css(cont, {
          'overflow-y': 'hidden'
        });

        if (self.ispage && cap.isie7) {
          if (self.doc[0].nodeName == 'BODY') self.css($("html"), {
            'overflow-y': 'hidden'
          }); //IE7 double scrollbar issue
          else if (self.doc[0].nodeName == 'HTML') self.css($("body"), {
            'overflow-y': 'hidden'
          }); //IE7 double scrollbar issue
        }

        if (cap.isios && !self.ispage && !self.haswrapper) self.css($("body"), {
          "-webkit-overflow-scrolling": "touch"
        }); //force hw acceleration

        var cursor = $(document.createElement('div'));
        cursor.css({
          position: "relative",
          top: 0,
          "float": "right",
          width: self.opt.cursorwidth,
          height: "0px",
          'background-color': self.opt.cursorcolor,
          border: self.opt.cursorborder,
          'background-clip': 'padding-box',
          '-webkit-border-radius': self.opt.cursorborderradius,
          '-moz-border-radius': self.opt.cursorborderradius,
          'border-radius': self.opt.cursorborderradius
        });

        cursor.hborder = parseFloat(cursor.outerHeight() - cursor.innerHeight());
        
        cursor.addClass('nicescroll-cursors');
        
        self.cursor = cursor;

        var rail = $(document.createElement('div'));
        rail.attr('id', self.id);
        rail.addClass('nicescroll-rails nicescroll-rails-vr');

        var v, a, kp = ["left","right","top","bottom"];  //**
        for (var n in kp) {
          a = kp[n];
          v = self.opt.railpadding[a];
          (v) ? rail.css("padding-"+a,v+"px") : self.opt.railpadding[a] = 0;
        }

        rail.append(cursor);

        rail.width = Math.max(parseFloat(self.opt.cursorwidth), cursor.outerWidth());
        rail.css({
          width: rail.width + "px",
          'zIndex': self.zindex,
          "background": self.opt.background,
          cursor: "default"
        });

        rail.visibility = true;
        rail.scrollable = true;

        rail.align = (self.opt.railalign == "left") ? 0 : 1;

        self.rail = rail;

        self.rail.drag = false;

        var zoom = false;
        if (self.opt.boxzoom && !self.ispage && !cap.isieold) {
          zoom = document.createElement('div');

          self.bind(zoom, "click", self.doZoom);
          self.bind(zoom, "mouseenter", function() {
            self.zoom.css('opacity', self.opt.cursoropacitymax);
          });
          self.bind(zoom, "mouseleave", function() {
            self.zoom.css('opacity', self.opt.cursoropacitymin);
          });

          self.zoom = $(zoom);
          self.zoom.css({
            "cursor": "pointer",
            'z-index': self.zindex,
            'backgroundImage': 'url(' + self.opt.scriptpath + 'zoomico.png)',
            'height': 18,
            'width': 18,
            'backgroundPosition': '0px 0px'
          });
          if (self.opt.dblclickzoom) self.bind(self.win, "dblclick", self.doZoom);
          if (cap.cantouch && self.opt.gesturezoom) {
            self.ongesturezoom = function(e) {
              if (e.scale > 1.5) self.doZoomIn(e);
              if (e.scale < 0.8) self.doZoomOut(e);
              return self.cancelEvent(e);
            };
            self.bind(self.win, "gestureend", self.ongesturezoom);
          }
        }

        // init HORIZ

        self.railh = false;
        var railh;

        if (self.opt.horizrailenabled) {

          self.css(cont, {
            'overflow-x': 'hidden'
          });

          var cursor = $(document.createElement('div'));
          cursor.css({
            position: "absolute",
            top: 0,
            height: self.opt.cursorwidth,
            width: "0px",
            'background-color': self.opt.cursorcolor,
            border: self.opt.cursorborder,
            'background-clip': 'padding-box',
            '-webkit-border-radius': self.opt.cursorborderradius,
            '-moz-border-radius': self.opt.cursorborderradius,
            'border-radius': self.opt.cursorborderradius
          });

          if (cap.isieold) cursor.css({'overflow':'hidden'});  //IE6 horiz scrollbar issue
          
          cursor.wborder = parseFloat(cursor.outerWidth() - cursor.innerWidth());
          
          cursor.addClass('nicescroll-cursors');
          
          self.cursorh = cursor;

          railh = $(document.createElement('div'));
          railh.attr('id', self.id + '-hr');
          railh.addClass('nicescroll-rails nicescroll-rails-hr');
          railh.height = Math.max(parseFloat(self.opt.cursorwidth), cursor.outerHeight());
          railh.css({
            height: railh.height + "px",
            'zIndex': self.zindex,
            "background": self.opt.background
          });

          railh.append(cursor);

          railh.visibility = true;
          railh.scrollable = true;

          railh.align = (self.opt.railvalign == "top") ? 0 : 1;

          self.railh = railh;

          self.railh.drag = false;

        }

        //        

        if (self.ispage) {
          rail.css({
            position: "fixed",
            top: "0px",
            height: "100%"
          });
          (rail.align) ? rail.css({
            right: "0px"
          }): rail.css({
            left: "0px"
          });
          self.body.append(rail);
          if (self.railh) {
            railh.css({
              position: "fixed",
              left: "0px",
              width: "100%"
            });
            (railh.align) ? railh.css({
              bottom: "0px"
            }): railh.css({
              top: "0px"
            });
            self.body.append(railh);
          }
        } else {
          if (self.ishwscroll) {
            if (self.win.css('position') == 'static') self.css(self.win, {
              'position': 'relative'
            });
            var bd = (self.win[0].nodeName == 'HTML') ? self.body : self.win;
            $(bd).scrollTop(0).scrollLeft(0);  // fix rail position if content already scrolled
            if (self.zoom) {
              self.zoom.css({
                position: "absolute",
                top: 1,
                right: 0,
                "margin-right": rail.width + 4
              });
              bd.append(self.zoom);
            }
            rail.css({
              position: "absolute",
              top: 0
            });
            (rail.align) ? rail.css({
              right: 0
            }): rail.css({
              left: 0
            });
            bd.append(rail);
            if (railh) {
              railh.css({
                position: "absolute",
                left: 0,
                bottom: 0
              });
              (railh.align) ? railh.css({
                bottom: 0
              }): railh.css({
                top: 0
              });
              bd.append(railh);
            }
          } else {
            self.isfixed = (self.win.css("position") == "fixed");
            var rlpos = (self.isfixed) ? "fixed" : "absolute";

            if (!self.isfixed) self.viewport = self.getViewport(self.win[0]);
            if (self.viewport) {
              self.body = self.viewport;
              if ((/fixed|absolute/.test(self.viewport.css("position"))) == false) self.css(self.viewport, {
                "position": "relative"
              });
            }

            rail.css({
              position: rlpos
            });
            if (self.zoom) self.zoom.css({
              position: rlpos
            });
            self.updateScrollBar();
            self.body.append(rail);
            if (self.zoom) self.body.append(self.zoom);
            if (self.railh) {
              railh.css({
                position: rlpos
              });
              self.body.append(railh);
            }
          }

          if (cap.isios) self.css(self.win, {
            '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
            '-webkit-touch-callout': 'none'
          }); // prevent grey layer on click

          if (cap.isie && self.opt.disableoutline) self.win.attr("hideFocus", "true"); // IE, prevent dotted rectangle on focused div
          if (cap.iswebkit && self.opt.disableoutline) self.win.css({"outline": "none"});  // Webkit outline
          //if (cap.isopera&&self.opt.disableoutline) self.win.css({"outline":"0"});  // Opera 12- to test [TODO]

        }

        if (self.opt.autohidemode === false) {
          self.autohidedom = false;
          self.rail.css({
            opacity: self.opt.cursoropacitymax
          });
          if (self.railh) self.railh.css({
            opacity: self.opt.cursoropacitymax
          });
        } else if ((self.opt.autohidemode === true) || (self.opt.autohidemode === "leave")) {
          self.autohidedom = $().add(self.rail);
          if (cap.isie8) self.autohidedom = self.autohidedom.add(self.cursor);
          if (self.railh) self.autohidedom = self.autohidedom.add(self.railh);
          if (self.railh && cap.isie8) self.autohidedom = self.autohidedom.add(self.cursorh);
        } else if (self.opt.autohidemode == "scroll") {
          self.autohidedom = $().add(self.rail);
          if (self.railh) self.autohidedom = self.autohidedom.add(self.railh);
        } else if (self.opt.autohidemode == "cursor") {
          self.autohidedom = $().add(self.cursor);
          if (self.railh) self.autohidedom = self.autohidedom.add(self.cursorh);
        } else if (self.opt.autohidemode == "hidden") {
          self.autohidedom = false;
          self.hide();
          self.railslocked = false;
        }

        if (cap.isie9mobile) {

          self.scrollmom = new ScrollMomentumClass2D(self);

          self.onmangotouch = function() {
            var py = self.getScrollTop();
            var px = self.getScrollLeft();

            if ((py == self.scrollmom.lastscrolly) && (px == self.scrollmom.lastscrollx)) return true;

            var dfy = py - self.mangotouch.sy;
            var dfx = px - self.mangotouch.sx;
            var df = Math.round(Math.sqrt(Math.pow(dfx, 2) + Math.pow(dfy, 2)));
            if (df == 0) return;

            var dry = (dfy < 0) ? -1 : 1;
            var drx = (dfx < 0) ? -1 : 1;

            var tm = +new Date();
            if (self.mangotouch.lazy) clearTimeout(self.mangotouch.lazy);

            if (((tm - self.mangotouch.tm) > 80) || (self.mangotouch.dry != dry) || (self.mangotouch.drx != drx)) {
              self.scrollmom.stop();
              self.scrollmom.reset(px, py);
              self.mangotouch.sy = py;
              self.mangotouch.ly = py;
              self.mangotouch.sx = px;
              self.mangotouch.lx = px;
              self.mangotouch.dry = dry;
              self.mangotouch.drx = drx;
              self.mangotouch.tm = tm;
            } else {

              self.scrollmom.stop();
              self.scrollmom.update(self.mangotouch.sx - dfx, self.mangotouch.sy - dfy);
              self.mangotouch.tm = tm;

              var ds = Math.max(Math.abs(self.mangotouch.ly - py), Math.abs(self.mangotouch.lx - px));
              self.mangotouch.ly = py;
              self.mangotouch.lx = px;

              if (ds > 2) {
                self.mangotouch.lazy = setTimeout(function() {
                  self.mangotouch.lazy = false;
                  self.mangotouch.dry = 0;
                  self.mangotouch.drx = 0;
                  self.mangotouch.tm = 0;
                  self.scrollmom.doMomentum(30);
                }, 100);
              }
            }
          };

          var top = self.getScrollTop();
          var lef = self.getScrollLeft();
          self.mangotouch = {
            sy: top,
            ly: top,
            dry: 0,
            sx: lef,
            lx: lef,
            drx: 0,
            lazy: false,
            tm: 0
          };

          self.bind(self.docscroll, "scroll", self.onmangotouch);

        } else {

          if (cap.cantouch || self.istouchcapable || self.opt.touchbehavior || cap.hasmstouch) {

            self.scrollmom = new ScrollMomentumClass2D(self);

            self.ontouchstart = function(e) {
              if (e.pointerType && e.pointerType != 2 && e.pointerType != "touch") return false;
              
              self.hasmoving = false;

              if (!self.railslocked) {

                var tg;
                if (cap.hasmstouch) {
                  tg = (e.target) ? e.target : false;
                  while (tg) {
                    var nc = $(tg).getNiceScroll();
                    if ((nc.length > 0) && (nc[0].me == self.me)) break;
                    if (nc.length > 0) return false;
                    if ((tg.nodeName == 'DIV') && (tg.id == self.id)) break;
                    tg = (tg.parentNode) ? tg.parentNode : false;
                  }
                }

                self.cancelScroll();

                tg = self.getTarget(e);

                if (tg) {
                  var skp = (/INPUT/i.test(tg.nodeName)) && (/range/i.test(tg.type));
                  if (skp) return self.stopPropagation(e);
                }

                if (!("clientX" in e) && ("changedTouches" in e)) {
                  e.clientX = e.changedTouches[0].clientX;
                  e.clientY = e.changedTouches[0].clientY;
                }

                if (self.forcescreen) {
                  var le = e;
                  e = {
                    "original": (e.original) ? e.original : e
                  };
                  e.clientX = le.screenX;
                  e.clientY = le.screenY;
                }

                self.rail.drag = {
                  x: e.clientX,
                  y: e.clientY,
                  sx: self.scroll.x,
                  sy: self.scroll.y,
                  st: self.getScrollTop(),
                  sl: self.getScrollLeft(),
                  pt: 2,
                  dl: false
                };

                if (self.ispage || !self.opt.directionlockdeadzone) {
                  self.rail.drag.dl = "f";
                } else {

                  var view = {
                    w: $(window).width(),
                    h: $(window).height()
                  };

                  var page = {
                    w: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth),
                    h: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                  };

                  var maxh = Math.max(0, page.h - view.h);
                  var maxw = Math.max(0, page.w - view.w);

                  if (!self.rail.scrollable && self.railh.scrollable) self.rail.drag.ck = (maxh > 0) ? "v" : false;
                  else if (self.rail.scrollable && !self.railh.scrollable) self.rail.drag.ck = (maxw > 0) ? "h" : false;
                  else self.rail.drag.ck = false;
                  if (!self.rail.drag.ck) self.rail.drag.dl = "f";
                }

                if (self.opt.touchbehavior && self.isiframe && cap.isie) {
                  var wp = self.win.position();
                  self.rail.drag.x += wp.left;
                  self.rail.drag.y += wp.top;
                }

                self.hasmoving = false;
                self.lastmouseup = false;
                self.scrollmom.reset(e.clientX, e.clientY);
                
                if (!cap.cantouch && !this.istouchcapable && !e.pointerType) {       
                
                  var ip = (tg) ? /INPUT|SELECT|TEXTAREA/i.test(tg.nodeName) : false;
                  if (!ip) {
                    if (!self.ispage && cap.hasmousecapture) tg.setCapture();
                    if (self.opt.touchbehavior) {
                      if (tg.onclick && !(tg._onclick || false)) { // intercept DOM0 onclick event
                        tg._onclick = tg.onclick;
                        tg.onclick = function(e) {
                          if (self.hasmoving) return false;
                          tg._onclick.call(this, e);
                        };
                      }
                      return self.cancelEvent(e);
                    }
                    return self.stopPropagation(e);
                  }

                  if (/SUBMIT|CANCEL|BUTTON/i.test($(tg).attr('type'))) {
                    pc = {
                      "tg": tg,
                      "click": false
                    };
                    self.preventclick = pc;
                  }

                }
              }

            };

            self.ontouchend = function(e) {              
              if (!self.rail.drag) return true;              
              if (self.rail.drag.pt == 2) {
                if (e.pointerType && e.pointerType != 2 && e.pointerType != "touch") return false;
                self.scrollmom.doMomentum();
                self.rail.drag = false;
                if (self.hasmoving) {
                  self.lastmouseup = true;
                  self.hideCursor();
                  if (cap.hasmousecapture) document.releaseCapture();
                  if (!cap.cantouch) return self.cancelEvent(e);
                }
              }
              else if (self.rail.drag.pt == 1) {
                return self.onmouseup(e);
              }

            };

            var moveneedoffset = (self.opt.touchbehavior && self.isiframe && !cap.hasmousecapture);

            self.ontouchmove = function(e, byiframe) {

              if (!self.rail.drag) return false;
            
              if (e.targetTouches && self.opt.preventmultitouchscrolling) {
                if (e.targetTouches.length > 1) return false; // multitouch
              }
            
              if (e.pointerType && e.pointerType != 2 && e.pointerType != "touch") return false;
          
              if (self.rail.drag.pt == 2) {
                if (cap.cantouch && (cap.isios) && (typeof e.original == "undefined")) return true; // prevent ios "ghost" events by clickable elements

                self.hasmoving = true;

                if (self.preventclick && !self.preventclick.click) {
                  self.preventclick.click = self.preventclick.tg.onclick || false;
                  self.preventclick.tg.onclick = self.onpreventclick;
                }

                var ev = $.extend({
                  "original": e
                }, e);
                e = ev;

                if (("changedTouches" in e)) {
                  e.clientX = e.changedTouches[0].clientX;
                  e.clientY = e.changedTouches[0].clientY;
                }

                if (self.forcescreen) {
                  var le = e;
                  e = {
                    "original": (e.original) ? e.original : e
                  };
                  e.clientX = le.screenX;
                  e.clientY = le.screenY;
                }

                var ofy,ofx;
                ofx = ofy = 0;

                if (moveneedoffset && !byiframe) {
                  var wp = self.win.position();
                  ofx = -wp.left;
                  ofy = -wp.top;
                }

                var fy = e.clientY + ofy;
                var my = (fy - self.rail.drag.y);
                var fx = e.clientX + ofx;
                var mx = (fx - self.rail.drag.x);

                var ny = self.rail.drag.st - my;

                if (self.ishwscroll && self.opt.bouncescroll) {
                  if (ny < 0) {
                    ny = Math.round(ny / 2);
                    //                    fy = 0;
                  } else if (ny > self.page.maxh) {
                    ny = self.page.maxh + Math.round((ny - self.page.maxh) / 2);
                    //                    fy = 0;
                  }
                } else {
                  if (ny < 0) {
                    ny = 0;
                    fy = 0;
                  }
                  if (ny > self.page.maxh) {
                    ny = self.page.maxh;
                    fy = 0;
                  }
                }

                var nx;
                if (self.railh && self.railh.scrollable) {
                  nx = (self.isrtlmode) ? mx - self.rail.drag.sl : self.rail.drag.sl - mx;

                  if (self.ishwscroll && self.opt.bouncescroll) {
                    if (nx < 0) {
                      nx = Math.round(nx / 2);
                      //                      fx = 0;
                    } else if (nx > self.page.maxw) {
                      nx = self.page.maxw + Math.round((nx - self.page.maxw) / 2);
                      //                      fx = 0;
                    }
                  } else {
                    if (nx < 0) {
                      nx = 0;
                      fx = 0;
                    }
                    if (nx > self.page.maxw) {
                      nx = self.page.maxw;
                      fx = 0;
                    }
                  }

                }

                var grabbed = false;
                if (self.rail.drag.dl) {
                  grabbed = true;
                  if (self.rail.drag.dl == "v") nx = self.rail.drag.sl;
                  else if (self.rail.drag.dl == "h") ny = self.rail.drag.st;
                } else {
                  var ay = Math.abs(my);
                  var ax = Math.abs(mx);
                  var dz = self.opt.directionlockdeadzone;
                  if (self.rail.drag.ck == "v") {
                    if (ay > dz && (ax <= (ay * 0.3))) {
                      self.rail.drag = false;
                      return true;
                    } else if (ax > dz) {
                      self.rail.drag.dl = "f";
                      $("body").scrollTop($("body").scrollTop()); // stop iOS native scrolling (when active javascript has blocked)
                    }
                  } else if (self.rail.drag.ck == "h") {
                    if (ax > dz && (ay <= (ax * 0.3))) {
                      self.rail.drag = false;
                      return true;
                    } else if (ay > dz) {
                      self.rail.drag.dl = "f";
                      $("body").scrollLeft($("body").scrollLeft()); // stop iOS native scrolling (when active javascript has blocked)
                    }
                  }
                }

                self.synched("touchmove", function() {
                  if (self.rail.drag && (self.rail.drag.pt == 2)) {
                    if (self.prepareTransition) self.prepareTransition(0);
                    if (self.rail.scrollable) self.setScrollTop(ny);
                    self.scrollmom.update(fx, fy);
                    if (self.railh && self.railh.scrollable) {
                      self.setScrollLeft(nx);
                      self.showCursor(ny, nx);
                    } else {
                      self.showCursor(ny);
                    }
                    if (cap.isie10) document.selection.clear();
                  }
                });

                if (cap.ischrome && self.istouchcapable) grabbed = false; //chrome touch emulation doesn't like!
                if (grabbed) return self.cancelEvent(e);
              }
              else if (self.rail.drag.pt == 1) { // drag on cursor
                return self.onmousemove(e);
              }

            };

          }

          self.onmousedown = function(e, hronly) {
            if (self.rail.drag && self.rail.drag.pt != 1) return;
            if (self.railslocked) return self.cancelEvent(e);
            self.cancelScroll();
            self.rail.drag = {
              x: e.clientX,
              y: e.clientY,
              sx: self.scroll.x,
              sy: self.scroll.y,
              pt: 1,
              hr: (!!hronly)
            };
            var tg = self.getTarget(e);
            if (!self.ispage && cap.hasmousecapture) tg.setCapture();
            if (self.isiframe && !cap.hasmousecapture) {
              self.saved.csspointerevents = self.doc.css("pointer-events");
              self.css(self.doc, {
                "pointer-events": "none"
              });
            }
            self.hasmoving = false;
            return self.cancelEvent(e);
          };

          self.onmouseup = function(e) {
            if (self.rail.drag) {
              if (self.rail.drag.pt != 1) return true;
              if (cap.hasmousecapture) document.releaseCapture();
              if (self.isiframe && !cap.hasmousecapture) self.doc.css("pointer-events", self.saved.csspointerevents);              
              self.rail.drag = false;
              //if (!self.rail.active) self.hideCursor();
              if (self.hasmoving) self.triggerScrollEnd(); // TODO - check &&!self.scrollrunning
              return self.cancelEvent(e);
            }
          };

          self.onmousemove = function(e) {
            if (self.rail.drag) {
              if (self.rail.drag.pt != 1) return;

              if (cap.ischrome && e.which == 0) return self.onmouseup(e);

              self.cursorfreezed = true;
              self.hasmoving = true;

              if (self.rail.drag.hr) {
                self.scroll.x = self.rail.drag.sx + (e.clientX - self.rail.drag.x);
                if (self.scroll.x < 0) self.scroll.x = 0;
                var mw = self.scrollvaluemaxw;
                if (self.scroll.x > mw) self.scroll.x = mw;
              } else {
                self.scroll.y = self.rail.drag.sy + (e.clientY - self.rail.drag.y);
                if (self.scroll.y < 0) self.scroll.y = 0;
                var my = self.scrollvaluemax;
                if (self.scroll.y > my) self.scroll.y = my;
              }

              self.synched('mousemove', function() {
                if (self.rail.drag && (self.rail.drag.pt == 1)) {
                  self.showCursor();
                  if (self.rail.drag.hr) {
                    if (self.hasreversehr) {
                      self.doScrollLeft(self.scrollvaluemaxw-Math.round(self.scroll.x * self.scrollratio.x), self.opt.cursordragspeed);
                    } else {
                      self.doScrollLeft(Math.round(self.scroll.x * self.scrollratio.x), self.opt.cursordragspeed);
                    }
                  }
                  else self.doScrollTop(Math.round(self.scroll.y * self.scrollratio.y), self.opt.cursordragspeed);
                }
              });

              return self.cancelEvent(e);
            }
            /*              
            else {
              self.checkarea = true;
            }
*/
          };

          if (cap.cantouch || self.opt.touchbehavior) {

            self.onpreventclick = function(e) {
              if (self.preventclick) {
                self.preventclick.tg.onclick = self.preventclick.click;
                self.preventclick = false;
                return self.cancelEvent(e);
              }
            }

            self.bind(self.win, "mousedown", self.ontouchstart); // control content dragging

            self.onclick = (cap.isios) ? false : function(e) {
              if (self.lastmouseup) {
                self.lastmouseup = false;
                return self.cancelEvent(e);
              } else {
                return true;
              }
            };

            if (self.opt.grabcursorenabled && cap.cursorgrabvalue) {
              self.css((self.ispage) ? self.doc : self.win, {
                'cursor': cap.cursorgrabvalue
              });
              self.css(self.rail, {
                'cursor': cap.cursorgrabvalue
              });
            }

          } else {

            var checkSelectionScroll = function(e) {
              if (!self.selectiondrag) return;

              if (e) {
                var ww = self.win.outerHeight();
                var df = (e.pageY - self.selectiondrag.top);
                if (df > 0 && df < ww) df = 0;
                if (df >= ww) df -= ww;
                self.selectiondrag.df = df;
              }
              if (self.selectiondrag.df == 0) return;

              var rt = -Math.floor(self.selectiondrag.df / 6) * 2;
              self.doScrollBy(rt);

              self.debounced("doselectionscroll", function() {
                checkSelectionScroll()
              }, 50);
            };

            if ("getSelection" in document) { // A grade - Major browsers
              self.hasTextSelected = function() {
                return (document.getSelection().rangeCount > 0);
              };
            } else if ("selection" in document) { //IE9-
              self.hasTextSelected = function() {
                return (document.selection.type != "None");
              };
            } else {
              self.hasTextSelected = function() { // no support
                return false;
              };
            }

            self.onselectionstart = function(e) {
/*  More testing - severe chrome issues            
              if (!self.haswrapper&&(e.which&&e.which==2)) {  // fool browser to manage middle button scrolling
                self.win.css({'overflow':'auto'});
                setTimeout(function(){
                  self.win.css({'overflow':''});
                },10);                
                return true;
              }            
*/              
              if (self.ispage) return;
              self.selectiondrag = self.win.offset();
            };
            
            self.onselectionend = function(e) {
              self.selectiondrag = false;
            };
            self.onselectiondrag = function(e) {
              if (!self.selectiondrag) return;
              if (self.hasTextSelected()) self.debounced("selectionscroll", function() {
                checkSelectionScroll(e)
              }, 250);
            };


          }

          if (cap.hasw3ctouch) { //IE11+
            self.css(self.rail, {
              'touch-action': 'none'
            });
            self.css(self.cursor, {
              'touch-action': 'none'
            });
            self.bind(self.win, "pointerdown", self.ontouchstart);
            self.bind(document, "pointerup", self.ontouchend);
            self.bind(document, "pointermove", self.ontouchmove);
          } else if (cap.hasmstouch) { //IE10
            self.css(self.rail, {
              '-ms-touch-action': 'none'
            });
            self.css(self.cursor, {
              '-ms-touch-action': 'none'
            });
            self.bind(self.win, "MSPointerDown", self.ontouchstart);
            self.bind(document, "MSPointerUp", self.ontouchend);
            self.bind(document, "MSPointerMove", self.ontouchmove);
            self.bind(self.cursor, "MSGestureHold", function(e) {
              e.preventDefault()
            });
            self.bind(self.cursor, "contextmenu", function(e) {
              e.preventDefault()
            });
          } else if (this.istouchcapable) { //desktop with screen touch enabled
            self.bind(self.win, "touchstart", self.ontouchstart);
            self.bind(document, "touchend", self.ontouchend);
            self.bind(document, "touchcancel", self.ontouchend);
            self.bind(document, "touchmove", self.ontouchmove);
          }

          
          if (self.opt.cursordragontouch || (!cap.cantouch && !self.opt.touchbehavior)) {

            self.rail.css({
              "cursor": "default"
            });
            self.railh && self.railh.css({
              "cursor": "default"
            });

            self.jqbind(self.rail, "mouseenter", function() {
              if (!self.ispage && !self.win.is(":visible")) return false;
              if (self.canshowonmouseevent) self.showCursor();
              self.rail.active = true;
            });
            self.jqbind(self.rail, "mouseleave", function() {
              self.rail.active = false;
              if (!self.rail.drag) self.hideCursor();
            });

            if (self.opt.sensitiverail) {
              self.bind(self.rail, "click", function(e) {
                self.doRailClick(e, false, false)
              });
              self.bind(self.rail, "dblclick", function(e) {
                self.doRailClick(e, true, false)
              });
              self.bind(self.cursor, "click", function(e) {
                self.cancelEvent(e)
              });
              self.bind(self.cursor, "dblclick", function(e) {
                self.cancelEvent(e)
              });
            }

            if (self.railh) {
              self.jqbind(self.railh, "mouseenter", function() {
                if (!self.ispage && !self.win.is(":visible")) return false;
                if (self.canshowonmouseevent) self.showCursor();
                self.rail.active = true;
              });
              self.jqbind(self.railh, "mouseleave", function() {
                self.rail.active = false;
                if (!self.rail.drag) self.hideCursor();
              });

              if (self.opt.sensitiverail) {
                self.bind(self.railh, "click", function(e) {
                  self.doRailClick(e, false, true)
                });
                self.bind(self.railh, "dblclick", function(e) {
                  self.doRailClick(e, true, true)
                });
                self.bind(self.cursorh, "click", function(e) {
                  self.cancelEvent(e)
                });
                self.bind(self.cursorh, "dblclick", function(e) {
                  self.cancelEvent(e)
                });
              }

            }

          }

          if (!cap.cantouch && !self.opt.touchbehavior) {

            self.bind((cap.hasmousecapture) ? self.win : document, "mouseup", self.onmouseup);
            self.bind(document, "mousemove", self.onmousemove);
            if (self.onclick) self.bind(document, "click", self.onclick);

            self.bind(self.cursor, "mousedown", self.onmousedown);
            self.bind(self.cursor, "mouseup", self.onmouseup);

            if (self.railh) {
              self.bind(self.cursorh, "mousedown", function(e) {
                self.onmousedown(e, true)
              });
              self.bind(self.cursorh, "mouseup", self.onmouseup);
            }
            
            if (!self.ispage && self.opt.enablescrollonselection) {
              self.bind(self.win[0], "mousedown", self.onselectionstart);
              self.bind(document, "mouseup", self.onselectionend);
              self.bind(self.cursor, "mouseup", self.onselectionend);
              if (self.cursorh) self.bind(self.cursorh, "mouseup", self.onselectionend);
              self.bind(document, "mousemove", self.onselectiondrag);
            }

            if (self.zoom) {
              self.jqbind(self.zoom, "mouseenter", function() {
                if (self.canshowonmouseevent) self.showCursor();
                self.rail.active = true;
              });
              self.jqbind(self.zoom, "mouseleave", function() {
                self.rail.active = false;
                if (!self.rail.drag) self.hideCursor();
              });
            }

          } else {

            self.bind((cap.hasmousecapture) ? self.win : document, "mouseup", self.ontouchend);
            self.bind(document, "mousemove", self.ontouchmove);
            if (self.onclick) self.bind(document, "click", self.onclick);

            if (self.opt.cursordragontouch) {
              self.bind(self.cursor, "mousedown", self.onmousedown);
              self.bind(self.cursor, "mouseup", self.onmouseup);
              //self.bind(self.cursor, "mousemove", self.onmousemove);
              self.cursorh && self.bind(self.cursorh, "mousedown", function(e) {
                self.onmousedown(e, true)
              });
              //self.cursorh && self.bind(self.cursorh, "mousemove", self.onmousemove);
              self.cursorh && self.bind(self.cursorh, "mouseup", self.onmouseup);
            }

          }

          if (self.opt.enablemousewheel) {
            if (!self.isiframe) self.bind((cap.isie && self.ispage) ? document : self.win /*self.docscroll*/ , "mousewheel", self.onmousewheel);
            self.bind(self.rail, "mousewheel", self.onmousewheel);
            if (self.railh) self.bind(self.railh, "mousewheel", self.onmousewheelhr);
          }

          if (!self.ispage && !cap.cantouch && !(/HTML|^BODY/.test(self.win[0].nodeName))) {
            if (!self.win.attr("tabindex")) self.win.attr({
              "tabindex": tabindexcounter++
            });

            self.jqbind(self.win, "focus", function(e) {
              domfocus = (self.getTarget(e)).id || true;
              self.hasfocus = true;
              if (self.canshowonmouseevent) self.noticeCursor();
            });
            self.jqbind(self.win, "blur", function(e) {
              domfocus = false;
              self.hasfocus = false;
            });

            self.jqbind(self.win, "mouseenter", function(e) {
              mousefocus = (self.getTarget(e)).id || true;
              self.hasmousefocus = true;
              if (self.canshowonmouseevent) self.noticeCursor();
            });
            self.jqbind(self.win, "mouseleave", function() {
              mousefocus = false;
              self.hasmousefocus = false;
              if (!self.rail.drag) self.hideCursor();
            });

          }

        } // !ie9mobile

        //Thanks to http://www.quirksmode.org !!
        self.onkeypress = function(e) {
          if (self.railslocked && self.page.maxh == 0) return true;

          e = (e) ? e : window.e;
          var tg = self.getTarget(e);
          if (tg && /INPUT|TEXTAREA|SELECT|OPTION/.test(tg.nodeName)) {
            var tp = tg.getAttribute('type') || tg.type || false;
            if ((!tp) || !(/submit|button|cancel/i.tp)) return true;
          }

          if ($(tg).attr('contenteditable')) return true;

          if (self.hasfocus || (self.hasmousefocus && !domfocus) || (self.ispage && !domfocus && !mousefocus)) {
            var key = e.keyCode;

            if (self.railslocked && key != 27) return self.cancelEvent(e);

            var ctrl = e.ctrlKey || false;
            var shift = e.shiftKey || false;

            var ret = false;
            switch (key) {
              case 38:
              case 63233: //safari
                self.doScrollBy(24 * 3);
                ret = true;
                break;
              case 40:
              case 63235: //safari
                self.doScrollBy(-24 * 3);
                ret = true;
                break;
              case 37:
              case 63232: //safari
                if (self.railh) {
                  (ctrl) ? self.doScrollLeft(0): self.doScrollLeftBy(24 * 3);
                  ret = true;
                }
                break;
              case 39:
              case 63234: //safari
                if (self.railh) {
                  (ctrl) ? self.doScrollLeft(self.page.maxw): self.doScrollLeftBy(-24 * 3);
                  ret = true;
                }
                break;
              case 33:
              case 63276: // safari
                self.doScrollBy(self.view.h);
                ret = true;
                break;
              case 34:
              case 63277: // safari
                self.doScrollBy(-self.view.h);
                ret = true;
                break;
              case 36:
              case 63273: // safari                
                (self.railh && ctrl) ? self.doScrollPos(0, 0): self.doScrollTo(0);
                ret = true;
                break;
              case 35:
              case 63275: // safari
                (self.railh && ctrl) ? self.doScrollPos(self.page.maxw, self.page.maxh): self.doScrollTo(self.page.maxh);
                ret = true;
                break;
              case 32:
                if (self.opt.spacebarenabled) {
                  (shift) ? self.doScrollBy(self.view.h): self.doScrollBy(-self.view.h);
                  ret = true;
                }
                break;
              case 27: // ESC
                if (self.zoomactive) {
                  self.doZoom();
                  ret = true;
                }
                break;
            }
            if (ret) return self.cancelEvent(e);
          }
        };

        if (self.opt.enablekeyboard) self.bind(document, (cap.isopera && !cap.isopera12) ? "keypress" : "keydown", self.onkeypress);

        self.bind(document, "keydown", function(e) {
          var ctrl = e.ctrlKey || false;
          if (ctrl) self.wheelprevented = true;
        });
        self.bind(document, "keyup", function(e) {
          var ctrl = e.ctrlKey || false;
          if (!ctrl) self.wheelprevented = false;
        });
        self.bind(window,"blur",function(e){
          self.wheelprevented = false;
        });        

        self.bind(window, 'resize', self.lazyResize);
        self.bind(window, 'orientationchange', self.lazyResize);

        self.bind(window, "load", self.lazyResize);

        if (cap.ischrome && !self.ispage && !self.haswrapper) { //chrome void scrollbar bug - it persists in version 26
          var tmp = self.win.attr("style");
          var ww = parseFloat(self.win.css("width")) + 1;
          self.win.css('width', ww);
          self.synched("chromefix", function() {
            self.win.attr("style", tmp)
          });
        }


        // Trying a cross-browser implementation - good luck!

        self.onAttributeChange = function(e) {
          self.lazyResize(self.isieold ? 250 : 30);
        };

        if (ClsMutationObserver !== false) {
          self.observerbody = new ClsMutationObserver(function(mutations) {
            mutations.forEach(function(mut){
              if (mut.type=="attributes") {
                return ($("body").hasClass("modal-open")) ? self.hide() : self.show();  // Support for Bootstrap modal
              }
            });  
            if (document.body.scrollHeight!=self.page.maxh) return self.lazyResize(30);
          });
          self.observerbody.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: false,
            attributes: true,
            attributeFilter: ['class']
          });
        }
        
        if (!self.ispage && !self.haswrapper) {
          // redesigned MutationObserver for Chrome18+/Firefox14+/iOS6+ with support for: remove div, add/remove content
          if (ClsMutationObserver !== false) {
            self.observer = new ClsMutationObserver(function(mutations) {
              mutations.forEach(self.onAttributeChange);
            });
            self.observer.observe(self.win[0], {
              childList: true,
              characterData: false,
              attributes: true,
              subtree: false
            });
            self.observerremover = new ClsMutationObserver(function(mutations) {
              mutations.forEach(function(mo) {
                if (mo.removedNodes.length > 0) {
                  for (var dd in mo.removedNodes) {
                    if (!!self && (mo.removedNodes[dd] == self.win[0])) return self.remove();
                  }
                }
              });
            });
            self.observerremover.observe(self.win[0].parentNode, {
              childList: true,
              characterData: false,
              attributes: false,
              subtree: false
            });
          } else {
            self.bind(self.win, (cap.isie && !cap.isie9) ? "propertychange" : "DOMAttrModified", self.onAttributeChange);
            if (cap.isie9) self.win[0].attachEvent("onpropertychange", self.onAttributeChange); //IE9 DOMAttrModified bug
            self.bind(self.win, "DOMNodeRemoved", function(e) {
              if (e.target == self.win[0]) self.remove();
            });
          }
        }

        //

        if (!self.ispage && self.opt.boxzoom) self.bind(window, "resize", self.resizeZoom);
        if (self.istextarea) self.bind(self.win, "mouseup", self.lazyResize);

        //        self.checkrtlmode = true;
        self.lazyResize(30);

      }
      
      if (this.doc[0].nodeName == 'IFRAME') {
        var oniframeload = function() {
          self.iframexd = false;
          var doc;
          try {
            doc = 'contentDocument' in this ? this.contentDocument : this.contentWindow.document;
            var a = doc.domain;
          } catch (e) {
            self.iframexd = true;
            doc = false
          }
          
          if (self.iframexd) {
            if ("console" in window) console.log('NiceScroll error: policy restriced iframe');
            return true; //cross-domain - I can't manage this        
          }

          self.forcescreen = true;

          if (self.isiframe) {
            self.iframe = {
              "doc": $(doc),
              "html": self.doc.contents().find('html')[0],
              "body": self.doc.contents().find('body')[0]
            };
            self.getContentSize = function() {
              return {
                w: Math.max(self.iframe.html.scrollWidth, self.iframe.body.scrollWidth),
                h: Math.max(self.iframe.html.scrollHeight, self.iframe.body.scrollHeight)
              };
            };
            self.docscroll = $(self.iframe.body); //$(this.contentWindow);
          }

          if (!cap.isios && self.opt.iframeautoresize && !self.isiframe) {
            self.win.scrollTop(0); // reset position
            self.doc.height(""); //reset height to fix browser bug
            var hh = Math.max(doc.getElementsByTagName('html')[0].scrollHeight, doc.body.scrollHeight);
            self.doc.height(hh);
          }
          self.lazyResize(30);

          if (cap.isie7) self.css($(self.iframe.html), {
            'overflow-y': 'hidden'
          });
          self.css($(self.iframe.body), {
            'overflow-y': 'hidden'
          });

          if (cap.isios && self.haswrapper) {
            self.css($(doc.body), {
              '-webkit-transform': 'translate3d(0,0,0)'
            }); // avoid iFrame content clipping - thanks to http://blog.derraab.com/2012/04/02/avoid-iframe-content-clipping-with-css-transform-on-ios/
          }

          if ('contentWindow' in this) {
            self.bind(this.contentWindow, "scroll", self.onscroll); //IE8 & minor
          } else {
            self.bind(doc, "scroll", self.onscroll);
          }

          if (self.opt.enablemousewheel) {
            self.bind(doc, "mousewheel", self.onmousewheel);
          }

          if (self.opt.enablekeyboard) self.bind(doc, (cap.isopera) ? "keypress" : "keydown", self.onkeypress);

          if (cap.cantouch || self.opt.touchbehavior) {
            self.bind(doc, "mousedown", self.ontouchstart);
            self.bind(doc, "mousemove", function(e) {
              return self.ontouchmove(e, true)
            });
            if (self.opt.grabcursorenabled && cap.cursorgrabvalue) self.css($(doc.body), {
              'cursor': cap.cursorgrabvalue
            });
          }

          self.bind(doc, "mouseup", self.ontouchend);

          if (self.zoom) {
            if (self.opt.dblclickzoom) self.bind(doc, 'dblclick', self.doZoom);
            if (self.ongesturezoom) self.bind(doc, "gestureend", self.ongesturezoom);
          }
        };

        if (this.doc[0].readyState && this.doc[0].readyState == "complete") {
          setTimeout(function() {
            oniframeload.call(self.doc[0], false)
          }, 500);
        }
        self.bind(this.doc, "load", oniframeload);

      }

    };

    this.showCursor = function(py, px) {
      if (self.cursortimeout) {
        clearTimeout(self.cursortimeout);
        self.cursortimeout = 0;
      }
      if (!self.rail) return;
      if (self.autohidedom) {
        self.autohidedom.stop().css({
          opacity: self.opt.cursoropacitymax
        });
        self.cursoractive = true;
      }

      if (!self.rail.drag || self.rail.drag.pt != 1) {
        if ((typeof py != "undefined") && (py !== false)) {
          self.scroll.y = Math.round(py * 1 / self.scrollratio.y);
        }
        if (typeof px != "undefined") {
          self.scroll.x = Math.round(px * 1 / self.scrollratio.x);
        }
      }

      self.cursor.css({
        height: self.cursorheight,
        top: self.scroll.y
      });
      if (self.cursorh) {        
        var lx = (self.hasreversehr) ? self.scrollvaluemaxw-self.scroll.x : self.scroll.x;
        (!self.rail.align && self.rail.visibility) ? self.cursorh.css({
          width: self.cursorwidth,
          left: lx + self.rail.width
        }): self.cursorh.css({
          width: self.cursorwidth,
          left: lx
        });
        self.cursoractive = true;
      }

      if (self.zoom) self.zoom.stop().css({
        opacity: self.opt.cursoropacitymax
      });
    };

    this.hideCursor = function(tm) {
      if (self.cursortimeout) return;
      if (!self.rail) return;
      if (!self.autohidedom) return;
      if (self.hasmousefocus && self.opt.autohidemode == "leave") return;
      self.cursortimeout = setTimeout(function() {
        if (!self.rail.active || !self.showonmouseevent) {
          self.autohidedom.stop().animate({
            opacity: self.opt.cursoropacitymin
          });
          if (self.zoom) self.zoom.stop().animate({
            opacity: self.opt.cursoropacitymin
          });
          self.cursoractive = false;
        }
        self.cursortimeout = 0;
      }, tm || self.opt.hidecursordelay);
    };

    this.noticeCursor = function(tm, py, px) {
      self.showCursor(py, px);
      if (!self.rail.active) self.hideCursor(tm);
    };

    this.getContentSize =
      (self.ispage) ?
      function() {
        return {
          w: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth),
          h: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        }
      } : (self.haswrapper) ?
      function() {
        return {
          w: self.doc.outerWidth() + parseInt(self.win.css('paddingLeft')) + parseInt(self.win.css('paddingRight')),
          h: self.doc.outerHeight() + parseInt(self.win.css('paddingTop')) + parseInt(self.win.css('paddingBottom'))
        }
      } : function() {
        return {
          w: self.docscroll[0].scrollWidth,
          h: self.docscroll[0].scrollHeight
        }
      };

    this.onResize = function(e, page) {
    
      if (!self || !self.win) return false;

      if (!self.haswrapper && !self.ispage) {
        if (self.win.css('display') == 'none') {
          if (self.visibility) self.hideRail().hideRailHr();
          return false;
        } else {
          if (!self.hidden && !self.visibility) self.showRail().showRailHr();
        }
      }

      var premaxh = self.page.maxh;
      var premaxw = self.page.maxw;

      var preview = {
        h: self.view.h,
        w: self.view.w
      };

      self.view = {
        w: (self.ispage) ? self.win.width() : parseInt(self.win[0].clientWidth),
        h: (self.ispage) ? self.win.height() : parseInt(self.win[0].clientHeight)
      };

      self.page = (page) ? page : self.getContentSize();

      self.page.maxh = Math.max(0, self.page.h - self.view.h);
      self.page.maxw = Math.max(0, self.page.w - self.view.w);
      
      if ((self.page.maxh == premaxh) && (self.page.maxw == premaxw) && (self.view.w == preview.w) && (self.view.h == preview.h)) {
        // test position        
        if (!self.ispage) {
          var pos = self.win.offset();
          if (self.lastposition) {
            var lst = self.lastposition;
            if ((lst.top == pos.top) && (lst.left == pos.left)) return self; //nothing to do            
          }
          self.lastposition = pos;
        } else {
          return self; //nothing to do
        }
      }

      if (self.page.maxh == 0) {
        self.hideRail();
        self.scrollvaluemax = 0;
        self.scroll.y = 0;
        self.scrollratio.y = 0;
        self.cursorheight = 0;
        self.setScrollTop(0);
        self.rail.scrollable = false;
      } else {
        self.page.maxh -= (self.opt.railpadding.top + self.opt.railpadding.bottom);  //**
        self.rail.scrollable = true;
      }

      if (self.page.maxw == 0) {
        self.hideRailHr();
        self.scrollvaluemaxw = 0;
        self.scroll.x = 0;
        self.scrollratio.x = 0;
        self.cursorwidth = 0;
        self.setScrollLeft(0);
        self.railh.scrollable = false;
      } else {
        self.page.maxw -= (self.opt.railpadding.left + self.opt.railpadding.right);  //**
        self.railh.scrollable = true;
      }

      self.railslocked = (self.locked) || ((self.page.maxh == 0) && (self.page.maxw == 0));
      if (self.railslocked) {
        if (!self.ispage) self.updateScrollBar(self.view);
        return false;
      }

      if (!self.hidden && !self.visibility) {
        self.showRail().showRailHr();
      }
      else if (!self.hidden && !self.railh.visibility) self.showRailHr();

      if (self.istextarea && self.win.css('resize') && self.win.css('resize') != 'none') self.view.h -= 20;

      self.cursorheight = Math.min(self.view.h, Math.round(self.view.h * (self.view.h / self.page.h)));
      self.cursorheight = (self.opt.cursorfixedheight) ? self.opt.cursorfixedheight : Math.max(self.opt.cursorminheight, self.cursorheight);

      self.cursorwidth = Math.min(self.view.w, Math.round(self.view.w * (self.view.w / self.page.w)));
      self.cursorwidth = (self.opt.cursorfixedheight) ? self.opt.cursorfixedheight : Math.max(self.opt.cursorminheight, self.cursorwidth);

      self.scrollvaluemax = self.view.h - self.cursorheight - self.cursor.hborder - (self.opt.railpadding.top + self.opt.railpadding.bottom);  //**

      if (self.railh) {
        self.railh.width = (self.page.maxh > 0) ? (self.view.w - self.rail.width) : self.view.w;
        self.scrollvaluemaxw = self.railh.width - self.cursorwidth - self.cursorh.wborder - (self.opt.railpadding.left + self.opt.railpadding.right);  //**
      }

      /*
      if (self.checkrtlmode&&self.railh) {
        self.checkrtlmode = false;
        if (self.opt.rtlmode&&self.scroll.x==0) self.setScrollLeft(self.page.maxw);
      }
*/

      if (!self.ispage) self.updateScrollBar(self.view);

      self.scrollratio = {
        x: (self.page.maxw / self.scrollvaluemaxw),
        y: (self.page.maxh / self.scrollvaluemax)
      };

      var sy = self.getScrollTop();
      if (sy > self.page.maxh) {
        self.doScrollTop(self.page.maxh);
      } else {
        self.scroll.y = Math.round(self.getScrollTop() * (1 / self.scrollratio.y));
        self.scroll.x = Math.round(self.getScrollLeft() * (1 / self.scrollratio.x));
        if (self.cursoractive) self.noticeCursor();
      }

      if (self.scroll.y && (self.getScrollTop() == 0)) self.doScrollTo(Math.floor(self.scroll.y * self.scrollratio.y));

      return self;
    };

    this.resize = self.onResize;

    this.lazyResize = function(tm) { // event debounce
      tm = (isNaN(tm)) ? 30 : tm;
      self.debounced('resize', self.resize, tm);
      return self;
    };

    // modified by MDN https://developer.mozilla.org/en-US/docs/DOM/Mozilla_event_reference/wheel
    function _modernWheelEvent(dom, name, fn, bubble) {
      self._bind(dom, name, function(e) {
        var e = (e) ? e : window.event;
        var event = {
          original: e,
          target: e.target || e.srcElement,
          type: "wheel",
          deltaMode: e.type == "MozMousePixelScroll" ? 0 : 1,
          deltaX: 0,
          deltaZ: 0,
          preventDefault: function() {
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            return false;
          },
          stopImmediatePropagation: function() {
            (e.stopImmediatePropagation) ? e.stopImmediatePropagation(): e.cancelBubble = true;
          }
        };

        if (name == "mousewheel") {
          event.deltaY = -1 / 40 * e.wheelDelta;
          e.wheelDeltaX && (event.deltaX = -1 / 40 * e.wheelDeltaX);
        } else {
          event.deltaY = e.detail;
        }

        return fn.call(dom, event);
      }, bubble);
    };



    this.jqbind = function(dom, name, fn) { // use jquery bind for non-native events (mouseenter/mouseleave)
      self.events.push({
        e: dom,
        n: name,
        f: fn,
        q: true
      });
      $(dom).bind(name, fn);
    };

    this.bind = function(dom, name, fn, bubble) { // touch-oriented & fixing jquery bind
      var el = ("jquery" in dom) ? dom[0] : dom;

      if (name == 'mousewheel') {
        if (window.addEventListener||'onwheel' in document) { // modern brosers & IE9 detection fix
          self._bind(el, "wheel", fn, bubble || false);
        } else {
          var wname = (typeof document.onmousewheel != "undefined") ? "mousewheel" : "DOMMouseScroll"; // older IE/Firefox
          _modernWheelEvent(el, wname, fn, bubble || false);
          if (wname == "DOMMouseScroll") _modernWheelEvent(el, "MozMousePixelScroll", fn, bubble || false); // Firefox legacy
        }
      } else if (el.addEventListener) {
        if (cap.cantouch && /mouseup|mousedown|mousemove/.test(name)) { // touch device support
          var tt = (name == 'mousedown') ? 'touchstart' : (name == 'mouseup') ? 'touchend' : 'touchmove';
          self._bind(el, tt, function(e) {
            if (e.touches) {
              if (e.touches.length < 2) {
                var ev = (e.touches.length) ? e.touches[0] : e;
                ev.original = e;
                fn.call(this, ev);
              }
            } else if (e.changedTouches) {
              var ev = e.changedTouches[0];
              ev.original = e;
              fn.call(this, ev);
            } //blackberry
          }, bubble || false);
        }
        self._bind(el, name, fn, bubble || false);
        if (cap.cantouch && name == "mouseup") self._bind(el, "touchcancel", fn, bubble || false);
      } else {
        self._bind(el, name, function(e) {
          e = e || window.event || false;
          if (e) {
            if (e.srcElement) e.target = e.srcElement;
          }
          if (!("pageY" in e)) {
            e.pageX = e.clientX + document.documentElement.scrollLeft;
            e.pageY = e.clientY + document.documentElement.scrollTop;
          }
          return ((fn.call(el, e) === false) || bubble === false) ? self.cancelEvent(e) : true;
        });
      }
    };

    if (cap.haseventlistener) {  // W3C standard model
      this._bind = function(el, name, fn, bubble) { // primitive bind
        self.events.push({
          e: el,
          n: name,
          f: fn,
          b: bubble,
          q: false
        });
        el.addEventListener(name, fn, bubble || false);
      };    
      this.cancelEvent = function(e) {
        if (!e) return false;
        var e = (e.original) ? e.original : e;
        e.preventDefault();
        e.stopPropagation();
        if (e.preventManipulation) e.preventManipulation(); //IE10
        return false;
      };
      this.stopPropagation = function(e) {
        if (!e) return false;
        var e = (e.original) ? e.original : e;
        e.stopPropagation();
        return false;
      };
      this._unbind = function(el, name, fn, bub) { // primitive unbind
        el.removeEventListener(name, fn, bub);
      };
    } else {  // old IE model
      this._bind = function(el, name, fn, bubble) { // primitive bind
        self.events.push({
          e: el,
          n: name,
          f: fn,
          b: bubble,
          q: false
        });
        if (el.attachEvent) {
          el.attachEvent("on" + name, fn);
        } else {
          el["on" + name] = fn;
        }
      };    
      // Thanks to http://www.switchonthecode.com !!
      this.cancelEvent = function(e) {
        var e = window.event || false;
        if (!e) return false;
        e.cancelBubble = true;
        e.cancel = true;
        e.returnValue = false;
        return false;
      };
      this.stopPropagation = function(e) {
        var e = window.event || false;
        if (!e) return false;
        e.cancelBubble = true;
        return false;
      };
      this._unbind = function(el, name, fn, bub) { // primitive unbind IE old
        if (el.detachEvent) {
          el.detachEvent('on' + name, fn);
        } else {
          el['on' + name] = false;
        }
      };
    }
    
    this.unbindAll = function() {
      for (var a = 0; a < self.events.length; a++) {
        var r = self.events[a];
        (r.q) ? r.e.unbind(r.n, r.f): self._unbind(r.e, r.n, r.f, r.b);
      }
    };

    this.showRail = function() {
      if ((self.page.maxh != 0) && (self.ispage || self.win.css('display') != 'none')) {
        self.visibility = true;
        self.rail.visibility = true;
        self.rail.css('display', 'block');
      }
      return self;
    };

    this.showRailHr = function() {
      if (!self.railh) return self;
      if ((self.page.maxw != 0) && (self.ispage || self.win.css('display') != 'none')) {
        self.railh.visibility = true;
        self.railh.css('display', 'block');
      }
      return self;
    };

    this.hideRail = function() {
      self.visibility = false;
      self.rail.visibility = false;
      self.rail.css('display', 'none');
      return self;
    };

    this.hideRailHr = function() {
      if (!self.railh) return self;
      self.railh.visibility = false;
      self.railh.css('display', 'none');
      return self;
    };

    this.show = function() {
      self.hidden = false;
      self.railslocked = false;
      return self.showRail().showRailHr();
    };

    this.hide = function() {
      self.hidden = true;
      self.railslocked = true;
      return self.hideRail().hideRailHr();
    };

    this.toggle = function() {
      return (self.hidden) ? self.show() : self.hide();
    };

    this.remove = function() {
      self.stop();
      if (self.cursortimeout) clearTimeout(self.cursortimeout);
      self.doZoomOut();
      self.unbindAll();

      if (cap.isie9) self.win[0].detachEvent("onpropertychange", self.onAttributeChange); //IE9 DOMAttrModified bug

      if (self.observer !== false) self.observer.disconnect();
      if (self.observerremover !== false) self.observerremover.disconnect();
      if (self.observerbody !== false) self.observerbody.disconnect();

      self.events = null;

      if (self.cursor) {
        self.cursor.remove();
      }
      if (self.cursorh) {
        self.cursorh.remove();
      }
      if (self.rail) {
        self.rail.remove();
      }
      if (self.railh) {
        self.railh.remove();
      }
      if (self.zoom) {
        self.zoom.remove();
      }
      for (var a = 0; a < self.saved.css.length; a++) {
        var d = self.saved.css[a];
        d[0].css(d[1], (typeof d[2] == "undefined") ? '' : d[2]);
      }
      self.saved = false;
      self.me.data('__nicescroll', ''); //erase all traces

      // memory leak fixed by GianlucaGuarini - thanks a lot!
      // remove the current nicescroll from the $.nicescroll array & normalize array
      var lst = $.nicescroll;
      lst.each(function(i) {
        if (!this) return;
        if (this.id === self.id) {
          delete lst[i];
          for (var b = ++i; b < lst.length; b++, i++) lst[i] = lst[b];
          lst.length--;
          if (lst.length) delete lst[lst.length];
        }
      });

      for (var i in self) {
        self[i] = null;
        delete self[i];
      }

      self = null;

    };

    this.scrollstart = function(fn) {
      this.onscrollstart = fn;
      return self;
    };
    this.scrollend = function(fn) {
      this.onscrollend = fn;
      return self;
    };
    this.scrollcancel = function(fn) {
      this.onscrollcancel = fn;
      return self;
    };

    this.zoomin = function(fn) {
      this.onzoomin = fn;
      return self;
    };
    this.zoomout = function(fn) {
      this.onzoomout = fn;
      return self;
    };

    this.isScrollable = function(e) {
      var dom = (e.target) ? e.target : e;
      if (dom.nodeName == 'OPTION') return true;
      while (dom && (dom.nodeType == 1) && !(/^BODY|HTML/.test(dom.nodeName))) {
        var dd = $(dom);
        var ov = dd.css('overflowY') || dd.css('overflowX') || dd.css('overflow') || '';
        if (/scroll|auto/.test(ov)) return (dom.clientHeight != dom.scrollHeight);
        dom = (dom.parentNode) ? dom.parentNode : false;
      }
      return false;
    };

    this.getViewport = function(me) {
      var dom = (me && me.parentNode) ? me.parentNode : false;
      while (dom && (dom.nodeType == 1) && !(/^BODY|HTML/.test(dom.nodeName))) {
        var dd = $(dom);
        if (/fixed|absolute/.test(dd.css("position"))) return dd;
        var ov = dd.css('overflowY') || dd.css('overflowX') || dd.css('overflow') || '';
        if ((/scroll|auto/.test(ov)) && (dom.clientHeight != dom.scrollHeight)) return dd;
        if (dd.getNiceScroll().length > 0) return dd;
        dom = (dom.parentNode) ? dom.parentNode : false;
      }
      return false; //(dom) ? $(dom) : false;
    };

    this.triggerScrollEnd = function() {
      if (!self.onscrollend) return;

      var px = self.getScrollLeft();
      var py = self.getScrollTop();

      var info = {
        "type": "scrollend",
        "current": {
          "x": px,
          "y": py
        },
        "end": {
          "x": px,
          "y": py
        }
      };
      self.onscrollend.call(self, info);
    }

    function execScrollWheel(e, hr, chkscroll) {
      var px, py;
      
      if (e.deltaMode == 0) { // PIXEL
        px = -Math.floor(e.deltaX * (self.opt.mousescrollstep / (18 * 3)));
        py = -Math.floor(e.deltaY * (self.opt.mousescrollstep / (18 * 3)));
      } else if (e.deltaMode == 1) { // LINE
        px = -Math.floor(e.deltaX * self.opt.mousescrollstep);
        py = -Math.floor(e.deltaY * self.opt.mousescrollstep);
      }

      if (hr && self.opt.oneaxismousemode && (px == 0) && py) { // classic vertical-only mousewheel + browser with x/y support 
        px = py;
        py = 0;
      
        if (chkscroll) {
          var hrend = (px < 0) ? (self.getScrollLeft() >= self.page.maxw) : (self.getScrollLeft() <= 0);
          if (hrend) {  // preserve vertical scrolling
            py = px;
            px = 0;            
          }
        }
        
      }

      if (px) {
        if (self.scrollmom) {
          self.scrollmom.stop()
        }
        self.lastdeltax += px;
        self.debounced("mousewheelx", function() {
          var dt = self.lastdeltax;
          self.lastdeltax = 0;
          if (!self.rail.drag) {
            self.doScrollLeftBy(dt)
          }
        }, 15);
      }
      if (py) {
        if (self.opt.nativeparentscrolling && chkscroll && !self.ispage && !self.zoomactive) {
          if (py < 0) {
            if (self.getScrollTop() >= self.page.maxh) return true;
          } else {
            if (self.getScrollTop() <= 0) return true;
          }
        }
        if (self.scrollmom) {
          self.scrollmom.stop()
        }
        self.lastdeltay += py;
        self.debounced("mousewheely", function() {
          var dt = self.lastdeltay;
          self.lastdeltay = 0;
          if (!self.rail.drag) {
            self.doScrollBy(dt)
          }
        }, 15);
      }

      e.stopImmediatePropagation();
      return e.preventDefault();
    };

    this.onmousewheel = function(e) {
      if (self.wheelprevented) return;
      if (self.railslocked) {
        self.debounced("checkunlock", self.resize, 250);
        return true;
      }
      if (self.rail.drag) return self.cancelEvent(e);

      if (self.opt.oneaxismousemode == "auto" && e.deltaX != 0) self.opt.oneaxismousemode = false; // check two-axis mouse support (not very elegant)

      if (self.opt.oneaxismousemode && e.deltaX == 0) {
        if (!self.rail.scrollable) {
          if (self.railh && self.railh.scrollable) {
            return self.onmousewheelhr(e);
          } else {
            return true;
          }
        }
      }

      var nw = +(new Date());
      var chk = false;
      if (self.opt.preservenativescrolling && ((self.checkarea + 600) < nw)) {
        self.nativescrollingarea = self.isScrollable(e);
        chk = true;
      }
      self.checkarea = nw;
      if (self.nativescrollingarea) return true; // this isn't my business
      var ret = execScrollWheel(e, false, chk);
      if (ret) self.checkarea = 0;
      return ret;
    };

    this.onmousewheelhr = function(e) {
      if (self.wheelprevented) return;
      if (self.railslocked || !self.railh.scrollable) return true;
      if (self.rail.drag) return self.cancelEvent(e);

      var nw = +(new Date());
      var chk = false;
      if (self.opt.preservenativescrolling && ((self.checkarea + 600) < nw)) {
        self.nativescrollingarea = self.isScrollable(e);
        chk = true;
      }
      self.checkarea = nw;
      if (self.nativescrollingarea) return true; // this isn't my business
      if (self.railslocked) return self.cancelEvent(e);

      return execScrollWheel(e, true, chk);
    };

    this.stop = function() {
      self.cancelScroll();
      if (self.scrollmon) self.scrollmon.stop();
      self.cursorfreezed = false;
      self.scroll.y = Math.round(self.getScrollTop() * (1 / self.scrollratio.y));
      self.noticeCursor();
      return self;
    };

    this.getTransitionSpeed = function(dif) {
      var sp = Math.round(self.opt.scrollspeed * 10);
      var ex = Math.min(sp, Math.round((dif / 20) * self.opt.scrollspeed));
      return (ex > 20) ? ex : 0;
    };

    if (!self.opt.smoothscroll) {
      this.doScrollLeft = function(x, spd) { //direct
        var y = self.getScrollTop();
        self.doScrollPos(x, y, spd);
      };
      this.doScrollTop = function(y, spd) { //direct
        var x = self.getScrollLeft();
        self.doScrollPos(x, y, spd);
      };
      this.doScrollPos = function(x, y, spd) { //direct
        var nx = (x > self.page.maxw) ? self.page.maxw : x;
        if (nx < 0) nx = 0;
        var ny = (y > self.page.maxh) ? self.page.maxh : y;
        if (ny < 0) ny = 0;
        self.synched('scroll', function() {
          self.setScrollTop(ny);
          self.setScrollLeft(nx);
        });
      };
      this.cancelScroll = function() {}; // direct
    } else if (self.ishwscroll && cap.hastransition && self.opt.usetransition && !!self.opt.smoothscroll) {
      this.prepareTransition = function(dif, istime) {
        var ex = (istime) ? ((dif > 20) ? dif : 0) : self.getTransitionSpeed(dif);
        var trans = (ex) ? cap.prefixstyle + 'transform ' + ex + 'ms ease-out' : '';
        if (!self.lasttransitionstyle || self.lasttransitionstyle != trans) {
          self.lasttransitionstyle = trans;
          self.doc.css(cap.transitionstyle, trans);
        }
        return ex;
      };

      this.doScrollLeft = function(x, spd) { //trans
        var y = (self.scrollrunning) ? self.newscrolly : self.getScrollTop();
        self.doScrollPos(x, y, spd);
      };

      this.doScrollTop = function(y, spd) { //trans
        var x = (self.scrollrunning) ? self.newscrollx : self.getScrollLeft();
        self.doScrollPos(x, y, spd);
      };

      this.doScrollPos = function(x, y, spd) { //trans

        var py = self.getScrollTop();
        var px = self.getScrollLeft();

        if (((self.newscrolly - py) * (y - py) < 0) || ((self.newscrollx - px) * (x - px) < 0)) self.cancelScroll(); //inverted movement detection      

        if (self.opt.bouncescroll == false) {
          if (y < 0) y = 0;
          else if (y > self.page.maxh) y = self.page.maxh;
          if (x < 0) x = 0;
          else if (x > self.page.maxw) x = self.page.maxw;
        }

        if (self.scrollrunning && x == self.newscrollx && y == self.newscrolly) return false;

        self.newscrolly = y;
        self.newscrollx = x;

        self.newscrollspeed = spd || false;

        if (self.timer) return false;

        self.timer = setTimeout(function() {

          var top = self.getScrollTop();
          var lft = self.getScrollLeft();

          var dst = {};
          dst.x = x - lft;
          dst.y = y - top;
          dst.px = lft;
          dst.py = top;

          var dd = Math.round(Math.sqrt(Math.pow(dst.x, 2) + Math.pow(dst.y, 2)));
          var ms = (self.newscrollspeed && self.newscrollspeed > 1) ? self.newscrollspeed : self.getTransitionSpeed(dd);
          if (self.newscrollspeed && self.newscrollspeed <= 1) ms *= self.newscrollspeed;

          self.prepareTransition(ms, true);

          if (self.timerscroll && self.timerscroll.tm) clearInterval(self.timerscroll.tm);

          if (ms > 0) {

            if (!self.scrollrunning && self.onscrollstart) {
              var info = {
                "type": "scrollstart",
                "current": {
                  "x": lft,
                  "y": top
                },
                "request": {
                  "x": x,
                  "y": y
                },
                "end": {
                  "x": self.newscrollx,
                  "y": self.newscrolly
                },
                "speed": ms
              };
              self.onscrollstart.call(self, info);
            }

            if (cap.transitionend) {
              if (!self.scrollendtrapped) {
                self.scrollendtrapped = true;
                self.bind(self.doc, cap.transitionend, self.onScrollTransitionEnd, false); //I have got to do something usefull!!
              }
            } else {
              if (self.scrollendtrapped) clearTimeout(self.scrollendtrapped);
              self.scrollendtrapped = setTimeout(self.onScrollTransitionEnd, ms); // simulate transitionend event
            }

            var py = top;
            var px = lft;
            self.timerscroll = {
              bz: new BezierClass(py, self.newscrolly, ms, 0, 0, 0.58, 1),
              bh: new BezierClass(px, self.newscrollx, ms, 0, 0, 0.58, 1)
            };
            if (!self.cursorfreezed) self.timerscroll.tm = setInterval(function() {
              self.showCursor(self.getScrollTop(), self.getScrollLeft())
            }, 60);

          }

          self.synched("doScroll-set", function() {
            self.timer = 0;
            if (self.scrollendtrapped) self.scrollrunning = true;
            self.setScrollTop(self.newscrolly);
            self.setScrollLeft(self.newscrollx);
            if (!self.scrollendtrapped) self.onScrollTransitionEnd();
          });


        }, 50);

      };

      this.cancelScroll = function() {
        if (!self.scrollendtrapped) return true;
        var py = self.getScrollTop();
        var px = self.getScrollLeft();
        self.scrollrunning = false;
        if (!cap.transitionend) clearTimeout(cap.transitionend);
        self.scrollendtrapped = false;
        self._unbind(self.doc[0], cap.transitionend, self.onScrollTransitionEnd);
        self.prepareTransition(0);
        self.setScrollTop(py); // fire event onscroll
        if (self.railh) self.setScrollLeft(px);
        if (self.timerscroll && self.timerscroll.tm) clearInterval(self.timerscroll.tm);
        self.timerscroll = false;

        self.cursorfreezed = false;

        self.showCursor(py, px);
        return self;
      };
      this.onScrollTransitionEnd = function() {
        if (self.scrollendtrapped) self._unbind(self.doc[0], cap.transitionend, self.onScrollTransitionEnd);
        self.scrollendtrapped = false;
        self.prepareTransition(0);
        if (self.timerscroll && self.timerscroll.tm) clearInterval(self.timerscroll.tm);
        self.timerscroll = false;
        var py = self.getScrollTop();
        var px = self.getScrollLeft();
        self.setScrollTop(py); // fire event onscroll        
        if (self.railh) self.setScrollLeft(px); // fire event onscroll left

        self.noticeCursor(false, py, px);

        self.cursorfreezed = false;

        if (py < 0) py = 0
        else if (py > self.page.maxh) py = self.page.maxh;
        if (px < 0) px = 0
        else if (px > self.page.maxw) px = self.page.maxw;
        if ((py != self.newscrolly) || (px != self.newscrollx)) return self.doScrollPos(px, py, self.opt.snapbackspeed);

        if (self.onscrollend && self.scrollrunning) {
          self.triggerScrollEnd();
        }
        self.scrollrunning = false;

      };

    } else {

      this.doScrollLeft = function(x, spd) { //no-trans
        var y = (self.scrollrunning) ? self.newscrolly : self.getScrollTop();
        self.doScrollPos(x, y, spd);
      };

      this.doScrollTop = function(y, spd) { //no-trans
        var x = (self.scrollrunning) ? self.newscrollx : self.getScrollLeft();
        self.doScrollPos(x, y, spd);
      };

      this.doScrollPos = function(x, y, spd) { //no-trans
        var y = ((typeof y == "undefined") || (y === false)) ? self.getScrollTop(true) : y;

        if ((self.timer) && (self.newscrolly == y) && (self.newscrollx == x)) return true;

        if (self.timer) clearAnimationFrame(self.timer);
        self.timer = 0;

        var py = self.getScrollTop();
        var px = self.getScrollLeft();

        if (((self.newscrolly - py) * (y - py) < 0) || ((self.newscrollx - px) * (x - px) < 0)) self.cancelScroll(); //inverted movement detection

        self.newscrolly = y;
        self.newscrollx = x;

        if (!self.bouncescroll || !self.rail.visibility) {
          if (self.newscrolly < 0) {
            self.newscrolly = 0;
          } else if (self.newscrolly > self.page.maxh) {
            self.newscrolly = self.page.maxh;
          }
        }
        if (!self.bouncescroll || !self.railh.visibility) {
          if (self.newscrollx < 0) {
            self.newscrollx = 0;
          } else if (self.newscrollx > self.page.maxw) {
            self.newscrollx = self.page.maxw;
          }
        }

        self.dst = {};
        self.dst.x = x - px;
        self.dst.y = y - py;
        self.dst.px = px;
        self.dst.py = py;

        var dst = Math.round(Math.sqrt(Math.pow(self.dst.x, 2) + Math.pow(self.dst.y, 2)));

        self.dst.ax = self.dst.x / dst;
        self.dst.ay = self.dst.y / dst;

        var pa = 0;
        var pe = dst;

        if (self.dst.x == 0) {
          pa = py;
          pe = y;
          self.dst.ay = 1;
          self.dst.py = 0;
        } else if (self.dst.y == 0) {
          pa = px;
          pe = x;
          self.dst.ax = 1;
          self.dst.px = 0;
        }

        var ms = self.getTransitionSpeed(dst);
        if (spd && spd <= 1) ms *= spd;
        if (ms > 0) {
          self.bzscroll = (self.bzscroll) ? self.bzscroll.update(pe, ms) : new BezierClass(pa, pe, ms, 0, 1, 0, 1);
        } else {
          self.bzscroll = false;
        }

        if (self.timer) return;

        if ((py == self.page.maxh && y >= self.page.maxh) || (px == self.page.maxw && x >= self.page.maxw)) self.checkContentSize();

        var sync = 1;

        function scrolling() {
          if (self.cancelAnimationFrame) return true;

          self.scrollrunning = true;

          sync = 1 - sync;
          if (sync) return (self.timer = setAnimationFrame(scrolling) || 1);

          var done = 0;
          var sx, sy;

          var sc = sy = self.getScrollTop();
          if (self.dst.ay) {
            sc = (self.bzscroll) ? self.dst.py + (self.bzscroll.getNow() * self.dst.ay) : self.newscrolly;
            var dr = sc - sy;
            if ((dr < 0 && sc < self.newscrolly) || (dr > 0 && sc > self.newscrolly)) sc = self.newscrolly;
            self.setScrollTop(sc);
            if (sc == self.newscrolly) done = 1;
          } else {
            done = 1;
          }

          var scx = sx = self.getScrollLeft();
          if (self.dst.ax) {
            scx = (self.bzscroll) ? self.dst.px + (self.bzscroll.getNow() * self.dst.ax) : self.newscrollx;
            var dr = scx - sx;
            if ((dr < 0 && scx < self.newscrollx) || (dr > 0 && scx > self.newscrollx)) scx = self.newscrollx;
            self.setScrollLeft(scx);
            if (scx == self.newscrollx) done += 1;
          } else {
            done += 1;
          }

          if (done == 2) {
            self.timer = 0;
            self.cursorfreezed = false;
            self.bzscroll = false;
            self.scrollrunning = false;
            if (sc < 0) sc = 0;
            else if (sc > self.page.maxh) sc = self.page.maxh;
            if (scx < 0) scx = 0;
            else if (scx > self.page.maxw) scx = self.page.maxw;
            if ((scx != self.newscrollx) || (sc != self.newscrolly)) self.doScrollPos(scx, sc);
            else {
              if (self.onscrollend) {
                self.triggerScrollEnd();
              }
            }
          } else {
            self.timer = setAnimationFrame(scrolling) || 1;
          }
        };
        self.cancelAnimationFrame = false;
        self.timer = 1;

        if (self.onscrollstart && !self.scrollrunning) {
          var info = {
            "type": "scrollstart",
            "current": {
              "x": px,
              "y": py
            },
            "request": {
              "x": x,
              "y": y
            },
            "end": {
              "x": self.newscrollx,
              "y": self.newscrolly
            },
            "speed": ms
          };
          self.onscrollstart.call(self, info);
        }

        scrolling();

        if ((py == self.page.maxh && y >= py) || (px == self.page.maxw && x >= px)) self.checkContentSize();

        self.noticeCursor();
      };

      this.cancelScroll = function() {
        if (self.timer) clearAnimationFrame(self.timer);
        self.timer = 0;
        self.bzscroll = false;
        self.scrollrunning = false;
        return self;
      };

    }

    this.doScrollBy = function(stp, relative) {
      var ny = 0;
      if (relative) {
        ny = Math.floor((self.scroll.y - stp) * self.scrollratio.y)
      } else {
        var sy = (self.timer) ? self.newscrolly : self.getScrollTop(true);
        ny = sy - stp;
      }
      if (self.bouncescroll) {
        var haf = Math.round(self.view.h / 2);
        if (ny < -haf) ny = -haf
        else if (ny > (self.page.maxh + haf)) ny = (self.page.maxh + haf);
      }
      self.cursorfreezed = false;

      var py = self.getScrollTop(true);
      if (ny < 0 && py <= 0) return self.noticeCursor();
      else if (ny > self.page.maxh && py >= self.page.maxh) {
        self.checkContentSize();
        return self.noticeCursor();
      }

      self.doScrollTop(ny);
    };

    this.doScrollLeftBy = function(stp, relative) {
      var nx = 0;
      if (relative) {
        nx = Math.floor((self.scroll.x - stp) * self.scrollratio.x)
      } else {
        var sx = (self.timer) ? self.newscrollx : self.getScrollLeft(true);
        nx = sx - stp;
      }
      if (self.bouncescroll) {
        var haf = Math.round(self.view.w / 2);
        if (nx < -haf) nx = -haf;
        else if (nx > (self.page.maxw + haf)) nx = (self.page.maxw + haf);
      }
      self.cursorfreezed = false;

      var px = self.getScrollLeft(true);
      if (nx < 0 && px <= 0) return self.noticeCursor();
      else if (nx > self.page.maxw && px >= self.page.maxw) return self.noticeCursor();

      self.doScrollLeft(nx);
    };

    this.doScrollTo = function(pos, relative) {
      var ny = (relative) ? Math.round(pos * self.scrollratio.y) : pos;
      if (ny < 0) ny = 0;
      else if (ny > self.page.maxh) ny = self.page.maxh;
      self.cursorfreezed = false;
      self.doScrollTop(pos);
    };

    this.checkContentSize = function() {
      var pg = self.getContentSize();
      if ((pg.h != self.page.h) || (pg.w != self.page.w)) self.resize(false, pg);
    };

    self.onscroll = function(e) {
      if (self.rail.drag) return;
      if (!self.cursorfreezed) {
        self.synched('scroll', function() {
          self.scroll.y = Math.round(self.getScrollTop() * (1 / self.scrollratio.y));
          if (self.railh) self.scroll.x = Math.round(self.getScrollLeft() * (1 / self.scrollratio.x));
          self.noticeCursor();
        });
      }
    };
    self.bind(self.docscroll, "scroll", self.onscroll);

    this.doZoomIn = function(e) {
      if (self.zoomactive) return;
      self.zoomactive = true;

      self.zoomrestore = {
        style: {}
      };
      var lst = ['position', 'top', 'left', 'zIndex', 'backgroundColor', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight'];
      var win = self.win[0].style;
      for (var a in lst) {
        var pp = lst[a];
        self.zoomrestore.style[pp] = (typeof win[pp] != "undefined") ? win[pp] : '';
      }

      self.zoomrestore.style.width = self.win.css('width');
      self.zoomrestore.style.height = self.win.css('height');

      self.zoomrestore.padding = {
        w: self.win.outerWidth() - self.win.width(),
        h: self.win.outerHeight() - self.win.height()
      };

      if (cap.isios4) {
        self.zoomrestore.scrollTop = $(window).scrollTop();
        $(window).scrollTop(0);
      }

      self.win.css({
        "position": (cap.isios4) ? "absolute" : "fixed",
        "top": 0,
        "left": 0,
        "z-index": globalmaxzindex + 100,
        "margin": "0px"
      });
      var bkg = self.win.css("backgroundColor");
      if (bkg == "" || /transparent|rgba\(0, 0, 0, 0\)|rgba\(0,0,0,0\)/.test(bkg)) self.win.css("backgroundColor", "#fff");
      self.rail.css({
        "z-index": globalmaxzindex + 101
      });
      self.zoom.css({
        "z-index": globalmaxzindex + 102
      });
      self.zoom.css('backgroundPosition', '0px -18px');
      self.resizeZoom();

      if (self.onzoomin) self.onzoomin.call(self);

      return self.cancelEvent(e);
    };

    this.doZoomOut = function(e) {
      if (!self.zoomactive) return;
      self.zoomactive = false;

      self.win.css("margin", "");
      self.win.css(self.zoomrestore.style);

      if (cap.isios4) {
        $(window).scrollTop(self.zoomrestore.scrollTop);
      }

      self.rail.css({
        "z-index": self.zindex
      });
      self.zoom.css({
        "z-index": self.zindex
      });
      self.zoomrestore = false;
      self.zoom.css('backgroundPosition', '0px 0px');
      self.onResize();

      if (self.onzoomout) self.onzoomout.call(self);

      return self.cancelEvent(e);
    };

    this.doZoom = function(e) {
      return (self.zoomactive) ? self.doZoomOut(e) : self.doZoomIn(e);
    };

    this.resizeZoom = function() {
      if (!self.zoomactive) return;

      var py = self.getScrollTop(); //preserve scrolling position
      self.win.css({
        width: $(window).width() - self.zoomrestore.padding.w + "px",
        height: $(window).height() - self.zoomrestore.padding.h + "px"
      });
      self.onResize();

      self.setScrollTop(Math.min(self.page.maxh, py));
    };

    this.init();

    $.nicescroll.push(this);

  };

  // Inspired by the work of Kin Blas
  // http://webpro.host.adobe.com/people/jblas/momentum/includes/jquery.momentum.0.7.js  


  var ScrollMomentumClass2D = function(nc) {
    var self = this;
    this.nc = nc;

    this.lastx = 0;
    this.lasty = 0;
    this.speedx = 0;
    this.speedy = 0;
    this.lasttime = 0;
    this.steptime = 0;
    this.snapx = false;
    this.snapy = false;
    this.demulx = 0;
    this.demuly = 0;

    this.lastscrollx = -1;
    this.lastscrolly = -1;

    this.chkx = 0;
    this.chky = 0;

    this.timer = 0;

    this.time = function() {
      return +new Date(); //beautifull hack
    };

    this.reset = function(px, py) {
      self.stop();
      var now = self.time();
      self.steptime = 0;
      self.lasttime = now;
      self.speedx = 0;
      self.speedy = 0;
      self.lastx = px;
      self.lasty = py;
      self.lastscrollx = -1;
      self.lastscrolly = -1;
    };

    this.update = function(px, py) {
      var now = self.time();
      self.steptime = now - self.lasttime;
      self.lasttime = now;
      var dy = py - self.lasty;
      var dx = px - self.lastx;
      var sy = self.nc.getScrollTop();
      var sx = self.nc.getScrollLeft();
      var newy = sy + dy;
      var newx = sx + dx;
      self.snapx = (newx < 0) || (newx > self.nc.page.maxw);
      self.snapy = (newy < 0) || (newy > self.nc.page.maxh);
      self.speedx = dx;
      self.speedy = dy;
      self.lastx = px;
      self.lasty = py;
    };

    this.stop = function() {
      self.nc.unsynched("domomentum2d");
      if (self.timer) clearTimeout(self.timer);
      self.timer = 0;
      self.lastscrollx = -1;
      self.lastscrolly = -1;
    };

    this.doSnapy = function(nx, ny) {
      var snap = false;

      if (ny < 0) {
        ny = 0;
        snap = true;
      } else if (ny > self.nc.page.maxh) {
        ny = self.nc.page.maxh;
        snap = true;
      }

      if (nx < 0) {
        nx = 0;
        snap = true;
      } else if (nx > self.nc.page.maxw) {
        nx = self.nc.page.maxw;
        snap = true;
      }

      (snap) ? self.nc.doScrollPos(nx, ny, self.nc.opt.snapbackspeed): self.nc.triggerScrollEnd();
    };

    this.doMomentum = function(gp) {
      var t = self.time();
      var l = (gp) ? t + gp : self.lasttime;

      var sl = self.nc.getScrollLeft();
      var st = self.nc.getScrollTop();

      var pageh = self.nc.page.maxh;
      var pagew = self.nc.page.maxw;

      self.speedx = (pagew > 0) ? Math.min(60, self.speedx) : 0;
      self.speedy = (pageh > 0) ? Math.min(60, self.speedy) : 0;

      var chk = l && (t - l) <= 60;

      if ((st < 0) || (st > pageh) || (sl < 0) || (sl > pagew)) chk = false;

      var sy = (self.speedy && chk) ? self.speedy : false;
      var sx = (self.speedx && chk) ? self.speedx : false;

      if (sy || sx) {
        var tm = Math.max(16, self.steptime); //timeout granularity

        if (tm > 50) { // do smooth
          var xm = tm / 50;
          self.speedx *= xm;
          self.speedy *= xm;
          tm = 50;
        }

        self.demulxy = 0;

        self.lastscrollx = self.nc.getScrollLeft();
        self.chkx = self.lastscrollx;
        self.lastscrolly = self.nc.getScrollTop();
        self.chky = self.lastscrolly;

        var nx = self.lastscrollx;
        var ny = self.lastscrolly;

        var onscroll = function() {
          var df = ((self.time() - t) > 600) ? 0.04 : 0.02;

          if (self.speedx) {
            nx = Math.floor(self.lastscrollx - (self.speedx * (1 - self.demulxy)));
            self.lastscrollx = nx;
            if ((nx < 0) || (nx > pagew)) df = 0.10;
          }

          if (self.speedy) {
            ny = Math.floor(self.lastscrolly - (self.speedy * (1 - self.demulxy)));
            self.lastscrolly = ny;
            if ((ny < 0) || (ny > pageh)) df = 0.10;
          }

          self.demulxy = Math.min(1, self.demulxy + df);

          self.nc.synched("domomentum2d", function() {

            if (self.speedx) {
              var scx = self.nc.getScrollLeft();
              if (scx != self.chkx) self.stop();
              self.chkx = nx;
              self.nc.setScrollLeft(nx);
            }

            if (self.speedy) {
              var scy = self.nc.getScrollTop();
              if (scy != self.chky) self.stop();
              self.chky = ny;
              self.nc.setScrollTop(ny);
            }

            if (!self.timer) {
              self.nc.hideCursor();
              self.doSnapy(nx, ny);
            }

          });

          if (self.demulxy < 1) {
            self.timer = setTimeout(onscroll, tm);
          } else {
            self.stop();
            self.nc.hideCursor();
            self.doSnapy(nx, ny);
          }
        };

        onscroll();

      } else {
        self.doSnapy(self.nc.getScrollLeft(), self.nc.getScrollTop());
      }

    }

  };


  // override jQuery scrollTop

  var _scrollTop = jQuery.fn.scrollTop; // preserve original function

  jQuery.cssHooks["pageYOffset"] = {
    get: function(elem, computed, extra) {
      var nice = $.data(elem, '__nicescroll') || false;
      return (nice && nice.ishwscroll) ? nice.getScrollTop() : _scrollTop.call(elem);
    },
    set: function(elem, value) {
      var nice = $.data(elem, '__nicescroll') || false;
      (nice && nice.ishwscroll) ? nice.setScrollTop(parseInt(value)): _scrollTop.call(elem, value);
      return this;
    }
  };

  /*  
  $.fx.step["scrollTop"] = function(fx){    
    $.cssHooks["scrollTop"].set( fx.elem, fx.now + fx.unit );
  };
*/

  jQuery.fn.scrollTop = function(value) {
    if (typeof value == "undefined") {
      var nice = (this[0]) ? $.data(this[0], '__nicescroll') || false : false;
      return (nice && nice.ishwscroll) ? nice.getScrollTop() : _scrollTop.call(this);
    } else {
      return this.each(function() {
        var nice = $.data(this, '__nicescroll') || false;
        (nice && nice.ishwscroll) ? nice.setScrollTop(parseInt(value)): _scrollTop.call($(this), value);
      });
    }
  };

  // override jQuery scrollLeft

  var _scrollLeft = jQuery.fn.scrollLeft; // preserve original function

  $.cssHooks.pageXOffset = {
    get: function(elem, computed, extra) {
      var nice = $.data(elem, '__nicescroll') || false;
      return (nice && nice.ishwscroll) ? nice.getScrollLeft() : _scrollLeft.call(elem);
    },
    set: function(elem, value) {
      var nice = $.data(elem, '__nicescroll') || false;
      (nice && nice.ishwscroll) ? nice.setScrollLeft(parseInt(value)): _scrollLeft.call(elem, value);
      return this;
    }
  };

  /*  
  $.fx.step["scrollLeft"] = function(fx){
    $.cssHooks["scrollLeft"].set( fx.elem, fx.now + fx.unit );
  };  
*/

  jQuery.fn.scrollLeft = function(value) {
    if (typeof value == "undefined") {
      var nice = (this[0]) ? $.data(this[0], '__nicescroll') || false : false;
      return (nice && nice.ishwscroll) ? nice.getScrollLeft() : _scrollLeft.call(this);
    } else {
      return this.each(function() {
        var nice = $.data(this, '__nicescroll') || false;
        (nice && nice.ishwscroll) ? nice.setScrollLeft(parseInt(value)): _scrollLeft.call($(this), value);
      });
    }
  };

  var NiceScrollArray = function(doms) {
    var self = this;
    this.length = 0;
    this.name = "nicescrollarray";

    this.each = function(fn) {
      for (var a = 0, i = 0; a < self.length; a++) fn.call(self[a], i++);
      return self;
    };

    this.push = function(nice) {
      self[self.length] = nice;
      self.length++;
    };

    this.eq = function(idx) {
      return self[idx];
    };

    if (doms) {
      for (var a = 0; a < doms.length; a++) {
        var nice = $.data(doms[a], '__nicescroll') || false;
        if (nice) {
          this[this.length] = nice;
          this.length++;
        }
      };
    }

    return this;
  };

  function mplex(el, lst, fn) {
    for (var a = 0; a < lst.length; a++) fn(el, lst[a]);
  };
  mplex(
    NiceScrollArray.prototype, ['show', 'hide', 'toggle', 'onResize', 'resize', 'remove', 'stop', 'doScrollPos'],
    function(e, n) {
      e[n] = function() {
        var args = arguments;
        return this.each(function() {
          this[n].apply(this, args);
        });
      };
    }
  );

  jQuery.fn.getNiceScroll = function(index) {
    if (typeof index == "undefined") {
      return new NiceScrollArray(this);
    } else {
      var nice = this[index] && $.data(this[index], '__nicescroll') || false;
      return nice;
    }
  };

  jQuery.extend(jQuery.expr[':'], {
    nicescroll: function(a) {
      return ($.data(a, '__nicescroll')) ? true : false;
    }
  });

  $.fn.niceScroll = function(wrapper, opt) {
    if (typeof opt == "undefined") {
      if ((typeof wrapper == "object") && !("jquery" in wrapper)) {
        opt = wrapper;
        wrapper = false;
      }
    }
    opt = $.extend({},opt); // cloning
    var ret = new NiceScrollArray();
    if (typeof opt == "undefined") opt = {};

    if (wrapper || false) {
      opt.doc = $(wrapper);
      opt.win = $(this);
    }
    var docundef = !("doc" in opt);
    if (!docundef && !("win" in opt)) opt.win = $(this);

    this.each(function() {
      var nice = $(this).data('__nicescroll') || false;
      if (!nice) {
        opt.doc = (docundef) ? $(this) : opt.doc;
        nice = new NiceScrollClass(opt, $(this));
        $(this).data('__nicescroll', nice);
      }
      ret.push(nice);
    });
    return (ret.length == 1) ? ret[0] : ret;
  };

  window.NiceScroll = {
    getjQuery: function() {
      return jQuery
    }
  };

  if (!$.nicescroll) {
    $.nicescroll = new NiceScrollArray();
    $.nicescroll.options = _globaloptions;
  }

}));
}.call(window));

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-param-reassign */

  (function (global) {
    var MAX_MESSAGE_LENGTH = 500;
    var MESSAGE_CELL_SELECTOR = '.abuse-reports .message';

    var AbuseReports = function () {
      function AbuseReports() {
        _classCallCheck(this, AbuseReports);

        $(MESSAGE_CELL_SELECTOR).each(this.truncateLongMessage);
        $(document).off('click', MESSAGE_CELL_SELECTOR).on('click', MESSAGE_CELL_SELECTOR, this.toggleMessageTruncation);
      }

      _createClass(AbuseReports, [{
        key: 'truncateLongMessage',
        value: function truncateLongMessage() {
          var $messageCellElement = $(this);
          var reportMessage = $messageCellElement.text();
          if (reportMessage.length > MAX_MESSAGE_LENGTH) {
            $messageCellElement.data('original-message', reportMessage);
            $messageCellElement.data('message-truncated', 'true');
            $messageCellElement.text(global.text.truncate(reportMessage, MAX_MESSAGE_LENGTH));
          }
        }
      }, {
        key: 'toggleMessageTruncation',
        value: function toggleMessageTruncation() {
          var $messageCellElement = $(this);
          var originalMessage = $messageCellElement.data('original-message');
          if (!originalMessage) return;
          if ($messageCellElement.data('message-truncated') === 'true') {
            $messageCellElement.data('message-truncated', 'false');
            $messageCellElement.text(originalMessage);
          } else {
            $messageCellElement.data('message-truncated', 'true');
            $messageCellElement.text(originalMessage.substr(0, MAX_MESSAGE_LENGTH - 3) + '...');
          }
        }
      }]);

      return AbuseReports;
    }();

    global.AbuseReports = AbuseReports;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-param-reassign, class-methods-use-this */
  /* global Pager */
  /* global Cookies */

  (function (global) {
    var Activities = function () {
      function Activities() {
        var _this = this;

        _classCallCheck(this, Activities);

        Pager.init(20, true, false, this.updateTooltips);
        $('.event-filter-link').on('click', function (e) {
          e.preventDefault();
          _this.toggleFilter(e.currentTarget);
          _this.reloadActivities();
        });
      }

      _createClass(Activities, [{
        key: 'updateTooltips',
        value: function updateTooltips() {
          gl.utils.localTimeAgo($('.js-timeago', '.content_list'));
        }
      }, {
        key: 'reloadActivities',
        value: function reloadActivities() {
          $('.content_list').html('');
          Pager.init(20, true, false, this.updateTooltips);
        }
      }, {
        key: 'toggleFilter',
        value: function toggleFilter(sender) {
          var $sender = $(sender);
          var filter = $sender.attr('id').split('_')[0];

          $('.event-filter .active').removeClass('active');
          Cookies.set('event_filter', filter);

          $sender.closest('li').toggleClass('active');
        }
      }]);

      return Activities;
    }();

    global.Activities = Activities;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-param-reassign, comma-dangle */
  /* global Api */

  __webpack_require__(5);

  (function (global) {
    var BlobCiYamlSelector = function (_gl$TemplateSelector) {
      _inherits(BlobCiYamlSelector, _gl$TemplateSelector);

      function BlobCiYamlSelector() {
        _classCallCheck(this, BlobCiYamlSelector);

        return _possibleConstructorReturn(this, (BlobCiYamlSelector.__proto__ || Object.getPrototypeOf(BlobCiYamlSelector)).apply(this, arguments));
      }

      _createClass(BlobCiYamlSelector, [{
        key: 'requestFile',
        value: function requestFile(query) {
          return Api.gitlabCiYml(query.name, this.requestFileSuccess.bind(this));
        }
      }, {
        key: 'requestFileSuccess',
        value: function requestFileSuccess(file) {
          return _get(BlobCiYamlSelector.prototype.__proto__ || Object.getPrototypeOf(BlobCiYamlSelector.prototype), 'requestFileSuccess', this).call(this, file);
        }
      }]);

      return BlobCiYamlSelector;
    }(gl.TemplateSelector);

    global.BlobCiYamlSelector = BlobCiYamlSelector;

    var BlobCiYamlSelectors = function () {
      function BlobCiYamlSelectors() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            editor = _ref.editor,
            $dropdowns = _ref.$dropdowns;

        _classCallCheck(this, BlobCiYamlSelectors);

        this.editor = editor;
        this.$dropdowns = $dropdowns || $('.js-gitlab-ci-yml-selector');
        this.initSelectors();
      }

      _createClass(BlobCiYamlSelectors, [{
        key: 'initSelectors',
        value: function initSelectors() {
          var editor = this.editor;
          this.$dropdowns.each(function (i, dropdown) {
            var $dropdown = $(dropdown);
            return new BlobCiYamlSelector({
              editor: editor,
              pattern: /(.gitlab-ci.yml)/,
              data: $dropdown.data('data'),
              wrapper: $dropdown.closest('.js-gitlab-ci-yml-selector-wrap'),
              dropdown: $dropdown
            });
          });
        }
      }]);

      return BlobCiYamlSelectors;
    }();

    global.BlobCiYamlSelectors = BlobCiYamlSelectors;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Api */

  __webpack_require__(5);

  (function () {
    var global = window.gl || (window.gl = {});

    var BlobDockerfileSelector = function (_gl$TemplateSelector) {
      _inherits(BlobDockerfileSelector, _gl$TemplateSelector);

      function BlobDockerfileSelector() {
        _classCallCheck(this, BlobDockerfileSelector);

        return _possibleConstructorReturn(this, (BlobDockerfileSelector.__proto__ || Object.getPrototypeOf(BlobDockerfileSelector)).apply(this, arguments));
      }

      _createClass(BlobDockerfileSelector, [{
        key: 'requestFile',
        value: function requestFile(query) {
          return Api.dockerfileYml(query.name, this.requestFileSuccess.bind(this));
        }
      }, {
        key: 'requestFileSuccess',
        value: function requestFileSuccess(file) {
          return _get(BlobDockerfileSelector.prototype.__proto__ || Object.getPrototypeOf(BlobDockerfileSelector.prototype), 'requestFileSuccess', this).call(this, file);
        }
      }]);

      return BlobDockerfileSelector;
    }(gl.TemplateSelector);

    global.BlobDockerfileSelector = BlobDockerfileSelector;
  })();
}).call(window);

/***/ }),
/* 63 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var global = window.gl || (window.gl = {});

    var BlobDockerfileSelectors = function () {
      function BlobDockerfileSelectors() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            editor = _ref.editor,
            $dropdowns = _ref.$dropdowns;

        _classCallCheck(this, BlobDockerfileSelectors);

        this.editor = editor;
        this.$dropdowns = $dropdowns || $('.js-dockerfile-selector');
        this.initSelectors();
      }

      _createClass(BlobDockerfileSelectors, [{
        key: 'initSelectors',
        value: function initSelectors() {
          var editor = this.editor;
          this.$dropdowns.each(function (i, dropdown) {
            var $dropdown = $(dropdown);
            return new gl.BlobDockerfileSelector({
              editor: editor,
              pattern: /(Dockerfile)/,
              data: $dropdown.data('data'),
              wrapper: $dropdown.closest('.js-dockerfile-selector-wrap'),
              dropdown: $dropdown
            });
          });
        }
      }]);

      return BlobDockerfileSelectors;
    }();

    global.BlobDockerfileSelectors = BlobDockerfileSelectors;
  })();
}).call(window);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars, no-param-reassign */
  /* global BlobLicenseSelector */

  (function (global) {
    var BlobLicenseSelectors = function BlobLicenseSelectors(_ref) {
      var $dropdowns = _ref.$dropdowns,
          editor = _ref.editor;

      _classCallCheck(this, BlobLicenseSelectors);

      this.$dropdowns = $('.js-license-selector');
      this.editor = editor;
      this.$dropdowns.each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        return new BlobLicenseSelector({
          editor: editor,
          pattern: /^(.+\/)?(licen[sc]e|copying)($|\.)/i,
          data: $dropdown.data('data'),
          wrapper: $dropdown.closest('.js-license-selector-wrap'),
          dropdown: $dropdown
        });
      });
    };

    global.BlobLicenseSelectors = BlobLicenseSelectors;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren */

  $(function () {
    $('.reveal-variables').off('click').on('click', function () {
      $('.js-build').toggle().niceScroll();
      $(this).hide();
    });
  });
}).call(window);

/***/ }),
/* 77 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    window.gl = window.gl || {};

    var CILintEditor = function CILintEditor() {
      var _this = this;

      _classCallCheck(this, CILintEditor);

      this.editor = window.ace.edit('ci-editor');
      this.textarea = document.querySelector('#content');

      this.editor.getSession().setMode('ace/mode/yaml');
      this.editor.on('input', function () {
        var content = _this.editor.getSession().getValue();
        _this.textarea.value = content;
      });
    };

    gl.CILintEditor = CILintEditor;
  })();
}).call(window);

/***/ }),
/* 78 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, object-shorthand, comma-dangle, prefer-arrow-callback, no-else-return, newline-per-chained-call, wrap-iife, max-len */

  (function () {
    this.CompareAutocomplete = function () {
      function CompareAutocomplete() {
        this.initDropdown();
      }

      CompareAutocomplete.prototype.initDropdown = function () {
        return $('.js-compare-dropdown').each(function () {
          var $dropdown, selected;
          $dropdown = $(this);
          selected = $dropdown.data('selected');
          var $dropdownContainer = $dropdown.closest('.dropdown');
          var $fieldInput = $('input[name="' + $dropdown.data('field-name') + '"]', $dropdownContainer);
          var $filterInput = $('input[type="search"]', $dropdownContainer);
          $dropdown.glDropdown({
            data: function data(term, callback) {
              return $.ajax({
                url: $dropdown.data('refs-url'),
                data: {
                  ref: $dropdown.data('ref')
                }
              }).done(function (refs) {
                return callback(refs);
              });
            },
            selectable: true,
            filterable: true,
            filterByText: true,
            fieldName: $dropdown.data('field-name'),
            filterInput: 'input[type="search"]',
            renderRow: function renderRow(ref) {
              var link;
              if (ref.header != null) {
                return $('<li />').addClass('dropdown-header').text(ref.header);
              } else {
                link = $('<a />').attr('href', '#').addClass(ref === selected ? 'is-active' : '').text(ref).attr('data-ref', escape(ref));
                return $('<li />').append(link);
              }
            },
            id: function id(obj, $el) {
              return $el.attr('data-ref');
            },
            toggleLabel: function toggleLabel(obj, $el) {
              return $el.text().trim();
            }
          });
          $filterInput.on('keyup', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode !== 13) return;
            var text = $filterInput.val();
            $fieldInput.val(text);
            $('.dropdown-toggle-text', $dropdown).text(text);
            $dropdownContainer.removeClass('open');
          });

          $dropdownContainer.on('click', '.dropdown-content a', function (e) {
            $dropdown.prop('title', e.target.text.replace(/_+?/g, '-'));
            if ($dropdown.hasClass('has-tooltip')) {
              $dropdown.tooltip('fixTitle');
            }
          });
        });
      };

      return CompareAutocomplete;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable class-methods-use-this, object-shorthand, no-unused-vars, no-use-before-define, no-new, max-len, no-restricted-syntax, guard-for-in, no-continue */
  /* jshint esversion: 6 */

  __webpack_require__(4);

  (function () {
    var gfmRules = {
      // The filters referenced in lib/banzai/pipeline/gfm_pipeline.rb convert
      // GitLab Flavored Markdown (GFM) to HTML.
      // These handlers consequently convert that same HTML to GFM to be copied to the clipboard.
      // Every filter in lib/banzai/pipeline/gfm_pipeline.rb that generates HTML
      // from GFM should have a handler here, in reverse order.
      // The GFM-to-HTML-to-GFM cycle is tested in spec/features/copy_as_gfm_spec.rb.
      InlineDiffFilter: {
        'span.idiff.addition': function spanIdiffAddition(el, text) {
          return '{+' + text + '+}';
        },
        'span.idiff.deletion': function spanIdiffDeletion(el, text) {
          return '{-' + text + '-}';
        }
      },
      TaskListFilter: {
        'input[type=checkbox].task-list-item-checkbox': function inputTypeCheckboxTaskListItemCheckbox(el, text) {
          return '[' + (el.checked ? 'x' : ' ') + ']';
        }
      },
      ReferenceFilter: {
        '.tooltip': function tooltip(el, text) {
          return '';
        },
        'a.gfm:not([data-link=true])': function aGfmNotDataLinkTrue(el, text) {
          return el.dataset.original || text;
        }
      },
      AutolinkFilter: {
        'a': function a(el, text) {
          // Fallback on the regular MarkdownFilter's `a` handler.
          if (text !== el.getAttribute('href')) return false;

          return text;
        }
      },
      TableOfContentsFilter: {
        'ul.section-nav': function ulSectionNav(el, text) {
          return '[[_TOC_]]';
        }
      },
      EmojiFilter: {
        'img.emoji': function imgEmoji(el, text) {
          return el.getAttribute('alt');
        }
      },
      ImageLinkFilter: {
        'a.no-attachment-icon': function aNoAttachmentIcon(el, text) {
          return text;
        }
      },
      VideoLinkFilter: {
        '.video-container': function videoContainer(el, text) {
          var videoEl = el.querySelector('video');
          if (!videoEl) return false;

          return CopyAsGFM.nodeToGFM(videoEl);
        },
        'video': function video(el, text) {
          return '![' + el.dataset.title + '](' + el.getAttribute('src') + ')';
        }
      },
      MathFilter: {
        'pre.code.math[data-math-style=display]': function preCodeMathDataMathStyleDisplay(el, text) {
          return '```math\n' + text.trim() + '\n```';
        },
        'code.code.math[data-math-style=inline]': function codeCodeMathDataMathStyleInline(el, text) {
          return '$`' + text + '`$';
        },
        'span.katex-display span.katex-mathml': function spanKatexDisplaySpanKatexMathml(el, text) {
          var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
          if (!mathAnnotation) return false;

          return '```math\n' + CopyAsGFM.nodeToGFM(mathAnnotation) + '\n```';
        },
        'span.katex-mathml': function spanKatexMathml(el, text) {
          var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
          if (!mathAnnotation) return false;

          return '$`' + CopyAsGFM.nodeToGFM(mathAnnotation) + '`$';
        },
        'span.katex-html': function spanKatexHtml(el, text) {
          // We don't want to include the content of this element in the copied text.
          return '';
        },
        'annotation[encoding="application/x-tex"]': function annotationEncodingApplicationXTex(el, text) {
          return text.trim();
        }
      },
      SanitizationFilter: {
        'a[name]:not([href]):empty': function aNameNotHrefEmpty(el, text) {
          return el.outerHTML;
        },
        'dl': function dl(el, text) {
          var lines = text.trim().split('\n');
          // Add two spaces to the front of subsequent list items lines,
          // or leave the line entirely blank.
          lines = lines.map(function (l) {
            var line = l.trim();
            if (line.length === 0) return '';

            return '  ' + line;
          });

          return '<dl>\n' + lines.join('\n') + '\n</dl>';
        },
        'sub, dt, dd, kbd, q, samp, var, ruby, rt, rp, abbr': function subDtDdKbdQSampVarRubyRtRpAbbr(el, text) {
          var tag = el.nodeName.toLowerCase();
          return '<' + tag + '>' + text + '</' + tag + '>';
        }
      },
      SyntaxHighlightFilter: {
        'pre.code.highlight': function preCodeHighlight(el, t) {
          var text = t.trim();

          var lang = el.getAttribute('lang');
          if (lang === 'plaintext') {
            lang = '';
          }

          // Prefixes lines with 4 spaces if the code contains triple backticks
          if (lang === '' && text.match(/^```/gm)) {
            return text.split('\n').map(function (l) {
              var line = l.trim();
              if (line.length === 0) return '';

              return '    ' + line;
            }).join('\n');
          }

          return '```' + lang + '\n' + text + '\n```';
        },
        'pre > code': function preCode(el, text) {
          // Don't wrap code blocks in ``
          return text;
        }
      },
      MarkdownFilter: {
        'br': function br(el, text) {
          // Two spaces at the end of a line are turned into a BR
          return '  ';
        },
        'code': function code(el, text) {
          var backtickCount = 1;
          var backtickMatch = text.match(/`+/);
          if (backtickMatch) {
            backtickCount = backtickMatch[0].length + 1;
          }

          var backticks = Array(backtickCount + 1).join('`');
          var spaceOrNoSpace = backtickCount > 1 ? ' ' : '';

          return backticks + spaceOrNoSpace + text + spaceOrNoSpace + backticks;
        },
        'blockquote': function blockquote(el, text) {
          return text.trim().split('\n').map(function (s) {
            return ('> ' + s).trim();
          }).join('\n');
        },
        'img': function img(el, text) {
          return '![' + el.getAttribute('alt') + '](' + el.getAttribute('src') + ')';
        },
        'a.anchor': function aAnchor(el, text) {
          // Don't render a Markdown link for the anchor link inside a heading
          return text;
        },
        'a': function a(el, text) {
          return '[' + text + '](' + el.getAttribute('href') + ')';
        },
        'li': function li(el, text) {
          var lines = text.trim().split('\n');
          var firstLine = '- ' + lines.shift();
          // Add four spaces to the front of subsequent list items lines,
          // or leave the line entirely blank.
          var nextLines = lines.map(function (s) {
            if (s.trim().length === 0) return '';

            return '    ' + s;
          });

          return firstLine + '\n' + nextLines.join('\n');
        },
        'ul': function ul(el, text) {
          return text;
        },
        'ol': function ol(el, text) {
          // LIs get a `- ` prefix by default, which we replace by `1. ` for ordered lists.
          return text.replace(/^- /mg, '1. ');
        },
        'h1': function h1(el, text) {
          return '# ' + text.trim();
        },
        'h2': function h2(el, text) {
          return '## ' + text.trim();
        },
        'h3': function h3(el, text) {
          return '### ' + text.trim();
        },
        'h4': function h4(el, text) {
          return '#### ' + text.trim();
        },
        'h5': function h5(el, text) {
          return '##### ' + text.trim();
        },
        'h6': function h6(el, text) {
          return '###### ' + text.trim();
        },
        'strong': function strong(el, text) {
          return '**' + text + '**';
        },
        'em': function em(el, text) {
          return '_' + text + '_';
        },
        'del': function del(el, text) {
          return '~~' + text + '~~';
        },
        'sup': function sup(el, text) {
          return '^' + text;
        },
        'hr': function hr(el, text) {
          return '-----';
        },
        'table': function table(el, text) {
          var theadEl = el.querySelector('thead');
          var tbodyEl = el.querySelector('tbody');
          if (!theadEl || !tbodyEl) return false;

          var theadText = CopyAsGFM.nodeToGFM(theadEl);
          var tbodyText = CopyAsGFM.nodeToGFM(tbodyEl);

          return theadText + tbodyText;
        },
        'thead': function thead(el, text) {
          var cells = _.map(el.querySelectorAll('th'), function (cell) {
            var chars = CopyAsGFM.nodeToGFM(cell).trim().length + 2;

            var before = '';
            var after = '';
            switch (cell.style.textAlign) {
              case 'center':
                before = ':';
                after = ':';
                chars -= 2;
                break;
              case 'right':
                after = ':';
                chars -= 1;
                break;
              default:
                break;
            }

            chars = Math.max(chars, 3);

            var middle = Array(chars + 1).join('-');

            return before + middle + after;
          });

          return text + '|' + cells.join('|') + '|';
        },
        'tr': function tr(el, text) {
          var cells = _.map(el.querySelectorAll('td, th'), function (cell) {
            return CopyAsGFM.nodeToGFM(cell).trim();
          });
          return '| ' + cells.join(' | ') + ' |';
        }
      }
    };

    var CopyAsGFM = function () {
      function CopyAsGFM() {
        _classCallCheck(this, CopyAsGFM);

        $(document).on('copy', '.md, .wiki', this.handleCopy);
        $(document).on('paste', '.js-gfm-input', this.handlePaste);
      }

      _createClass(CopyAsGFM, [{
        key: 'handleCopy',
        value: function handleCopy(e) {
          var clipboardData = e.originalEvent.clipboardData;
          if (!clipboardData) return;

          var documentFragment = window.gl.utils.getSelectedFragment();
          if (!documentFragment) return;

          // If the documentFragment contains more than just Markdown, don't copy as GFM.
          if (documentFragment.querySelector('.md, .wiki')) return;

          e.preventDefault();
          clipboardData.setData('text/plain', documentFragment.textContent);

          var gfm = CopyAsGFM.nodeToGFM(documentFragment);
          clipboardData.setData('text/x-gfm', gfm);
        }
      }, {
        key: 'handlePaste',
        value: function handlePaste(e) {
          var clipboardData = e.originalEvent.clipboardData;
          if (!clipboardData) return;

          var gfm = clipboardData.getData('text/x-gfm');
          if (!gfm) return;

          e.preventDefault();

          window.gl.utils.insertText(e.target, gfm);
        }
      }], [{
        key: 'nodeToGFM',
        value: function nodeToGFM(node) {
          if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent;
          }

          var text = this.innerGFM(node);

          if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            return text;
          }

          for (var filter in gfmRules) {
            var rules = gfmRules[filter];

            for (var selector in rules) {
              var func = rules[selector];

              if (!window.gl.utils.nodeMatchesSelector(node, selector)) continue;

              var result = func(node, text);
              if (result === false) continue;

              return result;
            }
          }

          return text;
        }
      }, {
        key: 'innerGFM',
        value: function innerGFM(parentNode) {
          var nodes = parentNode.childNodes;

          var clonedParentNode = parentNode.cloneNode(true);
          var clonedNodes = Array.prototype.slice.call(clonedParentNode.childNodes, 0);

          for (var i = 0; i < nodes.length; i += 1) {
            var node = nodes[i];
            var clonedNode = clonedNodes[i];

            var text = this.nodeToGFM(node);

            // `clonedNode.replaceWith(text)` is not yet widely supported
            clonedNode.parentNode.replaceChild(document.createTextNode(text), clonedNode);
          }

          return clonedParentNode.innerText || clonedParentNode.textContent;
        }
      }]);

      return CopyAsGFM;
    }();

    window.gl = window.gl || {};
    window.gl.CopyAsGFM = CopyAsGFM;

    new CopyAsGFM();
  })();
}).call(window);

/***/ }),
/* 80 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, comma-dangle, prefer-template, quotes, no-param-reassign, wrap-iife, max-len */
  /* global Api */

  (function (w) {
    var CreateLabelDropdown = function () {
      function CreateLabelDropdown($el, namespacePath, projectPath) {
        _classCallCheck(this, CreateLabelDropdown);

        this.$el = $el;
        this.namespacePath = namespacePath;
        this.projectPath = projectPath;
        this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
        this.$cancelButton = $('.js-cancel-label-btn', this.$el);
        this.$newLabelField = $('#new_label_name', this.$el);
        this.$newColorField = $('#new_label_color', this.$el);
        this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
        this.$newLabelError = $('.js-label-error', this.$el);
        this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
        this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

        this.$newLabelError.hide();
        this.$newLabelCreateButton.disable();

        this.cleanBinding();
        this.addBinding();
      }

      _createClass(CreateLabelDropdown, [{
        key: 'cleanBinding',
        value: function cleanBinding() {
          this.$colorSuggestions.off('click');
          this.$newLabelField.off('keyup change');
          this.$newColorField.off('keyup change');
          this.$dropdownBack.off('click');
          this.$cancelButton.off('click');
          this.$newLabelCreateButton.off('click');
        }
      }, {
        key: 'addBinding',
        value: function addBinding() {
          var self = this;

          this.$colorSuggestions.on('click', function (e) {
            var $this = $(this);
            self.addColorValue(e, $this);
          });

          this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
          this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

          this.$dropdownBack.on('click', this.resetForm.bind(this));

          this.$cancelButton.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            self.resetForm();
            self.$dropdownBack.trigger('click');
          });

          this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
        }
      }, {
        key: 'addColorValue',
        value: function addColorValue(e, $this) {
          e.preventDefault();
          e.stopPropagation();

          this.$newColorField.val($this.data('color')).trigger('change');
          this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
        }
      }, {
        key: 'enableLabelCreateButton',
        value: function enableLabelCreateButton() {
          if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
            this.$newLabelError.hide();
            this.$newLabelCreateButton.enable();
          } else {
            this.$newLabelCreateButton.disable();
          }
        }
      }, {
        key: 'resetForm',
        value: function resetForm() {
          this.$newLabelField.val('').trigger('change');

          this.$newColorField.val('').trigger('change');

          this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
        }
      }, {
        key: 'saveLabel',
        value: function saveLabel(e) {
          var _this = this;

          e.preventDefault();
          e.stopPropagation();

          Api.newLabel(this.namespacePath, this.projectPath, {
            title: this.$newLabelField.val(),
            color: this.$newColorField.val()
          }, function (label) {
            _this.$newLabelCreateButton.enable();

            if (label.message) {
              var errors = void 0;

              if (typeof label.message === 'string') {
                errors = label.message;
              } else {
                errors = label.message.map(function (value, key) {
                  return key + " " + value[0];
                }).join("<br/>");
              }

              _this.$newLabelError.html(errors).show();
            } else {
              _this.$dropdownBack.trigger('click');

              $(document).trigger('created.label', label);
            }
          });
        }
      }]);

      return CreateLabelDropdown;
    }();

    if (!w.gl) {
      w.gl = {};
    }

    gl.CreateLabelDropdown = CreateLabelDropdown;
  })(window);
}).call(window);

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable class-methods-use-this */

  __webpack_require__(38);

  (function () {
    var UNFOLD_COUNT = 20;
    var isBound = false;

    var Diff = function () {
      function Diff() {
        _classCallCheck(this, Diff);

        var $diffFile = $('.files .diff-file');
        $diffFile.singleFileDiff();
        $diffFile.filesCommentButton();

        $diffFile.each(function (index, file) {
          return new gl.ImageFile(file);
        });

        if (this.diffViewType() === 'parallel') {
          $('.content-wrapper .container-fluid').removeClass('container-limited');
        }

        if (!isBound) {
          $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this));
          isBound = true;
        }

        this.openAnchoredDiff();
      }

      _createClass(Diff, [{
        key: 'handleClickUnfold',
        value: function handleClickUnfold(e) {
          var $target = $(e.target);
          // current babel config relies on iterators implementation, so we cannot simply do:
          // const [oldLineNumber, newLineNumber] = this.lineNumbers($target.parent());
          var ref = this.lineNumbers($target.parent());
          var oldLineNumber = ref[0];
          var newLineNumber = ref[1];
          var offset = newLineNumber - oldLineNumber;
          var bottom = $target.hasClass('js-unfold-bottom');
          var since = void 0;
          var to = void 0;
          var unfold = true;

          if (bottom) {
            var lineNumber = newLineNumber + 1;
            since = lineNumber;
            to = lineNumber + UNFOLD_COUNT;
          } else {
            var _lineNumber = newLineNumber - 1;
            since = _lineNumber - UNFOLD_COUNT;
            to = _lineNumber;

            // make sure we aren't loading more than we need
            var prevNewLine = this.lineNumbers($target.parent().prev())[1];
            if (since <= prevNewLine + 1) {
              since = prevNewLine + 1;
              unfold = false;
            }
          }

          var file = $target.parents('.diff-file');
          var link = file.data('blob-diff-path');
          var view = file.data('view');

          var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
          $.get(link, params, function (response) {
            return $target.parent().replaceWith(response);
          });
        }
      }, {
        key: 'openAnchoredDiff',
        value: function openAnchoredDiff(cb) {
          var _this = this;

          var locationHash = gl.utils.getLocationHash();
          var anchoredDiff = locationHash && locationHash.split('_')[0];

          if (!anchoredDiff) return;

          var diffTitle = $('#' + anchoredDiff);
          var diffFile = diffTitle.closest('.diff-file');
          var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
          if (nothingHereBlock.length) {
            var clickTarget = $('.file-title, .click-to-expand', diffFile);
            diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
              _this.highlighSelectedLine();
              if (cb) cb();
            });
          } else if (cb) {
            cb();
          }
        }
      }, {
        key: 'handleClickLineNum',
        value: function handleClickLineNum(e) {
          var hash = $(e.currentTarget).attr('href');
          e.preventDefault();
          if (window.history.pushState) {
            window.history.pushState(null, null, hash);
          } else {
            window.location.hash = hash;
          }
          this.highlighSelectedLine();
        }
      }, {
        key: 'diffViewType',
        value: function diffViewType() {
          return $('.inline-parallel-buttons a.active').data('view-type');
        }
      }, {
        key: 'lineNumbers',
        value: function lineNumbers(line) {
          if (!line.children().length) {
            return [0, 0];
          }
          return line.find('.diff-line-num').map(function (i, elm) {
            return parseInt($(elm).data('linenumber'), 10);
          });
        }
      }, {
        key: 'highlighSelectedLine',
        value: function highlighSelectedLine() {
          var hash = gl.utils.getLocationHash();
          var $diffFiles = $('.diff-file');
          $diffFiles.find('.hll').removeClass('hll');

          if (hash) {
            $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
          }
        }
      }]);

      return Diff;
    }();

    window.gl = window.gl || {};
    window.gl.Diff = Diff;
  })();
}).call(window);

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, wrap-iife, no-shadow, consistent-return, one-var, one-var-declaration-per-line, camelcase, default-case, no-new, quotes, no-duplicate-case, no-case-declarations, no-fallthrough, max-len */
  /* global UsernameValidator */
  /* global ActiveTabMemoizer */
  /* global ShortcutsNavigation */
  /* global Build */
  /* global Issuable */
  /* global Issue */
  /* global ShortcutsIssuable */
  /* global ZenMode */
  /* global Milestone */
  /* global IssuableForm */
  /* global LabelsSelect */
  /* global MilestoneSelect */
  /* global MergedButtons */
  /* global Commit */
  /* global NotificationsForm */
  /* global TreeView */
  /* global NotificationsDropdown */
  /* global UsersSelect */
  /* global GroupAvatar */
  /* global LineHighlighter */
  /* global ProjectFork */
  /* global BuildArtifacts */
  /* global GroupsSelect */
  /* global Search */
  /* global Admin */
  /* global NamespaceSelects */
  /* global ShortcutsDashboardNavigation */
  /* global Project */
  /* global ProjectAvatar */
  /* global CompareAutocomplete */
  /* global ProjectNew */
  /* global Star */
  /* global ProjectShow */
  /* global Labels */
  /* global Shortcuts */

  var ShortcutsBlob = __webpack_require__(40);

  (function () {
    var Dispatcher;

    $(function () {
      return new Dispatcher();
    });

    Dispatcher = function () {
      function Dispatcher() {
        this.initSearch();
        this.initFieldErrors();
        this.initPageScripts();
      }

      Dispatcher.prototype.initPageScripts = function () {
        var page, path, shortcut_handler;
        page = $('body').attr('data-page');
        if (!page) {
          return false;
        }
        path = page.split(':');
        shortcut_handler = null;
        switch (page) {
          case 'sessions:new':
            new UsernameValidator();
            new ActiveTabMemoizer();
            break;
          case 'projects:boards:show':
          case 'projects:boards:index':
            shortcut_handler = new ShortcutsNavigation();
            break;
          case 'projects:builds:show':
            new Build();
            break;
          case 'projects:merge_requests:index':
          case 'projects:issues:index':
            if (gl.FilteredSearchManager) {
              new gl.FilteredSearchManager();
            }
            Issuable.init();
            new gl.IssuableBulkActions({
              prefixId: page === 'projects:merge_requests:index' ? 'merge_request_' : 'issue_'
            });
            shortcut_handler = new ShortcutsNavigation();
            break;
          case 'projects:issues:show':
            new Issue();
            shortcut_handler = new ShortcutsIssuable();
            new ZenMode();
            break;
          case 'projects:milestones:show':
          case 'groups:milestones:show':
          case 'dashboard:milestones:show':
            new Milestone();
            break;
          case 'dashboard:todos:index':
            new gl.Todos();
            break;
          case 'projects:milestones:new':
          case 'projects:milestones:edit':
            new ZenMode();
            new gl.DueDateSelectors();
            new gl.GLForm($('.milestone-form'));
            break;
          case 'groups:milestones:new':
            new ZenMode();
            break;
          case 'projects:compare:show':
            new gl.Diff();
            break;
          case 'projects:issues:new':
          case 'projects:issues:edit':
            shortcut_handler = new ShortcutsNavigation();
            new gl.GLForm($('.issue-form'));
            new IssuableForm($('.issue-form'));
            new LabelsSelect();
            new MilestoneSelect();
            new gl.IssuableTemplateSelectors();
            break;
          case 'projects:merge_requests:new':
          case 'projects:merge_requests:edit':
            new gl.Diff();
            shortcut_handler = new ShortcutsNavigation();
            new gl.GLForm($('.merge-request-form'));
            new IssuableForm($('.merge-request-form'));
            new LabelsSelect();
            new MilestoneSelect();
            new gl.IssuableTemplateSelectors();
            break;
          case 'projects:tags:new':
            new ZenMode();
            new gl.GLForm($('.tag-form'));
            break;
          case 'projects:releases:edit':
            new ZenMode();
            new gl.GLForm($('.release-form'));
            break;
          case 'projects:merge_requests:show':
            new gl.Diff();
            shortcut_handler = new ShortcutsIssuable(true);
            new ZenMode();
            new MergedButtons();
            break;
          case 'projects:merge_requests:commits':
            new MergedButtons();
            break;
          case "projects:merge_requests:diffs":
            new gl.Diff();
            new ZenMode();
            new MergedButtons();
            break;
          case 'dashboard:activity':
            new gl.Activities();
            break;
          case 'dashboard:projects:starred':
            new gl.Activities();
            break;
          case 'projects:commit:show':
            new Commit();
            new gl.Diff();
            new ZenMode();
            shortcut_handler = new ShortcutsNavigation();
            break;
          case 'projects:commit:pipelines':
            new gl.MiniPipelineGraph({
              container: '.js-pipeline-table'
            }).bindEvents();
            break;
          case 'projects:commits:show':
          case 'projects:activity':
            shortcut_handler = new ShortcutsNavigation();
            break;
          case 'projects:show':
            shortcut_handler = new ShortcutsNavigation();
            new NotificationsForm();
            if ($('#tree-slider').length) {
              new TreeView();
            }
            break;
          case 'projects:pipelines:builds':
          case 'projects:pipelines:show':
            var controllerAction = document.querySelector('.js-pipeline-container').dataset.controllerAction;


            new gl.Pipelines({
              initTabs: true,
              tabsOptions: {
                action: controllerAction,
                defaultAction: 'pipelines',
                parentEl: '.pipelines-tabs'
              }
            });
            break;
          case 'groups:activity':
            new gl.Activities();
            break;
          case 'groups:show':
            shortcut_handler = new ShortcutsNavigation();
            new NotificationsForm();
            new NotificationsDropdown();
            break;
          case 'groups:group_members:index':
            new gl.MemberExpirationDate();
            new gl.Members();
            new UsersSelect();
            break;
          case 'projects:members:show':
            new gl.MemberExpirationDate('.js-access-expiration-date-groups');
            new GroupsSelect();
            new gl.MemberExpirationDate();
            new gl.Members();
            new UsersSelect();
            break;
          case 'groups:new':
          case 'groups:edit':
          case 'admin:groups:edit':
          case 'admin:groups:new':
            new GroupAvatar();
            break;
          case 'projects:tree:show':
            shortcut_handler = new ShortcutsNavigation();
            new TreeView();
            break;
          case 'projects:find_file:show':
            shortcut_handler = true;
            break;
          case 'projects:blob:show':
          case 'projects:blame:show':
            new LineHighlighter();
            shortcut_handler = new ShortcutsNavigation();
            var fileBlobPermalinkUrlElement = document.querySelector('.js-data-file-blob-permalink-url');
            var fileBlobPermalinkUrl = fileBlobPermalinkUrlElement && fileBlobPermalinkUrlElement.getAttribute('href');
            new ShortcutsBlob({
              skipResetBindings: true,
              fileBlobPermalinkUrl: fileBlobPermalinkUrl
            });
            break;
          case 'groups:labels:new':
          case 'groups:labels:edit':
          case 'projects:labels:new':
          case 'projects:labels:edit':
            new Labels();
            break;
          case 'projects:labels:index':
            if ($('.prioritized-labels').length) {
              new gl.LabelManager();
            }
            break;
          case 'projects:network:show':
            // Ensure we don't create a particular shortcut handler here. This is
            // already created, where the network graph is created.
            shortcut_handler = true;
            break;
          case 'projects:forks:new':
            new ProjectFork();
            break;
          case 'projects:artifacts:browse':
            new BuildArtifacts();
            break;
          case 'help:index':
            gl.VersionCheckImage.bindErrorEvent($('img.js-version-status-badge'));
            break;
          case 'search:show':
            new Search();
            break;
          case 'projects:protected_branches:index':
            new gl.ProtectedBranchCreate();
            new gl.ProtectedBranchEditList();
            break;
          case 'projects:ci_cd:show':
            new gl.ProjectVariables();
            break;
          case 'ci:lints:create':
          case 'ci:lints:show':
            new gl.CILintEditor();
            break;
        }
        switch (path.first()) {
          case 'sessions':
          case 'omniauth_callbacks':
            if (!gon.u2f) break;
            gl.u2fAuthenticate = new gl.U2FAuthenticate($('#js-authenticate-u2f'), '#js-login-u2f-form', gon.u2f, document.querySelector('#js-login-2fa-device'), document.querySelector('.js-2fa-form'));
            gl.u2fAuthenticate.start();
          case 'admin':
            new Admin();
            switch (path[1]) {
              case 'groups':
                new UsersSelect();
                break;
              case 'projects':
                new NamespaceSelects();
                break;
              case 'labels':
                switch (path[2]) {
                  case 'new':
                  case 'edit':
                    new Labels();
                }
              case 'abuse_reports':
                new gl.AbuseReports();
                break;
            }
            break;
          case 'dashboard':
          case 'root':
            shortcut_handler = new ShortcutsDashboardNavigation();
            break;
          case 'profiles':
            new NotificationsForm();
            new NotificationsDropdown();
            break;
          case 'projects':
            new Project();
            new ProjectAvatar();
            switch (path[1]) {
              case 'compare':
                new CompareAutocomplete();
                break;
              case 'edit':
                shortcut_handler = new ShortcutsNavigation();
                new ProjectNew();
                break;
              case 'new':
                new ProjectNew();
                break;
              case 'show':
                new Star();
                new ProjectNew();
                new ProjectShow();
                new NotificationsDropdown();
                break;
              case 'wikis':
                new gl.Wikis();
                shortcut_handler = new ShortcutsNavigation();
                new ZenMode();
                new gl.GLForm($('.wiki-form'));
                break;
              case 'snippets':
                shortcut_handler = new ShortcutsNavigation();
                if (path[2] === 'show') {
                  new ZenMode();
                }
                break;
              case 'labels':
              case 'graphs':
              case 'compare':
              case 'pipelines':
              case 'forks':
              case 'milestones':
              case 'project_members':
              case 'deploy_keys':
              case 'builds':
              case 'hooks':
              case 'services':
              case 'protected_branches':
                shortcut_handler = new ShortcutsNavigation();
            }
        }
        // If we haven't installed a custom shortcut handler, install the default one
        if (!shortcut_handler) {
          new Shortcuts();
        }
      };

      Dispatcher.prototype.initSearch = function () {
        // Only when search form is present
        if ($('.search').length) {
          return new gl.SearchAutocomplete();
        }
      };

      Dispatcher.prototype.initFieldErrors = function () {
        $('.gl-show-field-errors').each(function (i, form) {
          new gl.GlFieldErrors(form);
        });
      };

      return Dispatcher;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, one-var, no-var, one-var-declaration-per-line, no-unused-vars, camelcase, quotes, no-useless-concat, prefer-template, quote-props, comma-dangle, object-shorthand, consistent-return, prefer-arrow-callback */
  /* global Dropzone */

  __webpack_require__(128);

  (function () {
    this.DropzoneInput = function () {
      function DropzoneInput(form) {
        var $mdArea, alertAttr, alertClass, appendToTextArea, btnAlert, child, closeAlertMessage, closeSpinner, divAlert, divHover, divSpinner, dropzone, form_dropzone, form_textarea, getFilename, handlePaste, iconPaperclip, iconSpinner, insertToTextArea, isImage, max_file_size, pasteText, project_uploads_path, showError, showSpinner, uploadFile, uploadProgress;
        Dropzone.autoDiscover = false;
        alertClass = "alert alert-danger alert-dismissable div-dropzone-alert";
        alertAttr = "class=\"close\" data-dismiss=\"alert\"" + "aria-hidden=\"true\"";
        divHover = "<div class=\"div-dropzone-hover\"></div>";
        divSpinner = "<div class=\"div-dropzone-spinner\"></div>";
        divAlert = "<div class=\"" + alertClass + "\"></div>";
        iconPaperclip = "<i class=\"fa fa-paperclip div-dropzone-icon\"></i>";
        iconSpinner = "<i class=\"fa fa-spinner fa-spin div-dropzone-icon\"></i>";
        uploadProgress = $("<div class=\"div-dropzone-progress\"></div>");
        btnAlert = "<button type=\"button\"" + alertAttr + ">&times;</button>";
        project_uploads_path = window.project_uploads_path || null;
        max_file_size = gon.max_file_size || 10;
        form_textarea = $(form).find(".js-gfm-input");
        form_textarea.wrap("<div class=\"div-dropzone\"></div>");
        form_textarea.on('paste', function (_this) {
          return function (event) {
            return handlePaste(event);
          };
        }(this));
        $mdArea = $(form_textarea).closest('.md-area');
        $(form).setupMarkdownPreview();
        form_dropzone = $(form).find('.div-dropzone');
        form_dropzone.parent().addClass("div-dropzone-wrapper");
        form_dropzone.append(divHover);
        form_dropzone.find(".div-dropzone-hover").append(iconPaperclip);
        form_dropzone.append(divSpinner);
        form_dropzone.find(".div-dropzone-spinner").append(iconSpinner);
        form_dropzone.find(".div-dropzone-spinner").append(uploadProgress);
        form_dropzone.find(".div-dropzone-spinner").css({
          "opacity": 0,
          "display": "none"
        });
        dropzone = form_dropzone.dropzone({
          url: project_uploads_path,
          dictDefaultMessage: "",
          clickable: true,
          paramName: "file",
          maxFilesize: max_file_size,
          uploadMultiple: false,
          headers: {
            "X-CSRF-Token": $("meta[name=\"csrf-token\"]").attr("content")
          },
          previewContainer: false,
          processing: function processing() {
            return $(".div-dropzone-alert").alert("close");
          },
          dragover: function dragover() {
            $mdArea.addClass('is-dropzone-hover');
            form.find(".div-dropzone-hover").css("opacity", 0.7);
          },
          dragleave: function dragleave() {
            $mdArea.removeClass('is-dropzone-hover');
            form.find(".div-dropzone-hover").css("opacity", 0);
          },
          drop: function drop() {
            $mdArea.removeClass('is-dropzone-hover');
            form.find(".div-dropzone-hover").css("opacity", 0);
            form_textarea.focus();
          },
          success: function success(header, response) {
            pasteText(response.link.markdown);
          },
          error: function error(temp) {
            var checkIfMsgExists, errorAlert;
            errorAlert = $(form).find('.error-alert');
            checkIfMsgExists = errorAlert.children().length;
            if (checkIfMsgExists === 0) {
              errorAlert.append(divAlert);
              $(".div-dropzone-alert").append(btnAlert + "Attaching the file failed.");
            }
          },
          totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
            uploadProgress.text(Math.round(totalUploadProgress) + "%");
          },
          sending: function sending() {
            form_dropzone.find(".div-dropzone-spinner").css({
              "opacity": 0.7,
              "display": "inherit"
            });
          },
          queuecomplete: function queuecomplete() {
            uploadProgress.text("");
            $(".dz-preview").remove();
            $(".markdown-area").trigger("input");
            $(".div-dropzone-spinner").css({
              "opacity": 0,
              "display": "none"
            });
          }
        });
        child = $(dropzone[0]).children("textarea");
        handlePaste = function handlePaste(event) {
          var filename, image, pasteEvent, text;
          pasteEvent = event.originalEvent;
          if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
            image = isImage(pasteEvent);
            if (image) {
              event.preventDefault();
              filename = getFilename(pasteEvent) || "image.png";
              text = "{{" + filename + "}}";
              pasteText(text);
              return uploadFile(image.getAsFile(), filename);
            }
          }
        };
        isImage = function isImage(data) {
          var i, item;
          i = 0;
          while (i < data.clipboardData.items.length) {
            item = data.clipboardData.items[i];
            if (item.type.indexOf("image") !== -1) {
              return item;
            }
            i += 1;
          }
          return false;
        };
        pasteText = function pasteText(text) {
          var afterSelection, beforeSelection, caretEnd, caretStart, textEnd;
          caretStart = $(child)[0].selectionStart;
          caretEnd = $(child)[0].selectionEnd;
          textEnd = $(child).val().length;
          beforeSelection = $(child).val().substring(0, caretStart);
          afterSelection = $(child).val().substring(caretEnd, textEnd);
          $(child).val(beforeSelection + text + afterSelection);
          child.get(0).setSelectionRange(caretStart + text.length, caretEnd + text.length);
          return form_textarea.trigger("input");
        };
        getFilename = function getFilename(e) {
          var value;
          if (window.clipboardData && window.clipboardData.getData) {
            value = window.clipboardData.getData("Text");
          } else if (e.clipboardData && e.clipboardData.getData) {
            value = e.clipboardData.getData("text/plain");
          }
          value = value.split("\r");
          return value.first();
        };
        uploadFile = function uploadFile(item, filename) {
          var formData;
          formData = new FormData();
          formData.append("file", item, filename);
          return $.ajax({
            url: project_uploads_path,
            type: "POST",
            data: formData,
            dataType: "json",
            processData: false,
            contentType: false,
            headers: {
              "X-CSRF-Token": $("meta[name=\"csrf-token\"]").attr("content")
            },
            beforeSend: function beforeSend() {
              showSpinner();
              return closeAlertMessage();
            },
            success: function success(e, textStatus, response) {
              return insertToTextArea(filename, response.responseJSON.link.markdown);
            },
            error: function error(response) {
              return showError(response.responseJSON.message);
            },
            complete: function complete() {
              return closeSpinner();
            }
          });
        };
        insertToTextArea = function insertToTextArea(filename, url) {
          return $(child).val(function (index, val) {
            return val.replace("{{" + filename + "}}", url + "\n");
          });
        };
        appendToTextArea = function appendToTextArea(url) {
          return $(child).val(function (index, val) {
            return val + url + "\n";
          });
        };
        showSpinner = function showSpinner(e) {
          return form.find(".div-dropzone-spinner").css({
            "opacity": 0.7,
            "display": "inherit"
          });
        };
        closeSpinner = function closeSpinner() {
          return form.find(".div-dropzone-spinner").css({
            "opacity": 0,
            "display": "none"
          });
        };
        showError = function showError(message) {
          var checkIfMsgExists, errorAlert;
          errorAlert = $(form).find('.error-alert');
          checkIfMsgExists = errorAlert.children().length;
          if (checkIfMsgExists === 0) {
            errorAlert.append(divAlert);
            return $(".div-dropzone-alert").append(btnAlert + message);
          }
        };
        closeAlertMessage = function closeAlertMessage() {
          return form.find(".div-dropzone-alert").alert("close");
        };
        form.find(".markdown-selector").click(function (e) {
          e.preventDefault();
          $(this).closest('.gfm-form').find('.div-dropzone').click();
        });
      }

      return DropzoneInput;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable wrap-iife, func-names, space-before-function-paren, comma-dangle, prefer-template, consistent-return, class-methods-use-this, arrow-body-style, no-unused-vars, no-underscore-dangle, no-new, max-len, no-sequences, no-unused-expressions, no-param-reassign */

  (function (global) {
    var DueDateSelect = function () {
      function DueDateSelect() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            $dropdown = _ref.$dropdown,
            $loading = _ref.$loading;

        _classCallCheck(this, DueDateSelect);

        var $dropdownParent = $dropdown.closest('.dropdown');
        var $block = $dropdown.closest('.block');
        this.$loading = $loading;
        this.$dropdown = $dropdown;
        this.$dropdownParent = $dropdownParent;
        this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
        this.$block = $block;
        this.$selectbox = $dropdown.closest('.selectbox');
        this.$value = $block.find('.value');
        this.$valueContent = $block.find('.value-content');
        this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
        this.fieldName = $dropdown.data('field-name'), this.abilityName = $dropdown.data('ability-name'), this.issueUpdateURL = $dropdown.data('issue-update');

        this.rawSelectedDate = null;
        this.displayedDate = null;
        this.datePayload = null;

        this.initGlDropdown();
        this.initRemoveDueDate();
        this.initDatePicker();
        this.initStopPropagation();
      }

      _createClass(DueDateSelect, [{
        key: 'initGlDropdown',
        value: function initGlDropdown() {
          var _this = this;

          this.$dropdown.glDropdown({
            hidden: function hidden() {
              _this.$selectbox.hide();
              _this.$value.css('display', '');
            }
          });
        }
      }, {
        key: 'initDatePicker',
        value: function initDatePicker() {
          var _this2 = this;

          this.$datePicker.datepicker({
            dateFormat: 'yy-mm-dd',
            defaultDate: $("input[name='" + this.fieldName + "']").val(),
            altField: "input[name='" + this.fieldName + "']",
            onSelect: function onSelect() {
              if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
                gl.issueBoards.BoardsStore.detail.issue.dueDate = $('input[name=\'' + _this2.fieldName + '\']').val();
                _this2.updateIssueBoardIssue();
              } else {
                return _this2.saveDueDate(true);
              }
            }
          });
        }
      }, {
        key: 'initRemoveDueDate',
        value: function initRemoveDueDate() {
          var _this3 = this;

          this.$block.on('click', '.js-remove-due-date', function (e) {
            e.preventDefault();

            if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
              gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
              _this3.updateIssueBoardIssue();
            } else {
              $("input[name='" + _this3.fieldName + "']").val('');
              return _this3.saveDueDate(false);
            }
          });
        }
      }, {
        key: 'initStopPropagation',
        value: function initStopPropagation() {
          $(document).off('click', '.ui-datepicker-header a').on('click', '.ui-datepicker-header a', function (e) {
            return e.stopImmediatePropagation();
          });
        }
      }, {
        key: 'saveDueDate',
        value: function saveDueDate(isDropdown) {
          this.parseSelectedDate();
          this.prepSelectedDate();
          this.submitSelectedDate(isDropdown);
        }
      }, {
        key: 'parseSelectedDate',
        value: function parseSelectedDate() {
          this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

          if (this.rawSelectedDate.length) {
            // Construct Date object manually to avoid buggy dateString support within Date constructor
            var dateArray = this.rawSelectedDate.split('-').map(function (v) {
              return parseInt(v, 10);
            });
            var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
            this.displayedDate = $.datepicker.formatDate('M d, yy', dateObj);
          } else {
            this.displayedDate = 'No due date';
          }
        }
      }, {
        key: 'prepSelectedDate',
        value: function prepSelectedDate() {
          var datePayload = {};
          datePayload[this.abilityName] = {};
          datePayload[this.abilityName].due_date = this.rawSelectedDate;
          this.datePayload = datePayload;
        }
      }, {
        key: 'updateIssueBoardIssue',
        value: function updateIssueBoardIssue() {
          var _this4 = this;

          this.$loading.fadeIn();
          this.$dropdown.trigger('loading.gl.dropdown');
          this.$selectbox.hide();
          this.$value.css('display', '');

          gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(function () {
            _this4.$loading.fadeOut();
          });
        }
      }, {
        key: 'submitSelectedDate',
        value: function submitSelectedDate(isDropdown) {
          var _this5 = this;

          return $.ajax({
            type: 'PUT',
            url: this.issueUpdateURL,
            data: this.datePayload,
            dataType: 'json',
            beforeSend: function beforeSend() {
              var selectedDateValue = _this5.datePayload[_this5.abilityName].due_date;
              var displayedDateStyle = _this5.displayedDate !== 'No due date' ? 'bold' : 'no-value';

              _this5.$loading.fadeIn();

              if (isDropdown) {
                _this5.$dropdown.trigger('loading.gl.dropdown');
                _this5.$selectbox.hide();
              }

              _this5.$value.css('display', '');
              _this5.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + _this5.displayedDate + '</span>');
              _this5.$sidebarValue.html(_this5.displayedDate);

              return selectedDateValue.length ? $('.js-remove-due-date-holder').removeClass('hidden') : $('.js-remove-due-date-holder').addClass('hidden');
            }
          }).done(function (data) {
            if (isDropdown) {
              _this5.$dropdown.trigger('loaded.gl.dropdown');
              _this5.$dropdown.dropdown('toggle');
            }
            return _this5.$loading.fadeOut();
          });
        }
      }]);

      return DueDateSelect;
    }();

    var DueDateSelectors = function () {
      function DueDateSelectors() {
        _classCallCheck(this, DueDateSelectors);

        this.initMilestoneDatePicker();
        this.initIssuableSelect();
      }

      _createClass(DueDateSelectors, [{
        key: 'initMilestoneDatePicker',
        value: function initMilestoneDatePicker() {
          $('.datepicker').datepicker({
            dateFormat: 'yy-mm-dd'
          });

          $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
            e.preventDefault();
            var datepicker = $(e.target).siblings('.datepicker');
            $.datepicker._clearDate(datepicker);
          });
        }
      }, {
        key: 'initIssuableSelect',
        value: function initIssuableSelect() {
          var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

          $('.js-due-date-select').each(function (i, dropdown) {
            var $dropdown = $(dropdown);
            new DueDateSelect({
              $dropdown: $dropdown,
              $loading: $loading
            });
          });
        }
      }]);

      return DueDateSelectors;
    }();

    global.DueDateSelectors = DueDateSelectors;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 105 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-extend-native, func-names, space-before-function-paren, space-infix-ops, strict, max-len */

  'use strict';

  Array.prototype.first = function () {
    return this[0];
  };

  Array.prototype.last = function () {
    return this[this.length - 1];
  };

  Array.prototype.find = Array.prototype.find || function (predicate) {
    if (!this) throw new TypeError('Array.prototype.find called on null or undefined');
    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');

    var list = Object(this);
    var thisArg = arguments.length <= 2 ? undefined : arguments[2];
    var value = {};

    for (var i = 0; i < list.length; i += 1) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) return value;
    }

    return undefined;
  };
}).call(window);

/***/ }),
/* 106 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global CustomEvent */
  /* eslint-disable no-global-assign */

  // Custom event support for IE
  CustomEvent = function CustomEvent(event, parameters) {
    var params = parameters || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
}).call(window);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Element */
  /* eslint-disable consistent-return, max-len, no-empty, func-names */

  Element.prototype.closest = Element.prototype.closest || function closest(selector) {
    var selectedElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

    if (!selectedElement) return;
    return selectedElement.matches(selector) ? selectedElement : Element.prototype.closest(selector, selectedElement.parentElement);
  };

  Element.prototype.matches = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = matches.length - 1;
    while (i >= 0 && matches.item(i) !== this) {
      i -= 1;
    }
    return i > -1;
  };
}).call(window);

/***/ }),
/* 108 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-restricted-syntax */

  // Adapted from https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
  if (typeof Object.assign !== 'function') {
    Object.assign = function assign(target) {
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 0; index < (arguments.length <= 1 ? 0 : arguments.length - 1); index += 1) {
        var nextSource = arguments.length <= index + 1 ? undefined : arguments[index + 1];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }
}).call(window);

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, class-methods-use-this, max-len, space-before-function-paren, arrow-parens, no-param-reassign */

  __webpack_require__(36);

  (function (global) {
    var customValidationFlag = 'gl-field-error-ignore';

    var GlFieldErrors = function () {
      function GlFieldErrors(form) {
        _classCallCheck(this, GlFieldErrors);

        this.form = $(form);
        this.state = {
          inputs: [],
          valid: false
        };
        this.initValidators();
      }

      _createClass(GlFieldErrors, [{
        key: 'initValidators',
        value: function initValidators() {
          var _this = this;

          // register selectors here as needed
          var validateSelectors = [':text', ':password', '[type=email]'].map(function (selector) {
            return 'input' + selector;
          }).join(',');

          this.state.inputs = this.form.find(validateSelectors).toArray().filter(function (input) {
            return !input.classList.contains(customValidationFlag);
          }).map(function (input) {
            return new global.GlFieldError({ input: input, formErrors: _this });
          });

          this.form.on('submit', this.catchInvalidFormSubmit);
        }

        /* Neccessary to prevent intercept and override invalid form submit
         * because Safari & iOS quietly allow form submission when form is invalid
         * and prevents disabling of invalid submit button by application.js */

      }, {
        key: 'catchInvalidFormSubmit',
        value: function catchInvalidFormSubmit(event) {
          if (!event.currentTarget.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
        }
      }, {
        key: 'focusOnFirstInvalid',
        value: function focusOnFirstInvalid() {
          var firstInvalid = this.state.inputs.filter(function (input) {
            return !input.inputDomElement.validity.valid;
          })[0];
          firstInvalid.inputElement.focus();
        }
      }]);

      return GlFieldErrors;
    }();

    global.GlFieldErrors = GlFieldErrors;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-new, max-len */
  /* global GitLab */
  /* global DropzoneInput */
  /* global autosize */

  (function () {
    var global = window.gl || (window.gl = {});

    function GLForm(form) {
      this.form = form;
      this.textarea = this.form.find('textarea.js-gfm-input');
      // Before we start, we should clean up any previous data for this form
      this.destroy();
      // Setup the form
      this.setupForm();
      this.form.data('gl-form', this);
    }

    GLForm.prototype.destroy = function () {
      // Clean form listeners
      this.clearEventListeners();
      return this.form.data('gl-form', null);
    };

    GLForm.prototype.setupForm = function () {
      var isNewForm;
      isNewForm = this.form.is(':not(.gfm-form)');
      this.form.removeClass('js-new-note-form');
      if (isNewForm) {
        this.form.find('.div-dropzone').remove();
        this.form.addClass('gfm-form');
        // remove notify commit author checkbox for non-commit notes
        gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button'));
        gl.GfmAutoComplete.setup(this.form.find('.js-gfm-input'));
        new DropzoneInput(this.form);
        autosize(this.textarea);
        // form and textarea event listeners
        this.addEventListeners();
      }
      gl.text.init(this.form);
      // hide discard button
      this.form.find('.js-note-discard').hide();
      this.form.show();
      if (this.isAutosizeable) this.setupAutosize();
    };

    GLForm.prototype.setupAutosize = function () {
      var _this = this;

      this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

      this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

      setTimeout(function () {
        autosize(_this.textarea);
        _this.textarea.css('resize', 'vertical');
      }, 0);
    };

    GLForm.prototype.setHeightData = function () {
      this.textarea.data('height', this.textarea.outerHeight());
    };

    GLForm.prototype.destroyAutosize = function () {
      var outerHeight = this.textarea.outerHeight();

      if (this.textarea.data('height') === outerHeight) return;

      autosize.destroy(this.textarea);

      this.textarea.data('height', outerHeight);
      this.textarea.outerHeight(outerHeight);
      this.textarea.css('max-height', window.outerHeight);
    };

    GLForm.prototype.clearEventListeners = function () {
      this.textarea.off('focus');
      this.textarea.off('blur');
      return gl.text.removeListeners(this.form);
    };

    GLForm.prototype.addEventListeners = function () {
      this.textarea.on('focus', function () {
        return $(this).closest('.md-area').addClass('is-focused');
      });
      return this.textarea.on('blur', function () {
        return $(this).closest('.md-area').removeClass('is-focused');
      });
    };

    global.GLForm = GLForm;
  })();
}).call(window);

/***/ }),
/* 118 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, object-shorthand, comma-dangle, wrap-iife, space-before-function-paren, no-param-reassign, max-len */

  (function (global) {
    var GroupLabelSubscription = function () {
      function GroupLabelSubscription(container) {
        _classCallCheck(this, GroupLabelSubscription);

        var $container = $(container);
        this.$dropdown = $container.find('.dropdown');
        this.$subscribeButtons = $container.find('.js-subscribe-button');
        this.$unsubscribeButtons = $container.find('.js-unsubscribe-button');

        this.$subscribeButtons.on('click', this.subscribe.bind(this));
        this.$unsubscribeButtons.on('click', this.unsubscribe.bind(this));
      }

      _createClass(GroupLabelSubscription, [{
        key: 'unsubscribe',
        value: function unsubscribe(event) {
          var _this = this;

          event.preventDefault();

          var url = this.$unsubscribeButtons.attr('data-url');

          $.ajax({
            type: 'POST',
            url: url
          }).done(function () {
            _this.toggleSubscriptionButtons();
            _this.$unsubscribeButtons.removeAttr('data-url');
          });
        }
      }, {
        key: 'subscribe',
        value: function subscribe(event) {
          var _this2 = this;

          event.preventDefault();

          var $btn = $(event.currentTarget);
          var url = $btn.attr('data-url');

          this.$unsubscribeButtons.attr('data-url', url);

          $.ajax({
            type: 'POST',
            url: url
          }).done(function () {
            _this2.toggleSubscriptionButtons();
          });
        }
      }, {
        key: 'toggleSubscriptionButtons',
        value: function toggleSubscriptionButtons() {
          this.$dropdown.toggleClass('hidden');
          this.$subscribeButtons.toggleClass('hidden');
          this.$unsubscribeButtons.toggleClass('hidden');
        }
      }]);

      return GroupLabelSubscription;
    }();

    global.GroupLabelSubscription = GroupLabelSubscription;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {
  var _this2 = this;

  /* eslint-disable no-param-reassign, func-names, no-var, camelcase, no-unused-vars, object-shorthand, space-before-function-paren, no-return-assign, comma-dangle, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, prefer-arrow-callback, wrap-iife, max-len */
  /* global Issuable */

  (function (global) {
    var issuable_created;

    issuable_created = false;

    global.Issuable = {
      init: function init() {
        Issuable.initTemplates();
        Issuable.initSearch();
        Issuable.initChecks();
        Issuable.initResetFilters();
        Issuable.resetIncomingEmailToken();
        return Issuable.initLabelFilterRemove();
      },
      initTemplates: function initTemplates() {
        return Issuable.labelRow = _.template('<% _.each(labels, function(label){ %> <span class="label-row btn-group" role="group" aria-label="<%- label.title %>" style="color: <%- label.text_color %>;"> <a href="#" class="btn btn-transparent has-tooltip" style="background-color: <%- label.color %>;" title="<%- label.description %>" data-container="body"> <%- label.title %> </a> <button type="button" class="btn btn-transparent label-remove js-label-filter-remove" style="background-color: <%- label.color %>;" data-label="<%- label.title %>"> <i class="fa fa-times"></i> </button> </span> <% }); %>');
      },
      initSearch: function initSearch() {
        var $searchInput = $('#issuable_search');

        Issuable.initSearchState($searchInput);

        // `immediate` param set to false debounces on the `trailing` edge, lets user finish typing
        var debouncedExecSearch = _.debounce(Issuable.executeSearch, 1000, false);

        $searchInput.off('keyup').on('keyup', debouncedExecSearch);

        // ensures existing filters are preserved when manually submitted
        $('#issuable_search_form').on('submit', function (e) {
          e.preventDefault();
          debouncedExecSearch(e);
        });
      },
      initSearchState: function initSearchState($searchInput) {
        var currentSearchVal = $searchInput.val();

        Issuable.searchState = {
          elem: $searchInput,
          current: currentSearchVal
        };

        Issuable.maybeFocusOnSearch();
      },
      accessSearchPristine: function accessSearchPristine(set) {
        // store reference to previous value to prevent search on non-mutating keyup
        var state = Issuable.searchState;
        var currentSearchVal = state.elem.val();

        if (set) {
          state.current = currentSearchVal;
        } else {
          return state.current === currentSearchVal;
        }
      },
      maybeFocusOnSearch: function maybeFocusOnSearch() {
        var currentSearchVal = Issuable.searchState.current;
        if (currentSearchVal && currentSearchVal !== '') {
          var queryLength = currentSearchVal.length;
          var $searchInput = Issuable.searchState.elem;

          /* The following ensures that the cursor is initially placed at
            * the end of search input when focus is applied. It accounts
            * for differences in browser implementations of `setSelectionRange`
            * and cursor placement for elements in focus.
          */
          $searchInput.focus();
          if ($searchInput.setSelectionRange) {
            $searchInput.setSelectionRange(queryLength, queryLength);
          } else {
            $searchInput.val(currentSearchVal);
          }
        }
      },
      executeSearch: function executeSearch(e) {
        var $search = $('#issuable_search');
        var $searchName = $search.attr('name');
        var $searchValue = $search.val();
        var $filtersForm = $('.js-filter-form');
        var $input = $('input[name=\'' + $searchName + '\']', $filtersForm);
        var isPristine = Issuable.accessSearchPristine();

        if (isPristine) {
          return;
        }

        if (!$input.length) {
          $filtersForm.append('<input type=\'hidden\' name=\'' + $searchName + '\' value=\'' + _.escape($searchValue) + '\'/>');
        } else {
          $input.val($searchValue);
        }

        Issuable.filterResults($filtersForm);
      },
      initLabelFilterRemove: function initLabelFilterRemove() {
        return $(document).off('click', '.js-label-filter-remove').on('click', '.js-label-filter-remove', function (e) {
          var $button;
          $button = $(this);
          // Remove the label input box
          $('input[name="label_name[]"]').filter(function () {
            return this.value === $button.data('label');
          }).remove();
          // Submit the form to get new data
          Issuable.filterResults($('.filter-form'));
        });
      },
      filterResults: function (_this) {
        return function (form) {
          var formAction, formData, issuesUrl;
          formData = form.serializeArray();
          formData = formData.filter(function (data) {
            return data.value !== '';
          });
          formData = $.param(formData);
          formAction = form.attr('action');
          issuesUrl = formAction;
          issuesUrl += "" + (formAction.indexOf('?') < 0 ? '?' : '&');
          issuesUrl += formData;
          return gl.utils.visitUrl(issuesUrl);
        };
      }(_this2),
      initResetFilters: function initResetFilters() {
        $('.reset-filters').on('click', function (e) {
          e.preventDefault();
          var target = e.target;
          var $form = $(target).parents('.js-filter-form');
          var baseIssuesUrl = target.href;

          $form.attr('action', baseIssuesUrl);
          gl.utils.visitUrl(baseIssuesUrl);
        });
      },
      initChecks: function initChecks() {
        this.issuableBulkActions = $('.bulk-update').data('bulkActions');
        $('.check_all_issues').off('click').on('click', function () {
          $('.selected_issue').prop('checked', this.checked);
          return Issuable.checkChanged();
        });
        return $('.selected_issue').off('change').on('change', Issuable.checkChanged.bind(this));
      },
      checkChanged: function checkChanged() {
        var $checkedIssues = $('.selected_issue:checked');
        var $updateIssuesIds = $('#update_issuable_ids');
        var $issuesOtherFilters = $('.issues-other-filters');
        var $issuesBulkUpdate = $('.issues_bulk_update');

        this.issuableBulkActions.willUpdateLabels = false;
        this.issuableBulkActions.setOriginalDropdownData();

        if ($checkedIssues.length > 0) {
          var ids = $.map($checkedIssues, function (value) {
            return $(value).data('id');
          });
          $updateIssuesIds.val(ids);
          $issuesOtherFilters.hide();
          $issuesBulkUpdate.show();
        } else {
          $updateIssuesIds.val([]);
          $issuesBulkUpdate.hide();
          $issuesOtherFilters.show();
        }
        return true;
      },

      resetIncomingEmailToken: function resetIncomingEmailToken() {
        $('.incoming-email-token-reset').on('click', function (e) {
          e.preventDefault();

          $.ajax({
            type: 'PUT',
            url: $('.incoming-email-token-reset').attr('href'),
            dataType: 'json',
            success: function success(response) {
              $('#issue_email').val(response.new_issue_address).focus();
            },
            beforeSend: function beforeSend() {
              $('.incoming-email-token-reset').text('resetting...');
            },
            complete: function complete() {
              $('.incoming-email-token-reset').text('reset it');
            }
          });
        });
      }
    };
  })(window);
}).call(window);

/***/ }),
/* 120 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */
  /* global Issuable */
  /* global Flash */

  (function (global) {
    var IssuableBulkActions = function () {
      function IssuableBulkActions() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            container = _ref.container,
            form = _ref.form,
            issues = _ref.issues,
            prefixId = _ref.prefixId;

        _classCallCheck(this, IssuableBulkActions);

        this.prefixId = prefixId || 'issue_';
        this.form = form || this.getElement('.bulk-update');
        this.$labelDropdown = this.form.find('.js-label-select');
        this.issues = issues || this.getElement('.issues-list .issue');
        this.form.data('bulkActions', this);
        this.willUpdateLabels = false;
        this.bindEvents();
        // Fixes bulk-assign not working when navigating through pages
        Issuable.initChecks();
      }

      _createClass(IssuableBulkActions, [{
        key: 'bindEvents',
        value: function bindEvents() {
          return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
        }
      }, {
        key: 'onFormSubmit',
        value: function onFormSubmit(e) {
          e.preventDefault();
          return this.submit();
        }
      }, {
        key: 'submit',
        value: function submit() {
          var _this = this;
          var xhr = $.ajax({
            url: this.form.attr('action'),
            method: this.form.attr('method'),
            dataType: 'JSON',
            data: this.getFormDataAsObject()
          });
          xhr.done(function () {
            return window.location.reload();
          });
          xhr.fail(function () {
            return new Flash("Issue update failed");
          });
          return xhr.always(this.onFormSubmitAlways.bind(this));
        }
      }, {
        key: 'onFormSubmitAlways',
        value: function onFormSubmitAlways() {
          return this.form.find('[type="submit"]').enable();
        }
      }, {
        key: 'getSelectedIssues',
        value: function getSelectedIssues() {
          return this.issues.has('.selected_issue:checked');
        }
      }, {
        key: 'getLabelsFromSelection',
        value: function getLabelsFromSelection() {
          var labels = [];
          this.getSelectedIssues().map(function () {
            var labelsData = $(this).data('labels');
            if (labelsData) {
              return labelsData.map(function (labelId) {
                if (labels.indexOf(labelId) === -1) {
                  return labels.push(labelId);
                }
              });
            }
          });
          return labels;
        }

        /**
         * Will return only labels that were marked previously and the user has unmarked
         * @return {Array} Label IDs
         */

      }, {
        key: 'getUnmarkedIndeterminedLabels',
        value: function getUnmarkedIndeterminedLabels() {
          var result = [];
          var labelsToKeep = this.$labelDropdown.data('indeterminate');

          this.getLabelsFromSelection().forEach(function (id) {
            if (labelsToKeep.indexOf(id) === -1) {
              result.push(id);
            }
          });

          return result;
        }

        /**
         * Simple form serialization, it will return just what we need
         * Returns key/value pairs from form data
         */

      }, {
        key: 'getFormDataAsObject',
        value: function getFormDataAsObject() {
          var formData = {
            update: {
              state_event: this.form.find('input[name="update[state_event]"]').val(),
              assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
              milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
              issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
              subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
              add_label_ids: [],
              remove_label_ids: []
            }
          };
          if (this.willUpdateLabels) {
            formData.update.add_label_ids = this.$labelDropdown.data('marked');
            formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
          }
          return formData;
        }
      }, {
        key: 'setOriginalDropdownData',
        value: function setOriginalDropdownData() {
          var $labelSelect = $('.bulk-update .js-label-select');
          $labelSelect.data('common', this.getOriginalCommonIds());
          $labelSelect.data('marked', this.getOriginalMarkedIds());
          $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
        }

        // From issuable's initial bulk selection

      }, {
        key: 'getOriginalCommonIds',
        value: function getOriginalCommonIds() {
          var _this2 = this;

          var labelIds = [];

          this.getElement('.selected_issue:checked').each(function (i, el) {
            labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
          });
          return _.intersection.apply(this, labelIds);
        }

        // From issuable's initial bulk selection

      }, {
        key: 'getOriginalMarkedIds',
        value: function getOriginalMarkedIds() {
          var _this3 = this;

          var labelIds = [];
          this.getElement('.selected_issue:checked').each(function (i, el) {
            labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
          });
          return _.intersection.apply(this, labelIds);
        }

        // From issuable's initial bulk selection

      }, {
        key: 'getOriginalIndeterminateIds',
        value: function getOriginalIndeterminateIds() {
          var _this4 = this;

          var uniqueIds = [];
          var labelIds = [];
          var issuableLabels = [];

          // Collect unique label IDs for all checked issues
          this.getElement('.selected_issue:checked').each(function (i, el) {
            issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
            issuableLabels.forEach(function (labelId) {
              // Store unique IDs
              if (uniqueIds.indexOf(labelId) === -1) {
                uniqueIds.push(labelId);
              }
            });
            // Store array of IDs per issuable
            labelIds.push(issuableLabels);
          });
          // Add uniqueIds to add it as argument for _.intersection
          labelIds.unshift(uniqueIds);
          // Return IDs that are present but not in all selected issueables
          return _.difference(uniqueIds, _.intersection.apply(this, labelIds));
        }
      }, {
        key: 'getElement',
        value: function getElement(selector) {
          this.scopeEl = this.scopeEl || $('.content');
          return this.scopeEl.find(selector);
        }
      }]);

      return IssuableBulkActions;
    }();

    global.IssuableBulkActions = IssuableBulkActions;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 121 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, class-methods-use-this, no-underscore-dangle, no-param-reassign, no-unused-vars, consistent-return, func-names, space-before-function-paren, max-len */
  /* global Flash */

  (function (global) {
    var LabelManager = function () {
      function LabelManager() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            togglePriorityButton = _ref.togglePriorityButton,
            prioritizedLabels = _ref.prioritizedLabels,
            otherLabels = _ref.otherLabels;

        _classCallCheck(this, LabelManager);

        this.togglePriorityButton = togglePriorityButton || $('.js-toggle-priority');
        this.prioritizedLabels = prioritizedLabels || $('.js-prioritized-labels');
        this.otherLabels = otherLabels || $('.js-other-labels');
        this.errorMessage = 'Unable to update label prioritization at this time';
        this.emptyState = document.querySelector('#js-priority-labels-empty-state');
        this.prioritizedLabels.sortable({
          items: 'li',
          placeholder: 'list-placeholder',
          axis: 'y',
          update: this.onPrioritySortUpdate.bind(this)
        });
        this.bindEvents();
      }

      _createClass(LabelManager, [{
        key: 'bindEvents',
        value: function bindEvents() {
          return this.togglePriorityButton.on('click', this, this.onTogglePriorityClick);
        }
      }, {
        key: 'onTogglePriorityClick',
        value: function onTogglePriorityClick(e) {
          e.preventDefault();
          var _this = e.data;
          var $btn = $(e.currentTarget);
          var $label = $('#' + $btn.data('domId'));
          var action = $btn.parents('.js-prioritized-labels').length ? 'remove' : 'add';
          var $tooltip = $('#' + $btn.find('.has-tooltip:visible').attr('aria-describedby'));
          $tooltip.tooltip('destroy');
          _this.toggleLabelPriority($label, action);
          _this.toggleEmptyState($label, $btn, action);
        }
      }, {
        key: 'toggleEmptyState',
        value: function toggleEmptyState($label, $btn, action) {
          this.emptyState.classList.toggle('hidden', !!this.prioritizedLabels[0].querySelector(':scope > li'));
        }
      }, {
        key: 'toggleLabelPriority',
        value: function toggleLabelPriority($label, action, persistState) {
          if (persistState == null) {
            persistState = true;
          }
          var xhr = void 0;
          var _this = this;
          var url = $label.find('.js-toggle-priority').data('url');
          var $target = this.prioritizedLabels;
          var $from = this.otherLabels;
          if (action === 'remove') {
            $target = this.otherLabels;
            $from = this.prioritizedLabels;
          }
          if ($from.find('li').length === 1) {
            $from.find('.empty-message').removeClass('hidden');
          }
          if (!$target.find('li').length) {
            $target.find('.empty-message').addClass('hidden');
          }
          $label.detach().appendTo($target);
          // Return if we are not persisting state
          if (!persistState) {
            return;
          }
          if (action === 'remove') {
            xhr = $.ajax({
              url: url,
              type: 'DELETE'
            });
            // Restore empty message
            if (!$from.find('li').length) {
              $from.find('.empty-message').removeClass('hidden');
            }
          } else {
            xhr = this.savePrioritySort($label, action);
          }
          return xhr.fail(this.rollbackLabelPosition.bind(this, $label, action));
        }
      }, {
        key: 'onPrioritySortUpdate',
        value: function onPrioritySortUpdate() {
          var xhr = this.savePrioritySort();
          return xhr.fail(function () {
            return new Flash(this.errorMessage, 'alert');
          });
        }
      }, {
        key: 'savePrioritySort',
        value: function savePrioritySort() {
          return $.post({
            url: this.prioritizedLabels.data('url'),
            data: {
              label_ids: this.getSortedLabelsIds()
            }
          });
        }
      }, {
        key: 'rollbackLabelPosition',
        value: function rollbackLabelPosition($label, originalAction) {
          var action = originalAction === 'remove' ? 'add' : 'remove';
          this.toggleLabelPriority($label, action, false);
          return new Flash(this.errorMessage, 'alert');
        }
      }, {
        key: 'getSortedLabelsIds',
        value: function getSortedLabelsIds() {
          var sortedIds = [];
          this.prioritizedLabels.find('li').each(function () {
            sortedIds.push($(this).data('id'));
          });
          return sortedIds;
        }
      }]);

      return LabelManager;
    }();

    gl.LabelManager = LabelManager;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 122 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    // Add datepickers to all `js-access-expiration-date` elements. If those elements are
    // children of an element with the `clearable-input` class, and have a sibling
    // `js-clear-input` element, then show that element when there is a value in the
    // datepicker, and make clicking on that element clear the field.
    //
    window.gl = window.gl || {};
    gl.MemberExpirationDate = function () {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-access-expiration-date';

      function toggleClearInput() {
        $(this).closest('.clearable-input').toggleClass('has-value', $(this).val() !== '');
      }
      var inputs = $(selector);

      inputs.datepicker({
        dateFormat: 'yy-mm-dd',
        minDate: 1,
        onSelect: function onSelect() {
          $(this).trigger('change');
          toggleClearInput.call(this);
        }
      });

      inputs.next('.js-clear-input').on('click', function clicked(event) {
        event.preventDefault();

        var input = $(this).closest('.clearable-input').find(selector);
        input.datepicker('setDate', null).trigger('change');
        toggleClearInput.call(input);
      });

      inputs.on('blur', toggleClearInput);

      inputs.each(toggleClearInput);
    };
  }).call(this);
}).call(window);

/***/ }),
/* 123 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable class-methods-use-this */
  (function () {
    window.gl = window.gl || {};

    var Members = function () {
      function Members() {
        _classCallCheck(this, Members);

        this.addListeners();
        this.initGLDropdown();
      }

      _createClass(Members, [{
        key: 'addListeners',
        value: function addListeners() {
          $('.project_member, .group_member').off('ajax:success').on('ajax:success', this.removeRow);
          $('.js-member-update-control').off('change').on('change', this.formSubmit.bind(this));
          $('.js-edit-member-form').off('ajax:success').on('ajax:success', this.formSuccess.bind(this));
          gl.utils.disableButtonIfEmptyField('#user_ids', 'input[name=commit]', 'change');
        }
      }, {
        key: 'initGLDropdown',
        value: function initGLDropdown() {
          var _this = this;

          $('.js-member-permissions-dropdown').each(function (i, btn) {
            var $btn = $(btn);

            $btn.glDropdown({
              selectable: true,
              isSelectable: function isSelectable(selected, $el) {
                return !$el.hasClass('is-active');
              },

              fieldName: $btn.data('field-name'),
              id: function id(selected, $el) {
                return $el.data('id');
              },
              toggleLabel: function toggleLabel(selected, $el) {
                return $el.text();
              },

              clicked: function clicked(selected, $link) {
                _this.formSubmit(null, $link);
              }
            });
          });
        }
      }, {
        key: 'removeRow',
        value: function removeRow(e) {
          var $target = $(e.target);

          if ($target.hasClass('btn-remove')) {
            $target.closest('.member').fadeOut(function fadeOutMemberRow() {
              $(this).remove();
            });
          }
        }
      }, {
        key: 'formSubmit',
        value: function formSubmit(e) {
          var $el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          var $this = e ? $(e.currentTarget) : $el;

          var _getMemberListItems = this.getMemberListItems($this),
              $toggle = _getMemberListItems.$toggle,
              $dateInput = _getMemberListItems.$dateInput;

          $this.closest('form').trigger('submit.rails');

          $toggle.disable();
          $dateInput.disable();
        }
      }, {
        key: 'formSuccess',
        value: function formSuccess(e) {
          var _getMemberListItems2 = this.getMemberListItems($(e.currentTarget).closest('.member')),
              $toggle = _getMemberListItems2.$toggle,
              $dateInput = _getMemberListItems2.$dateInput;

          $toggle.enable();
          $dateInput.enable();
        }
      }, {
        key: 'getMemberListItems',
        value: function getMemberListItems($el) {
          var $memberListItem = $el.is('.member') ? $el : $('#' + $el.data('el-id'));

          return {
            $memberListItem: $memberListItem,
            $toggle: $memberListItem.find('.dropdown-menu-toggle'),
            $dateInput: $memberListItem.find('.js-access-expiration-date')
          };
        }
      }]);

      return Members;
    }();

    gl.Members = Members;
  })();
}).call(window);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable max-len, no-var, func-names, space-before-function-paren, vars-on-top, comma-dangle, no-return-assign, consistent-return, no-param-reassign, one-var, one-var-declaration-per-line, quotes, prefer-template, no-else-return, prefer-arrow-callback, no-unused-vars, no-underscore-dangle, no-shadow, no-mixed-operators, camelcase, default-case, wrap-iife */
  /* global notify */
  /* global notifyPermissions */
  /* global merge_request_widget */

  __webpack_require__(14);

  (function (global) {
    var indexOf = [].indexOf || function (item) {
      for (var i = 0, l = this.length; i < l; i += 1) {
        if (i in this && this[i] === item) return i;
      }return -1;
    };

    var DEPLOYMENT_TEMPLATE = '<div class="mr-widget-heading" id="<%- id %>">\n       <div class="ci_widget ci-success">\n         <%= ci_success_icon %>\n         <span>\n           Deployed to\n           <a href="<%- url %>" target="_blank" rel="noopener noreferrer" class="environment">\n             <%- name %>\n           </a>\n           <span class="js-environment-timeago" data-toggle="tooltip" data-placement="top" data-title="<%- deployed_at_formatted %>">\n             <%- deployed_at %>\n           </span>\n           <a class="js-environment-link" href="<%- external_url %>" target="_blank" rel="noopener noreferrer">\n             <i class="fa fa-external-link"></i>\n             View on <%- external_url_formatted %>\n           </a>\n         </span>\n         <span class="stop-env-container js-stop-env-link">\n          <a href="<%- stop_url %>" class="close-evn-link" data-method="post" rel="nofollow" data-confirm="Are you sure you want to stop this environment?">\n            <i class="fa fa-stop-circle-o"/>\n            Stop environment\n          </a>\n         </span>\n       </div>\n     </div>';

    global.MergeRequestWidget = function () {
      function MergeRequestWidget(opts) {
        // Initialize MergeRequestWidget behavior
        //
        //   check_enable           - Boolean, whether to check automerge status
        //   merge_check_url - String, URL to use to check automerge status
        //   ci_status_url        - String, URL to use to check CI status
        //
        this.opts = opts;
        this.$widgetBody = $('.mr-widget-body');
        $('#modal_merge_info').modal({
          show: false
        });
        this.clearEventListeners();
        this.addEventListeners();
        this.getCIStatus(false);
        this.retrieveSuccessIcon();

        this.initMiniPipelineGraph();

        this.ciStatusInterval = new global.SmartInterval({
          callback: this.getCIStatus.bind(this, true),
          startingInterval: 10000,
          maxInterval: 30000,
          hiddenInterval: 120000,
          incrementByFactorOf: 5000
        });
        this.ciEnvironmentStatusInterval = new global.SmartInterval({
          callback: this.getCIEnvironmentsStatus.bind(this),
          startingInterval: 30000,
          maxInterval: 120000,
          hiddenInterval: 240000,
          incrementByFactorOf: 15000,
          immediateExecution: true
        });

        notifyPermissions();
      }

      MergeRequestWidget.prototype.clearEventListeners = function () {
        return $(document).off('DOMContentLoaded');
      };

      MergeRequestWidget.prototype.addEventListeners = function () {
        var allowedPages;
        allowedPages = ['show', 'commits', 'pipelines', 'changes'];
        $(document).on('DOMContentLoaded', function (_this) {
          return function () {
            var page;
            page = $('body').data('page').split(':').last();
            if (allowedPages.indexOf(page) < 0) {
              return _this.clearEventListeners();
            }
          };
        }(this));
      };

      MergeRequestWidget.prototype.retrieveSuccessIcon = function () {
        var $ciSuccessIcon = $('.js-success-icon');
        this.$ciSuccessIcon = $ciSuccessIcon.html();
        $ciSuccessIcon.remove();
      };

      MergeRequestWidget.prototype.mergeInProgress = function (deleteSourceBranch) {
        if (deleteSourceBranch == null) {
          deleteSourceBranch = false;
        }
        return $.ajax({
          type: 'GET',
          url: $('.merge-request').data('url'),
          success: function (_this) {
            return function (data) {
              var callback, urlSuffix;
              if (data.state === "merged") {
                urlSuffix = deleteSourceBranch ? '?deleted_source_branch=true' : '';
                return window.location.href = window.location.pathname + urlSuffix;
              } else if (data.merge_error) {
                return $('.mr-widget-body').html("<h4>" + data.merge_error + "</h4>");
              } else {
                callback = function callback() {
                  return merge_request_widget.mergeInProgress(deleteSourceBranch);
                };
                return setTimeout(callback, 2000);
              }
            };
          }(this),
          dataType: 'json'
        });
      };

      MergeRequestWidget.prototype.cancelPolling = function () {
        this.ciStatusInterval.cancel();
        this.ciEnvironmentStatusInterval.cancel();
      };

      MergeRequestWidget.prototype.getMergeStatus = function () {
        return $.get(this.opts.merge_check_url, function (data) {
          var $html = $(data);
          $('.mr-widget-body').replaceWith($html.find('.mr-widget-body'));
          $('.mr-widget-footer').replaceWith($html.find('.mr-widget-footer'));
        });
      };

      MergeRequestWidget.prototype.ciLabelForStatus = function (status) {
        switch (status) {
          case 'success':
            return 'passed';
          case 'success_with_warnings':
            return 'passed with warnings';
          default:
            return status;
        }
      };

      MergeRequestWidget.prototype.getCIStatus = function (showNotification) {
        var _this;
        _this = this;
        $('.ci-widget-fetching').show();
        return $.getJSON(this.opts.ci_status_url, function (_this) {
          return function (data) {
            var message, status, title;
            if (!data.status) {
              return;
            }
            if (data.environments && data.environments.length) _this.renderEnvironments(data.environments);
            if (data.status !== _this.opts.ci_status || data.sha !== _this.opts.ci_sha || data.pipeline !== _this.opts.ci_pipeline) {
              _this.opts.ci_status = data.status;
              _this.showCIStatus(data.status);
              if (data.coverage) {
                _this.showCICoverage(data.coverage);
              }
              if (data.pipeline) {
                _this.opts.ci_pipeline = data.pipeline;
                _this.updatePipelineUrls(data.pipeline);
              }
              if (data.sha) {
                _this.opts.ci_sha = data.sha;
                _this.updateCommitUrls(data.sha);
              }
              if (showNotification) {
                status = _this.ciLabelForStatus(data.status);
                if (status === "preparing") {
                  title = _this.opts.ci_title.preparing;
                  status = status.charAt(0).toUpperCase() + status.slice(1);
                  message = _this.opts.ci_message.preparing.replace('{{status}}', status);
                } else {
                  title = _this.opts.ci_title.normal;
                  message = _this.opts.ci_message.normal.replace('{{status}}', status);
                }
                title = title.replace('{{status}}', status);
                message = message.replace('{{sha}}', data.sha);
                message = message.replace('{{title}}', data.title);
                notify(title, message, _this.opts.gitlab_icon, function () {
                  this.close();
                });
              }
            }
          };
        }(this));
      };

      MergeRequestWidget.prototype.getCIEnvironmentsStatus = function () {
        var _this2 = this;

        $.getJSON(this.opts.ci_environments_status_url, function (environments) {
          if (environments && environments.length) _this2.renderEnvironments(environments);
        });
      };

      MergeRequestWidget.prototype.renderEnvironments = function (environments) {
        for (var i = 0; i < environments.length; i += 1) {
          var environment = environments[i];
          if ($('.mr-state-widget #' + environment.id).length) return;
          var $template = $(DEPLOYMENT_TEMPLATE);
          if (!environment.external_url || !environment.external_url_formatted) $('.js-environment-link', $template).remove();

          if (!environment.stop_url) {
            $('.js-stop-env-link', $template).remove();
          }

          if (environment.deployed_at && environment.deployed_at_formatted) {
            environment.deployed_at = gl.utils.getTimeago().format(environment.deployed_at, 'gl_en') + '.';
          } else {
            $('.js-environment-timeago', $template).remove();
            environment.name += '.';
          }
          environment.ci_success_icon = this.$ciSuccessIcon;
          var templateString = _.unescape($template[0].outerHTML);
          var template = _.template(templateString)(environment);
          this.$widgetBody.before(template);
        }
      };

      MergeRequestWidget.prototype.showCIStatus = function (state) {
        var allowed_states;
        if (state == null) {
          return;
        }
        $('.ci_widget').hide();
        allowed_states = ["failed", "canceled", "running", "pending", "success", "success_with_warnings", "skipped", "not_found"];
        if (indexOf.call(allowed_states, state) >= 0) {
          $('.ci_widget.ci-' + state).show();
          switch (state) {
            case "failed":
            case "canceled":
            case "not_found":
              this.setMergeButtonClass('btn-danger');
              break;
            case "running":
              this.setMergeButtonClass('btn-info');
              break;
            case "success":
            case "success_with_warnings":
              this.setMergeButtonClass('btn-create');
          }
        } else {
          $('.ci_widget.ci-error').show();
          this.setMergeButtonClass('btn-danger');
        }
        this.initMiniPipelineGraph();
      };

      MergeRequestWidget.prototype.showCICoverage = function (coverage) {
        var text;
        text = 'Coverage ' + coverage + '%';
        return $('.ci_widget:visible .ci-coverage').text(text);
      };

      MergeRequestWidget.prototype.setMergeButtonClass = function (css_class) {
        return $('.js-merge-button,.accept-action .dropdown-toggle').removeClass('btn-danger btn-info btn-create').addClass(css_class);
      };

      MergeRequestWidget.prototype.updatePipelineUrls = function (id) {
        var pipelineUrl = this.opts.pipeline_path;
        $('.pipeline').text('#' + id).attr('href', [pipelineUrl, id].join('/'));
      };

      MergeRequestWidget.prototype.updateCommitUrls = function (id) {
        var commitsUrl = this.opts.commits_path;
        $('.js-commit-link').text('#' + id).attr('href', [commitsUrl, id].join('/'));
      };

      MergeRequestWidget.prototype.initMiniPipelineGraph = function () {
        new gl.MiniPipelineGraph({
          container: '.js-pipeline-inline-mr-widget-graph:visible'
        }).bindEvents();
      };

      return MergeRequestWidget;
    }();
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 125 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Flash */

  /**
   * In each pipelines table we have a mini pipeline graph for each pipeline.
   *
   * When we click in a pipeline stage, we need to make an API call to get the
   * builds list to render in a dropdown.
   *
   * The container should be the table element.
   *
   * The stage icon clicked needs to have the following HTML structure:
   * <div class="dropdown">
   *   <button class="dropdown js-builds-dropdown-button" data-toggle="dropdown"></button>
   *   <div class="js-builds-dropdown-container dropdown-menu"></div>
   * </div>
   */
  (function () {
    var MiniPipelineGraph = function () {
      function MiniPipelineGraph() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, MiniPipelineGraph);

        this.container = opts.container || '';
        this.dropdownListSelector = '.js-builds-dropdown-container';
        this.getBuildsList = this.getBuildsList.bind(this);
      }

      /**
       * Adds the event listener when the dropdown is opened.
       * All dropdown events are fired at the .dropdown-menu's parent element.
       */


      _createClass(MiniPipelineGraph, [{
        key: 'bindEvents',
        value: function bindEvents() {
          $(this.container).on('shown.bs.dropdown', this.getBuildsList);
        }

        /**
         * For the clicked stage, renders the given data in the dropdown list.
         *
         * @param  {HTMLElement} stageContainer
         * @param  {Object} data
         */

      }, {
        key: 'renderBuildsList',
        value: function renderBuildsList(stageContainer, data) {
          var dropdownContainer = stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-list');

          dropdownContainer.innerHTML = data;
        }

        /**
         * For the clicked stage, gets the list of builds.
         *
         * All dropdown events have a relatedTarget property,
         * whose value is the toggling anchor element.
         *
         * @param  {Object} e bootstrap dropdown event
         * @return {Promise}
         */

      }, {
        key: 'getBuildsList',
        value: function getBuildsList(e) {
          var _this = this;

          var button = e.relatedTarget;
          var endpoint = button.dataset.stageEndpoint;

          return $.ajax({
            dataType: 'json',
            type: 'GET',
            url: endpoint,
            beforeSend: function beforeSend() {
              _this.renderBuildsList(button, '');
              _this.toggleLoading(button);
            },
            success: function success(data) {
              _this.toggleLoading(button);
              _this.renderBuildsList(button, data.html);
            },
            error: function error() {
              _this.toggleLoading(button);
              new Flash('An error occurred while fetching the builds.', 'alert');
            }
          });
        }

        /**
         * Toggles the visibility of the loading icon.
         *
         * @param  {HTMLElement} stageContainer
         * @return {type}
         */

      }, {
        key: 'toggleLoading',
        value: function toggleLoading(stageContainer) {
          stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-loading').classList.toggle('hidden');
        }
      }]);

      return MiniPipelineGraph;
    }();

    window.gl = window.gl || {};
    window.gl.MiniPipelineGraph = MiniPipelineGraph;
  })();
}).call(window);

/***/ }),
/* 126 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var ENDLESS_SCROLL_BOTTOM_PX = 400;
    var ENDLESS_SCROLL_FIRE_DELAY_MS = 1000;

    var Pager = {
      init: function init() {
        var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var preload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;

        this.limit = limit;
        this.offset = this.limit;
        this.disable = disable;
        this.callback = callback;
        this.loading = $('.loading').first();
        if (preload) {
          this.offset = 0;
          this.getOld();
        }
        this.initLoadMore();
      },
      getOld: function getOld() {
        var _this = this;

        this.loading.show();
        $.ajax({
          type: 'GET',
          url: $('.content_list').data('href') || window.location.href,
          data: 'limit=' + this.limit + '&offset=' + this.offset,
          dataType: 'json',
          error: function error() {
            return _this.loading.hide();
          },
          success: function success(data) {
            _this.append(data.count, data.html);
            _this.callback();

            // keep loading until we've filled the viewport height
            if (!_this.disable && !_this.isScrollable()) {
              _this.getOld();
            } else {
              _this.loading.hide();
            }
          }
        });
      },
      append: function append(count, html) {
        $('.content_list').append(html);
        if (count > 0) {
          this.offset += count;
        } else {
          this.disable = true;
        }
      },
      isScrollable: function isScrollable() {
        var $w = $(window);
        return $(document).height() > $w.height() + $w.scrollTop() + ENDLESS_SCROLL_BOTTOM_PX;
      },
      initLoadMore: function initLoadMore() {
        var _this2 = this;

        $(document).unbind('scroll');
        $(document).endlessScroll({
          bottomPixels: ENDLESS_SCROLL_BOTTOM_PX,
          fireDelay: ENDLESS_SCROLL_FIRE_DELAY_MS,
          fireOnce: true,
          ceaseFire: function ceaseFire() {
            return _this2.disable === true;
          },
          callback: function callback() {
            if (!_this2.loading.is(':visible')) {
              _this2.loading.show();
              _this2.getOld();
            }
          }
        });
      }
    };

    window.Pager = Pager;
  })();
}).call(window);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new, guard-for-in, no-restricted-syntax, no-continue, no-param-reassign, max-len */

  __webpack_require__(37);

  (function (global) {
    var Pipelines = function () {
      function Pipelines() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Pipelines);

        if (options.initTabs && options.tabsOptions) {
          new global.LinkedTabs(options.tabsOptions);
        }

        this.addMarginToBuildColumns();
      }

      _createClass(Pipelines, [{
        key: 'addMarginToBuildColumns',
        value: function addMarginToBuildColumns() {
          this.pipelineGraph = document.querySelector('.js-pipeline-graph');

          var secondChildBuildNodes = this.pipelineGraph.querySelectorAll('.build:nth-child(2)');

          for (var buildNodeIndex in secondChildBuildNodes) {
            var buildNode = secondChildBuildNodes[buildNodeIndex];
            var firstChildBuildNode = buildNode.previousElementSibling;
            if (!firstChildBuildNode || !firstChildBuildNode.matches('.build')) continue;
            var multiBuildColumn = buildNode.closest('.stage-column');
            var previousColumn = multiBuildColumn.previousElementSibling;
            if (!previousColumn || !previousColumn.matches('.stage-column')) continue;
            multiBuildColumn.classList.add('left-margin');
            firstChildBuildNode.classList.add('left-connector');
            var columnBuilds = previousColumn.querySelectorAll('.build');
            if (columnBuilds.length === 1) previousColumn.classList.add('no-margin');
          }

          this.pipelineGraph.classList.remove('hidden');
        }
      }]);

      return Pipelines;
    }();

    global.Pipelines = Pipelines;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 128 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, no-var, object-shorthand, comma-dangle, prefer-arrow-callback */

  // MarkdownPreview
  //
  // Handles toggling the "Write" and "Preview" tab clicks, rendering the preview,
  // and showing a warning when more than `x` users are referenced.
  //
  (function () {
    var lastTextareaPreviewed;
    var lastTextareaHeight = null;
    var markdownPreview;
    var previewButtonSelector;
    var writeButtonSelector;

    window.MarkdownPreview = function () {
      function MarkdownPreview() {}

      // Minimum number of users referenced before triggering a warning
      MarkdownPreview.prototype.referenceThreshold = 10;

      MarkdownPreview.prototype.ajaxCache = {};

      MarkdownPreview.prototype.showPreview = function ($form) {
        var mdText;
        var preview = $form.find('.js-md-preview');
        if (preview.hasClass('md-preview-loading')) {
          return;
        }
        mdText = $form.find('textarea.markdown-area').val();

        if (mdText.trim().length === 0) {
          preview.text('Nothing to preview.');
          this.hideReferencedUsers($form);
        } else {
          preview.addClass('md-preview-loading').text('Loading...');
          this.fetchMarkdownPreview(mdText, function (response) {
            preview.removeClass('md-preview-loading').html(response.body);
            preview.renderGFM();
            this.renderReferencedUsers(response.references.users, $form);
          }.bind(this));
        }
      };

      MarkdownPreview.prototype.fetchMarkdownPreview = function (text, success) {
        if (!window.preview_markdown_path) {
          return;
        }
        if (text === this.ajaxCache.text) {
          success(this.ajaxCache.response);
          return;
        }
        $.ajax({
          type: 'POST',
          url: window.preview_markdown_path,
          data: {
            text: text
          },
          dataType: 'json',
          success: function (response) {
            this.ajaxCache = {
              text: text,
              response: response
            };
            success(response);
          }.bind(this)
        });
      };

      MarkdownPreview.prototype.hideReferencedUsers = function ($form) {
        $form.find('.referenced-users').hide();
      };

      MarkdownPreview.prototype.renderReferencedUsers = function (users, $form) {
        var referencedUsers;
        referencedUsers = $form.find('.referenced-users');
        if (referencedUsers.length) {
          if (users.length >= this.referenceThreshold) {
            referencedUsers.show();
            referencedUsers.find('.js-referenced-users-count').text(users.length);
          } else {
            referencedUsers.hide();
          }
        }
      };

      return MarkdownPreview;
    }();

    markdownPreview = new window.MarkdownPreview();

    previewButtonSelector = '.js-md-preview-button';

    writeButtonSelector = '.js-md-write-button';

    lastTextareaPreviewed = null;

    $.fn.setupMarkdownPreview = function () {
      var $form = $(this);
      $form.find('textarea.markdown-area').on('input', function () {
        markdownPreview.hideReferencedUsers($form);
      });
    };

    $(document).on('markdown-preview:show', function (e, $form) {
      if (!$form) {
        return;
      }

      lastTextareaPreviewed = $form.find('textarea.markdown-area');
      lastTextareaHeight = lastTextareaPreviewed.height();

      // toggle tabs
      $form.find(writeButtonSelector).parent().removeClass('active');
      $form.find(previewButtonSelector).parent().addClass('active');

      // toggle content
      $form.find('.md-write-holder').hide();
      $form.find('.md-preview-holder').show();
      markdownPreview.showPreview($form);
    });

    $(document).on('markdown-preview:hide', function (e, $form) {
      if (!$form) {
        return;
      }
      lastTextareaPreviewed = null;

      if (lastTextareaHeight) {
        $form.find('textarea.markdown-area').height(lastTextareaHeight);
      }

      // toggle tabs
      $form.find(writeButtonSelector).parent().addClass('active');
      $form.find(previewButtonSelector).parent().removeClass('active');

      // toggle content
      $form.find('.md-write-holder').show();
      $form.find('textarea.markdown-area').focus();
      $form.find('.md-preview-holder').hide();
    });

    $(document).on('markdown-preview:toggle', function (e, keyboardEvent) {
      var $target;
      $target = $(keyboardEvent.target);
      if ($target.is('textarea.markdown-area')) {
        $(document).triggerHandler('markdown-preview:show', [$target.closest('form')]);
        keyboardEvent.preventDefault();
      } else if (lastTextareaPreviewed) {
        $target = lastTextareaPreviewed;
        $(document).triggerHandler('markdown-preview:hide', [$target.closest('form')]);
        keyboardEvent.preventDefault();
      }
    });

    $(document).on('click', previewButtonSelector, function (e) {
      var $form;
      e.preventDefault();
      $form = $(this).closest('form');
      $(document).triggerHandler('markdown-preview:show', [$form]);
    });

    $(document).on('click', writeButtonSelector, function (e) {
      var $form;
      e.preventDefault();
      $form = $(this).closest('form');
      $(document).triggerHandler('markdown-preview:hide', [$form]);
    });
  })();
}).call(window);

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable wrap-iife, func-names, space-before-function-paren, object-shorthand, comma-dangle, one-var, one-var-declaration-per-line, no-restricted-syntax, max-len, no-param-reassign */

  (function (global) {
    var ProjectLabelSubscription = function () {
      function ProjectLabelSubscription(container) {
        _classCallCheck(this, ProjectLabelSubscription);

        this.$container = $(container);
        this.$buttons = this.$container.find('.js-subscribe-button');

        this.$buttons.on('click', this.toggleSubscription.bind(this));
      }

      _createClass(ProjectLabelSubscription, [{
        key: 'toggleSubscription',
        value: function toggleSubscription(event) {
          var _this = this;

          event.preventDefault();

          var $btn = $(event.currentTarget);
          var $span = $btn.find('span');
          var url = $btn.attr('data-url');
          var oldStatus = $btn.attr('data-status');

          $btn.addClass('disabled');
          $span.toggleClass('hidden');

          $.ajax({
            type: 'POST',
            url: url
          }).done(function () {
            var newStatus = void 0,
                newAction = void 0;

            if (oldStatus === 'unsubscribed') {
              newStatus = 'subscribed';
              newAction = 'Unsubscribe';
            } else {
              newStatus = 'unsubscribed';
              newAction = 'Subscribe';
            }

            $span.toggleClass('hidden');
            $btn.removeClass('disabled');

            _this.$buttons.attr('data-status', newStatus);
            _this.$buttons.find('> span').text(newAction);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = _this.$buttons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var button = _step.value;

                var $button = $(button);

                if ($button.attr('data-original-title')) {
                  $button.tooltip('hide').attr('data-original-title', newAction).tooltip('fixTitle');
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
        }
      }]);

      return ProjectLabelSubscription;
    }();

    global.ProjectLabelSubscription = ProjectLabelSubscription;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 132 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var HIDDEN_VALUE_TEXT = '******';

    var ProjectVariables = function () {
      function ProjectVariables() {
        _classCallCheck(this, ProjectVariables);

        this.$revealBtn = $('.js-btn-toggle-reveal-values');
        this.$revealBtn.on('click', this.toggleRevealState.bind(this));
      }

      _createClass(ProjectVariables, [{
        key: 'toggleRevealState',
        value: function toggleRevealState(e) {
          e.preventDefault();

          var oldStatus = this.$revealBtn.attr('data-status');
          var newStatus = 'hidden';
          var newAction = 'Reveal Values';

          if (oldStatus === 'hidden') {
            newStatus = 'revealed';
            newAction = 'Hide Values';
          }

          this.$revealBtn.attr('data-status', newStatus);

          var $variables = $('.variable-value');

          $variables.each(function (_, variable) {
            var $variable = $(variable);
            var newText = HIDDEN_VALUE_TEXT;

            if (newStatus === 'revealed') {
              newText = $variable.attr('data-value');
            }

            $variable.text(newText);
          });

          this.$revealBtn.text(newAction);
        }
      }]);

      return ProjectVariables;
    }();

    window.gl = window.gl || {};
    window.gl.ProjectVariables = ProjectVariables;
  })();
}).call(window);

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, no-return-assign, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-unused-vars, no-cond-assign, consistent-return, object-shorthand, prefer-arrow-callback, func-names, space-before-function-paren, prefer-template, quotes, class-methods-use-this, no-unused-expressions, no-sequences, wrap-iife, no-lonely-if, no-else-return, no-param-reassign, vars-on-top, max-len */

  (function (global) {
    var KEYCODE = {
      ESCAPE: 27,
      BACKSPACE: 8,
      ENTER: 13,
      UP: 38,
      DOWN: 40
    };

    var SearchAutocomplete = function () {
      function SearchAutocomplete() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            wrap = _ref.wrap,
            optsEl = _ref.optsEl,
            autocompletePath = _ref.autocompletePath,
            projectId = _ref.projectId,
            projectRef = _ref.projectRef;

        _classCallCheck(this, SearchAutocomplete);

        this.bindEventContext();
        this.wrap = wrap || $('.search');
        this.optsEl = optsEl || this.wrap.find('.search-autocomplete-opts');
        this.autocompletePath = autocompletePath || this.optsEl.data('autocomplete-path');
        this.projectId = projectId || this.optsEl.data('autocomplete-project-id') || '';
        this.projectRef = projectRef || this.optsEl.data('autocomplete-project-ref') || '';
        this.dropdown = this.wrap.find('.dropdown');
        this.dropdownContent = this.dropdown.find('.dropdown-content');
        this.locationBadgeEl = this.getElement('.location-badge');
        this.scopeInputEl = this.getElement('#scope');
        this.searchInput = this.getElement('.search-input');
        this.projectInputEl = this.getElement('#search_project_id');
        this.groupInputEl = this.getElement('#group_id');
        this.searchCodeInputEl = this.getElement('#search_code');
        this.repositoryInputEl = this.getElement('#repository_ref');
        this.clearInput = this.getElement('.js-clear-input');
        this.saveOriginalState();
        // Only when user is logged in
        if (gon.current_user_id) {
          this.createAutocomplete();
        }
        this.searchInput.addClass('disabled');
        this.saveTextLength();
        this.bindEvents();
      }

      // Finds an element inside wrapper element


      _createClass(SearchAutocomplete, [{
        key: 'bindEventContext',
        value: function bindEventContext() {
          this.onSearchInputBlur = this.onSearchInputBlur.bind(this);
          this.onClearInputClick = this.onClearInputClick.bind(this);
          this.onSearchInputFocus = this.onSearchInputFocus.bind(this);
          this.onSearchInputClick = this.onSearchInputClick.bind(this);
          this.onSearchInputKeyUp = this.onSearchInputKeyUp.bind(this);
          this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
        }
      }, {
        key: 'getElement',
        value: function getElement(selector) {
          return this.wrap.find(selector);
        }
      }, {
        key: 'saveOriginalState',
        value: function saveOriginalState() {
          return this.originalState = this.serializeState();
        }
      }, {
        key: 'saveTextLength',
        value: function saveTextLength() {
          return this.lastTextLength = this.searchInput.val().length;
        }
      }, {
        key: 'createAutocomplete',
        value: function createAutocomplete() {
          return this.searchInput.glDropdown({
            filterInputBlur: false,
            filterable: true,
            filterRemote: true,
            highlight: true,
            enterCallback: false,
            filterInput: 'input#search',
            search: {
              fields: ['text']
            },
            id: this.getSearchText,
            data: this.getData.bind(this),
            selectable: true,
            clicked: this.onClick.bind(this)
          });
        }
      }, {
        key: 'getSearchText',
        value: function getSearchText(selectedObject, el) {
          return selectedObject.id ? selectedObject.text : '';
        }
      }, {
        key: 'getData',
        value: function getData(term, callback) {
          var _this, contents, jqXHR;
          _this = this;
          if (!term) {
            if (contents = this.getCategoryContents()) {
              this.searchInput.data('glDropdown').filter.options.callback(contents);
              this.enableAutocomplete();
            }
            return;
          }
          // Prevent multiple ajax calls
          if (this.loadingSuggestions) {
            return;
          }
          this.loadingSuggestions = true;
          return jqXHR = $.get(this.autocompletePath, {
            project_id: this.projectId,
            project_ref: this.projectRef,
            term: term
          }, function (response) {
            var data, firstCategory, i, lastCategory, len, suggestion;
            // Hide dropdown menu if no suggestions returns
            if (!response.length) {
              _this.disableAutocomplete();
              return;
            }
            data = [];
            // List results
            firstCategory = true;
            for (i = 0, len = response.length; i < len; i += 1) {
              suggestion = response[i];
              // Add group header before list each group
              if (lastCategory !== suggestion.category) {
                if (!firstCategory) {
                  data.push('separator');
                }
                if (firstCategory) {
                  firstCategory = false;
                }
                data.push({
                  header: suggestion.category
                });
                lastCategory = suggestion.category;
              }
              data.push({
                id: suggestion.category.toLowerCase() + "-" + suggestion.id,
                category: suggestion.category,
                text: suggestion.label,
                url: suggestion.url
              });
            }
            // Add option to proceed with the search
            if (data.length) {
              data.push('separator');
              data.push({
                text: "Result name contains \"" + term + "\"",
                url: "/search?search=" + term + "&project_id=" + _this.projectInputEl.val() + "&group_id=" + _this.groupInputEl.val()
              });
            }
            return callback(data);
          }).always(function () {
            return _this.loadingSuggestions = false;
          });
        }
      }, {
        key: 'getCategoryContents',
        value: function getCategoryContents() {
          var dashboardOptions, groupOptions, issuesPath, items, mrPath, name, options, projectOptions, userId, userName, utils;
          userId = gon.current_user_id;
          userName = gon.current_username;
          utils = gl.utils, projectOptions = gl.projectOptions, groupOptions = gl.groupOptions, dashboardOptions = gl.dashboardOptions;
          if (utils.isInGroupsPage() && groupOptions) {
            options = groupOptions[utils.getGroupSlug()];
          } else if (utils.isInProjectPage() && projectOptions) {
            options = projectOptions[utils.getProjectSlug()];
          } else if (dashboardOptions) {
            options = dashboardOptions;
          }
          issuesPath = options.issuesPath, mrPath = options.mrPath, name = options.name;
          items = [{
            header: "" + name
          }, {
            text: 'Issues assigned to me',
            url: issuesPath + "/?assignee_username=" + userName
          }, {
            text: "Issues I've created",
            url: issuesPath + "/?author_username=" + userName
          }, 'separator', {
            text: 'Merge requests assigned to me',
            url: mrPath + "/?assignee_id=" + userId
          }, {
            text: "Merge requests I've created",
            url: mrPath + "/?author_id=" + userId
          }];
          if (!name) {
            items.splice(0, 1);
          }
          return items;
        }
      }, {
        key: 'serializeState',
        value: function serializeState() {
          return {
            // Search Criteria
            search_project_id: this.projectInputEl.val(),
            group_id: this.groupInputEl.val(),
            search_code: this.searchCodeInputEl.val(),
            repository_ref: this.repositoryInputEl.val(),
            scope: this.scopeInputEl.val(),
            // Location badge
            _location: this.locationBadgeEl.text()
          };
        }
      }, {
        key: 'bindEvents',
        value: function bindEvents() {
          this.searchInput.on('keydown', this.onSearchInputKeyDown);
          this.searchInput.on('keyup', this.onSearchInputKeyUp);
          this.searchInput.on('click', this.onSearchInputClick);
          this.searchInput.on('focus', this.onSearchInputFocus);
          this.searchInput.on('blur', this.onSearchInputBlur);
          this.clearInput.on('click', this.onClearInputClick);
          return this.locationBadgeEl.on('click', function (_this) {
            return function () {
              return _this.searchInput.focus();
            };
          }(this));
        }
      }, {
        key: 'enableAutocomplete',
        value: function enableAutocomplete() {
          var _this;
          // No need to enable anything if user is not logged in
          if (!gon.current_user_id) {
            return;
          }
          if (!this.dropdown.hasClass('open')) {
            _this = this;
            this.loadingSuggestions = false;
            this.dropdown.addClass('open').trigger('shown.bs.dropdown');
            return this.searchInput.removeClass('disabled');
          }
        }

        // Saves last length of the entered text

      }, {
        key: 'onSearchInputKeyDown',
        value: function onSearchInputKeyDown() {
          return this.saveTextLength();
        }
      }, {
        key: 'onSearchInputKeyUp',
        value: function onSearchInputKeyUp(e) {
          switch (e.keyCode) {
            case KEYCODE.BACKSPACE:
              // when trying to remove the location badge
              if (this.lastTextLength === 0 && this.badgePresent()) {
                this.removeLocationBadge();
              }
              // When removing the last character and no badge is present
              if (this.lastTextLength === 1) {
                this.disableAutocomplete();
              }
              // When removing any character from existin value
              if (this.lastTextLength > 1) {
                this.enableAutocomplete();
              }
              break;
            case KEYCODE.ESCAPE:
              this.restoreOriginalState();
              break;
            case KEYCODE.ENTER:
              this.disableAutocomplete();
              break;
            case KEYCODE.UP:
            case KEYCODE.DOWN:
              return;
            default:
              // Handle the case when deleting the input value other than backspace
              // e.g. Pressing ctrl + backspace or ctrl + x
              if (this.searchInput.val() === '') {
                this.disableAutocomplete();
              } else {
                // We should display the menu only when input is not empty
                if (e.keyCode !== KEYCODE.ENTER) {
                  this.enableAutocomplete();
                }
              }
          }
          this.wrap.toggleClass('has-value', !!e.target.value);
        }

        // Avoid falsy value to be returned

      }, {
        key: 'onSearchInputClick',
        value: function onSearchInputClick(e) {
          return e.stopImmediatePropagation();
        }
      }, {
        key: 'onSearchInputFocus',
        value: function onSearchInputFocus() {
          this.isFocused = true;
          this.wrap.addClass('search-active');
          if (this.getValue() === '') {
            return this.getData();
          }
        }
      }, {
        key: 'getValue',
        value: function getValue() {
          return this.searchInput.val();
        }
      }, {
        key: 'onClearInputClick',
        value: function onClearInputClick(e) {
          e.preventDefault();
          return this.searchInput.val('').focus();
        }
      }, {
        key: 'onSearchInputBlur',
        value: function onSearchInputBlur(e) {
          this.isFocused = false;
          this.wrap.removeClass('search-active');
          // If input is blank then restore state
          if (this.searchInput.val() === '') {
            return this.restoreOriginalState();
          }
        }
      }, {
        key: 'addLocationBadge',
        value: function addLocationBadge(item) {
          var badgeText, category, value;
          category = item.category != null ? item.category + ": " : '';
          value = item.value != null ? item.value : '';
          badgeText = "" + category + value;
          this.locationBadgeEl.text(badgeText).show();
          return this.wrap.addClass('has-location-badge');
        }
      }, {
        key: 'hasLocationBadge',
        value: function hasLocationBadge() {
          return this.wrap.is('.has-location-badge');
        }
      }, {
        key: 'restoreOriginalState',
        value: function restoreOriginalState() {
          var i, input, inputs, len;
          inputs = Object.keys(this.originalState);
          for (i = 0, len = inputs.length; i < len; i += 1) {
            input = inputs[i];
            this.getElement("#" + input).val(this.originalState[input]);
          }
          if (this.originalState._location === '') {
            return this.locationBadgeEl.hide();
          } else {
            return this.addLocationBadge({
              value: this.originalState._location
            });
          }
        }
      }, {
        key: 'badgePresent',
        value: function badgePresent() {
          return this.locationBadgeEl.length;
        }
      }, {
        key: 'resetSearchState',
        value: function resetSearchState() {
          var i, input, inputs, len, results;
          inputs = Object.keys(this.originalState);
          results = [];
          for (i = 0, len = inputs.length; i < len; i += 1) {
            input = inputs[i];
            // _location isnt a input
            if (input === '_location') {
              break;
            }
            results.push(this.getElement("#" + input).val(''));
          }
          return results;
        }
      }, {
        key: 'removeLocationBadge',
        value: function removeLocationBadge() {
          this.locationBadgeEl.hide();
          this.resetSearchState();
          this.wrap.removeClass('has-location-badge');
          return this.disableAutocomplete();
        }
      }, {
        key: 'disableAutocomplete',
        value: function disableAutocomplete() {
          if (!this.searchInput.hasClass('disabled') && this.dropdown.hasClass('open')) {
            this.searchInput.addClass('disabled');
            this.dropdown.removeClass('open').trigger('hidden.bs.dropdown');
            this.restoreMenu();
          }
        }
      }, {
        key: 'restoreMenu',
        value: function restoreMenu() {
          var html;
          html = "<ul> <li><a class='dropdown-menu-empty-link is-focused'>Loading...</a></li> </ul>";
          return this.dropdownContent.html(html);
        }
      }, {
        key: 'onClick',
        value: function onClick(item, $el, e) {
          if (location.pathname.indexOf(item.url) !== -1) {
            if (!e.metaKey) e.preventDefault();
            if (!this.badgePresent) {
              if (item.category === 'Projects') {
                this.projectInputEl.val(item.id);
                this.addLocationBadge({
                  value: 'This project'
                });
              }
              if (item.category === 'Groups') {
                this.groupInputEl.val(item.id);
                this.addLocationBadge({
                  value: 'This group'
                });
              }
            }
            $el.removeClass('is-active');
            this.disableAutocomplete();
            return this.searchInput.val('').focus();
          }
        }
      }]);

      return SearchAutocomplete;
    }();

    global.SearchAutocomplete = SearchAutocomplete;

    $(function () {
      var $projectOptionsDataEl = $('.js-search-project-options');
      var $groupOptionsDataEl = $('.js-search-group-options');
      var $dashboardOptionsDataEl = $('.js-search-dashboard-options');

      if ($projectOptionsDataEl.length) {
        gl.projectOptions = gl.projectOptions || {};

        var projectPath = $projectOptionsDataEl.data('project-path');

        gl.projectOptions[projectPath] = {
          name: $projectOptionsDataEl.data('name'),
          issuesPath: $projectOptionsDataEl.data('issues-path'),
          mrPath: $projectOptionsDataEl.data('mr-path')
        };
      }

      if ($groupOptionsDataEl.length) {
        gl.groupOptions = gl.groupOptions || {};

        var groupPath = $groupOptionsDataEl.data('group-path');

        gl.groupOptions[groupPath] = {
          name: $groupOptionsDataEl.data('name'),
          issuesPath: $groupOptionsDataEl.data('issues-path'),
          mrPath: $groupOptionsDataEl.data('mr-path')
        };
      }

      if ($dashboardOptionsDataEl.length) {
        gl.dashboardOptions = {
          issuesPath: $dashboardOptionsDataEl.data('issues-path'),
          mrPath: $dashboardOptionsDataEl.data('mr-path')
        };
      }
    });
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 139 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable arrow-parens, class-methods-use-this, no-param-reassign */
  /* global Cookies */

  (function () {
    var pinnedStateCookie = 'pin_nav';
    var sidebarBreakpoint = 1024;

    var pageSelector = '.page-with-sidebar';
    var navbarSelector = '.navbar-fixed-top';
    var sidebarWrapperSelector = '.sidebar-wrapper';
    var sidebarContentSelector = '.nav-sidebar';

    var pinnedToggleSelector = '.js-nav-pin';
    var sidebarToggleSelector = '.toggle-nav-collapse, .side-nav-toggle';

    var pinnedPageClass = 'page-sidebar-pinned';
    var expandedPageClass = 'page-sidebar-expanded';

    var pinnedNavbarClass = 'header-sidebar-pinned';
    var expandedNavbarClass = 'header-sidebar-expanded';

    var Sidebar = function () {
      function Sidebar() {
        _classCallCheck(this, Sidebar);

        if (!Sidebar.singleton) {
          Sidebar.singleton = this;
          Sidebar.singleton.init();
        }

        return Sidebar.singleton;
      }

      _createClass(Sidebar, [{
        key: 'init',
        value: function init() {
          var _this = this;

          this.isPinned = Cookies.get(pinnedStateCookie) === 'true';
          this.isExpanded = window.innerWidth >= sidebarBreakpoint && $(pageSelector).hasClass(expandedPageClass);
          $(document).on('click', sidebarToggleSelector, function () {
            return _this.toggleSidebar();
          }).on('click', pinnedToggleSelector, function () {
            return _this.togglePinnedState();
          }).on('click', 'html, body, a, button', function (e) {
            return _this.handleClickEvent(e);
          }).on('DOMContentLoaded', function () {
            return _this.renderState();
          }).on('todo:toggle', function (e, count) {
            return _this.updateTodoCount(count);
          });
          this.renderState();
        }
      }, {
        key: 'handleClickEvent',
        value: function handleClickEvent(e) {
          if (this.isExpanded && (!this.isPinned || window.innerWidth < sidebarBreakpoint)) {
            var $target = $(e.target);
            var targetIsToggle = $target.closest(sidebarToggleSelector).length > 0;
            var targetIsSidebar = $target.closest(sidebarWrapperSelector).length > 0;
            if (!targetIsToggle && (!targetIsSidebar || $target.closest('a'))) {
              this.toggleSidebar();
            }
          }
        }
      }, {
        key: 'updateTodoCount',
        value: function updateTodoCount(count) {
          $('.js-todos-count').text(gl.text.addDelimiter(count));
        }
      }, {
        key: 'toggleSidebar',
        value: function toggleSidebar() {
          this.isExpanded = !this.isExpanded;
          this.renderState();
        }
      }, {
        key: 'togglePinnedState',
        value: function togglePinnedState() {
          this.isPinned = !this.isPinned;
          if (!this.isPinned) {
            this.isExpanded = false;
          }
          Cookies.set(pinnedStateCookie, this.isPinned ? 'true' : 'false', { expires: 3650 });
          this.renderState();
        }
      }, {
        key: 'renderState',
        value: function renderState() {
          $(pageSelector).toggleClass(pinnedPageClass, this.isPinned && this.isExpanded).toggleClass(expandedPageClass, this.isExpanded);
          $(navbarSelector).toggleClass(pinnedNavbarClass, this.isPinned && this.isExpanded).toggleClass(expandedNavbarClass, this.isExpanded);

          var $pinnedToggle = $(pinnedToggleSelector);
          var tooltipText = this.isPinned ? 'Unpin navigation' : 'Pin navigation';
          var tooltipState = $pinnedToggle.attr('aria-describedby') && this.isExpanded ? 'show' : 'hide';
          $pinnedToggle.attr('title', tooltipText).tooltip('fixTitle').tooltip(tooltipState);

          if (this.isExpanded) {
            var sidebarContent = $(sidebarContentSelector);
            setTimeout(function () {
              sidebarContent.niceScroll().updateScrollBar();
            }, 200);
          }
        }
      }]);

      return Sidebar;
    }();

    window.gl = window.gl || {};
    gl.Sidebar = Sidebar;
  })();
}).call(window);

/***/ }),
/* 140 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint no-param-reassign: ["error", { "props": false }]*/
  /* eslint no-new: "off" */
  (function (global) {
    /**
     * Memorize the last selected tab after reloading a page.
     * Does that setting the current selected tab in the localStorage
     */
    var ActiveTabMemoizer = function () {
      function ActiveTabMemoizer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$currentTabKey = _ref.currentTabKey,
            currentTabKey = _ref$currentTabKey === undefined ? 'current_signin_tab' : _ref$currentTabKey,
            _ref$tabSelector = _ref.tabSelector,
            tabSelector = _ref$tabSelector === undefined ? 'ul.nav-tabs' : _ref$tabSelector;

        _classCallCheck(this, ActiveTabMemoizer);

        this.currentTabKey = currentTabKey;
        this.tabSelector = tabSelector;
        this.bootstrap();
      }

      _createClass(ActiveTabMemoizer, [{
        key: 'bootstrap',
        value: function bootstrap() {
          var _this = this;

          var tabs = document.querySelectorAll(this.tabSelector);
          if (tabs.length > 0) {
            tabs[0].addEventListener('click', function (e) {
              if (e.target && e.target.nodeName === 'A') {
                var anchorName = e.target.getAttribute('href');
                _this.saveData(anchorName);
              }
            });
          }

          this.showTab();
        }
      }, {
        key: 'showTab',
        value: function showTab() {
          var anchorName = this.readData();
          if (anchorName) {
            var tab = document.querySelector(this.tabSelector + ' a[href="' + anchorName + '"]');
            if (tab) {
              tab.click();
            }
          }
        }
      }, {
        key: 'saveData',
        value: function saveData(val) {
          localStorage.setItem(this.currentTabKey, val);
        }
      }, {
        key: 'readData',
        value: function readData() {
          return localStorage.getItem(this.currentTabKey);
        }
      }]);

      return ActiveTabMemoizer;
    }();

    global.ActiveTabMemoizer = ActiveTabMemoizer;
  })(window);
}).call(window);

/***/ }),
/* 141 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable arrow-parens, no-param-reassign, space-before-function-paren, func-names, no-var, max-len */

  (function (global) {
    global.gl = global.gl || {};

    gl.SnippetsList = function () {
      var $holder = $('.snippets-list-holder');

      $holder.find('.pagination').on('ajax:success', function (e, data) {
        $holder.replaceWith(data.html);
      });
    };
  })(window);
}).call(window);

/***/ }),
/* 142 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */

  (function () {
    var Subscription = function () {
      function Subscription(containerElm) {
        _classCallCheck(this, Subscription);

        this.containerElm = containerElm;

        var subscribeButton = containerElm.querySelector('.js-subscribe-button');
        if (subscribeButton) {
          // remove class so we don't bind twice
          subscribeButton.classList.remove('js-subscribe-button');
          subscribeButton.addEventListener('click', this.toggleSubscription.bind(this));
        }
      }

      _createClass(Subscription, [{
        key: 'toggleSubscription',
        value: function toggleSubscription(event) {
          var button = event.currentTarget;
          var buttonSpan = button.querySelector('span');
          if (!buttonSpan || button.classList.contains('disabled')) {
            return;
          }
          button.classList.add('disabled');

          var isSubscribed = buttonSpan.innerHTML.trim().toLowerCase() !== 'subscribe';
          var toggleActionUrl = this.containerElm.dataset.url;

          $.post(toggleActionUrl, function () {
            button.classList.remove('disabled');

            // hack to allow this to work with the issue boards Vue object
            if (document.querySelector('html').classList.contains('issue-boards-page')) {
              Vue.set(gl.issueBoards.BoardsStore.detail.issue, 'subscribed', !gl.issueBoards.BoardsStore.detail.issue.subscribed);
            } else {
              buttonSpan.innerHTML = isSubscribed ? 'Subscribe' : 'Unsubscribe';
            }
          });
        }
      }], [{
        key: 'bindAll',
        value: function bindAll(selector) {
          [].forEach.call(document.querySelectorAll(selector), function (elm) {
            return new Subscription(elm);
          });
        }
      }]);

      return Subscription;
    }();

    window.gl = window.gl || {};
    window.gl.Subscription = Subscription;
  })();
}).call(window);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, max-len, no-useless-return, no-param-reassign, max-len */
  /* global Api */

  __webpack_require__(5);

  (function (global) {
    var IssuableTemplateSelector = function (_gl$TemplateSelector) {
      _inherits(IssuableTemplateSelector, _gl$TemplateSelector);

      function IssuableTemplateSelector() {
        var _ref;

        _classCallCheck(this, IssuableTemplateSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = IssuableTemplateSelector.__proto__ || Object.getPrototypeOf(IssuableTemplateSelector)).call.apply(_ref, [this].concat(args)));

        _this.projectPath = _this.dropdown.data('project-path');
        _this.namespacePath = _this.dropdown.data('namespace-path');
        _this.issuableType = _this.wrapper.data('issuable-type');
        _this.titleInput = $('#' + _this.issuableType + '_title');

        var initialQuery = {
          name: _this.dropdown.data('selected')
        };

        if (initialQuery.name) _this.requestFile(initialQuery);

        $('.reset-template', _this.dropdown.parent()).on('click', function () {
          _this.setInputValueToTemplateContent();
        });

        $('.no-template', _this.dropdown.parent()).on('click', function () {
          _this.currentTemplate.content = '';
          _this.setInputValueToTemplateContent();
          $('.dropdown-toggle-text', _this.dropdown).text('Choose a template');
        });
        return _this;
      }

      _createClass(IssuableTemplateSelector, [{
        key: 'requestFile',
        value: function requestFile(query) {
          var _this2 = this;

          this.startLoadingSpinner();
          Api.issueTemplate(this.namespacePath, this.projectPath, query.name, this.issuableType, function (err, currentTemplate) {
            _this2.currentTemplate = currentTemplate;
            if (err) return; // Error handled by global AJAX error handler
            _this2.stopLoadingSpinner();
            _this2.setInputValueToTemplateContent();
          });
          return;
        }
      }, {
        key: 'setInputValueToTemplateContent',
        value: function setInputValueToTemplateContent() {
          // `this.requestFileSuccess` sets the value of the description input field
          // to the content of the template selected.
          if (this.titleInput.val() === '') {
            // If the title has not yet been set, focus the title input and
            // skip focusing the description input by setting `true` as the
            // `skipFocus` option to `requestFileSuccess`.
            this.requestFileSuccess(this.currentTemplate, { skipFocus: true });
            this.titleInput.focus();
          } else {
            this.requestFileSuccess(this.currentTemplate, { skipFocus: false });
          }
          return;
        }
      }]);

      return IssuableTemplateSelector;
    }(gl.TemplateSelector);

    global.IssuableTemplateSelector = IssuableTemplateSelector;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 144 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new, comma-dangle, class-methods-use-this, no-param-reassign */

  (function (global) {
    var IssuableTemplateSelectors = function () {
      function IssuableTemplateSelectors() {
        var _this = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            $dropdowns = _ref.$dropdowns,
            editor = _ref.editor;

        _classCallCheck(this, IssuableTemplateSelectors);

        this.$dropdowns = $dropdowns || $('.js-issuable-selector');
        this.editor = editor || this.initEditor();

        this.$dropdowns.each(function (i, dropdown) {
          var $dropdown = $(dropdown);
          new gl.IssuableTemplateSelector({
            pattern: /(\.md)/,
            data: $dropdown.data('data'),
            wrapper: $dropdown.closest('.js-issuable-selector-wrap'),
            dropdown: $dropdown,
            editor: _this.editor
          });
        });
      }

      _createClass(IssuableTemplateSelectors, [{
        key: 'initEditor',
        value: function initEditor() {
          var editor = $('.markdown-area');
          // Proxy ace-editor's .setValue to jQuery's .val
          editor.setValue = editor.val;
          editor.getValue = editor.val;
          return editor;
        }
      }]);

      return IssuableTemplateSelectors;
    }();

    global.IssuableTemplateSelectors = IssuableTemplateSelectors;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 145 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable class-methods-use-this, no-new, func-names, prefer-template, no-unneeded-ternary, object-shorthand, space-before-function-paren, comma-dangle, quote-props, consistent-return, no-else-return, no-param-reassign, max-len */
  /* global UsersSelect */

  (function (global) {
    var Todos = function () {
      function Todos() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el;

        _classCallCheck(this, Todos);

        this.allDoneClicked = this.allDoneClicked.bind(this);
        this.doneClicked = this.doneClicked.bind(this);
        this.el = el || $('.js-todos-options');
        this.perPage = this.el.data('perPage');
        this.clearListeners();
        this.initBtnListeners();
        this.initFilters();
      }

      _createClass(Todos, [{
        key: 'clearListeners',
        value: function clearListeners() {
          $('.done-todo').off('click');
          $('.js-todos-mark-all').off('click');
          return $('.todo').off('click');
        }
      }, {
        key: 'initBtnListeners',
        value: function initBtnListeners() {
          $('.done-todo').on('click', this.doneClicked);
          $('.js-todos-mark-all').on('click', this.allDoneClicked);
          return $('.todo').on('click', this.goToTodoUrl);
        }
      }, {
        key: 'initFilters',
        value: function initFilters() {
          new UsersSelect();
          this.initFilterDropdown($('.js-project-search'), 'project_id', ['text']);
          this.initFilterDropdown($('.js-type-search'), 'type');
          this.initFilterDropdown($('.js-action-search'), 'action_id');

          $('form.filter-form').on('submit', function (event) {
            event.preventDefault();
            gl.utils.visitUrl(this.action + '&' + $(this).serialize());
          });
        }
      }, {
        key: 'initFilterDropdown',
        value: function initFilterDropdown($dropdown, fieldName, searchFields) {
          $dropdown.glDropdown({
            fieldName: fieldName,
            selectable: true,
            filterable: searchFields ? true : false,
            search: { fields: searchFields },
            data: $dropdown.data('data'),
            clicked: function clicked() {
              return $dropdown.closest('form.filter-form').submit();
            }
          });
        }
      }, {
        key: 'doneClicked',
        value: function doneClicked(e) {
          var _this = this;

          e.preventDefault();
          e.stopImmediatePropagation();
          var $target = $(e.currentTarget);
          $target.disable();
          return $.ajax({
            type: 'POST',
            url: $target.attr('href'),
            dataType: 'json',
            data: {
              '_method': 'delete'
            },
            success: function success(data) {
              _this.redirectIfNeeded(data.count);
              _this.clearDone($target.closest('li'));
              return _this.updateBadges(data);
            }
          });
        }
      }, {
        key: 'allDoneClicked',
        value: function allDoneClicked(e) {
          var _this2 = this;

          e.preventDefault();
          e.stopImmediatePropagation();
          var $target = $(e.currentTarget);
          $target.disable();
          return $.ajax({
            type: 'POST',
            url: $target.attr('href'),
            dataType: 'json',
            data: {
              '_method': 'delete'
            },
            success: function success(data) {
              $target.remove();
              $('.js-todos-all').html('<div class="nothing-here-block">You\'re all done!</div>');
              return _this2.updateBadges(data);
            }
          });
        }
      }, {
        key: 'clearDone',
        value: function clearDone($row) {
          var $ul = $row.closest('ul');
          $row.remove();
          if (!$ul.find('li').length) {
            return $ul.parents('.panel').remove();
          }
        }
      }, {
        key: 'updateBadges',
        value: function updateBadges(data) {
          $(document).trigger('todo:toggle', data.count);
          $('.todos-pending .badge').text(data.count);
          return $('.todos-done .badge').text(data.done_count);
        }
      }, {
        key: 'getTotalPages',
        value: function getTotalPages() {
          return this.el.data('totalPages');
        }
      }, {
        key: 'getCurrentPage',
        value: function getCurrentPage() {
          return this.el.data('currentPage');
        }
      }, {
        key: 'getTodosPerPage',
        value: function getTodosPerPage() {
          return this.el.data('perPage');
        }
      }, {
        key: 'redirectIfNeeded',
        value: function redirectIfNeeded(total) {
          var currPages = this.getTotalPages();
          var currPage = this.getCurrentPage();

          // Refresh if no remaining Todos
          if (!total) {
            window.location.reload();
            return;
          }
          // Do nothing if no pagination
          if (!currPages) {
            return;
          }

          var newPages = Math.ceil(total / this.getTodosPerPage());
          var url = location.href;

          if (newPages !== currPages) {
            // Redirect to previous page if there's one available
            if (currPages > 1 && currPage === currPages) {
              var pageParams = {
                page: currPages - 1
              };
              url = gl.utils.mergeUrlParams(pageParams, url);
            }
            return gl.utils.visitUrl(url);
          }
        }
      }, {
        key: 'goToTodoUrl',
        value: function goToTodoUrl(e) {
          var todoLink = this.dataset.url;

          if (!todoLink) {
            return;
          }

          if (gl.utils.isMetaClick(e)) {
            var windowTarget = '_blank';
            var selected = e.target;
            e.preventDefault();

            if (selected.tagName === 'IMG') {
              var avatarUrl = selected.parentElement.getAttribute('href');
              return window.open(avatarUrl, windowTarget);
            } else {
              return window.open(todoLink, windowTarget);
            }
          } else {
            return gl.utils.visitUrl(todoLink);
          }
        }
      }]);

      return Todos;
    }();

    global.Todos = Todos;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, prefer-arrow-callback, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
  /* global u2f */
  /* global U2FError */
  /* global U2FUtil */

  // Authenticate U2F (universal 2nd factor) devices for users to authenticate with.
  //
  // State Flow #1: setup -> in_progress -> authenticated -> POST to server
  // State Flow #2: setup -> in_progress -> error -> setup
  (function () {
    var global = window.gl || (window.gl = {});

    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    global.U2FAuthenticate = function () {
      function U2FAuthenticate(container, form, u2fParams, fallbackButton, fallbackUI) {
        this.container = container;
        this.renderNotSupported = bind(this.renderNotSupported, this);
        this.renderAuthenticated = bind(this.renderAuthenticated, this);
        this.renderError = bind(this.renderError, this);
        this.renderInProgress = bind(this.renderInProgress, this);
        this.renderTemplate = bind(this.renderTemplate, this);
        this.authenticate = bind(this.authenticate, this);
        this.start = bind(this.start, this);
        this.appId = u2fParams.app_id;
        this.challenge = u2fParams.challenge;
        this.form = form;
        this.fallbackButton = fallbackButton;
        this.fallbackUI = fallbackUI;
        if (this.fallbackButton) this.fallbackButton.addEventListener('click', this.switchToFallbackUI.bind(this));
        this.signRequests = u2fParams.sign_requests.map(function (request) {
          // The U2F Javascript API v1.1 requires a single challenge, with
          // _no challenges per-request_. The U2F Javascript API v1.0 requires a
          // challenge per-request, which is done by copying the single challenge
          // into every request.
          //
          // In either case, we don't need the per-request challenges that the server
          // has generated, so we can remove them.
          //
          // Note: The server library fixes this behaviour in (unreleased) version 1.0.0.
          // This can be removed once we upgrade.
          // https://github.com/castle/ruby-u2f/commit/103f428071a81cd3d5f80c2e77d522d5029946a4
          return _(request).omit('challenge');
        });
      }

      U2FAuthenticate.prototype.start = function () {
        if (U2FUtil.isU2FSupported()) {
          return this.renderInProgress();
        } else {
          return this.renderNotSupported();
        }
      };

      U2FAuthenticate.prototype.authenticate = function () {
        return u2f.sign(this.appId, this.challenge, this.signRequests, function (_this) {
          return function (response) {
            var error;
            if (response.errorCode) {
              error = new U2FError(response.errorCode, 'authenticate');
              return _this.renderError(error);
            } else {
              return _this.renderAuthenticated(JSON.stringify(response));
            }
          };
        }(this), 10);
      };

      // Rendering #
      U2FAuthenticate.prototype.templates = {
        "notSupported": "#js-authenticate-u2f-not-supported",
        "setup": '#js-authenticate-u2f-setup',
        "inProgress": '#js-authenticate-u2f-in-progress',
        "error": '#js-authenticate-u2f-error',
        "authenticated": '#js-authenticate-u2f-authenticated'
      };

      U2FAuthenticate.prototype.renderTemplate = function (name, params) {
        var template, templateString;
        templateString = $(this.templates[name]).html();
        template = _.template(templateString);
        return this.container.html(template(params));
      };

      U2FAuthenticate.prototype.renderInProgress = function () {
        this.renderTemplate('inProgress');
        return this.authenticate();
      };

      U2FAuthenticate.prototype.renderError = function (error) {
        this.renderTemplate('error', {
          error_message: error.message(),
          error_code: error.errorCode
        });
        return this.container.find('#js-u2f-try-again').on('click', this.renderInProgress);
      };

      U2FAuthenticate.prototype.renderAuthenticated = function (deviceResponse) {
        this.renderTemplate('authenticated');
        var container = this.container[0];
        container.querySelector('#js-device-response').value = deviceResponse;
        container.querySelector(this.form).submit();
        this.fallbackButton.classList.add('hidden');
      };

      U2FAuthenticate.prototype.renderNotSupported = function () {
        return this.renderTemplate('notSupported');
      };

      U2FAuthenticate.prototype.switchToFallbackUI = function () {
        this.fallbackButton.classList.add('hidden');
        this.container[0].classList.add('hidden');
        this.fallbackUI.classList.remove('hidden');
      };

      return U2FAuthenticate;
    }();
  })();
}).call(window);

/***/ }),
/* 147 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable class-methods-use-this, comma-dangle, arrow-parens, no-param-reassign */
  /* global Cookies */

  (function (global) {
    global.User = function () {
      function _class(_ref) {
        var action = _ref.action;

        _classCallCheck(this, _class);

        this.action = action;
        this.placeProfileAvatarsToTop();
        this.initTabs();
        this.hideProjectLimitMessage();
      }

      _createClass(_class, [{
        key: 'placeProfileAvatarsToTop',
        value: function placeProfileAvatarsToTop() {
          $('.profile-groups-avatars').tooltip({
            placement: 'top'
          });
        }
      }, {
        key: 'initTabs',
        value: function initTabs() {
          return new global.UserTabs({
            parentEl: '.user-profile',
            action: this.action
          });
        }
      }, {
        key: 'hideProjectLimitMessage',
        value: function hideProjectLimitMessage() {
          var _this = this;

          $('.hide-project-limit-message').on('click', function (e) {
            e.preventDefault();
            Cookies.set('hide_project_limit_message', 'false');
            $(_this).parents('.project-limit-message').remove();
          });
        }
      }]);

      return _class;
    }();
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 148 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable max-len, space-before-function-paren, no-underscore-dangle, consistent-return, comma-dangle, no-unused-vars, dot-notation, no-new, no-return-assign, camelcase, no-param-reassign */

  /*
  UserTabs
  
  Handles persisting and restoring the current tab selection and lazily-loading
  content on the Users#show page.
  
  ### Example Markup
  
     <ul class="nav-links">
       <li class="activity-tab active">
         <a data-action="activity" data-target="#activity" data-toggle="tab" href="/u/username">
           Activity
         </a>
       </li>
       <li class="groups-tab">
         <a data-action="groups" data-target="#groups" data-toggle="tab" href="/u/username/groups">
           Groups
         </a>
       </li>
       <li class="contributed-tab">
         <a data-action="contributed" data-target="#contributed" data-toggle="tab" href="/u/username/contributed">
           Contributed projects
         </a>
       </li>
       <li class="projects-tab">
         <a data-action="projects" data-target="#projects" data-toggle="tab" href="/u/username/projects">
           Personal projects
         </a>
       </li>
      <li class="snippets-tab">
         <a data-action="snippets" data-target="#snippets" data-toggle="tab" href="/u/username/snippets">
         </a>
       </li>
     </ul>
  
     <div class="tab-content">
       <div class="tab-pane" id="activity">
         Activity Content
       </div>
       <div class="tab-pane" id="groups">
         Groups Content
       </div>
       <div class="tab-pane" id="contributed">
         Contributed projects content
       </div>
       <div class="tab-pane" id="projects">
        Projects content
       </div>
       <div class="tab-pane" id="snippets">
         Snippets content
       </div>
    </div>
  
     <div class="loading-status">
       <div class="loading">
        Loading Animation
       </div>
     </div>
  */
  (function (global) {
    var UserTabs = function () {
      function UserTabs(_ref) {
        var _this = this;

        var defaultAction = _ref.defaultAction,
            action = _ref.action,
            parentEl = _ref.parentEl;

        _classCallCheck(this, UserTabs);

        this.loaded = {};
        this.defaultAction = defaultAction || 'activity';
        this.action = action || this.defaultAction;
        this.$parentEl = $(parentEl) || $(document);
        this._location = window.location;
        this.$parentEl.find('.nav-links a').each(function (i, navLink) {
          _this.loaded[$(navLink).attr('data-action')] = false;
        });
        this.actions = Object.keys(this.loaded);
        this.bindEvents();

        if (this.action === 'show') {
          this.action = this.defaultAction;
        }

        this.activateTab(this.action);
      }

      _createClass(UserTabs, [{
        key: 'bindEvents',
        value: function bindEvents() {
          var _this2 = this;

          return this.$parentEl.off('shown.bs.tab', '.nav-links a[data-toggle="tab"]').on('shown.bs.tab', '.nav-links a[data-toggle="tab"]', function (event) {
            return _this2.tabShown(event);
          });
        }
      }, {
        key: 'tabShown',
        value: function tabShown(event) {
          var $target = $(event.target);
          var action = $target.data('action');
          var source = $target.attr('href');
          this.setTab(source, action);
          return this.setCurrentAction(source, action);
        }
      }, {
        key: 'activateTab',
        value: function activateTab(action) {
          return this.$parentEl.find('.nav-links .js-' + action + '-tab a').tab('show');
        }
      }, {
        key: 'setTab',
        value: function setTab(source, action) {
          if (this.loaded[action]) {
            return;
          }
          if (action === 'activity') {
            this.loadActivities(source);
          }

          var loadableActions = ['groups', 'contributed', 'projects', 'snippets'];
          if (loadableActions.indexOf(action) > -1) {
            return this.loadTab(source, action);
          }
        }
      }, {
        key: 'loadTab',
        value: function loadTab(source, action) {
          var _this3 = this;

          return $.ajax({
            beforeSend: function beforeSend() {
              return _this3.toggleLoading(true);
            },
            complete: function complete() {
              return _this3.toggleLoading(false);
            },
            dataType: 'json',
            type: 'GET',
            url: source + '.json',
            success: function success(data) {
              var tabSelector = 'div#' + action;
              _this3.$parentEl.find(tabSelector).html(data.html);
              _this3.loaded[action] = true;
              return gl.utils.localTimeAgo($('.js-timeago', tabSelector));
            }
          });
        }
      }, {
        key: 'loadActivities',
        value: function loadActivities(source) {
          if (this.loaded['activity']) {
            return;
          }
          var $calendarWrap = this.$parentEl.find('.user-calendar');
          $calendarWrap.load($calendarWrap.data('href'));
          new gl.Activities();
          return this.loaded['activity'] = true;
        }
      }, {
        key: 'toggleLoading',
        value: function toggleLoading(status) {
          return this.$parentEl.find('.loading-status .loading').toggle(status);
        }
      }, {
        key: 'setCurrentAction',
        value: function setCurrentAction(source, action) {
          var new_state = source;
          new_state = new_state.replace(/\/+$/, '');
          new_state += this._location.search + this._location.hash;
          history.replaceState({
            url: new_state
          }, document.title, new_state);
          return new_state;
        }
      }]);

      return UserTabs;
    }();

    global.UserTabs = UserTabs;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 149 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, consistent-return, class-methods-use-this, arrow-parens, no-param-reassign, max-len */

  (function (global) {
    var debounceTimeoutDuration = 1000;
    var invalidInputClass = 'gl-field-error-outline';
    var successInputClass = 'gl-field-success-outline';
    var unavailableMessageSelector = '.username .validation-error';
    var successMessageSelector = '.username .validation-success';
    var pendingMessageSelector = '.username .validation-pending';
    var invalidMessageSelector = '.username .gl-field-error';

    var UsernameValidator = function () {
      function UsernameValidator() {
        var _this = this;

        _classCallCheck(this, UsernameValidator);

        this.inputElement = $('#new_user_username');
        this.inputDomElement = this.inputElement.get(0);
        this.state = {
          available: false,
          valid: false,
          pending: false,
          empty: true
        };

        var debounceTimeout = _.debounce(function (username) {
          _this.validateUsername(username);
        }, debounceTimeoutDuration);

        this.inputElement.on('keyup.username_check', function () {
          var username = _this.inputElement.val();

          _this.state.valid = _this.inputDomElement.validity.valid;
          _this.state.empty = !username.length;

          if (_this.state.valid) {
            return debounceTimeout(username);
          }

          _this.renderState();
        });

        // Override generic field validation
        this.inputElement.on('invalid', this.interceptInvalid.bind(this));
      }

      _createClass(UsernameValidator, [{
        key: 'renderState',
        value: function renderState() {
          // Clear all state
          this.clearFieldValidationState();

          if (this.state.valid && this.state.available) {
            return this.setSuccessState();
          }

          if (this.state.empty) {
            return this.clearFieldValidationState();
          }

          if (this.state.pending) {
            return this.setPendingState();
          }

          if (!this.state.available) {
            return this.setUnavailableState();
          }

          if (!this.state.valid) {
            return this.setInvalidState();
          }
        }
      }, {
        key: 'interceptInvalid',
        value: function interceptInvalid(event) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, {
        key: 'validateUsername',
        value: function validateUsername(username) {
          var _this2 = this;

          if (this.state.valid) {
            this.state.pending = true;
            this.state.available = false;
            this.renderState();
            return $.ajax({
              type: 'GET',
              url: gon.relative_url_root + '/users/' + username + '/exists',
              dataType: 'json',
              success: function success(res) {
                return _this2.setAvailabilityState(res.exists);
              }
            });
          }
        }
      }, {
        key: 'setAvailabilityState',
        value: function setAvailabilityState(usernameTaken) {
          if (usernameTaken) {
            this.state.valid = false;
            this.state.available = false;
          } else {
            this.state.available = true;
          }
          this.state.pending = false;
          this.renderState();
        }
      }, {
        key: 'clearFieldValidationState',
        value: function clearFieldValidationState() {
          this.inputElement.siblings('p').hide();

          this.inputElement.removeClass(invalidInputClass).removeClass(successInputClass);
        }
      }, {
        key: 'setUnavailableState',
        value: function setUnavailableState() {
          var $usernameUnavailableMessage = this.inputElement.siblings(unavailableMessageSelector);
          this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
          $usernameUnavailableMessage.show();
        }
      }, {
        key: 'setSuccessState',
        value: function setSuccessState() {
          var $usernameSuccessMessage = this.inputElement.siblings(successMessageSelector);
          this.inputElement.addClass(successInputClass).removeClass(invalidInputClass);
          $usernameSuccessMessage.show();
        }
      }, {
        key: 'setPendingState',
        value: function setPendingState() {
          var $usernamePendingMessage = $(pendingMessageSelector);
          if (this.state.pending) {
            $usernamePendingMessage.show();
          } else {
            $usernamePendingMessage.hide();
          }
        }
      }, {
        key: 'setInvalidState',
        value: function setInvalidState() {
          var $inputErrorMessage = $(invalidMessageSelector);
          this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
          $inputErrorMessage.show();
        }
      }]);

      return UsernameValidator;
    }();

    global.UsernameValidator = UsernameValidator;
  })(window);
}).call(window);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var VersionCheckImage = function () {
      function VersionCheckImage() {
        _classCallCheck(this, VersionCheckImage);
      }

      _createClass(VersionCheckImage, null, [{
        key: 'bindErrorEvent',
        value: function bindErrorEvent(imageElement) {
          imageElement.off('error').on('error', function () {
            return imageElement.hide();
          });
        }
      }]);

      return VersionCheckImage;
    }();

    window.gl = window.gl || {};
    gl.VersionCheckImage = VersionCheckImage;
  })();
}).call(window);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var gl = window.gl || (window.gl = {});

    var VisibilitySelect = function () {
      function VisibilitySelect(container) {
        _classCallCheck(this, VisibilitySelect);

        if (!container) throw new Error('VisibilitySelect requires a container element as argument 1');
        this.container = container;
        this.helpBlock = this.container.querySelector('.help-block');
        this.select = this.container.querySelector('select');
      }

      _createClass(VisibilitySelect, [{
        key: 'init',
        value: function init() {
          if (this.select) {
            this.updateHelpText();
            this.select.addEventListener('change', this.updateHelpText.bind(this));
          } else {
            this.helpBlock.textContent = this.container.querySelector('.js-locked').dataset.helpBlock;
          }
        }
      }, {
        key: 'updateHelpText',
        value: function updateHelpText() {
          this.helpBlock.textContent = this.select.querySelector('option:checked').dataset.description;
        }
      }]);

      return VisibilitySelect;
    }();

    gl.VisibilitySelect = VisibilitySelect;
  })();
}).call(window);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-param-reassign */
  /* global Breakpoints */

  __webpack_require__(30);
  __webpack_require__(55);

  (function (global) {
    var Wikis = function () {
      function Wikis() {
        var _this = this;

        _classCallCheck(this, Wikis);

        this.bp = Breakpoints.get();
        this.sidebarEl = document.querySelector('.js-wiki-sidebar');
        this.sidebarExpanded = false;
        $(this.sidebarEl).niceScroll();

        var sidebarToggles = document.querySelectorAll('.js-sidebar-wiki-toggle');
        for (var i = 0; i < sidebarToggles.length; i += 1) {
          sidebarToggles[i].addEventListener('click', function (e) {
            return _this.handleToggleSidebar(e);
          });
        }

        this.newWikiForm = document.querySelector('form.new-wiki-page');
        if (this.newWikiForm) {
          this.newWikiForm.addEventListener('submit', function (e) {
            return _this.handleNewWikiSubmit(e);
          });
        }

        window.addEventListener('resize', function () {
          return _this.renderSidebar();
        });
        this.renderSidebar();
      }

      _createClass(Wikis, [{
        key: 'handleNewWikiSubmit',
        value: function handleNewWikiSubmit(e) {
          if (!this.newWikiForm) return;

          var slugInput = this.newWikiForm.querySelector('#new_wiki_path');
          var slug = gl.text.slugify(slugInput.value);

          if (slug.length > 0) {
            var wikisPath = slugInput.getAttribute('data-wikis-path');
            window.location.href = wikisPath + '/' + slug;
            e.preventDefault();
          }
        }
      }, {
        key: 'handleToggleSidebar',
        value: function handleToggleSidebar(e) {
          e.preventDefault();
          this.sidebarExpanded = !this.sidebarExpanded;
          this.renderSidebar();
        }
      }, {
        key: 'sidebarCanCollapse',
        value: function sidebarCanCollapse() {
          var bootstrapBreakpoint = this.bp.getBreakpointSize();
          return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
        }
      }, {
        key: 'renderSidebar',
        value: function renderSidebar() {
          if (!this.sidebarEl) return;
          var classList = this.sidebarEl.classList;

          if (this.sidebarExpanded || !this.sidebarCanCollapse()) {
            if (!classList.contains('right-sidebar-expanded')) {
              classList.remove('right-sidebar-collapsed');
              classList.add('right-sidebar-expanded');
            }
          } else if (classList.contains('right-sidebar-expanded')) {
            classList.add('right-sidebar-collapsed');
            classList.remove('right-sidebar-expanded');
          }
        }
      }]);

      return Wikis;
    }();

    global.Wikis = Wikis;
  })(window.gl || (window.gl = {}));
}).call(window);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
	Autosize 3.0.14
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var set = typeof Set === 'function' ? new Set() : (function () {
		var list = [];

		return {
			has: function has(key) {
				return Boolean(list.indexOf(key) > -1);
			},
			add: function add(key) {
				list.push(key);
			},
			'delete': function _delete(key) {
				list.splice(list.indexOf(key), 1);
			} };
	})();

	function assign(ta) {
		var _ref = arguments[1] === undefined ? {} : arguments[1];

		var _ref$setOverflowX = _ref.setOverflowX;
		var setOverflowX = _ref$setOverflowX === undefined ? true : _ref$setOverflowX;
		var _ref$setOverflowY = _ref.setOverflowY;
		var setOverflowY = _ref$setOverflowY === undefined ? true : _ref$setOverflowY;

		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta)) return;

		var heightOffset = null;
		var overflowY = null;
		var clientWidth = ta.clientWidth;

		function init() {
			var style = window.getComputedStyle(ta, null);

			overflowY = style.overflowY;

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			overflowY = value;

			if (setOverflowY) {
				ta.style.overflowY = value;
			}

			resize();
		}

		function resize() {
			var htmlTop = window.pageYOffset;
			var bodyTop = document.body.scrollTop;
			var originalHeight = ta.style.height;

			ta.style.height = 'auto';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			document.documentElement.scrollTop = htmlTop;
			document.body.scrollTop = bodyTop;
		}

		function update() {
			var startHeight = ta.style.height;

			resize();

			var style = window.getComputedStyle(ta, null);

			if (style.height !== ta.style.height) {
				if (overflowY !== 'visible') {
					changeOverflow('visible');
				}
			} else {
				if (overflowY !== 'hidden') {
					changeOverflow('hidden');
				}
			}

			if (startHeight !== ta.style.height) {
				var evt = document.createEvent('Event');
				evt.initEvent('autosize:resized', true, false);
				ta.dispatchEvent(evt);
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);
			set['delete'](ta);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap });

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		set.add(ta);

		if (setOverflowX) {
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
		}

		init();
	}

	function destroy(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:destroy', true, false);
		ta.dispatchEvent(evt);
	}

	function update(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:update', true, false);
		ta.dispatchEvent(evt);
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});
}.call(window));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(19)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var mouseHandled = false;
$( document ).mouseup( function() {
	mouseHandled = false;
});

return $.widget("ui.mouse", {
	version: "1.11.4",
	options: {
		cancel: "input,textarea,button,select,option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.bind("mousedown." + this.widgetName, function(event) {
				return that._mouseDown(event);
			})
			.bind("click." + this.widgetName, function(event) {
				if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
					$.removeData(event.target, that.widgetName + ".preventClickEvent");
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind("." + this.widgetName);
		if ( this._mouseMoveDelegate ) {
			this.document
				.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
		}
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = (event.which === 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				that.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
			$.removeData(event.target, this.widgetName + ".preventClickEvent");
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return that._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return that._mouseUp(event);
		};

		this.document
			.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		this.document
			.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target === this._mouseDownEvent.target) {
				$.data(event.target, this.widgetName + ".preventClickEvent", true);
			}

			this._mouseStop(event);
		}

		mouseHandled = false;
		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(/* event */) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(/* event */) {},
	_mouseDrag: function(/* event */) {},
	_mouseStop: function(/* event */) {},
	_mouseCapture: function(/* event */) { return true; }
});

}));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),

			// support: jQuery 1.6.x
			// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
			width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !supportsOffsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function() {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

})();

return $.ui.position;

}));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./abuse_reports.js": 59,
	"./abuse_reports.js.es6": 59,
	"./activities.js": 60,
	"./activities.js.es6": 60,
	"./admin.js": 231,
	"./api.js": 232,
	"./aside.js": 233,
	"./autosave.js": 25,
	"./awards_handler.js": 234,
	"./breakpoints.js": 30,
	"./broadcast_message.js": 262,
	"./build.js": 263,
	"./build_artifacts.js": 264,
	"./build_variables.js": 76,
	"./build_variables.js.es6": 76,
	"./ci_lint_editor.js": 77,
	"./ci_lint_editor.js.es6": 77,
	"./commit.js": 265,
	"./commits.js": 270,
	"./compare.js": 271,
	"./compare_autocomplete.js": 78,
	"./compare_autocomplete.js.es6": 78,
	"./confirm_danger_modal.js": 272,
	"./copy_as_gfm.js": 79,
	"./copy_as_gfm.js.es6": 79,
	"./copy_to_clipboard.js": 273,
	"./create_label.js": 80,
	"./create_label.js.es6": 80,
	"./diff.js": 91,
	"./diff.js.es6": 91,
	"./dispatcher.js": 102,
	"./dispatcher.js.es6": 102,
	"./dropzone_input.js": 103,
	"./due_date_select.js": 104,
	"./due_date_select.js.es6": 104,
	"./files_comment_button.js": 285,
	"./flash.js": 34,
	"./gfm_auto_complete.js": 35,
	"./gfm_auto_complete.js.es6": 35,
	"./gl_dropdown.js": 286,
	"./gl_field_error.js": 36,
	"./gl_field_error.js.es6": 36,
	"./gl_field_errors.js": 116,
	"./gl_field_errors.js.es6": 116,
	"./gl_form.js": 117,
	"./gl_form.js.es6": 117,
	"./group_avatar.js": 291,
	"./group_label_subscription.js": 118,
	"./group_label_subscription.js.es6": 118,
	"./groups_select.js": 292,
	"./header.js": 293,
	"./importer_status.js": 294,
	"./issuable.js": 119,
	"./issuable.js.es6": 119,
	"./issuable_context.js": 302,
	"./issuable_form.js": 303,
	"./issue.js": 304,
	"./issue_status_select.js": 305,
	"./issues_bulk_assignment.js": 120,
	"./issues_bulk_assignment.js.es6": 120,
	"./label_manager.js": 121,
	"./label_manager.js.es6": 121,
	"./labels.js": 306,
	"./labels_select.js": 307,
	"./layout_nav.js": 308,
	"./line_highlighter.js": 312,
	"./logo.js": 313,
	"./member_expiration_date.js": 122,
	"./member_expiration_date.js.es6": 122,
	"./members.js": 123,
	"./members.js.es6": 123,
	"./merge_request.js": 314,
	"./merge_request_tabs.js": 39,
	"./merge_request_tabs.js.es6": 39,
	"./merge_request_widget.js": 124,
	"./merge_request_widget.js.es6": 124,
	"./merged_buttons.js": 315,
	"./milestone.js": 316,
	"./milestone_select.js": 317,
	"./mini_pipeline_graph_dropdown.js": 125,
	"./mini_pipeline_graph_dropdown.js.es6": 125,
	"./namespace_select.js": 318,
	"./new_branch_form.js": 321,
	"./new_commit_form.js": 322,
	"./notes.js": 323,
	"./notifications_dropdown.js": 324,
	"./notifications_form.js": 325,
	"./pager.js": 126,
	"./pager.js.es6": 126,
	"./pipelines.js": 127,
	"./pipelines.js.es6": 127,
	"./preview_markdown.js": 128,
	"./project.js": 326,
	"./project_avatar.js": 327,
	"./project_find_file.js": 328,
	"./project_fork.js": 329,
	"./project_import.js": 330,
	"./project_label_subscription.js": 131,
	"./project_label_subscription.js.es6": 131,
	"./project_new.js": 331,
	"./project_select.js": 332,
	"./project_show.js": 333,
	"./project_variables.js": 132,
	"./project_variables.js.es6": 132,
	"./projects_list.js": 334,
	"./render_gfm.js": 335,
	"./render_math.js": 336,
	"./right_sidebar.js": 337,
	"./search.js": 338,
	"./search_autocomplete.js": 138,
	"./search_autocomplete.js.es6": 138,
	"./shortcuts.js": 8,
	"./shortcuts_blob.js": 40,
	"./shortcuts_blob.js.es6": 40,
	"./shortcuts_dashboard_navigation.js": 50,
	"./shortcuts_find_file.js": 339,
	"./shortcuts_issuable.js": 51,
	"./shortcuts_navigation.js": 9,
	"./shortcuts_network.js": 52,
	"./sidebar.js": 139,
	"./sidebar.js.es6": 139,
	"./signin_tabs_memoizer.js": 140,
	"./signin_tabs_memoizer.js.es6": 140,
	"./single_file_diff.js": 340,
	"./smart_interval.js": 14,
	"./smart_interval.js.es6": 14,
	"./snippets_list.js": 141,
	"./snippets_list.js.es6": 141,
	"./star.js": 341,
	"./subbable_resource.js": 24,
	"./subbable_resource.js.es6": 24,
	"./subscription.js": 142,
	"./subscription.js.es6": 142,
	"./subscription_select.js": 342,
	"./syntax_highlight.js": 343,
	"./todos.js": 145,
	"./todos.js.es6": 145,
	"./tree.js": 344,
	"./user.js": 147,
	"./user.js.es6": 147,
	"./user_tabs.js": 148,
	"./user_tabs.js.es6": 148,
	"./username_validator.js": 149,
	"./username_validator.js.es6": 149,
	"./users_select.js": 349,
	"./version_check_image.js": 150,
	"./version_check_image.js.es6": 150,
	"./visibility_select.js": 151,
	"./visibility_select.js.es6": 151,
	"./wikis.js": 152,
	"./wikis.js.es6": 152,
	"./zen_mode.js": 352
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./autosize.js": 235,
	"./details_behavior.js": 236,
	"./quick_submit.js": 237,
	"./requires_input.js": 238,
	"./toggler_behavior.js": 239
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./blob_ci_yaml.js": 61,
	"./blob_ci_yaml.js.es6": 61,
	"./blob_dockerfile_selector.js": 62,
	"./blob_dockerfile_selector.js.es6": 62,
	"./blob_dockerfile_selectors.js": 63,
	"./blob_dockerfile_selectors.js.es6": 63,
	"./blob_file_dropzone.js": 240,
	"./blob_gitignore_selector.js": 241,
	"./blob_gitignore_selectors.js": 242,
	"./blob_license_selector.js": 243,
	"./blob_license_selectors.js": 64,
	"./blob_license_selectors.js.es6": 64,
	"./template_selector.js": 5,
	"./template_selector.js.es6": 5
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;


/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./file.js": 266,
	"./image_file.js": 267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./droplab.js": 274,
	"./droplab_ajax.js": 275,
	"./droplab_ajax_filter.js": 276,
	"./droplab_filter.js": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./array.js": 105,
	"./array.js.es6": 105,
	"./custom_event.js": 106,
	"./custom_event.js.es6": 106,
	"./element.js": 107,
	"./element.js.es6": 107,
	"./jquery.js": 32,
	"./object.js": 108,
	"./object.js.es6": 108
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;


/***/ }),
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./animate.js": 309,
	"./bootstrap_linked_tabs.js": 37,
	"./bootstrap_linked_tabs.js.es6": 37,
	"./common_utils.js": 4,
	"./common_utils.js.es6": 4,
	"./datetime_utility.js": 7,
	"./datetime_utility.js.es6": 7,
	"./notify.js": 310,
	"./pretty_time.js": 12,
	"./pretty_time.js.es6": 12,
	"./text_utility.js": 13,
	"./type_utility.js": 311,
	"./url_utility.js": 38,
	"./url_utility.js.es6": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;


/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./issuable_template_selector.js": 143,
	"./issuable_template_selector.js.es6": 143,
	"./issuable_template_selectors.js": 144,
	"./issuable_template_selectors.js.es6": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./authenticate.js": 146,
	"./authenticate.js.es6": 146,
	"./error.js": 345,
	"./register.js": 346,
	"./util.js": 347
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;


/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: affix.js v3.3.6
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.6'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: alert.js v3.3.6
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.6'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: button.js v3.3.6
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.6'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target)
      if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"]') || $(e.target).is('input[type="checkbox"]'))) e.preventDefault()
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: collapse.js v3.3.6
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.6'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.6
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.6'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.6
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.6'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.6
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.6'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.6
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.6'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tab.js v3.3.6
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.6'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.6
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.6'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      that.$element
        .removeAttr('aria-describedby')
        .trigger('hidden.bs.' + that.type)
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: transition.js v3.3.6
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);


/***/ }),
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.0.5
 */

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"vertx\""); e.code = 'MODULE_NOT_FOUND';; throw e; }()));
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.

    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```

    Chaining
    --------

    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.

    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });

    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```

    Assimilation
    ------------

    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.

    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```

    If the assimliated promise rejects, then the downstream promise will also reject.

    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```

    Simple Example
    --------------

    Synchronous Example

    ```javascript
    let result;

    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```

    Errback Example

    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```

    Promise Example;

    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```

    Advanced Example
    --------------

    Synchronous Example

    ```javascript
    let author, books;

    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```

    Errback Example

    ```js

    function foundBooks(books) {

    }

    function failure(reason) {

    }

    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```

    Promise Example;

    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```

    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.

    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }

    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }

    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```

    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(356), __webpack_require__(358)))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * fuzzaldrin-plus.js - 0.3.1
 * https://github.com/jeancroy/fuzzaldrin-plus
 *
 * Copyright 2016 - Jean Christophe Roy
 * Released under the MIT license
 * https://github.com/jeancroy/fuzzaldrin-plus/raw/master/LICENSE.md
 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
fuzzaldrinPlus = require('fuzzaldrin-plus');

},{"fuzzaldrin-plus":3}],2:[function(require,module,exports){
(function() {
  var PathSeparator, legacy_scorer, pluckCandidates, scorer, sortCandidates;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  pluckCandidates = function(a) {
    return a.candidate;
  };

  sortCandidates = function(a, b) {
    return b.score - a.score;
  };

  PathSeparator = require('path').sep;

  module.exports = function(candidates, query, _arg) {
    var allowErrors, bAllowErrors, bKey, candidate, coreQuery, key, legacy, maxInners, maxResults, prepQuery, queryHasSlashes, score, scoredCandidates, spotLeft, string, _i, _j, _len, _len1, _ref;
    _ref = _arg != null ? _arg : {}, key = _ref.key, maxResults = _ref.maxResults, maxInners = _ref.maxInners, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
    scoredCandidates = [];
    spotLeft = (maxInners != null) && maxInners > 0 ? maxInners : candidates.length;
    bAllowErrors = !!allowErrors;
    bKey = key != null;
    prepQuery = scorer.prepQuery(query);
    if (!legacy) {
      for (_i = 0, _len = candidates.length; _i < _len; _i++) {
        candidate = candidates[_i];
        string = bKey ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = scorer.score(string, query, prepQuery, bAllowErrors);
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
          if (!--spotLeft) {
            break;
          }
        }
      }
    } else {
      queryHasSlashes = prepQuery.depth > 0;
      coreQuery = prepQuery.core;
      for (_j = 0, _len1 = candidates.length; _j < _len1; _j++) {
        candidate = candidates[_j];
        string = key != null ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
        }
      }
    }
    scoredCandidates.sort(sortCandidates);
    candidates = scoredCandidates.map(pluckCandidates);
    if (maxResults != null) {
      candidates = candidates.slice(0, maxResults);
    }
    return candidates;
  };

}).call(this);

},{"./legacy":4,"./scorer":6,"path":7}],3:[function(require,module,exports){
(function() {
  var PathSeparator, filter, legacy_scorer, matcher, prepQueryCache, scorer;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  filter = require('./filter');

  matcher = require('./matcher');

  PathSeparator = require('path').sep;

  prepQueryCache = null;

  module.exports = {
    filter: function(candidates, query, options) {
      if (!((query != null ? query.length : void 0) && (candidates != null ? candidates.length : void 0))) {
        return [];
      }
      return filter(candidates, query, options);
    },
    prepQuery: function(query) {
      return scorer.prepQuery(query);
    },
    score: function(string, query, prepQuery, _arg) {
      var allowErrors, coreQuery, legacy, queryHasSlashes, score, _ref;
      _ref = _arg != null ? _arg : {}, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
      if (!((string != null ? string.length : void 0) && (query != null ? query.length : void 0))) {
        return 0;
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!legacy) {
        score = scorer.score(string, query, prepQuery, !!allowErrors);
      } else {
        queryHasSlashes = prepQuery.depth > 0;
        coreQuery = prepQuery.core;
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
      }
      return score;
    },
    match: function(string, query, prepQuery, _arg) {
      var allowErrors, baseMatches, matches, query_lw, string_lw, _i, _ref, _results;
      allowErrors = (_arg != null ? _arg : {}).allowErrors;
      if (!string) {
        return [];
      }
      if (!query) {
        return [];
      }
      if (string === query) {
        return (function() {
          _results = [];
          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
          return _results;
        }).apply(this);
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!(allowErrors || scorer.isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
        return [];
      }
      string_lw = string.toLowerCase();
      query_lw = prepQuery.query_lw;
      matches = matcher.match(string, string_lw, prepQuery);
      if (matches.length === 0) {
        return matches;
      }
      if (string.indexOf(PathSeparator) > -1) {
        baseMatches = matcher.basenameMatch(string, string_lw, prepQuery);
        matches = matcher.mergeMatches(matches, baseMatches);
      }
      return matches;
    }
  };

}).call(this);

},{"./filter":2,"./legacy":4,"./matcher":5,"./scorer":6,"path":7}],4:[function(require,module,exports){
(function() {
  var PathSeparator, queryIsLastPathSegment;

  PathSeparator = require('path').sep;

  exports.basenameScore = function(string, query, score) {
    var base, depth, index, lastCharacter, segmentCount, slashCount;
    index = string.length - 1;
    while (string[index] === PathSeparator) {
      index--;
    }
    slashCount = 0;
    lastCharacter = index;
    base = null;
    while (index >= 0) {
      if (string[index] === PathSeparator) {
        slashCount++;
        if (base == null) {
          base = string.substring(index + 1, lastCharacter + 1);
        }
      } else if (index === 0) {
        if (lastCharacter < string.length - 1) {
          if (base == null) {
            base = string.substring(0, lastCharacter + 1);
          }
        } else {
          if (base == null) {
            base = string;
          }
        }
      }
      index--;
    }
    if (base === string) {
      score *= 2;
    } else if (base) {
      score += exports.score(base, query);
    }
    segmentCount = slashCount + 1;
    depth = Math.max(1, 10 - segmentCount);
    score *= depth * 0.01;
    return score;
  };

  exports.score = function(string, query) {
    var character, characterScore, indexInQuery, indexInString, lowerCaseIndex, minIndex, queryLength, queryScore, stringLength, totalCharacterScore, upperCaseIndex, _ref;
    if (string === query) {
      return 1;
    }
    if (queryIsLastPathSegment(string, query)) {
      return 1;
    }
    totalCharacterScore = 0;
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return 0;
      }
      characterScore = 0.1;
      if (string[indexInString] === character) {
        characterScore += 0.1;
      }
      if (indexInString === 0 || string[indexInString - 1] === PathSeparator) {
        characterScore += 0.8;
      } else if ((_ref = string[indexInString - 1]) === '-' || _ref === '_' || _ref === ' ') {
        characterScore += 0.7;
      }
      string = string.substring(indexInString + 1, stringLength);
      totalCharacterScore += characterScore;
    }
    queryScore = totalCharacterScore / queryLength;
    return ((queryScore * (queryLength / stringLength)) + queryScore) / 2;
  };

  queryIsLastPathSegment = function(string, query) {
    if (string[string.length - query.length - 1] === PathSeparator) {
      return string.lastIndexOf(query) === string.length - query.length;
    }
  };

  exports.match = function(string, query, stringOffset) {
    var character, indexInQuery, indexInString, lowerCaseIndex, matches, minIndex, queryLength, stringLength, upperCaseIndex, _i, _ref, _results;
    if (stringOffset == null) {
      stringOffset = 0;
    }
    if (string === query) {
      return (function() {
        _results = [];
        for (var _i = stringOffset, _ref = stringOffset + string.length; stringOffset <= _ref ? _i < _ref : _i > _ref; stringOffset <= _ref ? _i++ : _i--){ _results.push(_i); }
        return _results;
      }).apply(this);
    }
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    matches = [];
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return [];
      }
      matches.push(stringOffset + indexInString);
      stringOffset += indexInString + 1;
      string = string.substring(indexInString + 1, stringLength);
    }
    return matches;
  };

}).call(this);

},{"path":7}],5:[function(require,module,exports){
(function() {
  var PathSeparator, scorer;

  PathSeparator = require('path').sep;

  scorer = require('./scorer');

  exports.basenameMatch = function(subject, subject_lw, prepQuery) {
    var basePos, depth, end;
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return [];
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return [];
      }
    }
    basePos++;
    end++;
    return exports.match(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery, basePos);
  };

  exports.mergeMatches = function(a, b) {
    var ai, bj, i, j, m, n, out;
    m = a.length;
    n = b.length;
    if (n === 0) {
      return a.slice();
    }
    if (m === 0) {
      return b.slice();
    }
    i = -1;
    j = 0;
    bj = b[j];
    out = [];
    while (++i < m) {
      ai = a[i];
      while (bj <= ai && ++j < n) {
        if (bj < ai) {
          out.push(bj);
        }
        bj = b[j];
      }
      out.push(ai);
    }
    while (j < n) {
      out.push(b[j++]);
    }
    return out;
  };

  exports.match = function(subject, subject_lw, prepQuery, offset) {
    var DIAGONAL, LEFT, STOP, UP, acro_score, align, backtrack, csc_diag, csc_row, csc_score, i, j, m, matches, move, n, pos, query, query_lw, score, score_diag, score_row, score_up, si_lw, start, trace;
    if (offset == null) {
      offset = 0;
    }
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro_score = scorer.scoreAcronyms(subject, subject_lw, query, query_lw).score;
    score_row = new Array(n);
    csc_row = new Array(n);
    STOP = 0;
    UP = 1;
    LEFT = 2;
    DIAGONAL = 3;
    trace = new Array(m * n);
    pos = -1;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = -1;
    while (++i < m) {
      score = 0;
      score_up = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      j = -1;
      while (++j < n) {
        csc_score = 0;
        align = 0;
        score_diag = score_up;
        if (query_lw[j] === si_lw) {
          start = scorer.isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scorer.scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scorer.scoreCharacter(i, j, start, acro_score, csc_score);
        }
        score_up = score_row[j];
        csc_diag = csc_row[j];
        if (score > score_up) {
          move = LEFT;
        } else {
          score = score_up;
          move = UP;
        }
        if (align > score) {
          score = align;
          move = DIAGONAL;
        } else {
          csc_score = 0;
        }
        score_row[j] = score;
        csc_row[j] = csc_score;
        trace[++pos] = score > 0 ? move : STOP;
      }
    }
    i = m - 1;
    j = n - 1;
    pos = i * n + j;
    backtrack = true;
    matches = [];
    while (backtrack && i >= 0 && j >= 0) {
      switch (trace[pos]) {
        case UP:
          i--;
          pos -= n;
          break;
        case LEFT:
          j--;
          pos--;
          break;
        case DIAGONAL:
          matches.push(i + offset);
          j--;
          i--;
          pos -= n + 1;
          break;
        default:
          backtrack = false;
      }
    }
    matches.reverse();
    return matches;
  };

}).call(this);

},{"./scorer":6,"path":7}],6:[function(require,module,exports){
(function() {
  var AcronymResult, PathSeparator, Query, basenameScore, coreChars, countDir, doScore, emptyAcronymResult, file_coeff, isMatch, isSeparator, isWordEnd, isWordStart, miss_coeff, opt_char_re, pos_bonus, scoreAcronyms, scoreCharacter, scoreConsecutives, scoreExact, scoreExactMatch, scorePattern, scorePosition, scoreSize, tau_depth, tau_size, truncatedUpperCase, wm;

  PathSeparator = require('path').sep;

  wm = 150;

  pos_bonus = 20;

  tau_depth = 13;

  tau_size = 85;

  file_coeff = 1.2;

  miss_coeff = 0.75;

  opt_char_re = /[ _\-:\/\\]/g;

  exports.coreChars = coreChars = function(query) {
    return query.replace(opt_char_re, '');
  };

  exports.score = function(string, query, prepQuery, allowErrors) {
    var score, string_lw;
    if (prepQuery == null) {
      prepQuery = new Query(query);
    }
    if (allowErrors == null) {
      allowErrors = false;
    }
    if (!(allowErrors || isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
      return 0;
    }
    string_lw = string.toLowerCase();
    score = doScore(string, string_lw, prepQuery);
    return Math.ceil(basenameScore(string, string_lw, prepQuery, score));
  };

  Query = (function() {
    function Query(query) {
      if (!(query != null ? query.length : void 0)) {
        return null;
      }
      this.query = query;
      this.query_lw = query.toLowerCase();
      this.core = coreChars(query);
      this.core_lw = this.core.toLowerCase();
      this.core_up = truncatedUpperCase(this.core);
      this.depth = countDir(query, query.length);
    }

    return Query;

  })();

  exports.prepQuery = function(query) {
    return new Query(query);
  };

  exports.isMatch = isMatch = function(subject, query_lw, query_up) {
    var i, j, m, n, qj_lw, qj_up, si;
    m = subject.length;
    n = query_lw.length;
    if (!m || n > m) {
      return false;
    }
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      qj_up = query_up[j];
      while (++i < m) {
        si = subject[i];
        if (si === qj_lw || si === qj_up) {
          break;
        }
      }
      if (i === m) {
        return false;
      }
    }
    return true;
  };

  doScore = function(subject, subject_lw, prepQuery) {
    var acro, acro_score, align, csc_diag, csc_row, csc_score, i, j, m, miss_budget, miss_left, mm, n, pos, query, query_lw, record_miss, score, score_diag, score_row, score_up, si_lw, start, sz;
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro = scoreAcronyms(subject, subject_lw, query, query_lw);
    acro_score = acro.score;
    if (acro.count === n) {
      return scoreExact(n, m, acro_score, acro.pos);
    }
    pos = subject_lw.indexOf(query_lw);
    if (pos > -1) {
      return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
    }
    score_row = new Array(n);
    csc_row = new Array(n);
    sz = scoreSize(n, m);
    miss_budget = Math.ceil(miss_coeff * n) + 5;
    miss_left = miss_budget;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = subject_lw.indexOf(query_lw[0]);
    if (i > -1) {
      i--;
    }
    mm = subject_lw.lastIndexOf(query_lw[n - 1], m);
    if (mm > i) {
      m = mm + 1;
    }
    while (++i < m) {
      score = 0;
      score_diag = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      record_miss = true;
      j = -1;
      while (++j < n) {
        score_up = score_row[j];
        if (score_up > score) {
          score = score_up;
        }
        csc_score = 0;
        if (query_lw[j] === si_lw) {
          start = isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
          if (align > score) {
            score = align;
            miss_left = miss_budget;
          } else {
            if (record_miss && --miss_left <= 0) {
              return score_row[n - 1] * sz;
            }
            record_miss = false;
          }
        }
        score_diag = score_up;
        csc_diag = csc_row[j];
        csc_row[j] = csc_score;
        score_row[j] = score;
      }
    }
    return score * sz;
  };

  exports.isWordStart = isWordStart = function(pos, subject, subject_lw) {
    var curr_s, prev_s;
    if (pos === 0) {
      return true;
    }
    curr_s = subject[pos];
    prev_s = subject[pos - 1];
    return isSeparator(curr_s) || isSeparator(prev_s) || (curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1]);
  };

  exports.isWordEnd = isWordEnd = function(pos, subject, subject_lw, len) {
    var curr_s, next_s;
    if (pos === len - 1) {
      return true;
    }
    curr_s = subject[pos];
    next_s = subject[pos + 1];
    return isSeparator(curr_s) || isSeparator(next_s) || (curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1]);
  };

  isSeparator = function(c) {
    return c === ' ' || c === '.' || c === '-' || c === '_' || c === '/' || c === '\\';
  };

  scorePosition = function(pos) {
    var sc;
    if (pos < pos_bonus) {
      sc = pos_bonus - pos;
      return 100 + sc * sc;
    } else {
      return Math.max(100 + pos_bonus - pos, 0);
    }
  };

  scoreSize = function(n, m) {
    return tau_size / (tau_size + Math.abs(m - n));
  };

  scoreExact = function(n, m, quality, pos) {
    return 2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);
  };

  exports.scorePattern = scorePattern = function(count, len, sameCase, start, end) {
    var bonus, sz;
    sz = count;
    bonus = 6;
    if (sameCase === count) {
      bonus += 2;
    }
    if (start) {
      bonus += 3;
    }
    if (end) {
      bonus += 1;
    }
    if (count === len) {
      if (start) {
        if (sameCase === len) {
          sz += 2;
        } else {
          sz += 1;
        }
      }
      if (end) {
        bonus += 1;
      }
    }
    return sameCase + sz * (sz + bonus);
  };

  exports.scoreCharacter = scoreCharacter = function(i, j, start, acro_score, csc_score) {
    var posBonus;
    posBonus = scorePosition(i);
    if (start) {
      return posBonus + wm * ((acro_score > csc_score ? acro_score : csc_score) + 10);
    }
    return posBonus + wm * csc_score;
  };

  exports.scoreConsecutives = scoreConsecutives = function(subject, subject_lw, query, query_lw, i, j, start) {
    var k, m, mi, n, nj, sameCase, startPos, sz;
    m = subject.length;
    n = query.length;
    mi = m - i;
    nj = n - j;
    k = mi < nj ? mi : nj;
    startPos = i;
    sameCase = 0;
    sz = 0;
    if (query[j] === subject[i]) {
      sameCase++;
    }
    while (++sz < k && query_lw[++j] === subject_lw[++i]) {
      if (query[j] === subject[i]) {
        sameCase++;
      }
    }
    if (sz === 1) {
      return 1 + 2 * sameCase;
    }
    return scorePattern(sz, n, sameCase, start, isWordEnd(i, subject, subject_lw, m));
  };

  exports.scoreExactMatch = scoreExactMatch = function(subject, subject_lw, query, query_lw, pos, n, m) {
    var end, i, pos2, sameCase, start;
    start = isWordStart(pos, subject, subject_lw);
    if (!start) {
      pos2 = subject_lw.indexOf(query_lw, pos + 1);
      if (pos2 > -1) {
        start = isWordStart(pos2, subject, subject_lw);
        if (start) {
          pos = pos2;
        }
      }
    }
    i = -1;
    sameCase = 0;
    while (++i < n) {
      if (query[pos + i] === subject[i]) {
        sameCase++;
      }
    }
    end = isWordEnd(pos + n - 1, subject, subject_lw, m);
    return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
  };

  AcronymResult = (function() {
    function AcronymResult(score, pos, count) {
      this.score = score;
      this.pos = pos;
      this.count = count;
    }

    return AcronymResult;

  })();

  emptyAcronymResult = new AcronymResult(0, 0.1, 0);

  exports.scoreAcronyms = scoreAcronyms = function(subject, subject_lw, query, query_lw) {
    var count, i, j, m, n, pos, qj_lw, sameCase, score;
    m = subject.length;
    n = query.length;
    if (!(m > 1 && n > 1)) {
      return emptyAcronymResult;
    }
    count = 0;
    pos = 0;
    sameCase = 0;
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      while (++i < m) {
        if (qj_lw === subject_lw[i] && isWordStart(i, subject, subject_lw)) {
          if (query[j] === subject[i]) {
            sameCase++;
          }
          pos += i;
          count++;
          break;
        }
      }
      if (i === m) {
        break;
      }
    }
    if (count < 2) {
      return emptyAcronymResult;
    }
    score = scorePattern(count, n, sameCase, true, false);
    return new AcronymResult(score, pos / count, count);
  };

  basenameScore = function(subject, subject_lw, prepQuery, fullPathScore) {
    var alpha, basePathScore, basePos, depth, end;
    if (fullPathScore === 0) {
      return 0;
    }
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return fullPathScore;
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return fullPathScore;
      }
    }
    basePos++;
    end++;
    basePathScore = doScore(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery);
    alpha = 0.5 * tau_depth / (tau_depth + countDir(subject, end + 1));
    return alpha * basePathScore + (1 - alpha) * fullPathScore * scoreSize(0, file_coeff * (end - basePos));
  };

  exports.countDir = countDir = function(path, end) {
    var count, i;
    if (end < 1) {
      return 0;
    }
    count = 0;
    i = -1;
    while (++i < end && path[i] === PathSeparator) {
      continue;
    }
    while (++i < end) {
      if (path[i] === PathSeparator) {
        count++;
        while (++i < end && path[i] === PathSeparator) {
          continue;
        }
      }
    }
    return count;
  };

  truncatedUpperCase = function(str) {
    var char, upper, _i, _len;
    upper = "";
    for (_i = 0, _len = str.length; _i < _len; _i++) {
      char = str[_i];
      upper += char.toUpperCase()[0];
    }
    return upper;
  };

}).call(this);

},{"path":7}],7:[function(require,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":8}],8:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[1]);

}.call(window));

/***/ }),
/* 218 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/**
 * Endless Scroll plugin for jQuery
 *
 * v1.4.8
 *
 * Copyright (c) 2008 Fred Wu
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */

/**
 * Usage:
 *
 * // using default options
 * $(document).endlessScroll();
 *
 * // using some custom options
 * $(document).endlessScroll({
 *   fireOnce: false,
 *   fireDelay: false,
 *   loader: "<div class=\"loading\"><div>",
 *   callback: function(){
 *     alert("test");
 *   }
 * });
 *
 * Configuration options:
 *
 * bottomPixels  integer          the number of pixels from the bottom of the page that triggers the event
 * fireOnce      boolean          only fire once until the execution of the current event is completed
 * fireDelay     integer          delay the subsequent firing, in milliseconds, 0 or false to disable delay
 * loader        string           the HTML to be displayed during loading
 * data          string|function  plain HTML data, can be either a string or a function that returns a string,
 *                                when passed as a function it accepts one argument: fire sequence (the number
 *                                of times the event triggered during the current page session)
 * insertAfter   string           jQuery selector syntax: where to put the loader as well as the plain HTML data
 * callback      function         callback function, accepts one argument: fire sequence (the number of times
 *                                the event triggered during the current page session)
 * resetCounter  function         resets the fire sequence counter if the function returns true, this function
 *                                could also perform hook actions since it is applied at the start of the event
 * ceaseFire     function         stops the event (no more endless scrolling) if the function returns true
 *
 * Usage tips:
 *
 * The plugin is more useful when used with the callback function, which can then make AJAX calls to retrieve content.
 * The fire sequence argument (for the callback function) is useful for 'pagination'-like features.
 */

(function($){

  $.fn.endlessScroll = function(options) {

    var defaults = {
      bottomPixels  : 50,
      fireOnce      : true,
      fireDelay     : 150,
      loader        : "<br />Loading...<br />",
      data          : "",
      insertAfter   : "div:last",
      resetCounter  : function() { return false; },
      callback      : function() { return true; },
      ceaseFire     : function() { return false; }
    };

    var options       = $.extend({}, defaults, options),
        firing        = true,
        fired         = false,
        fireSequence  = 0,
        is_scrollable;

    if (options.ceaseFire.apply(this) === true)
      firing = false;

    if (firing === true) {
      $(this).scroll(function() {
        if (options.ceaseFire.apply(this) === true) {
          firing = false;
          return; // Scroll will still get called, but nothing will happen
        }

        if (this == document || this == window) {
          is_scrollable = $(document).height() - $(window).height() <= $(window).scrollTop() + options.bottomPixels;
        } else {
          // calculates the actual height of the scrolling container
          var inner_wrap = $(".endless_scroll_inner_wrap", this);
          if (inner_wrap.length == 0)
            inner_wrap = $(this).wrapInner("<div class=\"endless_scroll_inner_wrap\" />").find(".endless_scroll_inner_wrap");
          is_scrollable = inner_wrap.length > 0 &&
            (inner_wrap.height() - $(this).height() <= $(this).scrollTop() + options.bottomPixels);
        }

        if (is_scrollable && (options.fireOnce == false || (options.fireOnce == true && fired != true))) {
          if (options.resetCounter.apply(this) === true) fireSequence = 0;

          fired = true;
          fireSequence++;

          $(options.insertAfter).after("<div id=\"endless_scroll_loader\">" + options.loader + "</div>");

          data = typeof options.data == 'function' ? options.data.apply(this, [fireSequence]) : options.data;

          if (data !== false) {
            $(options.insertAfter).after("<div id=\"endless_scroll_data\">" + data + "</div>");
            $("#endless_scroll_data").hide().fadeIn(250, function() {$(this).removeAttr("id");});

            options.callback.apply(this, [fireSequence]);

            if (options.fireDelay !== false || options.fireDelay !== 0) {
              $("body").after("<div id=\"endless_scroll_marker\"></div>");
              // slight delay for preventing event firing twice
              $("#endless_scroll_marker").fadeTo(options.fireDelay, 1, function() {
                $(this).remove();
                fired = false;
              });
            }
            else
              fired = false;
          }

          $("#endless_scroll_loader").remove();
        }
      });
    }
  };

})(jQuery);
}.call(window));

/***/ }),
/* 219 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/*

highlight v3

Highlights arbitrary terms.

<http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html>

MIT license.

Johann Burkard
<http://johannburkard.de>
<mailto:jb@eaio.com>

*/

jQuery.fn.highlight = function(pat) {
 function innerHighlight(node, pat) {
  var skip = 0;
  if (node.nodeType == 3) {
   var pos = node.data.toUpperCase().indexOf(pat);
   if (pos >= 0) {
    var spannode = document.createElement('span');
    spannode.className = 'highlight_word';
    var middlebit = node.splitText(pos);
    var endbit = middlebit.splitText(pat.length);
    var middleclone = middlebit.cloneNode(true);
    spannode.appendChild(middleclone);
    middlebit.parentNode.replaceChild(spannode, middlebit);
    skip = 1;
   }
  }
  else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
   for (var i = 0; i < node.childNodes.length; ++i) {
    i += innerHighlight(node.childNodes[i], pat);
   }
  }
  return skip;
 }
 return this.each(function() {
  innerHighlight(this, pat.toUpperCase());
 });
};

jQuery.fn.removeHighlight = function() {
 return this.find("span.highlight").each(function() {
  this.parentNode.firstChild.nodeName;
  with (this.parentNode) {
   replaceChild(this.firstChild, this);
   normalize();
  }
 }).end();
};

}.call(window));

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Autocomplete 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/autocomplete/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(18),
			__webpack_require__(19),
			__webpack_require__(155),
			__webpack_require__(355)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget( "ui.autocomplete", {
	version: "1.11.4",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {
		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		this.isMultiLine =
			// Textareas are always multi-line
			isTextarea ? true :
			// Inputs are always single-line, even if inside a contentEditable element
			// IE also treats inputs as contentEditable
			isInput ? false :
			// All other element types are determined by whether or not they're contentEditable
			this.element.prop( "isContentEditable" );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this.element
			.addClass( "ui-autocomplete-input" )
			.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:
					// when menu is open and has focus
					if ( this.menu.active ) {
						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );
						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;
					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		});

		this._initSource();
		this.menu = $( "<ul>" )
			.addClass( "ui-autocomplete ui-front" )
			.appendTo( this._appendTo() )
			.menu({
				// disable ARIA support, the live region takes care of that
				role: null
			})
			.hide()
			.menu( "instance" );

		this._on( this.menu.element, {
			mousedown: function( event ) {
				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay(function() {
					delete this.cancelBlur;
				});

				// clicking on the scrollbar causes focus to shift to the body
				// but we can't detect a mouseup or a click immediately afterward
				// so we have to track the next mousedown and close the menu if
				// the user clicks somewhere outside of the autocomplete
				var menuElement = this.menu.element[ 0 ];
				if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
					this._delay(function() {
						var that = this;
						this.document.one( "mousedown", function( event ) {
							if ( event.target !== that.element[ 0 ] &&
									event.target !== menuElement &&
									!$.contains( menuElement, event.target ) ) {
								that.close();
							}
						});
					});
				}
			},
			menufocus: function( event, ui ) {
				var label, item;
				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						});

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {
					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
					this.element.focus();
					this.previous = previous;
					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay(function() {
						this.previous = previous;
						this.selectedItem = item;
					});
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}
				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		});

		this.liveRegion = $( "<span>", {
				role: "status",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			})
			.addClass( "ui-helper-hidden-accessible" )
			.appendTo( this.document[ 0 ].body );

		// turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		});
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element
			.removeClass( "ui-autocomplete-input" )
			.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax({
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response([]);
					}
				});
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay(function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this.element.addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy(function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this.element.removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {
			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {
		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {
		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			});
		});
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend({
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(
			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		});
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" ).text( item.label ).appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	}
});

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		});
	}
});

// live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
});

return $.ui.autocomplete;

}));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Datepicker 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/datepicker/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(18)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.extend($.ui, { datepicker: { version: "1.11.4" } });

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {
		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {
			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[""] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: ["January","February","March","April","May","June",
			"July","August","September","October","November","December"], // Names of months for drop-down and formatting
		monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
		dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
		dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
		dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend(this._defaults, this.regional[""]);
	this.regional.en = $.extend( true, {}, this.regional[ "" ]);
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
}

$.extend(Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function(settings) {
		datepicker_extendRemove(this._defaults, settings || {});
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function(target, settings) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = (nodeName === "div" || nodeName === "span");
		if (!target.id) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst($(target), inline);
		inst.settings = $.extend({}, settings || {});
		if (nodeName === "input") {
			this._connectDatepicker(target, inst);
		} else if (inline) {
			this._inlineDatepicker(target, inst);
		}
	},

	/* Create a new instance object. */
	_newInst: function(target, inline) {
		var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
		return {id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: (!inline ? this.dpDiv : // presentation div
			datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function(target, inst) {
		var input = $(target);
		inst.append = $([]);
		inst.trigger = $([]);
		if (input.hasClass(this.markerClassName)) {
			return;
		}
		this._attachments(input, inst);
		input.addClass(this.markerClassName).keydown(this._doKeyDown).
			keypress(this._doKeyPress).keyup(this._doKeyUp);
		this._autoSize(inst);
		$.data(target, "datepicker", inst);
		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function(input, inst) {
		var showOn, buttonText, buttonImage,
			appendText = this._get(inst, "appendText"),
			isRTL = this._get(inst, "isRTL");

		if (inst.append) {
			inst.append.remove();
		}
		if (appendText) {
			inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
			input[isRTL ? "before" : "after"](inst.append);
		}

		input.unbind("focus", this._showDatepicker);

		if (inst.trigger) {
			inst.trigger.remove();
		}

		showOn = this._get(inst, "showOn");
		if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
			input.focus(this._showDatepicker);
		}
		if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
			buttonText = this._get(inst, "buttonText");
			buttonImage = this._get(inst, "buttonImage");
			inst.trigger = $(this._get(inst, "buttonImageOnly") ?
				$("<img/>").addClass(this._triggerClass).
					attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
				$("<button type='button'></button>").addClass(this._triggerClass).
					html(!buttonImage ? buttonText : $("<img/>").attr(
					{ src:buttonImage, alt:buttonText, title:buttonText })));
			input[isRTL ? "before" : "after"](inst.trigger);
			inst.trigger.click(function() {
				if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
					$.datepicker._hideDatepicker();
				} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker(input[0]);
				} else {
					$.datepicker._showDatepicker(input[0]);
				}
				return false;
			});
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function(inst) {
		if (this._get(inst, "autoSize") && !inst.inline) {
			var findMax, max, maxI, i,
				date = new Date(2009, 12 - 1, 20), // Ensure double digits
				dateFormat = this._get(inst, "dateFormat");

			if (dateFormat.match(/[DM]/)) {
				findMax = function(names) {
					max = 0;
					maxI = 0;
					for (i = 0; i < names.length; i++) {
						if (names[i].length > max) {
							max = names[i].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
					"monthNames" : "monthNamesShort"))));
				date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
					"dayNames" : "dayNamesShort"))) + 20 - date.getDay());
			}
			inst.input.attr("size", this._formatDate(inst, date).length);
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function(target, inst) {
		var divSpan = $(target);
		if (divSpan.hasClass(this.markerClassName)) {
			return;
		}
		divSpan.addClass(this.markerClassName).append(inst.dpDiv);
		$.data(target, "datepicker", inst);
		this._setDate(inst, this._getDefaultDate(inst), true);
		this._updateDatepicker(inst);
		this._updateAlternate(inst);
		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function(input, date, onSelect, settings, pos) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if (!inst) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $("<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>");
			this._dialogInput.keydown(this._doKeyDown);
			$("body").append(this._dialogInput);
			inst = this._dialogInst = this._newInst(this._dialogInput, false);
			inst.settings = {};
			$.data(this._dialogInput[0], "datepicker", inst);
		}
		datepicker_extendRemove(inst.settings, settings || {});
		date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
		this._dialogInput.val(date);

		this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
		if (!this._pos) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
		}

		// move input on screen for focus, but hidden behind dialog
		this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass(this._dialogClass);
		this._showDatepicker(this._dialogInput[0]);
		if ($.blockUI) {
			$.blockUI(this.dpDiv);
		}
		$.data(this._dialogInput[0], "datepicker", inst);
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function(target) {
		var nodeName,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData(target, "datepicker");
		if (nodeName === "input") {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass(this.markerClassName).
				unbind("focus", this._showDatepicker).
				unbind("keydown", this._doKeyDown).
				unbind("keypress", this._doKeyPress).
				unbind("keyup", this._doKeyUp);
		} else if (nodeName === "div" || nodeName === "span") {
			$target.removeClass(this.markerClassName).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = false;
			inst.trigger.filter("button").
				each(function() { this.disabled = false; }).end().
				filter("img").css({opacity: "1.0", cursor: ""});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().removeClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", false);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = true;
			inst.trigger.filter("button").
				each(function() { this.disabled = true; }).end().
				filter("img").css({opacity: "0.5", cursor: "default"});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().addClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", true);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
		this._disabledInputs[this._disabledInputs.length] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function(target) {
		if (!target) {
			return false;
		}
		for (var i = 0; i < this._disabledInputs.length; i++) {
			if (this._disabledInputs[i] === target) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function(target) {
		try {
			return $.data(target, "datepicker");
		}
		catch (err) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function(target, name, value) {
		var settings, date, minDate, maxDate,
			inst = this._getInst(target);

		if (arguments.length === 2 && typeof name === "string") {
			return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
				(inst ? (name === "all" ? $.extend({}, inst.settings) :
				this._get(inst, name)) : null));
		}

		settings = name || {};
		if (typeof name === "string") {
			settings = {};
			settings[name] = value;
		}

		if (inst) {
			if (this._curInst === inst) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker(target, true);
			minDate = this._getMinMaxDate(inst, "min");
			maxDate = this._getMinMaxDate(inst, "max");
			datepicker_extendRemove(inst.settings, settings);
			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
				inst.settings.minDate = this._formatDate(inst, minDate);
			}
			if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
				inst.settings.maxDate = this._formatDate(inst, maxDate);
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker(target);
				} else {
					this._enableDatepicker(target);
				}
			}
			this._attachments($(target), inst);
			this._autoSize(inst);
			this._setDate(inst, date);
			this._updateAlternate(inst);
			this._updateDatepicker(inst);
		}
	},

	// change method deprecated
	_changeDatepicker: function(target, name, value) {
		this._optionDatepicker(target, name, value);
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function(target) {
		var inst = this._getInst(target);
		if (inst) {
			this._updateDatepicker(inst);
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function(target, date) {
		var inst = this._getInst(target);
		if (inst) {
			this._setDate(inst, date);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function(target, noDefault) {
		var inst = this._getInst(target);
		if (inst && !inst.inline) {
			this._setDateFromField(inst, noDefault);
		}
		return (inst ? this._getDate(inst) : null);
	},

	/* Handle keystrokes. */
	_doKeyDown: function(event) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst(event.target),
			handled = true,
			isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

		inst._keyEvent = true;
		if ($.datepicker._datepickerShowing) {
			switch (event.keyCode) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv);
						if (sel[0]) {
							$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
						}

						onSelect = $.datepicker._get(inst, "onSelect");
						if (onSelect) {
							dateStr = $.datepicker._formatDate(inst);

							// trigger custom callback
							onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							-$.datepicker._get(inst, "stepBigMonths") :
							-$.datepicker._get(inst, "stepMonths")), "M");
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							+$.datepicker._get(inst, "stepBigMonths") :
							+$.datepicker._get(inst, "stepMonths")), "M");
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) {
							$.datepicker._clearDate(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if (event.ctrlKey || event.metaKey) {
							$.datepicker._gotoToday(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// -1 day on ctrl or command +left
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								-$.datepicker._get(inst, "stepBigMonths") :
								-$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +left on Mac
						break;
				case 38: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, -7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// +1 day on ctrl or command +right
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								+$.datepicker._get(inst, "stepBigMonths") :
								+$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +right
						break;
				case 40: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, +7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker(this);
		} else {
			handled = false;
		}

		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function(event) {
		var chars, chr,
			inst = $.datepicker._getInst(event.target);

		if ($.datepicker._get(inst, "constrainInput")) {
			chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
			chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
			return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function(event) {
		var date,
			inst = $.datepicker._getInst(event.target);

		if (inst.input.val() !== inst.lastVal) {
			try {
				date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
					(inst.input ? inst.input.val() : null),
					$.datepicker._getFormatConfig(inst));

				if (date) { // only if valid
					$.datepicker._setDateFromField(inst);
					$.datepicker._updateAlternate(inst);
					$.datepicker._updateDatepicker(inst);
				}
			}
			catch (err) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function(input) {
		input = input.target || input;
		if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
			input = $("input", input.parentNode)[0];
		}

		if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst(input);
		if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
			$.datepicker._curInst.dpDiv.stop(true, true);
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
			}
		}

		beforeShow = $.datepicker._get(inst, "beforeShow");
		beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
		if(beforeShowSettings === false){
			return;
		}
		datepicker_extendRemove(inst.settings, beforeShowSettings);

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField(inst);

		if ($.datepicker._inDialog) { // hide cursor
			input.value = "";
		}
		if (!$.datepicker._pos) { // position below input
			$.datepicker._pos = $.datepicker._findPos(input);
			$.datepicker._pos[1] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$(input).parents().each(function() {
			isFixed |= $(this).css("position") === "fixed";
			return !isFixed;
		});

		offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
		$.datepicker._pos = null;
		//to avoid flashes on Firefox
		inst.dpDiv.empty();
		// determine sizing offscreen
		inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
		$.datepicker._updateDatepicker(inst);
		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset(inst, offset, isFixed);
		inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
			"static" : (isFixed ? "fixed" : "absolute")), display: "none",
			left: offset.left + "px", top: offset.top + "px"});

		if (!inst.inline) {
			showAnim = $.datepicker._get(inst, "showAnim");
			duration = $.datepicker._get(inst, "duration");
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
			} else {
				inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.focus();
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function(inst) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append(this._generateHTML(inst));
		this._attachHandlers(inst);

		var origyearshtml,
			numMonths = this._getNumberOfMonths(inst),
			cols = numMonths[1],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
		if (cols > 1) {
			inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
		}
		inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
			"Class"]("ui-datepicker-multi");
		inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
			"Class"]("ui-datepicker-rtl");

		if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.focus();
		}

		// deffered render of the years select (to avoid flashes on Firefox)
		if( inst.yearshtml ){
			origyearshtml = inst.yearshtml;
			setTimeout(function(){
				//assure that inst.yearshtml didn't change.
				if( origyearshtml === inst.yearshtml && inst.yearshtml ){
					inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
				}
				origyearshtml = inst.yearshtml = null;
			}, 0);
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function(inst, offset, isFixed) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
			viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

		offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
		offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
		offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

		// now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
			Math.abs(offset.left + dpWidth - viewWidth) : 0);
		offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
			Math.abs(dpHeight + inputHeight) : 0);

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function(obj) {
		var position,
			inst = this._getInst(obj),
			isRTL = this._get(inst, "isRTL");

		while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
			obj = obj[isRTL ? "previousSibling" : "nextSibling"];
		}

		position = $(obj).offset();
		return [position.left, position.top];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function(input) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if (!inst || (input && inst !== $.data(input, "datepicker"))) {
			return;
		}

		if (this._datepickerShowing) {
			showAnim = this._get(inst, "showAnim");
			duration = this._get(inst, "duration");
			postProcess = function() {
				$.datepicker._tidyDialog(inst);
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
			} else {
				inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
					(showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
			}

			if (!showAnim) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get(inst, "onClose");
			if (onClose) {
				onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
			}

			this._lastInput = null;
			if (this._inDialog) {
				this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
				if ($.blockUI) {
					$.unblockUI();
					$("body").append(this.dpDiv);
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function(inst) {
		inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function(event) {
		if (!$.datepicker._curInst) {
			return;
		}

		var $target = $(event.target),
			inst = $.datepicker._getInst($target[0]);

		if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
				$target.parents("#" + $.datepicker._mainDivId).length === 0 &&
				!$target.hasClass($.datepicker.markerClassName) &&
				!$target.closest("." + $.datepicker._triggerClass).length &&
				$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
			( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function(id, offset, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		if (this._isDisabledDatepicker(target[0])) {
			return;
		}
		this._adjustInstDate(inst, offset +
			(period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
			period);
		this._updateDatepicker(inst);
	},

	/* Action for current link. */
	_gotoToday: function(id) {
		var date,
			target = $(id),
			inst = this._getInst(target[0]);

		if (this._get(inst, "gotoCurrent") && inst.currentDay) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function(id, select, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		inst["selected" + (period === "M" ? "Month" : "Year")] =
		inst["draw" + (period === "M" ? "Month" : "Year")] =
			parseInt(select.options[select.selectedIndex].value,10);

		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a day. */
	_selectDay: function(id, month, year, td) {
		var inst,
			target = $(id);

		if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
			return;
		}

		inst = this._getInst(target[0]);
		inst.selectedDay = inst.currentDay = $("a", td).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate(id, this._formatDate(inst,
			inst.currentDay, inst.currentMonth, inst.currentYear));
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function(id) {
		var target = $(id);
		this._selectDate(target, "");
	},

	/* Update the input field with the selected date. */
	_selectDate: function(id, dateStr) {
		var onSelect,
			target = $(id),
			inst = this._getInst(target[0]);

		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (inst.input) {
			inst.input.val(dateStr);
		}
		this._updateAlternate(inst);

		onSelect = this._get(inst, "onSelect");
		if (onSelect) {
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		} else if (inst.input) {
			inst.input.trigger("change"); // fire the change event
		}

		if (inst.inline){
			this._updateDatepicker(inst);
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[0];
			if (typeof(inst.input[0]) !== "object") {
				inst.input.focus(); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function(inst) {
		var altFormat, date, dateStr,
			altField = this._get(inst, "altField");

		if (altField) { // update alternate field too
			altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
			date = this._getDate(inst);
			dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
			$(altField).each(function() { $(this).val(dateStr); });
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function(date) {
		var day = date.getDay();
		return [(day > 0 && day < 6), ""];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function(date) {
		var time,
			checkDate = new Date(date.getTime());

		// Find Thursday of this week starting on Monday
		checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

		time = checkDate.getTime();
		checkDate.setMonth(0); // Compare with Jan 1
		checkDate.setDate(1);
		return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function (format, value, settings) {
		if (format == null || value == null) {
			throw "Invalid arguments";
		}

		value = (typeof value === "object" ? value.toString() : value + "");
		if (value === "") {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
			shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Extract a number from the string value
			getNumber = function(match) {
				var isDoubled = lookAhead(match),
					size = (match === "@" ? 14 : (match === "!" ? 20 :
					(match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
					minSize = (match === "y" ? size : 1),
					digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
					num = value.substring(iValue).match(digits);
				if (!num) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[0].length;
				return parseInt(num[0], 10);
			},
			// Extract a name from the string value and convert to an index
			getName = function(match, shortNames, longNames) {
				var index = -1,
					names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
						return [ [k, v] ];
					}).sort(function (a, b) {
						return -(a[1].length - b[1].length);
					});

				$.each(names, function (i, pair) {
					var name = pair[1];
					if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
						index = pair[0];
						iValue += name.length;
						return false;
					}
				});
				if (index !== -1) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if (value.charAt(iValue) !== format.charAt(iFormat)) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d":
						day = getNumber("d");
						break;
					case "D":
						getName("D", dayNamesShort, dayNames);
						break;
					case "o":
						doy = getNumber("o");
						break;
					case "m":
						month = getNumber("m");
						break;
					case "M":
						month = getName("M", monthNamesShort, monthNames);
						break;
					case "y":
						year = getNumber("y");
						break;
					case "@":
						date = new Date(getNumber("@"));
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if (lookAhead("'")){
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if (iValue < value.length){
			extra = value.substr(iValue);
			if (!/^\s+/.test(extra)) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if (year === -1) {
			year = new Date().getFullYear();
		} else if (year < 100) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				(year <= shortYearCutoff ? 0 : -100);
		}

		if (doy > -1) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth(year, month - 1);
				if (day <= dim) {
					break;
				}
				month++;
				day -= dim;
			} while (true);
		}

		date = this._daylightSavingAdjust(new Date(year, month - 1, day));
		if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
		Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function (format, date, settings) {
		if (!date) {
			return "";
		}

		var iFormat,
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Format a number, with leading zero if necessary
			formatNumber = function(match, value, len) {
				var num = "" + value;
				if (lookAhead(match)) {
					while (num.length < len) {
						num = "0" + num;
					}
				}
				return num;
			},
			// Format a name, short or long as requested
			formatName = function(match, value, shortNames, longNames) {
				return (lookAhead(match) ? longNames[value] : shortNames[value]);
			},
			output = "",
			literal = false;

		if (date) {
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						output += format.charAt(iFormat);
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d":
							output += formatNumber("d", date.getDate(), 2);
							break;
						case "D":
							output += formatName("D", date.getDay(), dayNamesShort, dayNames);
							break;
						case "o":
							output += formatNumber("o",
								Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
							break;
						case "m":
							output += formatNumber("m", date.getMonth() + 1, 2);
							break;
						case "M":
							output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
							break;
						case "y":
							output += (lookAhead("y") ? date.getFullYear() :
								(date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if (lookAhead("'")) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt(iFormat);
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function (format) {
		var iFormat,
			chars = "",
			literal = false,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					chars += format.charAt(iFormat);
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if (lookAhead("'")) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt(iFormat);
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function(inst, name) {
		return inst.settings[name] !== undefined ?
			inst.settings[name] : this._defaults[name];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function(inst, noDefault) {
		if (inst.input.val() === inst.lastVal) {
			return;
		}

		var dateFormat = this._get(inst, "dateFormat"),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate(inst),
			date = defaultDate,
			settings = this._getFormatConfig(inst);

		try {
			date = this.parseDate(dateFormat, dates, settings) || defaultDate;
		} catch (event) {
			dates = (noDefault ? "" : dates);
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = (dates ? date.getDate() : 0);
		inst.currentMonth = (dates ? date.getMonth() : 0);
		inst.currentYear = (dates ? date.getFullYear() : 0);
		this._adjustInstDate(inst);
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function(inst) {
		return this._restrictMinMax(inst,
			this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function(inst, date, defaultDate) {
		var offsetNumeric = function(offset) {
				var date = new Date();
				date.setDate(date.getDate() + offset);
				return date;
			},
			offsetString = function(offset) {
				try {
					return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
						offset, $.datepicker._getFormatConfig(inst));
				}
				catch (e) {
					// Ignore
				}

				var date = (offset.toLowerCase().match(/^c/) ?
					$.datepicker._getDate(inst) : null) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec(offset);

				while (matches) {
					switch (matches[2] || "d") {
						case "d" : case "D" :
							day += parseInt(matches[1],10); break;
						case "w" : case "W" :
							day += parseInt(matches[1],10) * 7; break;
						case "m" : case "M" :
							month += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
						case "y": case "Y" :
							year += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
					}
					matches = pattern.exec(offset);
				}
				return new Date(year, month, day);
			},
			newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
				(typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));

		newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
		if (newDate) {
			newDate.setHours(0);
			newDate.setMinutes(0);
			newDate.setSeconds(0);
			newDate.setMilliseconds(0);
		}
		return this._daylightSavingAdjust(newDate);
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function(date) {
		if (!date) {
			return null;
		}
		date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function(inst, date, noChange) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
			this._notifyChange(inst);
		}
		this._adjustInstDate(inst);
		if (inst.input) {
			inst.input.val(clear ? "" : this._formatDate(inst));
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function(inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
			this._daylightSavingAdjust(new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay)));
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function(inst) {
		var stepMonths = this._get(inst, "stepMonths"),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find("[data-handler]").map(function () {
			var handler = {
				prev: function () {
					$.datepicker._adjustDate(id, -stepMonths, "M");
				},
				next: function () {
					$.datepicker._adjustDate(id, +stepMonths, "M");
				},
				hide: function () {
					$.datepicker._hideDatepicker();
				},
				today: function () {
					$.datepicker._gotoToday(id);
				},
				selectDay: function () {
					$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
					return false;
				},
				selectMonth: function () {
					$.datepicker._selectMonthYear(id, this, "M");
					return false;
				},
				selectYear: function () {
					$.datepicker._selectMonthYear(id, this, "Y");
					return false;
				}
			};
			$(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
		});
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function(inst) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
			isRTL = this._get(inst, "isRTL"),
			showButtonPanel = this._get(inst, "showButtonPanel"),
			hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
			navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
			numMonths = this._getNumberOfMonths(inst),
			showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
			stepMonths = this._get(inst, "stepMonths"),
			isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
			currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
				new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if (drawMonth < 0) {
			drawMonth += 12;
			drawYear--;
		}
		if (maxDate) {
			maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
				maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
			maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
			while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
				drawMonth--;
				if (drawMonth < 0) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get(inst, "prevText");
		prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
			this._getFormatConfig(inst)));

		prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));

		nextText = this._get(inst, "nextText");
		nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
			this._getFormatConfig(inst)));

		next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));

		currentText = this._get(inst, "currentText");
		gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
		currentText = (!navigationAsDateFormat ? currentText :
			this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));

		controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get(inst, "closeText") + "</button>" : "");

		buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
			(this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

		firstDay = parseInt(this._get(inst, "firstDay"),10);
		firstDay = (isNaN(firstDay) ? 0 : firstDay);

		showWeek = this._get(inst, "showWeek");
		dayNames = this._get(inst, "dayNames");
		dayNamesMin = this._get(inst, "dayNamesMin");
		monthNames = this._get(inst, "monthNames");
		monthNamesShort = this._get(inst, "monthNamesShort");
		beforeShowDay = this._get(inst, "beforeShowDay");
		showOtherMonths = this._get(inst, "showOtherMonths");
		selectOtherMonths = this._get(inst, "selectOtherMonths");
		defaultDate = this._getDefaultDate(inst);
		html = "";
		dow;
		for (row = 0; row < numMonths[0]; row++) {
			group = "";
			this.maxRows = 4;
			for (col = 0; col < numMonths[1]; col++) {
				selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
				cornerClass = " ui-corner-all";
				calender = "";
				if (isMultiMonth) {
					calender += "<div class='ui-datepicker-group";
					if (numMonths[1] > 1) {
						switch (col) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
							case numMonths[1]-1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					(/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
					(/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
					this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
				for (dow = 0; dow < 7; dow++) { // days of the week
					day = (dow + firstDay) % 7;
					thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
						"<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
				if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
					inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
				}
				leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
				curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
				numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
				for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
					calender += "<tr>";
					tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get(inst, "calculateWeek")(printDate) + "</td>");
					for (dow = 0; dow < 7; dow++) { // create date picker days
						daySettings = (beforeShowDay ?
							beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
						otherMonth = (printDate.getMonth() !== drawMonth);
						unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
							(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
						tbody += "<td class='" +
							((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
							(otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
							((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
							(defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "") + // highlight selected day
							(unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
							(otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
							(printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
							(printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
							((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
							(unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
							(otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							(unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							(printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
							(printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
							(otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
						printDate.setDate(printDate.getDate() + 1);
						printDate = this._daylightSavingAdjust(printDate);
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if (drawMonth > 11) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
							((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get(inst, "changeMonth"),
			changeYear = this._get(inst, "changeYear"),
			showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// month selection
		if (secondary || !changeMonth) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
		} else {
			inMinYear = (minDate && minDate.getFullYear() === drawYear);
			inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++) {
				if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
					monthHtml += "<option value='" + month + "'" +
						(month === drawMonth ? " selected='selected'" : "") +
						">" + monthNamesShort[month] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if (!showMonthAfterYear) {
			html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
		}

		// year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if (secondary || !changeYear) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {
				// determine range of years to display
				years = this._get(inst, "yearRange").split(":");
				thisYear = new Date().getFullYear();
				determineYear = function(value) {
					var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
						(value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
						parseInt(value, 10)));
					return (isNaN(year) ? thisYear : year);
				};
				year = determineYear(years[0]);
				endYear = Math.max(year, determineYear(years[1] || ""));
				year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
				endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for (; year <= endYear; year++) {
					inst.yearshtml += "<option value='" + year + "'" +
						(year === drawYear ? " selected='selected'" : "") +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get(inst, "yearSuffix");
		if (showMonthAfterYear) {
			html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function(inst, offset, period) {
		var year = inst.drawYear + (period === "Y" ? offset : 0),
			month = inst.drawMonth + (period === "M" ? offset : 0),
			day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
			date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if (period === "M" || period === "Y") {
			this._notifyChange(inst);
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			newDate = (minDate && date < minDate ? minDate : date);
		return (maxDate && newDate > maxDate ? maxDate : newDate);
	},

	/* Notify change of month/year. */
	_notifyChange: function(inst) {
		var onChange = this._get(inst, "onChangeMonthYear");
		if (onChange) {
			onChange.apply((inst.input ? inst.input[0] : null),
				[inst.selectedYear, inst.selectedMonth + 1, inst]);
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function(inst) {
		var numMonths = this._get(inst, "numberOfMonths");
		return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function(inst, minMax) {
		return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function(year, month) {
		return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function(year, month) {
		return new Date(year, month, 1).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function(inst, offset, curYear, curMonth) {
		var numMonths = this._getNumberOfMonths(inst),
			date = this._daylightSavingAdjust(new Date(curYear,
			curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

		if (offset < 0) {
			date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
		}
		return this._isInRange(inst, date);
	},

	/* Is the given date in the accepted range? */
	_isInRange: function(inst, date) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			minYear = null,
			maxYear = null,
			years = this._get(inst, "yearRange");
			if (years){
				yearSplit = years.split(":");
				currentYear = new Date().getFullYear();
				minYear = parseInt(yearSplit[0], 10);
				maxYear = parseInt(yearSplit[1], 10);
				if ( yearSplit[0].match(/[+\-].*/) ) {
					minYear += currentYear;
				}
				if ( yearSplit[1].match(/[+\-].*/) ) {
					maxYear += currentYear;
				}
			}

		return ((!minDate || date.getTime() >= minDate.getTime()) &&
			(!maxDate || date.getTime() <= maxDate.getTime()) &&
			(!minYear || date.getFullYear() >= minYear) &&
			(!maxYear || date.getFullYear() <= maxYear));
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function(inst) {
		var shortYearCutoff = this._get(inst, "shortYearCutoff");
		shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		return {shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
			monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
	},

	/* Format the given date for display. */
	_formatDate: function(inst, day, month, year) {
		if (!day) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = (day ? (typeof day === "object" ? day :
			this._daylightSavingAdjust(new Date(year, month, day))) :
			this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
	}
});

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover(dpDiv) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.delegate(selector, "mouseout", function() {
			$(this).removeClass("ui-state-hover");
			if (this.className.indexOf("ui-datepicker-prev") !== -1) {
				$(this).removeClass("ui-datepicker-prev-hover");
			}
			if (this.className.indexOf("ui-datepicker-next") !== -1) {
				$(this).removeClass("ui-datepicker-next-hover");
			}
		})
		.delegate( selector, "mouseover", datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if (!$.datepicker._isDisabledDatepicker( datepicker_instActive.inline? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
		$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
		$(this).addClass("ui-state-hover");
		if (this.className.indexOf("ui-datepicker-prev") !== -1) {
			$(this).addClass("ui-datepicker-prev-hover");
		}
		if (this.className.indexOf("ui-datepicker-next") !== -1) {
			$(this).addClass("ui-datepicker-next-hover");
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove(target, props) {
	$.extend(target, props);
	for (var name in props) {
		if (props[name] == null) {
			target[name] = props[name];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function(options){

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if (!$.datepicker.initialized) {
		$(document).mousedown($.datepicker._checkExternalClick);
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ($("#"+$.datepicker._mainDivId).length === 0) {
		$("body").append($.datepicker.dpDiv);
	}

	var otherArgs = Array.prototype.slice.call(arguments, 1);
	if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	return this.each(function() {
		typeof options === "string" ?
			$.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this].concat(otherArgs)) :
			$.datepicker._attachDatepicker(this, options);
	});
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.11.4";

return $.datepicker;

}));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Draggable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(18),
			__webpack_require__(154),
			__webpack_require__(19)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.draggable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if (this.options.addClasses){
			this.element.addClass("ui-draggable");
		}
		if (this.options.disabled){
			this.element.addClass("ui-draggable-disabled");
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function(event) {
		var o = this.options;

		this._blurActiveElement( event );

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle) {
			return false;
		}

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var document = this.document[ 0 ];

		// Only need to blur if the event occurred on the draggable itself, see #10527
		if ( !this.handleElement.is( event.target ) ) {
			return;
		}

		// support: IE9
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {

			// Support: IE9, IE10
			// If the <body> is blurred, IE will switch windows, see #9520
			if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {

				// Blur any element that currently has focus, see #4261
				$( document.activeElement ).blur();
			}
		} catch ( error ) {}
	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		this.helper.addClass("ui-draggable-dragging");

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter(function() {
				return $( this ).css( "position" ) === "fixed";
			}).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if (this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		// Reset helper's right/bottom css if they're set and set explicit width/height instead
		// as this prevents resizing of elements with right/bottom set (see #7772)
		this._normalizeRightBottom();

		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart(this, event);
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function(event, noPropagation) {
		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if (this._trigger("drag", event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			dropped = $.ui.ddmanager.drop(this, event);
		}

		//if a drop comes from outside (a sortable)
		if (this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if (that._trigger("stop", event) !== false) {
					that._clear();
				}
			});
		} else {
			if (this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop(this, event);
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {
			// The interaction is over; whether or not the click resulted in a drag, focus the element
			this.element.focus();
		}

		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},

	cancel: function() {

		if (this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function(event) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this.handleElement.addClass( "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this.handleElement.removeClass( "ui-draggable-handle" );
	},

	_createHelper: function(event) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if (!helper.parents("body").length) {
			helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
		}

		// http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
			helper.css("position", "absolute");
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = { left: +obj[0], top: +obj[1] || 0 };
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"), 10) || 0),
			top: (parseInt(this.element.css("marginTop"), 10) || 0),
			right: (parseInt(this.element.css("marginRight"), 10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document") {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function(d, pos) {

		if (!pos) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ){
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if (event.pageX - this.offset.click.left < containment[0]) {
					pageX = containment[0] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top < containment[1]) {
					pageY = containment[1] + this.offset.click.top;
				}
				if (event.pageX - this.offset.click.left > containment[2]) {
					pageX = containment[2] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top > containment[3]) {
					pageY = containment[3] + this.offset.click.top;
				}
			}

			if (o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (
				pageY -																	// The absolute mouse position
				this.offset.click.top	-												// Click offset (relative to the element)
				this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (
				pageX -																	// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	_normalizeRightBottom: function() {
		if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
			this.helper.width( this.helper.width() );
			this.helper.css( "right", "auto" );
		}
		if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
			this.helper.height( this.helper.height() );
			this.helper.css( "bottom", "auto" );
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each(function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// refreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger("activate", event, uiSortable);
			}
		});
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop(event);

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {
				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		});
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {
					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				});
			}

			if ( innermostIntersecting ) {
				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});

					// hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );
					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {
				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});
				}
			}
		});
	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if (t.css("cursor")) {
			o._cursor = t.css("cursor");
		}
		t.css("cursor", o.cursor);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._cursor) {
			$("body").css("cursor", o._cursor);
		}
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if (t.css("opacity")) {
			o._opacity = t.css("opacity");
		}
		t.css("opacity", o.opacity);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._opacity) {
			$(ui.helper).css("opacity", o._opacity);
		}
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if (!o.axis || o.axis !== "x") {
				if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
				}
			}

			if (!o.axis || o.axis !== "y") {
				if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
				}
			}

		}

		if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(i, event);
		}

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
			var $t = $(this),
				$o = $t.offset();
			if (this !== i.element[0]) {
				i.snapElements.push({
					item: this,
					width: $t.outerWidth(), height: $t.outerHeight(),
					top: $o.top, left: $o.left
				});
			}
		});

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (i = inst.snapElements.length - 1; i >= 0; i--){

			l = inst.snapElements[i].left - inst.margins.left;
			r = l + inst.snapElements[i].width;
			t = inst.snapElements[i].top - inst.margins.top;
			b = t + inst.snapElements[i].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
				if (inst.snapElements[i].snapping) {
					(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = false;
				continue;
			}

			if (o.snapMode !== "inner") {
				ts = Math.abs(t - y2) <= d;
				bs = Math.abs(b - y1) <= d;
				ls = Math.abs(l - x2) <= d;
				rs = Math.abs(r - x1) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
				}
			}

			first = (ts || bs || ls || rs);

			if (o.snapMode !== "outer") {
				ts = Math.abs(t - y1) <= d;
				bs = Math.abs(b - y2) <= d;
				ls = Math.abs(l - x1) <= d;
				rs = Math.abs(r - x2) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
				}
			}

			if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			}
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		}

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray($(o.stack)).sort(function(a, b) {
				return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
			});

		if (!group.length) { return; }

		min = parseInt($(group[0]).css("zIndex"), 10) || 0;
		$(group).each(function(i) {
			$(this).css("zIndex", min + i);
		});
		this.css("zIndex", (min + group.length));
	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if (t.css("zIndex")) {
			o._zIndex = t.css("zIndex");
		}
		t.css("zIndex", o.zIndex);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if (o._zIndex) {
			$(ui.helper).css("zIndex", o._zIndex);
		}
	}
});

return $.ui.draggable;

}));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Effects Highlight 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/highlight-effect/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(354)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.effects.effect.highlight = function( o, done ) {
	var elem = $( this ),
		props = [ "backgroundImage", "backgroundColor", "opacity" ],
		mode = $.effects.setMode( elem, o.mode || "show" ),
		animation = {
			backgroundColor: elem.css( "backgroundColor" )
		};

	if (mode === "hide") {
		animation.opacity = 0;
	}

	$.effects.save( elem, props );

	elem
		.show()
		.css({
			backgroundImage: "none",
			backgroundColor: o.color || "#ffff99"
		})
		.animate( animation, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( mode === "hide" ) {
					elem.hide();
				}
				$.effects.restore( elem, props );
				done();
			}
		});
};

}));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Sortable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/sortable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(18),
			__webpack_require__(154),
			__webpack_require__(19)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget("ui.sortable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
	},

	_create: function() {
		this.containerCache = {};
		this.element.addClass("ui-sortable");

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		this.element.find( ".ui-sortable-handle" ).removeClass( "ui-sortable-handle" );
		$.each( this.items, function() {
			( this.instance.options.handle ?
				this.item.find( this.instance.options.handle ) : this.item )
				.addClass( "ui-sortable-handle" );
		});
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-sortable ui-sortable-disabled" )
			.find( ".ui-sortable-handle" )
				.removeClass( "ui-sortable-handle" );
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[i].item.removeData(this.widgetName + "-item");
		}

		return this;
	},

	_mouseCapture: function(event, overrideHandle) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if (this.reverting) {
			return false;
		}

		if(this.options.disabled || this.options.type === "static") {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems(event);

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$(event.target).parents().each(function() {
			if($.data(this, that.widgetName + "-item") === that) {
				currentItem = $(this);
				return false;
			}
		});
		if($.data(event.target, that.widgetName + "-item") === that) {
			currentItem = $(event.target);
		}

		if(!currentItem) {
			return false;
		}
		if(this.options.handle && !overrideHandle) {
			$(this.options.handle, currentItem).find("*").addBack().each(function() {
				if(this === event.target) {
					validHandle = true;
				}
			});
			if(!validHandle) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function(event, overrideHandle, noActivation) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend(this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
		});

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css("position", "absolute");
		this.cssPosition = this.helper.css("position");

		//Generate the original position
		this.originalPosition = this._generatePosition(event);
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Cache the former DOM position
		this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };

		//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
		if(this.helper[0] !== this.currentItem[0]) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if(o.containment) {
			this._setContainment();
		}

		if( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet = $( "<style>*{ cursor: "+o.cursor+" !important; }</style>" ).appendTo( body );
		}

		if(o.opacity) { // opacity option
			if (this.helper.css("opacity")) {
				this._storedOpacity = this.helper.css("opacity");
			}
			this.helper.css("opacity", o.opacity);
		}

		if(o.zIndex) { // zIndex option
			if (this.helper.css("zIndex")) {
				this._storedZIndex = this.helper.css("zIndex");
			}
			this.helper.css("zIndex", o.zIndex);
		}

		//Prepare scrolling
		if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger("start", event, this._uiHash());

		//Recache the helper size
		if(!this._preserveHelperProportions) {
			this._cacheHelperProportions();
		}


		//Post "activate" events to possible containers
		if( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		this.dragging = true;

		this.helper.addClass("ui-sortable-helper");
		this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
		return true;

	},

	_mouseDrag: function(event) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition(event);
		this.positionAbs = this._convertPositionTo("absolute");

		if (!this.lastPositionAbs) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if(this.options.scroll) {
			if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {

				if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
				} else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
				}

				if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
				} else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
				}

			} else {

				if(event.pageY - this.document.scrollTop() < o.scrollSensitivity) {
					scrolled = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed);
				} else if(this.window.height() - (event.pageY - this.document.scrollTop()) < o.scrollSensitivity) {
					scrolled = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed);
				}

				if(event.pageX - this.document.scrollLeft() < o.scrollSensitivity) {
					scrolled = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed);
				} else if(this.window.width() - (event.pageX - this.document.scrollLeft()) < o.scrollSensitivity) {
					scrolled = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed);
				}

			}

			if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo("absolute");

		//Set the helper position
		if(!this.options.axis || this.options.axis !== "y") {
			this.helper[0].style.left = this.position.left+"px";
		}
		if(!this.options.axis || this.options.axis !== "x") {
			this.helper[0].style.top = this.position.top+"px";
		}

		//Rearrange
		for (i = this.items.length - 1; i >= 0; i--) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[i];
			itemElement = item.item[0];
			intersection = this._intersectsWithPointer(item);
			if (!intersection) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if (item.instance !== this.currentContainer) {
				continue;
			}

			// cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if (itemElement !== this.currentItem[0] &&
				this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
				!$.contains(this.placeholder[0], itemElement) &&
				(this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
					this._rearrange(event, item);
				} else {
					break;
				}

				this._trigger("change", event, this._uiHash());
				break;
			}
		}

		//Post events to containers
		this._contactContainers(event);

		//Interconnect with droppables
		if($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		//Call callbacks
		this._trigger("sort", event, this._uiHash());

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function(event, noPropagation) {

		if(!event) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			$.ui.ddmanager.drop(this, event);
		}

		if(this.options.revert) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop);
			}
			this.reverting = true;
			$(this.helper).animate( animation, parseInt(this.options.revert, 10) || 500, function() {
				that._clear(event);
			});
		} else {
			this._clear(event, noPropagation);
		}

		return false;

	},

	cancel: function() {

		if(this.dragging) {

			this._mouseUp({ target: null });

			if(this.options.helper === "original") {
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for (var i = this.containers.length - 1; i >= 0; i--){
				this.containers[i]._trigger("deactivate", null, this._uiHash(this));
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", null, this._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}

		if (this.placeholder) {
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			if(this.placeholder[0].parentNode) {
				this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
			}
			if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
				this.helper.remove();
			}

			$.extend(this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			});

			if(this.domPosition.prev) {
				$(this.domPosition.prev).after(this.currentItem);
			} else {
				$(this.domPosition.parent).prepend(this.currentItem);
			}
		}

		return this;

	},

	serialize: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected),
			str = [];
		o = o || {};

		$(items).each(function() {
			var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
			if (res) {
				str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
			}
		});

		if(!str.length && o.key) {
			str.push(o.key + "=");
		}

		return str.join("&");

	},

	toArray: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected),
			ret = [];

		o = o || {};

		items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function(item) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t && ( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l && ( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			(this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
		) {
			return isOverElement;
		} else {

			return (l < x1 + (this.helperProportions.width / 2) && // Right Half
				x2 - (this.helperProportions.width / 2) < r && // Left Half
				t < y1 + (this.helperProportions.height / 2) && // Bottom Half
				y2 - (this.helperProportions.height / 2) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function(item) {

		var isOverElementHeight = (this.options.axis === "x") || this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
			isOverElementWidth = (this.options.axis === "y") || this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
			isOverElement = isOverElementHeight && isOverElementWidth,
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (!isOverElement) {
			return false;
		}

		return this.floating ?
			( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
			: ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );

	},

	_intersectsWithSides: function(item) {

		var isOverBottomHalf = this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
			isOverRightHalf = this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (this.floating && horizontalDirection) {
			return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
		} else {
			return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && (delta > 0 ? "down" : "up");
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && (delta > 0 ? "right" : "left");
	},

	refresh: function(event) {
		this._refreshItems(event);
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
	},

	_getItemsAsjQuery: function(connected) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if(connectWith && connected) {
			for (i = connectWith.length - 1; i >= 0; i--){
				cur = $(connectWith[i], this.document[0]);
				for ( j = cur.length - 1; j >= 0; j--){
					inst = $.data(cur[j], this.widgetFullName);
					if(inst && inst !== this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
					}
				}
			}
		}

		queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);

		function addItems() {
			items.push( this );
		}
		for (i = queries.length - 1; i >= 0; i--){
			queries[i][0].each( addItems );
		}

		return $(items);

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find(":data(" + this.widgetName + "-item)");

		this.items = $.grep(this.items, function (item) {
			for (var j=0; j < list.length; j++) {
				if(list[j] === item.item[0]) {
					return false;
				}
			}
			return true;
		});

	},

	_refreshItems: function(event) {

		this.items = [];
		this.containers = [this];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
			connectWith = this._connectWith();

		if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
			for (i = connectWith.length - 1; i >= 0; i--){
				cur = $(connectWith[i], this.document[0]);
				for (j = cur.length - 1; j >= 0; j--){
					inst = $.data(cur[j], this.widgetFullName);
					if(inst && inst !== this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
						this.containers.push(inst);
					}
				}
			}
		}

		for (i = queries.length - 1; i >= 0; i--) {
			targetData = queries[i][1];
			_queries = queries[i][0];

			for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
				item = $(_queries[j]);

				item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)

				items.push({
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				});
			}
		}

	},

	refreshPositions: function(fast) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
		if(this.offsetParent && this.helper) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for (i = this.items.length - 1; i >= 0; i--){
			item = this.items[i];

			//We ignore calculating positions of all connected containers when we're not over them
			if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
				continue;
			}

			t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;

			if (!fast) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if(this.options.custom && this.options.custom.refreshContainers) {
			this.options.custom.refreshContainers.call(this);
		} else {
			for (i = this.containers.length - 1; i >= 0; i--){
				p = this.containers[i].element.offset();
				this.containers[i].containerCache.left = p.left;
				this.containers[i].containerCache.top = p.top;
				this.containers[i].containerCache.width = this.containers[i].element.outerWidth();
				this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function(that) {
		that = that || this;
		var className,
			o = that.options;

		if(!o.placeholder || o.placeholder.constructor === String) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[0].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[0] )
							.addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
							.removeClass("ui-sortable-helper");

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function(container, p) {

					// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
					if(className && !o.forcePlaceholderSize) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
					if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
					if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
				}
			};
		}

		//Create the placeholder
		that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));

		//Append it after the actual current item
		that.currentItem.after(that.placeholder);

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update(that, that.placeholder);

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each(function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		});
	},

	_contactContainers: function(event) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom, floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// get innermost container that intersects with item
		for (i = this.containers.length - 1; i >= 0; i--) {

			// never consider a container that's located within the item itself
			if($.contains(this.currentItem[0], this.containers[i].element[0])) {
				continue;
			}

			if(this._intersectsWith(this.containers[i].containerCache)) {

				// if we've already found a container and it's more "inner" than this, then continue
				if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
					continue;
				}

				innermostContainer = this.containers[i];
				innermostIndex = i;

			} else {
				// container doesn't intersect. trigger "out" event if necessary
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", event, this._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}

		// if no intersecting containers found, return
		if(!innermostContainer) {
			return;
		}

		// move the item into the container if it's not there already
		if(this.containers.length === 1) {
			if (!this.containers[innermostIndex].containerCache.over) {
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			}
		} else {

			//When entering a new container, we will find the item with the least distance and append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating(this.currentItem);
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "clientX" : "clientY";

			for (j = this.items.length - 1; j >= 0; j--) {
				if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
					continue;
				}
				if(this.items[j].item[0] === this.currentItem[0]) {
					continue;
				}

				cur = this.items[j].item.offset()[posProperty];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up": "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
				return;
			}

			if(this.currentContainer === this.containers[innermostIndex]) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
			this._trigger("change", event, this._uiHash());
			this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
			this.currentContainer = this.containers[innermostIndex];

			//Update the placeholder
			this.options.placeholder.update(this.currentContainer, this.placeholder);

			this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
			this.containers[innermostIndex].containerCache.over = 1;
		}


	},

	_createHelper: function(event) {

		var o = this.options,
			helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);

		//Add the helper to the DOM if that didn't happen already
		if(!helper.parents("body").length) {
			$(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
		}

		if(helper[0] === this.currentItem[0]) {
			this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
		}

		if(!helper[0].style.width || o.forceHelperSize) {
			helper.width(this.currentItem.width());
		}
		if(!helper[0].style.height || o.forceHelperSize) {
			helper.height(this.currentItem.height());
		}

		return helper;

	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = {left: +obj[0], top: +obj[1] || 0};
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {


		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if(this.cssPosition === "absolute" && this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this information
		// with an ugly IE fix
		if( this.offsetParent[0] === this.document[0].body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
		};

	},

	_getRelativeOffset: function() {

		if(this.cssPosition === "relative") {
			var p = this.currentItem.position();
			return {
				top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
				left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
			top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if(o.containment === "parent") {
			o.containment = this.helper[0].parentNode;
		}
		if(o.containment === "document" || o.containment === "window") {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left,
				(o.containment === "document" ? this.document.width() : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
			];
		}

		if(!(/^(document|window|parent)$/).test(o.containment)) {
			ce = $(o.containment)[0];
			co = $(o.containment).offset();
			over = ($(ce).css("overflow") !== "hidden");

			this.containment = [
				co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
				co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
				co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
				co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function(d, pos) {

		if(!pos) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
			scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
			)
		};

	},

	_generatePosition: function(event) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if(this.cssPosition === "relative" && !(this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0])) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if(this.originalPosition) { //If we are not dragging yet, we won't check for options

			if(this.containment) {
				if(event.pageX - this.offset.click.left < this.containment[0]) {
					pageX = this.containment[0] + this.offset.click.left;
				}
				if(event.pageY - this.offset.click.top < this.containment[1]) {
					pageY = this.containment[1] + this.offset.click.top;
				}
				if(event.pageX - this.offset.click.left > this.containment[2]) {
					pageX = this.containment[2] + this.offset.click.left;
				}
				if(event.pageY - this.offset.click.top > this.containment[3]) {
					pageY = this.containment[3] + this.offset.click.top;
				}
			}

			if(o.grid) {
				top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
				pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
				pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

		}

		return {
			top: (
				pageY -																// The absolute mouse position
				this.offset.click.top -													// Click offset (relative to the element)
				this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
			),
			left: (
				pageX -																// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
			)
		};

	},

	_rearrange: function(event, i, a, hardRefresh) {

		a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay(function() {
			if(counter === this.counter) {
				this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
			}
		});

	},

	_clear: function(event, noPropagation) {

		this.reverting = false;
		// We delay all events that have to be triggered to after the point where the placeholder has been removed and
		// everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
		if(!this._noFinalSort && this.currentItem.parent().length) {
			this.placeholder.before(this.currentItem);
		}
		this._noFinalSort = null;

		if(this.helper[0] === this.currentItem[0]) {
			for(i in this._storedCSS) {
				if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
					this._storedCSS[i] = "";
				}
			}
			this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
		} else {
			this.currentItem.show();
		}

		if(this.fromOutside && !noPropagation) {
			delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
		}
		if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
			delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if (this !== this.currentContainer) {
			if(!noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
				delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
				delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
			}
		}


		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for (i = this.containers.length - 1; i >= 0; i--){
			if (!noPropagation) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if(this.containers[i].containerCache.over) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[i].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if(this._storedOpacity) {
			this.helper.css("opacity", this._storedOpacity);
		}
		if(this._storedZIndex) {
			this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
		}

		this.dragging = false;

		if(!noPropagation) {
			this._trigger("beforeStop", event, this._uiHash());
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
		this.placeholder[0].parentNode.removeChild(this.placeholder[0]);

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if(!noPropagation) {
			for (i=0; i < delayedTriggers.length; i++) {
				delayedTriggers[i].call(this, event);
			} //Trigger all delayed events
			this._trigger("stop", event, this._uiHash());
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
			this.cancel();
		}
	},

	_uiHash: function(_inst) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $([]),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

});

}));


/***/ }),
/* 227 */
/***/ (function(module, exports) {

(function($, undefined) {

/**
 * Unobtrusive scripting adapter for jQuery
 * https://github.com/rails/jquery-ujs
 *
 * Requires jQuery 1.8.0 or later.
 *
 * Released under the MIT license
 *
 */

  // Cut down on the number of issues from people inadvertently including jquery_ujs twice
  // by detecting and raising an error when it happens.
  'use strict';

  if ( $.rails !== undefined ) {
    $.error('jquery-ujs has already been loaded!');
  }

  // Shorthand to make it a little easier to call public rails functions from within rails.js
  var rails;
  var $document = $(document);

  $.rails = rails = {
    // Link elements bound by jquery-ujs
    linkClickSelector: 'a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]',

    // Button elements bound by jquery-ujs
    buttonClickSelector: 'button[data-remote]:not([form]):not(form button), button[data-confirm]:not([form]):not(form button)',

    // Select elements bound by jquery-ujs
    inputChangeSelector: 'select[data-remote], input[data-remote], textarea[data-remote]',

    // Form elements bound by jquery-ujs
    formSubmitSelector: 'form',

    // Form input elements bound by jquery-ujs
    formInputClickSelector: 'form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',

    // Form input elements disabled during form submission
    disableSelector: 'input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled',

    // Form input elements re-enabled after form submission
    enableSelector: 'input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled',

    // Form required input elements
    requiredInputSelector: 'input[name][required]:not([disabled]), textarea[name][required]:not([disabled])',

    // Form file input elements
    fileInputSelector: 'input[type=file]:not([disabled])',

    // Link onClick disable selector with possible reenable after remote submission
    linkDisableSelector: 'a[data-disable-with], a[data-disable]',

    // Button onClick disable selector with possible reenable after remote submission
    buttonDisableSelector: 'button[data-remote][data-disable-with], button[data-remote][data-disable]',

    // Up-to-date Cross-Site Request Forgery token
    csrfToken: function() {
     return $('meta[name=csrf-token]').attr('content');
    },

    // URL param that must contain the CSRF token
    csrfParam: function() {
     return $('meta[name=csrf-param]').attr('content');
    },

    // Make sure that every Ajax request sends the CSRF token
    CSRFProtection: function(xhr) {
      var token = rails.csrfToken();
      if (token) xhr.setRequestHeader('X-CSRF-Token', token);
    },

    // Make sure that all forms have actual up-to-date tokens (cached forms contain old ones)
    refreshCSRFTokens: function(){
      $('form input[name="' + rails.csrfParam() + '"]').val(rails.csrfToken());
    },

    // Triggers an event on an element and returns false if the event result is false
    fire: function(obj, name, data) {
      var event = $.Event(name);
      obj.trigger(event, data);
      return event.result !== false;
    },

    // Default confirm dialog, may be overridden with custom confirm dialog in $.rails.confirm
    confirm: function(message) {
      return confirm(message);
    },

    // Default ajax function, may be overridden with custom function in $.rails.ajax
    ajax: function(options) {
      return $.ajax(options);
    },

    // Default way to get an element's href. May be overridden at $.rails.href.
    href: function(element) {
      return element[0].href;
    },

    // Checks "data-remote" if true to handle the request through a XHR request.
    isRemote: function(element) {
      return element.data('remote') !== undefined && element.data('remote') !== false;
    },

    // Submits "remote" forms and links with ajax
    handleRemote: function(element) {
      var method, url, data, withCredentials, dataType, options;

      if (rails.fire(element, 'ajax:before')) {
        withCredentials = element.data('with-credentials') || null;
        dataType = element.data('type') || ($.ajaxSettings && $.ajaxSettings.dataType);

        if (element.is('form')) {
          method = element.data('ujs:submit-button-formmethod') || element.attr('method');
          url = element.data('ujs:submit-button-formaction') || element.attr('action');
          data = $(element[0]).serializeArray();
          // memoized value from clicked submit button
          var button = element.data('ujs:submit-button');
          if (button) {
            data.push(button);
            element.data('ujs:submit-button', null);
          }
          element.data('ujs:submit-button-formmethod', null);
          element.data('ujs:submit-button-formaction', null);
        } else if (element.is(rails.inputChangeSelector)) {
          method = element.data('method');
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else if (element.is(rails.buttonClickSelector)) {
          method = element.data('method') || 'get';
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else {
          method = element.data('method');
          url = rails.href(element);
          data = element.data('params') || null;
        }

        options = {
          type: method || 'GET', data: data, dataType: dataType,
          // stopping the "ajax:beforeSend" event will cancel the ajax request
          beforeSend: function(xhr, settings) {
            if (settings.dataType === undefined) {
              xhr.setRequestHeader('accept', '*/*;q=0.5, ' + settings.accepts.script);
            }
            if (rails.fire(element, 'ajax:beforeSend', [xhr, settings])) {
              element.trigger('ajax:send', xhr);
            } else {
              return false;
            }
          },
          success: function(data, status, xhr) {
            element.trigger('ajax:success', [data, status, xhr]);
          },
          complete: function(xhr, status) {
            element.trigger('ajax:complete', [xhr, status]);
          },
          error: function(xhr, status, error) {
            element.trigger('ajax:error', [xhr, status, error]);
          },
          crossDomain: rails.isCrossDomain(url)
        };

        // There is no withCredentials for IE6-8 when
        // "Enable native XMLHTTP support" is disabled
        if (withCredentials) {
          options.xhrFields = {
            withCredentials: withCredentials
          };
        }

        // Only pass url to `ajax` options if not blank
        if (url) { options.url = url; }

        return rails.ajax(options);
      } else {
        return false;
      }
    },

    // Determines if the request is a cross domain request.
    isCrossDomain: function(url) {
      var originAnchor = document.createElement('a');
      originAnchor.href = location.href;
      var urlAnchor = document.createElement('a');

      try {
        urlAnchor.href = url;
        // This is a workaround to a IE bug.
        urlAnchor.href = urlAnchor.href;

        // If URL protocol is false or is a string containing a single colon
        // *and* host are false, assume it is not a cross-domain request
        // (should only be the case for IE7 and IE compatibility mode).
        // Otherwise, evaluate protocol and host of the URL against the origin
        // protocol and host.
        return !(((!urlAnchor.protocol || urlAnchor.protocol === ':') && !urlAnchor.host) ||
          (originAnchor.protocol + '//' + originAnchor.host ===
            urlAnchor.protocol + '//' + urlAnchor.host));
      } catch (e) {
        // If there is an error parsing the URL, assume it is crossDomain.
        return true;
      }
    },

    // Handles "data-method" on links such as:
    // <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
    handleMethod: function(link) {
      var href = rails.href(link),
        method = link.data('method'),
        target = link.attr('target'),
        csrfToken = rails.csrfToken(),
        csrfParam = rails.csrfParam(),
        form = $('<form method="post" action="' + href + '"></form>'),
        metadataInput = '<input name="_method" value="' + method + '" type="hidden" />';

      if (csrfParam !== undefined && csrfToken !== undefined && !rails.isCrossDomain(href)) {
        metadataInput += '<input name="' + csrfParam + '" value="' + csrfToken + '" type="hidden" />';
      }

      if (target) { form.attr('target', target); }

      form.hide().append(metadataInput).appendTo('body');
      form.submit();
    },

    // Helper function that returns form elements that match the specified CSS selector
    // If form is actually a "form" element this will return associated elements outside the from that have
    // the html form attribute set
    formElements: function(form, selector) {
      return form.is('form') ? $(form[0].elements).filter(selector) : form.find(selector);
    },

    /* Disables form elements:
      - Caches element value in 'ujs:enable-with' data store
      - Replaces element text with value of 'data-disable-with' attribute
      - Sets disabled property to true
    */
    disableFormElements: function(form) {
      rails.formElements(form, rails.disableSelector).each(function() {
        rails.disableFormElement($(this));
      });
    },

    disableFormElement: function(element) {
      var method, replacement;

      method = element.is('button') ? 'html' : 'val';
      replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element[method]());
        element[method](replacement);
      }

      element.prop('disabled', true);
      element.data('ujs:disabled', true);
    },

    /* Re-enables disabled form elements:
      - Replaces element text with cached value from 'ujs:enable-with' data store (created in `disableFormElements`)
      - Sets disabled property to false
    */
    enableFormElements: function(form) {
      rails.formElements(form, rails.enableSelector).each(function() {
        rails.enableFormElement($(this));
      });
    },

    enableFormElement: function(element) {
      var method = element.is('button') ? 'html' : 'val';
      if (element.data('ujs:enable-with') !== undefined) {
        element[method](element.data('ujs:enable-with'));
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.prop('disabled', false);
      element.removeData('ujs:disabled');
    },

   /* For 'data-confirm' attribute:
      - Fires `confirm` event
      - Shows the confirmation dialog
      - Fires the `confirm:complete` event

      Returns `true` if no function stops the chain and user chose yes; `false` otherwise.
      Attaching a handler to the element's `confirm` event that returns a `falsy` value cancels the confirmation dialog.
      Attaching a handler to the element's `confirm:complete` event that returns a `falsy` value makes this function
      return false. The `confirm:complete` event is fired whether or not the user answered true or false to the dialog.
   */
    allowAction: function(element) {
      var message = element.data('confirm'),
          answer = false, callback;
      if (!message) { return true; }

      if (rails.fire(element, 'confirm')) {
        try {
          answer = rails.confirm(message);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
        callback = rails.fire(element, 'confirm:complete', [answer]);
      }
      return answer && callback;
    },

    // Helper function which checks for blank inputs in a form that match the specified CSS selector
    blankInputs: function(form, specifiedSelector, nonBlank) {
      var foundInputs = $(),
        input,
        valueToCheck,
        radiosForNameWithNoneSelected,
        radioName,
        selector = specifiedSelector || 'input,textarea',
        requiredInputs = form.find(selector),
        checkedRadioButtonNames = {};

      requiredInputs.each(function() {
        input = $(this);
        if (input.is('input[type=radio]')) {

          // Don't count unchecked required radio as blank if other radio with same name is checked,
          // regardless of whether same-name radio input has required attribute or not. The spec
          // states https://www.w3.org/TR/html5/forms.html#the-required-attribute
          radioName = input.attr('name');

          // Skip if we've already seen the radio with this name.
          if (!checkedRadioButtonNames[radioName]) {

            // If none checked
            if (form.find('input[type=radio]:checked[name="' + radioName + '"]').length === 0) {
              radiosForNameWithNoneSelected = form.find(
                'input[type=radio][name="' + radioName + '"]');
              foundInputs = foundInputs.add(radiosForNameWithNoneSelected);
            }

            // We only need to check each name once.
            checkedRadioButtonNames[radioName] = radioName;
          }
        } else {
          valueToCheck = input.is('input[type=checkbox],input[type=radio]') ? input.is(':checked') : !!input.val();
          if (valueToCheck === nonBlank) {
            foundInputs = foundInputs.add(input);
          }
        }
      });
      return foundInputs.length ? foundInputs : false;
    },

    // Helper function which checks for non-blank inputs in a form that match the specified CSS selector
    nonBlankInputs: function(form, specifiedSelector) {
      return rails.blankInputs(form, specifiedSelector, true); // true specifies nonBlank
    },

    // Helper function, needed to provide consistent behavior in IE
    stopEverything: function(e) {
      $(e.target).trigger('ujs:everythingStopped');
      e.stopImmediatePropagation();
      return false;
    },

    //  Replace element's html with the 'data-disable-with' after storing original html
    //  and prevent clicking on it
    disableElement: function(element) {
      var replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element.html()); // store enabled state
        element.html(replacement);
      }

      element.bind('click.railsDisable', function(e) { // prevent further clicking
        return rails.stopEverything(e);
      });
      element.data('ujs:disabled', true);
    },

    // Restore element to its original state which was disabled by 'disableElement' above
    enableElement: function(element) {
      if (element.data('ujs:enable-with') !== undefined) {
        element.html(element.data('ujs:enable-with')); // set to old enabled state
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.unbind('click.railsDisable'); // enable element
      element.removeData('ujs:disabled');
    }
  };

  if (rails.fire($document, 'rails:attachBindings')) {

    $.ajaxPrefilter(function(options, originalOptions, xhr){ if ( !options.crossDomain ) { rails.CSRFProtection(xhr); }});

    // This event works the same as the load event, except that it fires every
    // time the page is loaded.
    //
    // See https://github.com/rails/jquery-ujs/issues/357
    // See https://developer.mozilla.org/en-US/docs/Using_Firefox_1.5_caching
    $(window).on('pageshow.rails', function () {
      $($.rails.enableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableFormElement(element);
        }
      });

      $($.rails.linkDisableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableElement(element);
        }
      });
    });

    $document.delegate(rails.linkDisableSelector, 'ajax:complete', function() {
        rails.enableElement($(this));
    });

    $document.delegate(rails.buttonDisableSelector, 'ajax:complete', function() {
        rails.enableFormElement($(this));
    });

    $document.delegate(rails.linkClickSelector, 'click.rails', function(e) {
      var link = $(this), method = link.data('method'), data = link.data('params'), metaClick = e.metaKey || e.ctrlKey;
      if (!rails.allowAction(link)) return rails.stopEverything(e);

      if (!metaClick && link.is(rails.linkDisableSelector)) rails.disableElement(link);

      if (rails.isRemote(link)) {
        if (metaClick && (!method || method === 'GET') && !data) { return true; }

        var handleRemote = rails.handleRemote(link);
        // Response from rails.handleRemote() will either be false or a deferred object promise.
        if (handleRemote === false) {
          rails.enableElement(link);
        } else {
          handleRemote.fail( function() { rails.enableElement(link); } );
        }
        return false;

      } else if (method) {
        rails.handleMethod(link);
        return false;
      }
    });

    $document.delegate(rails.buttonClickSelector, 'click.rails', function(e) {
      var button = $(this);

      if (!rails.allowAction(button) || !rails.isRemote(button)) return rails.stopEverything(e);

      if (button.is(rails.buttonDisableSelector)) rails.disableFormElement(button);

      var handleRemote = rails.handleRemote(button);
      // Response from rails.handleRemote() will either be false or a deferred object promise.
      if (handleRemote === false) {
        rails.enableFormElement(button);
      } else {
        handleRemote.fail( function() { rails.enableFormElement(button); } );
      }
      return false;
    });

    $document.delegate(rails.inputChangeSelector, 'change.rails', function(e) {
      var link = $(this);
      if (!rails.allowAction(link) || !rails.isRemote(link)) return rails.stopEverything(e);

      rails.handleRemote(link);
      return false;
    });

    $document.delegate(rails.formSubmitSelector, 'submit.rails', function(e) {
      var form = $(this),
        remote = rails.isRemote(form),
        blankRequiredInputs,
        nonBlankFileInputs;

      if (!rails.allowAction(form)) return rails.stopEverything(e);

      // Skip other logic when required values are missing or file upload is present
      if (form.attr('novalidate') === undefined) {
        if (form.data('ujs:formnovalidate-button') === undefined) {
          blankRequiredInputs = rails.blankInputs(form, rails.requiredInputSelector, false);
          if (blankRequiredInputs && rails.fire(form, 'ajax:aborted:required', [blankRequiredInputs])) {
            return rails.stopEverything(e);
          }
        } else {
          // Clear the formnovalidate in case the next button click is not on a formnovalidate button
          // Not strictly necessary to do here, since it is also reset on each button click, but just to be certain
          form.data('ujs:formnovalidate-button', undefined);
        }
      }

      if (remote) {
        nonBlankFileInputs = rails.nonBlankInputs(form, rails.fileInputSelector);
        if (nonBlankFileInputs) {
          // Slight timeout so that the submit button gets properly serialized
          // (make it easy for event handler to serialize form without disabled values)
          setTimeout(function(){ rails.disableFormElements(form); }, 13);
          var aborted = rails.fire(form, 'ajax:aborted:file', [nonBlankFileInputs]);

          // Re-enable form elements if event bindings return false (canceling normal form submission)
          if (!aborted) { setTimeout(function(){ rails.enableFormElements(form); }, 13); }

          return aborted;
        }

        rails.handleRemote(form);
        return false;

      } else {
        // Slight timeout so that the submit button gets properly serialized
        setTimeout(function(){ rails.disableFormElements(form); }, 13);
      }
    });

    $document.delegate(rails.formInputClickSelector, 'click.rails', function(event) {
      var button = $(this);

      if (!rails.allowAction(button)) return rails.stopEverything(event);

      // Register the pressed submit button
      var name = button.attr('name'),
        data = name ? {name:name, value:button.val()} : null;

      var form = button.closest('form');
      if (form.length === 0) {
        form = $('#' + button.attr('form'));
      }
      form.data('ujs:submit-button', data);

      // Save attributes from button
      form.data('ujs:formnovalidate-button', button.attr('formnovalidate'));
      form.data('ujs:submit-button-formaction', button.attr('formaction'));
      form.data('ujs:submit-button-formmethod', button.attr('formmethod'));
    });

    $document.delegate(rails.formSubmitSelector, 'ajax:send.rails', function(event) {
      if (this === event.target) rails.disableFormElements($(this));
    });

    $document.delegate(rails.formSubmitSelector, 'ajax:complete.rails', function(event) {
      if (this === event.target) rails.enableFormElements($(this));
    });

    $(function(){
      rails.refreshCSRFTokens();
    });
  }

})( jQuery );


/***/ }),
/* 228 */
/***/ (function(module, exports) {

/*
Copyright 2012 Igor Vaynberg

Version: 3.5.2 Timestamp: Sat Nov  1 14:43:36 EDT 2014

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

    http://www.apache.org/licenses/LICENSE-2.0
    http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the
Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
the specific language governing permissions and limitations under the Apache License and the GPL License.
*/
(function ($) {
    if(typeof $.fn.each2 == "undefined") {
        $.extend($.fn, {
            /*
            * 4-10 times faster .each replacement
            * use it carefully, as it overrides jQuery context of element on each iteration
            */
            each2 : function (c) {
                var j = $([0]), i = -1, l = this.length;
                while (
                    ++i < l
                    && (j.context = j[0] = this[i])
                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
                );
                return this;
            }
        });
    }
})(jQuery);

(function ($, undefined) {
    "use strict";
    /*global document, window, jQuery, console */

    if (window.Select2 !== undefined) {
        return;
    }

    var AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,

    KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
            case KEY.LEFT:
            case KEY.RIGHT:
            case KEY.UP:
            case KEY.DOWN:
                return true;
            }
            return false;
        },
        isControl: function (e) {
            var k = e.which;
            switch (k) {
            case KEY.SHIFT:
            case KEY.CTRL:
            case KEY.ALT:
                return true;
            }

            if (e.metaKey) return true;

            return false;
        },
        isFunctionKey: function (k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        }
    },
    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",

    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038A":"\u0399","\u03AA":"\u0399","\u038C":"\u039F","\u038E":"\u03A5","\u03AB":"\u03A5","\u038F":"\u03A9","\u03AC":"\u03B1","\u03AD":"\u03B5","\u03AE":"\u03B7","\u03AF":"\u03B9","\u03CA":"\u03B9","\u0390":"\u03B9","\u03CC":"\u03BF","\u03CD":"\u03C5","\u03CB":"\u03C5","\u03B0":"\u03C5","\u03C9":"\u03C9","\u03C2":"\u03C3"};

    $document = $(document);

    nextUid=(function() { var counter=1; return function() { return counter++; }; }());


    function reinsertElement(element) {
        var placeholder = $(document.createTextNode(''));

        element.before(placeholder);
        placeholder.before(element);
        placeholder.remove();
    }

    function stripDiacritics(str) {
        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
        function match(a) {
            return DIACRITICS[a] || a;
        }

        return str.replace(/[^\u0000-\u007E]/g, match);
    }

    function indexOf(value, array) {
        var i = 0, l = array.length;
        for (; i < l; i = i + 1) {
            if (equal(value, array[i])) return i;
        }
        return -1;
    }

    function measureScrollbar () {
        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
        $template.appendTo(document.body);

        var dim = {
            width: $template.width() - $template[0].clientWidth,
            height: $template.height() - $template[0].clientHeight
        };
        $template.remove();

        return dim;
    }

    /**
     * Compares equality of a and b
     * @param a
     * @param b
     */
    function equal(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if (a === null || b === null) return false;
        // Check whether 'a' or 'b' is a string (primitive or object).
        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
        return false;
    }

    /**
     * Splits the string into an array of values, transforming each value. An empty array is returned for nulls or empty
     * strings
     * @param string
     * @param separator
     */
    function splitVal(string, separator, transform) {
        var val, i, l;
        if (string === null || string.length < 1) return [];
        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = transform(val[i]);
        return val;
    }

    function getSideBorderPadding(element) {
        return element.outerWidth(false) - element.width();
    }

    function installKeyUpChangeEvent(element) {
        var key="keyup-change-value";
        element.on("keydown", function () {
            if ($.data(element, key) === undefined) {
                $.data(element, key, element.val());
            }
        });
        element.on("keyup", function () {
            var val= $.data(element, key);
            if (val !== undefined && element.val() !== val) {
                $.removeData(element, key);
                element.trigger("keyup-change");
            }
        });
    }


    /**
     * filters mouse events so an event is fired only if the mouse moved.
     *
     * filters out mouse events that occur when mouse is stationary but
     * the elements under the pointer are scrolled.
     */
    function installFilteredMouseMove(element) {
        element.on("mousemove", function (e) {
            var lastpos = lastMousePosition;
            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
                $(e.target).trigger("mousemove-filtered", e);
            }
        });
    }

    /**
     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
     * within the last quietMillis milliseconds.
     *
     * @param quietMillis number of milliseconds to wait before invoking fn
     * @param fn function to be debounced
     * @param ctx object to be used as this reference within fn
     * @return debounced version of fn
     */
    function debounce(quietMillis, fn, ctx) {
        ctx = ctx || undefined;
        var timeout;
        return function () {
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                fn.apply(ctx, args);
            }, quietMillis);
        };
    }

    function installDebouncedScroll(threshold, element) {
        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
        element.on("scroll", function (e) {
            if (indexOf(e.target, element.get()) >= 0) notify(e);
        });
    }

    function focus($el) {
        if ($el[0] === document.activeElement) return;

        /* set the focus in a 0 timeout - that way the focus is set after the processing
            of the current event has finished - which seems like the only reliable way
            to set focus */
        window.setTimeout(function() {
            var el=$el[0], pos=$el.val().length, range;

            $el.focus();

            /* make sure el received focus so we do not error out when trying to manipulate the caret.
                sometimes modals or others listeners may steal it after its set */
            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
            if (isVisible && el === document.activeElement) {

                /* after the focus is set move the caret to the end, necessary when we val()
                    just before setting focus */
                if(el.setSelectionRange)
                {
                    el.setSelectionRange(pos, pos);
                }
                else if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }
        }, 0);
    }

    function getCursorInfo(el) {
        el = $(el)[0];
        var offset = 0;
        var length = 0;
        if ('selectionStart' in el) {
            offset = el.selectionStart;
            length = el.selectionEnd - offset;
        } else if ('selection' in document) {
            el.focus();
            var sel = document.selection.createRange();
            length = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            offset = sel.text.length - length;
        }
        return { offset: offset, length: length };
    }

    function killEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    function killEventImmediately(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    function measureTextWidth(e) {
        if (!sizer){
            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
            sizer = $(document.createElement("div")).css({
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
                display: "none",
                fontSize: style.fontSize,
                fontFamily: style.fontFamily,
                fontStyle: style.fontStyle,
                fontWeight: style.fontWeight,
                letterSpacing: style.letterSpacing,
                textTransform: style.textTransform,
                whiteSpace: "nowrap"
            });
            sizer.attr("class","select2-sizer");
            $(document.body).append(sizer);
        }
        sizer.text(e.val());
        return sizer.width();
    }

    function syncCssClasses(dest, src, adapter) {
        var classes, replacements = [], adapted;

        classes = $.trim(dest.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") === 0) {
                    replacements.push(this);
                }
            });
        }

        classes = $.trim(src.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") !== 0) {
                    adapted = adapter(this);

                    if (adapted) {
                        replacements.push(adapted);
                    }
                }
            });
        }

        dest.attr("class", replacements.join(" "));
    }


    function markMatch(text, term, markup, escapeMarkup) {
        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
            tl=term.length;

        if (match<0) {
            markup.push(escapeMarkup(text));
            return;
        }

        markup.push(escapeMarkup(text.substring(0, match)));
        markup.push("<span class='select2-match'>");
        markup.push(escapeMarkup(text.substring(match, match + tl)));
        markup.push("</span>");
        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
    }

    function defaultEscapeMarkup(markup) {
        var replace_map = {
            '\\': '&#92;',
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#47;'
        };

        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
            return replace_map[match];
        });
    }

    /**
     * Produces an ajax-based query function
     *
     * @param options object containing configuration parameters
     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
     * @param options.url url for the data
     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
     *      The expected format is an object containing the following keys:
     *      results array of objects that will be used as choices
     *      more (optional) boolean indicating whether there are more results available
     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
     */
    function ajax(options) {
        var timeout, // current scheduled but not yet executed request
            handler = null,
            quietMillis = options.quietMillis || 100,
            ajaxUrl = options.url,
            self = this;

        return function (query) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                var data = options.data, // ajax data function
                    url = ajaxUrl, // ajax url string or function
                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
                    // deprecated - to be removed in 4.0  - use params instead
                    deprecated = {
                        type: options.type || 'GET', // set type of request (GET or POST)
                        cache: options.cache || false,
                        jsonpCallback: options.jsonpCallback||undefined,
                        dataType: options.dataType||"json"
                    },
                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

                data = data ? data.call(self, query.term, query.page, query.context) : null;
                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;

                if (handler && typeof handler.abort === "function") { handler.abort(); }

                if (options.params) {
                    if ($.isFunction(options.params)) {
                        $.extend(params, options.params.call(self));
                    } else {
                        $.extend(params, options.params);
                    }
                }

                $.extend(params, {
                    url: url,
                    dataType: options.dataType,
                    data: data,
                    success: function (data) {
                        // TODO - replace query.page with query so users have access to term, page, etc.
                        // added query as third paramter to keep backwards compatibility
                        var results = options.results(data, query.page, query);
                        query.callback(results);
                    },
                    error: function(jqXHR, textStatus, errorThrown){
                        var results = {
                            hasError: true,
                            jqXHR: jqXHR,
                            textStatus: textStatus,
                            errorThrown: errorThrown
                        };

                        query.callback(results);
                    }
                });
                handler = transport.call(self, params);
            }, quietMillis);
        };
    }

    /**
     * Produces a query function that works with a local array
     *
     * @param options object containing configuration parameters. The options parameter can either be an array or an
     * object.
     *
     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
     *
     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
     * the text.
     */
    function local(options) {
        var data = options, // data elements
            dataText,
            tmp,
            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search

         if ($.isArray(data)) {
            tmp = data;
            data = { results: tmp };
        }

         if ($.isFunction(data) === false) {
            tmp = data;
            data = function() { return tmp; };
        }

        var dataItem = data();
        if (dataItem.text) {
            text = dataItem.text;
            // if text is not a function we assume it to be a key name
            if (!$.isFunction(text)) {
                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
                text = function (item) { return item[dataText]; };
            }
        }

        return function (query) {
            var t = query.term, filtered = { results: [] }, process;
            if (t === "") {
                query.callback(data());
                return;
            }

            process = function(datum, collection) {
                var group, attr;
                datum = datum[0];
                if (datum.children) {
                    group = {};
                    for (attr in datum) {
                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
                    }
                    group.children=[];
                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
                    if (group.children.length || query.matcher(t, text(group), datum)) {
                        collection.push(group);
                    }
                } else {
                    if (query.matcher(t, text(datum), datum)) {
                        collection.push(datum);
                    }
                }
            };

            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
            query.callback(filtered);
        };
    }

    // TODO javadoc
    function tags(data) {
        var isFunc = $.isFunction(data);
        return function (query) {
            var t = query.term, filtered = {results: []};
            var result = isFunc ? data(query) : data;
            if ($.isArray(result)) {
                $(result).each(function () {
                    var isObject = this.text !== undefined,
                        text = isObject ? this.text : this;
                    if (t === "" || query.matcher(t, text)) {
                        filtered.results.push(isObject ? this : {id: this, text: this});
                    }
                });
                query.callback(filtered);
            }
        };
    }

    /**
     * Checks if the formatter function should be used.
     *
     * Throws an error if it is not a function. Returns true if it should be used,
     * false if no formatting should be performed.
     *
     * @param formatter
     */
    function checkFormatter(formatter, formatterName) {
        if ($.isFunction(formatter)) return true;
        if (!formatter) return false;
        if (typeof(formatter) === 'string') return true;
        throw new Error(formatterName +" must be a string, function, or falsy value");
    }

  /**
   * Returns a given value
   * If given a function, returns its output
   *
   * @param val string|function
   * @param context value of "this" to be passed to function
   * @returns {*}
   */
    function evaluate(val, context) {
        if ($.isFunction(val)) {
            var args = Array.prototype.slice.call(arguments, 2);
            return val.apply(context, args);
        }
        return val;
    }

    function countResults(results) {
        var count = 0;
        $.each(results, function(i, item) {
            if (item.children) {
                count += countResults(item.children);
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * Default tokenizer. This function uses breaks the input on substring match of any string from the
     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
     * two options have to be defined in order for the tokenizer to work.
     *
     * @param input text user has typed so far or pasted into the search field
     * @param selection currently selected choices
     * @param selectCallback function(choice) callback tho add the choice to selection
     * @param opts select2's opts
     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
     */
    function defaultTokenizer(input, selection, selectCallback, opts) {
        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
            token, // token
            index, // position at which the separator was found
            i, l, // looping variables
            separator; // the matched separator

        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

        while (true) {
            index = -1;

            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
                separator = opts.tokenSeparators[i];
                index = input.indexOf(separator);
                if (index >= 0) break;
            }

            if (index < 0) break; // did not find any token separator in the input string, bail

            token = input.substring(0, index);
            input = input.substring(index + separator.length);

            if (token.length > 0) {
                token = opts.createSearchChoice.call(this, token, selection);
                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
                    dupe = false;
                    for (i = 0, l = selection.length; i < l; i++) {
                        if (equal(opts.id(token), opts.id(selection[i]))) {
                            dupe = true; break;
                        }
                    }

                    if (!dupe) selectCallback(token);
                }
            }
        }

        if (original!==input) return input;
    }

    function cleanupJQueryElements() {
        var self = this;

        $.each(arguments, function (i, element) {
            self[element].remove();
            self[element] = null;
        });
    }

    /**
     * Creates a new class
     *
     * @param superClass
     * @param methods
     */
    function clazz(SuperClass, methods) {
        var constructor = function () {};
        constructor.prototype = new SuperClass;
        constructor.prototype.constructor = constructor;
        constructor.prototype.parent = SuperClass.prototype;
        constructor.prototype = $.extend(constructor.prototype, methods);
        return constructor;
    }

    AbstractSelect2 = clazz(Object, {

        // abstract
        bind: function (func) {
            var self = this;
            return function () {
                func.apply(self, arguments);
            };
        },

        // abstract
        init: function (opts) {
            var results, search, resultsSelector = ".select2-results";

            // prepare options
            this.opts = opts = this.prepareOpts(opts);

            this.id=opts.id;

            // destroy if called on an existing component
            if (opts.element.data("select2") !== undefined &&
                opts.element.data("select2") !== null) {
                opts.element.data("select2").destroy();
            }

            this.container = this.createContainer();

            this.liveRegion = $('.select2-hidden-accessible');
            if (this.liveRegion.length == 0) {
                this.liveRegion = $("<span>", {
                        role: "status",
                        "aria-live": "polite"
                    })
                    .addClass("select2-hidden-accessible")
                    .appendTo(document.body);
            }

            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
            this.containerEventName= this.containerId
                .replace(/([.])/g, '_')
                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
            this.container.attr("id", this.containerId);

            this.container.attr("title", opts.element.attr("title"));

            this.body = $(document.body);

            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

            this.container.attr("style", opts.element.attr("style"));
            this.container.css(evaluate(opts.containerCss, this.opts.element));
            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));

            this.elementTabIndex = this.opts.element.attr("tabindex");

            // swap container for the element
            this.opts.element
                .data("select2", this)
                .attr("tabindex", "-1")
                .before(this.container)
                .on("click.select2", killEvent); // do not leak click events

            this.container.data("select2", this);

            this.dropdown = this.container.find(".select2-drop");

            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);

            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
            this.dropdown.data("select2", this);
            this.dropdown.on("click", killEvent);

            this.results = results = this.container.find(resultsSelector);
            this.search = search = this.container.find("input.select2-input");

            this.queryCount = 0;
            this.resultsPage = 0;
            this.context = null;

            // initialize the container
            this.initContainer();

            this.container.on("click", killEvent);

            installFilteredMouseMove(this.results);

            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
                this._touchEvent = true;
                this.highlightUnderEvent(event);
            }));
            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));

            // Waiting for a click event on touch devices to select option and hide dropdown
            // otherwise click will be triggered on an underlying element
            this.dropdown.on('click', this.bind(function (event) {
                if (this._touchEvent) {
                    this._touchEvent = false;
                    this.selectHighlighted();
                }
            }));

            installDebouncedScroll(80, this.results);
            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

            // do not propagate change event from the search field out of the component
            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});

            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
            if ($.fn.mousewheel) {
                results.mousewheel(function (e, delta, deltaX, deltaY) {
                    var top = results.scrollTop();
                    if (deltaY > 0 && top - deltaY <= 0) {
                        results.scrollTop(0);
                        killEvent(e);
                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
                        results.scrollTop(results.get(0).scrollHeight - results.height());
                        killEvent(e);
                    }
                });
            }

            installKeyUpChangeEvent(search);
            search.on("keyup-change input paste", this.bind(this.updateResults));
            search.on("focus", function () { search.addClass("select2-focused"); });
            search.on("blur", function () { search.removeClass("select2-focused");});

            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
                if ($(e.target).closest(".select2-result-selectable").length > 0) {
                    this.highlightUnderEvent(e);
                    this.selectHighlighted(e);
                }
            }));

            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
            // dom it will trigger the popup close, which is not what we want
            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });

            this.nextSearchTerm = undefined;

            if ($.isFunction(this.opts.initSelection)) {
                // initialize selection based on the current value of the source element
                this.initSelection();

                // if the user has provided a function that can set selection based on the value of the source element
                // we monitor the change event on the element and trigger it, allowing for two way synchronization
                this.monitorSource();
            }

            if (opts.maximumInputLength !== null) {
                this.search.attr("maxlength", opts.maximumInputLength);
            }

            var disabled = opts.element.prop("disabled");
            if (disabled === undefined) disabled = false;
            this.enable(!disabled);

            var readonly = opts.element.prop("readonly");
            if (readonly === undefined) readonly = false;
            this.readonly(readonly);

            // Calculate size of scrollbar
            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

            this.autofocus = opts.element.prop("autofocus");
            opts.element.prop("autofocus", false);
            if (this.autofocus) this.focus();

            this.search.attr("placeholder", opts.searchInputPlaceholder);
        },

        // abstract
        destroy: function () {
            var element=this.opts.element, select2 = element.data("select2"), self = this;

            this.close();

            if (element.length && element[0].detachEvent && self._sync) {
                element.each(function () {
                    if (self._sync) {
                        this.detachEvent("onpropertychange", self._sync);
                    }
                });
            }
            if (this.propertyObserver) {
                this.propertyObserver.disconnect();
                this.propertyObserver = null;
            }
            this._sync = null;

            if (select2 !== undefined) {
                select2.container.remove();
                select2.liveRegion.remove();
                select2.dropdown.remove();
                element
                    .show()
                    .removeData("select2")
                    .off(".select2")
                    .prop("autofocus", this.autofocus || false);
                if (this.elementTabIndex) {
                    element.attr({tabindex: this.elementTabIndex});
                } else {
                    element.removeAttr("tabindex");
                }
                element.show();
            }

            cleanupJQueryElements.call(this,
                "container",
                "liveRegion",
                "dropdown",
                "results",
                "search"
            );
        },

        // abstract
        optionToData: function(element) {
            if (element.is("option")) {
                return {
                    id:element.prop("value"),
                    text:element.text(),
                    element: element.get(),
                    css: element.attr("class"),
                    disabled: element.prop("disabled"),
                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
                };
            } else if (element.is("optgroup")) {
                return {
                    text:element.attr("label"),
                    children:[],
                    element: element.get(),
                    css: element.attr("class")
                };
            }
        },

        // abstract
        prepareOpts: function (opts) {
            var element, select, idKey, ajaxUrl, self = this;

            element = opts.element;

            if (element.get(0).tagName.toLowerCase() === "select") {
                this.select = select = opts.element;
            }

            if (select) {
                // these options are not allowed when attached to a select because they are picked up off the element itself
                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
                    if (this in opts) {
                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
                    }
                });
            }

            opts = $.extend({}, {
                populateResults: function(container, results, query) {
                    var populate, id=this.opts.id, liveRegion=this.liveRegion;

                    populate=function(results, container, depth) {

                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

                        results = opts.sortResults(results, container, query);

                        // collect the created nodes for bulk append
                        var nodes = [];
                        for (i = 0, l = results.length; i < l; i = i + 1) {

                            result=results[i];

                            disabled = (result.disabled === true);
                            selectable = (!disabled) && (id(result) !== undefined);

                            compound=result.children && result.children.length > 0;

                            node=$("<li></li>");
                            node.addClass("select2-results-dept-"+depth);
                            node.addClass("select2-result");
                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
                            if (disabled) { node.addClass("select2-disabled"); }
                            if (compound) { node.addClass("select2-result-with-children"); }
                            node.addClass(self.opts.formatResultCssClass(result));
                            node.attr("role", "presentation");

                            label=$(document.createElement("div"));
                            label.addClass("select2-result-label");
                            label.attr("id", "select2-result-label-" + nextUid());
                            label.attr("role", "option");

                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
                            if (formatted!==undefined) {
                                label.html(formatted);
                                node.append(label);
                            }


                            if (compound) {

                                innerContainer=$("<ul></ul>");
                                innerContainer.addClass("select2-result-sub");
                                populate(result.children, innerContainer, depth+1);
                                node.append(innerContainer);
                            }

                            node.data("select2-data", result);
                            nodes.push(node[0]);
                        }

                        // bulk append the created nodes
                        container.append(nodes);
                        liveRegion.text(opts.formatMatches(results.length));
                    };

                    populate(results, container, 0);
                }
            }, $.fn.select2.defaults, opts);

            if (typeof(opts.id) !== "function") {
                idKey = opts.id;
                opts.id = function (e) { return e[idKey]; };
            }

            if ($.isArray(opts.element.data("select2Tags"))) {
                if ("tags" in opts) {
                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
                }
                opts.tags=opts.element.data("select2Tags");
            }

            if (select) {
                opts.query = this.bind(function (query) {
                    var data = { results: [], more: false },
                        term = query.term,
                        children, placeholderOption, process;

                    process=function(element, collection) {
                        var group;
                        if (element.is("option")) {
                            if (query.matcher(term, element.text(), element)) {
                                collection.push(self.optionToData(element));
                            }
                        } else if (element.is("optgroup")) {
                            group=self.optionToData(element);
                            element.children().each2(function(i, elm) { process(elm, group.children); });
                            if (group.children.length>0) {
                                collection.push(group);
                            }
                        }
                    };

                    children=element.children();

                    // ignore the placeholder option if there is one
                    if (this.getPlaceholder() !== undefined && children.length > 0) {
                        placeholderOption = this.getPlaceholderOption();
                        if (placeholderOption) {
                            children=children.not(placeholderOption);
                        }
                    }

                    children.each2(function(i, elm) { process(elm, data.results); });

                    query.callback(data);
                });
                // this is needed because inside val() we construct choices from options and their id is hardcoded
                opts.id=function(e) { return e.id; };
            } else {
                if (!("query" in opts)) {

                    if ("ajax" in opts) {
                        ajaxUrl = opts.element.data("ajax-url");
                        if (ajaxUrl && ajaxUrl.length > 0) {
                            opts.ajax.url = ajaxUrl;
                        }
                        opts.query = ajax.call(opts.element, opts.ajax);
                    } else if ("data" in opts) {
                        opts.query = local(opts.data);
                    } else if ("tags" in opts) {
                        opts.query = tags(opts.tags);
                        if (opts.createSearchChoice === undefined) {
                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
                        }
                        if (opts.initSelection === undefined) {
                            opts.initSelection = function (element, callback) {
                                var data = [];
                                $(splitVal(element.val(), opts.separator, opts.transformVal)).each(function () {
                                    var obj = { id: this, text: this },
                                        tags = opts.tags;
                                    if ($.isFunction(tags)) tags=tags();
                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
                                    data.push(obj);
                                });

                                callback(data);
                            };
                        }
                    }
                }
            }
            if (typeof(opts.query) !== "function") {
                throw "query function not defined for Select2 " + opts.element.attr("id");
            }

            if (opts.createSearchChoicePosition === 'top') {
                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
            }
            else if (opts.createSearchChoicePosition === 'bottom') {
                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
            }
            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
            }

            return opts;
        },

        /**
         * Monitor the original element for changes and update select2 accordingly
         */
        // abstract
        monitorSource: function () {
            var el = this.opts.element, observer, self = this;

            el.on("change.select2", this.bind(function (e) {
                if (this.opts.element.data("select2-change-triggered") !== true) {
                    this.initSelection();
                }
            }));

            this._sync = this.bind(function () {

                // sync enabled state
                var disabled = el.prop("disabled");
                if (disabled === undefined) disabled = false;
                this.enable(!disabled);

                var readonly = el.prop("readonly");
                if (readonly === undefined) readonly = false;
                this.readonly(readonly);

                if (this.container) {
                    syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
                    this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));
                }

                if (this.dropdown) {
                    syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
                    this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));
                }

            });

            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
            if (el.length && el[0].attachEvent) {
                el.each(function() {
                    this.attachEvent("onpropertychange", self._sync);
                });
            }

            // safari, chrome, firefox, IE11
            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
            if (observer !== undefined) {
                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
                this.propertyObserver = new observer(function (mutations) {
                    $.each(mutations, self._sync);
                });
                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
            }
        },

        // abstract
        triggerSelect: function(data) {
            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
            this.opts.element.trigger(evt);
            return !evt.isDefaultPrevented();
        },

        /**
         * Triggers the change event on the source element
         */
        // abstract
        triggerChange: function (details) {

            details = details || {};
            details= $.extend({}, details, { type: "change", val: this.val() });
            // prevents recursive triggering
            this.opts.element.data("select2-change-triggered", true);
            this.opts.element.trigger(details);
            this.opts.element.data("select2-change-triggered", false);

            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
            // so here we trigger the click event manually
            this.opts.element.click();

            // ValidationEngine ignores the change event and listens instead to blur
            // so here we trigger the blur event manually if so desired
            if (this.opts.blurOnChange)
                this.opts.element.blur();
        },

        //abstract
        isInterfaceEnabled: function()
        {
            return this.enabledInterface === true;
        },

        // abstract
        enableInterface: function() {
            var enabled = this._enabled && !this._readonly,
                disabled = !enabled;

            if (enabled === this.enabledInterface) return false;

            this.container.toggleClass("select2-container-disabled", disabled);
            this.close();
            this.enabledInterface = enabled;

            return true;
        },

        // abstract
        enable: function(enabled) {
            if (enabled === undefined) enabled = true;
            if (this._enabled === enabled) return;
            this._enabled = enabled;

            this.opts.element.prop("disabled", !enabled);
            this.enableInterface();
        },

        // abstract
        disable: function() {
            this.enable(false);
        },

        // abstract
        readonly: function(enabled) {
            if (enabled === undefined) enabled = false;
            if (this._readonly === enabled) return;
            this._readonly = enabled;

            this.opts.element.prop("readonly", enabled);
            this.enableInterface();
        },

        // abstract
        opened: function () {
            return (this.container) ? this.container.hasClass("select2-dropdown-open") : false;
        },

        // abstract
        positionDropdown: function() {
            var $dropdown = this.dropdown,
                container = this.container,
                offset = container.offset(),
                height = container.outerHeight(false),
                width = container.outerWidth(false),
                dropHeight = $dropdown.outerHeight(false),
                $window = $(window),
                windowWidth = $window.width(),
                windowHeight = $window.height(),
                viewPortRight = $window.scrollLeft() + windowWidth,
                viewportBottom = $window.scrollTop() + windowHeight,
                dropTop = offset.top + height,
                dropLeft = offset.left,
                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
                dropWidth = $dropdown.outerWidth(false),
                enoughRoomOnRight = function() {
                    return dropLeft + dropWidth <= viewPortRight;
                },
                enoughRoomOnLeft = function() {
                    return offset.left + viewPortRight + container.outerWidth(false)  > dropWidth;
                },
                aboveNow = $dropdown.hasClass("select2-drop-above"),
                bodyOffset,
                above,
                changeDirection,
                css,
                resultsListNode;

            // always prefer the current above/below alignment, unless there is not enough room
            if (aboveNow) {
                above = true;
                if (!enoughRoomAbove && enoughRoomBelow) {
                    changeDirection = true;
                    above = false;
                }
            } else {
                above = false;
                if (!enoughRoomBelow && enoughRoomAbove) {
                    changeDirection = true;
                    above = true;
                }
            }

            //if we are changing direction we need to get positions when dropdown is hidden;
            if (changeDirection) {
                $dropdown.hide();
                offset = this.container.offset();
                height = this.container.outerHeight(false);
                width = this.container.outerWidth(false);
                dropHeight = $dropdown.outerHeight(false);
                viewPortRight = $window.scrollLeft() + windowWidth;
                viewportBottom = $window.scrollTop() + windowHeight;
                dropTop = offset.top + height;
                dropLeft = offset.left;
                dropWidth = $dropdown.outerWidth(false);
                $dropdown.show();

                // fix so the cursor does not move to the left within the search-textbox in IE
                this.focusSearch();
            }

            if (this.opts.dropdownAutoWidth) {
                resultsListNode = $('.select2-results', $dropdown)[0];
                $dropdown.addClass('select2-drop-auto-width');
                $dropdown.css('width', '');
                // Add scrollbar width to dropdown if vertical scrollbar is present
                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
                dropWidth > width ? width = dropWidth : dropWidth = width;
                dropHeight = $dropdown.outerHeight(false);
            }
            else {
                this.container.removeClass('select2-drop-auto-width');
            }

            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);

            // fix positioning when body has an offset and is not position: static
            if (this.body.css('position') !== 'static') {
                bodyOffset = this.body.offset();
                dropTop -= bodyOffset.top;
                dropLeft -= bodyOffset.left;
            }

            if (!enoughRoomOnRight() && enoughRoomOnLeft()) {
                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
            }

            css =  {
                left: dropLeft,
                width: width
            };

            if (above) {
                css.top = offset.top - dropHeight;
                css.bottom = 'auto';
                this.container.addClass("select2-drop-above");
                $dropdown.addClass("select2-drop-above");
            }
            else {
                css.top = dropTop;
                css.bottom = 'auto';
                this.container.removeClass("select2-drop-above");
                $dropdown.removeClass("select2-drop-above");
            }
            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));

            $dropdown.css(css);
        },

        // abstract
        shouldOpen: function() {
            var event;

            if (this.opened()) return false;

            if (this._enabled === false || this._readonly === true) return false;

            event = $.Event("select2-opening");
            this.opts.element.trigger(event);
            return !event.isDefaultPrevented();
        },

        // abstract
        clearDropdownAlignmentPreference: function() {
            // clear the classes used to figure out the preference of where the dropdown should be opened
            this.container.removeClass("select2-drop-above");
            this.dropdown.removeClass("select2-drop-above");
        },

        /**
         * Opens the dropdown
         *
         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
         */
        // abstract
        open: function () {

            if (!this.shouldOpen()) return false;

            this.opening();

            // Only bind the document mousemove when the dropdown is visible
            $document.on("mousemove.select2Event", function (e) {
                lastMousePosition.x = e.pageX;
                lastMousePosition.y = e.pageY;
            });

            return true;
        },

        /**
         * Performs the opening of the dropdown
         */
        // abstract
        opening: function() {
            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid,
                mask;

            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

            this.clearDropdownAlignmentPreference();

            if(this.dropdown[0] !== this.body.children().last()[0]) {
                this.dropdown.detach().appendTo(this.body);
            }

            // create the dropdown mask if doesn't already exist
            mask = $("#select2-drop-mask");
            if (mask.length === 0) {
                mask = $(document.createElement("div"));
                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
                mask.hide();
                mask.appendTo(this.body);
                mask.on("mousedown touchstart click", function (e) {
                    // Prevent IE from generating a click event on the body
                    reinsertElement(mask);

                    var dropdown = $("#select2-drop"), self;
                    if (dropdown.length > 0) {
                        self=dropdown.data("select2");
                        if (self.opts.selectOnBlur) {
                            self.selectHighlighted({noFocus: true});
                        }
                        self.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }

            // ensure the mask is always right before the dropdown
            if (this.dropdown.prev()[0] !== mask[0]) {
                this.dropdown.before(mask);
            }

            // move the global id to the correct dropdown
            $("#select2-drop").removeAttr("id");
            this.dropdown.attr("id", "select2-drop");

            // show the elements
            mask.show();

            this.positionDropdown();
            this.dropdown.show();
            this.positionDropdown();

            this.dropdown.addClass("select2-drop-active");

            // attach listeners to events that can change the position of the container and thus require
            // the position of the dropdown to be updated as well so it does not come unglued from the container
            var that = this;
            this.container.parents().add(window).each(function () {
                $(this).on(resize+" "+scroll+" "+orient, function (e) {
                    if (that.opened()) that.positionDropdown();
                });
            });


        },

        // abstract
        close: function () {
            if (!this.opened()) return;

            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid;

            // unbind event listeners
            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });

            this.clearDropdownAlignmentPreference();

            $("#select2-drop-mask").hide();
            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
            this.dropdown.hide();
            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
            this.results.empty();

            // Now that the dropdown is closed, unbind the global document mousemove event
            $document.off("mousemove.select2Event");

            this.clearSearch();
            this.search.removeClass("select2-active");
            this.opts.element.trigger($.Event("select2-close"));
        },

        /**
         * Opens control, sets input value, and updates results.
         */
        // abstract
        externalSearch: function (term) {
            this.open();
            this.search.val(term);
            this.updateResults(false);
        },

        // abstract
        clearSearch: function () {

        },

        //abstract
        getMaximumSelectionSize: function() {
            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
        },

        // abstract
        ensureHighlightVisible: function () {
            var results = this.results, children, index, child, hb, rb, y, more, topOffset;

            index = this.highlight();

            if (index < 0) return;

            if (index == 0) {

                // if the first element is highlighted scroll all the way to the top,
                // that way any unselectable headers above it will also be scrolled
                // into view

                results.scrollTop(0);
                return;
            }

            children = this.findHighlightableChoices().find('.select2-result-label');

            child = $(children[index]);

            topOffset = (child.offset() || {}).top || 0;

            hb = topOffset + child.outerHeight(true);

            // if this is the last child lets also make sure select2-more-results is visible
            if (index === children.length - 1) {
                more = results.find("li.select2-more-results");
                if (more.length > 0) {
                    hb = more.offset().top + more.outerHeight(true);
                }
            }

            rb = results.offset().top + results.outerHeight(false);
            if (hb > rb) {
                results.scrollTop(results.scrollTop() + (hb - rb));
            }
            y = topOffset - results.offset().top;

            // make sure the top of the element is visible
            if (y < 0 && child.css('display') != 'none' ) {
                results.scrollTop(results.scrollTop() + y); // y is negative
            }
        },

        // abstract
        findHighlightableChoices: function() {
            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
        },

        // abstract
        moveHighlight: function (delta) {
            var choices = this.findHighlightableChoices(),
                index = this.highlight();

            while (index > -1 && index < choices.length) {
                index += delta;
                var choice = $(choices[index]);
                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
                    this.highlight(index);
                    break;
                }
            }
        },

        // abstract
        highlight: function (index) {
            var choices = this.findHighlightableChoices(),
                choice,
                data;

            if (arguments.length === 0) {
                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
            }

            if (index >= choices.length) index = choices.length - 1;
            if (index < 0) index = 0;

            this.removeHighlight();

            choice = $(choices[index]);
            choice.addClass("select2-highlighted");

            // ensure assistive technology can determine the active choice
            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));

            this.ensureHighlightVisible();

            this.liveRegion.text(choice.text());

            data = choice.data("select2-data");
            if (data) {
                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
            }
        },

        removeHighlight: function() {
            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
        },

        touchMoved: function() {
            this._touchMoved = true;
        },

        clearTouchMoved: function() {
          this._touchMoved = false;
        },

        // abstract
        countSelectableResults: function() {
            return this.findHighlightableChoices().length;
        },

        // abstract
        highlightUnderEvent: function (event) {
            var el = $(event.target).closest(".select2-result-selectable");
            if (el.length > 0 && !el.is(".select2-highlighted")) {
                var choices = this.findHighlightableChoices();
                this.highlight(choices.index(el));
            } else if (el.length == 0) {
                // if we are over an unselectable item remove all highlights
                this.removeHighlight();
            }
        },

        // abstract
        loadMoreIfNeeded: function () {
            var results = this.results,
                more = results.find("li.select2-more-results"),
                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
                page = this.resultsPage + 1,
                self=this,
                term=this.search.val(),
                context=this.context;

            if (more.length === 0) return;
            below = more.offset().top - results.offset().top - results.height();

            if (below <= this.opts.loadMorePadding) {
                more.addClass("select2-active");
                this.opts.query({
                        element: this.opts.element,
                        term: term,
                        page: page,
                        context: context,
                        matcher: this.opts.matcher,
                        callback: this.bind(function (data) {

                    // ignore a response if the select2 has been closed before it was received
                    if (!self.opened()) return;


                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
                    self.postprocessResults(data, false, false);

                    if (data.more===true) {
                        more.detach().appendTo(results).html(self.opts.escapeMarkup(evaluate(self.opts.formatLoadMore, self.opts.element, page+1)));
                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                    } else {
                        more.remove();
                    }
                    self.positionDropdown();
                    self.resultsPage = page;
                    self.context = data.context;
                    this.opts.element.trigger({ type: "select2-loaded", items: data });
                })});
            }
        },

        /**
         * Default tokenizer function which does nothing
         */
        tokenize: function() {

        },

        /**
         * @param initial whether or not this is the call to this method right after the dropdown has been opened
         */
        // abstract
        updateResults: function (initial) {
            var search = this.search,
                results = this.results,
                opts = this.opts,
                data,
                self = this,
                input,
                term = search.val(),
                lastTerm = $.data(this.container, "select2-last-term"),
                // sequence number used to drop out-of-order responses
                queryNumber;

            // prevent duplicate queries against the same term
            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

            $.data(this.container, "select2-last-term", term);

            // if the search is currently hidden we do not alter the results
            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
                return;
            }

            function postRender() {
                search.removeClass("select2-active");
                self.positionDropdown();
                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
                    self.liveRegion.text(results.text());
                }
                else {
                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable:not(".select2-selected")').length));
                }
            }

            function render(html) {
                results.html(html);
                postRender();
            }

            queryNumber = ++this.queryCount;

            var maxSelSize = this.getMaximumSelectionSize();
            if (maxSelSize >=1) {
                data = this.data();
                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
                    return;
                }
            }

            if (search.val().length < opts.minimumInputLength) {
                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
                } else {
                    render("");
                }
                if (initial && this.showSearch) this.showSearch(true);
                return;
            }

            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
                } else {
                    render("");
                }
                return;
            }

            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
            }

            search.addClass("select2-active");

            this.removeHighlight();

            // give the tokenizer a chance to pre-process the input
            input = this.tokenize();
            if (input != undefined && input != null) {
                search.val(input);
            }

            this.resultsPage = 1;

            opts.query({
                element: opts.element,
                    term: search.val(),
                    page: this.resultsPage,
                    context: null,
                    matcher: opts.matcher,
                    callback: this.bind(function (data) {
                var def; // default choice

                // ignore old responses
                if (queryNumber != this.queryCount) {
                  return;
                }

                // ignore a response if the select2 has been closed before it was received
                if (!this.opened()) {
                    this.search.removeClass("select2-active");
                    return;
                }

                // handle ajax error
                if(data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
                    render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
                    return;
                }

                // save context, if any
                this.context = (data.context===undefined) ? null : data.context;
                // create a default choice and prepend it to the list
                if (this.opts.createSearchChoice && search.val() !== "") {
                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
                        if ($(data.results).filter(
                            function () {
                                return equal(self.id(this), self.id(def));
                            }).length === 0) {
                            this.opts.createSearchChoicePosition(data.results, def);
                        }
                    }
                }

                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
                    return;
                }

                results.empty();
                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});

                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
                    results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                }

                this.postprocessResults(data, initial);

                postRender();

                this.opts.element.trigger({ type: "select2-loaded", items: data });
            })});
        },

        // abstract
        cancel: function () {
            this.close();
        },

        // abstract
        blur: function () {
            // if selectOnBlur == true, select the currently highlighted option
            if (this.opts.selectOnBlur)
                this.selectHighlighted({noFocus: true});

            this.close();
            this.container.removeClass("select2-container-active");
            // synonymous to .is(':focus'), which is available in jquery >= 1.6
            if (this.search[0] === document.activeElement) { this.search.blur(); }
            this.clearSearch();
            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
        },

        // abstract
        focusSearch: function () {
            focus(this.search);
        },

        // abstract
        selectHighlighted: function (options) {
            if (this._touchMoved) {
              this.clearTouchMoved();
              return;
            }
            var index=this.highlight(),
                highlighted=this.results.find(".select2-highlighted"),
                data = highlighted.closest('.select2-result').data("select2-data");

            if (data) {
                this.highlight(index);
                this.onSelect(data, options);
            } else if (options && options.noFocus) {
                this.close();
            }
        },

        // abstract
        getPlaceholder: function () {
            var placeholderOption;
            return this.opts.element.attr("placeholder") ||
                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
                this.opts.element.data("placeholder") ||
                this.opts.placeholder ||
                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
        },

        // abstract
        getPlaceholderOption: function() {
            if (this.select) {
                var firstOption = this.select.children('option').first();
                if (this.opts.placeholderOption !== undefined ) {
                    //Determine the placeholder option based on the specified placeholderOption setting
                    return (this.opts.placeholderOption === "first" && firstOption) ||
                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
                    //No explicit placeholder option specified, use the first if it's blank
                    return firstOption;
                }
            }
        },

        /**
         * Get the desired width for the container element.  This is
         * derived first from option `width` passed to select2, then
         * the inline 'style' on the original element, and finally
         * falls back to the jQuery calculated element width.
         */
        // abstract
        initContainerWidth: function () {
            function resolveContainerWidth() {
                var style, attrs, matches, i, l, attr;

                if (this.opts.width === "off") {
                    return null;
                } else if (this.opts.width === "element"){
                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
                    // check if there is inline style on the element that contains width
                    style = this.opts.element.attr('style');
                    if (style !== undefined) {
                        attrs = style.split(';');
                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
                            attr = attrs[i].replace(/\s/g, '');
                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (matches !== null && matches.length >= 1)
                                return matches[1];
                        }
                    }

                    if (this.opts.width === "resolve") {
                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
                        // when attached to input type=hidden or elements hidden via css
                        style = this.opts.element.css('width');
                        if (style.indexOf("%") > 0) return style;

                        // finally, fallback on the calculated width of the element
                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
                    }

                    return null;
                } else if ($.isFunction(this.opts.width)) {
                    return this.opts.width();
                } else {
                    return this.opts.width;
               }
            };

            var width = resolveContainerWidth.call(this);
            if (width !== null) {
                this.container.css("width", width);
            }
        }
    });

    SingleSelect2 = clazz(AbstractSelect2, {

        // single

        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container"
            }).html([
                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
                "</a>",
                "<label for='' class='select2-offscreen'></label>",
                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
                "<div class='select2-drop select2-display-none'>",
                "   <div class='select2-search'>",
                "       <label for='' class='select2-offscreen'></label>",
                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
                "       aria-autocomplete='list' />",
                "   </div>",
                "   <ul class='select2-results' role='listbox'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // single
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.focusser.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // single
        opening: function () {
            var el, range, len;

            if (this.opts.minimumResultsForSearch >= 0) {
                this.showSearch(true);
            }

            this.parent.opening.apply(this, arguments);

            if (this.showSearchInput !== false) {
                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
                // all other browsers handle this just fine

                this.search.val(this.focusser.val());
            }
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
                // move the cursor to the end after focussing, otherwise it will be at the beginning and
                // new text will appear *before* focusser.val()
                el = this.search.get(0);
                if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                } else if (el.setSelectionRange) {
                    len = this.search.val().length;
                    el.setSelectionRange(len, len);
                }
            }

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.focusser.prop("disabled", true).val("");
            this.updateResults(true);
            this.opts.element.trigger($.Event("select2-open"));
        },

        // single
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);

            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        focus: function () {
            if (this.opened()) {
                this.close();
            } else {
                this.focusser.prop("disabled", false);
                if (this.opts.shouldFocusInput(this)) {
                    this.focusser.focus();
                }
            }
        },

        // single
        isFocused: function () {
            return this.container.hasClass("select2-container-active");
        },

        // single
        cancel: function () {
            this.parent.cancel.apply(this, arguments);
            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        destroy: function() {
            $("label[for='" + this.focusser.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "selection",
                "focusser"
            );
        },

        // single
        initContainer: function () {

            var selection,
                container = this.container,
                dropdown = this.dropdown,
                idSuffix = nextUid(),
                elementLabel;

            if (this.opts.minimumResultsForSearch < 0) {
                this.showSearch(false);
            } else {
                this.showSearch(true);
            }

            this.selection = selection = container.find(".select2-choice");

            this.focusser = container.find(".select2-focusser");

            // add aria associations
            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
            this.results.attr("id", "select2-results-"+idSuffix);
            this.search.attr("aria-owns", "select2-results-"+idSuffix);

            // rewrite labels from original element to focusser
            this.focusser.attr("id", "s2id_autogen"+idSuffix);

            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.focusser.prev()
                .text(elementLabel.text())
                .attr('for', this.focusser.attr('id'));

            // Ensure the original element retains an accessible name
            var originalTitle = this.opts.element.attr("title");
            this.opts.element.attr("title", (originalTitle || elementLabel.text()));

            this.focusser.attr("tabindex", this.elementTabIndex);

            // write label for search field using the label from the focusser element
            this.search.attr("id", this.focusser.attr('id') + '_search');

            this.search.prev()
                .text($("label[for='" + this.focusser.attr('id') + "']").text())
                .attr('for', this.search.attr('id'));

            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                // filter 229 keyCodes (input method editor is processing key input)
                if (229 == e.keyCode) return;

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                    return;
                }

                switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus: true});
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                }
            }));

            this.search.on("blur", this.bind(function(e) {
                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
                // without this the search field loses focus which is annoying
                if (document.activeElement === this.body.get(0)) {
                    window.setTimeout(this.bind(function() {
                        if (this.opened()) {
                            this.search.focus();
                        }
                    }), 0);
                }
            }));

            this.focusser.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
                    return;
                }

                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DOWN || e.which == KEY.UP
                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {

                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

                    this.open();
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
                    if (this.opts.allowClear) {
                        this.clear();
                    }
                    killEvent(e);
                    return;
                }
            }));


            installKeyUpChangeEvent(this.focusser);
            this.focusser.on("keyup-change input", this.bind(function(e) {
                if (this.opts.minimumResultsForSearch >= 0) {
                    e.stopPropagation();
                    if (this.opened()) return;
                    this.open();
                }
            }));

            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) {
                    return;
                }

                this.clear();
                killEventImmediately(e);
                this.close();

                if (this.selection) {
                    this.selection.focus();
                }
            }));

            selection.on("mousedown touchstart", this.bind(function (e) {
                // Prevent IE from generating a click event on the body
                reinsertElement(selection);

                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }

                if (this.opened()) {
                    this.close();
                } else if (this.isInterfaceEnabled()) {
                    this.open();
                }

                killEvent(e);
            }));

            dropdown.on("mousedown touchstart", this.bind(function() {
                if (this.opts.shouldFocusInput(this)) {
                    this.search.focus();
                }
            }));

            selection.on("focus", this.bind(function(e) {
                killEvent(e);
            }));

            this.focusser.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            })).on("blur", this.bind(function() {
                if (!this.opened()) {
                    this.container.removeClass("select2-container-active");
                    this.opts.element.trigger($.Event("select2-blur"));
                }
            }));
            this.search.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            }));

            this.initContainerWidth();
            this.opts.element.hide();
            this.setPlaceholder();

        },

        // single
        clear: function(triggerChange) {
            var data=this.selection.data("select2-data");
            if (data) { // guard against queued quick consecutive clicks
                var evt = $.Event("select2-clearing");
                this.opts.element.trigger(evt);
                if (evt.isDefaultPrevented()) {
                    return;
                }
                var placeholderOption = this.getPlaceholderOption();
                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
                this.selection.find(".select2-chosen").empty();
                this.selection.removeData("select2-data");
                this.setPlaceholder();

                if (triggerChange !== false){
                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
                    this.triggerChange({removed:data});
                }
            }
        },

        /**
         * Sets selection based on source element's value
         */
        // single
        initSelection: function () {
            var selected;
            if (this.isPlaceholderOptionSelected()) {
                this.updateSelection(null);
                this.close();
                this.setPlaceholder();
            } else {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(selected){
                    if (selected !== undefined && selected !== null) {
                        self.updateSelection(selected);
                        self.close();
                        self.setPlaceholder();
                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
                    }
                });
            }
        },

        isPlaceholderOptionSelected: function() {
            var placeholderOption;
            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
                || (this.opts.element.val() === "")
                || (this.opts.element.val() === undefined)
                || (this.opts.element.val() === null);
        },

        // single
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {
                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
                    // a single select box always has a value, no need to null check 'selected'
                    callback(self.optionToData(selected));
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var id = element.val();
                    //search in data by id, storing the actual matching item
                    var match = null;
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = equal(id, opts.id(el));
                            if (is_match) {
                                match = el;
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            callback(match);
                        }
                    });
                };
            }

            return opts;
        },

        // single
        getPlaceholder: function() {
            // if a placeholder is specified on a single select without a valid placeholder option ignore it
            if (this.select) {
                if (this.getPlaceholderOption() === undefined) {
                    return undefined;
                }
            }

            return this.parent.getPlaceholder.apply(this, arguments);
        },

        // single
        setPlaceholder: function () {
            var placeholder = this.getPlaceholder();

            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

                // check for a placeholder option if attached to a select
                if (this.select && this.getPlaceholderOption() === undefined) return;

                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));

                this.selection.addClass("select2-default");

                this.container.removeClass("select2-allowclear");
            }
        },

        // single
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var selected = 0, self = this, showSearchInput = true;

            // find the selected element in the result list

            this.findHighlightableChoices().each2(function (i, elm) {
                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
                    selected = i;
                    return false;
                }
            });

            // and highlight it
            if (noHighlightUpdate !== false) {
                if (initial === true && selected >= 0) {
                    this.highlight(selected);
                } else {
                    this.highlight(0);
                }
            }

            // hide the search box if this is the first we got the results and there are enough of them for search

            if (initial === true) {
                var min = this.opts.minimumResultsForSearch;
                if (min >= 0) {
                    this.showSearch(countResults(data.results) >= min);
                }
            }
        },

        // single
        showSearch: function(showSearchInput) {
            if (this.showSearchInput === showSearchInput) return;

            this.showSearchInput = showSearchInput;

            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
            //add "select2-with-searchbox" to the container if search box is shown
            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
        },

        // single
        onSelect: function (data, options) {

            if (!this.triggerSelect(data)) { return; }

            var old = this.opts.element.val(),
                oldData = this.data();

            this.opts.element.val(this.id(data));
            this.updateSelection(data);

            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
            this.close();

            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }

            if (!equal(old, this.id(data))) {
                this.triggerChange({ added: data, removed: oldData });
            }
        },

        // single
        updateSelection: function (data) {

            var container=this.selection.find(".select2-chosen"), formatted, cssClass;

            this.selection.data("select2-data", data);

            container.empty();
            if (data !== null) {
                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
            }
            if (formatted !== undefined) {
                container.append(formatted);
            }
            cssClass=this.opts.formatSelectionCssClass(data, container);
            if (cssClass !== undefined) {
                container.addClass(cssClass);
            }

            this.selection.removeClass("select2-default");

            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
                this.container.addClass("select2-allowclear");
            }
        },

        // single
        val: function () {
            var val,
                triggerChange = false,
                data = null,
                self = this,
                oldData = this.data();

            if (arguments.length === 0) {
                return this.opts.element.val();
            }

            val = arguments[0];

            if (arguments.length > 1) {
                triggerChange = arguments[1];
            }

            if (this.select) {
                this.select
                    .val(val)
                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
                        data = self.optionToData(elm);
                        return false;
                    });
                this.updateSelection(data);
                this.setPlaceholder();
                if (triggerChange) {
                    this.triggerChange({added: data, removed:oldData});
                }
            } else {
                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
                if (!val && val !== 0) {
                    this.clear(triggerChange);
                    return;
                }
                if (this.opts.initSelection === undefined) {
                    throw new Error("cannot call val() if initSelection() is not defined");
                }
                this.opts.element.val(val);
                this.opts.initSelection(this.opts.element, function(data){
                    self.opts.element.val(!data ? "" : self.id(data));
                    self.updateSelection(data);
                    self.setPlaceholder();
                    if (triggerChange) {
                        self.triggerChange({added: data, removed:oldData});
                    }
                });
            }
        },

        // single
        clearSearch: function () {
            this.search.val("");
            this.focusser.val("");
        },

        // single
        data: function(value) {
            var data,
                triggerChange = false;

            if (arguments.length === 0) {
                data = this.selection.data("select2-data");
                if (data == undefined) data = null;
                return data;
            } else {
                if (arguments.length > 1) {
                    triggerChange = arguments[1];
                }
                if (!value) {
                    this.clear(triggerChange);
                } else {
                    data = this.data();
                    this.opts.element.val(!value ? "" : this.id(value));
                    this.updateSelection(value);
                    if (triggerChange) {
                        this.triggerChange({added: value, removed:data});
                    }
                }
            }
        }
    });

    MultiSelect2 = clazz(AbstractSelect2, {

        // multi
        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container select2-container-multi"
            }).html([
                "<ul class='select2-choices'>",
                "  <li class='select2-search-field'>",
                "    <label for='' class='select2-offscreen'></label>",
                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
                "  </li>",
                "</ul>",
                "<div class='select2-drop select2-drop-multi select2-display-none'>",
                "   <ul class='select2-results'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // multi
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            // TODO validate placeholder is a string if specified
            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {

                    var data = [];

                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
                        data.push(self.optionToData(elm));
                    });
                    callback(data);
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var ids = splitVal(element.val(), opts.separator, opts.transformVal);
                    //search in data by array of ids, storing matching items in a list
                    var matches = [];
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = $.grep(ids, function(id) {
                                return equal(id, opts.id(el));
                            }).length;
                            if (is_match) {
                                matches.push(el);
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            // reorder matches based on the order they appear in the ids array because right now
                            // they are in the order in which they appear in data array
                            var ordered = [];
                            for (var i = 0; i < ids.length; i++) {
                                var id = ids[i];
                                for (var j = 0; j < matches.length; j++) {
                                    var match = matches[j];
                                    if (equal(id, opts.id(match))) {
                                        ordered.push(match);
                                        matches.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                            callback(ordered);
                        }
                    });
                };
            }

            return opts;
        },

        // multi
        selectChoice: function (choice) {

            var selected = this.container.find(".select2-search-choice-focus");
            if (selected.length && choice && choice[0] == selected[0]) {

            } else {
                if (selected.length) {
                    this.opts.element.trigger("choice-deselected", selected);
                }
                selected.removeClass("select2-search-choice-focus");
                if (choice && choice.length) {
                    this.close();
                    choice.addClass("select2-search-choice-focus");
                    this.opts.element.trigger("choice-selected", choice);
                }
            }
        },

        // multi
        destroy: function() {
            $("label[for='" + this.search.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "searchContainer",
                "selection"
            );
        },

        // multi
        initContainer: function () {

            var selector = ".select2-choices", selection;

            this.searchContainer = this.container.find(".select2-search-field");
            this.selection = selection = this.container.find(selector);

            var _this = this;
            this.selection.on("click", ".select2-container:not(.select2-container-disabled) .select2-search-choice:not(.select2-locked)", function (e) {
                _this.search[0].focus();
                _this.selectChoice($(this));
            });

            // rewrite labels from original element to focusser
            this.search.attr("id", "s2id_autogen"+nextUid());

            this.search.prev()
                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
                .attr('for', this.search.attr('id'));
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.search.on("input paste", this.bind(function() {
                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
                if (!this.isInterfaceEnabled()) return;
                if (!this.opened()) {
                    this.open();
                }
            }));

            this.search.attr("tabindex", this.elementTabIndex);

            this.keydowns = 0;
            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                ++this.keydowns;
                var selected = selection.find(".select2-search-choice-focus");
                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
                var next = selected.next(".select2-search-choice:not(.select2-locked)");
                var pos = getCursorInfo(this.search);

                if (selected.length &&
                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
                    var selectedChoice = selected;
                    if (e.which == KEY.LEFT && prev.length) {
                        selectedChoice = prev;
                    }
                    else if (e.which == KEY.RIGHT) {
                        selectedChoice = next.length ? next : null;
                    }
                    else if (e.which === KEY.BACKSPACE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = prev.length ? prev : next;
                        }
                    } else if (e.which == KEY.DELETE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = next.length ? next : null;
                        }
                    } else if (e.which == KEY.ENTER) {
                        selectedChoice = null;
                    }

                    this.selectChoice(selectedChoice);
                    killEvent(e);
                    if (!selectedChoice || !selectedChoice.length) {
                        this.open();
                    }
                    return;
                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {

                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
                    killEvent(e);
                    return;
                } else {
                    this.selectChoice(null);
                }

                if (this.opened()) {
                    switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus:true});
                        this.close();
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                    }
                }

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
                    return;
                }

                if (e.which === KEY.ENTER) {
                    if (this.opts.openOnEnter === false) {
                        return;
                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                        return;
                    }
                }

                this.open();

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                }

                if (e.which === KEY.ENTER) {
                    // prevent form from being submitted
                    killEvent(e);
                }

            }));

            this.search.on("keyup", this.bind(function (e) {
                this.keydowns = 0;
                this.resizeSearch();
            })
            );

            this.search.on("blur", this.bind(function(e) {
                this.container.removeClass("select2-container-active");
                this.search.removeClass("select2-focused");
                this.selectChoice(null);
                if (!this.opened()) this.clearSearch();
                e.stopImmediatePropagation();
                this.opts.element.trigger($.Event("select2-blur"));
            }));

            this.container.on("click", selector, this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                if ($(e.target).closest(".select2-search-choice").length > 0) {
                    // clicked inside a select2 search choice, do not open
                    return;
                }
                this.selectChoice(null);
                this.clearPlaceholder();
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.open();
                this.focusSearch();
                e.preventDefault();
            }));

            this.container.on("focus", selector, this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
                this.dropdown.addClass("select2-drop-active");
                this.clearPlaceholder();
            }));

            this.initContainerWidth();
            this.opts.element.hide();

            // set the placeholder if necessary
            this.clearSearch();
        },

        // multi
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.search.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // multi
        initSelection: function () {
            var data;
            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
                this.updateSelection([]);
                this.close();
                // set the placeholder if necessary
                this.clearSearch();
            }
            if (this.select || this.opts.element.val() !== "") {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(data){
                    if (data !== undefined && data !== null) {
                        self.updateSelection(data);
                        self.close();
                        // set the placeholder if necessary
                        self.clearSearch();
                    }
                });
            }
        },

        // multi
        clearSearch: function () {
            var placeholder = this.getPlaceholder(),
                maxWidth = this.getMaxSearchWidth();

            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
                this.search.val(placeholder).addClass("select2-default");
                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
            } else {
                this.search.val("").width(10);
            }
        },

        // multi
        clearPlaceholder: function () {
            if (this.search.hasClass("select2-default")) {
                this.search.val("").removeClass("select2-default");
            }
        },

        // multi
        opening: function () {
            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
            this.resizeSearch();

            this.parent.opening.apply(this, arguments);

            this.focusSearch();

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.updateResults(true);
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
            }
            this.opts.element.trigger($.Event("select2-open"));
        },

        // multi
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
        },

        // multi
        focus: function () {
            this.close();
            this.search.focus();
        },

        // multi
        isFocused: function () {
            return this.search.hasClass("select2-focused");
        },

        // multi
        updateSelection: function (data) {
            var ids = [], filtered = [], self = this;

            // filter out duplicates
            $(data).each(function () {
                if (indexOf(self.id(this), ids) < 0) {
                    ids.push(self.id(this));
                    filtered.push(this);
                }
            });
            data = filtered;

            this.selection.find(".select2-search-choice").remove();
            $(data).each(function () {
                self.addSelectedChoice(this);
            });
            self.postprocessResults();
        },

        // multi
        tokenize: function() {
            var input = this.search.val();
            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
            if (input != null && input != undefined) {
                this.search.val(input);
                if (input.length > 0) {
                    this.open();
                }
            }

        },

        // multi
        onSelect: function (data, options) {

            if (!this.triggerSelect(data) || data.text === "") { return; }

            this.addSelectedChoice(data);

            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

            // keep track of the search's value before it gets cleared
            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());

            this.clearSearch();
            this.updateResults();

            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);

            if (this.opts.closeOnSelect) {
                this.close();
                this.search.width(10);
            } else {
                if (this.countSelectableResults()>0) {
                    this.search.width(10);
                    this.resizeSearch();
                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
                        // if we reached max selection size repaint the results so choices
                        // are replaced with the max selection reached message
                        this.updateResults(true);
                    } else {
                        // initializes search's value with nextSearchTerm and update search result
                        if(this.nextSearchTerm != undefined){
                            this.search.val(this.nextSearchTerm);
                            this.updateResults();
                            this.search.select();
                        }
                    }
                    this.positionDropdown();
                } else {
                    // if nothing left to select close
                    this.close();
                    this.search.width(10);
                }
            }

            // since its not possible to select an element that has already been
            // added we do not need to check if this is a new element before firing change
            this.triggerChange({ added: data });

            if (!options || !options.noFocus)
                this.focusSearch();
        },

        // multi
        cancel: function () {
            this.close();
            this.focusSearch();
        },

        addSelectedChoice: function (data) {
            var enableChoice = !data.locked,
                enabledItem = $(
                    "<li class='select2-search-choice'>" +
                    "    <div></div>" +
                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
                    "</li>"),
                disabledItem = $(
                    "<li class='select2-search-choice select2-locked'>" +
                    "<div></div>" +
                    "</li>");
            var choice = enableChoice ? enabledItem : disabledItem,
                id = this.id(data),
                val = this.getVal(),
                formatted,
                cssClass;

            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
            if (formatted != undefined) {
                choice.find("div").replaceWith($("<div></div>").html(formatted));
            }
            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
            if (cssClass != undefined) {
                choice.addClass(cssClass);
            }

            if(enableChoice){
              choice.find(".select2-search-choice-close")
                  .on("mousedown", killEvent)
                  .on("click dblclick", this.bind(function (e) {
                  if (!this.isInterfaceEnabled()) return;

                  this.unselect($(e.target));
                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
                  killEvent(e);
                  this.close();
                  this.focusSearch();
              })).on("focus", this.bind(function () {
                  if (!this.isInterfaceEnabled()) return;
                  this.container.addClass("select2-container-active");
                  this.dropdown.addClass("select2-drop-active");
              }));
            }

            choice.data("select2-data", data);
            choice.insertBefore(this.searchContainer);

            val.push(id);
            this.setVal(val);
        },

        // multi
        unselect: function (selected) {
            var val = this.getVal(),
                data,
                index;
            selected = selected.closest(".select2-search-choice");

            if (selected.length === 0) {
                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
            }

            data = selected.data("select2-data");

            if (!data) {
                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
                // and invoked on an element already removed
                return;
            }

            var evt = $.Event("select2-removing");
            evt.val = this.id(data);
            evt.choice = data;
            this.opts.element.trigger(evt);

            if (evt.isDefaultPrevented()) {
                return false;
            }

            while((index = indexOf(this.id(data), val)) >= 0) {
                val.splice(index, 1);
                this.setVal(val);
                if (this.select) this.postprocessResults();
            }

            selected.remove();

            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
            this.triggerChange({ removed: data });

            return true;
        },

        // multi
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var val = this.getVal(),
                choices = this.results.find(".select2-result"),
                compound = this.results.find(".select2-result-with-children"),
                self = this;

            choices.each2(function (i, choice) {
                var id = self.id(choice.data("select2-data"));
                if (indexOf(id, val) >= 0) {
                    choice.addClass("select2-selected");
                    // mark all children of the selected parent as selected
                    choice.find(".select2-result-selectable").addClass("select2-selected");
                }
            });

            compound.each2(function(i, choice) {
                // hide an optgroup if it doesn't have any selectable children
                if (!choice.is('.select2-result-selectable')
                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
                    choice.addClass("select2-selected");
                }
            });

            if (this.highlight() == -1 && noHighlightUpdate !== false && this.opts.closeOnSelect === true){
                self.highlight(0);
            }

            //If all results are chosen render formatNoMatches
            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
                    }
                }
            }

        },

        // multi
        getMaxSearchWidth: function() {
            return this.selection.width() - getSideBorderPadding(this.search);
        },

        // multi
        resizeSearch: function () {
            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
                sideBorderPadding = getSideBorderPadding(this.search);

            minimumWidth = measureTextWidth(this.search) + 10;

            left = this.search.offset().left;

            maxWidth = this.selection.width();
            containerLeft = this.selection.offset().left;

            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

            if (searchWidth < minimumWidth) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth < 40) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth <= 0) {
              searchWidth = minimumWidth;
            }

            this.search.width(Math.floor(searchWidth));
        },

        // multi
        getVal: function () {
            var val;
            if (this.select) {
                val = this.select.val();
                return val === null ? [] : val;
            } else {
                val = this.opts.element.val();
                return splitVal(val, this.opts.separator, this.opts.transformVal);
            }
        },

        // multi
        setVal: function (val) {
            var unique;
            if (this.select) {
                this.select.val(val);
            } else {
                unique = [];
                // filter out duplicates
                $(val).each(function () {
                    if (indexOf(this, unique) < 0) unique.push(this);
                });
                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
            }
        },

        // multi
        buildChangeDetails: function (old, current) {
            var current = current.slice(0),
                old = old.slice(0);

            // remove intersection from each array
            for (var i = 0; i < current.length; i++) {
                for (var j = 0; j < old.length; j++) {
                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
                        current.splice(i, 1);
                        if(i>0){
                            i--;
                        }
                        old.splice(j, 1);
                        j--;
                    }
                }
            }

            return {added: current, removed: old};
        },


        // multi
        val: function (val, triggerChange) {
            var oldData, self=this;

            if (arguments.length === 0) {
                return this.getVal();
            }

            oldData=this.data();
            if (!oldData.length) oldData=[];

            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
            if (!val && val !== 0) {
                this.opts.element.val("");
                this.updateSelection([]);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange({added: this.data(), removed: oldData});
                }
                return;
            }

            // val is a list of ids
            this.setVal(val);

            if (this.select) {
                this.opts.initSelection(this.select, this.bind(this.updateSelection));
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
                }
            } else {
                if (this.opts.initSelection === undefined) {
                    throw new Error("val() cannot be called if initSelection() is not defined");
                }

                this.opts.initSelection(this.opts.element, function(data){
                    var ids=$.map(data, self.id);
                    self.setVal(ids);
                    self.updateSelection(data);
                    self.clearSearch();
                    if (triggerChange) {
                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
                    }
                });
            }
            this.clearSearch();
        },

        // multi
        onSortStart: function() {
            if (this.select) {
                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
            }

            // collapse search field into 0 width so its container can be collapsed as well
            this.search.width(0);
            // hide the container
            this.searchContainer.hide();
        },

        // multi
        onSortEnd:function() {

            var val=[], self=this;

            // show search and move it to the end of the list
            this.searchContainer.show();
            // make sure the search container is the last item in the list
            this.searchContainer.appendTo(this.searchContainer.parent());
            // since we collapsed the width in dragStarted, we resize it here
            this.resizeSearch();

            // update selection
            this.selection.find(".select2-search-choice").each(function() {
                val.push(self.opts.id($(this).data("select2-data")));
            });
            this.setVal(val);
            this.triggerChange();
        },

        // multi
        data: function(values, triggerChange) {
            var self=this, ids, old;
            if (arguments.length === 0) {
                 return this.selection
                     .children(".select2-search-choice")
                     .map(function() { return $(this).data("select2-data"); })
                     .get();
            } else {
                old = this.data();
                if (!values) { values = []; }
                ids = $.map(values, function(e) { return self.opts.id(e); });
                this.setVal(ids);
                this.updateSelection(values);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(old, this.data()));
                }
            }
        }
    });

    $.fn.select2 = function () {

        var args = Array.prototype.slice.call(arguments, 0),
            opts,
            select2,
            method, value, multiple,
            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
            valueMethods = ["opened", "isFocused", "container", "dropdown"],
            propertyMethods = ["val", "data"],
            methodsMap = { search: "externalSearch" };

        this.each(function () {
            if (args.length === 0 || typeof(args[0]) === "object") {
                opts = args.length === 0 ? {} : $.extend({}, args[0]);
                opts.element = $(this);

                if (opts.element.get(0).tagName.toLowerCase() === "select") {
                    multiple = opts.element.prop("multiple");
                } else {
                    multiple = opts.multiple || false;
                    if ("tags" in opts) {opts.multiple = multiple = true;}
                }

                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
                select2.init(opts);
            } else if (typeof(args[0]) === "string") {

                if (indexOf(args[0], allowedMethods) < 0) {
                    throw "Unknown method: " + args[0];
                }

                value = undefined;
                select2 = $(this).data("select2");
                if (select2 === undefined) return;

                method=args[0];

                if (method === "container") {
                    value = select2.container;
                } else if (method === "dropdown") {
                    value = select2.dropdown;
                } else {
                    if (methodsMap[method]) method = methodsMap[method];

                    value = select2[method].apply(select2, args.slice(1));
                }
                if (indexOf(args[0], valueMethods) >= 0
                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
                    return false; // abort the iteration, ready to return first matched value
                }
            } else {
                throw "Invalid arguments to select2 plugin: " + args;
            }
        });
        return (value === undefined) ? this : value;
    };

    // plugin defaults, accessible to users
    $.fn.select2.defaults = {
        width: "copy",
        loadMorePadding: 0,
        closeOnSelect: true,
        openOnEnter: true,
        containerCss: {},
        dropdownCss: {},
        containerCssClass: "",
        dropdownCssClass: "",
        formatResult: function(result, container, query, escapeMarkup) {
            var markup=[];
            markMatch(this.text(result), query.term, markup, escapeMarkup);
            return markup.join("");
        },
        transformVal: function(val) {
            return $.trim(val);
        },
        formatSelection: function (data, container, escapeMarkup) {
            return data ? escapeMarkup(this.text(data)) : undefined;
        },
        sortResults: function (results, container, query) {
            return results;
        },
        formatResultCssClass: function(data) {return data.css;},
        formatSelectionCssClass: function(data, container) {return undefined;},
        minimumResultsForSearch: 0,
        minimumInputLength: 0,
        maximumInputLength: null,
        maximumSelectionSize: 0,
        id: function (e) { return e == undefined ? null : e.id; },
        text: function (e) {
          if (e && this.data && this.data.text) {
            if ($.isFunction(this.data.text)) {
              return this.data.text(e);
            } else {
              return e[this.data.text];
            }
          } else {
            return e.text;
          }
        },
        matcher: function(term, text) {
            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
        },
        separator: ",",
        tokenSeparators: [],
        tokenizer: defaultTokenizer,
        escapeMarkup: defaultEscapeMarkup,
        blurOnChange: false,
        selectOnBlur: false,
        adaptContainerCssClass: function(c) { return c; },
        adaptDropdownCssClass: function(c) { return null; },
        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
        searchInputPlaceholder: '',
        createSearchChoicePosition: 'top',
        shouldFocusInput: function (instance) {
            // Attempt to detect touch devices
            var supportsTouchEvents = (('ontouchstart' in window) ||
                                       (navigator.msMaxTouchPoints > 0));

            // Only devices which support touch events should be special cased
            if (!supportsTouchEvents) {
                return true;
            }

            // Never focus the input if search is disabled
            if (instance.opts.minimumResultsForSearch < 0) {
                return false;
            }

            return true;
        }
    };

    $.fn.select2.locales = [];

    $.fn.select2.locales['en'] = {
         formatMatches: function (matches) { if (matches === 1) { return "One result is available, press enter to select it."; } return matches + " results are available, use up and down arrow keys to navigate."; },
         formatNoMatches: function () { return "No matches found"; },
         formatAjaxError: function (jqXHR, textStatus, errorThrown) { return "Loading failed"; },
         formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1 ? "" : "s"); },
         formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1 ? "" : "s"); },
         formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
         formatLoadMore: function (pageNumber) { return "Loading more results…"; },
         formatSearching: function () { return "Searching…"; }
    };

    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);

    $.fn.select2.ajaxDefaults = {
        transport: $.ajax,
        params: {
            type: "GET",
            cache: false,
            dataType: "json"
        }
    };

    // exports
    window.Select2 = {
        query: {
            ajax: ajax,
            local: local,
            tags: tags
        }, util: {
            debounce: debounce,
            markMatch: markMatch,
            escapeMarkup: defaultEscapeMarkup,
            stripDiacritics: stripDiacritics
        }, "class": {
            "abstract": AbstractSelect2,
            "single": SingleSelect2,
            "multi": MultiSelect2
        }
    };

}(jQuery));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = {
	"small_airplane": "airplane_small",
	"right_anger_bubble": "anger_right",
	"keycap_asterisk": "asterisk",
	"atom_symbol": "atom",
	"ballot_box_with_ballot": "ballot_box",
	"person_with_ball": "basketball_player",
	"person_with_ball_tone1": "basketball_player_tone1",
	"person_with_ball_tone2": "basketball_player_tone2",
	"person_with_ball_tone3": "basketball_player_tone3",
	"person_with_ball_tone4": "basketball_player_tone4",
	"person_with_ball_tone5": "basketball_player_tone5",
	"beach_with_umbrella": "beach",
	"umbrella_on_ground": "beach_umbrella",
	"bellhop_bell": "bellhop",
	"biohazard_sign": "biohazard",
	"archery": "bow_and_arrow",
	"boxing_gloves": "boxing_glove",
	"spiral_calendar_pad": "calendar_spiral",
	"call_me_hand": "call_me",
	"call_me_hand_tone1": "call_me_tone1",
	"call_me_hand_tone2": "call_me_tone2",
	"call_me_hand_tone3": "call_me_tone3",
	"call_me_hand_tone4": "call_me_tone4",
	"call_me_hand_tone5": "call_me_tone5",
	"kayak": "canoe",
	"card_file_box": "card_box",
	"person_doing_cartwheel": "cartwheel",
	"person_doing_cartwheel_tone1": "cartwheel_tone1",
	"person_doing_cartwheel_tone2": "cartwheel_tone2",
	"person_doing_cartwheel_tone3": "cartwheel_tone3",
	"person_doing_cartwheel_tone4": "cartwheel_tone4",
	"person_doing_cartwheel_tone5": "cartwheel_tone5",
	"bottle_with_popping_cork": "champagne",
	"clinking_glass": "champagne_glass",
	"cheese_wedge": "cheese",
	"city_sunrise": "city_sunset",
	"mantlepiece_clock": "clock",
	"cloud_with_lightning": "cloud_lightning",
	"cloud_with_rain": "cloud_rain",
	"cloud_with_snow": "cloud_snow",
	"cloud_with_tornado": "cloud_tornado",
	"clown_face": "clown",
	"building_construction": "construction_site",
	"couch_and_lamp": "couch",
	"couple_with_heart_mm": "couple_mm",
	"couple_with_heart_ww": "couple_ww",
	"face_with_cowboy_hat": "cowboy",
	"lower_left_crayon": "crayon",
	"cricket_bat_ball": "cricket",
	"latin_cross": "cross",
	"passenger_ship": "cruise_ship",
	"dagger_knife": "dagger",
	"desktop_computer": "desktop",
	"card_index_dividers": "dividers",
	"dove_of_peace": "dove",
	"drool": "drooling_face",
	"drum_with_drumsticks": "drum",
	"email": "e-mail",
	"eject_symbol": "eject",
	"facepalm": "face_palm",
	"facepalm_tone1": "face_palm_tone1",
	"facepalm_tone2": "face_palm_tone2",
	"facepalm_tone3": "face_palm_tone3",
	"facepalm_tone4": "face_palm_tone4",
	"facepalm_tone5": "face_palm_tone5",
	"fencing": "fencer",
	"hand_with_index_and_middle_finger_crossed": "fingers_crossed",
	"hand_with_index_and_middle_fingers_crossed_tone1": "fingers_crossed_tone1",
	"hand_with_index_and_middle_fingers_crossed_tone2": "fingers_crossed_tone2",
	"hand_with_index_and_middle_fingers_crossed_tone3": "fingers_crossed_tone3",
	"hand_with_index_and_middle_fingers_crossed_tone4": "fingers_crossed_tone4",
	"hand_with_index_and_middle_fingers_crossed_tone5": "fingers_crossed_tone5",
	"flame": "fire",
	"first_place_medal": "first_place",
	"ac": "flag_ac",
	"ad": "flag_ad",
	"ae": "flag_ae",
	"af": "flag_af",
	"ag": "flag_ag",
	"ai": "flag_ai",
	"al": "flag_al",
	"am": "flag_am",
	"ao": "flag_ao",
	"aq": "flag_aq",
	"ar": "flag_ar",
	"as": "flag_as",
	"at": "flag_at",
	"au": "flag_au",
	"aw": "flag_aw",
	"ax": "flag_ax",
	"az": "flag_az",
	"ba": "flag_ba",
	"bb": "flag_bb",
	"bd": "flag_bd",
	"be": "flag_be",
	"bf": "flag_bf",
	"bg": "flag_bg",
	"bh": "flag_bh",
	"bi": "flag_bi",
	"bj": "flag_bj",
	"bl": "flag_bl",
	"waving_black_flag": "flag_black",
	"bm": "flag_bm",
	"bn": "flag_bn",
	"bo": "flag_bo",
	"bq": "flag_bq",
	"br": "flag_br",
	"bs": "flag_bs",
	"bt": "flag_bt",
	"bv": "flag_bv",
	"bw": "flag_bw",
	"by": "flag_by",
	"bz": "flag_bz",
	"ca": "flag_ca",
	"cc": "flag_cc",
	"congo": "flag_cd",
	"cf": "flag_cf",
	"cg": "flag_cg",
	"ch": "flag_ch",
	"ci": "flag_ci",
	"ck": "flag_ck",
	"chile": "flag_cl",
	"cm": "flag_cm",
	"cn": "flag_cn",
	"co": "flag_co",
	"cp": "flag_cp",
	"cr": "flag_cr",
	"cu": "flag_cu",
	"cv": "flag_cv",
	"cw": "flag_cw",
	"cx": "flag_cx",
	"cy": "flag_cy",
	"cz": "flag_cz",
	"de": "flag_de",
	"dg": "flag_dg",
	"dj": "flag_dj",
	"dk": "flag_dk",
	"dm": "flag_dm",
	"do": "flag_do",
	"dz": "flag_dz",
	"ea": "flag_ea",
	"ec": "flag_ec",
	"ee": "flag_ee",
	"eg": "flag_eg",
	"eh": "flag_eh",
	"er": "flag_er",
	"es": "flag_es",
	"et": "flag_et",
	"eu": "flag_eu",
	"fi": "flag_fi",
	"fj": "flag_fj",
	"fk": "flag_fk",
	"fm": "flag_fm",
	"fo": "flag_fo",
	"fr": "flag_fr",
	"ga": "flag_ga",
	"gb": "flag_gb",
	"gd": "flag_gd",
	"ge": "flag_ge",
	"gf": "flag_gf",
	"gg": "flag_gg",
	"gh": "flag_gh",
	"gi": "flag_gi",
	"gl": "flag_gl",
	"gm": "flag_gm",
	"gn": "flag_gn",
	"gp": "flag_gp",
	"gq": "flag_gq",
	"gr": "flag_gr",
	"gs": "flag_gs",
	"gt": "flag_gt",
	"gu": "flag_gu",
	"gw": "flag_gw",
	"gy": "flag_gy",
	"hk": "flag_hk",
	"hm": "flag_hm",
	"hn": "flag_hn",
	"hr": "flag_hr",
	"ht": "flag_ht",
	"hu": "flag_hu",
	"ic": "flag_ic",
	"indonesia": "flag_id",
	"ie": "flag_ie",
	"il": "flag_il",
	"im": "flag_im",
	"in": "flag_in",
	"io": "flag_io",
	"iq": "flag_iq",
	"ir": "flag_ir",
	"is": "flag_is",
	"it": "flag_it",
	"je": "flag_je",
	"jm": "flag_jm",
	"jo": "flag_jo",
	"jp": "flag_jp",
	"ke": "flag_ke",
	"kg": "flag_kg",
	"kh": "flag_kh",
	"ki": "flag_ki",
	"km": "flag_km",
	"kn": "flag_kn",
	"kp": "flag_kp",
	"kr": "flag_kr",
	"kw": "flag_kw",
	"ky": "flag_ky",
	"kz": "flag_kz",
	"la": "flag_la",
	"lb": "flag_lb",
	"lc": "flag_lc",
	"li": "flag_li",
	"lk": "flag_lk",
	"lr": "flag_lr",
	"ls": "flag_ls",
	"lt": "flag_lt",
	"lu": "flag_lu",
	"lv": "flag_lv",
	"ly": "flag_ly",
	"ma": "flag_ma",
	"mc": "flag_mc",
	"md": "flag_md",
	"me": "flag_me",
	"mf": "flag_mf",
	"mg": "flag_mg",
	"mh": "flag_mh",
	"mk": "flag_mk",
	"ml": "flag_ml",
	"mm": "flag_mm",
	"mn": "flag_mn",
	"mo": "flag_mo",
	"mp": "flag_mp",
	"mq": "flag_mq",
	"mr": "flag_mr",
	"ms": "flag_ms",
	"mt": "flag_mt",
	"mu": "flag_mu",
	"mv": "flag_mv",
	"mw": "flag_mw",
	"mx": "flag_mx",
	"my": "flag_my",
	"mz": "flag_mz",
	"na": "flag_na",
	"nc": "flag_nc",
	"ne": "flag_ne",
	"nf": "flag_nf",
	"nigeria": "flag_ng",
	"ni": "flag_ni",
	"nl": "flag_nl",
	"no": "flag_no",
	"np": "flag_np",
	"nr": "flag_nr",
	"nu": "flag_nu",
	"nz": "flag_nz",
	"om": "flag_om",
	"pa": "flag_pa",
	"pe": "flag_pe",
	"pf": "flag_pf",
	"pg": "flag_pg",
	"ph": "flag_ph",
	"pk": "flag_pk",
	"pl": "flag_pl",
	"pm": "flag_pm",
	"pn": "flag_pn",
	"pr": "flag_pr",
	"ps": "flag_ps",
	"pt": "flag_pt",
	"pw": "flag_pw",
	"py": "flag_py",
	"qa": "flag_qa",
	"re": "flag_re",
	"ro": "flag_ro",
	"rs": "flag_rs",
	"ru": "flag_ru",
	"rw": "flag_rw",
	"saudiarabia": "flag_sa",
	"saudi": "flag_sa",
	"sb": "flag_sb",
	"sc": "flag_sc",
	"sd": "flag_sd",
	"se": "flag_se",
	"sg": "flag_sg",
	"sh": "flag_sh",
	"si": "flag_si",
	"sj": "flag_sj",
	"sk": "flag_sk",
	"sl": "flag_sl",
	"sm": "flag_sm",
	"sn": "flag_sn",
	"so": "flag_so",
	"sr": "flag_sr",
	"ss": "flag_ss",
	"st": "flag_st",
	"sv": "flag_sv",
	"sx": "flag_sx",
	"sy": "flag_sy",
	"sz": "flag_sz",
	"ta": "flag_ta",
	"tc": "flag_tc",
	"td": "flag_td",
	"tf": "flag_tf",
	"tg": "flag_tg",
	"th": "flag_th",
	"tj": "flag_tj",
	"tk": "flag_tk",
	"tl": "flag_tl",
	"turkmenistan": "flag_tm",
	"tn": "flag_tn",
	"to": "flag_to",
	"tr": "flag_tr",
	"tt": "flag_tt",
	"tuvalu": "flag_tv",
	"tw": "flag_tw",
	"tz": "flag_tz",
	"ua": "flag_ua",
	"ug": "flag_ug",
	"um": "flag_um",
	"us": "flag_us",
	"uy": "flag_uy",
	"uz": "flag_uz",
	"va": "flag_va",
	"vc": "flag_vc",
	"ve": "flag_ve",
	"vg": "flag_vg",
	"vi": "flag_vi",
	"vn": "flag_vn",
	"vu": "flag_vu",
	"wf": "flag_wf",
	"waving_white_flag": "flag_white",
	"ws": "flag_ws",
	"xk": "flag_xk",
	"ye": "flag_ye",
	"yt": "flag_yt",
	"za": "flag_za",
	"zm": "flag_zm",
	"zw": "flag_zw",
	"fork_and_knife_with_plate": "fork_knife_plate",
	"fox_face": "fox",
	"frame_with_picture": "frame_photo",
	"baguette_bread": "french_bread",
	"anguished": "frowning",
	"white_frowning_face": "frowning2",
	"goal_net": "goal",
	"hammer_and_pick": "hammer_pick",
	"raised_hand_with_fingers_splayed": "hand_splayed",
	"raised_hand_with_fingers_splayed_tone1": "hand_splayed_tone1",
	"raised_hand_with_fingers_splayed_tone2": "hand_splayed_tone2",
	"raised_hand_with_fingers_splayed_tone3": "hand_splayed_tone3",
	"raised_hand_with_fingers_splayed_tone4": "hand_splayed_tone4",
	"raised_hand_with_fingers_splayed_tone5": "hand_splayed_tone5",
	"shaking_hands": "handshake",
	"shaking_hands_tone1": "handshake_tone1",
	"shaking_hands_tone2": "handshake_tone2",
	"shaking_hands_tone3": "handshake_tone3",
	"shaking_hands_tone4": "handshake_tone4",
	"shaking_hands_tone5": "handshake_tone5",
	"face_with_head_bandage": "head_bandage",
	"heavy_heart_exclamation_mark_ornament": "heart_exclamation",
	"helmet_with_white_cross": "helmet_with_cross",
	"house_buildings": "homes",
	"hot_dog": "hotdog",
	"derelict_house_building": "house_abandoned",
	"hugging_face": "hugging",
	"desert_island": "island",
	"juggler": "juggling",
	"juggler_tone1": "juggling_tone1",
	"juggler_tone2": "juggling_tone2",
	"juggler_tone3": "juggling_tone3",
	"juggler_tone4": "juggling_tone4",
	"juggler_tone5": "juggling_tone5",
	"old_key": "key2",
	"couplekiss_mm": "kiss_mm",
	"couplekiss_ww": "kiss_ww",
	"kiwifruit": "kiwi",
	"satisfied": "laughing",
	"left_fist": "left_facing_fist",
	"left_fist_tone1": "left_facing_fist_tone1",
	"left_fist_tone2": "left_facing_fist_tone2",
	"left_fist_tone3": "left_facing_fist_tone3",
	"left_fist_tone4": "left_facing_fist_tone4",
	"left_fist_tone5": "left_facing_fist_tone5",
	"man_in_business_suit_levitating": "levitate",
	"weight_lifter": "lifter",
	"weight_lifter_tone1": "lifter_tone1",
	"weight_lifter_tone2": "lifter_tone2",
	"weight_lifter_tone3": "lifter_tone3",
	"weight_lifter_tone4": "lifter_tone4",
	"weight_lifter_tone5": "lifter_tone5",
	"lion": "lion_face",
	"liar": "lying_face",
	"male_dancer": "man_dancing",
	"male_dancer_tone1": "man_dancing_tone1",
	"male_dancer_tone2": "man_dancing_tone2",
	"male_dancer_tone3": "man_dancing_tone3",
	"male_dancer_tone4": "man_dancing_tone4",
	"male_dancer_tone5": "man_dancing_tone5",
	"tuxedo_tone1": "man_in_tuxedo_tone1",
	"tuxedo_tone2": "man_in_tuxedo_tone2",
	"tuxedo_tone3": "man_in_tuxedo_tone3",
	"tuxedo_tone4": "man_in_tuxedo_tone4",
	"tuxedo_tone5": "man_in_tuxedo_tone5",
	"world_map": "map",
	"karate_uniform": "martial_arts_uniform",
	"sports_medal": "medal",
	"sign_of_the_horns": "metal",
	"sign_of_the_horns_tone1": "metal_tone1",
	"sign_of_the_horns_tone2": "metal_tone2",
	"sign_of_the_horns_tone3": "metal_tone3",
	"sign_of_the_horns_tone4": "metal_tone4",
	"sign_of_the_horns_tone5": "metal_tone5",
	"studio_microphone": "microphone2",
	"reversed_hand_with_middle_finger_extended": "middle_finger",
	"reversed_hand_with_middle_finger_extended_tone1": "middle_finger_tone1",
	"reversed_hand_with_middle_finger_extended_tone2": "middle_finger_tone2",
	"reversed_hand_with_middle_finger_extended_tone3": "middle_finger_tone3",
	"reversed_hand_with_middle_finger_extended_tone4": "middle_finger_tone4",
	"reversed_hand_with_middle_finger_extended_tone5": "middle_finger_tone5",
	"glass_of_milk": "milk",
	"money_mouth_face": "money_mouth",
	"motorbike": "motor_scooter",
	"racing_motorcycle": "motorcycle",
	"snow_capped_mountain": "mountain_snow",
	"three_button_mouse": "mouse_three_button",
	"mother_christmas": "mrs_claus",
	"mother_christmas_tone1": "mrs_claus_tone1",
	"mother_christmas_tone2": "mrs_claus_tone2",
	"mother_christmas_tone3": "mrs_claus_tone3",
	"mother_christmas_tone4": "mrs_claus_tone4",
	"mother_christmas_tone5": "mrs_claus_tone5",
	"sick": "nauseated_face",
	"nerd_face": "nerd",
	"rolled_up_newspaper": "newspaper2",
	"spiral_note_pad": "notepad_spiral",
	"stop_sign": "octagonal_sign",
	"oil_drum": "oil",
	"grandma": "older_woman",
	"grandma_tone1": "older_woman_tone1",
	"grandma_tone2": "older_woman_tone2",
	"grandma_tone3": "older_woman_tone3",
	"grandma_tone4": "older_woman_tone4",
	"grandma_tone5": "older_woman_tone5",
	"lower_left_paintbrush": "paintbrush",
	"linked_paperclips": "paperclips",
	"national_park": "park",
	"double_vertical_bar": "pause_button",
	"peace_symbol": "peace",
	"shelled_peanut": "peanuts",
	"lower_left_ballpoint_pen": "pen_ballpoint",
	"lower_left_fountain_pen": "pen_fountain",
	"memo": "pencil",
	"table_tennis": "ping_pong",
	"worship_symbol": "place_of_worship",
	"shit": "poop",
	"hankey": "poop",
	"poo": "poop",
	"expecting_woman": "pregnant_woman",
	"expecting_woman_tone1": "pregnant_woman_tone1",
	"expecting_woman_tone2": "pregnant_woman_tone2",
	"expecting_woman_tone3": "pregnant_woman_tone3",
	"expecting_woman_tone4": "pregnant_woman_tone4",
	"expecting_woman_tone5": "pregnant_woman_tone5",
	"film_projector": "projector",
	"racing_car": "race_car",
	"radioactive_sign": "radioactive",
	"railroad_track": "railway_track",
	"back_of_hand": "raised_back_of_hand",
	"back_of_hand_tone1": "raised_back_of_hand_tone1",
	"back_of_hand_tone2": "raised_back_of_hand_tone2",
	"back_of_hand_tone3": "raised_back_of_hand_tone3",
	"back_of_hand_tone4": "raised_back_of_hand_tone4",
	"back_of_hand_tone5": "raised_back_of_hand_tone5",
	"rhinoceros": "rhino",
	"right_fist": "right_facing_fist",
	"right_fist_tone1": "right_facing_fist_tone1",
	"right_fist_tone2": "right_facing_fist_tone2",
	"right_fist_tone3": "right_facing_fist_tone3",
	"right_fist_tone4": "right_facing_fist_tone4",
	"right_fist_tone5": "right_facing_fist_tone5",
	"robot_face": "robot",
	"rolling_on_the_floor_laughing": "rofl",
	"face_with_rolling_eyes": "rolling_eyes",
	"green_salad": "salad",
	"second_place_medal": "second_place",
	"paella": "shallow_pan_of_food",
	"shopping_trolley": "shopping_cart",
	"skeleton": "skull",
	"skull_and_crossbones": "skull_crossbones",
	"slightly_frowning_face": "slight_frown",
	"slightly_smiling_face": "slight_smile",
	"sneeze": "sneezing_face",
	"speaking_head_in_silhouette": "speaking_head",
	"sleuth_or_spy": "spy",
	"sleuth_or_spy_tone1": "spy_tone1",
	"sleuth_or_spy_tone2": "spy_tone2",
	"sleuth_or_spy_tone3": "spy_tone3",
	"sleuth_or_spy_tone4": "spy_tone4",
	"sleuth_or_spy_tone5": "spy_tone5",
	"stuffed_pita": "stuffed_flatbread",
	"face_with_thermometer": "thermometer_face",
	"thinking_face": "thinking",
	"third_place_medal": "third_place",
	"-1": "thumbsdown",
	"-1_tone1": "thumbsdown_tone1",
	"-1_tone2": "thumbsdown_tone2",
	"-1_tone3": "thumbsdown_tone3",
	"-1_tone4": "thumbsdown_tone4",
	"-1_tone5": "thumbsdown_tone5",
	"+1": "thumbsup",
	"+1_tone1": "thumbsup_tone1",
	"+1_tone2": "thumbsup_tone2",
	"+1_tone3": "thumbsup_tone3",
	"+1_tone4": "thumbsup_tone4",
	"+1_tone5": "thumbsup_tone5",
	"thunder_cloud_and_rain": "thunder_cloud_rain",
	"admission_tickets": "tickets",
	"timer_clock": "timer",
	"hammer_and_wrench": "tools",
	"next_track": "track_next",
	"previous_track": "track_previous",
	"whisky": "tumbler_glass",
	"unicorn_face": "unicorn",
	"upside_down_face": "upside_down",
	"funeral_urn": "urn",
	"raised_hand_with_part_between_middle_and_ring_fingers": "vulcan",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone1": "vulcan_tone1",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone2": "vulcan_tone2",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone3": "vulcan_tone3",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone4": "vulcan_tone4",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone5": "vulcan_tone5",
	"white_sun_behind_cloud": "white_sun_cloud",
	"white_sun_behind_cloud_with_rain": "white_sun_rain_cloud",
	"white_sun_with_small_cloud": "white_sun_small_cloud",
	"wilted_flower": "wilted_rose",
	"wrestling": "wrestlers",
	"wrestling_tone1": "wrestlers_tone1",
	"wrestling_tone2": "wrestlers_tone2",
	"wrestling_tone3": "wrestlers_tone3",
	"wrestling_tone4": "wrestlers_tone4",
	"wrestling_tone5": "wrestlers_tone5",
	"zipper_mouth_face": "zipper_mouth"
};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, no-else-return, prefer-arrow-callback, camelcase, quotes, comma-dangle, max-len */

  (function () {
    this.Admin = function () {
      function Admin() {
        var modal, showBlacklistType;
        $('input#user_force_random_password').on('change', function (elem) {
          var elems;
          elems = $('#user_password, #user_password_confirmation');
          if ($(this).attr('checked')) {
            return elems.val('').attr('disabled', true);
          } else {
            return elems.removeAttr('disabled');
          }
        });
        $('body').on('click', '.js-toggle-colors-link', function (e) {
          e.preventDefault();
          return $('.js-toggle-colors-container').toggle();
        });
        $('.log-tabs a').click(function (e) {
          e.preventDefault();
          return $(this).tab('show');
        });
        $('.log-bottom').click(function (e) {
          var visible_log;
          e.preventDefault();
          visible_log = $(".file-content:visible");
          return visible_log.animate({
            scrollTop: visible_log.find('ol').height()
          }, "fast");
        });
        modal = $('.change-owner-holder');
        $('.change-owner-link').bind("click", function (e) {
          e.preventDefault();
          $(this).hide();
          return modal.show();
        });
        $('.change-owner-cancel-link').bind("click", function (e) {
          e.preventDefault();
          modal.hide();
          return $('.change-owner-link').show();
        });
        $('li.project_member').bind('ajax:success', function () {
          return gl.utils.refreshCurrentPage();
        });
        $('li.group_member').bind('ajax:success', function () {
          return gl.utils.refreshCurrentPage();
        });
        showBlacklistType = function showBlacklistType() {
          if ($("input[name='blacklist_type']:checked").val() === 'file') {
            $('.blacklist-file').show();
            return $('.blacklist-raw').hide();
          } else {
            $('.blacklist-file').hide();
            return $('.blacklist-raw').show();
          }
        };
        $("input[name='blacklist_type']").click(showBlacklistType);
        showBlacklistType();
      }

      return Admin;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 232 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, quotes, object-shorthand, camelcase, no-var, comma-dangle, prefer-arrow-callback, quote-props, no-param-reassign, max-len */

  (function () {
    var Api = {
      groupsPath: "/api/:version/groups.json",
      groupPath: "/api/:version/groups/:id.json",
      namespacesPath: "/api/:version/namespaces.json",
      groupProjectsPath: "/api/:version/groups/:id/projects.json",
      projectsPath: "/api/:version/projects.json?simple=true",
      labelsPath: "/:namespace_path/:project_path/labels",
      licensePath: "/api/:version/templates/licenses/:key",
      gitignorePath: "/api/:version/templates/gitignores/:key",
      gitlabCiYmlPath: "/api/:version/templates/gitlab_ci_ymls/:key",
      dockerfilePath: "/api/:version/dockerfiles/:key",
      issuableTemplatePath: "/:namespace_path/:project_path/templates/:type/:key",
      group: function group(group_id, callback) {
        var url = Api.buildUrl(Api.groupPath).replace(':id', group_id);
        return $.ajax({
          url: url,
          dataType: "json"
        }).done(function (group) {
          return callback(group);
        });
      },
      // Return groups list. Filtered by query
      groups: function groups(query, options, callback) {
        var url = Api.buildUrl(Api.groupsPath);
        return $.ajax({
          url: url,
          data: $.extend({
            search: query,
            per_page: 20
          }, options),
          dataType: "json"
        }).done(function (groups) {
          return callback(groups);
        });
      },
      // Return namespaces list. Filtered by query
      namespaces: function namespaces(query, callback) {
        var url = Api.buildUrl(Api.namespacesPath);
        return $.ajax({
          url: url,
          data: {
            search: query,
            per_page: 20
          },
          dataType: "json"
        }).done(function (namespaces) {
          return callback(namespaces);
        });
      },
      // Return projects list. Filtered by query
      projects: function projects(query, order, callback) {
        var url = Api.buildUrl(Api.projectsPath);
        return $.ajax({
          url: url,
          data: {
            search: query,
            order_by: order,
            per_page: 20
          },
          dataType: "json"
        }).done(function (projects) {
          return callback(projects);
        });
      },
      newLabel: function newLabel(namespace_path, project_path, data, callback) {
        var url = Api.buildUrl(Api.labelsPath).replace(':namespace_path', namespace_path).replace(':project_path', project_path);
        return $.ajax({
          url: url,
          type: "POST",
          data: { 'label': data },
          dataType: "json"
        }).done(function (label) {
          return callback(label);
        }).error(function (message) {
          return callback(message.responseJSON);
        });
      },
      // Return group projects list. Filtered by query
      groupProjects: function groupProjects(group_id, query, callback) {
        var url = Api.buildUrl(Api.groupProjectsPath).replace(':id', group_id);
        return $.ajax({
          url: url,
          data: {
            search: query,
            per_page: 20
          },
          dataType: "json"
        }).done(function (projects) {
          return callback(projects);
        });
      },
      // Return text for a specific license
      licenseText: function licenseText(key, data, callback) {
        var url = Api.buildUrl(Api.licensePath).replace(':key', key);
        return $.ajax({
          url: url,
          data: data
        }).done(function (license) {
          return callback(license);
        });
      },
      gitignoreText: function gitignoreText(key, callback) {
        var url = Api.buildUrl(Api.gitignorePath).replace(':key', key);
        return $.get(url, function (gitignore) {
          return callback(gitignore);
        });
      },
      gitlabCiYml: function gitlabCiYml(key, callback) {
        var url = Api.buildUrl(Api.gitlabCiYmlPath).replace(':key', key);
        return $.get(url, function (file) {
          return callback(file);
        });
      },
      dockerfileYml: function dockerfileYml(key, callback) {
        var url = Api.buildUrl(Api.dockerfilePath).replace(':key', key);
        $.get(url, callback);
      },
      issueTemplate: function issueTemplate(namespacePath, projectPath, key, type, callback) {
        var url = Api.buildUrl(Api.issuableTemplatePath).replace(':key', key).replace(':type', type).replace(':project_path', projectPath).replace(':namespace_path', namespacePath);
        $.ajax({
          url: url,
          dataType: 'json'
        }).done(function (file) {
          callback(null, file);
        }).error(callback);
      },
      buildUrl: function buildUrl(url) {
        if (gon.relative_url_root != null) {
          url = gon.relative_url_root + url;
        }
        return url.replace(':version', gon.api_version);
      }
    };

    window.Api = Api;
  }).call(this);
}).call(window);

/***/ }),
/* 233 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, prefer-arrow-callback, no-var, one-var, one-var-declaration-per-line, no-else-return, max-len */
  (function () {
    this.Aside = function () {
      function Aside() {
        $(document).off("click", "a.show-aside");
        $(document).on("click", 'a.show-aside', function (e) {
          var btn, icon;
          e.preventDefault();
          btn = $(e.currentTarget);
          icon = btn.find('i');
          if (icon.hasClass('fa-angle-left')) {
            btn.parent().find('section').hide();
            btn.parent().find('aside').fadeIn();
            return icon.removeClass('fa-angle-left').addClass('fa-angle-right');
          } else {
            btn.parent().find('aside').hide();
            btn.parent().find('section').fadeIn();
            return icon.removeClass('fa-angle-right').addClass('fa-angle-left');
          }
        });
      }

      return Aside;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, no-var, prefer-arrow-callback, consistent-return, one-var, one-var-declaration-per-line, no-unused-vars, no-else-return, prefer-template, quotes, comma-dangle, no-param-reassign, no-void, brace-style, no-underscore-dangle, no-return-assign, camelcase */
  /* global Cookies */

  var emojiAliases = __webpack_require__(230);

  (function () {
    this.AwardsHandler = function () {
      var FROM_SENTENCE_REGEX = /(?:, and | and |, )/; // For separating lists produced by ruby's Array#toSentence
      function AwardsHandler() {
        this.aliases = emojiAliases;
        $(document).off('click', '.js-add-award').on('click', '.js-add-award', function (_this) {
          return function (e) {
            e.stopPropagation();
            e.preventDefault();
            return _this.showEmojiMenu($(e.currentTarget));
          };
        }(this));
        $('html').on('click', function (e) {
          var $target;
          $target = $(e.target);
          if (!$target.closest('.emoji-menu-content').length) {
            $('.js-awards-block.current').removeClass('current');
          }
          if (!$target.closest('.emoji-menu').length) {
            if ($('.emoji-menu').is(':visible')) {
              $('.js-add-award.is-active').removeClass('is-active');
              return $('.emoji-menu').removeClass('is-visible');
            }
          }
        });
        $(document).off('click', '.js-emoji-btn').on('click', '.js-emoji-btn', function (_this) {
          return function (e) {
            var $target, emoji;
            e.preventDefault();
            $target = $(e.currentTarget);
            emoji = $target.find('.icon').data('emoji');
            $target.closest('.js-awards-block').addClass('current');
            return _this.addAward(_this.getVotesBlock(), _this.getAwardUrl(), emoji);
          };
        }(this));
      }

      AwardsHandler.prototype.showEmojiMenu = function ($addBtn) {
        var $holder, $menu, url;
        $menu = $('.emoji-menu');
        if ($addBtn.hasClass('js-note-emoji')) {
          $addBtn.closest('.note').find('.js-awards-block').addClass('current');
        } else {
          $addBtn.closest('.js-awards-block').addClass('current');
        }
        if ($menu.length) {
          $holder = $addBtn.closest('.js-award-holder');
          if ($menu.is('.is-visible')) {
            $addBtn.removeClass('is-active');
            $menu.removeClass('is-visible');
            return $('#emoji_search').blur();
          } else {
            $addBtn.addClass('is-active');
            this.positionMenu($menu, $addBtn);
            $menu.addClass('is-visible');
            return $('#emoji_search').focus();
          }
        } else {
          $addBtn.addClass('is-loading is-active');
          url = this.getAwardMenuUrl();
          return this.createEmojiMenu(url, function (_this) {
            return function () {
              $addBtn.removeClass('is-loading');
              $menu = $('.emoji-menu');
              _this.positionMenu($menu, $addBtn);
              if (!_this.frequentEmojiBlockRendered) {
                _this.renderFrequentlyUsedBlock();
              }
              return setTimeout(function () {
                $menu.addClass('is-visible');
                $('#emoji_search').focus();
                return _this.setupSearch();
              }, 200);
            };
          }(this));
        }
      };

      AwardsHandler.prototype.createEmojiMenu = function (awardMenuUrl, callback) {
        return $.get(awardMenuUrl, function (response) {
          $('body').append(response);
          return callback();
        });
      };

      AwardsHandler.prototype.positionMenu = function ($menu, $addBtn) {
        var css, position;
        position = $addBtn.data('position');
        // The menu could potentially be off-screen or in a hidden overflow element
        // So we position the element absolute in the body
        css = {
          top: $addBtn.offset().top + $addBtn.outerHeight() + "px"
        };
        if (position === 'right') {
          css.left = $addBtn.offset().left - $menu.outerWidth() + 20 + "px";
          $menu.addClass('is-aligned-right');
        } else {
          css.left = $addBtn.offset().left + "px";
          $menu.removeClass('is-aligned-right');
        }
        return $menu.css(css);
      };

      AwardsHandler.prototype.addAward = function (votesBlock, awardUrl, emoji, checkMutuality, callback) {
        if (checkMutuality == null) {
          checkMutuality = true;
        }
        emoji = this.normilizeEmojiName(emoji);
        this.postEmoji(awardUrl, emoji, function (_this) {
          return function () {
            _this.addAwardToEmojiBar(votesBlock, emoji, checkMutuality);
            return typeof callback === "function" ? callback() : void 0;
          };
        }(this));
        return $('.emoji-menu').removeClass('is-visible');
      };

      AwardsHandler.prototype.addAwardToEmojiBar = function (votesBlock, emoji, checkForMutuality) {
        var $emojiButton, counter;
        if (checkForMutuality == null) {
          checkForMutuality = true;
        }
        if (checkForMutuality) {
          this.checkMutuality(votesBlock, emoji);
        }
        this.addEmojiToFrequentlyUsedList(emoji);
        emoji = this.normilizeEmojiName(emoji);
        $emojiButton = this.findEmojiIcon(votesBlock, emoji).parent();
        if ($emojiButton.length > 0) {
          if (this.isActive($emojiButton)) {
            return this.decrementCounter($emojiButton, emoji);
          } else {
            counter = $emojiButton.find('.js-counter');
            counter.text(parseInt(counter.text(), 10) + 1);
            $emojiButton.addClass('active');
            this.addYouToUserList(votesBlock, emoji);
            return this.animateEmoji($emojiButton);
          }
        } else {
          votesBlock.removeClass('hidden');
          return this.createEmoji(votesBlock, emoji);
        }
      };

      AwardsHandler.prototype.getVotesBlock = function () {
        var currentBlock;
        currentBlock = $('.js-awards-block.current');
        if (currentBlock.length) {
          return currentBlock;
        } else {
          return $('.js-awards-block').eq(0);
        }
      };

      AwardsHandler.prototype.getAwardUrl = function () {
        return this.getVotesBlock().data('award-url');
      };

      AwardsHandler.prototype.checkMutuality = function (votesBlock, emoji) {
        var $emojiButton, awardUrl, isAlreadyVoted, mutualVote;
        awardUrl = this.getAwardUrl();
        if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
          mutualVote = emoji === 'thumbsup' ? 'thumbsdown' : 'thumbsup';
          $emojiButton = votesBlock.find("[data-emoji=" + mutualVote + "]").parent();
          isAlreadyVoted = $emojiButton.hasClass('active');
          if (isAlreadyVoted) {
            this.addAward(votesBlock, awardUrl, mutualVote, false);
          }
        }
      };

      AwardsHandler.prototype.isActive = function ($emojiButton) {
        return $emojiButton.hasClass('active');
      };

      AwardsHandler.prototype.decrementCounter = function ($emojiButton, emoji) {
        var counter, counterNumber;
        counter = $('.js-counter', $emojiButton);
        counterNumber = parseInt(counter.text(), 10);
        if (counterNumber > 1) {
          counter.text(counterNumber - 1);
          this.removeYouFromUserList($emojiButton, emoji);
        } else if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
          $emojiButton.tooltip('destroy');
          counter.text('0');
          this.removeYouFromUserList($emojiButton, emoji);
          if ($emojiButton.parents('.note').length) {
            this.removeEmoji($emojiButton);
          }
        } else {
          this.removeEmoji($emojiButton);
        }
        return $emojiButton.removeClass('active');
      };

      AwardsHandler.prototype.removeEmoji = function ($emojiButton) {
        var $votesBlock;
        $emojiButton.tooltip('destroy');
        $emojiButton.remove();
        $votesBlock = this.getVotesBlock();
        if ($votesBlock.find('.js-emoji-btn').length === 0) {
          return $votesBlock.addClass('hidden');
        }
      };

      AwardsHandler.prototype.getAwardTooltip = function ($awardBlock) {
        return $awardBlock.attr('data-original-title') || $awardBlock.attr('data-title') || '';
      };

      AwardsHandler.prototype.toSentence = function (list) {
        if (list.length <= 2) {
          return list.join(' and ');
        } else {
          return list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
        }
      };

      AwardsHandler.prototype.removeYouFromUserList = function ($emojiButton, emoji) {
        var authors, awardBlock, newAuthors, originalTitle;
        awardBlock = $emojiButton;
        originalTitle = this.getAwardTooltip(awardBlock);
        authors = originalTitle.split(FROM_SENTENCE_REGEX);
        authors.splice(authors.indexOf('You'), 1);
        return awardBlock.closest('.js-emoji-btn').removeData('title').removeAttr('data-title').removeAttr('data-original-title').attr('title', this.toSentence(authors)).tooltip('fixTitle');
      };

      AwardsHandler.prototype.addYouToUserList = function (votesBlock, emoji) {
        var awardBlock, origTitle, users;
        awardBlock = this.findEmojiIcon(votesBlock, emoji).parent();
        origTitle = this.getAwardTooltip(awardBlock);
        users = [];
        if (origTitle) {
          users = origTitle.trim().split(FROM_SENTENCE_REGEX);
        }
        users.unshift('You');
        return awardBlock.attr('title', this.toSentence(users)).tooltip('fixTitle');
      };

      AwardsHandler.prototype.createEmoji_ = function (votesBlock, emoji) {
        var $emojiButton, buttonHtml, emojiCssClass;
        emojiCssClass = this.resolveNameToCssClass(emoji);
        buttonHtml = "<button class='btn award-control js-emoji-btn has-tooltip active' title='You' data-placement='bottom'> <div class='icon emoji-icon " + emojiCssClass + "' data-emoji='" + emoji + "'></div> <span class='award-control-text js-counter'>1</span> </button>";
        $emojiButton = $(buttonHtml);
        $emojiButton.insertBefore(votesBlock.find('.js-award-holder')).find('.emoji-icon').data('emoji', emoji);
        this.animateEmoji($emojiButton);
        $('.award-control').tooltip();
        return votesBlock.removeClass('current');
      };

      AwardsHandler.prototype.animateEmoji = function ($emoji) {
        var className = 'pulse animated once short';
        $emoji.addClass(className);

        $emoji.on('webkitAnimationEnd animationEnd', function () {
          $(this).removeClass(className);
        });
      };

      AwardsHandler.prototype.createEmoji = function (votesBlock, emoji) {
        if ($('.emoji-menu').length) {
          return this.createEmoji_(votesBlock, emoji);
        }
        return this.createEmojiMenu(this.getAwardMenuUrl(), function (_this) {
          return function () {
            return _this.createEmoji_(votesBlock, emoji);
          };
        }(this));
      };

      AwardsHandler.prototype.getAwardMenuUrl = function () {
        return gon.award_menu_url;
      };

      AwardsHandler.prototype.resolveNameToCssClass = function (emoji) {
        var emojiIcon, unicodeName;
        emojiIcon = $(".emoji-menu-content [data-emoji='" + emoji + "']");
        if (emojiIcon.length > 0) {
          unicodeName = emojiIcon.data('unicode-name');
        } else {
          // Find by alias
          unicodeName = $(".emoji-menu-content [data-aliases*=':" + emoji + ":']").data('unicode-name');
        }
        return "emoji-" + unicodeName;
      };

      AwardsHandler.prototype.postEmoji = function (awardUrl, emoji, callback) {
        return $.post(awardUrl, {
          name: emoji
        }, function (data) {
          if (data.ok) {
            return callback();
          }
        });
      };

      AwardsHandler.prototype.findEmojiIcon = function (votesBlock, emoji) {
        return votesBlock.find(".js-emoji-btn [data-emoji='" + emoji + "']");
      };

      AwardsHandler.prototype.scrollToAwards = function () {
        var options;
        options = {
          scrollTop: $('.awards').offset().top - 110
        };
        return $('body, html').animate(options, 200);
      };

      AwardsHandler.prototype.normilizeEmojiName = function (emoji) {
        return this.aliases[emoji] || emoji;
      };

      AwardsHandler.prototype.addEmojiToFrequentlyUsedList = function (emoji) {
        var frequentlyUsedEmojis;
        frequentlyUsedEmojis = this.getFrequentlyUsedEmojis();
        frequentlyUsedEmojis.push(emoji);
        Cookies.set('frequently_used_emojis', frequentlyUsedEmojis.join(','), { expires: 365 });
      };

      AwardsHandler.prototype.getFrequentlyUsedEmojis = function () {
        var frequentlyUsedEmojis;
        frequentlyUsedEmojis = (Cookies.get('frequently_used_emojis') || '').split(',');
        return _.compact(_.uniq(frequentlyUsedEmojis));
      };

      AwardsHandler.prototype.renderFrequentlyUsedBlock = function () {
        var emoji, frequentlyUsedEmojis, i, len, ul;
        if (Cookies.get('frequently_used_emojis')) {
          frequentlyUsedEmojis = this.getFrequentlyUsedEmojis();
          ul = $("<ul class='clearfix emoji-menu-list frequent-emojis'>");
          for (i = 0, len = frequentlyUsedEmojis.length; i < len; i += 1) {
            emoji = frequentlyUsedEmojis[i];
            $(".emoji-menu-content [data-emoji='" + emoji + "']").closest('li').clone().appendTo(ul);
          }
          $('.emoji-menu-content').prepend(ul).prepend($('<h5>').text('Frequently used'));
        }
        return this.frequentEmojiBlockRendered = true;
      };

      AwardsHandler.prototype.setupSearch = function () {
        return $('input.emoji-search').on('keyup', function (_this) {
          return function (ev) {
            var found_emojis, h5, term, ul;
            term = $(ev.target).val();
            // Clean previous search results
            $('ul.emoji-menu-search, h5.emoji-search').remove();
            if (term) {
              // Generate a search result block
              h5 = $('<h5 class="emoji-search" />').text('Search results');
              found_emojis = _this.searchEmojis(term).show();
              ul = $('<ul>').addClass('emoji-menu-list emoji-menu-search').append(found_emojis);
              $('.emoji-menu-content ul, .emoji-menu-content h5').hide();
              return $('.emoji-menu-content').append(h5).append(ul);
            } else {
              return $('.emoji-menu-content').children().show();
            }
          };
        }(this));
      };

      AwardsHandler.prototype.searchEmojis = function (term) {
        return $(".emoji-menu-list:not(.frequent-emojis) [data-emoji*='" + term + "']").closest('li').clone();
      };

      return AwardsHandler;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, consistent-return, max-len */
  /* global autosize */

  var autosize = __webpack_require__(153);

  (function () {
    $(function () {
      var $fields;
      $fields = $('.js-autosize');
      $fields.on('autosize:resized', function () {
        var $field;
        $field = $(this);
        return $field.data('height', $field.outerHeight());
      });
      $fields.on('resize.autosize', function () {
        var $field;
        $field = $(this);
        if ($field.data('height') !== $field.outerHeight()) {
          $field.data('height', $field.outerHeight());
          autosize.destroy($field);
          return $field.css('max-height', window.outerHeight);
        }
      });
      autosize($fields);
      autosize.update($fields);
      return $fields.css('resize', 'vertical');
    });
  }).call(this);
}).call(window);

/***/ }),
/* 236 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, quotes, no-var, vars-on-top, max-len */
  (function () {
    $(function () {
      $("body").on("click", ".js-details-target", function () {
        var container;
        container = $(this).closest(".js-details-container");
        return container.toggleClass("open");
      });
      // Show details content. Hides link after click.
      //
      // %div
      //   %a.js-details-expand
      //   %div.js-details-content
      //
      return $("body").on("click", ".js-details-expand", function (e) {
        $(this).next('.js-details-content').removeClass("hide");
        $(this).hide();

        var truncatedItem = $(this).siblings('.js-details-short');
        if (truncatedItem.length) {
          truncatedItem.addClass("hide");
        }
        return e.preventDefault();
      });
    });
  }).call(this);
}).call(window);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, prefer-arrow-callback, camelcase, consistent-return, quotes, object-shorthand, comma-dangle, max-len */

  // Quick Submit behavior
  //
  // When a child field of a form with a `js-quick-submit` class receives a
  // "Meta+Enter" (Mac) or "Ctrl+Enter" (Linux/Windows) key combination, the form
  // is submitted.
  //
  __webpack_require__(32);

  //
  // ### Example Markup
  //
  //   <form action="/foo" class="js-quick-submit">
  //     <input type="text" />
  //     <textarea></textarea>
  //     <input type="submit" value="Submit" />
  //   </form>
  //
  (function () {
    var isMac, keyCodeIs;

    isMac = function isMac() {
      return navigator.userAgent.match(/Macintosh/);
    };

    keyCodeIs = function keyCodeIs(e, keyCode) {
      if (e.originalEvent && e.originalEvent.repeat || e.repeat) {
        return false;
      }
      return e.keyCode === keyCode;
    };

    $(document).on('keydown.quick_submit', '.js-quick-submit', function (e) {
      var $form, $submit_button;
      // Enter
      if (!keyCodeIs(e, 13)) {
        return;
      }
      if (!(e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey || e.ctrlKey && !e.altKey && !e.metaKey && !e.shiftKey)) {
        return;
      }
      e.preventDefault();
      $form = $(e.target).closest('form');
      $submit_button = $form.find('input[type=submit], button[type=submit]');
      if ($submit_button.attr('disabled')) {
        return;
      }
      $submit_button.disable();
      return $form.submit();
    });

    // If the user tabs to a submit button on a `js-quick-submit` form, display a
    // tooltip to let them know they could've used the hotkey
    $(document).on('keyup.quick_submit', '.js-quick-submit input[type=submit], .js-quick-submit button[type=submit]', function (e) {
      var $this, title;
      // Tab
      if (!keyCodeIs(e, 9)) {
        return;
      }
      if (isMac()) {
        title = "You can also press &#8984;-Enter";
      } else {
        title = "You can also press Ctrl-Enter";
      }
      $this = $(this);
      return $this.tooltip({
        container: 'body',
        html: 'true',
        placement: 'auto top',
        title: title,
        trigger: 'manual'
      }).tooltip('show').one('blur', function () {
        return $this.tooltip('hide');
      });
    });
  }).call(this);
}).call(window);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, quotes, prefer-template, prefer-arrow-callback, no-else-return, consistent-return, max-len */
  // Requires Input behavior
  //
  // When called on a form with input fields with the `required` attribute, the
  // form's submit button will be disabled until all required fields have values.
  //
  __webpack_require__(32);

  //
  // ### Example Markup
  //
  //   <form class="js-requires-input">
  //     <input type="text" required="required">
  //     <input type="submit" value="Submit">
  //   </form>
  //
  (function () {
    $.fn.requiresInput = function () {
      var $button, $form, fieldSelector, requireInput, required;
      $form = $(this);
      $button = $('button[type=submit], input[type=submit]', $form);
      required = '[required=required]';
      fieldSelector = "input" + required + ", select" + required + ", textarea" + required;
      requireInput = function requireInput() {
        var values;
        values = _.map($(fieldSelector, $form), function (field) {
          // Collect the input values of *all* required fields
          return field.value;
        });
        // Disable the button if any required fields are empty
        if (values.length && _.any(values, _.isEmpty)) {
          return $button.disable();
        } else {
          return $button.enable();
        }
      };
      // Set initial button state
      requireInput();
      return $form.on('change input', fieldSelector, requireInput);
    };

    $(function () {
      var $form, hideOrShowHelpBlock;
      $form = $('form.js-requires-input');
      $form.requiresInput();
      // Hide or Show the help block when creating a new project
      // based on the option selected
      hideOrShowHelpBlock = function hideOrShowHelpBlock(form) {
        var selected;
        selected = $('.js-select-namespace option:selected');
        if (selected.length && selected.data('options-parent') === 'groups') {
          return form.find('.help-block').hide();
        } else if (selected.length) {
          return form.find('.help-block').show();
        }
      };
      hideOrShowHelpBlock($form);
      return $('.select2.js-select-namespace').change(function () {
        return hideOrShowHelpBlock($form);
      });
    });
  }).call(this);
}).call(window);

/***/ }),
/* 239 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable wrap-iife, func-names, space-before-function-paren, prefer-arrow-callback, vars-on-top, no-var, max-len */
  (function (w) {
    $(function () {
      var toggleContainer = function toggleContainer(container, /* optional */toggleState) {
        var $container = $(container);

        $container.find('.js-toggle-button .fa').toggleClass('fa-chevron-up', toggleState).toggleClass('fa-chevron-down', toggleState !== undefined ? !toggleState : undefined);

        $container.find('.js-toggle-content').toggle(toggleState);
      };

      // Toggle button. Show/hide content inside parent container.
      // Button does not change visibility. If button has icon - it changes chevron style.
      //
      // %div.js-toggle-container
      //   %a.js-toggle-button
      //   %div.js-toggle-content
      //
      $('body').on('click', '.js-toggle-button', function (e) {
        e.preventDefault();
        toggleContainer($(this).closest('.js-toggle-container'));
      });

      // If we're accessing a permalink, ensure it is not inside a
      // closed js-toggle-container!
      var hash = w.gl.utils.getLocationHash();
      var anchor = hash && document.getElementById(hash);
      var container = anchor && $(anchor).closest('.js-toggle-container');

      if (container) {
        toggleContainer(container, true);
        anchor.scrollIntoView();
      }
    });
  })(window);
}).call(window);

/***/ }),
/* 240 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, camelcase, object-shorthand, quotes, comma-dangle, prefer-arrow-callback, no-unused-vars, prefer-template, no-useless-escape, no-alert, max-len */
  /* global Dropzone */

  (function () {
    this.BlobFileDropzone = function () {
      function BlobFileDropzone(form, method) {
        var dropzone, form_dropzone, submitButton;
        form_dropzone = form.find('.dropzone');
        Dropzone.autoDiscover = false;
        dropzone = form_dropzone.dropzone({
          autoDiscover: false,
          autoProcessQueue: false,
          url: form.attr('action'),
          // Rails uses a hidden input field for PUT
          // http://stackoverflow.com/questions/21056482/how-to-set-method-put-in-form-tag-in-rails
          method: method,
          clickable: true,
          uploadMultiple: false,
          paramName: "file",
          maxFilesize: gon.max_file_size || 10,
          parallelUploads: 1,
          maxFiles: 1,
          addRemoveLinks: true,
          previewsContainer: '.dropzone-previews',
          headers: {
            "X-CSRF-Token": $("meta[name=\"csrf-token\"]").attr("content")
          },
          init: function init() {
            this.on('addedfile', function (file) {
              $('.dropzone-alerts').html('').hide();
            });
            this.on('success', function (header, response) {
              window.location.href = response.filePath;
            });
            this.on('maxfilesexceeded', function (file) {
              this.removeFile(file);
            });
            return this.on('sending', function (file, xhr, formData) {
              formData.append('target_branch', form.find('.js-target-branch').val());
              formData.append('create_merge_request', form.find('.js-create-merge-request').val());
              formData.append('commit_message', form.find('.js-commit-message').val());
            });
          },
          // Override behavior of adding error underneath preview
          error: function error(file, errorMessage) {
            var stripped;
            stripped = $("<div/>").html(errorMessage).text();
            $('.dropzone-alerts').html('Error uploading file: \"' + stripped + '\"').show();
            this.removeFile(file);
          }
        });
        submitButton = form.find('#submit-all')[0];
        submitButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (dropzone[0].dropzone.getQueuedFiles().length === 0) {
            alert("Please select a file");
          }
          dropzone[0].dropzone.processQueue();
          return false;
        });
      }

      return BlobFileDropzone;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-rest-params */
  /* global Api */

  __webpack_require__(5);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.BlobGitignoreSelector = function (superClass) {
      extend(BlobGitignoreSelector, superClass);

      function BlobGitignoreSelector() {
        return BlobGitignoreSelector.__super__.constructor.apply(this, arguments);
      }

      BlobGitignoreSelector.prototype.requestFile = function (query) {
        return Api.gitignoreText(query.name, this.requestFileSuccess.bind(this));
      };

      return BlobGitignoreSelector;
    }(gl.TemplateSelector);
  }).call(this);
}).call(window);

/***/ }),
/* 242 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-unused-expressions, no-cond-assign, no-sequences, comma-dangle, max-len */
  /* global BlobGitignoreSelector */

  (function () {
    this.BlobGitignoreSelectors = function () {
      function BlobGitignoreSelectors(opts) {
        var ref;
        this.$dropdowns = (ref = opts.$dropdowns) != null ? ref : $('.js-gitignore-selector'), this.editor = opts.editor;
        this.$dropdowns.each(function (_this) {
          return function (i, dropdown) {
            var $dropdown;
            $dropdown = $(dropdown);
            return new BlobGitignoreSelector({
              pattern: /(.gitignore)/,
              data: $dropdown.data('data'),
              wrapper: $dropdown.closest('.js-gitignore-selector-wrap'),
              dropdown: $dropdown,
              editor: _this.editor
            });
          };
        }(this));
      }

      return BlobGitignoreSelectors;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-rest-params, comma-dangle */
  /* global Api */

  __webpack_require__(5);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.BlobLicenseSelector = function (superClass) {
      extend(BlobLicenseSelector, superClass);

      function BlobLicenseSelector() {
        return BlobLicenseSelector.__super__.constructor.apply(this, arguments);
      }

      BlobLicenseSelector.prototype.requestFile = function (query) {
        var data;
        data = {
          project: this.dropdown.data('project'),
          fullname: this.dropdown.data('fullname')
        };
        return Api.licenseText(query.id, data, this.requestFileSuccess.bind(this));
      };

      return BlobLicenseSelector;
    }(gl.TemplateSelector);
  }).call(this);
}).call(window);

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, quotes, no-else-return, object-shorthand, comma-dangle, max-len */
  (function () {
    $(function () {
      var previewPath;
      $('input#broadcast_message_color').on('input', function () {
        var previewColor;
        previewColor = $(this).val();
        return $('div.broadcast-message-preview').css('background-color', previewColor);
      });
      $('input#broadcast_message_font').on('input', function () {
        var previewColor;
        previewColor = $(this).val();
        return $('div.broadcast-message-preview').css('color', previewColor);
      });
      previewPath = $('textarea#broadcast_message_message').data('preview-path');
      return $('textarea#broadcast_message_message').on('input', function () {
        var message;
        message = $(this).val();
        if (message === '') {
          return $('.js-broadcast-message-preview').text("Your message here");
        } else {
          return $.ajax({
            url: previewPath,
            type: "POST",
            data: {
              broadcast_message: {
                message: message
              }
            }
          });
        }
      });
    });
  }).call(this);
}).call(window);

/***/ }),
/* 263 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-param-reassign, quotes, yoda, no-else-return, consistent-return, comma-dangle, object-shorthand, prefer-template, one-var, one-var-declaration-per-line, no-unused-vars, max-len, vars-on-top */
  /* global Breakpoints */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };
    var AUTO_SCROLL_OFFSET = 75;
    var DOWN_BUILD_TRACE = '#down-build-trace';

    this.Build = function () {
      Build.timeout = null;

      Build.state = null;

      function Build(options) {
        options = options || $('.js-build-options').data();
        this.pageUrl = options.pageUrl;
        this.buildUrl = options.buildUrl;
        this.buildStatus = options.buildStatus;
        this.state = options.logState;
        this.buildStage = options.buildStage;
        this.updateDropdown = bind(this.updateDropdown, this);
        this.$document = $(document);
        this.$body = $('body');
        this.$buildTrace = $('#build-trace');
        this.$autoScrollContainer = $('.autoscroll-container');
        this.$autoScrollStatus = $('#autoscroll-status');
        this.$autoScrollStatusText = this.$autoScrollStatus.find('.status-text');
        this.$upBuildTrace = $('#up-build-trace');
        this.$downBuildTrace = $(DOWN_BUILD_TRACE);
        this.$scrollTopBtn = $('#scroll-top');
        this.$scrollBottomBtn = $('#scroll-bottom');
        this.$buildRefreshAnimation = $('.js-build-refresh');

        clearTimeout(Build.timeout);
        // Init breakpoint checker
        this.bp = Breakpoints.get();

        this.initSidebar();
        this.$buildScroll = $('#js-build-scroll');

        this.populateJobs(this.buildStage);
        this.updateStageDropdownText(this.buildStage);
        this.sidebarOnResize();

        this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.sidebarOnClick.bind(this));
        this.$document.off('click', '.stage-item').on('click', '.stage-item', this.updateDropdown);
        this.$document.on('scroll', this.initScrollMonitor.bind(this));
        $(window).off('resize.build').on('resize.build', this.sidebarOnResize.bind(this));
        $('a', this.$buildScroll).off('click.stepTrace').on('click.stepTrace', this.stepTrace);
        this.updateArtifactRemoveDate();
        if ($('#build-trace').length) {
          this.getInitialBuildTrace();
          this.initScrollButtonAffix();
        }
        this.invokeBuildTrace();
      }

      Build.prototype.initSidebar = function () {
        this.$sidebar = $('.js-build-sidebar');
        this.sidebarTranslationLimits = {
          min: $('.navbar-gitlab').outerHeight() + $('.layout-nav').outerHeight()
        };
        this.sidebarTranslationLimits.max = this.sidebarTranslationLimits.min + $('.scrolling-tabs-container').outerHeight();
        this.$sidebar.css({
          top: this.sidebarTranslationLimits.max
        });
        this.$sidebar.niceScroll();
        this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.toggleSidebar);
        this.$document.off('scroll.translateSidebar').on('scroll.translateSidebar', this.translateSidebar.bind(this));
      };

      Build.prototype.location = function () {
        return window.location.href.split("#")[0];
      };

      Build.prototype.invokeBuildTrace = function () {
        var continueRefreshStatuses = ['running', 'pending'];
        // Continue to update build trace when build is running or pending
        if (continueRefreshStatuses.indexOf(this.buildStatus) !== -1) {
          // Check for new build output if user still watching build page
          // Only valid for runnig build when output changes during time
          Build.timeout = setTimeout(function (_this) {
            return function () {
              if (_this.location() === _this.pageUrl) {
                return _this.getBuildTrace();
              }
            };
          }(this), 4000);
        }
      };

      Build.prototype.getInitialBuildTrace = function () {
        var removeRefreshStatuses = ['success', 'failed', 'canceled', 'skipped'];

        return $.ajax({
          url: this.buildUrl,
          dataType: 'json',
          success: function (buildData) {
            $('.js-build-output').html(buildData.trace_html);
            if (window.location.hash === DOWN_BUILD_TRACE) {
              $("html,body").scrollTop(this.$buildTrace.height());
            }
            if (removeRefreshStatuses.indexOf(buildData.status) >= 0) {
              this.$buildRefreshAnimation.remove();
              return this.initScrollMonitor();
            }
          }.bind(this)
        });
      };

      Build.prototype.getBuildTrace = function () {
        return $.ajax({
          url: this.pageUrl + "/trace.json?state=" + encodeURIComponent(this.state),
          dataType: "json",
          success: function (_this) {
            return function (log) {
              var pageUrl;

              if (log.state) {
                _this.state = log.state;
              }
              _this.invokeBuildTrace();
              if (log.status === "running") {
                if (log.append) {
                  $('.js-build-output').append(log.html);
                } else {
                  $('.js-build-output').html(log.html);
                }
                return _this.checkAutoscroll();
              } else if (log.status !== _this.buildStatus) {
                pageUrl = _this.pageUrl;
                if (_this.$autoScrollStatus.data('state') === 'enabled') {
                  pageUrl += DOWN_BUILD_TRACE;
                }

                return gl.utils.visitUrl(pageUrl);
              }
            };
          }(this)
        });
      };

      Build.prototype.checkAutoscroll = function () {
        if (this.$autoScrollStatus.data("state") === "enabled") {
          return $("html,body").scrollTop(this.$buildTrace.height());
        }

        // Handle a situation where user started new build
        // but never scrolled a page
        if (!this.$scrollTopBtn.is(':visible') && !this.$scrollBottomBtn.is(':visible') && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
          this.$scrollBottomBtn.show();
        }
      };

      Build.prototype.initScrollButtonAffix = function () {
        // Hide everything initially
        this.$scrollTopBtn.hide();
        this.$scrollBottomBtn.hide();
        this.$autoScrollContainer.hide();
      };

      // Page scroll listener to detect if user has scrolling page
      // and handle following cases
      // 1) User is at Top of Build Log;
      //      - Hide Top Arrow button
      //      - Show Bottom Arrow button
      //      - Disable Autoscroll and hide indicator (when build is running)
      // 2) User is at Bottom of Build Log;
      //      - Show Top Arrow button
      //      - Hide Bottom Arrow button
      //      - Enable Autoscroll and show indicator (when build is running)
      // 3) User is somewhere in middle of Build Log;
      //      - Show Top Arrow button
      //      - Show Bottom Arrow button
      //      - Disable Autoscroll and hide indicator (when build is running)
      Build.prototype.initScrollMonitor = function () {
        if (!gl.utils.isInViewport(this.$upBuildTrace.get(0)) && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
          // User is somewhere in middle of Build Log

          this.$scrollTopBtn.show();

          if (this.buildStatus === 'success' || this.buildStatus === 'failed') {
            // Check if Build is completed
            this.$scrollBottomBtn.show();
          } else if (this.$buildRefreshAnimation.is(':visible') && !gl.utils.isInViewport(this.$buildRefreshAnimation.get(0))) {
            this.$scrollBottomBtn.show();
          } else {
            this.$scrollBottomBtn.hide();
          }

          // Hide Autoscroll Status Indicator
          if (this.$scrollBottomBtn.is(':visible')) {
            this.$autoScrollContainer.hide();
            this.$autoScrollStatusText.removeClass('animate');
          } else {
            this.$autoScrollContainer.css({ top: this.$body.outerHeight() - AUTO_SCROLL_OFFSET }).show();
            this.$autoScrollStatusText.addClass('animate');
          }
        } else if (gl.utils.isInViewport(this.$upBuildTrace.get(0)) && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
          // User is at Top of Build Log

          this.$scrollTopBtn.hide();
          this.$scrollBottomBtn.show();

          this.$autoScrollContainer.hide();
          this.$autoScrollStatusText.removeClass('animate');
        } else if (!gl.utils.isInViewport(this.$upBuildTrace.get(0)) && gl.utils.isInViewport(this.$downBuildTrace.get(0)) || this.$buildRefreshAnimation.is(':visible') && gl.utils.isInViewport(this.$buildRefreshAnimation.get(0))) {
          // User is at Bottom of Build Log

          this.$scrollTopBtn.show();
          this.$scrollBottomBtn.hide();

          // Show and Reposition Autoscroll Status Indicator
          this.$autoScrollContainer.css({ top: this.$body.outerHeight() - AUTO_SCROLL_OFFSET }).show();
          this.$autoScrollStatusText.addClass('animate');
        } else if (gl.utils.isInViewport(this.$upBuildTrace.get(0)) && gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
          // Build Log height is small

          this.$scrollTopBtn.hide();
          this.$scrollBottomBtn.hide();

          // Hide Autoscroll Status Indicator
          this.$autoScrollContainer.hide();
          this.$autoScrollStatusText.removeClass('animate');
        }

        if (this.buildStatus === "running" || this.buildStatus === "pending") {
          // Check if Refresh Animation is in Viewport and enable Autoscroll, disable otherwise.
          this.$autoScrollStatus.data("state", gl.utils.isInViewport(this.$buildRefreshAnimation.get(0)) ? 'enabled' : 'disabled');
        }
      };

      Build.prototype.shouldHideSidebarForViewport = function () {
        var bootstrapBreakpoint;
        bootstrapBreakpoint = this.bp.getBreakpointSize();
        return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
      };

      Build.prototype.translateSidebar = function (e) {
        var newPosition = this.sidebarTranslationLimits.max - (document.body.scrollTop || document.documentElement.scrollTop);
        if (newPosition < this.sidebarTranslationLimits.min) newPosition = this.sidebarTranslationLimits.min;
        this.$sidebar.css({
          top: newPosition
        });
      };

      Build.prototype.toggleSidebar = function (shouldHide) {
        var shouldShow = typeof shouldHide === 'boolean' ? !shouldHide : undefined;
        this.$buildScroll.toggleClass('sidebar-expanded', shouldShow).toggleClass('sidebar-collapsed', shouldHide);
        this.$sidebar.toggleClass('right-sidebar-expanded', shouldShow).toggleClass('right-sidebar-collapsed', shouldHide);
      };

      Build.prototype.sidebarOnResize = function () {
        this.toggleSidebar(this.shouldHideSidebarForViewport());
      };

      Build.prototype.sidebarOnClick = function () {
        if (this.shouldHideSidebarForViewport()) this.toggleSidebar();
      };

      Build.prototype.updateArtifactRemoveDate = function () {
        var $date, date;
        $date = $('.js-artifacts-remove');
        if ($date.length) {
          date = $date.text();
          return $date.text(gl.utils.timeFor(new Date(date.replace(/([0-9]+)-([0-9]+)-([0-9]+)/g, '$1/$2/$3')), ' '));
        }
      };

      Build.prototype.populateJobs = function (stage) {
        $('.build-job').hide();
        $('.build-job[data-stage="' + stage + '"]').show();
      };

      Build.prototype.updateStageDropdownText = function (stage) {
        $('.stage-selection').text(stage);
      };

      Build.prototype.updateDropdown = function (e) {
        e.preventDefault();
        var stage = e.currentTarget.text;
        this.updateStageDropdownText(stage);
        this.populateJobs(stage);
      };

      Build.prototype.stepTrace = function (e) {
        var $currentTarget;
        e.preventDefault();
        $currentTarget = $(e.currentTarget);
        $.scrollTo($currentTarget.attr('href'), {
          offset: -($('.navbar-gitlab').outerHeight() + $('.layout-nav').outerHeight())
        });
      };

      return Build;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, no-return-assign, max-len */
  (function () {
    this.BuildArtifacts = function () {
      function BuildArtifacts() {
        this.disablePropagation();
        this.setupEntryClick();
      }

      BuildArtifacts.prototype.disablePropagation = function () {
        $('.top-block').on('click', '.download', function (e) {
          return e.stopPropagation();
        });
        return $('.tree-holder').on('click', 'tr[data-link] a', function (e) {
          return e.stopImmediatePropagation();
        });
      };

      BuildArtifacts.prototype.setupEntryClick = function () {
        return $('.tree-holder').on('click', 'tr[data-link]', function (e) {
          return window.location = this.dataset.link;
        });
      };

      return BuildArtifacts;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 265 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife */
  /* global CommitFile */

  (function () {
    this.Commit = function () {
      function Commit() {
        $('.files .diff-file').each(function () {
          return new CommitFile(this);
        });
      }

      return Commit;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-new */
  /* global ImageFile */

  (function () {
    this.CommitFile = function () {
      function CommitFile(file) {
        if ($('.image', file).length) {
          new gl.ImageFile(file);
        }
      }

      return CommitFile;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 267 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */
  (function () {
    gl.ImageFile = function () {
      var prepareFrames;

      // Width where images must fits in, for 2-up this gets divided by 2
      ImageFile.availWidth = 900;

      ImageFile.viewModes = ['two-up', 'swipe'];

      function ImageFile(file) {
        this.file = file;
        this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
          // Determine if old and new file has same dimensions, if not show 'two-up' view
          return function (deletedWidth, deletedHeight) {
            return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
              if (width === deletedWidth && height === deletedHeight) {
                return _this.initViewModes();
              } else {
                return _this.initView('two-up');
              }
            });
          };
        }(this));
      }

      ImageFile.prototype.initViewModes = function () {
        var viewMode;
        viewMode = ImageFile.viewModes[0];
        $('.view-modes', this.file).removeClass('hide');
        $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
          return function (event) {
            if (!$(event.currentTarget).hasClass('active')) {
              return _this.activateViewMode(event.currentTarget.className);
            }
          };
        }(this));
        return this.activateViewMode(viewMode);
      };

      ImageFile.prototype.activateViewMode = function (viewMode) {
        $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
        return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
          return function () {
            $(".view." + viewMode, _this.file).fadeIn(200);
            return _this.initView(viewMode);
          };
        }(this));
      };

      ImageFile.prototype.initView = function (viewMode) {
        return this.views[viewMode].call(this);
      };

      prepareFrames = function prepareFrames(view) {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        $('.frame', view).each(function (_this) {
          return function (index, frame) {
            var height, width;
            width = $(frame).width();
            height = $(frame).height();
            maxWidth = width > maxWidth ? width : maxWidth;
            return maxHeight = height > maxHeight ? height : maxHeight;
          };
        }(this)).css({
          width: maxWidth,
          height: maxHeight
        });
        return [maxWidth, maxHeight];
      };

      ImageFile.prototype.views = {
        'two-up': function twoUp() {
          return $('.two-up.view .wrap', this.file).each(function (_this) {
            return function (index, wrap) {
              $('img', wrap).each(function () {
                var currentWidth;
                currentWidth = $(this).width();
                if (currentWidth > ImageFile.availWidth / 2) {
                  return $(this).width(ImageFile.availWidth / 2);
                }
              });
              return _this.requestImageInfo($('img', wrap), function (width, height) {
                $('.image-info .meta-width', wrap).text(width + "px");
                $('.image-info .meta-height', wrap).text(height + "px");
                return $('.image-info', wrap).removeClass('hide');
              });
            };
          }(this));
        },
        'swipe': function swipe() {
          var maxHeight, maxWidth;
          maxWidth = 0;
          maxHeight = 0;
          return $('.swipe.view', this.file).each(function (_this) {
            return function (index, view) {
              var ref;
              ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
              $('.swipe-frame', view).css({
                width: maxWidth + 16,
                height: maxHeight + 28
              });
              $('.swipe-wrap', view).css({
                width: maxWidth + 1,
                height: maxHeight + 2
              });
              return $('.swipe-bar', view).css({
                left: 0
              }).draggable({
                axis: 'x',
                containment: 'parent',
                drag: function drag(event) {
                  return $('.swipe-wrap', view).width(maxWidth + 1 - $(this).position().left);
                },
                stop: function stop(event) {
                  return $('.swipe-wrap', view).width(maxWidth + 1 - $(this).position().left);
                }
              });
            };
          }(this));
        },
        'onion-skin': function onionSkin() {
          var dragTrackWidth, maxHeight, maxWidth;
          maxWidth = 0;
          maxHeight = 0;
          dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
          return $('.onion-skin.view', this.file).each(function (_this) {
            return function (index, view) {
              var ref;
              ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
              $('.onion-skin-frame', view).css({
                width: maxWidth + 16,
                height: maxHeight + 28
              });
              $('.swipe-wrap', view).css({
                width: maxWidth + 1,
                height: maxHeight + 2
              });
              return $('.dragger', view).css({
                left: dragTrackWidth
              }).draggable({
                axis: 'x',
                containment: 'parent',
                drag: function drag(event) {
                  return $('.frame.added', view).css('opacity', $(this).position().left / dragTrackWidth);
                },
                stop: function stop(event) {
                  return $('.frame.added', view).css('opacity', $(this).position().left / dragTrackWidth);
                }
              });
            };
          }(this));
        }
      };

      ImageFile.prototype.requestImageInfo = function (img, callback) {
        var domImg;
        domImg = img.get(0);
        if (domImg) {
          if (domImg.complete) {
            return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
          } else {
            return img.on('load', function (_this) {
              return function () {
                return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
              };
            }(this));
          }
        }
      };

      return ImageFile;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, consistent-return, no-return-assign, no-param-reassign, one-var, no-var, one-var-declaration-per-line, no-unused-vars, prefer-template, object-shorthand, comma-dangle, max-len, prefer-arrow-callback */
  /* global Pager */

  (function () {
    this.CommitsList = function () {
      var CommitsList = {};

      CommitsList.timer = null;

      CommitsList.init = function (limit) {
        $("body").on("click", ".day-commits-table li.commit", function (e) {
          if (e.target.nodeName !== "A") {
            location.href = $(this).attr("url");
            e.stopPropagation();
            return false;
          }
        });
        Pager.init(limit, false, false, function () {
          gl.utils.localTimeAgo($('.js-timeago'));
        });
        this.content = $("#commits-list");
        this.searchField = $("#commits-search");
        this.lastSearch = this.searchField.val();
        return this.initSearch();
      };

      CommitsList.initSearch = function () {
        this.timer = null;
        return this.searchField.keyup(function (_this) {
          return function () {
            clearTimeout(_this.timer);
            return _this.timer = setTimeout(_this.filterResults, 500);
          };
        }(this));
      };

      CommitsList.filterResults = function () {
        var commitsUrl, form, search;
        form = $(".commits-search-form");
        search = CommitsList.searchField.val();
        if (search === CommitsList.lastSearch) return;
        commitsUrl = form.attr("action") + '?' + form.serialize();
        CommitsList.content.fadeTo('fast', 0.5);
        return $.ajax({
          type: "GET",
          url: form.attr("action"),
          data: form.serialize(),
          complete: function complete() {
            return CommitsList.content.fadeTo('fast', 1.0);
          },
          success: function success(data) {
            CommitsList.lastSearch = search;
            CommitsList.content.html(data.html);
            return history.replaceState({
              page: commitsUrl
              // Change url so if user reload a page - search results are saved
            }, document.title, commitsUrl);
          },
          error: function error() {
            CommitsList.lastSearch = null;
          },
          dataType: "json"
        });
      };

      return CommitsList;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 271 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, object-shorthand, consistent-return, no-unused-vars, comma-dangle, vars-on-top, prefer-template, max-len */
  (function () {
    this.Compare = function () {
      function Compare(opts) {
        this.opts = opts;
        this.source_loading = $(".js-source-loading");
        this.target_loading = $(".js-target-loading");
        $('.js-compare-dropdown').each(function (_this) {
          return function (i, dropdown) {
            var $dropdown;
            $dropdown = $(dropdown);
            return $dropdown.glDropdown({
              selectable: true,
              fieldName: $dropdown.data('field-name'),
              filterable: true,
              id: function id(obj, $el) {
                return $el.data('id');
              },
              toggleLabel: function toggleLabel(obj, $el) {
                return $el.text().trim();
              },
              clicked: function clicked(e, el) {
                if ($dropdown.is('.js-target-branch')) {
                  return _this.getTargetHtml();
                } else if ($dropdown.is('.js-source-branch')) {
                  return _this.getSourceHtml();
                } else if ($dropdown.is('.js-target-project')) {
                  return _this.getTargetProject();
                }
              }
            });
          };
        }(this));
        this.initialState();
      }

      Compare.prototype.initialState = function () {
        this.getSourceHtml();
        return this.getTargetHtml();
      };

      Compare.prototype.getTargetProject = function () {
        return $.ajax({
          url: this.opts.targetProjectUrl,
          data: {
            target_project_id: $("input[name='merge_request[target_project_id]']").val()
          },
          beforeSend: function beforeSend() {
            return $('.mr_target_commit').empty();
          },
          success: function success(html) {
            return $('.js-target-branch-dropdown .dropdown-content').html(html);
          }
        });
      };

      Compare.prototype.getSourceHtml = function () {
        return this.sendAjax(this.opts.sourceBranchUrl, this.source_loading, '.mr_source_commit', {
          ref: $("input[name='merge_request[source_branch]']").val()
        });
      };

      Compare.prototype.getTargetHtml = function () {
        return this.sendAjax(this.opts.targetBranchUrl, this.target_loading, '.mr_target_commit', {
          target_project_id: $("input[name='merge_request[target_project_id]']").val(),
          ref: $("input[name='merge_request[target_branch]']").val()
        });
      };

      Compare.prototype.sendAjax = function (url, loading, target, data) {
        var $target;
        $target = $(target);
        return $.ajax({
          url: url,
          data: data,
          beforeSend: function beforeSend() {
            loading.show();
            return $target.empty();
          },
          success: function success(html) {
            loading.hide();
            $target.html(html);
            var className = '.' + $target[0].className.replace(' ', '.');
            gl.utils.localTimeAgo($('.js-timeago', className));
          }
        });
      };

      return Compare;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 272 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, camelcase, one-var-declaration-per-line, no-else-return, max-len */
  (function () {
    this.ConfirmDangerModal = function () {
      function ConfirmDangerModal(form, text) {
        var project_path, submit;
        this.form = form;
        $('.js-confirm-text').text(text || '');
        $('.js-confirm-danger-input').val('');
        $('#modal-confirm-danger').modal('show');
        project_path = $('.js-confirm-danger-match').text();
        submit = $('.js-confirm-danger-submit');
        submit.disable();
        $('.js-confirm-danger-input').off('input');
        $('.js-confirm-danger-input').on('input', function () {
          if (gl.utils.rstrip($(this).val()) === project_path) {
            return submit.enable();
          } else {
            return submit.disable();
          }
        });
        $('.js-confirm-danger-submit').off('click');
        $('.js-confirm-danger-submit').on('click', function (_this) {
          return function () {
            return _this.form.submit();
          };
        }(this));
      }

      return ConfirmDangerModal;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, prefer-template, quotes, no-unused-vars, prefer-arrow-callback, max-len */
  /* global Clipboard */

  window.Clipboard = __webpack_require__(353);

  (function () {
    var genericError, genericSuccess, showTooltip;

    genericSuccess = function genericSuccess(e) {
      showTooltip(e.trigger, 'Copied');
      // Clear the selection and blur the trigger so it loses its border
      e.clearSelection();
      return $(e.trigger).blur();
    };

    // Safari doesn't support `execCommand`, so instead we inform the user to
    // copy manually.
    //
    // See http://clipboardjs.com/#browser-support
    genericError = function genericError(e) {
      var key;
      if (/Mac/i.test(navigator.userAgent)) {
        key = '&#8984;'; // Command
      } else {
        key = 'Ctrl';
      }
      return showTooltip(e.trigger, "Press " + key + "-C to copy");
    };

    showTooltip = function showTooltip(target, title) {
      var $target = $(target);
      var originalTitle = $target.data('original-title');

      $target.attr('title', 'Copied').tooltip('fixTitle').tooltip('show').attr('title', originalTitle).tooltip('fixTitle');
    };

    $(function () {
      var clipboard;

      clipboard = new Clipboard('[data-clipboard-target], [data-clipboard-text]');
      clipboard.on('success', genericSuccess);
      return clipboard.on('error', genericError);
    });
  }).call(this);
}).call(window);

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable */
  // Determine where to place this
  if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) {
      // .length of function is 2
      'use strict';

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }

  (function (f) {
    if (( false ? 'undefined' : _typeof(exports)) === "object" && typeof module !== "undefined") {
      module.exports = f();
    } else if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      var g;if (typeof window !== "undefined") {
        g = window;
      } else if (typeof global !== "undefined") {
        g = global;
      } else if (typeof self !== "undefined") {
        g = self;
      } else {
        g = this;
      }g.droplab = f();
    }
  })(function () {
    var define, module, exports;return function e(t, n, r) {
      function s(o, u) {
        if (!n[o]) {
          if (!t[o]) {
            var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
          }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
            var n = t[o][1][e];return s(n ? n : e);
          }, l, l.exports, e, t, n, r);
        }return n[o].exports;
      }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
        s(r[o]);
      }return s;
    }({ 1: [function (require, module, exports) {
        var DATA_TRIGGER = 'data-dropdown-trigger';
        var DATA_DROPDOWN = 'data-dropdown';

        module.exports = {
          DATA_TRIGGER: DATA_TRIGGER,
          DATA_DROPDOWN: DATA_DROPDOWN
        };
      }, {}], 2: [function (require, module, exports) {
        // Custom event support for IE
        if (typeof CustomEvent === "function") {
          module.exports = CustomEvent;
        } else {
          require('./window')(function (w) {
            var CustomEvent = function CustomEvent(event, params) {
              params = params || { bubbles: false, cancelable: false, detail: undefined };
              var evt = document.createEvent('CustomEvent');
              evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
              return evt;
            };
            CustomEvent.prototype = w.Event.prototype;

            w.CustomEvent = CustomEvent;
          });
          module.exports = CustomEvent;
        }
      }, { "./window": 11 }], 3: [function (require, module, exports) {
        var CustomEvent = require('./custom_event_polyfill');
        var utils = require('./utils');

        var DropDown = function DropDown(list) {
          this.currentIndex = 0;
          this.hidden = true;
          this.list = list;
          this.items = [];
          this.getItems();
          this.initTemplateString();
          this.addEvents();
          this.initialState = list.innerHTML;
        };

        Object.assign(DropDown.prototype, {
          getItems: function getItems() {
            this.items = [].slice.call(this.list.querySelectorAll('li'));
            return this.items;
          },

          initTemplateString: function initTemplateString() {
            var items = this.items || this.getItems();

            var templateString = '';
            if (items.length > 0) {
              templateString = items[items.length - 1].outerHTML;
            }
            this.templateString = templateString;
            return this.templateString;
          },

          clickEvent: function clickEvent(e) {
            // climb up the tree to find the LI
            var selected = utils.closest(e.target, 'LI');

            if (selected) {
              e.preventDefault();
              this.hide();
              var listEvent = new CustomEvent('click.dl', {
                detail: {
                  list: this,
                  selected: selected,
                  data: e.target.dataset
                }
              });
              this.list.dispatchEvent(listEvent);
            }
          },

          addEvents: function addEvents() {
            this.clickWrapper = this.clickEvent.bind(this);
            // event delegation.
            this.list.addEventListener('click', this.clickWrapper);
          },

          toggle: function toggle() {
            if (this.hidden) {
              this.show();
            } else {
              this.hide();
            }
          },

          setData: function setData(data) {
            this.data = data;
            this.render(data);
          },

          addData: function addData(data) {
            this.data = (this.data || []).concat(data);
            this.render(this.data);
          },

          // call render manually on data;
          render: function render(data) {
            // debugger
            // empty the list first
            var templateString = this.templateString;
            var newChildren = [];
            var toAppend;

            newChildren = (data || []).map(function (dat) {
              var html = utils.t(templateString, dat);
              var template = document.createElement('div');
              template.innerHTML = html;

              // Help set the image src template
              var imageTags = template.querySelectorAll('img[data-src]');
              // debugger
              for (var i = 0; i < imageTags.length; i++) {
                var imageTag = imageTags[i];
                imageTag.src = imageTag.getAttribute('data-src');
                imageTag.removeAttribute('data-src');
              }

              if (dat.hasOwnProperty('droplab_hidden') && dat.droplab_hidden) {
                template.firstChild.style.display = 'none';
              } else {
                template.firstChild.style.display = 'block';
              }
              return template.firstChild.outerHTML;
            });
            toAppend = this.list.querySelector('ul[data-dynamic]');
            if (toAppend) {
              toAppend.innerHTML = newChildren.join('');
            } else {
              this.list.innerHTML = newChildren.join('');
            }
          },

          show: function show() {
            if (this.hidden) {
              // debugger
              this.list.style.display = 'block';
              this.currentIndex = 0;
              this.hidden = false;
            }
          },

          hide: function hide() {
            if (!this.hidden) {
              // debugger
              this.list.style.display = 'none';
              this.currentIndex = 0;
              this.hidden = true;
            }
          },

          destroy: function destroy() {
            this.hide();
            this.list.removeEventListener('click', this.clickWrapper);
          }
        });

        module.exports = DropDown;
      }, { "./custom_event_polyfill": 2, "./utils": 10 }], 4: [function (require, module, exports) {
        require('./window')(function (w) {
          module.exports = function (deps) {
            deps = deps || {};
            var window = deps.window || w;
            var document = deps.document || window.document;
            var CustomEvent = deps.CustomEvent || require('./custom_event_polyfill');
            var HookButton = deps.HookButton || require('./hook_button');
            var HookInput = deps.HookInput || require('./hook_input');
            var utils = deps.utils || require('./utils');
            var DATA_TRIGGER = require('./constants').DATA_TRIGGER;

            var DropLab = function DropLab(hook) {
              if (!(this instanceof DropLab)) return new DropLab(hook);
              this.ready = false;
              this.hooks = [];
              this.queuedData = [];
              this.config = {};
              this.loadWrapper;
              if (typeof hook !== 'undefined') {
                this.addHook(hook);
              }
            };

            Object.assign(DropLab.prototype, {
              load: function load() {
                this.loadWrapper();
              },

              loadWrapper: function loadWrapper() {
                var dropdownTriggers = [].slice.apply(document.querySelectorAll('[' + DATA_TRIGGER + ']'));
                this.addHooks(dropdownTriggers).init();
              },

              addData: function addData() {
                var args = [].slice.apply(arguments);
                this.applyArgs(args, '_addData');
              },

              setData: function setData() {
                var args = [].slice.apply(arguments);
                this.applyArgs(args, '_setData');
              },

              destroy: function destroy() {
                for (var i = 0; i < this.hooks.length; i++) {
                  this.hooks[i].destroy();
                }
                this.hooks = [];
                this.removeEvents();
              },

              applyArgs: function applyArgs(args, methodName) {
                if (this.ready) {
                  this[methodName].apply(this, args);
                } else {
                  this.queuedData = this.queuedData || [];
                  this.queuedData.push(args);
                }
              },

              _addData: function _addData(trigger, data) {
                this._processData(trigger, data, 'addData');
              },

              _setData: function _setData(trigger, data) {
                this._processData(trigger, data, 'setData');
              },

              _processData: function _processData(trigger, data, methodName) {
                for (var i = 0; i < this.hooks.length; i++) {
                  var hook = this.hooks[i];
                  if (hook.trigger.dataset.hasOwnProperty('id')) {
                    if (hook.trigger.dataset.id === trigger) {
                      hook.list[methodName](data);
                    }
                  }
                }
              },

              addEvents: function addEvents() {
                var self = this;
                this.windowClickedWrapper = function (e) {
                  var thisTag = e.target;
                  if (thisTag.tagName !== 'UL') {
                    // climb up the tree to find the UL
                    thisTag = utils.closest(thisTag, 'UL');
                  }
                  if (utils.isDropDownParts(thisTag)) {
                    return;
                  }
                  if (utils.isDropDownParts(e.target)) {
                    return;
                  }
                  for (var i = 0; i < self.hooks.length; i++) {
                    self.hooks[i].list.hide();
                  }
                }.bind(this);
                document.addEventListener('click', this.windowClickedWrapper);
              },

              removeEvents: function removeEvents() {
                w.removeEventListener('click', this.windowClickedWrapper);
                w.removeEventListener('load', this.loadWrapper);
              },

              changeHookList: function changeHookList(trigger, list, plugins, config) {
                trigger = document.querySelector('[data-id="' + trigger + '"]');
                // list = document.querySelector(list);
                this.hooks.every(function (hook, i) {
                  if (hook.trigger === trigger) {
                    hook.destroy();
                    this.hooks.splice(i, 1);
                    this.addHook(trigger, list, plugins, config);
                    return false;
                  }
                  return true;
                }.bind(this));
              },

              addHook: function addHook(hook, list, plugins, config) {
                if (!(hook instanceof HTMLElement) && typeof hook === 'string') {
                  hook = document.querySelector(hook);
                }
                if (!list) {
                  list = document.querySelector(hook.dataset[utils.toDataCamelCase(DATA_TRIGGER)]);
                }

                if (hook) {
                  if (hook.tagName === 'A' || hook.tagName === 'BUTTON') {
                    this.hooks.push(new HookButton(hook, list, plugins, config));
                  } else if (hook.tagName === 'INPUT') {
                    this.hooks.push(new HookInput(hook, list, plugins, config));
                  }
                }
                return this;
              },

              addHooks: function addHooks(hooks, plugins, config) {
                for (var i = 0; i < hooks.length; i++) {
                  var hook = hooks[i];
                  this.addHook(hook, null, plugins, config);
                }
                return this;
              },

              setConfig: function setConfig(obj) {
                this.config = obj;
              },

              init: function init() {
                this.addEvents();
                var readyEvent = new CustomEvent('ready.dl', {
                  detail: {
                    dropdown: this
                  }
                });
                window.dispatchEvent(readyEvent);
                this.ready = true;
                for (var i = 0; i < this.queuedData.length; i++) {
                  this.addData.apply(this, this.queuedData[i]);
                }
                this.queuedData = [];
                return this;
              }
            });

            return DropLab;
          };
        });
      }, { "./constants": 1, "./custom_event_polyfill": 2, "./hook_button": 6, "./hook_input": 7, "./utils": 10, "./window": 11 }], 5: [function (require, module, exports) {
        var DropDown = require('./dropdown');

        var Hook = function Hook(trigger, list, plugins, config) {
          this.trigger = trigger;
          this.list = new DropDown(list);
          this.type = 'Hook';
          this.event = 'click';
          this.plugins = plugins || [];
          this.config = config || {};
          this.id = trigger.dataset.id;
        };

        Object.assign(Hook.prototype, {

          addEvents: function addEvents() {},

          constructor: Hook
        });

        module.exports = Hook;
      }, { "./dropdown": 3 }], 6: [function (require, module, exports) {
        var CustomEvent = require('./custom_event_polyfill');
        var Hook = require('./hook');

        var HookButton = function HookButton(trigger, list, plugins, config) {
          Hook.call(this, trigger, list, plugins, config);
          this.type = 'button';
          this.event = 'click';
          this.addEvents();
          this.addPlugins();
        };

        HookButton.prototype = Object.create(Hook.prototype);

        Object.assign(HookButton.prototype, {
          addPlugins: function addPlugins() {
            for (var i = 0; i < this.plugins.length; i++) {
              this.plugins[i].init(this);
            }
          },

          clicked: function clicked(e) {
            var buttonEvent = new CustomEvent('click.dl', {
              detail: {
                hook: this
              },
              bubbles: true,
              cancelable: true
            });
            this.list.show();
            e.target.dispatchEvent(buttonEvent);
          },

          addEvents: function addEvents() {
            this.clickedWrapper = this.clicked.bind(this);
            this.trigger.addEventListener('click', this.clickedWrapper);
          },

          removeEvents: function removeEvents() {
            this.trigger.removeEventListener('click', this.clickedWrapper);
          },

          restoreInitialState: function restoreInitialState() {
            this.list.list.innerHTML = this.list.initialState;
          },

          removePlugins: function removePlugins() {
            for (var i = 0; i < this.plugins.length; i++) {
              this.plugins[i].destroy();
            }
          },

          destroy: function destroy() {
            this.restoreInitialState();
            this.removeEvents();
            this.removePlugins();
          },

          constructor: HookButton
        });

        module.exports = HookButton;
      }, { "./custom_event_polyfill": 2, "./hook": 5 }], 7: [function (require, module, exports) {
        var CustomEvent = require('./custom_event_polyfill');
        var Hook = require('./hook');

        var HookInput = function HookInput(trigger, list, plugins, config) {
          Hook.call(this, trigger, list, plugins, config);
          this.type = 'input';
          this.event = 'input';
          this.addPlugins();
          this.addEvents();
        };

        Object.assign(HookInput.prototype, {
          addPlugins: function addPlugins() {
            var self = this;
            for (var i = 0; i < this.plugins.length; i++) {
              this.plugins[i].init(self);
            }
          },

          addEvents: function addEvents() {
            var self = this;

            this.mousedown = function mousedown(e) {
              if (self.hasRemovedEvents) return;

              var mouseEvent = new CustomEvent('mousedown.dl', {
                detail: {
                  hook: self,
                  text: e.target.value
                },
                bubbles: true,
                cancelable: true
              });
              e.target.dispatchEvent(mouseEvent);
            };

            this.input = function input(e) {
              if (self.hasRemovedEvents) return;

              self.list.show();

              var inputEvent = new CustomEvent('input.dl', {
                detail: {
                  hook: self,
                  text: e.target.value
                },
                bubbles: true,
                cancelable: true
              });
              e.target.dispatchEvent(inputEvent);
            };

            this.keyup = function keyup(e) {
              if (self.hasRemovedEvents) return;

              keyEvent(e, 'keyup.dl');
            };

            this.keydown = function keydown(e) {
              if (self.hasRemovedEvents) return;

              keyEvent(e, 'keydown.dl');
            };

            function keyEvent(e, keyEventName) {
              self.list.show();

              var keyEvent = new CustomEvent(keyEventName, {
                detail: {
                  hook: self,
                  text: e.target.value,
                  which: e.which,
                  key: e.key
                },
                bubbles: true,
                cancelable: true
              });
              e.target.dispatchEvent(keyEvent);
            }

            this.events = this.events || {};
            this.events.mousedown = this.mousedown;
            this.events.input = this.input;
            this.events.keyup = this.keyup;
            this.events.keydown = this.keydown;
            this.trigger.addEventListener('mousedown', this.mousedown);
            this.trigger.addEventListener('input', this.input);
            this.trigger.addEventListener('keyup', this.keyup);
            this.trigger.addEventListener('keydown', this.keydown);
          },

          removeEvents: function removeEvents() {
            this.hasRemovedEvents = true;
            this.trigger.removeEventListener('mousedown', this.mousedown);
            this.trigger.removeEventListener('input', this.input);
            this.trigger.removeEventListener('keyup', this.keyup);
            this.trigger.removeEventListener('keydown', this.keydown);
          },

          restoreInitialState: function restoreInitialState() {
            this.list.list.innerHTML = this.list.initialState;
          },

          removePlugins: function removePlugins() {
            for (var i = 0; i < this.plugins.length; i++) {
              this.plugins[i].destroy();
            }
          },

          destroy: function destroy() {
            this.restoreInitialState();
            this.removeEvents();
            this.removePlugins();
            this.list.destroy();
          }
        });

        module.exports = HookInput;
      }, { "./custom_event_polyfill": 2, "./hook": 5 }], 8: [function (require, module, exports) {
        var DropLab = require('./droplab')();
        var DATA_TRIGGER = require('./constants').DATA_TRIGGER;
        var keyboard = require('./keyboard')();
        var setup = function setup() {
          window.DropLab = DropLab;
        };

        module.exports = setup();
      }, { "./constants": 1, "./droplab": 4, "./keyboard": 9 }], 9: [function (require, module, exports) {
        require('./window')(function (w) {
          module.exports = function () {
            var currentKey;
            var currentFocus;
            var isUpArrow = false;
            var isDownArrow = false;
            var removeHighlight = function removeHighlight(list) {
              var listItems = Array.prototype.slice.call(list.list.querySelectorAll('li:not(.divider)'), 0);
              var listItemsTmp = [];
              for (var i = 0; i < listItems.length; i++) {
                var listItem = listItems[i];
                listItem.classList.remove('dropdown-active');

                if (listItem.style.display !== 'none') {
                  listItemsTmp.push(listItem);
                }
              }
              return listItemsTmp;
            };

            var setMenuForArrows = function setMenuForArrows(list) {
              var listItems = removeHighlight(list);
              if (list.currentIndex > 0) {
                if (!listItems[list.currentIndex - 1]) {
                  list.currentIndex = list.currentIndex - 1;
                }

                if (listItems[list.currentIndex - 1]) {
                  var el = listItems[list.currentIndex - 1];
                  var filterDropdownEl = el.closest('.filter-dropdown');
                  el.classList.add('dropdown-active');

                  if (filterDropdownEl) {
                    var filterDropdownBottom = filterDropdownEl.offsetHeight;
                    var elOffsetTop = el.offsetTop - 30;

                    if (elOffsetTop > filterDropdownBottom) {
                      filterDropdownEl.scrollTop = elOffsetTop - filterDropdownBottom;
                    }
                  }
                }
              }
            };

            var mousedown = function mousedown(e) {
              var list = e.detail.hook.list;
              removeHighlight(list);
              list.show();
              list.currentIndex = 0;
              isUpArrow = false;
              isDownArrow = false;
            };
            var selectItem = function selectItem(list) {
              var listItems = removeHighlight(list);
              var currentItem = listItems[list.currentIndex - 1];
              var listEvent = new CustomEvent('click.dl', {
                detail: {
                  list: list,
                  selected: currentItem,
                  data: currentItem.dataset
                }
              });
              list.list.dispatchEvent(listEvent);
              list.hide();
            };

            var keydown = function keydown(e) {
              var typedOn = e.target;
              var list = e.detail.hook.list;
              var currentIndex = list.currentIndex;
              isUpArrow = false;
              isDownArrow = false;

              if (e.detail.which) {
                currentKey = e.detail.which;
                if (currentKey === 13) {
                  selectItem(e.detail.hook.list);
                  return;
                }
                if (currentKey === 38) {
                  isUpArrow = true;
                }
                if (currentKey === 40) {
                  isDownArrow = true;
                }
              } else if (e.detail.key) {
                currentKey = e.detail.key;
                if (currentKey === 'Enter') {
                  selectItem(e.detail.hook.list);
                  return;
                }
                if (currentKey === 'ArrowUp') {
                  isUpArrow = true;
                }
                if (currentKey === 'ArrowDown') {
                  isDownArrow = true;
                }
              }
              if (isUpArrow) {
                currentIndex--;
              }
              if (isDownArrow) {
                currentIndex++;
              }
              if (currentIndex < 0) {
                currentIndex = 0;
              }
              list.currentIndex = currentIndex;
              setMenuForArrows(e.detail.hook.list);
            };

            w.addEventListener('mousedown.dl', mousedown);
            w.addEventListener('keydown.dl', keydown);
          };
        });
      }, { "./window": 11 }], 10: [function (require, module, exports) {
        var DATA_TRIGGER = require('./constants').DATA_TRIGGER;
        var DATA_DROPDOWN = require('./constants').DATA_DROPDOWN;

        var toDataCamelCase = function toDataCamelCase(attr) {
          return this.camelize(attr.split('-').slice(1).join(' '));
        };

        // the tiniest damn templating I can do
        var t = function t(s, d) {
          for (var p in d) {
            s = s.replace(new RegExp('{{' + p + '}}', 'g'), d[p]);
          }return s;
        };

        var camelize = function camelize(str) {
          return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
            return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
          }).replace(/\s+/g, '');
        };

        var closest = function closest(thisTag, stopTag) {
          while (thisTag && thisTag.tagName !== stopTag && thisTag.tagName !== 'HTML') {
            thisTag = thisTag.parentNode;
          }
          return thisTag;
        };

        var isDropDownParts = function isDropDownParts(target) {
          if (!target || target.tagName === 'HTML') {
            return false;
          }
          return target.hasAttribute(DATA_TRIGGER) || target.hasAttribute(DATA_DROPDOWN);
        };

        module.exports = {
          toDataCamelCase: toDataCamelCase,
          t: t,
          camelize: camelize,
          closest: closest,
          isDropDownParts: isDropDownParts
        };
      }, { "./constants": 1 }], 11: [function (require, module, exports) {
        module.exports = function (callback) {
          return function () {
            callback(this);
          }.call(null);
        };
      }, {}] }, {}, [8])(8);
  });
}).call(window);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable */
  (function (f) {
    if (( false ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
      module.exports = f();
    } else if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      var g;if (typeof window !== "undefined") {
        g = window;
      } else if (typeof global !== "undefined") {
        g = global;
      } else if (typeof self !== "undefined") {
        g = self;
      } else {
        g = this;
      }g = g.droplab || (g.droplab = {});g = g.ajax || (g.ajax = {});g = g.datasource || (g.datasource = {});g.js = f();
    }
  })(function () {
    var define, module, exports;return function e(t, n, r) {
      function s(o, u) {
        if (!n[o]) {
          if (!t[o]) {
            var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
          }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
            var n = t[o][1][e];return s(n ? n : e);
          }, l, l.exports, e, t, n, r);
        }return n[o].exports;
      }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
        s(r[o]);
      }return s;
    }({ 1: [function (require, module, exports) {
        /* global droplab */

        require('../window')(function (w) {
          function droplabAjaxException(message) {
            this.message = message;
          }

          w.droplabAjax = {
            _loadUrlData: function _loadUrlData(url) {
              var self = this;
              return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                      var data = JSON.parse(xhr.responseText);
                      self.cache[url] = data;
                      return resolve(data);
                    } else {
                      return reject([xhr.responseText, xhr.status]);
                    }
                  }
                };
                xhr.send();
              });
            },

            _loadData: function _loadData(data, config, self) {
              if (config.loadingTemplate) {
                var dataLoadingTemplate = self.hook.list.list.querySelector('[data-loading-template]');

                if (dataLoadingTemplate) {
                  dataLoadingTemplate.outerHTML = self.listTemplate;
                }
              }

              self.hook.list[config.method].call(self.hook.list, data);
            },

            init: function init(hook) {
              var self = this;
              self.cache = self.cache || {};
              var config = hook.config.droplabAjax;
              this.hook = hook;

              if (!config || !config.endpoint || !config.method) {
                return;
              }

              if (config.method !== 'setData' && config.method !== 'addData') {
                return;
              }

              if (config.loadingTemplate) {
                var dynamicList = hook.list.list.querySelector('[data-dynamic]');

                var loadingTemplate = document.createElement('div');
                loadingTemplate.innerHTML = config.loadingTemplate;
                loadingTemplate.setAttribute('data-loading-template', '');

                this.listTemplate = dynamicList.outerHTML;
                dynamicList.outerHTML = loadingTemplate.outerHTML;
              }

              if (self.cache[config.endpoint]) {
                self._loadData(self.cache[config.endpoint], config, self);
              } else {
                this._loadUrlData(config.endpoint).then(function (d) {
                  self._loadData(d, config, self);
                }).catch(function (e) {
                  throw new droplabAjaxException(e.message || e);
                });
              }
            },

            destroy: function destroy() {
              var dynamicList = this.hook.list.list.querySelector('[data-dynamic]');
              if (this.listTemplate && dynamicList) {
                dynamicList.outerHTML = this.listTemplate;
              }
            }
          };
        });
      }, { "../window": 2 }], 2: [function (require, module, exports) {
        module.exports = function (callback) {
          return function () {
            callback(this);
          }.call(null);
        };
      }, {}] }, {}, [1])(1);
  });
}).call(window);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable */
  (function (f) {
    if (( false ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
      module.exports = f();
    } else if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      var g;if (typeof window !== "undefined") {
        g = window;
      } else if (typeof global !== "undefined") {
        g = global;
      } else if (typeof self !== "undefined") {
        g = self;
      } else {
        g = this;
      }g = g.droplab || (g.droplab = {});g = g.ajax || (g.ajax = {});g = g.datasource || (g.datasource = {});g.js = f();
    }
  })(function () {
    var define, module, exports;return function e(t, n, r) {
      function s(o, u) {
        if (!n[o]) {
          if (!t[o]) {
            var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
          }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
            var n = t[o][1][e];return s(n ? n : e);
          }, l, l.exports, e, t, n, r);
        }return n[o].exports;
      }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
        s(r[o]);
      }return s;
    }({ 1: [function (require, module, exports) {
        /* global droplab */

        require('../window')(function (w) {
          w.droplabAjaxFilter = {
            init: function init(hook) {
              this.destroyed = false;
              this.hook = hook;
              this.notLoading();

              this.debounceTriggerWrapper = this.debounceTrigger.bind(this);
              this.hook.trigger.addEventListener('keydown.dl', this.debounceTriggerWrapper);
              this.hook.trigger.addEventListener('focus', this.debounceTriggerWrapper);
              this.trigger(true);
            },

            notLoading: function notLoading() {
              this.loading = false;
            },

            debounceTrigger: function debounceTrigger(e) {
              var NON_CHARACTER_KEYS = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93];
              var invalidKeyPressed = NON_CHARACTER_KEYS.indexOf(e.detail.which || e.detail.keyCode) > -1;
              var focusEvent = e.type === 'focus';

              if (invalidKeyPressed || this.loading) {
                return;
              }

              if (this.timeout) {
                clearTimeout(this.timeout);
              }

              this.timeout = setTimeout(this.trigger.bind(this, focusEvent), 200);
            },

            trigger: function trigger(getEntireList) {
              var config = this.hook.config.droplabAjaxFilter;
              var searchValue = this.trigger.value;

              if (!config || !config.endpoint || !config.searchKey) {
                return;
              }

              if (config.searchValueFunction) {
                searchValue = config.searchValueFunction();
              }

              if (config.loadingTemplate && this.hook.list.data === undefined || this.hook.list.data.length === 0) {
                var dynamicList = this.hook.list.list.querySelector('[data-dynamic]');

                var loadingTemplate = document.createElement('div');
                loadingTemplate.innerHTML = config.loadingTemplate;
                loadingTemplate.setAttribute('data-loading-template', true);

                this.listTemplate = dynamicList.outerHTML;
                dynamicList.outerHTML = loadingTemplate.outerHTML;
              }

              if (getEntireList) {
                searchValue = '';
              }

              if (config.searchKey === searchValue) {
                return this.list.show();
              }

              this.loading = true;

              var params = config.params || {};
              params[config.searchKey] = searchValue;
              var self = this;
              self.cache = self.cache || {};
              var url = config.endpoint + this.buildParams(params);
              var urlCachedData = self.cache[url];

              if (urlCachedData) {
                self._loadData(urlCachedData, config, self);
              } else {
                this._loadUrlData(url).then(function (data) {
                  self._loadData(data, config, self);
                });
              }
            },

            _loadUrlData: function _loadUrlData(url) {
              var self = this;
              return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                      var data = JSON.parse(xhr.responseText);
                      self.cache[url] = data;
                      return resolve(data);
                    } else {
                      return reject([xhr.responseText, xhr.status]);
                    }
                  }
                };
                xhr.send();
              });
            },

            _loadData: function _loadData(data, config, self) {
              if (config.loadingTemplate && self.hook.list.data === undefined || self.hook.list.data.length === 0) {
                var dataLoadingTemplate = self.hook.list.list.querySelector('[data-loading-template]');

                if (dataLoadingTemplate) {
                  dataLoadingTemplate.outerHTML = self.listTemplate;
                }
              }

              if (!self.destroyed) {
                var hookListChildren = self.hook.list.list.children;
                var onlyDynamicList = hookListChildren.length === 1 && hookListChildren[0].hasAttribute('data-dynamic');

                if (onlyDynamicList && data.length === 0) {
                  self.hook.list.hide();
                }

                self.hook.list.setData.call(self.hook.list, data);
              }
              self.notLoading();
              self.hook.list.currentIndex = 0;
            },

            buildParams: function buildParams(params) {
              if (!params) return '';
              var paramsArray = Object.keys(params).map(function (param) {
                return param + '=' + (params[param] || '');
              });
              return '?' + paramsArray.join('&');
            },

            destroy: function destroy() {
              if (this.timeout) {
                clearTimeout(this.timeout);
              }

              this.destroyed = true;

              this.hook.trigger.removeEventListener('keydown.dl', this.debounceTriggerWrapper);
              this.hook.trigger.removeEventListener('focus', this.debounceTriggerWrapper);
            }
          };
        });
      }, { "../window": 2 }], 2: [function (require, module, exports) {
        module.exports = function (callback) {
          return function () {
            callback(this);
          }.call(null);
        };
      }, {}] }, {}, [1])(1);
  });
}).call(window);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable */
  (function (f) {
    if (( false ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
      module.exports = f();
    } else if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      var g;if (typeof window !== "undefined") {
        g = window;
      } else if (typeof global !== "undefined") {
        g = global;
      } else if (typeof self !== "undefined") {
        g = self;
      } else {
        g = this;
      }g = g.droplab || (g.droplab = {});g = g.filter || (g.filter = {});g.js = f();
    }
  })(function () {
    var define, module, exports;return function e(t, n, r) {
      function s(o, u) {
        if (!n[o]) {
          if (!t[o]) {
            var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
          }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
            var n = t[o][1][e];return s(n ? n : e);
          }, l, l.exports, e, t, n, r);
        }return n[o].exports;
      }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
        s(r[o]);
      }return s;
    }({ 1: [function (require, module, exports) {
        /* global droplab */

        require('../window')(function (w) {
          w.droplabFilter = {

            keydownWrapper: function keydownWrapper(e) {
              var hiddenCount = 0;
              var dataHiddenCount = 0;
              var list = e.detail.hook.list;
              var data = list.data;
              var value = e.detail.hook.trigger.value.toLowerCase();
              var config = e.detail.hook.config.droplabFilter;
              var matches = [];
              var filterFunction;
              // will only work on dynamically set data
              if (!data) {
                return;
              }

              if (config && config.filterFunction && typeof config.filterFunction === 'function') {
                filterFunction = config.filterFunction;
              } else {
                filterFunction = function filterFunction(o) {
                  // cheap string search
                  o.droplab_hidden = o[config.template].toLowerCase().indexOf(value) === -1;
                  return o;
                };
              }

              dataHiddenCount = data.filter(function (o) {
                return !o.droplab_hidden;
              }).length;

              matches = data.map(function (o) {
                return filterFunction(o, value);
              });

              hiddenCount = matches.filter(function (o) {
                return !o.droplab_hidden;
              }).length;

              if (dataHiddenCount !== hiddenCount) {
                list.render(matches);
                list.currentIndex = 0;
              }
            },

            init: function init(hookInput) {
              var config = hookInput.config.droplabFilter;

              if (!config || !config.template && !config.filterFunction) {
                return;
              }

              this.hookInput = hookInput;
              this.hookInput.trigger.addEventListener('keyup.dl', this.keydownWrapper);
            },

            destroy: function destroy() {
              this.hookInput.trigger.removeEventListener('keyup.dl', this.keydownWrapper);
            }
          };
        });
      }, { "../window": 2 }], 2: [function (require, module, exports) {
        module.exports = function (callback) {
          return function () {
            callback(this);
          }.call(null);
        };
      }, {}] }, {}, [1])(1);
  });
}).call(window);

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, max-len, one-var, one-var-declaration-per-line, quotes, prefer-template, newline-per-chained-call, comma-dangle, new-cap, no-else-return, consistent-return */
  /* global FilesCommentButton */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.FilesCommentButton = function () {
      var COMMENT_BUTTON_CLASS, COMMENT_BUTTON_TEMPLATE, DEBOUNCE_TIMEOUT_DURATION, EMPTY_CELL_CLASS, LINE_COLUMN_CLASSES, LINE_CONTENT_CLASS, LINE_HOLDER_CLASS, LINE_NUMBER_CLASS, OLD_LINE_CLASS, TEXT_FILE_SELECTOR, UNFOLDABLE_LINE_CLASS;

      COMMENT_BUTTON_CLASS = '.add-diff-note';

      COMMENT_BUTTON_TEMPLATE = _.template('<button name="button" type="submit" class="btn <%- COMMENT_BUTTON_CLASS %> js-add-diff-note-button" title="Add a comment to this line"><i class="fa fa-comment-o"></i></button>');

      LINE_HOLDER_CLASS = '.line_holder';

      LINE_NUMBER_CLASS = 'diff-line-num';

      LINE_CONTENT_CLASS = 'line_content';

      UNFOLDABLE_LINE_CLASS = 'js-unfold';

      EMPTY_CELL_CLASS = 'empty-cell';

      OLD_LINE_CLASS = 'old_line';

      LINE_COLUMN_CLASSES = "." + LINE_NUMBER_CLASS + ", .line_content";

      TEXT_FILE_SELECTOR = '.text-file';

      DEBOUNCE_TIMEOUT_DURATION = 100;

      function FilesCommentButton(filesContainerElement) {
        var debounce;
        this.filesContainerElement = filesContainerElement;
        this.destroy = bind(this.destroy, this);
        this.render = bind(this.render, this);
        this.VIEW_TYPE = $('input#view[type=hidden]').val();
        debounce = _.debounce(this.render, DEBOUNCE_TIMEOUT_DURATION);
        $(this.filesContainerElement).off('mouseover', LINE_COLUMN_CLASSES).off('mouseleave', LINE_COLUMN_CLASSES).on('mouseover', LINE_COLUMN_CLASSES, debounce).on('mouseleave', LINE_COLUMN_CLASSES, this.destroy);
      }

      FilesCommentButton.prototype.render = function (e) {
        var $currentTarget, buttonParentElement, lineContentElement, textFileElement;
        $currentTarget = $(e.currentTarget);

        buttonParentElement = this.getButtonParent($currentTarget);
        if (!this.validateButtonParent(buttonParentElement)) return;
        lineContentElement = this.getLineContent($currentTarget);
        if (!this.validateLineContent(lineContentElement)) return;

        textFileElement = this.getTextFileElement($currentTarget);
        buttonParentElement.append(this.buildButton({
          noteableType: textFileElement.attr('data-noteable-type'),
          noteableID: textFileElement.attr('data-noteable-id'),
          commitID: textFileElement.attr('data-commit-id'),
          noteType: lineContentElement.attr('data-note-type'),
          position: lineContentElement.attr('data-position'),
          lineType: lineContentElement.attr('data-line-type'),
          discussionID: lineContentElement.attr('data-discussion-id'),
          lineCode: lineContentElement.attr('data-line-code')
        }));
      };

      FilesCommentButton.prototype.destroy = function (e) {
        if (this.isMovingToSameType(e)) {
          return;
        }
        $(COMMENT_BUTTON_CLASS, this.getButtonParent($(e.currentTarget))).remove();
      };

      FilesCommentButton.prototype.buildButton = function (buttonAttributes) {
        var initializedButtonTemplate;
        initializedButtonTemplate = COMMENT_BUTTON_TEMPLATE({
          COMMENT_BUTTON_CLASS: COMMENT_BUTTON_CLASS.substr(1)
        });
        return $(initializedButtonTemplate).attr({
          'data-noteable-type': buttonAttributes.noteableType,
          'data-noteable-id': buttonAttributes.noteableID,
          'data-commit-id': buttonAttributes.commitID,
          'data-note-type': buttonAttributes.noteType,
          'data-line-code': buttonAttributes.lineCode,
          'data-position': buttonAttributes.position,
          'data-discussion-id': buttonAttributes.discussionID,
          'data-line-type': buttonAttributes.lineType
        });
      };

      FilesCommentButton.prototype.getTextFileElement = function (hoveredElement) {
        return $(hoveredElement.closest(TEXT_FILE_SELECTOR));
      };

      FilesCommentButton.prototype.getLineContent = function (hoveredElement) {
        if (hoveredElement.hasClass(LINE_CONTENT_CLASS)) {
          return hoveredElement;
        }
        if (this.VIEW_TYPE === 'inline') {
          return $(hoveredElement).closest(LINE_HOLDER_CLASS).find("." + LINE_CONTENT_CLASS);
        } else {
          return $(hoveredElement).next("." + LINE_CONTENT_CLASS);
        }
      };

      FilesCommentButton.prototype.getButtonParent = function (hoveredElement) {
        if (this.VIEW_TYPE === 'inline') {
          if (hoveredElement.hasClass(OLD_LINE_CLASS)) {
            return hoveredElement;
          }
          return hoveredElement.parent().find("." + OLD_LINE_CLASS);
        } else {
          if (hoveredElement.hasClass(LINE_NUMBER_CLASS)) {
            return hoveredElement;
          }
          return $(hoveredElement).prev("." + LINE_NUMBER_CLASS);
        }
      };

      FilesCommentButton.prototype.isMovingToSameType = function (e) {
        var newButtonParent;
        newButtonParent = this.getButtonParent($(e.toElement));
        if (!newButtonParent) {
          return false;
        }
        return newButtonParent.is(this.getButtonParent($(e.currentTarget)));
      };

      FilesCommentButton.prototype.validateButtonParent = function (buttonParentElement) {
        return !buttonParentElement.hasClass(EMPTY_CELL_CLASS) && !buttonParentElement.hasClass(UNFOLDABLE_LINE_CLASS) && $(COMMENT_BUTTON_CLASS, buttonParentElement).length === 0;
      };

      FilesCommentButton.prototype.validateLineContent = function (lineContentElement) {
        return lineContentElement.attr('data-discussion-id') && lineContentElement.attr('data-discussion-id') !== '';
      };

      return FilesCommentButton;
    }();

    $.fn.filesCommentButton = function () {
      if (!(this && this.parent().data('can-create-note') != null)) {
        return;
      }
      return this.each(function () {
        if (!$.data(this, 'filesCommentButton')) {
          return $.data(this, 'filesCommentButton', new FilesCommentButton($(this)));
        }
      });
    };
  }).call(this);
}).call(window);

/***/ }),
/* 286 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, one-var, one-var-declaration-per-line, prefer-rest-params, max-len, vars-on-top, wrap-iife, no-unused-vars, quotes, no-shadow, no-cond-assign, prefer-arrow-callback, no-return-assign, no-else-return, camelcase, comma-dangle, no-lonely-if, guard-for-in, no-restricted-syntax, consistent-return, prefer-template, no-param-reassign, no-loop-func, no-mixed-operators */
  /* global fuzzaldrinPlus */

  (function () {
    var GitLabDropdown,
        GitLabDropdownFilter,
        GitLabDropdownRemote,
        bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
        indexOf = [].indexOf || function (item) {
      for (var i = 0, l = this.length; i < l; i += 1) {
        if (i in this && this[i] === item) return i;
      }return -1;
    };

    GitLabDropdownFilter = function () {
      var ARROW_KEY_CODES, BLUR_KEYCODES, HAS_VALUE_CLASS;

      BLUR_KEYCODES = [27, 40];

      ARROW_KEY_CODES = [38, 40];

      HAS_VALUE_CLASS = "has-value";

      function GitLabDropdownFilter(input, options) {
        var $clearButton, $inputContainer, ref, timeout;
        this.input = input;
        this.options = options;
        this.filterInputBlur = (ref = this.options.filterInputBlur) != null ? ref : true;
        $inputContainer = this.input.parent();
        $clearButton = $inputContainer.find('.js-dropdown-input-clear');
        $clearButton.on('click', function (_this) {
          // Clear click
          return function (e) {
            e.preventDefault();
            e.stopPropagation();
            return _this.input.val('').trigger('input').focus();
          };
        }(this));
        // Key events
        timeout = "";
        this.input.on('keydown', function (e) {
          var keyCode = e.which;
          if (keyCode === 13 && !options.elIsInput) {
            e.preventDefault();
          }
        }).on('input', function () {
          if (this.input.val() !== "" && !$inputContainer.hasClass(HAS_VALUE_CLASS)) {
            $inputContainer.addClass(HAS_VALUE_CLASS);
          } else if (this.input.val() === "" && $inputContainer.hasClass(HAS_VALUE_CLASS)) {
            $inputContainer.removeClass(HAS_VALUE_CLASS);
          }
          // Only filter asynchronously only if option remote is set
          if (this.options.remote) {
            clearTimeout(timeout);
            return timeout = setTimeout(function () {
              $inputContainer.parent().addClass('is-loading');

              return this.options.query(this.input.val(), function (data) {
                $inputContainer.parent().removeClass('is-loading');
                return this.options.callback(data);
              }.bind(this));
            }.bind(this), 250);
          } else {
            return this.filter(this.input.val());
          }
        }.bind(this));
      }

      GitLabDropdownFilter.prototype.shouldBlur = function (keyCode) {
        return BLUR_KEYCODES.indexOf(keyCode) >= 0;
      };

      GitLabDropdownFilter.prototype.filter = function (search_text) {
        var data, elements, group, key, results, tmp;
        if (this.options.onFilter) {
          this.options.onFilter(search_text);
        }
        data = this.options.data();
        if (data != null && !this.options.filterByText) {
          results = data;
          if (search_text !== '') {
            // When data is an array of objects therefore [object Array] e.g.
            // [
            //   { prop: 'foo' },
            //   { prop: 'baz' }
            // ]
            if (_.isArray(data)) {
              results = fuzzaldrinPlus.filter(data, search_text, {
                key: this.options.keys
              });
            } else {
              // If data is grouped therefore an [object Object]. e.g.
              // {
              //   groupName1: [
              //     { prop: 'foo' },
              //     { prop: 'baz' }
              //   ],
              //   groupName2: [
              //     { prop: 'abc' },
              //     { prop: 'def' }
              //   ]
              // }
              if (gl.utils.isObject(data)) {
                results = {};
                for (key in data) {
                  group = data[key];
                  tmp = fuzzaldrinPlus.filter(group, search_text, {
                    key: this.options.keys
                  });
                  if (tmp.length) {
                    results[key] = tmp.map(function (item) {
                      return item;
                    });
                  }
                }
              }
            }
          }
          return this.options.callback(results);
        } else {
          elements = this.options.elements();
          if (search_text) {
            return elements.each(function () {
              var $el, matches;
              $el = $(this);
              matches = fuzzaldrinPlus.match($el.text().trim(), search_text);
              if (!$el.is('.dropdown-header')) {
                if (matches.length) {
                  return $el.show().removeClass('option-hidden');
                } else {
                  return $el.hide().addClass('option-hidden');
                }
              }
            });
          } else {
            return elements.show().removeClass('option-hidden');
          }
        }
      };

      return GitLabDropdownFilter;
    }();

    GitLabDropdownRemote = function () {
      function GitLabDropdownRemote(dataEndpoint, options) {
        this.dataEndpoint = dataEndpoint;
        this.options = options;
      }

      GitLabDropdownRemote.prototype.execute = function () {
        if (typeof this.dataEndpoint === "string") {
          return this.fetchData();
        } else if (typeof this.dataEndpoint === "function") {
          if (this.options.beforeSend) {
            this.options.beforeSend();
          }
          return this.dataEndpoint("", function (_this) {
            // Fetch the data by calling the data funcfion
            return function (data) {
              if (_this.options.success) {
                _this.options.success(data);
              }
              if (_this.options.beforeSend) {
                return _this.options.beforeSend();
              }
            };
          }(this));
        }
      };

      GitLabDropdownRemote.prototype.fetchData = function () {
        return $.ajax({
          url: this.dataEndpoint,
          dataType: this.options.dataType,
          beforeSend: function (_this) {
            return function () {
              if (_this.options.beforeSend) {
                return _this.options.beforeSend();
              }
            };
          }(this),
          success: function (_this) {
            return function (data) {
              if (_this.options.success) {
                return _this.options.success(data);
              }
            };
          }(this)
        });
        // Fetch the data through ajax if the data is a string
      };

      return GitLabDropdownRemote;
    }();

    GitLabDropdown = function () {
      var ACTIVE_CLASS, FILTER_INPUT, INDETERMINATE_CLASS, LOADING_CLASS, PAGE_TWO_CLASS, NON_SELECTABLE_CLASSES, SELECTABLE_CLASSES, CURSOR_SELECT_SCROLL_PADDING, currentIndex;

      LOADING_CLASS = "is-loading";

      PAGE_TWO_CLASS = "is-page-two";

      ACTIVE_CLASS = "is-active";

      INDETERMINATE_CLASS = "is-indeterminate";

      currentIndex = -1;

      NON_SELECTABLE_CLASSES = '.divider, .separator, .dropdown-header, .dropdown-menu-empty-link';

      SELECTABLE_CLASSES = ".dropdown-content li:not(" + NON_SELECTABLE_CLASSES + ", .option-hidden)";

      CURSOR_SELECT_SCROLL_PADDING = 5;

      FILTER_INPUT = '.dropdown-input .dropdown-input-field';

      function GitLabDropdown(el1, options) {
        var searchFields, selector, self;
        this.el = el1;
        this.options = options;
        this.updateLabel = bind(this.updateLabel, this);
        this.hidden = bind(this.hidden, this);
        this.opened = bind(this.opened, this);
        this.shouldPropagate = bind(this.shouldPropagate, this);
        self = this;
        selector = $(this.el).data("target");
        this.dropdown = selector != null ? $(selector) : $(this.el).parent();
        // Set Defaults
        this.filterInput = this.options.filterInput || this.getElement(FILTER_INPUT);
        this.highlight = !!this.options.highlight;
        this.filterInputBlur = this.options.filterInputBlur != null ? this.options.filterInputBlur : true;
        // If no input is passed create a default one
        self = this;
        // If selector was passed
        if (_.isString(this.filterInput)) {
          this.filterInput = this.getElement(this.filterInput);
        }
        searchFields = this.options.search ? this.options.search.fields : [];
        if (this.options.data) {
          // If we provided data
          // data could be an array of objects or a group of arrays
          if (_.isObject(this.options.data) && !_.isFunction(this.options.data)) {
            this.fullData = this.options.data;
            currentIndex = -1;
            this.parseData(this.options.data);
            this.focusTextInput();
          } else {
            this.remote = new GitLabDropdownRemote(this.options.data, {
              dataType: this.options.dataType,
              beforeSend: this.toggleLoading.bind(this),
              success: function (_this) {
                return function (data) {
                  _this.fullData = data;
                  _this.parseData(_this.fullData);
                  _this.focusTextInput();
                  if (_this.options.filterable && _this.filter && _this.filter.input && _this.filter.input.val() && _this.filter.input.val().trim() !== '') {
                    return _this.filter.input.trigger('input');
                  }
                };
                // Remote data
              }(this)
            });
          }
        }
        // Init filterable
        if (this.options.filterable) {
          this.filter = new GitLabDropdownFilter(this.filterInput, {
            elIsInput: $(this.el).is('input'),
            filterInputBlur: this.filterInputBlur,
            filterByText: this.options.filterByText,
            onFilter: this.options.onFilter,
            remote: this.options.filterRemote,
            query: this.options.data,
            keys: searchFields,
            elements: function (_this) {
              return function () {
                selector = '.dropdown-content li:not(' + NON_SELECTABLE_CLASSES + ')';
                if (_this.dropdown.find('.dropdown-toggle-page').length) {
                  selector = ".dropdown-page-one " + selector;
                }
                return $(selector);
              };
            }(this),
            data: function (_this) {
              return function () {
                return _this.fullData;
              };
            }(this),
            callback: function (_this) {
              return function (data) {
                _this.parseData(data);
                if (_this.filterInput.val() !== '') {
                  selector = SELECTABLE_CLASSES;
                  if (_this.dropdown.find('.dropdown-toggle-page').length) {
                    selector = ".dropdown-page-one " + selector;
                  }
                  if ($(_this.el).is('input')) {
                    currentIndex = -1;
                  } else {
                    $(selector, _this.dropdown).first().find('a').addClass('is-focused');
                    currentIndex = 0;
                  }
                }
              };
            }(this)
          });
        }
        // Event listeners
        this.dropdown.on("shown.bs.dropdown", this.opened);
        this.dropdown.on("hidden.bs.dropdown", this.hidden);
        $(this.el).on("update.label", this.updateLabel);
        this.dropdown.on("click", ".dropdown-menu, .dropdown-menu-close", this.shouldPropagate);
        this.dropdown.on('keyup', function (_this) {
          return function (e) {
            // Escape key
            if (e.which === 27) {
              return $('.dropdown-menu-close', _this.dropdown).trigger('click');
            }
          };
        }(this));
        this.dropdown.on('blur', 'a', function (_this) {
          return function (e) {
            var $dropdownMenu, $relatedTarget;
            if (e.relatedTarget != null) {
              $relatedTarget = $(e.relatedTarget);
              $dropdownMenu = $relatedTarget.closest('.dropdown-menu');
              if ($dropdownMenu.length === 0) {
                return _this.dropdown.removeClass('open');
              }
            }
          };
        }(this));
        if (this.dropdown.find(".dropdown-toggle-page").length) {
          this.dropdown.find(".dropdown-toggle-page, .dropdown-menu-back").on("click", function (_this) {
            return function (e) {
              e.preventDefault();
              e.stopPropagation();
              return _this.togglePage();
            };
          }(this));
        }
        if (this.options.selectable) {
          selector = ".dropdown-content a";
          if (this.dropdown.find(".dropdown-toggle-page").length) {
            selector = ".dropdown-page-one .dropdown-content a";
          }
          this.dropdown.on("click", selector, function (e) {
            var $el, selected, selectedObj, isMarking;
            $el = $(this);
            selected = self.rowClicked($el);
            selectedObj = selected ? selected[0] : null;
            isMarking = selected ? selected[1] : null;
            if (self.options.clicked) {
              self.options.clicked(selectedObj, $el, e, isMarking);
            }

            // Update label right after all modifications in dropdown has been done
            if (self.options.toggleLabel) {
              self.updateLabel(selectedObj, $el, self);
            }

            $el.trigger('blur');
          });
        }
      }

      // Finds an element inside wrapper element
      GitLabDropdown.prototype.getElement = function (selector) {
        return this.dropdown.find(selector);
      };

      GitLabDropdown.prototype.toggleLoading = function () {
        return $('.dropdown-menu', this.dropdown).toggleClass(LOADING_CLASS);
      };

      GitLabDropdown.prototype.togglePage = function () {
        var menu;
        menu = $('.dropdown-menu', this.dropdown);
        if (menu.hasClass(PAGE_TWO_CLASS)) {
          if (this.remote) {
            this.remote.execute();
          }
        }
        menu.toggleClass(PAGE_TWO_CLASS);
        // Focus first visible input on active page
        return this.dropdown.find('[class^="dropdown-page-"]:visible :text:visible:first').focus();
      };

      GitLabDropdown.prototype.parseData = function (data) {
        var full_html, groupData, html, name;
        this.renderedData = data;
        if (this.options.filterable && data.length === 0) {
          // render no matching results
          html = [this.noResults()];
        } else {
          // Handle array groups
          if (gl.utils.isObject(data)) {
            html = [];
            for (name in data) {
              groupData = data[name];
              html.push(this.renderItem({
                header: name
                // Add header for each group
              }, name));
              this.renderData(groupData, name).map(function (item) {
                return html.push(item);
              });
            }
          } else {
            // Render each row
            html = this.renderData(data);
          }
        }
        // Render the full menu
        full_html = this.renderMenu(html);
        return this.appendMenu(full_html);
      };

      GitLabDropdown.prototype.renderData = function (data, group) {
        if (group == null) {
          group = false;
        }
        return data.map(function (_this) {
          return function (obj, index) {
            return _this.renderItem(obj, group, index);
          };
        }(this));
      };

      GitLabDropdown.prototype.shouldPropagate = function (e) {
        var $target;
        if (this.options.multiSelect) {
          $target = $(e.target);
          if ($target && !$target.hasClass('dropdown-menu-close') && !$target.hasClass('dropdown-menu-close-icon') && !$target.data('is-link')) {
            e.stopPropagation();
            return false;
          } else {
            return true;
          }
        }
      };

      GitLabDropdown.prototype.opened = function () {
        var contentHtml;
        this.resetRows();
        this.addArrowKeyEvent();

        // Makes indeterminate items effective
        if (this.fullData && this.dropdown.find('.dropdown-menu-toggle').hasClass('js-filter-bulk-update')) {
          this.parseData(this.fullData);
        }
        contentHtml = $('.dropdown-content', this.dropdown).html();
        if (this.remote && contentHtml === "") {
          this.remote.execute();
        } else {
          this.focusTextInput();
        }

        if (this.options.showMenuAbove) {
          this.positionMenuAbove();
        }

        return this.dropdown.trigger('shown.gl.dropdown');
      };

      GitLabDropdown.prototype.positionMenuAbove = function () {
        var $button = $(this.el);
        var $menu = this.dropdown.find('.dropdown-menu');

        $menu.css('top', ($button.height() + $menu.height()) * -1);
      };

      GitLabDropdown.prototype.hidden = function (e) {
        var $input;
        this.resetRows();
        this.removeArrayKeyEvent();
        $input = this.dropdown.find(".dropdown-input-field");
        if (this.options.filterable) {
          $input.blur();
        }
        if (this.dropdown.find(".dropdown-toggle-page").length) {
          $('.dropdown-menu', this.dropdown).removeClass(PAGE_TWO_CLASS);
        }
        if (this.options.hidden) {
          this.options.hidden.call(this, e);
        }
        return this.dropdown.trigger('hidden.gl.dropdown');
      };

      // Render the full menu
      GitLabDropdown.prototype.renderMenu = function (html) {
        if (this.options.renderMenu) {
          return this.options.renderMenu(html);
        } else {
          var ul = document.createElement('ul');

          for (var i = 0; i < html.length; i += 1) {
            var el = html[i];

            if (el instanceof jQuery) {
              el = el.get(0);
            }

            if (typeof el === 'string') {
              ul.innerHTML += el;
            } else {
              ul.appendChild(el);
            }
          }

          return ul;
        }
      };

      // Append the menu into the dropdown
      GitLabDropdown.prototype.appendMenu = function (html) {
        return this.clearMenu().append(html);
      };

      GitLabDropdown.prototype.clearMenu = function () {
        var selector;
        selector = '.dropdown-content';
        if (this.dropdown.find(".dropdown-toggle-page").length) {
          selector = ".dropdown-page-one .dropdown-content";
        }

        return $(selector, this.dropdown).empty();
      };

      GitLabDropdown.prototype.renderItem = function (data, group, index) {
        var field, fieldName, html, selected, text, url, value;
        if (group == null) {
          group = false;
        }
        if (index == null) {
          // Render the row
          index = false;
        }
        html = document.createElement('li');
        if (data === 'divider' || data === 'separator') {
          html.className = data;
          return html;
        }
        // Header
        if (data.header != null) {
          html.className = 'dropdown-header';
          html.innerHTML = data.header;
          return html;
        }
        if (this.options.renderRow) {
          // Call the render function
          html = this.options.renderRow.call(this.options, data, this);
        } else {
          if (!selected) {
            value = this.options.id ? this.options.id(data) : data.id;
            fieldName = this.options.fieldName;

            if (value) {
              value = value.toString().replace(/'/g, '\\\'');
            }

            field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value + "']");
            if (field.length) {
              selected = true;
            }
          }
          // Set URL
          if (this.options.url != null) {
            url = this.options.url(data);
          } else {
            url = data.url != null ? data.url : '#';
          }
          // Set Text
          if (this.options.text != null) {
            text = this.options.text(data);
          } else {
            text = data.text != null ? data.text : '';
          }
          if (this.highlight) {
            text = this.highlightTextMatches(text, this.filterInput.val());
          }
          // Create the list item & the link
          var link = document.createElement('a');

          link.href = url;
          link.innerHTML = text;

          if (selected) {
            link.className = 'is-active';
          }

          if (group) {
            link.dataset.group = group;
            link.dataset.index = index;
          }

          html.appendChild(link);
        }
        return html;
      };

      GitLabDropdown.prototype.highlightTextMatches = function (text, term) {
        var occurrences;
        occurrences = fuzzaldrinPlus.match(text, term);
        return text.split('').map(function (character, i) {
          if (indexOf.call(occurrences, i) >= 0) {
            return "<b>" + character + "</b>";
          } else {
            return character;
          }
        }).join('');
      };

      GitLabDropdown.prototype.noResults = function () {
        var html;
        return html = "<li class='dropdown-menu-empty-link'> <a href='#' class='is-focused'> No matching results. </a> </li>";
      };

      GitLabDropdown.prototype.rowClicked = function (el) {
        var field, fieldName, groupName, isInput, selectedIndex, selectedObject, value, isMarking;

        fieldName = this.options.fieldName;
        isInput = $(this.el).is('input');
        if (this.renderedData) {
          groupName = el.data('group');
          if (groupName) {
            selectedIndex = el.data('index');
            selectedObject = this.renderedData[groupName][selectedIndex];
          } else {
            selectedIndex = el.closest('li').index();
            selectedObject = this.renderedData[selectedIndex];
          }
        }

        if (this.options.vue) {
          if (el.hasClass(ACTIVE_CLASS)) {
            el.removeClass(ACTIVE_CLASS);
          } else {
            el.addClass(ACTIVE_CLASS);
          }

          return [selectedObject];
        }

        field = [];
        value = this.options.id ? this.options.id(selectedObject, el) : selectedObject.id;
        if (isInput) {
          field = $(this.el);
        } else if (value) {
          field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value.toString().replace(/'/g, '\\\'') + "']");
        }

        if (this.options.isSelectable && !this.options.isSelectable(selectedObject, el)) {
          return;
        }

        if (el.hasClass(ACTIVE_CLASS)) {
          isMarking = false;
          el.removeClass(ACTIVE_CLASS);
          if (field && field.length) {
            this.clearField(field, isInput);
          }
        } else if (el.hasClass(INDETERMINATE_CLASS)) {
          isMarking = true;
          el.addClass(ACTIVE_CLASS);
          el.removeClass(INDETERMINATE_CLASS);
          if (field && field.length && value == null) {
            this.clearField(field, isInput);
          }
          if ((!field || !field.length) && fieldName) {
            this.addInput(fieldName, value, selectedObject);
          }
        } else {
          isMarking = true;
          if (!this.options.multiSelect || el.hasClass('dropdown-clear-active')) {
            this.dropdown.find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
            if (!isInput) {
              this.dropdown.parent().find("input[name='" + fieldName + "']").remove();
            }
          }
          if (field && field.length && value == null) {
            this.clearField(field, isInput);
          }
          // Toggle active class for the tick mark
          el.addClass(ACTIVE_CLASS);
          if (value != null) {
            if ((!field || !field.length) && fieldName) {
              this.addInput(fieldName, value, selectedObject);
            } else if (field && field.length) {
              field.val(value).trigger('change');
            }
          }
        }

        return [selectedObject, isMarking];
      };

      GitLabDropdown.prototype.focusTextInput = function () {
        if (this.options.filterable) {
          this.filterInput.focus();
        }
      };

      GitLabDropdown.prototype.addInput = function (fieldName, value, selectedObject) {
        var $input;
        // Create hidden input for form
        $input = $('<input>').attr('type', 'hidden').attr('name', fieldName).val(value);
        if (this.options.inputId != null) {
          $input.attr('id', this.options.inputId);
        }
        return this.dropdown.before($input);
      };

      GitLabDropdown.prototype.selectRowAtIndex = function (index) {
        var $el, selector;
        // If we pass an option index
        if (typeof index !== "undefined") {
          selector = SELECTABLE_CLASSES + ":eq(" + index + ") a";
        } else {
          selector = ".dropdown-content .is-focused";
        }
        if (this.dropdown.find(".dropdown-toggle-page").length) {
          selector = ".dropdown-page-one " + selector;
        }
        // simulate a click on the first link
        $el = $(selector, this.dropdown);
        if ($el.length) {
          var href = $el.attr('href');
          if (href && href !== '#') {
            gl.utils.visitUrl(href);
          } else {
            $el.first().trigger('click');
          }
        }
      };

      GitLabDropdown.prototype.addArrowKeyEvent = function () {
        var $input, ARROW_KEY_CODES, selector;
        ARROW_KEY_CODES = [38, 40];
        $input = this.dropdown.find(".dropdown-input-field");
        selector = SELECTABLE_CLASSES;
        if (this.dropdown.find(".dropdown-toggle-page").length) {
          selector = ".dropdown-page-one " + selector;
        }
        return $('body').on('keydown', function (_this) {
          return function (e) {
            var $listItems, PREV_INDEX, currentKeyCode;
            currentKeyCode = e.which;
            if (ARROW_KEY_CODES.indexOf(currentKeyCode) >= 0) {
              e.preventDefault();
              e.stopImmediatePropagation();
              PREV_INDEX = currentIndex;
              $listItems = $(selector, _this.dropdown);
              // if @options.filterable
              //   $input.blur()
              if (currentKeyCode === 40) {
                // Move down
                if (currentIndex < $listItems.length - 1) {
                  currentIndex += 1;
                }
              } else if (currentKeyCode === 38) {
                // Move up
                if (currentIndex > 0) {
                  currentIndex -= 1;
                }
              }
              if (currentIndex !== PREV_INDEX) {
                _this.highlightRowAtIndex($listItems, currentIndex);
              }
              return false;
            }
            if (currentKeyCode === 13 && currentIndex !== -1) {
              e.preventDefault();
              _this.selectRowAtIndex();
            }
          };
        }(this));
      };

      GitLabDropdown.prototype.removeArrayKeyEvent = function () {
        return $('body').off('keydown');
      };

      GitLabDropdown.prototype.resetRows = function resetRows() {
        currentIndex = -1;
        $('.is-focused', this.dropdown).removeClass('is-focused');
      };

      GitLabDropdown.prototype.highlightRowAtIndex = function ($listItems, index) {
        var $dropdownContent, $listItem, dropdownContentBottom, dropdownContentHeight, dropdownContentTop, dropdownScrollTop, listItemBottom, listItemHeight, listItemTop;
        // Remove the class for the previously focused row
        $('.is-focused', this.dropdown).removeClass('is-focused');
        // Update the class for the row at the specific index
        $listItem = $listItems.eq(index);
        $listItem.find('a:first-child').addClass("is-focused");
        // Dropdown content scroll area
        $dropdownContent = $listItem.closest('.dropdown-content');
        dropdownScrollTop = $dropdownContent.scrollTop();
        dropdownContentHeight = $dropdownContent.outerHeight();
        dropdownContentTop = $dropdownContent.prop('offsetTop');
        dropdownContentBottom = dropdownContentTop + dropdownContentHeight;
        // Get the offset bottom of the list item
        listItemHeight = $listItem.outerHeight();
        listItemTop = $listItem.prop('offsetTop');
        listItemBottom = listItemTop + listItemHeight;
        if (!index) {
          // Scroll the dropdown content to the top
          $dropdownContent.scrollTop(0);
        } else if (index === $listItems.length - 1) {
          // Scroll the dropdown content to the bottom
          $dropdownContent.scrollTop($dropdownContent.prop('scrollHeight'));
        } else if (listItemBottom > dropdownContentBottom + dropdownScrollTop) {
          // Scroll the dropdown content down
          $dropdownContent.scrollTop(listItemBottom - dropdownContentBottom + CURSOR_SELECT_SCROLL_PADDING);
        } else if (listItemTop < dropdownContentTop + dropdownScrollTop) {
          // Scroll the dropdown content up
          return $dropdownContent.scrollTop(listItemTop - dropdownContentTop - CURSOR_SELECT_SCROLL_PADDING);
        }
      };

      GitLabDropdown.prototype.updateLabel = function (selected, el, instance) {
        if (selected == null) {
          selected = null;
        }
        if (el == null) {
          el = null;
        }
        if (instance == null) {
          instance = null;
        }
        return $(this.el).find(".dropdown-toggle-text").text(this.options.toggleLabel(selected, el, instance));
      };

      GitLabDropdown.prototype.clearField = function (field, isInput) {
        return isInput ? field.val('') : field.remove();
      };

      return GitLabDropdown;
    }();

    $.fn.glDropdown = function (opts) {
      return this.each(function () {
        if (!$.data(this, 'glDropdown')) {
          return $.data(this, 'glDropdown', new GitLabDropdown(this, opts));
        }
      });
    };
  }).call(this);
}).call(window);

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */
  (function () {
    this.GroupAvatar = function () {
      function GroupAvatar() {
        $('.js-choose-group-avatar-button').on("click", function () {
          var form;
          form = $(this).closest("form");
          return form.find(".js-group-avatar-input").click();
        });
        $('.js-group-avatar-input').on("change", function () {
          var filename, form;
          form = $(this).closest("form");
          filename = $(this).val().replace(/^.*[\\\/]/, '');
          return form.find(".js-avatar-filename").text(filename);
        });
      }

      return GroupAvatar;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 292 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, wrap-iife, one-var, camelcase, one-var-declaration-per-line, quotes, object-shorthand, prefer-arrow-callback, comma-dangle, consistent-return, yoda, prefer-rest-params, prefer-spread, no-unused-vars, prefer-template, max-len */
  /* global Api */

  (function () {
    var slice = [].slice;

    this.GroupsSelect = function () {
      function GroupsSelect() {
        $('.ajax-groups-select').each(function (_this) {
          return function (i, select) {
            var all_available, skip_groups;
            all_available = $(select).data('all-available');
            skip_groups = $(select).data('skip-groups') || [];
            return $(select).select2({
              placeholder: "Search for a group",
              multiple: $(select).hasClass('multiselect'),
              minimumInputLength: 0,
              query: function query(_query) {
                var options = { all_available: all_available, skip_groups: skip_groups };
                return Api.groups(_query.term, options, function (groups) {
                  var data;
                  data = {
                    results: groups
                  };
                  return _query.callback(data);
                });
              },
              initSelection: function initSelection(element, callback) {
                var id;
                id = $(element).val();
                if (id !== "") {
                  return Api.group(id, callback);
                }
              },
              formatResult: function formatResult() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return _this.formatResult.apply(_this, args);
              },
              formatSelection: function formatSelection() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return _this.formatSelection.apply(_this, args);
              },
              dropdownCssClass: "ajax-groups-dropdown",
              // we do not want to escape markup since we are displaying html in results
              escapeMarkup: function escapeMarkup(m) {
                return m;
              }
            });
          };
        }(this));
      }

      GroupsSelect.prototype.formatResult = function (group) {
        var avatar;
        if (group.avatar_url) {
          avatar = group.avatar_url;
        } else {
          avatar = gon.default_avatar_url;
        }
        return "<div class='group-result'> <div class='group-name'>" + group.full_name + "</div> <div class='group-path'>" + group.full_path + "</div> </div>";
      };

      GroupsSelect.prototype.formatSelection = function (group) {
        return group.full_name;
      };

      return GroupsSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 293 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable wrap-iife, func-names, space-before-function-paren, prefer-arrow-callback, no-var, max-len */
  (function () {
    $(document).on('todo:toggle', function (e, count) {
      var $todoPendingCount = $('.todos-pending-count');
      $todoPendingCount.text(gl.text.addDelimiter(count));
      $todoPendingCount.toggleClass('hidden', count === 0);
    });
  })();
}).call(window);

/***/ }),
/* 294 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, camelcase, no-var, one-var, one-var-declaration-per-line, prefer-template, quotes, object-shorthand, comma-dangle, no-unused-vars, prefer-arrow-callback, no-else-return, vars-on-top, no-new, max-len */

  (function () {
    window.ImporterStatus = function () {
      function ImporterStatus(jobs_url, import_url) {
        this.jobs_url = jobs_url;
        this.import_url = import_url;
        this.initStatusPage();
        this.setAutoUpdate();
      }

      ImporterStatus.prototype.initStatusPage = function () {
        $('.js-add-to-import').off('click').on('click', function (_this) {
          return function (e) {
            var $btn, $namespace_input, $target_field, $tr, id, target_namespace, newName;
            $btn = $(e.currentTarget);
            $tr = $btn.closest('tr');
            $target_field = $tr.find('.import-target');
            $namespace_input = $target_field.find('.js-select-namespace option:selected');
            id = $tr.attr('id').replace('repo_', '');
            target_namespace = null;
            newName = null;
            if ($namespace_input.length > 0) {
              target_namespace = $namespace_input[0].innerHTML;
              newName = $target_field.find('#path').prop('value');
              $target_field.empty().append(target_namespace + "/" + newName);
            }
            $btn.disable().addClass('is-loading');
            return $.post(_this.import_url, {
              repo_id: id,
              target_namespace: target_namespace,
              new_name: newName
            }, {
              dataType: 'script'
            });
          };
        }(this));
        return $('.js-import-all').off('click').on('click', function (e) {
          var $btn;
          $btn = $(this);
          $btn.disable().addClass('is-loading');
          return $('.js-add-to-import').each(function () {
            return $(this).trigger('click');
          });
        });
      };

      ImporterStatus.prototype.setAutoUpdate = function () {
        return setInterval(function (_this) {
          return function () {
            return $.get(_this.jobs_url, function (data) {
              return $.each(data, function (i, job) {
                var job_item, status_field;
                job_item = $("#project_" + job.id);
                status_field = job_item.find(".job-status");
                if (job.import_status === 'finished') {
                  job_item.removeClass("active").addClass("success");
                  return status_field.html('<span><i class="fa fa-check"></i> done</span>');
                } else if (job.import_status === 'started') {
                  return status_field.html("<i class='fa fa-spinner fa-spin'></i> started");
                } else {
                  return status_field.html(job.import_status);
                }
              });
            });
          };
        }(this), 4000);
      };

      return ImporterStatus;
    }();

    $(function () {
      if ($('.js-importer-status').length) {
        var jobsImportPath = $('.js-importer-status').data('jobs-import-path');
        var importPath = $('.js-importer-status').data('import-path');

        new window.ImporterStatus(jobsImportPath, importPath);
      }
    });
  }).call(this);
}).call(window);

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-new, comma-dangle, quotes, prefer-arrow-callback, consistent-return, one-var, no-var, one-var-declaration-per-line, no-underscore-dangle, max-len */
  /* global UsersSelect */
  /* global Cookies */
  /* global bp */

  (function () {
    this.IssuableContext = function () {
      function IssuableContext(currentUser) {
        this.initParticipants();
        new UsersSelect(currentUser);
        $('select.select2').select2({
          width: 'resolve',
          dropdownAutoWidth: true
        });
        $(".issuable-sidebar .inline-update").on("change", "select", function () {
          return $(this).submit();
        });
        $(".issuable-sidebar .inline-update").on("change", ".js-assignee", function () {
          return $(this).submit();
        });
        $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
          return e.preventDefault();
        });
        $(document).off('click', '.edit-link').on('click', '.edit-link', function (e) {
          var $block, $selectbox;
          e.preventDefault();
          $block = $(this).parents('.block');
          $selectbox = $block.find('.selectbox');
          if ($selectbox.is(':visible')) {
            $selectbox.hide();
            $block.find('.value').show();
          } else {
            $selectbox.show();
            $block.find('.value').hide();
          }
          if ($selectbox.is(':visible')) {
            return setTimeout(function () {
              return $block.find('.dropdown-menu-toggle').trigger('click');
            }, 0);
          }
        });
        window.addEventListener('beforeunload', function () {
          // collapsed_gutter cookie hides the sidebar
          var bpBreakpoint = bp.getBreakpointSize();
          if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
            Cookies.set('collapsed_gutter', true);
          }
        });
        $(".right-sidebar").niceScroll();
      }

      IssuableContext.prototype.initParticipants = function () {
        var _this;
        _this = this;
        $(document).on("click", ".js-participants-more", this.toggleHiddenParticipants);
        return $(".js-participants-author").each(function (i) {
          if (i >= _this.PARTICIPANTS_ROW_COUNT) {
            return $(this).addClass("js-participants-hidden").hide();
          }
        });
      };

      IssuableContext.prototype.toggleHiddenParticipants = function (e) {
        var currentText, lessText, originalText;
        e.preventDefault();
        currentText = $(this).text().trim();
        lessText = $(this).data("less-text");
        originalText = $(this).data("original-text");
        if (currentText === originalText) {
          $(this).text(lessText);
        } else {
          $(this).text(originalText);
        }
        return $(".js-participants-hidden").toggle();
      };

      return IssuableContext;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 303 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-useless-escape, no-new, quotes, object-shorthand, no-unused-vars, comma-dangle, no-alert, consistent-return, no-else-return, prefer-template, one-var, one-var-declaration-per-line, curly, max-len */
  /* global GitLab */
  /* global UsersSelect */
  /* global ZenMode */
  /* global Autosave */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.IssuableForm = function () {
      IssuableForm.prototype.issueMoveConfirmMsg = 'Are you sure you want to move this issue to another project?';

      IssuableForm.prototype.wipRegex = /^\s*(\[WIP\]\s*|WIP:\s*|WIP\s+)+\s*/i;

      function IssuableForm(form) {
        var $issuableDueDate;
        this.form = form;
        this.toggleWip = bind(this.toggleWip, this);
        this.renderWipExplanation = bind(this.renderWipExplanation, this);
        this.resetAutosave = bind(this.resetAutosave, this);
        this.handleSubmit = bind(this.handleSubmit, this);
        gl.GfmAutoComplete.setup();
        new UsersSelect();
        new ZenMode();
        this.titleField = this.form.find("input[name*='[title]']");
        this.descriptionField = this.form.find("textarea[name*='[description]']");
        this.issueMoveField = this.form.find("#move_to_project_id");
        if (!(this.titleField.length && this.descriptionField.length)) {
          return;
        }
        this.initAutosave();
        this.form.on("submit", this.handleSubmit);
        this.form.on("click", ".btn-cancel", this.resetAutosave);
        this.initWip();
        this.initMoveDropdown();
        $issuableDueDate = $('#issuable-due-date');
        if ($issuableDueDate.length) {
          $('.datepicker').datepicker({
            dateFormat: 'yy-mm-dd',
            onSelect: function onSelect(dateText, inst) {
              return $issuableDueDate.val(dateText);
            }
          }).datepicker('setDate', $.datepicker.parseDate('yy-mm-dd', $issuableDueDate.val()));
        }
      }

      IssuableForm.prototype.initAutosave = function () {
        new Autosave(this.titleField, [document.location.pathname, document.location.search, "title"]);
        return new Autosave(this.descriptionField, [document.location.pathname, document.location.search, "description"]);
      };

      IssuableForm.prototype.handleSubmit = function () {
        var fieldId = this.issueMoveField != null ? this.issueMoveField.val() : null;
        if ((parseInt(fieldId, 10) || 0) > 0) {
          if (!confirm(this.issueMoveConfirmMsg)) {
            return false;
          }
        }
        return this.resetAutosave();
      };

      IssuableForm.prototype.resetAutosave = function () {
        this.titleField.data("autosave").reset();
        return this.descriptionField.data("autosave").reset();
      };

      IssuableForm.prototype.initWip = function () {
        this.$wipExplanation = this.form.find(".js-wip-explanation");
        this.$noWipExplanation = this.form.find(".js-no-wip-explanation");
        if (!(this.$wipExplanation.length && this.$noWipExplanation.length)) {
          return;
        }
        this.form.on("click", ".js-toggle-wip", this.toggleWip);
        this.titleField.on("keyup blur", this.renderWipExplanation);
        return this.renderWipExplanation();
      };

      IssuableForm.prototype.workInProgress = function () {
        return this.wipRegex.test(this.titleField.val());
      };

      IssuableForm.prototype.renderWipExplanation = function () {
        if (this.workInProgress()) {
          this.$wipExplanation.show();
          return this.$noWipExplanation.hide();
        } else {
          this.$wipExplanation.hide();
          return this.$noWipExplanation.show();
        }
      };

      IssuableForm.prototype.toggleWip = function (event) {
        event.preventDefault();
        if (this.workInProgress()) {
          this.removeWip();
        } else {
          this.addWip();
        }
        return this.renderWipExplanation();
      };

      IssuableForm.prototype.removeWip = function () {
        return this.titleField.val(this.titleField.val().replace(this.wipRegex, ""));
      };

      IssuableForm.prototype.addWip = function () {
        return this.titleField.val("WIP: " + this.titleField.val());
      };

      IssuableForm.prototype.initMoveDropdown = function () {
        var $moveDropdown, pageSize;
        $moveDropdown = $('.js-move-dropdown');
        if ($moveDropdown.length) {
          pageSize = $moveDropdown.data('page-size');
          return $('.js-move-dropdown').select2({
            ajax: {
              url: $moveDropdown.data('projects-url'),
              quietMillis: 125,
              data: function data(term, page, context) {
                return {
                  search: term,
                  offset_id: context
                };
              },
              results: function results(data) {
                var context, more;

                if (data.length >= pageSize) more = true;

                if (data[data.length - 1]) context = data[data.length - 1].id;

                return {
                  results: data,
                  more: more,
                  context: context
                };
              }
            },
            formatResult: function formatResult(project) {
              return project.name_with_namespace;
            },
            formatSelection: function formatSelection(project) {
              return project.name_with_namespace;
            }
          });
        }
      };

      return IssuableForm;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, no-underscore-dangle, one-var-declaration-per-line, object-shorthand, no-unused-vars, no-new, comma-dangle, consistent-return, quotes, dot-notation, quote-props, prefer-arrow-callback, max-len */
  /* global Flash */

  __webpack_require__(34);
  __webpack_require__(28);
  __webpack_require__(49);

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.Issue = function () {
      function Issue() {
        this.submitNoteForm = bind(this.submitNoteForm, this);
        // Prevent duplicate event bindings
        this.disableTaskList();
        if ($('a.btn-close').length) {
          this.initTaskList();
          this.initIssueBtnEventListeners();
        }
        this.initMergeRequests();
        this.initRelatedBranches();
        this.initCanCreateBranch();
      }

      Issue.prototype.initTaskList = function () {
        $('.detail-page-description .js-task-list-container').taskList('enable');
        return $(document).on('tasklist:changed', '.detail-page-description .js-task-list-container', this.updateTaskList);
      };

      Issue.prototype.initIssueBtnEventListeners = function () {
        var _this, issueFailMessage;
        _this = this;
        issueFailMessage = 'Unable to update this issue at this time.';
        return $('a.btn-close, a.btn-reopen').on('click', function (e) {
          var $this, isClose, shouldSubmit, url;
          e.preventDefault();
          e.stopImmediatePropagation();
          $this = $(this);
          isClose = $this.hasClass('btn-close');
          shouldSubmit = $this.hasClass('btn-comment');
          if (shouldSubmit) {
            _this.submitNoteForm($this.closest('form'));
          }
          $this.prop('disabled', true);
          url = $this.attr('href');
          return $.ajax({
            type: 'PUT',
            url: url,
            error: function error(jqXHR, textStatus, errorThrown) {
              var issueStatus;
              issueStatus = isClose ? 'close' : 'open';
              return new Flash(issueFailMessage, 'alert');
            },
            success: function success(data, textStatus, jqXHR) {
              if ('id' in data) {
                $(document).trigger('issuable:change');
                if (isClose) {
                  $('a.btn-close').addClass('hidden');
                  $('a.btn-reopen').removeClass('hidden');
                  $('div.status-box-closed').removeClass('hidden');
                  $('div.status-box-open').addClass('hidden');
                } else {
                  $('a.btn-reopen').addClass('hidden');
                  $('a.btn-close').removeClass('hidden');
                  $('div.status-box-closed').addClass('hidden');
                  $('div.status-box-open').removeClass('hidden');
                }
              } else {
                new Flash(issueFailMessage, 'alert');
              }
              return $this.prop('disabled', false);
            }
          });
        });
      };

      Issue.prototype.submitNoteForm = function (form) {
        var noteText;
        noteText = form.find("textarea.js-note-text").val();
        if (noteText.trim().length > 0) {
          return form.submit();
        }
      };

      Issue.prototype.disableTaskList = function () {
        $('.detail-page-description .js-task-list-container').taskList('disable');
        return $(document).off('tasklist:changed', '.detail-page-description .js-task-list-container');
      };

      Issue.prototype.updateTaskList = function () {
        var patchData;
        patchData = {};
        patchData['issue'] = {
          'description': $('.js-task-list-field', this).val()
        };
        return $.ajax({
          type: 'PATCH',
          url: $('form.js-issuable-update').attr('action'),
          data: patchData,
          success: function success(issue) {
            document.querySelector('#task_status').innerText = issue.task_status;
            document.querySelector('#task_status_short').innerText = issue.task_status_short;
          }
        });
        // TODO (rspeicher): Make the issue description inline-editable like a note so
        // that we can re-use its form here
      };

      Issue.prototype.initMergeRequests = function () {
        var $container;
        $container = $('#merge-requests');
        return $.getJSON($container.data('url')).error(function () {
          return new Flash('Failed to load referenced merge requests', 'alert');
        }).success(function (data) {
          if ('html' in data) {
            return $container.html(data.html);
          }
        });
      };

      Issue.prototype.initRelatedBranches = function () {
        var $container;
        $container = $('#related-branches');
        return $.getJSON($container.data('url')).error(function () {
          return new Flash('Failed to load related branches', 'alert');
        }).success(function (data) {
          if ('html' in data) {
            return $container.html(data.html);
          }
        });
      };

      Issue.prototype.initCanCreateBranch = function () {
        var $container;
        $container = $('#new-branch');
        // If the user doesn't have the required permissions the container isn't
        // rendered at all.
        if ($container.length === 0) {
          return;
        }
        return $.getJSON($container.data('path')).error(function () {
          $container.find('.unavailable').show();
          return new Flash('Failed to check if a new branch can be created.', 'alert');
        }).success(function (data) {
          if (data.can_create_branch) {
            $container.find('.available').show();
          } else {
            return $container.find('.unavailable').show();
          }
        });
      };

      return Issue;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 305 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */
  (function () {
    this.IssueStatusSelect = function () {
      function IssueStatusSelect() {
        $('.js-issue-status').each(function (i, el) {
          var fieldName;
          fieldName = $(el).data("field-name");
          return $(el).glDropdown({
            selectable: true,
            fieldName: fieldName,
            toggleLabel: function (_this) {
              return function (selected, el, instance) {
                var $item, label;
                label = 'Author';
                $item = instance.dropdown.find('.is-active');
                if ($item.length) {
                  label = $item.text();
                }
                return label;
              };
            }(this),
            clicked: function clicked(item, $el, e) {
              return e.preventDefault();
            },
            id: function id(obj, el) {
              return $(el).data("id");
            }
          });
        });
      }

      return IssueStatusSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 306 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, vars-on-top, no-unused-vars, max-len */
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.Labels = function () {
      function Labels() {
        this.setSuggestedColor = bind(this.setSuggestedColor, this);
        this.updateColorPreview = bind(this.updateColorPreview, this);
        var form;
        form = $('.label-form');
        this.cleanBinding();
        this.addBinding();
        this.updateColorPreview();
      }

      Labels.prototype.addBinding = function () {
        $(document).on('click', '.suggest-colors a', this.setSuggestedColor);
        return $(document).on('input', 'input#label_color', this.updateColorPreview);
      };

      Labels.prototype.cleanBinding = function () {
        $(document).off('click', '.suggest-colors a');
        return $(document).off('input', 'input#label_color');
      };

      Labels.prototype.updateColorPreview = function () {
        var previewColor;
        previewColor = $('input#label_color').val();
        return $('div.label-color-preview').css('background-color', previewColor);
        // Updates the the preview color with the hex-color input
      };

      // Updates the preview color with a click on a suggested color
      Labels.prototype.setSuggestedColor = function (e) {
        var color;
        color = $(e.currentTarget).data('color');
        $('input#label_color').val(color);
        this.updateColorPreview();
        // Notify the form, that color has changed
        $('.label-form').trigger('keyup');
        return e.preventDefault();
      };

      return Labels;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 307 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
  /* global Issuable */
  /* global ListLabel */

  (function () {
    this.LabelsSelect = function () {
      function LabelsSelect(els) {
        var _this, $els;
        _this = this;

        $els = $(els);

        if (!els) {
          $els = $('.js-label-select');
        }

        $els.each(function (i, dropdown) {
          var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelHTMLTemplate, labelNoneHTMLTemplate, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
          $dropdown = $(dropdown);
          $dropdownContainer = $dropdown.closest('.labels-filter');
          $toggleText = $dropdown.find('.dropdown-toggle-text');
          namespacePath = $dropdown.data('namespace-path');
          projectPath = $dropdown.data('project-path');
          labelUrl = $dropdown.data('labels');
          issueUpdateURL = $dropdown.data('issueUpdate');
          selectedLabel = $dropdown.data('selected');
          if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
            selectedLabel = selectedLabel.split(',');
          }
          showNo = $dropdown.data('show-no');
          showAny = $dropdown.data('show-any');
          showMenuAbove = $dropdown.data('showMenuAbove');
          defaultLabel = $dropdown.data('default-label');
          abilityName = $dropdown.data('ability-name');
          $selectbox = $dropdown.closest('.selectbox');
          $block = $selectbox.closest('.block');
          $form = $dropdown.closest('form, .js-issuable-update');
          $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
          $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
          $value = $block.find('.value');
          $loading = $block.find('.block-loading').fadeOut();
          fieldName = $dropdown.data('field-name');
          useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
          propertyName = useId ? 'id' : 'title';
          initialSelected = $selectbox.find('input[name="' + $dropdown.data('field-name') + '"]').map(function () {
            return this.value;
          }).get();
          if (issueUpdateURL != null) {
            issueURLSplit = issueUpdateURL.split('/');
          }
          if (issueUpdateURL) {
            labelHTMLTemplate = _.template('<% _.each(labels, function(label){ %> <a href="<%- ["",issueURLSplit[1], issueURLSplit[2],""].join("/") %>issues?label_name[]=<%- encodeURIComponent(label.title) %>"> <span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;"> <%- label.title %> </span> </a> <% }); %>');
            labelNoneHTMLTemplate = '<span class="no-value">None</span>';
          }

          $sidebarLabelTooltip.tooltip();

          if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
            new gl.CreateLabelDropdown($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
          }

          saveLabelData = function saveLabelData() {
            var data, selected;
            selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
              return this.value;
            }).get();

            if (_.isEqual(initialSelected, selected)) return;
            initialSelected = selected;

            data = {};
            data[abilityName] = {};
            data[abilityName].label_ids = selected;
            if (!selected.length) {
              data[abilityName].label_ids = [''];
            }
            $loading.fadeIn();
            $dropdown.trigger('loading.gl.dropdown');
            return $.ajax({
              type: 'PUT',
              url: issueUpdateURL,
              dataType: 'JSON',
              data: data
            }).done(function (data) {
              var labelCount, template, labelTooltipTitle, labelTitles;
              $loading.fadeOut();
              $dropdown.trigger('loaded.gl.dropdown');
              $selectbox.hide();
              data.issueURLSplit = issueURLSplit;
              labelCount = 0;
              if (data.labels.length) {
                template = labelHTMLTemplate(data);
                labelCount = data.labels.length;
              } else {
                template = labelNoneHTMLTemplate;
              }
              $value.removeAttr('style').html(template);
              $sidebarCollapsedValue.text(labelCount);

              if (data.labels.length) {
                labelTitles = data.labels.map(function (label) {
                  return label.title;
                });

                if (labelTitles.length > 5) {
                  labelTitles = labelTitles.slice(0, 5);
                  labelTitles.push('and ' + (data.labels.length - 5) + ' more');
                }

                labelTooltipTitle = labelTitles.join(', ');
              } else {
                labelTooltipTitle = '';
                $sidebarLabelTooltip.tooltip('destroy');
              }

              $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

              $('.has-tooltip', $value).tooltip({
                container: 'body'
              });
              return $value.find('a').each(function (i) {
                return setTimeout(function (_this) {
                  return function () {
                    return gl.animate.animate($(_this), 'pulse');
                  };
                }(this), 200 * i);
              });
            });
          };
          $dropdown.glDropdown({
            showMenuAbove: showMenuAbove,
            data: function data(term, callback) {
              return $.ajax({
                url: labelUrl
              }).done(function (data) {
                data = _.chain(data).groupBy(function (label) {
                  return label.title;
                }).map(function (label) {
                  var color;
                  color = _.map(label, function (dup) {
                    return dup.color;
                  });
                  return {
                    id: label[0].id,
                    title: label[0].title,
                    color: color,
                    duplicate: color.length > 1
                  };
                }).value();
                if ($dropdown.hasClass('js-extra-options')) {
                  var extraData = [];
                  if (showNo) {
                    extraData.unshift({
                      id: 0,
                      title: 'No Label'
                    });
                  }
                  if (showAny) {
                    extraData.unshift({
                      isAny: true,
                      title: 'Any Label'
                    });
                  }
                  if (extraData.length) {
                    extraData.push('divider');
                    data = extraData.concat(data);
                  }
                }

                callback(data);
                if (showMenuAbove) {
                  $dropdown.data('glDropdown').positionMenuAbove();
                }
              });
            },
            renderRow: function renderRow(label, instance) {
              var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
              $li = $('<li>');
              $a = $('<a href="#">');
              selectedClass = [];
              removesAll = label.id <= 0 || label.id == null;
              if ($dropdown.hasClass('js-filter-bulk-update')) {
                indeterminate = $dropdown.data('indeterminate') || [];
                marked = $dropdown.data('marked') || [];

                if (indeterminate.indexOf(label.id) !== -1) {
                  selectedClass.push('is-indeterminate');
                }

                if (marked.indexOf(label.id) !== -1) {
                  // Remove is-indeterminate class if the item will be marked as active
                  i = selectedClass.indexOf('is-indeterminate');
                  if (i !== -1) {
                    selectedClass.splice(i, 1);
                  }
                  selectedClass.push('is-active');
                }
              } else {
                if (this.id(label)) {
                  dropdownName = $dropdown.data('fieldName');
                  dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

                  if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                    selectedClass.push('is-active');
                  }
                }

                if ($dropdown.hasClass('js-multiselect') && removesAll) {
                  selectedClass.push('dropdown-clear-active');
                }
              }
              if (label.duplicate) {
                spacing = 100 / label.color.length;
                // Reduce the colors to 4
                label.color = label.color.filter(function (color, i) {
                  return i < 4;
                });
                color = _.map(label.color, function (color, i) {
                  var percentFirst, percentSecond;
                  percentFirst = Math.floor(spacing * i);
                  percentSecond = Math.floor(spacing * (i + 1));
                  return color + " " + percentFirst + "%," + color + " " + percentSecond + "% ";
                }).join(',');
                color = "linear-gradient(" + color + ")";
              } else {
                if (label.color != null) {
                  color = label.color[0];
                }
              }
              if (color) {
                colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
              } else {
                colorEl = '';
              }
              // We need to identify which items are actually labels
              if (label.id) {
                selectedClass.push('label-item');
                $a.attr('data-label-id', label.id);
              }
              $a.addClass(selectedClass.join(' ')).html(colorEl + " " + label.title);
              // Return generated html
              return $li.html($a).prop('outerHTML');
            },
            search: {
              fields: ['title']
            },
            selectable: true,
            filterable: true,
            selected: $dropdown.data('selected') || [],
            toggleLabel: function toggleLabel(selected, el) {
              var isSelected = el !== null ? el.hasClass('is-active') : false;
              var title = selected.title;
              var selectedLabels = this.selected;

              if (selected.id === 0) {
                this.selected = [];
                return 'No Label';
              } else if (isSelected) {
                this.selected.push(title);
              } else {
                var index = this.selected.indexOf(title);
                this.selected.splice(index, 1);
              }

              if (selectedLabels.length === 1) {
                return selectedLabels;
              } else if (selectedLabels.length) {
                return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
              } else {
                return defaultLabel;
              }
            },
            fieldName: $dropdown.data('field-name'),
            id: function id(label) {
              if (label.id <= 0) return label.title;

              if ($dropdown.hasClass('js-issuable-form-dropdown')) {
                return label.id;
              }

              if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
                return label.title;
              } else {
                return label.id;
              }
            },
            hidden: function hidden() {
              var isIssueIndex, isMRIndex, page, selectedLabels;
              page = $('body').data('page');
              isIssueIndex = page === 'projects:issues:index';
              isMRIndex = page === 'projects:merge_requests:index';
              $selectbox.hide();
              // display:block overrides the hide-collapse rule
              $value.removeAttr('style');

              if ($dropdown.hasClass('js-issuable-form-dropdown')) {
                return;
              }

              if ($('html').hasClass('issue-boards-page')) {
                return;
              }
              if ($dropdown.hasClass('js-multiselect')) {
                if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                  selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
                  Issuable.filterResults($dropdown.closest('form'));
                } else if ($dropdown.hasClass('js-filter-submit')) {
                  $dropdown.closest('form').submit();
                } else {
                  if (!$dropdown.hasClass('js-filter-bulk-update')) {
                    saveLabelData();
                  }
                }
              }
            },
            multiSelect: $dropdown.hasClass('js-multiselect'),
            vue: $dropdown.hasClass('js-issue-board-sidebar'),
            clicked: function clicked(label, $el, e, isMarking) {
              var isIssueIndex, isMRIndex, page, boardsModel;

              page = $('body').data('page');
              isIssueIndex = page === 'projects:issues:index';
              isMRIndex = page === 'projects:merge_requests:index';

              if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
                $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
              }

              if ($dropdown.hasClass('js-issuable-form-dropdown')) {
                return;
              }

              if ($dropdown.hasClass('js-filter-bulk-update')) {
                _this.enableBulkLabelDropdown();
                _this.setDropdownData($dropdown, isMarking, this.id(label));
                return;
              }

              if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar') && !$dropdown.closest('.add-issues-modal').length) {
                boardsModel = gl.issueBoards.BoardsStore.state.filters;
              } else if ($dropdown.closest('.add-issues-modal').length) {
                boardsModel = gl.issueBoards.ModalStore.store.filter;
              }

              if (boardsModel) {
                if (label.isAny) {
                  boardsModel['label_name'] = [];
                } else if ($el.hasClass('is-active')) {
                  boardsModel['label_name'].push(label.title);
                } else {
                  var filters = boardsModel['label_name'];
                  filters = filters.filter(function (filteredLabel) {
                    return filteredLabel !== label.title;
                  });
                  boardsModel['label_name'] = filters;
                }

                if (!$dropdown.closest('.add-issues-modal').length) {
                  gl.issueBoards.BoardsStore.updateFiltersUrl();
                }
                e.preventDefault();
                return;
              } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                if (!$dropdown.hasClass('js-multiselect')) {
                  selectedLabel = label.title;
                  return Issuable.filterResults($dropdown.closest('form'));
                }
              } else if ($dropdown.hasClass('js-filter-submit')) {
                return $dropdown.closest('form').submit();
              } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
                if ($el.hasClass('is-active')) {
                  gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                    id: label.id,
                    title: label.title,
                    color: label.color[0],
                    textColor: '#fff'
                  }));
                } else {
                  var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
                  labels = labels.filter(function (selectedLabel) {
                    return selectedLabel.id !== label.id;
                  });
                  gl.issueBoards.BoardsStore.detail.issue.labels = labels;
                }

                $loading.fadeIn();

                gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                  $loading.fadeOut();
                });
              } else {
                if ($dropdown.hasClass('js-multiselect')) {} else {
                  return saveLabelData();
                }
              }
            }
          });

          // Set dropdown data
          _this.setOriginalDropdownData($dropdownContainer, $dropdown);
        });
        this.bindEvents();
      }

      LabelsSelect.prototype.bindEvents = function () {
        return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
      };

      LabelsSelect.prototype.onSelectCheckboxIssue = function () {
        if ($('.selected_issue:checked').length) {
          return;
        }
        return $('.issues_bulk_update .labels-filter .dropdown-toggle-text').text('Label');
      };

      LabelsSelect.prototype.enableBulkLabelDropdown = function () {
        var issuableBulkActions;
        if ($('.selected_issue:checked').length) {
          issuableBulkActions = $('.bulk-update').data('bulkActions');
          return issuableBulkActions.willUpdateLabels = true;
        }
      };

      LabelsSelect.prototype.setDropdownData = function ($dropdown, isMarking, value) {
        var i, markedIds, unmarkedIds, indeterminateIds;
        var issuableBulkActions = $('.bulk-update').data('bulkActions');

        markedIds = $dropdown.data('marked') || [];
        unmarkedIds = $dropdown.data('unmarked') || [];
        indeterminateIds = $dropdown.data('indeterminate') || [];

        if (isMarking) {
          markedIds.push(value);

          i = indeterminateIds.indexOf(value);
          if (i > -1) {
            indeterminateIds.splice(i, 1);
          }

          i = unmarkedIds.indexOf(value);
          if (i > -1) {
            unmarkedIds.splice(i, 1);
          }
        } else {
          // If marked item (not common) is unmarked
          i = markedIds.indexOf(value);
          if (i > -1) {
            markedIds.splice(i, 1);
          }

          // If an indeterminate item is being unmarked
          if (issuableBulkActions.getOriginalIndeterminateIds().indexOf(value) > -1) {
            unmarkedIds.push(value);
          }

          // If a marked item is being unmarked
          // (a marked item could also be a label that is present in all selection)
          if (issuableBulkActions.getOriginalCommonIds().indexOf(value) > -1) {
            unmarkedIds.push(value);
          }
        }

        $dropdown.data('marked', markedIds);
        $dropdown.data('unmarked', unmarkedIds);
        $dropdown.data('indeterminate', indeterminateIds);
      };

      LabelsSelect.prototype.setOriginalDropdownData = function ($container, $dropdown) {
        var labels = [];
        $container.find('[name="label_name[]"]').map(function () {
          return labels.push(this.value);
        });
        $dropdown.data('marked', labels);
      };

      return LabelsSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, no-unused-vars, one-var, one-var-declaration-per-line, vars-on-top, max-len */

  (function () {
    var hideEndFade;

    hideEndFade = function hideEndFade($scrollingTabs) {
      return $scrollingTabs.each(function () {
        var $this;
        $this = $(this);
        return $this.siblings('.fade-right').toggleClass('scrolling', $this.width() < $this.prop('scrollWidth'));
      });
    };

    $(function () {
      var $scrollingTabs = $('.scrolling-tabs');

      hideEndFade($scrollingTabs);
      $(window).off('resize.nav').on('resize.nav', function () {
        return hideEndFade($scrollingTabs);
      });
      $scrollingTabs.off('scroll').on('scroll', function (event) {
        var $this, currentPosition, maxPosition;
        $this = $(this);
        currentPosition = $this.scrollLeft();
        maxPosition = $this.prop('scrollWidth') - $this.outerWidth();
        $this.siblings('.fade-left').toggleClass('scrolling', currentPosition > 0);
        return $this.siblings('.fade-right').toggleClass('scrolling', currentPosition < maxPosition - 1);
      });

      $scrollingTabs.each(function () {
        var $this = $(this);
        var scrollingTabWidth = $this.width();
        var $active = $this.find('.active');
        var activeWidth = $active.width();

        if ($active.length) {
          var offset = $active.offset().left + activeWidth;

          if (offset > scrollingTabWidth - 30) {
            var scrollLeft = scrollingTabWidth / 2;
            scrollLeft = offset - scrollLeft - activeWidth / 2;
            $this.scrollLeft(scrollLeft);
          }
        }
      });
    });
  }).call(this);
}).call(window);

/***/ }),
/* 309 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-param-reassign, no-void, prefer-template, no-var, new-cap, prefer-arrow-callback, consistent-return, max-len */
  (function () {
    (function (w) {
      if (w.gl == null) {
        w.gl = {};
      }
      if (gl.animate == null) {
        gl.animate = {};
      }
      gl.animate.animate = function ($el, animation, options, done) {
        if ((options != null ? options.cssStart : void 0) != null) {
          $el.css(options.cssStart);
        }
        $el.removeClass(animation + ' animated').addClass(animation + ' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
          $(this).removeClass(animation + ' animated');
          if (done != null) {
            done();
          }
          if ((options != null ? options.cssEnd : void 0) != null) {
            $el.css(options.cssEnd);
          }
        });
      };
      gl.animate.animateEach = function ($els, animation, time, options, done) {
        var dfd;
        dfd = $.Deferred();
        if (!$els.length) {
          dfd.resolve();
        }
        $els.each(function (i) {
          setTimeout(function (_this) {
            return function () {
              var $this;
              $this = $(_this);
              return gl.animate.animate($this, animation, options, function () {
                if (i === $els.length - 1) {
                  dfd.resolve();
                  if (done != null) {
                    return done();
                  }
                }
              });
            };
          }(this), time * i);
        });
        return dfd.promise();
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, consistent-return, prefer-arrow-callback, no-return-assign, object-shorthand, comma-dangle, no-param-reassign, max-len */

  (function () {
    (function (w) {
      var notificationGranted, notifyMe, notifyPermissions;
      notificationGranted = function notificationGranted(message, opts, onclick) {
        var notification;
        notification = new Notification(message, opts);
        setTimeout(function () {
          return notification.close();
          // Hide the notification after X amount of seconds
        }, 8000);
        if (onclick) {
          return notification.onclick = onclick;
        }
      };
      notifyPermissions = function notifyPermissions() {
        if ('Notification' in window) {
          return Notification.requestPermission();
        }
      };
      notifyMe = function notifyMe(message, body, icon, onclick) {
        var opts;
        opts = {
          body: body,
          icon: icon
        };
        // Let's check if the browser supports notifications
        if (!('Notification' in window)) {

          // do nothing
        } else if (Notification.permission === 'granted') {
          // If it's okay let's create a notification
          return notificationGranted(message, opts, onclick);
        } else if (Notification.permission !== 'denied') {
          return Notification.requestPermission(function (permission) {
            // If the user accepts, let's create a notification
            if (permission === 'granted') {
              return notificationGranted(message, opts, onclick);
            }
          });
        }
      };
      w.notify = notifyMe;
      return w.notifyPermissions = notifyPermissions;
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, no-return-assign, max-len */
  (function () {
    (function (w) {
      var base;
      if (w.gl == null) {
        w.gl = {};
      }
      if ((base = w.gl).utils == null) {
        base.utils = {};
      }
      return w.gl.utils.isObject = function (obj) {
        return obj != null && obj.constructor === Object;
      };
    })(window);
  }).call(this);
}).call(window);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-underscore-dangle, no-param-reassign, prefer-template, quotes, comma-dangle, prefer-arrow-callback, consistent-return, one-var, one-var-declaration-per-line, no-else-return, max-len */

  // LineHighlighter
  //
  // Handles single- and multi-line selection and highlight for blob views.
  //
  __webpack_require__(27);

  //
  // ### Example Markup
  //
  //   <div id="blob-content-holder">
  //     <div class="file-content">
  //       <div class="line-numbers">
  //         <a href="#L1" id="L1" data-line-number="1">1</a>
  //         <a href="#L2" id="L2" data-line-number="2">2</a>
  //         <a href="#L3" id="L3" data-line-number="3">3</a>
  //         <a href="#L4" id="L4" data-line-number="4">4</a>
  //         <a href="#L5" id="L5" data-line-number="5">5</a>
  //       </div>
  //       <pre class="code highlight">
  //         <code>
  //           <span id="LC1" class="line">...</span>
  //           <span id="LC2" class="line">...</span>
  //           <span id="LC3" class="line">...</span>
  //           <span id="LC4" class="line">...</span>
  //           <span id="LC5" class="line">...</span>
  //         </code>
  //       </pre>
  //     </div>
  //   </div>
  //
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.LineHighlighter = function () {
      // CSS class applied to highlighted lines
      LineHighlighter.prototype.highlightClass = 'hll';

      // Internal copy of location.hash so we're not dependent on `location` in tests
      LineHighlighter.prototype._hash = '';

      function LineHighlighter(hash) {
        var range;
        if (hash == null) {
          // Initialize a LineHighlighter object
          //
          // hash - String URL hash for dependency injection in tests
          hash = location.hash;
        }
        this.setHash = bind(this.setHash, this);
        this.highlightLine = bind(this.highlightLine, this);
        this.clickHandler = bind(this.clickHandler, this);
        this._hash = hash;
        this.bindEvents();
        if (hash !== '') {
          range = this.hashToRange(hash);
          if (range[0]) {
            this.highlightRange(range);
            $.scrollTo("#L" + range[0], {
              // Scroll to the first highlighted line on initial load
              // Offset -50 for the sticky top bar, and another -100 for some context
              offset: -150
            });
          }
        }
      }

      LineHighlighter.prototype.bindEvents = function () {
        $('#blob-content-holder').on('mousedown', 'a[data-line-number]', this.clickHandler);
        // While it may seem odd to bind to the mousedown event and then throw away
        // the click event, there is a method to our madness.
        //
        // If not done this way, the line number anchor will sometimes keep its
        // active state even when the event is cancelled, resulting in an ugly border
        // around the link and/or a persisted underline text decoration.
        $('#blob-content-holder').on('click', 'a[data-line-number]', function (event) {
          event.preventDefault();
          event.stopPropagation();
        });
      };

      LineHighlighter.prototype.clickHandler = function (event) {
        var current, lineNumber, range;
        event.preventDefault();
        this.clearHighlight();
        lineNumber = $(event.target).closest('a').data('line-number');
        current = this.hashToRange(this._hash);
        if (!(current[0] && event.shiftKey)) {
          // If there's no current selection, or there is but Shift wasn't held,
          // treat this like a single-line selection.
          this.setHash(lineNumber);
          return this.highlightLine(lineNumber);
        } else if (event.shiftKey) {
          if (lineNumber < current[0]) {
            range = [lineNumber, current[0]];
          } else {
            range = [current[0], lineNumber];
          }
          this.setHash(range[0], range[1]);
          return this.highlightRange(range);
        }
      };

      LineHighlighter.prototype.clearHighlight = function () {
        return $("." + this.highlightClass).removeClass(this.highlightClass);
        // Unhighlight previously highlighted lines
      };

      // Convert a URL hash String into line numbers
      //
      // hash - Hash String
      //
      // Examples:
      //
      //   hashToRange('#L5')    # => [5, null]
      //   hashToRange('#L5-15') # => [5, 15]
      //   hashToRange('#foo')   # => [null, null]
      //
      // Returns an Array
      LineHighlighter.prototype.hashToRange = function (hash) {
        var first, last, matches;
        // ?L(\d+)(?:-(\d+))?$/)
        matches = hash.match(/^#?L(\d+)(?:-(\d+))?$/);
        if (matches && matches.length) {
          first = parseInt(matches[1], 10);
          last = matches[2] ? parseInt(matches[2], 10) : null;
          return [first, last];
        } else {
          return [null, null];
        }
      };

      // Highlight a single line
      //
      // lineNumber - Line number to highlight
      LineHighlighter.prototype.highlightLine = function (lineNumber) {
        return $("#LC" + lineNumber).addClass(this.highlightClass);
      };

      // Highlight all lines within a range
      //
      // range - Array containing the starting and ending line numbers
      LineHighlighter.prototype.highlightRange = function (range) {
        var i, lineNumber, ref, ref1, results;
        if (range[1]) {
          results = [];
          for (lineNumber = i = ref = range[0], ref1 = range[1]; ref <= ref1 ? i <= ref1 : i >= ref1; lineNumber = ref <= ref1 ? i += 1 : i -= 1) {
            results.push(this.highlightLine(lineNumber));
          }
          return results;
        } else {
          return this.highlightLine(range[0]);
        }
      };

      // Set the URL hash string
      LineHighlighter.prototype.setHash = function (firstLineNumber, lastLineNumber) {
        var hash;
        if (lastLineNumber) {
          hash = "#L" + firstLineNumber + "-" + lastLineNumber;
        } else {
          hash = "#L" + firstLineNumber;
        }
        this._hash = hash;
        return this.__setLocationHash__(hash);
      };

      // Make the actual hash change in the browser
      //
      // This method is stubbed in tests.
      LineHighlighter.prototype.__setLocationHash__ = function (value) {
        return history.pushState({
          url: value
          // We're using pushState instead of assigning location.hash directly to
          // prevent the page from scrolling on the hashchange event
        }, document.title, value);
      };

      return LineHighlighter;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 313 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback */

  (function () {
    window.addEventListener('beforeunload', function () {
      $('.tanuki-logo').addClass('animate');
    });
  }).call(this);
}).call(window);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, no-underscore-dangle, one-var, one-var-declaration-per-line, consistent-return, dot-notation, quote-props, comma-dangle, object-shorthand, max-len, prefer-arrow-callback */
  /* global MergeRequestTabs */

  __webpack_require__(28);
  __webpack_require__(49);
  __webpack_require__(39);

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.MergeRequest = function () {
      function MergeRequest(opts) {
        // Initialize MergeRequest behavior
        //
        // Options:
        //   action - String, current controller action
        //
        this.opts = opts != null ? opts : {};
        this.submitNoteForm = bind(this.submitNoteForm, this);
        this.$el = $('.merge-request');
        this.$('.show-all-commits').on('click', function (_this) {
          return function () {
            return _this.showAllCommits();
          };
        }(this));
        this.initTabs();
        // Prevent duplicate event bindings
        this.disableTaskList();
        this.initMRBtnListeners();
        this.initCommitMessageListeners();
        if ($("a.btn-close").length) {
          this.initTaskList();
        }
      }

      // Local jQuery finder
      MergeRequest.prototype.$ = function (selector) {
        return this.$el.find(selector);
      };

      MergeRequest.prototype.initTabs = function () {
        if (window.mrTabs) {
          window.mrTabs.unbindEvents();
        }
        window.mrTabs = new gl.MergeRequestTabs(this.opts);
      };

      MergeRequest.prototype.showAllCommits = function () {
        this.$('.first-commits').remove();
        return this.$('.all-commits').removeClass('hide');
      };

      MergeRequest.prototype.initTaskList = function () {
        $('.detail-page-description .js-task-list-container').taskList('enable');
        return $(document).on('tasklist:changed', '.detail-page-description .js-task-list-container', this.updateTaskList);
      };

      MergeRequest.prototype.initMRBtnListeners = function () {
        var _this;
        _this = this;
        return $('a.btn-close, a.btn-reopen').on('click', function (e) {
          var $this, shouldSubmit;
          $this = $(this);
          shouldSubmit = $this.hasClass('btn-comment');
          if (shouldSubmit && $this.data('submitted')) {
            return;
          }
          if (shouldSubmit) {
            if ($this.hasClass('btn-comment-and-close') || $this.hasClass('btn-comment-and-reopen')) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return _this.submitNoteForm($this.closest('form'), $this);
            }
          }
        });
      };

      MergeRequest.prototype.submitNoteForm = function (form, $button) {
        var noteText;
        noteText = form.find("textarea.js-note-text").val();
        if (noteText.trim().length > 0) {
          form.submit();
          $button.data('submitted', true);
          return $button.trigger('click');
        }
      };

      MergeRequest.prototype.disableTaskList = function () {
        $('.detail-page-description .js-task-list-container').taskList('disable');
        return $(document).off('tasklist:changed', '.detail-page-description .js-task-list-container');
      };

      MergeRequest.prototype.updateTaskList = function () {
        var patchData;
        patchData = {};
        patchData['merge_request'] = {
          'description': $('.js-task-list-field', this).val()
        };
        return $.ajax({
          type: 'PATCH',
          url: $('form.js-issuable-update').attr('action'),
          data: patchData,
          success: function success(mergeRequest) {
            document.querySelector('#task_status').innerText = mergeRequest.task_status;
            document.querySelector('#task_status_short').innerText = mergeRequest.task_status_short;
          }
        });
        // TODO (rspeicher): Make the merge request description inline-editable like a
        // note so that we can re-use its form here
      };

      MergeRequest.prototype.initCommitMessageListeners = function () {
        $(document).on('click', 'a.js-with-description-link', function (e) {
          var textarea = $('textarea.js-commit-message');
          e.preventDefault();

          textarea.val(textarea.data('messageWithDescription'));
          $('p.js-with-description-hint').hide();
          $('p.js-without-description-hint').show();
        });

        $(document).on('click', 'a.js-without-description-link', function (e) {
          var textarea = $('textarea.js-commit-message');
          e.preventDefault();

          textarea.val(textarea.data('messageWithoutDescription'));
          $('p.js-with-description-hint').show();
          $('p.js-without-description-hint').hide();
        });
      };

      return MergeRequest;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, max-len */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.MergedButtons = function () {
      function MergedButtons() {
        this.removeSourceBranch = bind(this.removeSourceBranch, this);
        this.$removeBranchWidget = $('.remove_source_branch_widget');
        this.$removeBranchProgress = $('.remove_source_branch_in_progress');
        this.$removeBranchFailed = $('.remove_source_branch_widget.failed');
        this.cleanEventListeners();
        this.initEventListeners();
      }

      MergedButtons.prototype.cleanEventListeners = function () {
        $(document).off('click', '.remove_source_branch');
        $(document).off('ajax:success', '.remove_source_branch');
        return $(document).off('ajax:error', '.remove_source_branch');
      };

      MergedButtons.prototype.initEventListeners = function () {
        $(document).on('click', '.remove_source_branch', this.removeSourceBranch);
        $(document).on('ajax:success', '.remove_source_branch', this.removeBranchSuccess);
        return $(document).on('ajax:error', '.remove_source_branch', this.removeBranchError);
      };

      MergedButtons.prototype.removeSourceBranch = function () {
        this.$removeBranchWidget.hide();
        return this.$removeBranchProgress.show();
      };

      MergedButtons.prototype.removeBranchSuccess = function () {
        return location.reload();
      };

      MergedButtons.prototype.removeBranchError = function () {
        this.$removeBranchWidget.hide();
        this.$removeBranchProgress.hide();
        return this.$removeBranchFailed.show();
      };

      return MergedButtons;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 316 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-use-before-define, camelcase, quotes, object-shorthand, no-shadow, no-unused-vars, comma-dangle, no-var, prefer-template, no-underscore-dangle, consistent-return, one-var, one-var-declaration-per-line, default-case, prefer-arrow-callback, max-len */
  /* global Flash */

  (function () {
    this.Milestone = function () {
      Milestone.updateIssue = function (li, issue_url, data) {
        return $.ajax({
          type: "PUT",
          url: issue_url,
          data: data,
          success: function (_this) {
            return function (_data) {
              return _this.successCallback(_data, li);
            };
          }(this),
          error: function error(data) {
            return new Flash("Issue update failed", 'alert');
          },
          dataType: "json"
        });
      };

      Milestone.sortIssues = function (data) {
        var sort_issues_url;
        sort_issues_url = location.href + "/sort_issues";
        return $.ajax({
          type: "PUT",
          url: sort_issues_url,
          data: data,
          success: function (_this) {
            return function (_data) {
              return _this.successCallback(_data);
            };
          }(this),
          error: function error() {
            return new Flash("Issues update failed", 'alert');
          },
          dataType: "json"
        });
      };

      Milestone.sortMergeRequests = function (data) {
        var sort_mr_url;
        sort_mr_url = location.href + "/sort_merge_requests";
        return $.ajax({
          type: "PUT",
          url: sort_mr_url,
          data: data,
          success: function (_this) {
            return function (_data) {
              return _this.successCallback(_data);
            };
          }(this),
          error: function error(data) {
            return new Flash("Issue update failed", 'alert');
          },
          dataType: "json"
        });
      };

      Milestone.updateMergeRequest = function (li, merge_request_url, data) {
        return $.ajax({
          type: "PUT",
          url: merge_request_url,
          data: data,
          success: function (_this) {
            return function (_data) {
              return _this.successCallback(_data, li);
            };
          }(this),
          error: function error(data) {
            return new Flash("Issue update failed", 'alert');
          },
          dataType: "json"
        });
      };

      Milestone.successCallback = function (data, element) {
        var img_tag;
        if (data.assignee) {
          img_tag = $('<img/>');
          img_tag.attr('src', data.assignee.avatar_url);
          img_tag.addClass('avatar s16');
          $(element).find('.assignee-icon').html(img_tag);
        } else {
          $(element).find('.assignee-icon').html('');
        }
        return $(element).effect('highlight');
      };

      function Milestone() {
        var oldMouseStart;
        oldMouseStart = $.ui.sortable.prototype._mouseStart;
        $.ui.sortable.prototype._mouseStart = function (event, overrideHandle, noActivation) {
          this._trigger("beforeStart", event, this._uiHash());
          return oldMouseStart.apply(this, [event, overrideHandle, noActivation]);
        };
        this.bindIssuesSorting();
        this.bindMergeRequestSorting();
        this.bindTabsSwitching();
      }

      Milestone.prototype.bindIssuesSorting = function () {
        return $("#issues-list-unassigned, #issues-list-ongoing, #issues-list-closed").sortable({
          connectWith: ".issues-sortable-list",
          dropOnEmpty: true,
          items: "li:not(.ui-sort-disabled)",
          beforeStart: function beforeStart(event, ui) {
            return $(".issues-sortable-list").css("min-height", ui.item.outerHeight());
          },
          stop: function stop(event, ui) {
            return $(".issues-sortable-list").css("min-height", "0px");
          },
          update: function update(event, ui) {
            var data;
            // Prevents sorting from container which element has been removed.
            if ($(this).find(ui.item).length > 0) {
              data = $(this).sortable("serialize");
              return Milestone.sortIssues(data);
            }
          },
          receive: function receive(event, ui) {
            var data, issue_id, issue_url, new_state;
            new_state = $(this).data('state');
            issue_id = ui.item.data('iid');
            issue_url = ui.item.data('url');
            data = function () {
              switch (new_state) {
                case 'ongoing':
                  return "issue[assignee_id]=" + gon.current_user_id;
                case 'unassigned':
                  return "issue[assignee_id]=";
                case 'closed':
                  return "issue[state_event]=close";
              }
            }();
            if ($(ui.sender).data('state') === "closed") {
              data += "&issue[state_event]=reopen";
            }
            return Milestone.updateIssue(ui.item, issue_url, data);
          }
        }).disableSelection();
      };

      Milestone.prototype.bindTabsSwitching = function () {
        return $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
          var currentTabClass, previousTabClass;
          currentTabClass = $(e.target).data('show');
          previousTabClass = $(e.relatedTarget).data('show');
          $(previousTabClass).hide();
          $(currentTabClass).removeClass('hidden');
          return $(currentTabClass).show();
        });
      };

      Milestone.prototype.bindMergeRequestSorting = function () {
        return $("#merge_requests-list-unassigned, #merge_requests-list-ongoing, #merge_requests-list-closed").sortable({
          connectWith: ".merge_requests-sortable-list",
          dropOnEmpty: true,
          items: "li:not(.ui-sort-disabled)",
          beforeStart: function beforeStart(event, ui) {
            return $(".merge_requests-sortable-list").css("min-height", ui.item.outerHeight());
          },
          stop: function stop(event, ui) {
            return $(".merge_requests-sortable-list").css("min-height", "0px");
          },
          update: function update(event, ui) {
            var data;
            data = $(this).sortable("serialize");
            return Milestone.sortMergeRequests(data);
          },
          receive: function receive(event, ui) {
            var data, merge_request_id, merge_request_url, new_state;
            new_state = $(this).data('state');
            merge_request_id = ui.item.data('iid');
            merge_request_url = ui.item.data('url');
            data = function () {
              switch (new_state) {
                case 'ongoing':
                  return "merge_request[assignee_id]=" + gon.current_user_id;
                case 'unassigned':
                  return "merge_request[assignee_id]=";
                case 'closed':
                  return "merge_request[state_event]=close";
              }
            }();
            if ($(ui.sender).data('state') === "closed") {
              data += "&merge_request[state_event]=reopen";
            }
            return Milestone.updateMergeRequest(ui.item, merge_request_url, data);
          }
        }).disableSelection();
      };

      return Milestone;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 317 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, one-var-declaration-per-line, no-unused-vars, object-shorthand, comma-dangle, no-else-return, no-self-compare, consistent-return, no-param-reassign, no-shadow */
  /* global Vue */
  /* global Issuable */
  /* global ListMilestone */

  (function () {
    this.MilestoneSelect = function () {
      function MilestoneSelect(currentProject, els) {
        var _this, $els;
        if (currentProject != null) {
          _this = this;
          this.currentProject = JSON.parse(currentProject);
        }

        $els = $(els);

        if (!els) {
          $els = $('.js-milestone-select');
        }

        $els.each(function (i, dropdown) {
          var $block, $dropdown, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, collapsedSidebarLabelTemplate, defaultLabel, issuableId, issueUpdateURL, milestoneLinkNoneTemplate, milestoneLinkTemplate, milestonesUrl, projectId, selectedMilestone, showAny, showNo, showUpcoming, useId, showMenuAbove;
          $dropdown = $(dropdown);
          projectId = $dropdown.data('project-id');
          milestonesUrl = $dropdown.data('milestones');
          issueUpdateURL = $dropdown.data('issueUpdate');
          selectedMilestone = $dropdown.data('selected');
          showNo = $dropdown.data('show-no');
          showAny = $dropdown.data('show-any');
          showMenuAbove = $dropdown.data('showMenuAbove');
          showUpcoming = $dropdown.data('show-upcoming');
          useId = $dropdown.data('use-id');
          defaultLabel = $dropdown.data('default-label');
          issuableId = $dropdown.data('issuable-id');
          abilityName = $dropdown.data('ability-name');
          $selectbox = $dropdown.closest('.selectbox');
          $block = $selectbox.closest('.block');
          $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon');
          $value = $block.find('.value');
          $loading = $block.find('.block-loading').fadeOut();
          if (issueUpdateURL) {
            milestoneLinkTemplate = _.template('<a href="/<%- namespace %>/<%- path %>/milestones/<%- iid %>" class="bold has-tooltip" data-container="body" title="<%- remaining %>"><%- title %></a>');
            milestoneLinkNoneTemplate = '<span class="no-value">None</span>';
            collapsedSidebarLabelTemplate = _.template('<span class="has-tooltip" data-container="body" title="<%- remaining %>" data-placement="left"> <%- title %> </span>');
          }
          return $dropdown.glDropdown({
            showMenuAbove: showMenuAbove,
            data: function data(term, callback) {
              return $.ajax({
                url: milestonesUrl
              }).done(function (data) {
                var extraOptions = [];
                if (showAny) {
                  extraOptions.push({
                    id: 0,
                    name: '',
                    title: 'Any Milestone'
                  });
                }
                if (showNo) {
                  extraOptions.push({
                    id: -1,
                    name: 'No Milestone',
                    title: 'No Milestone'
                  });
                }
                if (showUpcoming) {
                  extraOptions.push({
                    id: -2,
                    name: '#upcoming',
                    title: 'Upcoming'
                  });
                }
                if (extraOptions.length) {
                  extraOptions.push('divider');
                }

                callback(extraOptions.concat(data));
                if (showMenuAbove) {
                  $dropdown.data('glDropdown').positionMenuAbove();
                }
              });
            },
            filterable: true,
            search: {
              fields: ['title']
            },
            selectable: true,
            toggleLabel: function toggleLabel(selected, el, e) {
              if (selected && 'id' in selected && $(el).hasClass('is-active')) {
                return selected.title;
              } else {
                return defaultLabel;
              }
            },
            defaultLabel: defaultLabel,
            fieldName: $dropdown.data('field-name'),
            text: function text(milestone) {
              return _.escape(milestone.title);
            },
            id: function id(milestone) {
              if (!useId && !$dropdown.is('.js-issuable-form-dropdown')) {
                return milestone.name;
              } else {
                return milestone.id;
              }
            },
            isSelected: function isSelected(milestone) {
              return milestone.name === selectedMilestone;
            },
            hidden: function hidden() {
              $selectbox.hide();
              // display:block overrides the hide-collapse rule
              return $value.css('display', '');
            },
            vue: $dropdown.hasClass('js-issue-board-sidebar'),
            clicked: function clicked(selected, $el, e) {
              var data, isIssueIndex, isMRIndex, page, boardsStore;
              page = $('body').data('page');
              isIssueIndex = page === 'projects:issues:index';
              isMRIndex = page === page && page === 'projects:merge_requests:index';
              if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
                e.preventDefault();
                return;
              }

              if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar') && !$dropdown.closest('.add-issues-modal').length) {
                boardsStore = gl.issueBoards.BoardsStore.state.filters;
              } else if ($dropdown.closest('.add-issues-modal').length) {
                boardsStore = gl.issueBoards.ModalStore.store.filter;
              }

              if (boardsStore) {
                boardsStore[$dropdown.data('field-name')] = selected.name;
                if (!$dropdown.closest('.add-issues-modal').length) {
                  gl.issueBoards.BoardsStore.updateFiltersUrl();
                }
                e.preventDefault();
              } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                if (selected.name != null) {
                  selectedMilestone = selected.name;
                } else {
                  selectedMilestone = '';
                }
                return Issuable.filterResults($dropdown.closest('form'));
              } else if ($dropdown.hasClass('js-filter-submit')) {
                return $dropdown.closest('form').submit();
              } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
                if (selected.id !== -1) {
                  Vue.set(gl.issueBoards.BoardsStore.detail.issue, 'milestone', new ListMilestone({
                    id: selected.id,
                    title: selected.name
                  }));
                } else {
                  Vue.delete(gl.issueBoards.BoardsStore.detail.issue, 'milestone');
                }

                $dropdown.trigger('loading.gl.dropdown');
                $loading.fadeIn();

                gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                  $dropdown.trigger('loaded.gl.dropdown');
                  $loading.fadeOut();
                });
              } else {
                selected = $selectbox.find('input[type="hidden"]').val();
                data = {};
                data[abilityName] = {};
                data[abilityName].milestone_id = selected != null ? selected : null;
                $loading.fadeIn();
                $dropdown.trigger('loading.gl.dropdown');
                return $.ajax({
                  type: 'PUT',
                  url: issueUpdateURL,
                  data: data
                }).done(function (data) {
                  $dropdown.trigger('loaded.gl.dropdown');
                  $loading.fadeOut();
                  $selectbox.hide();
                  $value.css('display', '');
                  if (data.milestone != null) {
                    data.milestone.namespace = _this.currentProject.namespace;
                    data.milestone.path = _this.currentProject.path;
                    data.milestone.remaining = gl.utils.timeFor(data.milestone.due_date);
                    $value.html(milestoneLinkTemplate(data.milestone));
                    return $sidebarCollapsedValue.find('span').html(collapsedSidebarLabelTemplate(data.milestone));
                  } else {
                    $value.html(milestoneLinkNoneTemplate);
                    return $sidebarCollapsedValue.find('span').text('No');
                  }
                });
              }
            }
          });
        });
      }

      return MilestoneSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 318 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, vars-on-top, one-var-declaration-per-line, comma-dangle, object-shorthand, no-else-return, prefer-template, quotes, prefer-arrow-callback, no-param-reassign, no-cond-assign, max-len */
  /* global Api */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    window.NamespaceSelect = function () {
      function NamespaceSelect(opts) {
        this.onSelectItem = bind(this.onSelectItem, this);
        var fieldName, showAny;
        this.dropdown = opts.dropdown;
        showAny = true;
        fieldName = 'namespace_id';
        if (this.dropdown.attr('data-field-name')) {
          fieldName = this.dropdown.data('fieldName');
        }
        if (this.dropdown.attr('data-show-any')) {
          showAny = this.dropdown.data('showAny');
        }
        this.dropdown.glDropdown({
          filterable: true,
          selectable: true,
          filterRemote: true,
          search: {
            fields: ['path']
          },
          fieldName: fieldName,
          toggleLabel: function toggleLabel(selected) {
            if (selected.id == null) {
              return selected.text;
            } else {
              return selected.kind + ": " + selected.path;
            }
          },
          data: function data(term, dataCallback) {
            return Api.namespaces(term, function (namespaces) {
              var anyNamespace;
              if (showAny) {
                anyNamespace = {
                  text: 'Any namespace',
                  id: null
                };
                namespaces.unshift(anyNamespace);
                namespaces.splice(1, 0, 'divider');
              }
              return dataCallback(namespaces);
            });
          },
          text: function text(namespace) {
            if (namespace.id == null) {
              return namespace.text;
            } else {
              return namespace.kind + ": " + namespace.path;
            }
          },
          renderRow: this.renderRow,
          clicked: this.onSelectItem
        });
      }

      NamespaceSelect.prototype.onSelectItem = function (item, el, e) {
        return e.preventDefault();
      };

      return NamespaceSelect;
    }();

    window.NamespaceSelects = function () {
      function NamespaceSelects(opts) {
        var ref;
        if (opts == null) {
          opts = {};
        }
        this.$dropdowns = (ref = opts.$dropdowns) != null ? ref : $('.js-namespace-select');
        this.$dropdowns.each(function (i, dropdown) {
          var $dropdown;
          $dropdown = $(dropdown);
          return new window.NamespaceSelect({
            dropdown: $dropdown
          });
        });
      }

      return NamespaceSelects;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, one-var, prefer-rest-params, max-len, vars-on-top, wrap-iife, consistent-return, comma-dangle, one-var-declaration-per-line, quotes, no-return-assign, prefer-arrow-callback, prefer-template, no-shadow, no-else-return, max-len */
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
        indexOf = [].indexOf || function (item) {
      for (var i = 0, l = this.length; i < l; i += 1) {
        if (i in this && this[i] === item) return i;
      }return -1;
    };

    this.NewBranchForm = function () {
      function NewBranchForm(form, availableRefs) {
        this.validate = bind(this.validate, this);
        this.branchNameError = form.find('.js-branch-name-error');
        this.name = form.find('.js-branch-name');
        this.ref = form.find('#ref');
        this.setupAvailableRefs(availableRefs);
        this.setupRestrictions();
        this.addBinding();
        this.init();
      }

      NewBranchForm.prototype.addBinding = function () {
        return this.name.on('blur', this.validate);
      };

      NewBranchForm.prototype.init = function () {
        if (this.name.val().length > 0) {
          return this.name.trigger('blur');
        }
      };

      NewBranchForm.prototype.setupAvailableRefs = function (availableRefs) {
        return this.ref.autocomplete({
          source: availableRefs,
          minLength: 1
        });
      };

      NewBranchForm.prototype.setupRestrictions = function () {
        var endsWith, invalid, single, startsWith;
        startsWith = {
          pattern: /^(\/|\.)/g,
          prefix: "can't start with",
          conjunction: "or"
        };
        endsWith = {
          pattern: /(\/|\.|\.lock)$/g,
          prefix: "can't end in",
          conjunction: "or"
        };
        invalid = {
          pattern: /(\s|~|\^|:|\?|\*|\[|\\|\.\.|@\{|\/{2,}){1}/g,
          prefix: "can't contain",
          conjunction: ", "
        };
        single = {
          pattern: /^@+$/g,
          prefix: "can't be",
          conjunction: "or"
        };
        return this.restrictions = [startsWith, invalid, endsWith, single];
      };

      NewBranchForm.prototype.validate = function () {
        var errorMessage, errors, formatter, unique, validator;
        this.branchNameError.empty();
        unique = function unique(values, value) {
          if (indexOf.call(values, value) < 0) {
            values.push(value);
          }
          return values;
        };
        formatter = function formatter(values, restriction) {
          var formatted;
          formatted = values.map(function (value) {
            switch (false) {
              case !/\s/.test(value):
                return 'spaces';
              case !/\/{2,}/g.test(value):
                return 'consecutive slashes';
              default:
                return "'" + value + "'";
            }
          });
          return restriction.prefix + " " + formatted.join(restriction.conjunction);
        };
        validator = function (_this) {
          return function (errors, restriction) {
            var matched;
            matched = _this.name.val().match(restriction.pattern);
            if (matched) {
              return errors.concat(formatter(matched.reduce(unique, []), restriction));
            } else {
              return errors;
            }
          };
        }(this);
        errors = this.restrictions.reduce(validator, []);
        if (errors.length > 0) {
          errorMessage = $("<span/>").text(errors.join(', '));
          return this.branchNameError.append(errorMessage);
        }
      };

      return NewBranchForm;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 322 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-return-assign, max-len */
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.NewCommitForm = function () {
      function NewCommitForm(form) {
        this.renderDestination = bind(this.renderDestination, this);
        this.newBranch = form.find('.js-target-branch');
        this.originalBranch = form.find('.js-original-branch');
        this.createMergeRequest = form.find('.js-create-merge-request');
        this.createMergeRequestContainer = form.find('.js-create-merge-request-container');
        this.renderDestination();
        this.newBranch.keyup(this.renderDestination);
      }

      NewCommitForm.prototype.renderDestination = function () {
        var different;
        different = this.newBranch.val() !== this.originalBranch.val();
        if (different) {
          this.createMergeRequestContainer.show();
          if (!this.wasDifferent) {
            this.createMergeRequest.prop('checked', true);
          }
        } else {
          this.createMergeRequestContainer.hide();
          this.createMergeRequest.prop('checked', false);
        }
        return this.wasDifferent = different;
      };

      return NewCommitForm;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-restricted-properties, func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase, no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line, default-case, prefer-template, consistent-return, no-alert, no-return-assign, no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new, brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow, newline-per-chained-call, no-useless-escape */
  /* global Flash */
  /* global Autosave */
  /* global ResolveService */
  /* global mrRefreshWidgetUrl */

  __webpack_require__(25);
  window.autosize = __webpack_require__(153);
  window.Dropzone = __webpack_require__(26);
  __webpack_require__(103);
  __webpack_require__(35);
  __webpack_require__(54); // required by jquery.atwho
  __webpack_require__(53);
  __webpack_require__(49);

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.Notes = function () {
      var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;

      Notes.interval = null;

      function Notes(notes_url, note_ids, last_fetched_at, view) {
        this.updateTargetButtons = bind(this.updateTargetButtons, this);
        this.updateCloseButton = bind(this.updateCloseButton, this);
        this.visibilityChange = bind(this.visibilityChange, this);
        this.cancelDiscussionForm = bind(this.cancelDiscussionForm, this);
        this.addDiffNote = bind(this.addDiffNote, this);
        this.setupDiscussionNoteForm = bind(this.setupDiscussionNoteForm, this);
        this.replyToDiscussionNote = bind(this.replyToDiscussionNote, this);
        this.removeNote = bind(this.removeNote, this);
        this.cancelEdit = bind(this.cancelEdit, this);
        this.updateNote = bind(this.updateNote, this);
        this.addDiscussionNote = bind(this.addDiscussionNote, this);
        this.addNoteError = bind(this.addNoteError, this);
        this.addNote = bind(this.addNote, this);
        this.resetMainTargetForm = bind(this.resetMainTargetForm, this);
        this.refresh = bind(this.refresh, this);
        this.keydownNoteText = bind(this.keydownNoteText, this);
        this.toggleCommitList = bind(this.toggleCommitList, this);
        this.notes_url = notes_url;
        this.note_ids = note_ids;
        this.last_fetched_at = last_fetched_at;
        this.view = view;
        this.noteable_url = document.URL;
        this.notesCountBadge || (this.notesCountBadge = $(".issuable-details").find(".notes-tab .badge"));
        this.basePollingInterval = 15000;
        this.maxPollingSteps = 4;
        this.cleanBinding();
        this.addBinding();
        this.setPollingInterval();
        this.setupMainTargetNoteForm();
        this.initTaskList();
        this.collapseLongCommitList();

        // We are in the Merge Requests page so we need another edit form for Changes tab
        if (gl.utils.getPagePath(1) === 'merge_requests') {
          $('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
        }
      }

      Notes.prototype.addBinding = function () {
        // add note to UI after creation
        $(document).on("ajax:success", ".js-main-target-form", this.addNote);
        $(document).on("ajax:success", ".js-discussion-note-form", this.addDiscussionNote);
        // catch note ajax errors
        $(document).on("ajax:error", ".js-main-target-form", this.addNoteError);
        // change note in UI after update
        $(document).on("ajax:success", "form.edit-note", this.updateNote);
        // Edit note link
        $(document).on("click", ".js-note-edit", this.showEditForm.bind(this));
        $(document).on("click", ".note-edit-cancel", this.cancelEdit);
        // Reopen and close actions for Issue/MR combined with note form submit
        $(document).on("click", ".js-comment-button", this.updateCloseButton);
        $(document).on("keyup input", ".js-note-text", this.updateTargetButtons);
        // resolve a discussion
        $(document).on('click', '.js-comment-resolve-button', this.resolveDiscussion);
        // remove a note (in general)
        $(document).on("click", ".js-note-delete", this.removeNote);
        // delete note attachment
        $(document).on("click", ".js-note-attachment-delete", this.removeAttachment);
        // reset main target form after submit
        $(document).on("ajax:complete", ".js-main-target-form", this.reenableTargetFormSubmitButton);
        $(document).on("ajax:success", ".js-main-target-form", this.resetMainTargetForm);
        // reset main target form when clicking discard
        $(document).on("click", ".js-note-discard", this.resetMainTargetForm);
        // update the file name when an attachment is selected
        $(document).on("change", ".js-note-attachment-input", this.updateFormAttachment);
        // reply to diff/discussion notes
        $(document).on("click", ".js-discussion-reply-button", this.replyToDiscussionNote);
        // add diff note
        $(document).on("click", ".js-add-diff-note-button", this.addDiffNote);
        // hide diff note form
        $(document).on("click", ".js-close-discussion-note-form", this.cancelDiscussionForm);
        // toggle commit list
        $(document).on("click", '.system-note-commit-list-toggler', this.toggleCommitList);
        // fetch notes when tab becomes visible
        $(document).on("visibilitychange", this.visibilityChange);
        // when issue status changes, we need to refresh data
        $(document).on("issuable:change", this.refresh);

        // when a key is clicked on the notes
        return $(document).on("keydown", ".js-note-text", this.keydownNoteText);
      };

      Notes.prototype.cleanBinding = function () {
        $(document).off("ajax:success", ".js-main-target-form");
        $(document).off("ajax:success", ".js-discussion-note-form");
        $(document).off("ajax:success", "form.edit-note");
        $(document).off("click", ".js-note-edit");
        $(document).off("click", ".note-edit-cancel");
        $(document).off("click", ".js-note-delete");
        $(document).off("click", ".js-note-attachment-delete");
        $(document).off("ajax:complete", ".js-main-target-form");
        $(document).off("ajax:success", ".js-main-target-form");
        $(document).off("click", ".js-discussion-reply-button");
        $(document).off("click", ".js-add-diff-note-button");
        $(document).off("visibilitychange");
        $(document).off("keyup", ".js-note-text");
        $(document).off("click", ".js-note-target-reopen");
        $(document).off("click", ".js-note-target-close");
        $(document).off("click", ".js-note-discard");
        $(document).off("keydown", ".js-note-text");
        $(document).off('click', '.js-comment-resolve-button');
        $(document).off("click", '.system-note-commit-list-toggler');
        $('.note .js-task-list-container').taskList('disable');
        return $(document).off('tasklist:changed', '.note .js-task-list-container');
      };

      Notes.prototype.keydownNoteText = function (e) {
        var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
        if (gl.utils.isMetaKey(e)) {
          return;
        }

        $textarea = $(e.target);
        // Edit previous note when UP arrow is hit
        switch (e.which) {
          case 38:
            if ($textarea.val() !== '') {
              return;
            }
            myLastNote = $("li.note[data-author-id='" + gon.current_user_id + "'][data-editable]:last");
            if (myLastNote.length) {
              myLastNoteEditBtn = myLastNote.find('.js-note-edit');
              return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
            }
            break;
          // Cancel creating diff note or editing any note when ESCAPE is hit
          case 27:
            discussionNoteForm = $textarea.closest('.js-discussion-note-form');
            if (discussionNoteForm.length) {
              if ($textarea.val() !== '') {
                if (!confirm('Are you sure you want to cancel creating this comment?')) {
                  return;
                }
              }
              this.removeDiscussionNoteForm(discussionNoteForm);
              return;
            }
            editNote = $textarea.closest('.note');
            if (editNote.length) {
              originalText = $textarea.closest('form').data('original-note');
              newText = $textarea.val();
              if (originalText !== newText) {
                if (!confirm('Are you sure you want to cancel editing this comment?')) {
                  return;
                }
              }
              return this.removeNoteEditForm(editNote);
            }
        }
      };

      Notes.prototype.initRefresh = function () {
        clearInterval(Notes.interval);
        return Notes.interval = setInterval(function (_this) {
          return function () {
            return _this.refresh();
          };
        }(this), this.pollingInterval);
      };

      Notes.prototype.refresh = function () {
        if (!document.hidden && document.URL.indexOf(this.noteable_url) === 0) {
          return this.getContent();
        }
      };

      Notes.prototype.getContent = function () {
        if (this.refreshing) {
          return;
        }
        this.refreshing = true;
        return $.ajax({
          url: this.notes_url,
          data: "last_fetched_at=" + this.last_fetched_at,
          dataType: "json",
          success: function (_this) {
            return function (data) {
              var notes;
              notes = data.notes;
              _this.last_fetched_at = data.last_fetched_at;
              _this.setPollingInterval(data.notes.length);
              return $.each(notes, function (i, note) {
                if (note.discussion_html != null) {
                  return _this.renderDiscussionNote(note);
                } else {
                  return _this.renderNote(note);
                }
              });
            };
          }(this)
        }).always(function (_this) {
          return function () {
            return _this.refreshing = false;
          };
        }(this));
      };

      /*
      Increase @pollingInterval up to 120 seconds on every function call,
      if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
      will reset to @basePollingInterval.
       Note: this function is used to gradually increase the polling interval
      if there aren't new notes coming from the server
       */

      Notes.prototype.setPollingInterval = function (shouldReset) {
        var nthInterval;
        if (shouldReset == null) {
          shouldReset = true;
        }
        nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
        if (shouldReset) {
          this.pollingInterval = this.basePollingInterval;
        } else if (this.pollingInterval < nthInterval) {
          this.pollingInterval *= 2;
        }
        return this.initRefresh();
      };

      Notes.prototype.handleCreateChanges = function (note) {
        if (typeof note === 'undefined') {
          return;
        }

        if (note.commands_changes && note.commands_changes.indexOf('merge') !== -1) {
          $.get(mrRefreshWidgetUrl);
        }
      };

      /*
      Render note in main comments area.
       Note: for rendering inline notes use renderDiscussionNote
       */

      Notes.prototype.renderNote = function (note) {
        var $notesList, votesBlock;
        if (!note.valid) {
          if (note.award) {
            new Flash('You have already awarded this emoji!', 'alert', this.parentTimeline);
          } else {
            if (note.errors.commands_only) {
              new Flash(note.errors.commands_only, 'notice', this.parentTimeline);
              this.refresh();
            }
          }
          return;
        }
        if (note.award) {
          votesBlock = $('.js-awards-block').eq(0);
          gl.awardsHandler.addAwardToEmojiBar(votesBlock, note.name);
          return gl.awardsHandler.scrollToAwards();
          // render note if it not present in loaded list
          // or skip if rendered
        } else if (this.isNewNote(note)) {
          this.note_ids.push(note.id);
          $notesList = $('ul.main-notes-list');
          $notesList.append(note.html).syntaxHighlight();
          // Update datetime format on the recent note
          gl.utils.localTimeAgo($notesList.find("#note_" + note.id + " .js-timeago"), false);
          this.collapseLongCommitList();
          this.initTaskList();
          this.refresh();
          return this.updateNotesCount(1);
        }
      };

      /*
      Check if note does not exists on page
       */

      Notes.prototype.isNewNote = function (note) {
        return $.inArray(note.id, this.note_ids) === -1;
      };

      Notes.prototype.isParallelView = function () {
        return this.view === 'parallel';
      };

      /*
      Render note in discussion area.
       Note: for rendering inline notes use renderDiscussionNote
       */

      Notes.prototype.renderDiscussionNote = function (note) {
        var discussionContainer, form, note_html, row;
        if (!this.isNewNote(note)) {
          return;
        }
        this.note_ids.push(note.id);
        form = $("#new-discussion-note-form-" + note.discussion_id);
        if (note.original_discussion_id != null && form.length === 0) {
          form = $("#new-discussion-note-form-" + note.original_discussion_id);
        }
        row = form.closest("tr");
        note_html = $(note.html);
        note_html.renderGFM();
        // is this the first note of discussion?
        discussionContainer = $(".notes[data-discussion-id='" + note.discussion_id + "']");
        if (note.original_discussion_id != null && discussionContainer.length === 0) {
          discussionContainer = $(".notes[data-discussion-id='" + note.original_discussion_id + "']");
        }
        if (discussionContainer.length === 0) {
          // insert the note and the reply button after the temp row
          row.after(note.diff_discussion_html);
          // remove the note (will be added again below)
          row.next().find(".note").remove();
          // Before that, the container didn't exist
          discussionContainer = $(".notes[data-discussion-id='" + note.discussion_id + "']");
          // Add note to 'Changes' page discussions
          discussionContainer.append(note_html);
          // Init discussion on 'Discussion' page if it is merge request page
          if ($('body').attr('data-page').indexOf('projects:merge_request') === 0) {
            $('ul.main-notes-list').append(note.discussion_html).renderGFM();
          }
        } else {
          // append new note to all matching discussions
          discussionContainer.append(note_html);
        }

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        gl.utils.localTimeAgo($('.js-timeago'), false);
        return this.updateNotesCount(1);
      };

      /*
      Called in response the main target form has been successfully submitted.
       Removes any errors.
      Resets text and preview.
      Resets buttons.
       */

      Notes.prototype.resetMainTargetForm = function (e) {
        var form;
        form = $(".js-main-target-form");
        // remove validation errors
        form.find(".js-errors").remove();
        // reset text and preview
        form.find(".js-md-write-button").click();
        form.find(".js-note-text").val("").trigger("input");
        form.find(".js-note-text").data("autosave").reset();

        var event = document.createEvent('Event');
        event.initEvent('autosize:update', true, false);
        form.find('.js-autosize')[0].dispatchEvent(event);

        this.updateTargetButtons(e);
      };

      Notes.prototype.reenableTargetFormSubmitButton = function () {
        var form;
        form = $(".js-main-target-form");
        return form.find(".js-note-text").trigger("input");
      };

      /*
      Shows the main form and does some setup on it.
       Sets some hidden fields in the form.
       */

      Notes.prototype.setupMainTargetNoteForm = function () {
        var form;
        // find the form
        form = $(".js-new-note-form");
        // Set a global clone of the form for later cloning
        this.formClone = form.clone();
        // show the form
        this.setupNoteForm(form);
        // fix classes
        form.removeClass("js-new-note-form");
        form.addClass("js-main-target-form");
        form.find("#note_line_code").remove();
        form.find("#note_position").remove();
        form.find("#note_type").remove();
        form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
        return this.parentTimeline = form.parents('.timeline');
      };

      /*
      General note form setup.
       deactivates the submit button when text is empty
      hides the preview button when text is empty
      setup GFM auto complete
      show the form
       */

      Notes.prototype.setupNoteForm = function (form) {
        var textarea;
        new gl.GLForm(form);
        textarea = form.find(".js-note-text");
        return new Autosave(textarea, ["Note", form.find("#note_noteable_type").val(), form.find("#note_noteable_id").val(), form.find("#note_commit_id").val(), form.find("#note_type").val(), form.find("#note_line_code").val(), form.find("#note_position").val()]);
      };

      /*
      Called in response to the new note form being submitted
       Adds new note to list.
       */

      Notes.prototype.addNote = function (xhr, note, status) {
        this.handleCreateChanges(note);
        return this.renderNote(note);
      };

      Notes.prototype.addNoteError = function (xhr, note, status) {
        return new Flash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', this.parentTimeline);
      };

      /*
      Called in response to the new note form being submitted
       Adds new note to list.
       */

      Notes.prototype.addDiscussionNote = function (xhr, note, status) {
        var $form = $(xhr.target);

        if ($form.attr('data-resolve-all') != null) {
          var projectPath = $form.data('project-path');
          var discussionId = $form.data('discussion-id');
          var mergeRequestId = $form.data('noteable-iid');

          if (ResolveService != null) {
            ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
          }
        }

        this.renderDiscussionNote(note);
        // cleanup after successfully creating a diff/discussion note
        this.removeDiscussionNoteForm($form);
      };

      /*
      Called in response to the edit note form being submitted
       Updates the current note field.
       */

      Notes.prototype.updateNote = function (_xhr, note, _status) {
        var $html, $note_li;
        // Convert returned HTML to a jQuery object so we can modify it further
        $html = $(note.html);
        this.revertNoteEditForm();
        gl.utils.localTimeAgo($('.js-timeago', $html));
        $html.renderGFM();
        $html.find('.js-task-list-container').taskList('enable');
        // Find the note's `li` element by ID and replace it with the updated HTML
        $note_li = $('.note-row-' + note.id);

        $note_li.replaceWith($html);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      };

      Notes.prototype.checkContentToAllowEditing = function ($el) {
        var initialContent = $el.find('.original-note-content').text().trim();
        var currentContent = $el.find('.note-textarea').val();
        var isAllowed = true;

        if (currentContent === initialContent) {
          this.removeNoteEditForm($el);
        } else {
          var $buttons = $el.find('.note-form-actions');
          var isWidgetVisible = gl.utils.isInViewport($el.get(0));

          if (!isWidgetVisible) {
            gl.utils.scrollToElement($el);
          }

          $el.find('.js-edit-warning').show();
          isAllowed = false;
        }

        return isAllowed;
      };

      /*
      Called in response to clicking the edit note link
       Replaces the note text with the note edit form
      Adds a data attribute to the form with the original content of the note for cancellations
      */
      Notes.prototype.showEditForm = function (e, scrollTo, myLastNote) {
        e.preventDefault();

        var $target = $(e.target);
        var $editForm = $(this.getEditFormSelector($target));
        var $note = $target.closest('.note');
        var $currentlyEditing = $('.note.is-editting:visible');

        if ($currentlyEditing.length) {
          var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

          if (!isEditAllowed) {
            return;
          }
        }

        $note.find('.js-note-attachment-delete').show();
        $editForm.addClass('current-note-edit-form');
        $note.addClass('is-editting');
        this.putEditFormInPlace($target);
      };

      /*
      Called in response to clicking the edit note link
       Hides edit form and restores the original note text to the editor textarea.
       */

      Notes.prototype.cancelEdit = function (e) {
        e.preventDefault();
        var $target = $(e.target);
        var note = $target.closest('.note');
        note.find('.js-edit-warning').hide();
        this.revertNoteEditForm($target);
        return this.removeNoteEditForm(note);
      };

      Notes.prototype.revertNoteEditForm = function ($target) {
        $target = $target || $('.note.is-editting:visible');
        var selector = this.getEditFormSelector($target);
        var $editForm = $(selector);

        $editForm.insertBefore('.notes-form');
        $editForm.find('.js-comment-button').enable();
        $editForm.find('.js-edit-warning').hide();
      };

      Notes.prototype.getEditFormSelector = function ($el) {
        var selector = '.note-edit-form:not(.mr-note-edit-form)';

        if ($el.parents('#diffs').length) {
          selector = '.note-edit-form.mr-note-edit-form';
        }

        return selector;
      };

      Notes.prototype.removeNoteEditForm = function (note) {
        var form = note.find('.current-note-edit-form');
        note.removeClass('is-editting');
        form.removeClass('current-note-edit-form');
        form.find('.js-edit-warning').hide();
        // Replace markdown textarea text with original note text.
        return form.find('.js-note-text').val(form.find('form.edit-note').data('original-note'));
      };

      /*
      Called in response to deleting a note of any kind.
       Removes the actual note from view.
      Removes the whole discussion if the last note is being removed.
       */

      Notes.prototype.removeNote = function (e) {
        var noteId;
        noteId = $(e.currentTarget).closest(".note").attr("id");
        $(".note[id='" + noteId + "']").each(function (_this) {
          // A same note appears in the "Discussion" and in the "Changes" tab, we have
          // to remove all. Using $(".note[id='noteId']") ensure we get all the notes,
          // where $("#noteId") would return only one.
          return function (i, el) {
            var note, notes;
            note = $(el);
            notes = note.closest(".notes");

            if (typeof gl.diffNotesCompileComponents !== 'undefined') {
              if (gl.diffNoteApps[noteId]) {
                gl.diffNoteApps[noteId].$destroy();
              }
            }

            // check if this is the last note for this line
            if (notes.find(".note").length === 1) {
              // "Discussions" tab
              notes.closest(".timeline-entry").remove();
              // "Changes" tab / commit view
              notes.closest("tr").remove();
            }
            return note.remove();
          };
        }(this));
        // Decrement the "Discussions" counter only once
        return this.updateNotesCount(-1);
      };

      /*
      Called in response to clicking the delete attachment link
       Removes the attachment wrapper view, including image tag if it exists
      Resets the note editing form
       */

      Notes.prototype.removeAttachment = function () {
        var note;
        note = $(this).closest(".note");
        note.find(".note-attachment").remove();
        note.find(".note-body > .note-text").show();
        note.find(".note-header").show();
        return note.find(".current-note-edit-form").remove();
      };

      /*
      Called when clicking on the "reply" button for a diff line.
       Shows the note form below the notes.
       */

      Notes.prototype.replyToDiscussionNote = function (e) {
        var form, replyLink;
        form = this.formClone.clone();
        replyLink = $(e.target).closest(".js-discussion-reply-button");
        // insert the form after the button
        replyLink.closest('.discussion-reply-holder').hide().after(form);
        // show the form
        return this.setupDiscussionNoteForm(replyLink, form);
      };

      /*
      Shows the diff or discussion form and does some setup on it.
       Sets some hidden fields in the form.
       Note: dataHolder must have the "discussionId", "lineCode", "noteableType"
      and "noteableId" data attributes set.
       */

      Notes.prototype.setupDiscussionNoteForm = function (dataHolder, form) {
        // setup note target
        form.attr('id', "new-discussion-note-form-" + dataHolder.data("discussionId"));
        form.attr("data-line-code", dataHolder.data("lineCode"));
        form.find("#note_type").val(dataHolder.data("noteType"));
        form.find("#line_type").val(dataHolder.data("lineType"));
        form.find("#note_commit_id").val(dataHolder.data("commitId"));
        form.find("#note_line_code").val(dataHolder.data("lineCode"));
        form.find("#note_position").val(dataHolder.attr("data-position"));
        form.find("#note_noteable_type").val(dataHolder.data("noteableType"));
        form.find("#note_noteable_id").val(dataHolder.data("noteableId"));
        form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancel-text'));
        form.find('.js-note-target-close').remove();
        this.setupNoteForm(form);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          var $commentBtn = form.find('comment-and-resolve-btn');
          $commentBtn.attr(':discussion-id', "'" + dataHolder.data('discussionId') + "'");

          gl.diffNotesCompileComponents();
        }

        form.find(".js-note-text").focus();
        form.find('.js-comment-resolve-button').attr('data-discussion-id', dataHolder.data('discussionId'));
        form.removeClass('js-main-target-form').addClass("discussion-form js-discussion-note-form");
      };

      /*
      Called when clicking on the "add a comment" button on the side of a diff line.
       Inserts a temporary row for the form below the line.
      Sets up the form and shows it.
       */

      Notes.prototype.addDiffNote = function (e) {
        var $link, addForm, hasNotes, lineType, newForm, nextRow, noteForm, notesContent, notesContentSelector, replyButton, row, rowCssToAdd, targetContent;
        e.preventDefault();
        $link = $(e.currentTarget);
        row = $link.closest("tr");
        nextRow = row.next();
        hasNotes = nextRow.is(".notes_holder");
        addForm = false;
        notesContentSelector = ".notes_content";
        rowCssToAdd = "<tr class=\"notes_holder js-temp-notes-holder\"><td class=\"notes_line\" colspan=\"2\"></td><td class=\"notes_content\"><div class=\"content\"></div></td></tr>";
        // In parallel view, look inside the correct left/right pane
        if (this.isParallelView()) {
          lineType = $link.data("lineType");
          notesContentSelector += "." + lineType;
          rowCssToAdd = "<tr class=\"notes_holder js-temp-notes-holder\"><td class=\"notes_line old\"></td><td class=\"notes_content parallel old\"><div class=\"content\"></div></td><td class=\"notes_line new\"></td><td class=\"notes_content parallel new\"><div class=\"content\"></div></td></tr>";
        }
        notesContentSelector += " .content";
        if (hasNotes) {
          nextRow.show();
          notesContent = nextRow.find(notesContentSelector);
          if (notesContent.length) {
            notesContent.show();
            replyButton = notesContent.find(".js-discussion-reply-button:visible");
            if (replyButton.length) {
              e.target = replyButton[0];
              $.proxy(this.replyToDiscussionNote, replyButton[0], e).call();
            } else {
              // In parallel view, the form may not be present in one of the panes
              noteForm = notesContent.find(".js-discussion-note-form");
              if (noteForm.length === 0) {
                addForm = true;
              }
            }
          }
        } else {
          // add a notes row and insert the form
          row.after(rowCssToAdd);
          nextRow = row.next();
          notesContent = nextRow.find(notesContentSelector);
          addForm = true;
        }
        if (addForm) {
          newForm = this.formClone.clone();
          newForm.appendTo(notesContent);
          // show the form
          return this.setupDiscussionNoteForm($link, newForm);
        }
      };

      /*
      Called in response to "cancel" on a diff note form.
       Shows the reply button again.
      Removes the form and if necessary it's temporary row.
       */

      Notes.prototype.removeDiscussionNoteForm = function (form) {
        var glForm, row;
        row = form.closest("tr");
        glForm = form.data('gl-form');
        glForm.destroy();
        form.find(".js-note-text").data("autosave").reset();
        // show the reply button (will only work for replies)
        form.prev('.discussion-reply-holder').show();
        if (row.is(".js-temp-notes-holder")) {
          // remove temporary row for diff lines
          return row.remove();
        } else {
          // only remove the form
          return form.remove();
        }
      };

      Notes.prototype.cancelDiscussionForm = function (e) {
        var form;
        e.preventDefault();
        form = $(e.target).closest(".js-discussion-note-form");
        return this.removeDiscussionNoteForm(form);
      };

      /*
      Called after an attachment file has been selected.
       Updates the file name for the selected attachment.
       */

      Notes.prototype.updateFormAttachment = function () {
        var filename, form;
        form = $(this).closest("form");
        // get only the basename
        filename = $(this).val().replace(/^.*[\\\/]/, "");
        return form.find(".js-attachment-filename").text(filename);
      };

      /*
      Called when the tab visibility changes
       */

      Notes.prototype.visibilityChange = function () {
        return this.refresh();
      };

      Notes.prototype.updateCloseButton = function (e) {
        var closebtn, form, textarea;
        textarea = $(e.target);
        form = textarea.parents('form');
        closebtn = form.find('.js-note-target-close');
        return closebtn.text(closebtn.data('original-text'));
      };

      Notes.prototype.updateTargetButtons = function (e) {
        var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
        textarea = $(e.target);
        form = textarea.parents('form');
        reopenbtn = form.find('.js-note-target-reopen');
        closebtn = form.find('.js-note-target-close');
        discardbtn = form.find('.js-note-discard');
        if (textarea.val().trim().length > 0) {
          reopentext = reopenbtn.data('alternative-text');
          closetext = closebtn.data('alternative-text');
          if (reopenbtn.text() !== reopentext) {
            reopenbtn.text(reopentext);
          }
          if (closebtn.text() !== closetext) {
            closebtn.text(closetext);
          }
          if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
            reopenbtn.addClass('btn-comment-and-reopen');
          }
          if (closebtn.is(':not(.btn-comment-and-close)')) {
            closebtn.addClass('btn-comment-and-close');
          }
          if (discardbtn.is(':hidden')) {
            return discardbtn.show();
          }
        } else {
          reopentext = reopenbtn.data('original-text');
          closetext = closebtn.data('original-text');
          if (reopenbtn.text() !== reopentext) {
            reopenbtn.text(reopentext);
          }
          if (closebtn.text() !== closetext) {
            closebtn.text(closetext);
          }
          if (reopenbtn.is('.btn-comment-and-reopen')) {
            reopenbtn.removeClass('btn-comment-and-reopen');
          }
          if (closebtn.is('.btn-comment-and-close')) {
            closebtn.removeClass('btn-comment-and-close');
          }
          if (discardbtn.is(':visible')) {
            return discardbtn.hide();
          }
        }
      };

      Notes.prototype.initTaskList = function () {
        this.enableTaskList();
        return $(document).on('tasklist:changed', '.note .js-task-list-container', this.updateTaskList.bind(this));
      };

      Notes.prototype.enableTaskList = function () {
        return $('.note .js-task-list-container').taskList('enable');
      };

      Notes.prototype.putEditFormInPlace = function ($el) {
        var $editForm = $(this.getEditFormSelector($el));
        var $note = $el.closest('.note');

        $editForm.insertAfter($note.find('.note-text'));

        var $originalContentEl = $note.find('.original-note-content');
        var originalContent = $originalContentEl.text().trim();
        var postUrl = $originalContentEl.data('post-url');
        var targetId = $originalContentEl.data('target-id');
        var targetType = $originalContentEl.data('target-type');

        new gl.GLForm($editForm.find('form'));

        $editForm.find('form').attr('action', postUrl).attr('data-remote', 'true');
        $editForm.find('.js-form-target-id').val(targetId);
        $editForm.find('.js-form-target-type').val(targetType);
        $editForm.find('.js-note-text').focus().val(originalContent);
        $editForm.find('.js-md-write-button').trigger('click');
        $editForm.find('.referenced-users').hide();
      };

      Notes.prototype.updateTaskList = function (e) {
        var $target = $(e.target);
        var $list = $target.closest('.js-task-list-container');
        var $editForm = $(this.getEditFormSelector($target));
        var $note = $list.closest('.note');

        this.putEditFormInPlace($list);
        $editForm.find('#note_note').val($note.find('.original-task-list').val());
        $('form', $list).submit();
      };

      Notes.prototype.updateNotesCount = function (updateCount) {
        return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
      };

      Notes.prototype.resolveDiscussion = function () {
        var $this = $(this);
        var discussionId = $this.attr('data-discussion-id');

        $this.closest('form').attr('data-discussion-id', discussionId).attr('data-resolve-all', 'true').attr('data-project-path', $this.attr('data-project-path'));
      };

      Notes.prototype.toggleCommitList = function (e) {
        var $element = $(e.target);
        var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

        $closestSystemCommitList.toggleClass('hide-shade');
      };

      /**
      Scans system notes with `ul` elements in system note body
      then collapse long commit list pushed by user to make it less
      intrusive.
       */
      Notes.prototype.collapseLongCommitList = function () {
        var systemNotes = $('#notes-list').find('li.system-note').has('ul');

        $.each(systemNotes, function (index, systemNote) {
          var $systemNote = $(systemNote);
          var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

          $systemNote.find('.note-header .system-note-message').html(headerMessage);

          if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
            $systemNote.find('.note-text').addClass('system-note-commit-list');
            $systemNote.find('.system-note-commit-list-toggler').show();
          } else {
            $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
          }
        });
      };

      return Notes;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 324 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, consistent-return, prefer-arrow-callback, no-else-return, max-len */
  /* global Flash */

  (function () {
    this.NotificationsDropdown = function () {
      function NotificationsDropdown() {
        $(document).off('click', '.update-notification').on('click', '.update-notification', function (e) {
          var form, label, notificationLevel;
          e.preventDefault();
          if ($(this).is('.is-active') && $(this).data('notification-level') === 'custom') {
            return;
          }
          notificationLevel = $(this).data('notification-level');
          label = $(this).data('notification-title');
          form = $(this).parents('.notification-form:first');
          form.find('.js-notification-loading').toggleClass('fa-bell fa-spin fa-spinner');
          form.find('#notification_setting_level').val(notificationLevel);
          return form.submit();
        });
        $(document).off('ajax:success', '.notification-form').on('ajax:success', '.notification-form', function (e, data) {
          if (data.saved) {
            return $(e.currentTarget).closest('.js-notification-dropdown').replaceWith(data.html);
          } else {
            return new Flash('Failed to save new settings', 'alert');
          }
        });
      }

      return NotificationsDropdown;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 325 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, newline-per-chained-call, comma-dangle, consistent-return, prefer-arrow-callback, max-len */
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.NotificationsForm = function () {
      function NotificationsForm() {
        this.toggleCheckbox = bind(this.toggleCheckbox, this);
        this.removeEventListeners();
        this.initEventListeners();
      }

      NotificationsForm.prototype.removeEventListeners = function () {
        return $(document).off('change', '.js-custom-notification-event');
      };

      NotificationsForm.prototype.initEventListeners = function () {
        return $(document).on('change', '.js-custom-notification-event', this.toggleCheckbox);
      };

      NotificationsForm.prototype.toggleCheckbox = function (e) {
        var $checkbox, $parent;
        $checkbox = $(e.currentTarget);
        $parent = $checkbox.closest('.checkbox');
        return this.saveEvent($checkbox, $parent);
      };

      NotificationsForm.prototype.showCheckboxLoadingSpinner = function ($parent) {
        return $parent.addClass('is-loading').find('.custom-notification-event-loading').removeClass('fa-check').addClass('fa-spin fa-spinner').removeClass('is-done');
      };

      NotificationsForm.prototype.saveEvent = function ($checkbox, $parent) {
        var form;
        form = $parent.parents('form:first');
        return $.ajax({
          url: form.attr('action'),
          method: form.attr('method'),
          dataType: 'json',
          data: form.serialize(),
          beforeSend: function (_this) {
            return function () {
              return _this.showCheckboxLoadingSpinner($parent);
            };
          }(this)
        }).done(function (data) {
          $checkbox.enable();
          if (data.saved) {
            $parent.find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
            return setTimeout(function () {
              return $parent.removeClass('is-loading').find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
            }, 2000);
          }
        });
      };

      return NotificationsForm;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 326 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, comma-dangle, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */
  /* global Cookies */
  /* global ProjectSelect */

  (function () {
    this.Project = function () {
      function Project() {
        $('ul.clone-options-dropdown a').click(function () {
          var url;
          if ($(this).hasClass('active')) {
            return;
          }
          $('.active').not($(this)).removeClass('active');
          $(this).toggleClass('active');
          url = $("#project_clone").val();
          $('#project_clone').val(url);
          return $('.clone').text(url);
          // Git protocol switcher
          // Remove the active class for all buttons (ssh, http, kerberos if shown)
          // Add the active class for the clicked button
          // Update the input field
          // Update the command line instructions
        });
        // Ref switcher
        this.initRefSwitcher();
        $('.project-refs-select').on('change', function () {
          return $(this).parents('form').submit();
        });
        $('.hide-no-ssh-message').on('click', function (e) {
          Cookies.set('hide_no_ssh_message', 'false');
          $(this).parents('.no-ssh-key-message').remove();
          return e.preventDefault();
        });
        $('.hide-no-password-message').on('click', function (e) {
          Cookies.set('hide_no_password_message', 'false');
          $(this).parents('.no-password-message').remove();
          return e.preventDefault();
        });
        this.projectSelectDropdown();
      }

      Project.prototype.projectSelectDropdown = function () {
        new ProjectSelect();
        $('.project-item-select').on('click', function (_this) {
          return function (e) {
            return _this.changeProject($(e.currentTarget).val());
          };
        }(this));
        return $('.js-projects-dropdown-toggle').on('click', function (e) {
          e.preventDefault();
          return $('.js-projects-dropdown').select2('open');
        });
      };

      Project.prototype.changeProject = function (url) {
        return window.location = url;
      };

      Project.prototype.initRefSwitcher = function () {
        var refListItem = document.createElement('li');
        var refLink = document.createElement('a');

        refLink.href = '#';

        return $('.js-project-refs-dropdown').each(function () {
          var $dropdown, selected;
          $dropdown = $(this);
          selected = $dropdown.data('selected');
          return $dropdown.glDropdown({
            data: function data(term, callback) {
              return $.ajax({
                url: $dropdown.data('refs-url'),
                data: {
                  ref: $dropdown.data('ref'),
                  search: term
                },
                dataType: "json"
              }).done(function (refs) {
                return callback(refs);
              });
            },
            selectable: true,
            filterable: true,
            filterRemote: true,
            filterByText: true,
            fieldName: $dropdown.data('field-name'),
            renderRow: function renderRow(ref) {
              var li = refListItem.cloneNode(false);

              if (ref.header != null) {
                li.className = 'dropdown-header';
                li.textContent = ref.header;
              } else {
                var link = refLink.cloneNode(false);

                if (ref === selected) {
                  link.className = 'is-active';
                }

                link.textContent = ref;
                link.dataset.ref = ref;

                li.appendChild(link);
              }

              return li;
            },
            id: function id(obj, $el) {
              return $el.attr('data-ref');
            },
            toggleLabel: function toggleLabel(obj, $el) {
              return $el.text().trim();
            },
            clicked: function clicked(selected, $el, e) {
              e.preventDefault();
              if ($('input[name="ref"]').length) {
                var $form = $dropdown.closest('form');
                var action = $form.attr('action');
                var divider = action.indexOf('?') < 0 ? '?' : '&';
                gl.utils.visitUrl(action + '' + divider + '' + $form.serialize());
              }
            }
          });
        });
      };

      return Project;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 327 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */
  (function () {
    this.ProjectAvatar = function () {
      function ProjectAvatar() {
        $('.js-choose-project-avatar-button').bind('click', function () {
          var form;
          form = $(this).closest('form');
          return form.find('.js-project-avatar-input').click();
        });
        $('.js-project-avatar-input').bind('change', function () {
          var filename, form;
          form = $(this).closest('form');
          filename = $(this).val().replace(/^.*[\\\/]/, '');
          return form.find('.js-avatar-filename').text(filename);
        });
      }

      return ProjectAvatar;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 328 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, consistent-return, one-var, one-var-declaration-per-line, no-cond-assign, max-len, object-shorthand, no-param-reassign, comma-dangle, prefer-template, no-unused-vars, no-return-assign */
  /* global fuzzaldrinPlus */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.ProjectFindFile = function () {
      var highlighter;

      function ProjectFindFile(element1, options) {
        this.element = element1;
        this.options = options;
        this.goToBlob = bind(this.goToBlob, this);
        this.goToTree = bind(this.goToTree, this);
        this.selectRowDown = bind(this.selectRowDown, this);
        this.selectRowUp = bind(this.selectRowUp, this);
        this.filePaths = {};
        this.inputElement = this.element.find(".file-finder-input");
        // init event
        this.initEvent();
        // focus text input box
        this.inputElement.focus();
        // load file list
        this.load(this.options.url);
      }

      ProjectFindFile.prototype.initEvent = function () {
        this.inputElement.off("keyup");
        this.inputElement.on("keyup", function (_this) {
          return function (event) {
            var oldValue, ref, target, value;
            target = $(event.target);
            value = target.val();
            oldValue = (ref = target.data("oldValue")) != null ? ref : "";
            if (value !== oldValue) {
              target.data("oldValue", value);
              _this.findFile();
              return _this.element.find("tr.tree-item").eq(0).addClass("selected").focus();
            }
          };
        }(this));
      };

      ProjectFindFile.prototype.findFile = function () {
        var result, searchText;
        searchText = this.inputElement.val();
        result = searchText.length > 0 ? fuzzaldrinPlus.filter(this.filePaths, searchText) : this.filePaths;
        return this.renderList(result, searchText);
        // find file
      };

      // files pathes load
      ProjectFindFile.prototype.load = function (url) {
        return $.ajax({
          url: url,
          method: "get",
          dataType: "json",
          success: function (_this) {
            return function (data) {
              _this.element.find(".loading").hide();
              _this.filePaths = data;
              _this.findFile();
              return _this.element.find(".files-slider tr.tree-item").eq(0).addClass("selected").focus();
            };
          }(this)
        });
      };

      // render result
      ProjectFindFile.prototype.renderList = function (filePaths, searchText) {
        var blobItemUrl, filePath, html, i, j, len, matches, results;
        this.element.find(".tree-table > tbody").empty();
        results = [];
        for (i = j = 0, len = filePaths.length; j < len; i = j += 1) {
          filePath = filePaths[i];
          if (i === 20) {
            break;
          }
          if (searchText) {
            matches = fuzzaldrinPlus.match(filePath, searchText);
          }
          blobItemUrl = this.options.blobUrlTemplate + "/" + filePath;
          html = this.makeHtml(filePath, matches, blobItemUrl);
          results.push(this.element.find(".tree-table > tbody").append(html));
        }
        return results;
      };

      // highlight text(awefwbwgtc -> <b>a</b>wefw<b>b</b>wgt<b>c</b> )
      highlighter = function highlighter(element, text, matches) {
        var highlightText, j, lastIndex, len, matchIndex, matchedChars, unmatched;
        lastIndex = 0;
        highlightText = "";
        matchedChars = [];
        for (j = 0, len = matches.length; j < len; j += 1) {
          matchIndex = matches[j];
          unmatched = text.substring(lastIndex, matchIndex);
          if (unmatched) {
            if (matchedChars.length) {
              element.append(matchedChars.join("").bold());
            }
            matchedChars = [];
            element.append(document.createTextNode(unmatched));
          }
          matchedChars.push(text[matchIndex]);
          lastIndex = matchIndex + 1;
        }
        if (matchedChars.length) {
          element.append(matchedChars.join("").bold());
        }
        return element.append(document.createTextNode(text.substring(lastIndex)));
      };

      // make tbody row html
      ProjectFindFile.prototype.makeHtml = function (filePath, matches, blobItemUrl) {
        var $tr;
        $tr = $("<tr class='tree-item'><td class='tree-item-file-name link-container'><a><i class='fa fa-file-text-o fa-fw'></i><span class='str-truncated'></span></a></td></tr>");
        if (matches) {
          $tr.find("a").replaceWith(highlighter($tr.find("a"), filePath, matches).attr("href", blobItemUrl));
        } else {
          $tr.find("a").attr("href", blobItemUrl);
          $tr.find(".str-truncated").text(filePath);
        }
        return $tr;
      };

      ProjectFindFile.prototype.selectRow = function (type) {
        var next, rows, selectedRow;
        rows = this.element.find(".files-slider tr.tree-item");
        selectedRow = this.element.find(".files-slider tr.tree-item.selected");
        if (rows && rows.length > 0) {
          if (selectedRow && selectedRow.length > 0) {
            if (type === "UP") {
              next = selectedRow.prev();
            } else if (type === "DOWN") {
              next = selectedRow.next();
            }
            if (next.length > 0) {
              selectedRow.removeClass("selected");
              selectedRow = next;
            }
          } else {
            selectedRow = rows.eq(0);
          }
          return selectedRow.addClass("selected").focus();
        }
      };

      ProjectFindFile.prototype.selectRowUp = function () {
        return this.selectRow("UP");
      };

      ProjectFindFile.prototype.selectRowDown = function () {
        return this.selectRow("DOWN");
      };

      ProjectFindFile.prototype.goToTree = function () {
        return location.href = this.options.treeUrl;
      };

      ProjectFindFile.prototype.goToBlob = function () {
        var $link = this.element.find(".tree-item.selected .tree-item-file-name a");

        if ($link.length) {
          $link.get(0).click();
        }
      };

      return ProjectFindFile;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 329 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len */
  (function () {
    this.ProjectFork = function () {
      function ProjectFork() {
        $('.fork-thumbnail a').on('click', function () {
          $('.fork-namespaces').hide();
          return $('.save-project-loader').show();
        });
      }

      return ProjectFork;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 330 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len */

  (function () {
    this.ProjectImport = function () {
      function ProjectImport() {
        setTimeout(function () {
          return gl.utils.visitUrl(location.href);
        }, 5000);
      }

      return ProjectImport;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 331 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, one-var, no-underscore-dangle, prefer-template, no-else-return, prefer-arrow-callback, max-len */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.ProjectNew = function () {
      function ProjectNew() {
        this.toggleSettings = bind(this.toggleSettings, this);
        this.$selects = $('.features select');
        this.$repoSelects = this.$selects.filter('.js-repo-select');

        $('.project-edit-container').on('ajax:before', function (_this) {
          return function () {
            $('.project-edit-container').hide();
            return $('.save-project-loader').show();
          };
        }(this));

        this.initVisibilitySelect();

        this.toggleSettings();
        this.toggleSettingsOnclick();
        this.toggleRepoVisibility();
      }

      ProjectNew.prototype.initVisibilitySelect = function () {
        var visibilityContainer = document.querySelector('.js-visibility-select');
        if (!visibilityContainer) return;
        var visibilitySelect = new gl.VisibilitySelect(visibilityContainer);
        visibilitySelect.init();
      };

      ProjectNew.prototype.toggleSettings = function () {
        var self = this;

        this.$selects.each(function () {
          var $select = $(this);
          var className = $select.data('field').replace(/_/g, '-').replace('access-level', 'feature');
          self._showOrHide($select, '.' + className);
        });
      };

      ProjectNew.prototype.toggleSettingsOnclick = function () {
        this.$selects.on('change', this.toggleSettings);
      };

      ProjectNew.prototype._showOrHide = function (checkElement, container) {
        var $container = $(container);

        if ($(checkElement).val() !== '0') {
          return $container.show();
        } else {
          return $container.hide();
        }
      };

      ProjectNew.prototype.toggleRepoVisibility = function () {
        var $repoAccessLevel = $('.js-repo-access-level select');
        var containerRegistry = document.querySelectorAll('.js-container-registry')[0];
        var containerRegistryCheckbox = document.getElementById('project_container_registry_enabled');

        this.$repoSelects.find("option[value='" + $repoAccessLevel.val() + "']").nextAll().hide();

        $repoAccessLevel.off('change').on('change', function () {
          var selectedVal = parseInt($repoAccessLevel.val(), 10);

          this.$repoSelects.each(function () {
            var $this = $(this);
            var repoSelectVal = parseInt($this.val(), 10);

            $this.find('option').show();

            if (selectedVal < repoSelectVal) {
              $this.val(selectedVal);
            }

            $this.find("option[value='" + selectedVal + "']").nextAll().hide();
          });

          if (selectedVal) {
            this.$repoSelects.removeClass('disabled');

            if (containerRegistry) {
              containerRegistry.style.display = '';
            }
          } else {
            this.$repoSelects.addClass('disabled');

            if (containerRegistry) {
              containerRegistry.style.display = 'none';
              containerRegistryCheckbox.checked = false;
            }
          }
        }.bind(this));
      };

      return ProjectNew;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 332 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */
  /* global Api */

  (function () {
    this.ProjectSelect = function () {
      function ProjectSelect() {
        $('.js-projects-dropdown-toggle').each(function (i, dropdown) {
          var $dropdown;
          $dropdown = $(dropdown);
          return $dropdown.glDropdown({
            filterable: true,
            filterRemote: true,
            search: {
              fields: ['name_with_namespace']
            },
            data: function data(term, callback) {
              var finalCallback, projectsCallback;
              var orderBy = $dropdown.data('order-by');
              finalCallback = function finalCallback(projects) {
                return callback(projects);
              };
              if (this.includeGroups) {
                projectsCallback = function projectsCallback(projects) {
                  var groupsCallback;
                  groupsCallback = function groupsCallback(groups) {
                    var data;
                    data = groups.concat(projects);
                    return finalCallback(data);
                  };
                  return Api.groups(term, {}, groupsCallback);
                };
              } else {
                projectsCallback = finalCallback;
              }
              if (this.groupId) {
                return Api.groupProjects(this.groupId, term, projectsCallback);
              } else {
                return Api.projects(term, orderBy, projectsCallback);
              }
            },
            url: function url(project) {
              return project.web_url;
            },
            text: function text(project) {
              return project.name_with_namespace;
            }
          });
        });
        $('.ajax-project-select').each(function (i, select) {
          var placeholder;
          this.groupId = $(select).data('group-id');
          this.includeGroups = $(select).data('include-groups');
          this.orderBy = $(select).data('order-by') || 'id';
          placeholder = "Search for project";
          if (this.includeGroups) {
            placeholder += " or group";
          }
          return $(select).select2({
            placeholder: placeholder,
            minimumInputLength: 0,
            query: function (_this) {
              return function (query) {
                var finalCallback, projectsCallback;
                finalCallback = function finalCallback(projects) {
                  var data;
                  data = {
                    results: projects
                  };
                  return query.callback(data);
                };
                if (_this.includeGroups) {
                  projectsCallback = function projectsCallback(projects) {
                    var groupsCallback;
                    groupsCallback = function groupsCallback(groups) {
                      var data;
                      data = groups.concat(projects);
                      return finalCallback(data);
                    };
                    return Api.groups(query.term, {}, groupsCallback);
                  };
                } else {
                  projectsCallback = finalCallback;
                }
                if (_this.groupId) {
                  return Api.groupProjects(_this.groupId, query.term, projectsCallback);
                } else {
                  return Api.projects(query.term, _this.orderBy, projectsCallback);
                }
              };
            }(this),
            id: function id(project) {
              return project.web_url;
            },
            text: function text(project) {
              return project.name_with_namespace || project.name;
            },
            dropdownCssClass: "ajax-project-dropdown"
          });
        });
      }

      return ProjectSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 333 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife */

  (function () {
    this.ProjectShow = function () {
      function ProjectShow() {}

      return ProjectShow;
    }();
  }).call(this);

  // I kept class for future
}).call(window);

/***/ }),
/* 334 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, object-shorthand, quotes, no-var, one-var, one-var-declaration-per-line, prefer-arrow-callback, consistent-return, no-unused-vars, camelcase, prefer-template, comma-dangle, max-len */

  (function () {
    window.ProjectsList = {
      init: function init() {
        $(".projects-list-filter").off('keyup');
        this.initSearch();
        return this.initPagination();
      },
      initSearch: function initSearch() {
        var debounceFilter, projectsListFilter;
        projectsListFilter = $('.projects-list-filter');
        debounceFilter = _.debounce(window.ProjectsList.filterResults, 500);
        return projectsListFilter.on('keyup', function (e) {
          if (projectsListFilter.val() !== '') {
            return debounceFilter();
          }
        });
      },
      filterResults: function filterResults() {
        var form, project_filter_url, search;
        $('.projects-list-holder').fadeTo(250, 0.5);
        form = null;
        form = $("form#project-filter-form");
        search = $(".projects-list-filter").val();
        project_filter_url = form.attr('action') + '?' + form.serialize();
        return $.ajax({
          type: "GET",
          url: form.attr('action'),
          data: form.serialize(),
          complete: function complete() {
            return $('.projects-list-holder').fadeTo(250, 1);
          },
          success: function success(data) {
            $('.projects-list-holder').replaceWith(data.html);
            return history.replaceState({
              page: project_filter_url
              // Change url so if user reload a page - search results are saved
            }, document.title, project_filter_url);
          },
          dataType: "json"
        });
      },
      initPagination: function initPagination() {
        return $('.projects-list-holder .pagination').on('ajax:success', function (e, data) {
          return $('.projects-list-holder').replaceWith(data.html);
        });
      }
    };
  }).call(this);
}).call(window);

/***/ }),
/* 335 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-undef, no-else-return, prefer-arrow-callback, max-len */
  // Render Gitlab flavoured Markdown
  //
  // Delegates to syntax highlight and render math
  //
  (function () {
    $.fn.renderGFM = function () {
      this.find('.js-syntax-highlight').syntaxHighlight();
      this.find('.js-render-math').renderMath();
    };

    $(document).on('ready load', function () {
      return $('body').renderGFM();
    });
  }).call(this);
}).call(window);

/***/ }),
/* 336 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-undef, no-else-return, prefer-arrow-callback, max-len, no-console */
  // Renders math using KaTeX in any element with the
  // `js-render-math` class
  //
  // ### Example Markup
  //
  //   <code class="js-render-math"></div>
  //
  (function () {
    // Only load once
    var katexLoaded = false;

    // Loop over all math elements and render math
    var renderWithKaTeX = function renderWithKaTeX(elements) {
      elements.each(function () {
        var mathNode = $('<span></span>');
        var $this = $(this);

        var display = $this.attr('data-math-style') === 'display';
        try {
          katex.render($this.text(), mathNode.get(0), { displayMode: display });
          mathNode.insertAfter($this);
          $this.remove();
        } catch (err) {
          // What can we do??
          console.log(err.message);
        }
      });
    };

    $.fn.renderMath = function () {
      var $this = this;
      if ($this.length === 0) return;

      if (katexLoaded) renderWithKaTeX($this);else {
        // Request CSS file so it is in the cache
        $.get(gon.katex_css_url, function () {
          var css = $('<link>', { rel: 'stylesheet',
            type: 'text/css',
            href: gon.katex_css_url
          });
          css.appendTo('head');

          // Load KaTeX js
          $.getScript(gon.katex_js_url, function () {
            katexLoaded = true;
            renderWithKaTeX($this); // Run KaTeX
          });
        });
      }
    };
  }).call(this);
}).call(window);

/***/ }),
/* 337 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */
  /* global Cookies */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.Sidebar = function () {
      function Sidebar(currentUser) {
        this.toggleTodo = bind(this.toggleTodo, this);
        this.sidebar = $('aside');
        this.removeListeners();
        this.addEventListeners();
      }

      Sidebar.prototype.removeListeners = function () {
        this.sidebar.off('click', '.sidebar-collapsed-icon');
        $('.dropdown').off('hidden.gl.dropdown');
        $('.dropdown').off('loading.gl.dropdown');
        $('.dropdown').off('loaded.gl.dropdown');
        $(document).off('click', '.js-sidebar-toggle');
      };

      Sidebar.prototype.addEventListeners = function () {
        this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
        $('.dropdown').on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
        $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
        $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);
        $(document).on('click', '.js-sidebar-toggle', function (e, triggered) {
          var $allGutterToggleIcons, $this, $thisIcon;
          e.preventDefault();
          $this = $(this);
          $thisIcon = $this.find('i');
          $allGutterToggleIcons = $('.js-sidebar-toggle i');
          if ($thisIcon.hasClass('fa-angle-double-right')) {
            $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
            $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
            $('.page-with-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
          } else {
            $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
            $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
            $('.page-with-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
          }
          if (!triggered) {
            return Cookies.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
          }
        });
        return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
      };

      Sidebar.prototype.toggleTodo = function (e) {
        var $btnText, $this, $todoLoading, ajaxType, url;
        $this = $(e.currentTarget);
        $todoLoading = $('.js-issuable-todo-loading');
        $btnText = $('.js-issuable-todo-text', $this);
        ajaxType = $this.attr('data-delete-path') ? 'DELETE' : 'POST';
        if ($this.attr('data-delete-path')) {
          url = "" + $this.attr('data-delete-path');
        } else {
          url = "" + $this.data('url');
        }
        return $.ajax({
          url: url,
          type: ajaxType,
          dataType: 'json',
          data: {
            issuable_id: $this.data('issuable-id'),
            issuable_type: $this.data('issuable-type')
          },
          beforeSend: function (_this) {
            return function () {
              return _this.beforeTodoSend($this, $todoLoading);
            };
          }(this)
        }).done(function (_this) {
          return function (data) {
            return _this.todoUpdateDone(data, $this, $btnText, $todoLoading);
          };
        }(this));
      };

      Sidebar.prototype.beforeTodoSend = function ($btn, $todoLoading) {
        $btn.disable();
        return $todoLoading.removeClass('hidden');
      };

      Sidebar.prototype.todoUpdateDone = function (data, $btn, $btnText, $todoLoading) {
        $(document).trigger('todo:toggle', data.count);

        $btn.enable();
        $todoLoading.addClass('hidden');

        if (data.delete_path != null) {
          $btn.attr('aria-label', $btn.data('mark-text')).attr('data-delete-path', data.delete_path);
          return $btnText.text($btn.data('mark-text'));
        } else {
          $btn.attr('aria-label', $btn.data('todo-text')).removeAttr('data-delete-path');
          return $btnText.text($btn.data('todo-text'));
        }
      };

      Sidebar.prototype.sidebarDropdownLoading = function (e) {
        var $loading, $sidebarCollapsedIcon, i, img;
        $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
        img = $sidebarCollapsedIcon.find('img');
        i = $sidebarCollapsedIcon.find('i');
        $loading = $('<i class="fa fa-spinner fa-spin"></i>');
        if (img.length) {
          img.before($loading);
          return img.hide();
        } else if (i.length) {
          i.before($loading);
          return i.hide();
        }
      };

      Sidebar.prototype.sidebarDropdownLoaded = function (e) {
        var $sidebarCollapsedIcon, i, img;
        $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
        img = $sidebarCollapsedIcon.find('img');
        $sidebarCollapsedIcon.find('i.fa-spin').remove();
        i = $sidebarCollapsedIcon.find('i');
        if (img.length) {
          return img.show();
        } else {
          return i.show();
        }
      };

      Sidebar.prototype.sidebarCollapseClicked = function (e) {
        var $block, sidebar;
        if ($(e.currentTarget).hasClass('dont-change-state')) {
          return;
        }
        sidebar = e.data;
        e.preventDefault();
        $block = $(this).closest('.block');
        return sidebar.openDropdown($block);
      };

      Sidebar.prototype.openDropdown = function (blockOrName) {
        var $block;
        $block = _.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
        $block.find('.edit-link').trigger('click');
        if (!this.isOpen()) {
          this.setCollapseAfterUpdate($block);
          return this.toggleSidebar('open');
        }
      };

      Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
        $block.addClass('collapse-after-update');
        return $('.page-with-sidebar').addClass('with-overlay');
      };

      Sidebar.prototype.onSidebarDropdownHidden = function (e) {
        var $block, sidebar;
        sidebar = e.data;
        e.preventDefault();
        $block = $(this).closest('.block');
        return sidebar.sidebarDropdownHidden($block);
      };

      Sidebar.prototype.sidebarDropdownHidden = function ($block) {
        if ($block.hasClass('collapse-after-update')) {
          $block.removeClass('collapse-after-update');
          $('.page-with-sidebar').removeClass('with-overlay');
          return this.toggleSidebar('hide');
        }
      };

      Sidebar.prototype.triggerOpenSidebar = function () {
        return this.sidebar.find('.js-sidebar-toggle').trigger('click');
      };

      Sidebar.prototype.toggleSidebar = function (action) {
        if (action == null) {
          action = 'toggle';
        }
        if (action === 'toggle') {
          this.triggerOpenSidebar();
        }
        if (action === 'open') {
          if (!this.isOpen()) {
            this.triggerOpenSidebar();
          }
        }
        if (action === 'hide') {
          if (this.isOpen()) {
            return this.triggerOpenSidebar();
          }
        }
      };

      Sidebar.prototype.isOpen = function () {
        return this.sidebar.is('.right-sidebar-expanded');
      };

      Sidebar.prototype.getBlock = function (name) {
        return this.sidebar.find(".block." + name);
      };

      return Sidebar;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, object-shorthand, prefer-arrow-callback, comma-dangle, prefer-template, quotes, no-else-return, max-len */
  /* global Api */

  (function () {
    this.Search = function () {
      function Search() {
        var $groupDropdown, $projectDropdown;
        $groupDropdown = $('.js-search-group-dropdown');
        $projectDropdown = $('.js-search-project-dropdown');
        this.eventListeners();
        $groupDropdown.glDropdown({
          selectable: true,
          filterable: true,
          fieldName: 'group_id',
          search: {
            fields: ['full_name']
          },
          data: function data(term, callback) {
            return Api.groups(term, {}, function (data) {
              data.unshift({
                full_name: 'Any'
              });
              data.splice(1, 0, 'divider');
              return callback(data);
            });
          },
          id: function id(obj) {
            return obj.id;
          },
          text: function text(obj) {
            return obj.full_name;
          },
          toggleLabel: function toggleLabel(obj) {
            return $groupDropdown.data('default-label') + " " + obj.full_name;
          },
          clicked: function (_this) {
            return function () {
              return _this.submitSearch();
            };
          }(this)
        });
        $projectDropdown.glDropdown({
          selectable: true,
          filterable: true,
          fieldName: 'project_id',
          search: {
            fields: ['name']
          },
          data: function data(term, callback) {
            return Api.projects(term, 'id', function (data) {
              data.unshift({
                name_with_namespace: 'Any'
              });
              data.splice(1, 0, 'divider');
              return callback(data);
            });
          },
          id: function id(obj) {
            return obj.id;
          },
          text: function text(obj) {
            return obj.name_with_namespace;
          },
          toggleLabel: function toggleLabel(obj) {
            return $projectDropdown.data('default-label') + " " + obj.name_with_namespace;
          },
          clicked: function (_this) {
            return function () {
              return _this.submitSearch();
            };
          }(this)
        });
      }

      Search.prototype.eventListeners = function () {
        $(document).off('keyup', '.js-search-input').on('keyup', '.js-search-input', this.searchKeyUp);
        return $(document).off('click', '.js-search-clear').on('click', '.js-search-clear', this.clearSearchField);
      };

      Search.prototype.submitSearch = function () {
        return $('.js-search-form').submit();
      };

      Search.prototype.searchKeyUp = function () {
        var $input;
        $input = $(this);
        if ($input.val() === '') {
          return $('.js-search-clear').addClass('hidden');
        } else {
          return $('.js-search-clear').removeClass('hidden');
        }
      };

      Search.prototype.clearSearchField = function () {
        return $('.js-search-input').val('').trigger('keyup').focus();
      };

      return Search;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife */
  /* global Mousetrap */
  /* global ShortcutsNavigation */

  __webpack_require__(9);

  (function () {
    var extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }function ctor() {
        this.constructor = child;
      }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
    },
        hasProp = {}.hasOwnProperty;

    this.ShortcutsFindFile = function (superClass) {
      extend(ShortcutsFindFile, superClass);

      function ShortcutsFindFile(projectFindFile) {
        var _oldStopCallback;
        this.projectFindFile = projectFindFile;
        ShortcutsFindFile.__super__.constructor.call(this);
        _oldStopCallback = Mousetrap.stopCallback;
        Mousetrap.stopCallback = function (_this) {
          // override to fire shortcuts action when focus in textbox
          return function (event, element, combo) {
            if (element === _this.projectFindFile.inputElement[0] && (combo === 'up' || combo === 'down' || combo === 'esc' || combo === 'enter')) {
              // when press up/down key in textbox, cusor prevent to move to home/end
              event.preventDefault();
              return false;
            }
            return _oldStopCallback(event, element, combo);
          };
        }(this);
        Mousetrap.bind('up', this.projectFindFile.selectRowUp);
        Mousetrap.bind('down', this.projectFindFile.selectRowDown);
        Mousetrap.bind('esc', this.projectFindFile.goToTree);
        Mousetrap.bind('enter', this.projectFindFile.goToBlob);
      }

      return ShortcutsFindFile;
    }(ShortcutsNavigation);
  }).call(this);
}).call(window);

/***/ }),
/* 340 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    window.SingleFileDiff = function () {
      var COLLAPSED_HTML, ERROR_HTML, LOADING_HTML, WRAPPER;

      WRAPPER = '<div class="diff-content diff-wrap-lines"></div>';

      LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';

      ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';

      COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

      function SingleFileDiff(file) {
        this.file = file;
        this.toggleDiff = bind(this.toggleDiff, this);
        this.content = $('.diff-content', this.file);
        this.$toggleIcon = $('.diff-toggle-caret', this.file);
        this.diffForPath = this.content.find('[data-diff-for-path]').data('diff-for-path');
        this.isOpen = !this.diffForPath;
        if (this.diffForPath) {
          this.collapsedContent = this.content;
          this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
          this.content = null;
          this.collapsedContent.after(this.loadingContent);
          this.$toggleIcon.addClass('fa-caret-right');
        } else {
          this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
          this.content.after(this.collapsedContent);
          this.$toggleIcon.addClass('fa-caret-down');
        }

        $('.file-title, .click-to-expand', this.file).on('click', function (e) {
          this.toggleDiff($(e.target));
        }.bind(this));
      }

      SingleFileDiff.prototype.toggleDiff = function ($target, cb) {
        if (!$target.hasClass('file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
        this.isOpen = !this.isOpen;
        if (!this.isOpen && !this.hasError) {
          this.content.hide();
          this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
          this.collapsedContent.show();
          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            gl.diffNotesCompileComponents();
          }
        } else if (this.content) {
          this.collapsedContent.hide();
          this.content.show();
          this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            gl.diffNotesCompileComponents();
          }
        } else {
          this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
          return this.getContentHTML(cb);
        }
      };

      SingleFileDiff.prototype.getContentHTML = function (cb) {
        this.collapsedContent.hide();
        this.loadingContent.show();
        $.get(this.diffForPath, function (_this) {
          return function (data) {
            _this.loadingContent.hide();
            if (data.html) {
              _this.content = $(data.html);
              _this.content.syntaxHighlight();
            } else {
              _this.hasError = true;
              _this.content = $(ERROR_HTML);
            }
            _this.collapsedContent.after(_this.content);

            if (typeof gl.diffNotesCompileComponents !== 'undefined') {
              gl.diffNotesCompileComponents();
            }

            if (cb) cb();
          };
        }(this));
      };

      return SingleFileDiff;
    }();

    $.fn.singleFileDiff = function () {
      return this.each(function () {
        if (!$.data(this, 'singleFileDiff')) {
          return $.data(this, 'singleFileDiff', new window.SingleFileDiff(this));
        }
      });
    };
  }).call(this);
}).call(window);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-unused-vars, one-var, no-var, one-var-declaration-per-line, prefer-arrow-callback, no-new, max-len */
  /* global Flash */

  (function () {
    this.Star = function () {
      function Star() {
        $('.project-home-panel .toggle-star').on('ajax:success', function (e, data, status, xhr) {
          var $starIcon, $starSpan, $this, toggleStar;
          $this = $(this);
          $starSpan = $this.find('span');
          $starIcon = $this.find('i');
          toggleStar = function toggleStar(isStarred) {
            $this.parent().find('.star-count').text(data.star_count);
            if (isStarred) {
              $starSpan.removeClass('starred').text('Star');
              $starIcon.removeClass('fa-star').addClass('fa-star-o');
            } else {
              $starSpan.addClass('starred').text('Unstar');
              $starIcon.removeClass('fa-star-o').addClass('fa-star');
            }
          };
          toggleStar($starSpan.hasClass('starred'));
        }).on('ajax:error', function (e, xhr, status, error) {
          new Flash('Star toggle failed. Try again later.', 'alert');
        });
      }

      return Star;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 342 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */
  (function () {
    this.SubscriptionSelect = function () {
      function SubscriptionSelect() {
        $('.js-subscription-event').each(function (i, el) {
          var fieldName;
          fieldName = $(el).data("field-name");
          return $(el).glDropdown({
            selectable: true,
            fieldName: fieldName,
            toggleLabel: function (_this) {
              return function (selected, el, instance) {
                var $item, label;
                label = 'Subscription';
                $item = instance.dropdown.find('.is-active');
                if ($item.length) {
                  label = $item.text();
                }
                return label;
              };
            }(this),
            clicked: function clicked(item, $el, e) {
              return e.preventDefault();
            },
            id: function id(obj, el) {
              return $(el).data("id");
            }
          });
        });
      }

      return SubscriptionSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 343 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */

  // Syntax Highlighter
  //
  // Applies a syntax highlighting color scheme CSS class to any element with the
  // `js-syntax-highlight` class
  //
  // ### Example Markup
  //
  //   <div class="js-syntax-highlight"></div>
  //
  (function () {
    $.fn.syntaxHighlight = function () {
      var $children;

      if ($(this).hasClass('js-syntax-highlight')) {
        // Given the element itself, apply highlighting
        return $(this).addClass(gon.user_color_scheme);
      } else {
        // Given a parent element, recurse to any of its applicable children
        $children = $(this).find('.js-syntax-highlight');
        if ($children.length) {
          return $children.syntaxHighlight();
        }
      }
    };
  }).call(this);
}).call(window);

/***/ }),
/* 344 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, quotes, consistent-return, no-var, one-var, one-var-declaration-per-line, no-else-return, prefer-arrow-callback, max-len */

  (function () {
    this.TreeView = function () {
      function TreeView() {
        this.initKeyNav();
        // Code browser tree slider
        // Make the entire tree-item row clickable, but not if clicking another link (like a commit message)
        $(".tree-content-holder .tree-item").on('click', function (e) {
          var $clickedEl, path;
          $clickedEl = $(e.target);
          path = $('.tree-item-file-name a', this).attr('href');
          if (!$clickedEl.is('a') && !$clickedEl.is('.str-truncated')) {
            if (e.metaKey || e.which === 2) {
              e.preventDefault();
              return window.open(path, '_blank');
            } else {
              return gl.utils.visitUrl(path);
            }
          }
        });
        // Show the "Loading commit data" for only the first element
        $('span.log_loading:first').removeClass('hide');
      }

      TreeView.prototype.initKeyNav = function () {
        var li, liSelected;
        li = $("tr.tree-item");
        liSelected = null;
        return $('body').keydown(function (e) {
          var next, path;
          if ($("input:focus").length > 0 && (e.which === 38 || e.which === 40)) {
            return false;
          }
          if (e.which === 40) {
            if (liSelected) {
              next = liSelected.next();
              if (next.length > 0) {
                liSelected.removeClass("selected");
                liSelected = next.addClass("selected");
              }
            } else {
              liSelected = li.eq(0).addClass("selected");
            }
            return $(liSelected).focus();
          } else if (e.which === 38) {
            if (liSelected) {
              next = liSelected.prev();
              if (next.length > 0) {
                liSelected.removeClass("selected");
                liSelected = next.addClass("selected");
              }
            } else {
              liSelected = li.last().addClass("selected");
            }
            return $(liSelected).focus();
          } else if (e.which === 13) {
            path = $('.tree-item.selected .tree-item-file-name a').attr('href');
            if (path) {
              return gl.utils.visitUrl(path);
            }
          }
        });
      };

      return TreeView;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 345 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-console, quotes, prefer-template, max-len */
  /* global u2f */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.U2FError = function () {
      function U2FError(errorCode, u2fFlowType) {
        this.errorCode = errorCode;
        this.message = bind(this.message, this);
        this.httpsDisabled = window.location.protocol !== 'https:';
        this.u2fFlowType = u2fFlowType;
      }

      U2FError.prototype.message = function () {
        if (this.errorCode === u2f.ErrorCodes.BAD_REQUEST && this.httpsDisabled) {
          return 'U2F only works with HTTPS-enabled websites. Contact your administrator for more details.';
        } else if (this.errorCode === u2f.ErrorCodes.DEVICE_INELIGIBLE) {
          if (this.u2fFlowType === 'authenticate') return 'This device has not been registered with us.';
          if (this.u2fFlowType === 'register') return 'This device has already been registered with us.';
        }
        return "There was a problem communicating with your device.";
      };

      return U2FError;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
  /* global u2f */
  /* global U2FError */
  /* global U2FUtil */

  // Register U2F (universal 2nd factor) devices for users to authenticate with.
  //
  // State Flow #1: setup -> in_progress -> registered -> POST to server
  // State Flow #2: setup -> in_progress -> error -> setup
  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

    this.U2FRegister = function () {
      function U2FRegister(container, u2fParams) {
        this.container = container;
        this.renderNotSupported = bind(this.renderNotSupported, this);
        this.renderRegistered = bind(this.renderRegistered, this);
        this.renderError = bind(this.renderError, this);
        this.renderInProgress = bind(this.renderInProgress, this);
        this.renderSetup = bind(this.renderSetup, this);
        this.renderTemplate = bind(this.renderTemplate, this);
        this.register = bind(this.register, this);
        this.start = bind(this.start, this);
        this.appId = u2fParams.app_id;
        this.registerRequests = u2fParams.register_requests;
        this.signRequests = u2fParams.sign_requests;
      }

      U2FRegister.prototype.start = function () {
        if (U2FUtil.isU2FSupported()) {
          return this.renderSetup();
        } else {
          return this.renderNotSupported();
        }
      };

      U2FRegister.prototype.register = function () {
        return u2f.register(this.appId, this.registerRequests, this.signRequests, function (_this) {
          return function (response) {
            var error;
            if (response.errorCode) {
              error = new U2FError(response.errorCode, 'register');
              return _this.renderError(error);
            } else {
              return _this.renderRegistered(JSON.stringify(response));
            }
          };
        }(this), 10);
      };

      // Rendering #
      U2FRegister.prototype.templates = {
        "notSupported": "#js-register-u2f-not-supported",
        "setup": '#js-register-u2f-setup',
        "inProgress": '#js-register-u2f-in-progress',
        "error": '#js-register-u2f-error',
        "registered": '#js-register-u2f-registered'
      };

      U2FRegister.prototype.renderTemplate = function (name, params) {
        var template, templateString;
        templateString = $(this.templates[name]).html();
        template = _.template(templateString);
        return this.container.html(template(params));
      };

      U2FRegister.prototype.renderSetup = function () {
        this.renderTemplate('setup');
        return this.container.find('#js-setup-u2f-device').on('click', this.renderInProgress);
      };

      U2FRegister.prototype.renderInProgress = function () {
        this.renderTemplate('inProgress');
        return this.register();
      };

      U2FRegister.prototype.renderError = function (error) {
        this.renderTemplate('error', {
          error_message: error.message(),
          error_code: error.errorCode
        });
        return this.container.find('#js-u2f-try-again').on('click', this.renderSetup);
      };

      U2FRegister.prototype.renderRegistered = function (deviceResponse) {
        this.renderTemplate('registered');
        // Prefer to do this instead of interpolating using Underscore templates
        // because of JSON escaping issues.
        return this.container.find("#js-device-response").val(deviceResponse);
      };

      U2FRegister.prototype.renderNotSupported = function () {
        return this.renderTemplate('notSupported');
      };

      return U2FRegister;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife */
  (function () {
    this.U2FUtil = function () {
      function U2FUtil() {}

      U2FUtil.isU2FSupported = function () {
        return window.u2f;
      };

      return U2FUtil;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
  /* global Vue */
  /* global Issuable */
  /* global ListUser */

  (function () {
    var bind = function bind(fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
        slice = [].slice;

    this.UsersSelect = function () {
      function UsersSelect(currentUser, els) {
        var $els;
        this.users = bind(this.users, this);
        this.user = bind(this.user, this);
        this.usersPath = "/autocomplete/users.json";
        this.userPath = "/autocomplete/users/:id.json";
        if (currentUser != null) {
          if ((typeof currentUser === "undefined" ? "undefined" : _typeof(currentUser)) === 'object') {
            this.currentUser = currentUser;
          } else {
            this.currentUser = JSON.parse(currentUser);
          }
        }

        $els = $(els);

        if (!els) {
          $els = $('.js-user-search');
        }

        $els.each(function (_this) {
          return function (i, dropdown) {
            var options = {};
            var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, firstUser, issueURL, selectedId, showAnyUser, showNullUser, showMenuAbove;
            $dropdown = $(dropdown);
            options.projectId = $dropdown.data('project-id');
            options.showCurrentUser = $dropdown.data('current-user');
            options.todoFilter = $dropdown.data('todo-filter');
            options.todoStateFilter = $dropdown.data('todo-state-filter');
            showNullUser = $dropdown.data('null-user');
            showMenuAbove = $dropdown.data('showMenuAbove');
            showAnyUser = $dropdown.data('any-user');
            firstUser = $dropdown.data('first-user');
            options.authorId = $dropdown.data('author-id');
            selectedId = $dropdown.data('selected');
            defaultLabel = $dropdown.data('default-label');
            issueURL = $dropdown.data('issueUpdate');
            $selectbox = $dropdown.closest('.selectbox');
            $block = $selectbox.closest('.block');
            abilityName = $dropdown.data('ability-name');
            $value = $block.find('.value');
            $collapsedSidebar = $block.find('.sidebar-collapsed-user');
            $loading = $block.find('.block-loading').fadeOut();

            var updateIssueBoardsIssue = function updateIssueBoardsIssue() {
              $loading.fadeIn();
              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                $loading.fadeOut();
              });
            };

            $block.on('click', '.js-assign-yourself', function (e) {
              e.preventDefault();

              if ($dropdown.hasClass('js-issue-board-sidebar')) {
                Vue.set(gl.issueBoards.BoardsStore.detail.issue, 'assignee', new ListUser({
                  id: _this.currentUser.id,
                  username: _this.currentUser.username,
                  name: _this.currentUser.name,
                  avatar_url: _this.currentUser.avatar_url
                }));

                updateIssueBoardsIssue();
              } else {
                return assignTo(_this.currentUser.id);
              }
            });
            assignTo = function assignTo(selected) {
              var data;
              data = {};
              data[abilityName] = {};
              data[abilityName].assignee_id = selected != null ? selected : null;
              $loading.fadeIn();
              $dropdown.trigger('loading.gl.dropdown');
              return $.ajax({
                type: 'PUT',
                dataType: 'json',
                url: issueURL,
                data: data
              }).done(function (data) {
                var user;
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
                $selectbox.hide();
                if (data.assignee) {
                  user = {
                    name: data.assignee.name,
                    username: data.assignee.username,
                    avatar: data.assignee.avatar_url
                  };
                } else {
                  user = {
                    name: 'Unassigned',
                    username: '',
                    avatar: ''
                  };
                }
                $value.html(assigneeTemplate(user));
                $collapsedSidebar.attr('title', user.name).tooltip('fixTitle');
                return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
              });
            };
            collapsedAssigneeTemplate = _.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
            assigneeTemplate = _.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
            return $dropdown.glDropdown({
              showMenuAbove: showMenuAbove,
              data: function data(term, callback) {
                var isAuthorFilter;
                isAuthorFilter = $('.js-author-search');
                return _this.users(term, options, function (users) {
                  var anyUser, index, j, len, name, obj, showDivider;
                  if (term.length === 0) {
                    showDivider = 0;
                    if (firstUser) {
                      // Move current user to the front of the list
                      for (index = j = 0, len = users.length; j < len; index = j += 1) {
                        obj = users[index];
                        if (obj.username === firstUser) {
                          users.splice(index, 1);
                          users.unshift(obj);
                          break;
                        }
                      }
                    }
                    if (showNullUser) {
                      showDivider += 1;
                      users.unshift({
                        beforeDivider: true,
                        name: 'Unassigned',
                        id: 0
                      });
                    }
                    if (showAnyUser) {
                      showDivider += 1;
                      name = showAnyUser;
                      if (name === true) {
                        name = 'Any User';
                      }
                      anyUser = {
                        beforeDivider: true,
                        name: name,
                        id: null
                      };
                      users.unshift(anyUser);
                    }
                  }
                  if (showDivider) {
                    users.splice(showDivider, 0, "divider");
                  }

                  callback(users);
                  if (showMenuAbove) {
                    $dropdown.data('glDropdown').positionMenuAbove();
                  }
                });
              },
              filterable: true,
              filterRemote: true,
              search: {
                fields: ['name', 'username']
              },
              selectable: true,
              fieldName: $dropdown.data('field-name'),
              toggleLabel: function toggleLabel(selected, el) {
                if (selected && 'id' in selected && $(el).hasClass('is-active')) {
                  if (selected.text) {
                    return selected.text;
                  } else {
                    return selected.name;
                  }
                } else {
                  return defaultLabel;
                }
              },
              defaultLabel: defaultLabel,
              inputId: 'issue_assignee_id',
              hidden: function hidden(e) {
                $selectbox.hide();
                // display:block overrides the hide-collapse rule
                return $value.css('display', '');
              },
              vue: $dropdown.hasClass('js-issue-board-sidebar'),
              clicked: function clicked(user, $el, e) {
                var isIssueIndex, isMRIndex, page, selected;
                page = $('body').data('page');
                isIssueIndex = page === 'projects:issues:index';
                isMRIndex = page === page && page === 'projects:merge_requests:index';
                if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
                  e.preventDefault();
                  selectedId = user.id;
                  return;
                }
                if ($el.closest('.add-issues-modal').length) {
                  gl.issueBoards.ModalStore.store.filter[$dropdown.data('field-name')] = user.id;
                } else if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar')) {
                  selectedId = user.id;
                  gl.issueBoards.BoardsStore.state.filters[$dropdown.data('field-name')] = user.id;
                  gl.issueBoards.BoardsStore.updateFiltersUrl();
                  e.preventDefault();
                } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                  selectedId = user.id;
                  return Issuable.filterResults($dropdown.closest('form'));
                } else if ($dropdown.hasClass('js-filter-submit')) {
                  return $dropdown.closest('form').submit();
                } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
                  if (user.id) {
                    Vue.set(gl.issueBoards.BoardsStore.detail.issue, 'assignee', new ListUser({
                      id: user.id,
                      username: user.username,
                      name: user.name,
                      avatar_url: user.avatar_url
                    }));
                  } else {
                    Vue.delete(gl.issueBoards.BoardsStore.detail.issue, 'assignee');
                  }

                  updateIssueBoardsIssue();
                } else {
                  selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "']").val();
                  return assignTo(selected);
                }
              },
              id: function id(user) {
                return user.id;
              },
              renderRow: function renderRow(user) {
                var avatar, img, listClosingTags, listWithName, listWithUserName, selected, username;
                username = user.username ? "@" + user.username : "";
                avatar = user.avatar_url ? user.avatar_url : false;
                selected = user.id === selectedId ? "is-active" : "";
                img = "";
                if (user.beforeDivider != null) {
                  "<li> <a href='#' class='" + selected + "'> " + user.name + " </a> </li>";
                } else {
                  if (avatar) {
                    img = "<img src='" + avatar + "' class='avatar avatar-inline' width='30' />";
                  }
                }
                // split into three parts so we can remove the username section if nessesary
                listWithName = "<li> <a href='#' class='dropdown-menu-user-link " + selected + "'> " + img + " <strong class='dropdown-menu-user-full-name'> " + user.name + " </strong>";
                listWithUserName = "<span class='dropdown-menu-user-username'> " + username + " </span>";
                listClosingTags = "</a> </li>";
                if (username === '') {
                  listWithUserName = '';
                }
                return listWithName + listWithUserName + listClosingTags;
              }
            });
          };
        }(this));
        $('.ajax-users-select').each(function (_this) {
          return function (i, select) {
            var firstUser, showAnyUser, showEmailUser, showNullUser;
            var options = {};
            options.skipLdap = $(select).hasClass('skip_ldap');
            options.projectId = $(select).data('project-id');
            options.groupId = $(select).data('group-id');
            options.showCurrentUser = $(select).data('current-user');
            options.pushCodeToProtectedBranches = $(select).data('push-code-to-protected-branches');
            options.authorId = $(select).data('author-id');
            options.skipUsers = $(select).data('skip-users');
            showNullUser = $(select).data('null-user');
            showAnyUser = $(select).data('any-user');
            showEmailUser = $(select).data('email-user');
            firstUser = $(select).data('first-user');
            return $(select).select2({
              placeholder: "Search for a user",
              multiple: $(select).hasClass('multiselect'),
              minimumInputLength: 0,
              query: function query(_query) {
                return _this.users(_query.term, options, function (users) {
                  var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
                  data = {
                    results: users
                  };
                  if (_query.term.length === 0) {
                    if (firstUser) {
                      // Move current user to the front of the list
                      ref = data.results;
                      for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                        obj = ref[index];
                        if (obj.username === firstUser) {
                          data.results.splice(index, 1);
                          data.results.unshift(obj);
                          break;
                        }
                      }
                    }
                    if (showNullUser) {
                      nullUser = {
                        name: 'Unassigned',
                        id: 0
                      };
                      data.results.unshift(nullUser);
                    }
                    if (showAnyUser) {
                      name = showAnyUser;
                      if (name === true) {
                        name = 'Any User';
                      }
                      anyUser = {
                        name: name,
                        id: null
                      };
                      data.results.unshift(anyUser);
                    }
                  }
                  if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
                    var trimmed = _query.term.trim();
                    emailUser = {
                      name: "Invite \"" + _query.term + "\"",
                      username: trimmed,
                      id: trimmed
                    };
                    data.results.unshift(emailUser);
                  }
                  return _query.callback(data);
                });
              },
              initSelection: function initSelection() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return _this.initSelection.apply(_this, args);
              },
              formatResult: function formatResult() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return _this.formatResult.apply(_this, args);
              },
              formatSelection: function formatSelection() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return _this.formatSelection.apply(_this, args);
              },
              dropdownCssClass: "ajax-users-dropdown",
              // we do not want to escape markup since we are displaying html in results
              escapeMarkup: function escapeMarkup(m) {
                return m;
              }
            });
          };
        }(this));
      }

      UsersSelect.prototype.initSelection = function (element, callback) {
        var id, nullUser;
        id = $(element).val();
        if (id === "0") {
          nullUser = {
            name: 'Unassigned'
          };
          return callback(nullUser);
        } else if (id !== "") {
          return this.user(id, callback);
        }
      };

      UsersSelect.prototype.formatResult = function (user) {
        var avatar;
        if (user.avatar_url) {
          avatar = user.avatar_url;
        } else {
          avatar = gon.default_avatar_url;
        }
        return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar s24' src='" + avatar + "'></div> <div class='user-name'>" + user.name + "</div> <div class='user-username'>" + (user.username || "") + "</div> </div>";
      };

      UsersSelect.prototype.formatSelection = function (user) {
        return user.name;
      };

      UsersSelect.prototype.user = function (user_id, callback) {
        if (!/^\d+$/.test(user_id)) {
          return false;
        }

        var url;
        url = this.buildUrl(this.userPath);
        url = url.replace(':id', user_id);
        return $.ajax({
          url: url,
          dataType: "json"
        }).done(function (user) {
          return callback(user);
        });
      };

      // Return users list. Filtered by query
      // Only active users retrieved
      UsersSelect.prototype.users = function (query, options, callback) {
        var url;
        url = this.buildUrl(this.usersPath);
        return $.ajax({
          url: url,
          data: {
            search: query,
            per_page: 20,
            active: true,
            project_id: options.projectId || null,
            group_id: options.groupId || null,
            skip_ldap: options.skipLdap || null,
            todo_filter: options.todoFilter || null,
            todo_state_filter: options.todoStateFilter || null,
            current_user: options.showCurrentUser || null,
            push_code_to_protected_branches: options.pushCodeToProtectedBranches || null,
            author_id: options.authorId || null,
            skip_users: options.skipUsers || null
          },
          dataType: "json"
        }).done(function (users) {
          return callback(users);
        });
      };

      UsersSelect.prototype.buildUrl = function (url) {
        if (gon.relative_url_root != null) {
          url = gon.relative_url_root.replace(/\/$/, '') + url;
        }
        return url;
      };

      return UsersSelect;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len */
  /* global Dropzone */
  /* global Mousetrap */

  // Zen Mode (full screen) textarea
  //
  /*= provides zen_mode:enter */
  /*= provides zen_mode:leave */

  __webpack_require__(27);
  window.Dropzone = __webpack_require__(26);
  __webpack_require__(29);
  __webpack_require__(58);

  //
  // ### Events
  //
  // `zen_mode:enter`
  //
  // Fired when the "Edit in fullscreen" link is clicked.
  //
  // **Synchronicity** Sync
  // **Bubbles** Yes
  // **Cancelable** No
  // **Target** a.js-zen-enter
  //
  // `zen_mode:leave`
  //
  // Fired when the "Leave Fullscreen" link is clicked.
  //
  // **Synchronicity** Sync
  // **Bubbles** Yes
  // **Cancelable** No
  // **Target** a.js-zen-leave
  //
  (function () {
    this.ZenMode = function () {
      function ZenMode() {
        this.active_backdrop = null;
        this.active_textarea = null;
        $(document).on('click', '.js-zen-enter', function (e) {
          e.preventDefault();
          return $(e.currentTarget).trigger('zen_mode:enter');
        });
        $(document).on('click', '.js-zen-leave', function (e) {
          e.preventDefault();
          return $(e.currentTarget).trigger('zen_mode:leave');
        });
        $(document).on('zen_mode:enter', function (_this) {
          return function (e) {
            return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
          };
        }(this));
        $(document).on('zen_mode:leave', function (_this) {
          return function (e) {
            return _this.exit();
          };
        }(this));
        $(document).on('keydown', function (e) {
          // Esc
          if (e.keyCode === 27) {
            e.preventDefault();
            return $(document).trigger('zen_mode:leave');
          }
        });
      }

      ZenMode.prototype.enter = function (backdrop) {
        Mousetrap.pause();
        this.active_backdrop = $(backdrop);
        this.active_backdrop.addClass('fullscreen');
        this.active_textarea = this.active_backdrop.find('textarea');
        // Prevent a user-resized textarea from persisting to fullscreen
        this.active_textarea.removeAttr('style');
        return this.active_textarea.focus();
      };

      ZenMode.prototype.exit = function () {
        if (this.active_textarea) {
          Mousetrap.unpause();
          this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
          this.scrollTo(this.active_textarea);
          this.active_textarea = null;
          this.active_backdrop = null;
          return Dropzone.forElement('.div-dropzone').enable();
        }
      };

      ZenMode.prototype.scrollTo = function (zen_area) {
        return $.scrollTo(zen_area, 0, {
          offset: -150
        });
      };

      return ZenMode;
    }();
  }).call(this);
}).call(window);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * clipboard.js v1.4.2
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Clipboard = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * Module dependencies.
 */

var closest = require('closest')
  , event = require('component-event');

/**
 * Delegate event `type` to `selector`
 * and invoke `fn(e)`. A callback function
 * is returned which may be passed to `.unbind()`.
 *
 * @param {Element} el
 * @param {String} selector
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

// Some events don't bubble, so we want to bind to the capture phase instead
// when delegating.
var forceCaptureEvents = ['focus', 'blur'];

exports.bind = function(el, selector, type, fn, capture){
  if (forceCaptureEvents.indexOf(type) !== -1) capture = true;

  return event.bind(el, type, function(e){
    var target = e.target || e.srcElement;
    e.delegateTarget = closest(target, selector, true, el);
    if (e.delegateTarget) fn.call(el, e);
  }, capture);
};

/**
 * Unbind event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  if (forceCaptureEvents.indexOf(type) !== -1) capture = true;

  event.unbind(el, type, fn, capture);
};

},{"closest":2,"component-event":4}],2:[function(require,module,exports){
var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}

},{"matches-selector":3}],3:[function(require,module,exports){

/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}
},{}],4:[function(require,module,exports){
var bind = window.addEventListener ? 'addEventListener' : 'attachEvent',
    unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
    prefix = bind !== 'addEventListener' ? 'on' : '';

/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.bind = function(el, type, fn, capture){
  el[bind](prefix + type, fn, capture || false);
  return fn;
};

/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  el[unbind](prefix + type, fn, capture || false);
  return fn;
};
},{}],5:[function(require,module,exports){
function E () {
	// Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
	on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    var fn = function () {
      self.off(name, fn);
      callback.apply(ctx, arguments);
    };

    return this.on(name, fn, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;

},{}],6:[function(require,module,exports){
/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ClipboardAction = (function () {
    /**
     * @param {Object} options
     */

    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */

    ClipboardAction.prototype.resolveOptions = function resolveOptions() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        this.action = options.action;
        this.emitter = options.emitter;
        this.target = options.target;
        this.text = options.text;
        this.trigger = options.trigger;

        this.selectedText = '';
    };

    /**
     * Decides which selection strategy is going to be applied based
     * on the existence of `text` and `target` properties.
     */

    ClipboardAction.prototype.initSelection = function initSelection() {
        if (this.text && this.target) {
            throw new Error('Multiple attributes declared, use either "target" or "text"');
        } else if (this.text) {
            this.selectFake();
        } else if (this.target) {
            this.selectTarget();
        } else {
            throw new Error('Missing required attributes, use either "target" or "text"');
        }
    };

    /**
     * Creates a fake textarea element, sets its value from `text` property,
     * and makes a selection on it.
     */

    ClipboardAction.prototype.selectFake = function selectFake() {
        var _this = this;

        this.removeFake();

        this.fakeHandler = document.body.addEventListener('click', function () {
            return _this.removeFake();
        });

        this.fakeElem = document.createElement('textarea');
        this.fakeElem.style.position = 'absolute';
        this.fakeElem.style.left = '-9999px';
        this.fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
        this.fakeElem.setAttribute('readonly', '');
        this.fakeElem.value = this.text;
        this.selectedText = this.text;

        document.body.appendChild(this.fakeElem);

        this.fakeElem.select();
        this.copyText();
    };

    /**
     * Only removes the fake element after another click event, that way
     * a user can hit `Ctrl+C` to copy because selection still exists.
     */

    ClipboardAction.prototype.removeFake = function removeFake() {
        if (this.fakeHandler) {
            document.body.removeEventListener('click');
            this.fakeHandler = null;
        }

        if (this.fakeElem) {
            document.body.removeChild(this.fakeElem);
            this.fakeElem = null;
        }
    };

    /**
     * Selects the content from element passed on `target` property.
     */

    ClipboardAction.prototype.selectTarget = function selectTarget() {
        if (this.target.nodeName === 'INPUT' || this.target.nodeName === 'TEXTAREA') {
            this.target.select();
            this.selectedText = this.target.value;
        } else {
            var range = document.createRange();
            var selection = window.getSelection();

            selection.removeAllRanges();
            range.selectNodeContents(this.target);
            selection.addRange(range);
            this.selectedText = selection.toString();
        }

        this.copyText();
    };

    /**
     * Executes the copy operation based on the current selection.
     */

    ClipboardAction.prototype.copyText = function copyText() {
        var succeeded = undefined;

        try {
            succeeded = document.execCommand(this.action);
        } catch (err) {
            succeeded = false;
        }

        this.handleResult(succeeded);
    };

    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */

    ClipboardAction.prototype.handleResult = function handleResult(succeeded) {
        if (succeeded) {
            this.emitter.emit('success', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        } else {
            this.emitter.emit('error', {
                action: this.action,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }
    };

    /**
     * Removes current selection and focus from `target` element.
     */

    ClipboardAction.prototype.clearSelection = function clearSelection() {
        if (this.target) {
            this.target.blur();
        }

        window.getSelection().removeAllRanges();
    };

    /**
     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
     * @param {String} action
     */

    /**
     * Destroy lifecycle.
     */

    ClipboardAction.prototype.destroy = function destroy() {
        this.removeFake();
    };

    _createClass(ClipboardAction, [{
        key: 'action',
        set: function set() {
            var action = arguments.length <= 0 || arguments[0] === undefined ? 'copy' : arguments[0];

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        },

        /**
         * Gets the `action` property.
         * @return {String}
         */
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */
    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && typeof target === 'object' && target.nodeType === 1) {
                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        },

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
})();

exports['default'] = ClipboardAction;
module.exports = exports['default'];

},{}],7:[function(require,module,exports){
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _clipboardAction = require('./clipboard-action');

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _delegateEvents = require('delegate-events');

var _delegateEvents2 = _interopRequireDefault(_delegateEvents);

var _tinyEmitter = require('tiny-emitter');

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

/**
 * Base class which takes a selector, delegates a click event to it,
 * and instantiates a new `ClipboardAction` on each click.
 */

var Clipboard = (function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String} selector
     * @param {Object} options
     */

    function Clipboard(selector, options) {
        _classCallCheck(this, Clipboard);

        _Emitter.call(this);

        this.resolveOptions(options);
        this.delegateClick(selector);
    }

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */

    Clipboard.prototype.resolveOptions = function resolveOptions() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
        this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
        this.text = typeof options.text === 'function' ? options.text : this.defaultText;
    };

    /**
     * Delegates a click event on the passed selector.
     * @param {String} selector
     */

    Clipboard.prototype.delegateClick = function delegateClick(selector) {
        var _this = this;

        this.binding = _delegateEvents2['default'].bind(document.body, selector, 'click', function (e) {
            return _this.onClick(e);
        });
    };

    /**
     * Undelegates a click event on body.
     * @param {String} selector
     */

    Clipboard.prototype.undelegateClick = function undelegateClick() {
        _delegateEvents2['default'].unbind(document.body, 'click', this.binding);
    };

    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

    Clipboard.prototype.onClick = function onClick(e) {
        if (this.clipboardAction) {
            this.clipboardAction = null;
        }

        this.clipboardAction = new _clipboardAction2['default']({
            action: this.action(e.delegateTarget),
            target: this.target(e.delegateTarget),
            text: this.text(e.delegateTarget),
            trigger: e.delegateTarget,
            emitter: this
        });
    };

    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultAction = function defaultAction(trigger) {
        return getAttributeValue('action', trigger);
    };

    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultTarget = function defaultTarget(trigger) {
        var selector = getAttributeValue('target', trigger);

        if (selector) {
            return document.querySelector(selector);
        }
    };

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultText = function defaultText(trigger) {
        return getAttributeValue('text', trigger);
    };

    /**
     * Destroy lifecycle.
     */

    Clipboard.prototype.destroy = function destroy() {
        this.undelegateClick();

        if (this.clipboardAction) {
            this.clipboardAction.destroy();
            this.clipboardAction = null;
        }
    };

    return Clipboard;
})(_tinyEmitter2['default']);

function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

exports['default'] = Clipboard;
module.exports = exports['default'];

},{"./clipboard-action":6,"delegate-events":1,"tiny-emitter":5}]},{},[7])(7)
});

}.call(window));

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Effects 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/effects-core/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var dataSpace = "ui-effects-",

	// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery = $;

$.effects = {
	effect: {}
};

/*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
(function( jQuery, undefined ) {

	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	// plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
	// a set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {
			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 )
				];
			}
		}, {
			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// jQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// colors = jQuery.Color.names
	colors,

	// local aliases of functions called often
	each = jQuery.each;

// determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
});

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return (allowEmpty || !prop.def) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {
		// we add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return (value + type.mod) % type.mod;
	}

	// for now all property types without mod have min and max
	return 0 > value ? 0 : type.max < value ? type.max : value;
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// if this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// exit each( stringParsers ) here because we matched
			return false;
		}
	});

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// if this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = jQuery.type( red ),
			rgba = this._rgba = [];

		// more than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			});
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				});
			} else {
				each( spaces, function( spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// if the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// if the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// this is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					});

					// everything defined but alpha?
					if ( inst[ cache ] && jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
						// use the default of 1
						inst[ cache ][ 3 ] = 1;
						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				});
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if (isCache) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				});
			}
			return same;
		});
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		});
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// if null, don't override start value
			if ( endValue === null ) {
				return;
			}
			// if null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		});
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {
		// if we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		}));
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				return v == null ? ( i > 2 ? 1 : 0 ) : v;
			});

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			});

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		}).join("");
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
});
color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round(h) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};

each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = jQuery.type( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		});

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {
		// alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var vtype = jQuery.type( value ),
				fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
				local = this[ fn ](),
				cur = local[ prop.idx ],
				match;

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = jQuery.type( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	});
});

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( jQuery.type( value ) !== "string" || ( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							(backgroundColor === "" || backgroundColor === "transparent") &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {
					// wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	});

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		});
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {
	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};

})( jQuery );

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
(function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each([ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ], function( _, prop ) {
	$.fx.step[ prop ] = function( fx ) {
		if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
			jQuery.style( fx.elem, prop, fx.end );
			fx.setAttr = true;
		}
	};
});

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ $.camelCase( key ) ] = style[ key ];
			}
		}
	// support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// map the animated objects to store the original styles.
		allAnimations = allAnimations.map(function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		});

		// apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function(i, action) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			});
		};
		applyClassChange();

		// map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map(function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		});

		// apply original class
		animated.attr( "class", baseClass );

		// map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map(function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend({}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				});

			this.el.animate( this.diff, opts );
			return dfd.promise();
		});

		// once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done(function() {

			// set the final class
			applyClassChange();

			// for each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function(key) {
					el.css( key, "" );
				});
			});

			// this is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		});
	});
};

$.fn.extend({
	addClass: (function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	})( $.fn.addClass ),

	removeClass: (function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	})( $.fn.removeClass ),

	toggleClass: (function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {
					// without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						(force ? { add: classNames } : { remove: classNames }),
						speed, easing, callback );
				}
			} else {
				// without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	})( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
});

})();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

(function() {

$.extend( $.effects, {
	version: "1.11.4",

	// Saves a set of properties in a data storage
	save: function( element, set ) {
		for ( var i = 0; i < set.length; i++ ) {
			if ( set[ i ] !== null ) {
				element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
			}
		}
	},

	// Restores a set of previously saved properties from a data storage
	restore: function( element, set ) {
		var val, i;
		for ( i = 0; i < set.length; i++ ) {
			if ( set[ i ] !== null ) {
				val = element.data( dataSpace + set[ i ] );
				// support: jQuery 1.6.2
				// http://bugs.jquery.com/ticket/9917
				// jQuery 1.6.2 incorrectly returns undefined for any falsy value.
				// We can't differentiate between "" and 0 here, so we just assume
				// empty string since it's likely to be a more common value...
				if ( val === undefined ) {
					val = "";
				}
				element.css( set[ i ], val );
			}
		}
	},

	setMode: function( el, mode ) {
		if (mode === "toggle") {
			mode = el.is( ":hidden" ) ? "show" : "hide";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	// this should be a little more flexible in the future to handle a string & hash
	getBaseline: function( origin, original ) {
		var y, x;
		switch ( origin[ 0 ] ) {
			case "top": y = 0; break;
			case "middle": y = 0.5; break;
			case "bottom": y = 1; break;
			default: y = origin[ 0 ] / original.height;
		}
		switch ( origin[ 1 ] ) {
			case "left": x = 0; break;
			case "center": x = 0.5; break;
			case "right": x = 1; break;
			default: x = origin[ 1 ] / original.width;
		}
		return {
			x: x,
			y: y
		};
	},

	// Wraps the element around a wrapper that copies position properties
	createWrapper: function( element ) {

		// if the element is already wrapped, return it
		if ( element.parent().is( ".ui-effects-wrapper" )) {
			return element.parent();
		}

		// wrap the element
		var props = {
				width: element.outerWidth(true),
				height: element.outerHeight(true),
				"float": element.css( "float" )
			},
			wrapper = $( "<div></div>" )
				.addClass( "ui-effects-wrapper" )
				.css({
					fontSize: "100%",
					background: "transparent",
					border: "none",
					margin: 0,
					padding: 0
				}),
			// Store the size in case width/height are defined in % - Fixes #5245
			size = {
				width: element.width(),
				height: element.height()
			},
			active = document.activeElement;

		// support: Firefox
		// Firefox incorrectly exposes anonymous content
		// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
		try {
			active.id;
		} catch ( e ) {
			active = document.body;
		}

		element.wrap( wrapper );

		// Fixes #7595 - Elements lose focus when wrapped.
		if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
			$( active ).focus();
		}

		wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element

		// transfer positioning properties to the wrapper
		if ( element.css( "position" ) === "static" ) {
			wrapper.css({ position: "relative" });
			element.css({ position: "relative" });
		} else {
			$.extend( props, {
				position: element.css( "position" ),
				zIndex: element.css( "z-index" )
			});
			$.each([ "top", "left", "bottom", "right" ], function(i, pos) {
				props[ pos ] = element.css( pos );
				if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
					props[ pos ] = "auto";
				}
			});
			element.css({
				position: "relative",
				top: 0,
				left: 0,
				right: "auto",
				bottom: "auto"
			});
		}
		element.css(size);

		return wrapper.css( props ).show();
	},

	removeWrapper: function( element ) {
		var active = document.activeElement;

		if ( element.parent().is( ".ui-effects-wrapper" ) ) {
			element.parent().replaceWith( element );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).focus();
			}
		}

		return element;
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		});
		return value;
	}
});

// return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// convert to an object
	effect = { effect: effect };

	// catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// catch (effect, callback)
	if ( $.isFunction( options ) ) {
		callback = options;
		speed = null;
		options = {};
	}

	// catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// catch (effect, options, callback)
	if ( $.isFunction( speed ) ) {
		callback = speed;
		speed = null;
	}

	// add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {
	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( $.isFunction( option ) ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend({
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			mode = args.mode,
			queue = args.queue,
			effectMethod = $.effects.effect[ args.effect ];

		if ( $.fx.off || !effectMethod ) {
			// delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, args.complete );
			} else {
				return this.each( function() {
					if ( args.complete ) {
						args.complete.call( this );
					}
				});
			}
		}

		function run( next ) {
			var elem = $( this ),
				complete = args.complete,
				mode = args.mode;

			function done() {
				if ( $.isFunction( complete ) ) {
					complete.call( elem[0] );
				}
				if ( $.isFunction( next ) ) {
					next();
				}
			}

			// If the element already has the correct final state, delegate to
			// the core methods so the internal tracking of "olddisplay" works.
			if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
				elem[ mode ]();
				done();
			} else {
				effectMethod.call( elem[0], args, done );
			}
		}

		return queue === false ? this.each( run ) : this.queue( queue || "fx", run );
	},

	show: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.show ),

	hide: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.hide ),

	toggle: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.toggle ),

	// helper functions
	cssUnit: function(key) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		});
		return val;
	}
});

})();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

(function() {

// based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
});

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
});

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
});

})();

return $.effects;

}));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Menu 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/menu/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(1),
			__webpack_require__(18),
			__webpack_require__(19),
			__webpack_require__(155)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget( "ui.menu", {
	version: "1.11.4",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-carat-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left-1 top",
			at: "right top"
		},
		role: "menu",

		// callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.addClass( "ui-menu ui-widget ui-widget-content" )
			.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
			.attr({
				role: this.options.role,
				tabIndex: 0
			});

		if ( this.options.disabled ) {
			this.element
				.addClass( "ui-state-disabled" )
				.attr( "aria-disabled", "true" );
		}

		this._on({
			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) && $( this.document[ 0 ].activeElement ).closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {
				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}
				var target = $( event.currentTarget );
				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				target.siblings( ".ui-state-active" ).removeClass( "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {
				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay(function() {
					if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
						this.collapseAll( event );
					}
				});
			},
			keydown: "_keydown"
		});

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		});
	},

	_destroy: function() {
		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeClass( "ui-menu ui-widget ui-widget-content ui-menu-icons ui-front" )
				.removeAttr( "role" )
				.removeAttr( "tabIndex" )
				.removeAttr( "aria-labelledby" )
				.removeAttr( "aria-expanded" )
				.removeAttr( "aria-hidden" )
				.removeAttr( "aria-disabled" )
				.removeUniqueId()
				.show();

		// Destroy menu items
		this.element.find( ".ui-menu-item" )
			.removeClass( "ui-menu-item" )
			.removeAttr( "role" )
			.removeAttr( "aria-disabled" )
			.removeUniqueId()
			.removeClass( "ui-state-hover" )
			.removeAttr( "tabIndex" )
			.removeAttr( "role" )
			.removeAttr( "aria-haspopup" )
			.children().each( function() {
				var elem = $( this );
				if ( elem.data( "ui-menu-submenu-carat" ) ) {
					elem.remove();
				}
			});

		// Destroy menu dividers
		this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			character = String.fromCharCode( event.keyCode );
			skip = false;

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay(function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.is( "[aria-haspopup='true']" ) ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this.element.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		submenus.filter( ":not(.ui-menu)" )
			.addClass( "ui-menu ui-widget ui-widget-content ui-front" )
			.hide()
			.attr({
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			})
			.each(function() {
				var menu = $( this ),
					item = menu.parent(),
					submenuCarat = $( "<span>" )
						.addClass( "ui-menu-icon ui-icon " + icon )
						.data( "ui-menu-submenu-carat", true );

				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCarat );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			});

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each(function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				item.addClass( "ui-widget-content ui-menu-divider" );
			}
		});

		// Don't refresh list items that are already adapted
		items.not( ".ui-menu-item, .ui-menu-divider" )
			.addClass( "ui-menu-item" )
			.uniqueId()
			.attr({
				tabIndex: -1,
				role: this._itemRole()
			});

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			this.element.find( ".ui-menu-icon" )
				.removeClass( this.options.icons.submenu )
				.addClass( value.submenu );
		}
		if ( key === "disabled" ) {
			this.element
				.toggleClass( "ui-state-disabled", !!value )
				.attr( "aria-disabled", value );
		}
		this._super( key, value );
	},

	focus: function( event, item ) {
		var nested, focused;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();
		focused = this.active.addClass( "ui-state-focus" ).removeClass( "ui-state-active" );
		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		this.active
			.parent()
			.closest( ".ui-menu-item" )
			.addClass( "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay(function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening(nested);
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this.active.removeClass( "ui-state-focus" );
		this.active = null;

		this._trigger( "blur", event, { item: this.active } );
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the carat icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay(function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend({
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay(function() {
			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );
			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu
			.find( ".ui-menu" )
				.hide()
				.attr( "aria-hidden", "true" )
				.attr( "aria-expanded", "false" )
			.end()
			.find( ".ui-state-active" ).not( ".ui-state-focus" )
				.removeClass( "ui-state-active" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
				.find( this.options.items )
				.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay(function() {
				this.focus( event, newItem );
			});
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {
		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function(character) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

			// Only match on items, not dividers or other content (#10571)
			.filter( ".ui-menu-item" )
			.filter(function() {
				return regex.test( $.trim( $( this ).text() ) );
			});
	}
});

}));


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 357 */,
/* 358 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, space-before-function-paren, no-var, quotes, consistent-return, prefer-arrow-callback, comma-dangle, object-shorthand, no-new, max-len, no-multi-spaces, import/newline-after-import */
  /* global bp */
  /* global Cookies */
  /* global Flash */
  /* global ConfirmDangerModal */
  /* global AwardsHandler */
  /* global Aside */

  function requireAll(context) {
    return context.keys().map(context);
  }

  window.$ = window.jQuery = __webpack_require__(1);
  __webpack_require__(222);
  __webpack_require__(223);
  __webpack_require__(224);
  __webpack_require__(225);
  __webpack_require__(226);
  __webpack_require__(227);
  __webpack_require__(218);
  __webpack_require__(219);
  __webpack_require__(28);
  __webpack_require__(54);
  __webpack_require__(53);
  __webpack_require__(27);
  window.Cookies = __webpack_require__(10);
  __webpack_require__(25);
  __webpack_require__(203);
  __webpack_require__(204);
  __webpack_require__(205);
  __webpack_require__(206);
  __webpack_require__(207);
  __webpack_require__(208);
  __webpack_require__(210);
  __webpack_require__(211);
  __webpack_require__(213);
  __webpack_require__(212);
  __webpack_require__(209);
  __webpack_require__(228);
  window._ = __webpack_require__(229);
  window.Dropzone = __webpack_require__(26);
  __webpack_require__(29);
  __webpack_require__(58);
  __webpack_require__(8);
  __webpack_require__(9);
  __webpack_require__(50);
  __webpack_require__(51);
  __webpack_require__(52);
  __webpack_require__(55);
  requireAll(__webpack_require__(157));
  requireAll(__webpack_require__(158));
  requireAll(__webpack_require__(181));
  requireAll(__webpack_require__(164));
  requireAll(__webpack_require__(173));
  requireAll(__webpack_require__(176));
  requireAll(__webpack_require__(182));
  requireAll(__webpack_require__(172));
  requireAll(__webpack_require__(156));
  __webpack_require__(217);
  window.ES6Promise = __webpack_require__(216);
  window.ES6Promise.polyfill();

  (function () {
    document.addEventListener('beforeunload', function () {
      // Unbind scroll events
      $(document).off('scroll');
      // Close any open tooltips
      $('.has-tooltip, [data-toggle="tooltip"]').tooltip('destroy');
    });

    window.addEventListener('hashchange', gl.utils.handleLocationHash);
    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad, false);
      gl.utils.handleLocationHash();
    }, false);

    $(function () {
      var $body = $('body');
      var $document = $(document);
      var $window = $(window);
      var $sidebarGutterToggle = $('.js-sidebar-toggle');
      var $flash = $('.flash-container');
      var bootstrapBreakpoint = bp.getBreakpointSize();
      var fitSidebarForSize;

      // Set the default path for all cookies to GitLab's root directory
      Cookies.defaults.path = gon.relative_url_root || '/';

      // `hashchange` is not triggered when link target is already in window.location
      $body.on('click', 'a[href^="#"]', function () {
        var href = this.getAttribute('href');
        if (href.substr(1) === gl.utils.getLocationHash()) {
          setTimeout(gl.utils.handleLocationHash, 1);
        }
      });

      // prevent default action for disabled buttons
      $('.btn').click(function (e) {
        if ($(this).hasClass('disabled')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      });

      $('.nav-sidebar').niceScroll({
        cursoropacitymax: '0.4',
        cursorcolor: '#FFF',
        cursorborder: '1px solid #FFF'
      });
      $('.js-select-on-focus').on('focusin', function () {
        return $(this).select().one('mouseup', function (e) {
          return e.preventDefault();
        });
        // Click a .js-select-on-focus field, select the contents
        // Prevent a mouseup event from deselecting the input
      });
      $('.remove-row').bind('ajax:success', function () {
        $(this).tooltip('destroy').closest('li').fadeOut();
      });
      $('.js-remove-tr').bind('ajax:before', function () {
        return $(this).hide();
      });
      $('.js-remove-tr').bind('ajax:success', function () {
        return $(this).closest('tr').fadeOut();
      });
      $('select.select2').select2({
        width: 'resolve',
        // Initialize select2 selects
        dropdownAutoWidth: true
      });
      $('.js-select2').bind('select2-close', function () {
        return setTimeout(function () {
          $('.select2-container-active').removeClass('select2-container-active');
          return $(':focus').blur();
        }, 1);
        // Close select2 on escape
      });
      // Initialize tooltips
      $.fn.tooltip.Constructor.DEFAULTS.trigger = 'hover';
      $body.tooltip({
        selector: '.has-tooltip, [data-toggle="tooltip"]',
        placement: function placement(_, el) {
          return $(el).data('placement') || 'bottom';
        }
      });
      $('.trigger-submit').on('change', function () {
        return $(this).parents('form').submit();
        // Form submitter
      });
      gl.utils.localTimeAgo($('abbr.timeago, .js-timeago'), true);
      // Flash
      if ($flash.length > 0) {
        $flash.click(function () {
          return $(this).fadeOut();
        });
        $flash.show();
      }
      // Disable form buttons while a form is submitting
      $body.on('ajax:complete, ajax:beforeSend, submit', 'form', function (e) {
        var buttons;
        buttons = $('[type="submit"]', this);
        switch (e.type) {
          case 'ajax:beforeSend':
          case 'submit':
            return buttons.disable();
          default:
            return buttons.enable();
        }
      });
      $(document).ajaxError(function (e, xhrObj) {
        var ref = xhrObj.status;
        if (xhrObj.status === 401) {
          return new Flash('You need to be logged in.', 'alert');
        } else if (ref === 404 || ref === 500) {
          return new Flash('Something went wrong on our end.', 'alert');
        }
      });
      $('.account-box').hover(function () {
        // Show/Hide the profile menu when hovering the account box
        return $(this).toggleClass('hover');
      });
      $document.on('click', '.diff-content .js-show-suppressed-diff', function () {
        var $container;
        $container = $(this).parent();
        $container.next('table').show();
        return $container.remove();
        // Commit show suppressed diff
      });
      $('.navbar-toggle').on('click', function () {
        $('.header-content .title').toggle();
        $('.header-content .header-logo').toggle();
        $('.header-content .navbar-collapse').toggle();
        return $('.navbar-toggle').toggleClass('active');
      });
      // Show/hide comments on diff
      $body.on('click', '.js-toggle-diff-comments', function (e) {
        var $this = $(this);
        var notesHolders = $this.closest('.diff-file').find('.notes_holder');
        $this.toggleClass('active');
        if ($this.hasClass('active')) {
          notesHolders.show().find('.hide').show();
        } else {
          notesHolders.hide();
        }
        $this.trigger('blur');
        return e.preventDefault();
      });
      $document.off('click', '.js-confirm-danger');
      $document.on('click', '.js-confirm-danger', function (e) {
        var btn = $(e.target);
        var form = btn.closest('form');
        var text = btn.data('confirm-danger-message');
        e.preventDefault();
        return new ConfirmDangerModal(form, text);
      });
      $('input[type="search"]').each(function () {
        var $this = $(this);
        $this.attr('value', $this.val());
      });
      $document.off('keyup', 'input[type="search"]').on('keyup', 'input[type="search"]', function () {
        var $this;
        $this = $(this);
        return $this.attr('value', $this.val());
      });
      $document.off('breakpoint:change').on('breakpoint:change', function (e, breakpoint) {
        var $gutterIcon;
        if (breakpoint === 'sm' || breakpoint === 'xs') {
          $gutterIcon = $sidebarGutterToggle.find('i');
          if ($gutterIcon.hasClass('fa-angle-double-right')) {
            return $sidebarGutterToggle.trigger('click');
          }
        }
      });
      fitSidebarForSize = function fitSidebarForSize() {
        var oldBootstrapBreakpoint;
        oldBootstrapBreakpoint = bootstrapBreakpoint;
        bootstrapBreakpoint = bp.getBreakpointSize();
        if (bootstrapBreakpoint !== oldBootstrapBreakpoint) {
          return $document.trigger('breakpoint:change', [bootstrapBreakpoint]);
        }
      };
      $window.off('resize.app').on('resize.app', function () {
        return fitSidebarForSize();
      });
      gl.awardsHandler = new AwardsHandler();
      new Aside();
      // bind sidebar events
      new gl.Sidebar();

      gl.utils.initTimeagoTimeout();
    });
  }).call(this);
}).call(window);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// application-3f57aec261e7ca2359b8-v2.js